(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else {
		var a = factory();
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function() {
return webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_addremoveclass_js__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_jqajx_js__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_jqajx_post_js__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_create_js__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_elements_js__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_events_js__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_domready_js__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_aspectheight_js__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_nodetree_js__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_imagesize_js__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_stringtrim_js__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_textkeys_js__ = __webpack_require__(384);
/*
payments/common/lib/core

This is meant to be a small library for some good-to-have functions.

*/














/* harmony default export */ __webpack_exports__["a"] = {
	addClass: function addClass(elm, classname) {
		return __WEBPACK_IMPORTED_MODULE_0__utils_addremoveclass_js__["a" /* default */].add(elm, classname);
	},
	deleteElement: function deleteElement(elm, modulenameUsingTheMethod) {
		return __WEBPACK_IMPORTED_MODULE_4__utils_elements_js__["a" /* default */].deleteElement(elm, modulenameUsingTheMethod);
	},
	deleteElementsInObjectExcept: function deleteElementsInObjectExcept(obj, keysToIgnoreArr, modulenameUsingTheMethod) {
		return __WEBPACK_IMPORTED_MODULE_4__utils_elements_js__["a" /* default */].deleteElementsInObjectExcept(obj, keysToIgnoreArr, modulenameUsingTheMethod);
	},
	hasClass: function hasClass(elm, classname) {
		return __WEBPACK_IMPORTED_MODULE_0__utils_addremoveclass_js__["a" /* default */].hasClass(elm, classname);
	},
	getElementIfValid: function getElementIfValid(obj, key, modulenameUsingTheMethod) {
		return __WEBPACK_IMPORTED_MODULE_4__utils_elements_js__["a" /* default */].getElementInObjectIfValid(obj, key, modulenameUsingTheMethod);
	},
	selectElements: function selectElements(objWithSelectors, modulenameUsingTheMethod) {
		return __WEBPACK_IMPORTED_MODULE_4__utils_elements_js__["a" /* default */].selectElements(objWithSelectors, modulenameUsingTheMethod);
	},
	removeClass: function removeClass(elm, classname) {
		return __WEBPACK_IMPORTED_MODULE_0__utils_addremoveclass_js__["a" /* default */].remove(elm, classname);
	},
	create: function create(typeOrConfig, classname, id) {
		return __WEBPACK_IMPORTED_MODULE_3__utils_create_js__["a" /* default */].basicElement(typeOrConfig, classname, id);
	},
	domready: function domready(initFunction) {
		return __WEBPACK_IMPORTED_MODULE_6__utils_domready_js__["a" /* default */].run(initFunction);
	},
	addListener: function addListener(parentElm, eventType, eventHandler) {
		// window.CORE.addListener(someElement, 'click', )
		/*
  The main adavantage of this method
  for registration of dom - listeners is the ability to register before the triggering elements are inserted into the dom.(similar to jquery.on(...))
  Best usage in this
  case is to combine with the 'handle'
  method.
  Example:
      var clickListenerHandler = function (e) {
              var cb = function (p) {
                  p.e.stopPropagation();
                  var elm = p.elm,
                      row = elm.getAttribute('row'),
                      col = elm.getAttribute('col');
                  actions.clickboard(row, col);
              };
              //If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked
              core.handle(e, '.board_item', cb, true);
          },
          addListener = function (parent) {
              core.addListener(parent, 'click', clickListenerHandler);
          };
  */
		return __WEBPACK_IMPORTED_MODULE_5__utils_events_js__["a" /* default */].add(parentElm, eventType, eventHandler);
	},
	removeListener: function removeListener(parentElm, eventType, eventHandler) {
		/* this method may be called although arguments may be empty */
		__WEBPACK_IMPORTED_MODULE_5__utils_events_js__["a" /* default */].remove(parentElm, eventType, eventHandler);
	},
	getTextkeysFromString: function getTextkeysFromString(str) {
		var endofkey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '__ENDOFKEY__';
		var endofvalue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '__ENDOFVAL__';

		// preferred: passing of textkeys separated from dom-object
		return __WEBPACK_IMPORTED_MODULE_11__utils_textkeys_js__["a" /* default */].objFromString(str, endofkey, endofvalue);
	},
	getTextkeysFromElement: function getTextkeysFromElement(elm, modulenameUsingTheMethod) {
		var endofkey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '__ENDOFKEY__';
		var endofvalue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '__ENDOFVAL__';

		// temporary solution: method that takes the dom-object handling previously done in the 'textkeys' module.
		function getStringFrom(theElement) {
			var str = null;
			if (__WEBPACK_IMPORTED_MODULE_4__utils_elements_js__["a" /* default */].isElement(theElement)) {
				str = theElement.dataset ? theElement.dataset.textkeys || null : null;
			}
			return str;
		}
		var textkeysAsString = getStringFrom(elm);
		return __WEBPACK_IMPORTED_MODULE_11__utils_textkeys_js__["a" /* default */].objFromString(textkeysAsString, endofkey, endofvalue);
	},
	handle: function handle(event, classSelectorFilter, sendFkn, checkParentFilterHit) {
		return __WEBPACK_IMPORTED_MODULE_5__utils_events_js__["a" /* default */].handle(event, classSelectorFilter, sendFkn, checkParentFilterHit);
	},
	isElement: function isElement(elm) {
		return __WEBPACK_IMPORTED_MODULE_4__utils_elements_js__["a" /* default */].isElement(elm);
	},
	nodetree: function nodetree(optNodeOrArrOfNodes) {
		if (arguments.length > 1) {
			console.warn('control:nodetree: arguments must be sent as an array or only the first argument will be used');
		}
		return __WEBPACK_IMPORTED_MODULE_8__utils_nodetree_js__["a" /* default */].fragment(optNodeOrArrOfNodes);
	},
	aspectHeight: function aspectHeight(w, refH, refW) {
		return __WEBPACK_IMPORTED_MODULE_7__utils_aspectheight_js__["a" /* default */].scaledHeight(w, refH, refW);
	},

	// onResize(cb) {
	// TODO the resize listener.
	// addListener = function () {
	// window.addEventListener("resize", function () {cb()});
	// };
	// },
	onimagesize: function onimagesize(src, cbArgHW) {
		/* returns the size {'w':#, 'h':#} */
		return __WEBPACK_IMPORTED_MODULE_9__utils_imagesize_js__["a" /* default */].onsize(src, cbArgHW);
	},
	keepdigits: function keepdigits(str) {
		/* returns the digits from a string, converted into a number */
		return __WEBPACK_IMPORTED_MODULE_10__utils_stringtrim_js__["a" /* default */].keepdigits(str);
	},
	multispace: function multispace(str) {
		return __WEBPACK_IMPORTED_MODULE_10__utils_stringtrim_js__["a" /* default */].multispace(str);
	},
	trailspace: function trailspace(str) {
		return __WEBPACK_IMPORTED_MODULE_10__utils_stringtrim_js__["a" /* default */].trailspace(str);
	},
	get: function get(url, successhandler, errorhandler) {
		if (!(successhandler && typeof successhandler === 'function')) {
			console.error('core:request:provide a successhandler: function(data){}');
		}
		if (!(errorhandler && typeof errorhandler === 'function')) {
			console.error('core:request:provide a errorhandler: function(){}');
		}
		// ajaxJquery_crossdomain.getAsString(url, successhandler, errorhandler);
		__WEBPACK_IMPORTED_MODULE_1__utils_jqajx_js__["a" /* default */].getData(url, successhandler, errorhandler);
	},
	post: function post(url, data, successhandler, errorhandler, contentType) {
		/* errorhandler is optional */
		if (!(successhandler && typeof successhandler === 'function')) {
			console.error('core:post:provide a successhandler: function(data){}: core.post(url,data,successhandler, errorhandler)');
		}
		// if (!(errorhandler && typeof errorhandler === 'function')) {
		//     console.error('core:post:provide a errorhandler: function(){}: core.post(url,data,successhandler, errorhandler)');
		// }
		// ajaxJquery_crossdomain.getAsString(url, successhandler, errorhandler);
		__WEBPACK_IMPORTED_MODULE_2__utils_jqajx_post_js__["a" /* default */].submit(url, data, successhandler, errorhandler, contentType);
	}
};

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_query_string___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_query_string__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cookies_js__ = __webpack_require__(10);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return history; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return push; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return replace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return pushBack; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return basePathname; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return pushBasePathname; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseQueryString; });




var history = __WEBPACK_IMPORTED_MODULE_1_history_createBrowserHistory___default()();

function push(path, state) {
	if (!path) {
		console.warn('No location provided');
		return;
	}
	history.push(path, state);
}

function replace(path, state) {
	if (!path) {
		console.warn('No location provided');
		return;
	}
	history.replace(path, state);
}

function basePathname() {
	var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';

	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cookies_js__["a" /* lastProduct */])() ? '/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cookies_js__["a" /* lastProduct */])() : path;
}

function pushBack() {
	if (history.length > 1) {
		history.goBack();
		return;
	}
	push(basePathname());
}

function pushBasePathname() {
	push(basePathname());
}

history.listen(function (location) {
	location = Object.assign(location,
	// parse the search string using your package of choice
	{ query: __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(location.search) });
});

function parseQueryString(location) {
	if (location && location.query) {
		return location.query;
	} else if (location && location.search) {
		return __WEBPACK_IMPORTED_MODULE_0_query_string___default.a.parse(location.search);
	}
	return false;
}



/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dispatcher_js__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants_js__ = __webpack_require__(9);
/*
 common/actions

 usage:
 var actions = require('../../common/lib/dataflow').actions();

 var actions = require('../common/actions');
 Naming-convention: modulenameExtension ....function...type...constants.MODULENAME_EXTENSION

 actions.createMyAction(some,data);

 When the action is invoked the dispatcher invokes all callbacks with the provided type and arguments.

 */



function check() {
	/* verify that constants that will be used also exists and are defined */
	var used0 = ['BONUSES', 'CANCEL_WITHDRAW_FAIL_NOTIFICATION', 'FEE', 'FETCH_AMOUNTS', 'FETCH_BONUSES', 'FETCH_BONUSES_FREE_MONEY_BONUS_SUCCESS', 'FETCH_CANCEL_WITHDRAW', 'FETCH_FEES_AND_LIMITS'];
	var used1 = ['FETCH_FEES_AND_LIMITS', 'FETCH_METHODDETAILS', 'FETCH_PAYMENTMETHODS', 'FETCH_PENDING_WITHDRAWALS'];
	var used2 = ['SETUP_BONUS', 'PENDING_WITHDRAWALS', 'RESULT_AFTER_SINGLE_CALL', 'SETUP_PAYMENT', 'SETUP_PENDING_WITHDRAWALS', 'SUBMIT_PAYMENT', 'TEST_PURPOSE'];
	var used3 = ['VIEW', 'VIEW_AMOUNTINPUT', 'VIEW_BONUS', 'VIEW_CURRENCYSELECT', 'VIEW_CREDITCARDLAST', 'VIEW_PENDING_WITHDRAWALS', 'VIEW_CREDITCARD', 'VIEW_METHODS', 'VIEW_NAV'];
	var used4 = ['VIEW_PAYMENTFORM_SUBMIT', 'VIEW_UK_FIRST_TIME_DEPOSIT_LINK', 'VIEW_AMOUNTSELECT'];
	var used = used0.concat(used1, used2, used3, used4);

	used.forEach(function (key) {
		if (__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].hasOwnProperty && !{}.hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */], key)) {
			console.error('payment/common/utils/actions:28:check: constant does not exist:' + key);
			return;
		}
	});
}
check();

/* harmony default export */ __webpack_exports__["a"] = {
	asynchronousResultAfterSingleCall: function asynchronousResultAfterSingleCall(paymentHandled) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL,
			paymentHandled: paymentHandled
		});
	},
	bonuses: function bonuses(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].BONUSES,
			data: data
		});
	},
	fee: function fee(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].FEE,
			data: data
		});
	},
	fetchAmounts: function fetchAmounts(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].FETCH_AMOUNTS,
			data: data
		});
	},
	fetchBonuses: function fetchBonuses(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].FETCH_BONUSES,
			data: data
		});
	},
	fetchBonusesFreeMoneyBonusSuccess: function fetchBonusesFreeMoneyBonusSuccess(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].FETCH_BONUSES_FREE_MONEY_BONUS_SUCCESS,
			data: data
		});
	},
	fetchBonusesForShopDeposit: function fetchBonusesForShopDeposit(data, selectedBonusId, bonusPaymentMethods) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].FETCH_BONUSES_FOR_SHOP_DEPOSIT,
			data: data,
			selectedBonusId: selectedBonusId,
			bonusPaymentMethods: bonusPaymentMethods
		});
	},
	fetchCancelWithdraw: function fetchCancelWithdraw(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].FETCH_CANCEL_WITHDRAW,
			data: data
		});
	},
	fetchFeesAndLimits: function fetchFeesAndLimits(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].FETCH_FEES_AND_LIMITS,
			data: data
		});
	},
	validateFeesAndLimitsAtSubmit: function validateFeesAndLimitsAtSubmit(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VALIDATE_FEES_AND_LIMITS_AT_SUBMIT,
			data: data
		});
	},
	fetchMethodDetails: function fetchMethodDetails(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].FETCH_METHODDETAILS,
			data: data
		});
	},
	fetchPaymentmethods: function fetchPaymentmethods(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].FETCH_PAYMENTMETHODS,
			data: data
		});
	},
	fetchPendingWithdrawals: function fetchPendingWithdrawals(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].FETCH_PENDING_WITHDRAWALS,
			data: data
		});
	},
	resultAfterSingleCall: function resultAfterSingleCall(paymentHandled) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].RESULT_AFTER_SINGLE_CALL,
			paymentHandled: paymentHandled
		});
	},
	paymentmethods: function paymentmethods(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].PAYMENTMETHODS,
			data: data
		});
	},
	pendingWithdrawals: function pendingWithdrawals(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].PENDING_WITHDRAWALS,
			data: data
		});
	},
	reloadBonuses: function reloadBonuses() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].RELOAD_BONUSES
		});
	},
	reloadBonusesAfterFreeMoneyBonusSuccess: function reloadBonusesAfterFreeMoneyBonusSuccess() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].RELOAD_BONUSES_FREE_MONEY_BONUS_SUCCESS
		});
	},
	setupBonus: function setupBonus() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].SETUP_BONUS
		});
	},
	setupPayment: function setupPayment() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].SETUP_PAYMENT
		});
	},
	setupPendingWithdrawals: function setupPendingWithdrawals() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].SETUP_PENDING_WITHDRAWALS
		});
	},
	shopHandleBonusForDeposit: function shopHandleBonusForDeposit(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].SHOP_HANDLE_BONUS_FOR_DEPOSIT,
			data: data
		});
	},
	submitPayment: function submitPayment(p) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].SUBMIT_PAYMENT,
			sendHandlerData: p.sendHandlerData,
			accHistRef: p.accHistRef,
			paymentFetchResultFlow: p.paymentFetchResultFlow,
			sendHandlerType: p.sendHandlerType,
			success: p.success
		});
	},
	testPurpose: function testPurpose(data) {
		/* during setup of tests */
		// console.log('actions:testPurposeAction');
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].TEST_PURPOSE,
			data: data
		});
	},
	view: function view(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW,
			data: data
		});
	},
	viewAmountInput: function viewAmountInput(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_AMOUNTINPUT,
			data: data
		});
	},
	viewAmountselect: function viewAmountselect(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_AMOUNTSELECT,
			data: data
		});
	},
	viewBonus: function viewBonus(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_BONUS,
			data: data
		});
	},
	viewBonusFromShop: function viewBonusFromShop(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_BONUS_FROM_SHOP,
			data: data
		});
	},
	viewCurrencySelect: function viewCurrencySelect(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_CURRENCYSELECT,
			data: data
		});
	},
	viewCreditcard: function viewCreditcard(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_CREDITCARD,
			data: data
		});
	},
	viewCreditCardNew: function viewCreditCardNew(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_CREDITCARDNEW,
			data: data
		});
	},
	viewCreditcardlast: function viewCreditcardlast(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_CREDITCARDLAST,
			data: data
		});
	},
	viewUkFirstTimeDepositLink: function viewUkFirstTimeDepositLink(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_UK_FIRST_TIME_DEPOSIT_LINK,
			data: data
		});
	},
	viewNav: function viewNav(p) {
		/* TODO: this will probably not be used when router.js is replaced by react-router navigation. See 'nav_withdrawal' folder. */
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_NAV,
			skip: p.skip,
			back: p.back,
			close: p.close
		});
	},
	viewMethods: function viewMethods(methodId, methodText) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_METHODS,
			id: methodId,
			text: methodText
		});
	},
	viewPaymentform: function viewPaymentform(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_PAYMENTFORM,
			data: data
		});
	},
	viewPaymentformSubmit: function viewPaymentformSubmit(formdata) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_PAYMENTFORM_SUBMIT,
			data: formdata
		});
	},
	viewPaymentMethodLink: function viewPaymentMethodLink(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_PAYMENT_METHOD_LINK,
			data: data
		});
	},
	viewPendingWithdrawals: function viewPendingWithdrawals(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_PENDING_WITHDRAWALS,
			data: data
		});
	},
	cancelWithDrawFailNotification: function cancelWithDrawFailNotification(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].CANCEL_WITHDRAW_FAIL_NOTIFICATION,
			data: data
		});
	},
	viewSelectSkrillAccount: function viewSelectSkrillAccount(data) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dispatcher_js__["a" /* dispatch */])({
			type: __WEBPACK_IMPORTED_MODULE_1__constants_js__["a" /* default */].VIEW_SELECT_SKRILL_ACCOUNTING,
			data: data
		});
	}
};

/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
common/lib/utils/constants

usage:

Naming-convention: MODULENAME_EXTENSION

*/

var constants = {
	BONUSES: 'bonuses',
	DEFAULT: 'default',
	FEE: 'fee',
	FETCH_AMOUNTS: 'fetch_amounts',
	FETCH_BONUSES: 'fetch_bonuses',
	FETCH_BONUSES_FREE_MONEY_BONUS_SUCCESS: 'fetch_bonuses_free_money_bonus_success',
	FETCH_BONUSES_FOR_SHOP_DEPOSIT: 'fetch_bonuses_for_shop_deposit',
	FETCH_CANCEL_WITHDRAW: 'fetch_cancel_withdraw',
	FETCH_PENDING_WITHDRAWALS: 'fetch_pending_withdrawals',
	FETCH_FEES_AND_LIMITS: 'fetch_fees_and_limits',
	VALIDATE_FEES_AND_LIMITS_AT_SUBMIT: 'validate_fees_and_limits_at_submit',
	FETCH_PAYMENTMETHODS: 'fetch_paymentmethods',
	FETCH_METHODDETAILS: 'fetch_methoddetails',
	FETCH_TYPE_ASYNCH: 'fetch_type_asynch',
	FETCH_TYPE_SYNCH: 'fetch_type_synch',
	HANDLE_PAYMENT_RESPONSE: 'handle_payment_response',
	PAYMENT_HANDLED: 'payment_handled',
	PAYMENTMETHODS: 'paymentmethods',
	PENDING_WITHDRAWALS: 'pending_withdrawals',
	SETUP_BONUS: 'setup_bonus',
	SETUP_PAYMENT: 'setup_payment',
	SETUP_PENDING_WITHDRAWALS: 'setup_pending_withdrawals',
	SUBMIT_PAYMENT: 'submit_payment',
	TEST_PURPOSE: 'test_purpose',
	VIEW: 'view',
	VIEW_AMOUNTINPUT: 'view_amount_input',
	VIEW_AMOUNTSELECT: 'view_amountselect',
	VIEW_BONUS: 'view_bonus',
	VIEW_BONUS_FROM_SHOP: 'view_bonus_from_shop',
	VIEW_CURRENCYSELECT: 'view_currencyselect',
	VIEW_PENDING_WITHDRAWALS_NEXT: 'view_pending_withdrawals_next',
	VIEW_CREDITCARD: 'view_creditcard',
	VIEW_CREDITCARDLAST: 'view_creditcardlast',
	VIEW_CREDITCARDNEW: 'view_creditcardnew',
	VIEW_UK_FIRST_TIME_DEPOSIT_LINK: 'view_uk_first_time_deposit_link',
	VIEW_NAV: 'view_nav',
	VIEW_PAYMENTFORM: 'view_paymentform',
	VIEW_PAYMENTFORM_SUBMIT: 'view_paymentform_submit',
	VIEW_PAYMENT_METHOD_LINK: 'view_payment_method_link',
	VIEW_PENDING_WITHDRAWALS: 'view_pending_withdrawals',
	// payment Sendhandlers, defined as upper case in database
	RESULT_AFTER_SINGLE_CALL: 'RESULT_AFTER_SINGLE_CALL',
	PENDING_RESULT_AFTER_SINGLE_CALL: 'PENDING_RESULT_AFTER_SINGLE_CALL',
	EXTERNAL_PANEL: 'EXTERNAL_PANEL',
	EXTERNAL_WINDOW: 'EXTERNAL_WINDOW',
	SEND_HANDLER_CONTROLLER: 'SEND_HANDLER_CONTROLLER',
	INTERNAL_PANEL: 'INTERNAL_PANEL',
	ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL: 'ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL',
	EXTERNAL_WINDOW_IFRAME: 'EXTERNAL_WINDOW_IFRAME',
	// End payment sendhandlers
	// Payment status, defined as enum in java: successful, cancelled, pending, notFound
	SUCCESS: 'successful',
	CANCELLED: 'cancelled',
	PENDING: 'pending',
	NOT_FOUND: 'notFound',
	RELOAD_BONUSES: 'reload_bonuses',
	SHOP_HANDLE_BONUS_FOR_DEPOSIT: 'shop_handle_bonus_for_deposit',
	VIEW_METHODS: 'VIEW_METHODS',
	// End Payment status
	TRANSITION_DEFAULT_TIME: 250,
	CANCEL_WITHDRAW_FAIL_NOTIFICATION: 'cancel_withdraw_fail_notification',
	RELOAD_BONUSES_FREE_MONEY_BONUS_SUCCESS: 'reload_bonuses_free_money_bonus_success',
	VIEW_SELECT_SKRILL_ACCOUNTING: 'view_selectskrillaccount'
};
/* harmony default export */ __webpack_exports__["a"] = constants;

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_tomcat_cookies_js__ = __webpack_require__(23);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return sessionKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return lastProduct; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return navigation; });
/* unused harmony export lovedGames */
/* unused harmony export recentlyPlayedGames */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isoCode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return locale; });
/* unused harmony export justAccepted */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setNavigationCookies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return setDesktopCookies; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return rootDomain; });
/* unused harmony export getCookies */


function getCookies(cookie) {
	var cookieValue = __WEBPACK_IMPORTED_MODULE_0__libs_tomcat_cookies_js__["a" /* default */].get(cookie);
	if (cookieValue && cookieValue !== 'undefined') {
		return cookieValue;
	}
	return null;
}
var sessionKey = function sessionKey() {
	return getCookies('sessionId');
};

var lastProduct = function lastProduct() {
	return getCookies('lastProduct');
};

var navigation = function navigation() {
	return getCookies('navigation');
};

var lovedGames = function lovedGames() {
	return getCookies('lovedGames');
};

var recentlyPlayedGames = function recentlyPlayedGames() {
	return getCookies('recentlyPlayedGames');
};

var isoCode = function isoCode() {
	return getCookies('isocode');
};

var locale = function locale() {
	return getCookies('locale');
};

var justAccepted = function justAccepted() {
	return getCookies('justAccepted');
};

var rootDomain = function rootDomain() {
	return getRootDomain();
};

function getRootDomain() {
	return location.href.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i)[1].replace('mobile.', '').split(':')[0];
}

function setDesktopCookies() {
	__WEBPACK_IMPORTED_MODULE_0__libs_tomcat_cookies_js__["a" /* default */].set('deviceRedirection', '443', { domain: rootDomain() });
	__WEBPACK_IMPORTED_MODULE_0__libs_tomcat_cookies_js__["a" /* default */].set('useMobile', false, { domain: rootDomain() });
}

/**
 * Set last product cookie. It helps to determine what view to request from sever.
 *
 * @param {string} arg - It must be one of 'casino', 'shop' or 'sportsbook'
 */
function setNavigationCookies(arg) {
	if (arg !== undefined && arg != null && lastProduct() !== arg) {
		/**
   * @deprecated 'navigation' cookie is depricated. use 'lastProduct' instead.
   */
		console.warn('\'navigation\' cookie is depricated. use \'lastProduct\' instead. It\'ll be removed after MVP');
		__WEBPACK_IMPORTED_MODULE_0__libs_tomcat_cookies_js__["a" /* default */].set('navigation', arg, { path: '/' });
		__WEBPACK_IMPORTED_MODULE_0__libs_tomcat_cookies_js__["a" /* default */].set('lastProduct', arg, { path: '/' });
	}
}



/***/ }),
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchJson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return postFormUrlEncoded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return postJson; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return postFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return postObjectAsFormUrlEncoded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return putJson; });
function sendJson(url, data, httpMethod) {
	var headers = new Headers();
	headers.append('Content-Type', 'application/json');
	var options = {
		headers: headers,
		method: httpMethod,
		mode: 'cors',
		cache: 'default',
		credentials: 'include',
		body: JSON.stringify(data)
	};

	return fetch(url, options).then(function (response) {
		if (response.status === 204) {
			return undefined;
		}
		return response.json();
	}).catch(function (e) {
		console.log(e + ' for ' + httpMethod + ' ' + url);

		return Promise.reject(e);
	});
}
function postJson(url, data) {
	return sendJson(url, data, 'POST');
}

function postFile(url, file) {
	var form = new FormData();
	form.append('file', file);
	var options = {
		method: 'POST',
		credentials: 'include',
		body: form
	};
	return fetch(url, options).then(function (response) {
		return response.json();
	}).catch(function (e) {
		return Promise.reject(e);
	});
}

function putJson(url, data) {
	return sendJson(url, data, 'PUT');
}

function postFormUrlEncoded(url, urlEncodedData) {
	var headers = new Headers();
	headers.append('Content-Type', 'application/x-www-form-urlencoded');

	var options = {
		headers: headers,
		method: 'POST',
		mode: 'cors',
		cache: 'default',
		credentials: 'include',
		body: urlEncodedData
	};
	return fetch(url, options).then(function (response) {
		return response.json();
	}).catch(function (e) {
		console.log('Post url-encoded form failed. url=' + url + ', options=' + urlEncodedData + ', error:', e);
		return Promise.reject(e);
	});
}

function createUrlParameters(data) {
	return Object.keys(data).map(function (key) {
		var encodedKey = encodeURIComponent(key);
		var encodedDataKey = encodeURIComponent(data[key]);
		return encodedKey + '=' + encodedDataKey;
	}).join('&');
}

function getUrl(url, data) {
	if (data === undefined) {
		return url;
	}
	return url + '?' + createUrlParameters(data);
}

function postObjectAsFormUrlEncoded(url, data) {
	return postFormUrlEncoded(url, createUrlParameters(data));
}

function fetchJson(url, data) {
	var headers = new Headers();
	headers.append('accept', 'application/json');
	var options = {
		headers: headers,
		method: 'GET',
		credentials: 'include',
		cache: 'no-store'
	};

	return fetch(getUrl(url, data), options).then(function (response) {
		return response.json();
	});
}



/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/*
commonview/view_textkeys

Sunny: Textkeys may be stored in an attribute for a hidden tag and then
filtered out by selecting the tag in the dom.
 An exemple exists in src/main/app/packages/mobile-core-assets/templates/html/account/textkeys-payment.mustache.
To filter out the textkeys from an element into an object there is a method in the
core-library, see example in
src/main/app/packages/mobile-core/src/payment/pendingwithdrawals/lib/view.js :
textkeysObj = core.getTextkeysFromElement(elements.textkeys[0], 'pendingwithdrawals:view');

usage:
import viewTextkeys from '../../commonview/view-textkeys.js'
const textkeysObj = viewTextkeys.depositflow(); // add hidden dom-element with textkeys for the area of interest.

*/


var elements = null;
var textkeysObjDepositflow = null;
var selectors = {
	payment: '#js-textkeys-depositflow'
};

function init() {
	elements = elements || __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].selectElements(selectors, 'view_textkeys:init');
}

/* harmony default export */ __webpack_exports__["a"] = {
	depositflow: function depositflow() {
		init();
		textkeysObjDepositflow = textkeysObjDepositflow || __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].getTextkeysFromElement(elements.payment, 'view_textkeys:20:selectElements');
		return textkeysObjDepositflow;
	}
};

/***/ }),
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__payment_common_lib_core_js__ = __webpack_require__(2);
/* mobile-core/src/notifications */

// import $ from 'jquery';


var $ = jQuery;

var $globalNotificationsContainer = $('.global-notification');
var typesArray = ['success', 'fail'];

// Effects are not implemented/used for MVP
var validEffects = ['confetti', 'rain'];

var validColors = ['red', 'green', 'yellow'];
var iconsForConfirmationModal = ['default-success', 'default-failure', 'forgotten-password', 'has-documents', 'empty-documents'];
var timerForMessageAutoHide = 20000;
var elements = {};

var storedInfo = void 0;

function _hideNotification() {
	var $notification = $globalNotificationsContainer.find('.notification-wrap');
	$notification.removeClass('notification-wrap--open').addClass('notification-wrap--close');
	$notification.find('.notification-wrap__error-text-msg').text('');
	$globalNotificationsContainer.removeClass('global-notification--is-open');
}

function shouldHideGlobalNotification() {
	var notificationArray = document.querySelectorAll('.notify--is-open');
	var notifyArray = [];
	for (var i = 0; i < notificationArray.length; i += 1) {
		if (notificationArray[i].classList.contains('u-hide') === false) {
			notifyArray.push(notificationArray[i]);
		}
	}
	return notifyArray.length < 1;
}

function _closeNotifyWrapper($notifyWrapper) {
	// TODO clean messages
	$($notifyWrapper).removeClass('notify--is-open');
	if (shouldHideGlobalNotification()) {
		$globalNotificationsContainer.removeClass('global-notification--is-open');
	}
}

function _showNotification(message, color, autoHide, customTimer) {
	var $notification = $globalNotificationsContainer.find('.notification-wrap');
	var notificationColor = color && $.inArray(color, validColors) >= 0 ? color : 'yellow';

	document.getElementsByClassName('notification-wrap__error-text-msg')[0].innerHTML = message;

	$globalNotificationsContainer.addClass('global-notification--is-open');
	$notification.removeClass('notification-wrap--close red green yellow').addClass('notification-wrap--open ' + notificationColor);

	// add click handler to close the notification
	$notification.find('.icon-close').on('click', function (event) {
		event.preventDefault();
		event.stopPropagation();
		_hideNotification();
	});

	if (autoHide) {
		setTimeout(function () {
			_hideNotification();
		}, customTimer || timerForMessageAutoHide);
	}
}

function _showInformationMessage(type, titleText, messageText, effect, time, closeCallback) {
	var $informationWrapper = $globalNotificationsContainer.find('.js-information-message');
	var textWrapper = $informationWrapper.find('.notify__text-wrapper');
	var titleElement = textWrapper.find('.js-notify__main-title');
	var messageElement = textWrapper.find('.js-notify__p');
	var confirmationEffect = effect && $.inArray(effect, validEffects) >= 0 ? effect : '';
	var typeSelected = type && $.inArray(type, typesArray) >= 0 ? type : 'success';
	var $closeButton = $informationWrapper.find('.icon-close');
	var timeToShow = time || timerForMessageAutoHide;
	var $successIcon = $informationWrapper.find('.js-icon-success');
	var $failIcon = $informationWrapper.find('.js-icon-fail');

	if (typeSelected === 'success') {
		$successIcon.removeClass('u-hide');
		$failIcon.addClass('u-hide');
	} else {
		$successIcon.addClass('u-hide');
		$failIcon.removeClass('u-hide');
	}

	titleElement.text(titleText);
	messageElement.text(messageText);

	$globalNotificationsContainer.addClass('global-notification--is-open');
	$informationWrapper.addClass('notify--is-open' + confirmationEffect);

	// enter negative time to disable auto-hide
	// Always enable close button
	if (timeToShow > 0) {
		// $closeButton.addClass('u-hide');
		setTimeout(function () {
			_closeNotifyWrapper($informationWrapper);
			$(titleElement, messageElement).text('');
		}, timeToShow);
	} // else {
	$closeButton.removeClass('u-hide');
	$closeButton.off('click');

	if (closeCallback) {
		$closeButton.click(function () {
			closeCallback();
		});
	} else {
		$closeButton.click(function () {
			_closeNotifyWrapper($informationWrapper);
			$(titleElement, messageElement).text('');
		});
	}
	// }
}

function closeConfirmationMessage() {
	__WEBPACK_IMPORTED_MODULE_0__payment_common_lib_core_js__["a" /* default */].removeClass(elements.confirmationWrapper, 'notify--is-open');
	if (shouldHideGlobalNotification()) {
		__WEBPACK_IMPORTED_MODULE_0__payment_common_lib_core_js__["a" /* default */].removeClass(elements.wrap, 'global-notification--is-open');
	}
	elements.icon.classList.add('u-hide');
	elements.closeButtonElement.classList.add('u-hide');
	elements.buttonElement.innerHTML = '';
	elements.closeButtonElement.innerHTML = '';
	elements.mainTitle.innerHTML = '';
	elements.mainText.innerHTML = '';
}
function _showConfirmationMessage(p) {
	var iconIdentifier = p.iconIdentifier;
	var titleText = p.titleText;
	var messageText = p.messageText;
	var buttonText = p.buttonText;
	var confirmCallback = p.confirmCallback;
	var closeButtonText = p.closeButtonText;
	var callbacks = p.callbacks;
	var globalWrap = p.globalWrap;

	var confirmationCallback = confirmCallback;
	var iconSelected = iconIdentifier && $.inArray(iconIdentifier, iconsForConfirmationModal) >= 0 ? iconIdentifier : 'default-success';
	elements.confirmationWrapper = elements.wrap.querySelector('.js-confirm-modal');
	elements.iconWrapper = elements.confirmationWrapper.querySelector('.js-notify__icon-wrapper');
	elements.icon = elements.iconWrapper.querySelector('.' + iconSelected);
	elements.mainTitle = elements.confirmationWrapper.querySelector('.js-notify__main-title');
	elements.mainText = elements.confirmationWrapper.querySelector('.js-notify__main-text');
	elements.buttonWrapper = elements.confirmationWrapper.querySelector('.js-notify__button-wrapper');
	elements.buttonElement = elements.buttonWrapper.querySelector('.js-button');
	elements.closeButtonElement = elements.buttonWrapper.querySelector('.js-close-button');
	elements.buttonElement.innerHTML = buttonText || '';
	elements.closeButtonElement.innerHTML = closeButtonText || '';
	elements.mainTitle.innerHTML = titleText || '';
	elements.mainText.innerHTML = messageText || '';

	function showIcon() {
		__WEBPACK_IMPORTED_MODULE_0__payment_common_lib_core_js__["a" /* default */].addClass(elements.icon, 'u-show');
		__WEBPACK_IMPORTED_MODULE_0__payment_common_lib_core_js__["a" /* default */].removeClass(elements.icon, 'u-hide');
	}

	function openWrappers() {
		__WEBPACK_IMPORTED_MODULE_0__payment_common_lib_core_js__["a" /* default */].addClass(elements.wrap, 'global-notification--is-open');
		__WEBPACK_IMPORTED_MODULE_0__payment_common_lib_core_js__["a" /* default */].addClass(elements.confirmationWrapper, 'notify--is-open');
	}

	function clickAcceptHandler() {
		if (confirmationCallback) {
			confirmationCallback();
		}
		closeConfirmationMessage(globalWrap);
	}

	function clickCancelHandler() {
		if (callbacks && callbacks.closeCallback) {
			callbacks.closeCallback();
		}
		closeConfirmationMessage(globalWrap);
	}

	function showCloseButton() {
		if (closeButtonText) {
			elements.closeButtonElement.classList.remove('u-hide');
		}
	}

	elements.buttonElement.addEventListener('click', clickAcceptHandler);
	elements.closeButtonElement.addEventListener('click', clickCancelHandler);
	showIcon();
	showCloseButton();
	openWrappers();
	if (callbacks && callbacks.viewReadyCallback) {
		callbacks.viewReadyCallback();
	}
}

function _showBinaryQuestion(title, confirmButtonText, rejectButtonText, confirmCallback, rejectCallback, text) {
	var $binaryQuestionWrapper = $globalNotificationsContainer.find('.js-binary-question');
	var titleWrapper = $binaryQuestionWrapper.find('.js-title');
	var textWrapper = $binaryQuestionWrapper.find('.js-');
	var confirmButton = $binaryQuestionWrapper.find('.binary-question__yes');
	var rejectButton = $binaryQuestionWrapper.find('.binary-question__no');
	var confirmationCallback = confirmCallback || function empty() {};
	var rejectionCallback = rejectCallback || function empty() {};

	if (confirmButtonText) {
		confirmButton.text(confirmButtonText);
	}
	if (rejectButtonText) {
		rejectButton.text(rejectButtonText);
	}

	confirmButton.off();

	confirmButton.on('click', function (e) {
		e.preventDefault();
		confirmationCallback();
		_closeNotifyWrapper($binaryQuestionWrapper);
	});

	rejectButton.off();

	rejectButton.on('click', function (e) {
		e.preventDefault();
		rejectionCallback();
		_closeNotifyWrapper($binaryQuestionWrapper);
	});

	titleWrapper.text(title);
	textWrapper.text(text);

	$globalNotificationsContainer.addClass('global-notification--is-open');
	$binaryQuestionWrapper.addClass('notify--is-open');
}

function init() {
	var globalContainer = document.querySelector('.global-notification');
	$globalNotificationsContainer = $globalNotificationsContainer || $('.global-notification');
	elements.wrap = globalContainer;
	return globalContainer;
	/* this wrapper is put into below the #container div and in one occurence per casino, shop and ... */
}

// Use the exported api instead // Sunny
// window.showNotification = showNotification;
window.showNotification = function printToConsole(message, color, autoHide, customTimer) {
	console.error('notifications: do not use this module from the window object. Use the exported api instead.');
	_showNotification(message, color, autoHide, customTimer);
};

/* harmony default export */ __webpack_exports__["a"] = {
	showInformationMessage: function showInformationMessage(type, titleText, messageText, effect, time, closeCallback) {
		// TODO: adding an intermediate layer to separate implementation from api and place readability to the export.
		init();
		_showInformationMessage(type, titleText, messageText, effect, time, closeCallback);
	},
	showConfirmationMessage: function showConfirmationMessage(iconIdentifier, titleText, messageText, buttonText, confirmCallback, closeButtonText, callbacks) {
		// TODO: adding an intermediate layer to separate implementation from api and place readability to the export.
		var globalWrap = init();
		// showConfirmationMessage(iconIdentifier, titleText, messageText, buttonText, confirmCallback, closeButtonText, callbacks);
		_showConfirmationMessage({
			iconIdentifier: iconIdentifier,
			titleText: titleText,
			messageText: messageText,
			buttonText: buttonText,
			confirmCallback: confirmCallback,
			closeButtonText: closeButtonText,
			callbacks: callbacks,
			globalWrap: globalWrap
		});
	},
	showBinaryQuestion: function showBinaryQuestion(messageText, confirmButtonText, rejectButtonText, confirmCallback, rejectCallback) {
		// TODO: adding an intermediate layer to separate implementation from api and place readability to the export.
		init();
		_showBinaryQuestion(messageText, confirmButtonText, rejectButtonText, confirmCallback, rejectCallback);
	},
	showNotification: function showNotification(message, color, autoHide, customTimer) {
		// TODO: adding an intermediate layer to separate implementation from api and place readability to the export.
		init();
		_showNotification(message, color, autoHide, customTimer);
	},
	hideNotification: function hideNotification() {
		// TODO: adding an intermediate layer to separate implementation from api and place readability to the export.
		init();
		_hideNotification();
	},
	closeNotifyWrapper: function closeNotifyWrapper(notifyWrapper) {
		// TODO: adding an intermediate layer to separate implementation from api and place readability to the export.
		init();
		_closeNotifyWrapper(notifyWrapper);
	},
	storeInfo: function storeInfo(p) {
		/* copy of text in 'signup-validation.js' :
   the notification is not directly controlled from here, since it gets overly complex to keep track of the
  mix of timers, global overlaying elements, navigation routing, notifications-module used by many modules and asynchrononus calls.
  The notifications module is therefore extended (temporarily) to keep the information and access it later.
  For example may this module be appended with a check to the 'storedInfo' object, to see if some data may be displayed.
  /Sunny jan 2017*/
		// {'posting':'signup-validation','type':informationmessage,success:true, message:msg}
		storedInfo = p;
	},

	hideConfirmationMessage: closeConfirmationMessage
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dispatcher_js__ = __webpack_require__(203);
/*

dataflow
build from the Flux pattern
This is the utility to enable the fluxpattern.

usage:
register, dispatch

Any module registers functions that then are invoked with any payload as argument.

var someFunctionWhichFiltersBehaviourFromPayloadType = function (payload) {
    if (payload.type === selected_type) {
        dosomething(payload.data);
    }
}

require('../../common/lib/dataflow').register(someFunctionWhichFiltersBehaviourFromPayloadType);
require('../../common/lib/dataflow').dispatch({
    'type': 'action_type',
    'data_1': 'some_data',
    'data_2': 'some other data'
}
});


*/


/* harmony default export */ __webpack_exports__["a"] = {
	register: function register(cb) {
		__WEBPACK_IMPORTED_MODULE_0__utils_dispatcher_js__["b" /* default */].register(cb);
	},
	unregister: function unregister(cb) {
		__WEBPACK_IMPORTED_MODULE_0__utils_dispatcher_js__["b" /* default */].unregister(cb);
	},
	dispatch: function dispatch(payload) {
		__WEBPACK_IMPORTED_MODULE_0__utils_dispatcher_js__["b" /* default */].dispatch(payload);
	}
};

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/**
 * Created by dilip on 14/06/16.
 */

// TODO This is a fix for an issue at Tomcat's end as explained here https://github.com/js-cookie/js-cookie/issues/100.
// Solution for temporary fix is listed here https://github.com/js-cookie/js-cookie/blob/master/SERVER_SIDE.md.
// This shall be removed and original js-cookie should be used as soon support for http://www.rfc-base.org/txt/rfc-6265.txt land in tomcat.



var TomcatCookies = __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.withConverter({
	write: function write(value) {
		// Encode all characters according to the "encodeURIComponent" spec
		return encodeURIComponent(value)
		// Revert the characters that are unnecessarly encoded but are
		// allowed in a cookie value
		.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
		// Encode the parens that are interpreted incorrectly by Tomcat
		.replace(/[\(\)]/g, escape);
	},
	read: function read(value) {
		return decodeURIComponent(value);
	}
});

/* harmony default export */ __webpack_exports__["a"] = TomcatCookies;

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return eventType; });
var eventType = 'click';



/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_currencyformatter_js__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_currencyformatter_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_currencyformatter_js__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var currencyFormatters = {
	EUR: {
		postFormat: function postFormat() {
			var currencySymbol = __WEBPACK_IMPORTED_MODULE_0_currencyformatter_js___default.a.symbols.EUR;
			var symbolLen = currencySymbol.length;
			var pattern = new RegExp('(\\s)+' + currencySymbol, 'g');
			var value = this.value;
			if (this.locale === 'fi_FI') {
				value = this.value.replace(pattern, currencySymbol);
			} else if (this.value.substr(-symbolLen, symbolLen) === currencySymbol) {
				value = this.value.replace(pattern, currencySymbol);
				value = currencySymbol + value.replace(currencySymbol, '');
			}
			return value;
		}
	},
	SEK: {
		locale: 'sv_SE'
	},
	NOK: {
		// show same as sek
		locale: 'sv_SE'
	},
	DKK: {
		locale: 'da_DK',
		postFormat: function postFormat() {
			if (this.value.charAt(this.value.length - 1) === '.') {
				return this.value.slice(0, -1);
			}
			return this.value;
		}
	},
	AUD: {
		locale: 'en_AU'
	},
	CAD: {
		locale: 'en_CA'
	},
	USD: {
		locale: 'en_US'
	},
	NZD: {
		locale: 'en_NZ'
	},
	GBP: {
		locale: 'en_GB'
	},
	CLP: {
		locale: 'en_GB',
		postFormat: function postFormat() {
			var currencySymbol = __WEBPACK_IMPORTED_MODULE_0_currencyformatter_js___default.a.symbols.CLP;
			return this.value.replace(currencySymbol, 'CLP' + currencySymbol);
		}
	},
	PLN: {
		locale: 'pl_PL'
	},
	RUB: {
		locale: 'ru_RU',
		symbol: 'RUB'
	}
};

function format2(value, options) {
	// extend options
	var config = _extends({ value: value }, options, currencyFormatters[options.currency]);

	// consolidate options for currency formatter
	var formatOptions = Object.assign({}, config.currency && { currency: config.currency }, config.symbol && { symbol: config.symbol }, config.locale && { locale: config.locale === 'en_XX' ? 'en_GB' : config.locale });

	config.value = __WEBPACK_IMPORTED_MODULE_0_currencyformatter_js___default.a.format(value, formatOptions);
	if (config.postFormat) {
		config.value = config.postFormat.call(config);
	}
	return config.value;
}

function format(number, currency, locale) {
	var floatNumber = number;

	if (floatNumber === undefined || !currency) {
		return '';
	}

	if (typeof floatNumber === 'string') {
		floatNumber = parseFloat(floatNumber);
	}

	return format2(floatNumber, { currency: currency, locale: locale.replace('-', '_') });
}

/* harmony default export */ __webpack_exports__["a"] = {
	format: format
};

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_tomcat_cookies_js__ = __webpack_require__(23);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLocale; });


function getLocale() {
	var locale = __WEBPACK_IMPORTED_MODULE_0__libs_tomcat_cookies_js__["a" /* default */].get('locale');
	return locale && locale.replace('_', '-');
}



/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_view_nav_js__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__ = __webpack_require__(2);
/*
navdeposit/index.js

usage:

Taking configuration from global navigation and updates wrappers navigation.


return:
*/



function doTemporaryFix() {
	// Fix to position the submitbuttons in the viewport at all times
	// A better solution is to use react-library to minimize the number of
	// dom-elements open, and thereby simplify the css. Sunny Dec 2016
	var htmlElm = document.querySelector('html');
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(htmlElm, 'overlay--open');
}

function resetTemporaryFix() {
	// Reset the Fix to position the submitbuttons in the viewport at all times
	var htmlElm = document.querySelector('html');
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(htmlElm, 'overlay--open');
}
/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(conf) {
		/* conf is probably parsed from global navigation */
		/* conf is set in the global navigation, components/register.js*/
		/* see also common/utils/lib/router-config.js */
		/* this init  is used from components/deposit-bonus.js */
		doTemporaryFix();
		__WEBPACK_IMPORTED_MODULE_0__lib_view_nav_js__["a" /* default */].init(conf);
	},
	close: function close() {
		resetTemporaryFix();
		__WEBPACK_IMPORTED_MODULE_0__lib_view_nav_js__["a" /* default */].close();
	}
};

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_custom_events_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_tomcat_cookies_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__floating_labels_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__spinner_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__toggle_password_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__casino_ingame_js__ = __webpack_require__(196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sportsbook_sports_helper_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__websocket_websocket_event_esm_js__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__config_settings_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__forgotten_password_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__menues_rootview_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__libs_currency_formatter_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__libs_locale_js__ = __webpack_require__(31);
/* global sessionStorage */




















var $login = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.log-in');
var $loginForm = $login.find('form');
var $termsForm = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.terms-menu').find('.u-btn-wrapper');
var $allGamesTab = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#section2');
var $allGamesGrid = $allGamesTab.find('.game-grid');
var $supportNav = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.support-nav');
var $bottomWrapper = $login.parent();
// const $notificationWrapper = $('.terms-menu');
var ERROR_CLASS = 'input-wrap__error';
var VALID_CLASS = 'is-valid';
var isInited = false;
var shouldShowCompliance = false;

function setLoginClass(state) {
	var root = document.documentElement;
	var status = state !== undefined ? state : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["c" /* sessionKey */])();
	if (status) {
		root.classList.add('is-logged-in');
		root.classList.remove('is-not-logged-in');
	} else {
		root.classList.add('is-not-logged-in');
		root.classList.remove('is-logged-in');
	}
}

setLoginClass();
function changeBalanceSportsbook(balance) {
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["d" /* navigation */])() === 'sportsbook') {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#casino-header-title').text(balance);
	}
}

function emptyBalanceSportsbook() {
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["d" /* navigation */])() === 'sportsbook') {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#casino-header-title').text('');
	}
}

function setLoggedOutStyle() {
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.header-icon--login').removeClass('u-hide').addClass('u-show');
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.header-icon--account').removeClass('u-show').addClass('u-hide');
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.bottom-wrapper').removeClass('log-in--loggedin');
	$login.addClass('log-in--is-not');

	setLoginClass(false);

	closeAllWindows();
}

function closeAllWindows() {
	__WEBPACK_IMPORTED_MODULE_16__menues_rootview_js__["a" /* default */].closeMySettings();
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#js-deposit-flow').removeClass('deposit--open');
}

// Logout
function simpleLogout(message) {
	// var loginBtn = $loginForm.find('.login-in-button');
	var loggedOutMsg = message.message;
	__WEBPACK_IMPORTED_MODULE_5__notifications_js__["a" /* default */].showNotification(loggedOutMsg, 'red', true);

	logoutSetUp();
	emptyBalanceSportsbook();

	if (location.href.includes('shop')) {
		location.reload();
	}
}

__WEBPACK_IMPORTED_MODULE_10__websocket_websocket_event_esm_js__["a" /* default */].on('player.logout', function (event, message) {
	console.info(event, message);
	if (typeof message.webSessionIdToKeep === 'undefined' || message.webSessionIdToKeep !== __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["c" /* sessionKey */])()) {
		__WEBPACK_IMPORTED_MODULE_10__websocket_websocket_event_esm_js__["a" /* default */].disconnect();
		simpleLogout(message);
	}
});

__WEBPACK_IMPORTED_MODULE_10__websocket_websocket_event_esm_js__["a" /* default */].on('player.update', function (event, message) {
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["d" /* navigation */])() === 'sportsbook') {
		console.info(event, message);
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__core_ajax_json_js__["a" /* fetchJson */])('/player/currency').then(function (response) {
			var formattedBalance = __WEBPACK_IMPORTED_MODULE_17__libs_currency_formatter_js__["a" /* default */].format(message.totalBalance, response.result, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__libs_locale_js__["a" /* getLocale */])());
			changeBalanceSportsbook(formattedBalance);
		});
	}
});

function closeSupportNavIfOpen() {
	$supportNav.removeClass('support-nav--is-open');
}

function openLoginFrom(gameCode) {
	init();
	closeSupportNavIfOpen();
	$login.removeClass('u-hide').addClass('u-show');
	$bottomWrapper.addClass('log-in--open');
	$login.removeClass('log-in--is-not');

	setTimeout(function () {
		$bottomWrapper.addClass('u-transform-none u-absolute u-pos-t0');
	}, 750);

	if (gameCode) {
		$login.find('.login-in-button').attr('loadGame', gameCode);
	}
}

function changeHeaderIcon() {
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.header-icon--login').removeClass('u-show').addClass('u-hide');
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.header-icon--account').removeClass('u-hide logged-out').addClass('u-show');
	$bottomWrapper.addClass('log-in--loggedin');
}

function closeLoginForm() {
	$bottomWrapper.removeClass('menu--is-open log-in--open');
	$login.addClass('log-in--is-not');
	$bottomWrapper.removeClass('log-in--open u-transform-none u-absolute u-pos-t0');
	$loginForm.find('.login-in-button').removeClass('btn--is-loading');
}

function doLogin($game, termsAccepted) {
	/* After each login the getPlayerInfo, getPlayerBalance and getPlayerPoints are called. */
	var $email = $loginForm.find("input[id='login-email']");

	var $pass = $loginForm.find("input[id='login-password']");

	var data = {
		email: $email.val(),
		password: $pass.val(),
		isComplianceTermsAccepted: false
	};

	if (termsAccepted) {
		data.isComplianceTermsAccepted = true;
	}

	__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		url: '/player/session/login',
		method: 'POST',
		data: JSON.stringify(data),
		contentType: 'application/json; charset=utf-8'
	}).done(function (resultData) {
		var dmain = null; // temp while dev.
		if (resultData.status === 'SUCCESS') {
			__WEBPACK_IMPORTED_MODULE_3__libs_tomcat_cookies_js__["a" /* default */].set('reality-check-login', true);
			__WEBPACK_IMPORTED_MODULE_1__utils_custom_events_js__["a" /* emitter */].emit('login');
			__WEBPACK_IMPORTED_MODULE_3__libs_tomcat_cookies_js__["a" /* default */].set('login', true);
			var newSessionKey = resultData.result.sessionKey;
			__WEBPACK_IMPORTED_MODULE_5__notifications_js__["a" /* default */].hideNotification();
			changeHeaderIcon();
			dmain = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["e" /* rootDomain */])();
			__WEBPACK_IMPORTED_MODULE_3__libs_tomcat_cookies_js__["a" /* default */].set('sessionId', newSessionKey, { domain: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["e" /* rootDomain */])() });
			__WEBPACK_IMPORTED_MODULE_3__libs_tomcat_cookies_js__["a" /* default */].set('loginEmail', data.email);
			console.info('login:sessionId:', newSessionKey);
			console.info('login:domain', dmain);

			if ({}.hasOwnProperty.call(resultData.result, 'shouldShowComplianceMessage')) {
				shouldShowCompliance = resultData.result.shouldShowComplianceMessage;
			} else {
				console.warn('could not find compliance flag');
			}

			if (termsAccepted && !shouldShowCompliance) {
				//we replace the t&c page in the history to stop user going back to it
				//we replace t&c page with '/casino' if the user came from landing page
				//we don't want the user to go back to landing page after logging in
				var redirectUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__store_history_js__["d" /* basePathname */])() == '/' ? '/casino' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__store_history_js__["d" /* basePathname */])();
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__store_history_js__["f" /* replace */])(redirectUrl);
			}

			if (shouldShowCompliance) {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__store_history_js__["c" /* push */])('/terms_and_conditions');
				__WEBPACK_IMPORTED_MODULE_5__notifications_js__["a" /* default */].showNotification(resultData.result.complianceMessageHeader, 'green', true);
				// TODO get rid of this once notifications are sorted
				// this is to make the buttons clickable on t&c page
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.global-notification').addClass('is-simple-notification');
				return;
			}

			// Notify native app clients about the login action and provide the necessary credentials.
			try {
				window.webkit.messageHandlers.nativeBridgeHandler.postMessage((data.WebAction = 'Login', data));
			} catch (e) {
				console.log('Native bridge error : ', e);
			}

			// clean login form if user already accepted the T&C
			// else keep the data on loginform for use in logging user in again after accept
			// don't clear login field CO-17549
			// $loginForm.find('input[type=text], input[type=email], input[type=password]').val('');
			// remove helper classes
			$bottomWrapper.removeClass('u-transform-none u-absolute u-pos-t0');

			try {
				__WEBPACK_IMPORTED_MODULE_10__websocket_websocket_event_esm_js__["a" /* default */].connect(newSessionKey);
			} catch (e) {
				console.error('Websocket error:', e);
			}

			if ($game) {
				// we don't close the login form here because this is a redirect currently.
				// loagGame gets the game object, fun mode false, callback to execute when session not longer valid
				__WEBPACK_IMPORTED_MODULE_8__casino_ingame_js__["a" /* default */].loadGame($game, false, openLoginFrom($game));
				return;
			}

			var referrer = __WEBPACK_IMPORTED_MODULE_12__store_history_js__["a" /* history */].location.state.from.pathname;
			if (__WEBPACK_IMPORTED_MODULE_2__config_js__["a" /* default */].page === 'landing') {
				console.log(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["a" /* lastProduct */])());
				if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["a" /* lastProduct */])()) {
					getDefaultPath(function () {
						document.location.replace('/global');
					});
				} else {
					if (referrer) {
						document.location.replace(referrer);
					} else {
						getDefaultPath(function (path) {
							document.location.replace(path);
						});
					}
				}
			} else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["a" /* lastProduct */])() === 'shop') {
				document.location.replace('/shop');
			} else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["a" /* lastProduct */])() === 'sportsbook') {
				if (referrer) {
					__WEBPACK_IMPORTED_MODULE_9__sportsbook_sports_helper_js__["a" /* default */].fetchToken(referrer);
				} else {
					getDefaultPath(function (path) {
						__WEBPACK_IMPORTED_MODULE_9__sportsbook_sports_helper_js__["a" /* default */].fetchToken(path);
					});
				}
			} else {
				if (referrer) {
					document.location.replace(referrer);
				} else {
					getDefaultPath(function (path) {
						document.location.replace(path);
					});
				}
			}
		}
		if (resultData.status === 'FAILURE') {
			console.error(resultData.errorDescription + '. Code: ' + resultData.errorCode);
			__WEBPACK_IMPORTED_MODULE_5__notifications_js__["a" /* default */].showNotification(resultData.errorDescription, 'red', true);

			if (resultData.errorDescription.includes('<a href')) {
				//TODO find a good way to validate the error textkey has an anchor tag in it and style it properly
				document.getElementsByClassName('notification-wrap__error-text-msg')[0].getElementsByTagName('a')[0].onclick = function () {
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["f" /* setDesktopCookies */])();
					return true;
				};
			}

			$loginForm.find('.login-in-button').removeClass('btn--is-loading');
		}
		setLoginClass(true);
	}).fail(function (jqXHR, textStatus, errorThrown) {
		console.error(jqXHR, textStatus, errorThrown);
		var loginButton = document.getElementsByClassName('js-login-button');
		__WEBPACK_IMPORTED_MODULE_5__notifications_js__["a" /* default */].showNotification(loginButton[0].getAttribute('data-error-message-ajax-failure'), 'red');
		setLoginClass(false);
	}).always(function () {
		__WEBPACK_IMPORTED_MODULE_6__spinner_js__["a" /* default */].hide($loginForm);
		__WEBPACK_IMPORTED_MODULE_6__spinner_js__["a" /* default */].hide($termsForm);
	});
}

function getDefaultPath(cb) {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__core_ajax_json_js__["a" /* fetchJson */])('/site').then(function (response) {
		var defaultPath = response.result.toLowerCase();
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["b" /* setNavigationCookies */])(defaultPath);
		cb(defaultPath);
	});
}

function logoutSetUp() {
	setLoggedOutStyle();
	__WEBPACK_IMPORTED_MODULE_3__libs_tomcat_cookies_js__["a" /* default */].remove('sessionId', { domain: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["e" /* rootDomain */])() });
	__WEBPACK_IMPORTED_MODULE_3__libs_tomcat_cookies_js__["a" /* default */].remove('franchise', { domain: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["e" /* rootDomain */])() });
	/**
  * Push to default product URL.
  * @todo - only push if current view is private
  */
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__store_history_js__["f" /* replace */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__store_history_js__["d" /* basePathname */])());
	__WEBPACK_IMPORTED_MODULE_1__utils_custom_events_js__["a" /* emitter */].emit('logout');
}

function sendLogout() {
	__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		url: '/player/session/logout',
		type: 'GET',
		contentType: 'application/json; charset=utf-8'
	}).done(function (resultData) {
		if (resultData.status === 'SUCCESS') {}
		if (resultData.status === 'FAILURE') {
			console.log('Failed on logout ' + resultData.errorDescription + 'Error code: ' + resultData.errorCode);
			__WEBPACK_IMPORTED_MODULE_5__notifications_js__["a" /* default */].showNotification('Failed on logout ' + resultData.errorDescription, 'red', true);
		}

		logoutSetUp();
		emptyBalanceSportsbook();

		$loginForm.find('.login-in-button').removeClass('btn--is-loading');
		if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["a" /* lastProduct */])() === 'shop') {
			location.reload();
		}
	}).fail(function (jqXHR, textStatus, errorThrown) {
		console.error(jqXHR, textStatus, errorThrown);
		logoutSetUp();
	});
}

// Logout
function doLogout() {
	// TODO add spinner
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["c" /* sessionKey */])() && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["c" /* sessionKey */])() !== 'undefined') {
		sendLogout();
	} else {
		logoutSetUp();
	}
}

function checkComplianceFlag() {
	return shouldShowCompliance;
}

function displayError(field) {
	var $inputField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(field);
	var $inputFieldParent = $inputField.parent();
	var errorMessage = $inputFieldParent.data('content-error');
	if ($inputFieldParent.data('content-dynamic-error') !== undefined) {
		errorMessage = $inputField.data('content-dynamic-error');
	}
	$inputFieldParent.find('.js-input-error-display').text(errorMessage);
}

function removeErrorMessage(field) {
	var $inputField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(field);
	var $inputFieldParent = $inputField.parent();
	$inputFieldParent.find('.js-input-error-display').text('');
}

function markInvalid($input) {
	$input.addClass(ERROR_CLASS).removeClass(VALID_CLASS);
	displayError($input);
}

function markValid($input) {
	$input.addClass(VALID_CLASS).removeClass(ERROR_CLASS);
	removeErrorMessage($input);
}

function validateLoginForm(loginForm) {
	/* The argument is a jquery-selection, and contains jquery specific functionality. Therfore it is preceeded by '$' to denotate this.
  'The .val() method is primarily used to get the values
  of form elements such as input, select and textarea.  */

	// validate fields
	var $email = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(loginForm).find("input[id='login-email']");

	var $pass = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(loginForm).find("input[id='login-password']");
	var emailValid = false;
	var passValid = false;

	// TODO add real email and pass validation
	if (!$email.val()) {
		markInvalid($email);
	} else {
		markValid($email);
		emailValid = true;
	}
	if (!$pass.val()) {
		markInvalid($pass);
	} else {
		markValid($pass);
		passValid = true;
	}
	return emailValid && passValid;
}

function setUpClickHandlers() {
	$login.find('.page-head .icon-close').on(__WEBPACK_IMPORTED_MODULE_13__config_settings_js__["a" /* eventType */], function () {
		// var router = require('./router');
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__store_history_js__["f" /* replace */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__store_history_js__["d" /* basePathname */])());
	});

	// submit form and do login
	$loginForm.find('.login-in-button').on(__WEBPACK_IMPORTED_MODULE_13__config_settings_js__["a" /* eventType */], function submitLogin(event) {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('btn--is-loading'); // Hide the text on the button
		var gameToOpen = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('loadgame');
		var $game = void 0;

		/* event.preventDefault() or 'return false' is required here, otherwise the page will redirect. */
		event.preventDefault();
		event.stopPropagation();

		if (gameToOpen) {
			$game = $allGamesGrid.find('.game-item[data-gamecode="' + gameToOpen + '"]');
		}

		if (validateLoginForm($loginForm)) {
			__WEBPACK_IMPORTED_MODULE_6__spinner_js__["a" /* default */].show($loginForm);
			doLogin($game);
		}
	});
	var loginElem = document.getElementsByClassName('log-in')[0];
	if (loginElem !== undefined) {
		__WEBPACK_IMPORTED_MODULE_14__forgotten_password_js__["a" /* default */].init(document.getElementsByClassName('log-in')[0]);
	}

	// Logout - is handled by <a href="#/logout">... see 'router.js'
}

function init() {
	/* if already initialized it should not be possible to repeat the setup. Clickhandlers are then for example added again. */
	/* An alternative way to init is to hook up this module to an action handler. Anywhere from the application the login
  then may be initialized without need for a strong coupling to this api
  (see fluxpattern for more info. https://facebook.github.io/flux/) */
	if (isInited) {
		return;
	}

	__WEBPACK_IMPORTED_MODULE_4__floating_labels_js__["a" /* default */].setupPersistentLabels($loginForm);
	__WEBPACK_IMPORTED_MODULE_7__toggle_password_js__["a" /* default */].setupInForm($loginForm);
	setUpClickHandlers();
	isInited = true;

	var loginEmail = __WEBPACK_IMPORTED_MODULE_3__libs_tomcat_cookies_js__["a" /* default */].get('loginEmail');
	if (loginEmail) {
		$loginForm.find("input[id='login-email']").val(loginEmail);
	}
	// const sessionKey = Cookies.get('sessionId');
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["c" /* sessionKey */])()) {
		__WEBPACK_IMPORTED_MODULE_10__websocket_websocket_event_esm_js__["a" /* default */].connect(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_cookies_js__["c" /* sessionKey */])());
	}
}

/**
 * Inititalize login form when it's open in openLoginFrom. Removed init from export.
 */

var loginApi = {
	doLogin: doLogin,
	doLogout: doLogout,
	openLoginFrom: openLoginFrom,
	closeLoginForm: closeLoginForm,
	changeHeaderIcon: changeHeaderIcon,
	checkComplianceFlag: checkComplianceFlag,
	getDefaultPath: getDefaultPath
};

/* harmony default export */ __webpack_exports__["a"] = loginApi;

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_merge_js__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__bonus_index_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navdeposit_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pendingwithdrawals_index_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__payment_index_js__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_cookies_js__ = __webpack_require__(10);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return closeStepsDepositflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return confAccountPendingWithdrawals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return confDepositBonus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return confDepositBonusNp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return confDepositBonusFromRegister; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return confDepositPaymentFromRegister; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return confDepositPaymentFromShop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return confDepositWithdraw; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return confDepositPayment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return confDepositPaymentNp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return confDepositPaymentNb; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return confDepositPaymentNpNb; });
/*
payment/common/lib/utils/router-config.js

Settings for the view in depositflow.

content of : Title, back-, skip-, and close-buttons

The setup is exported and used by the navigation, components/deposit-bonus.js and other components/deposit-*****.js

*/









var isLandingPage = __WEBPACK_IMPORTED_MODULE_5__store_index_js__["a" /* default */].page && __WEBPACK_IMPORTED_MODULE_5__store_index_js__["a" /* default */].page === 'landing';

function closeStepsDepositflow(step) {
	if (step.bonus) {
		__WEBPACK_IMPORTED_MODULE_1__bonus_index_js__["a" /* default */].close();
	}

	if (step.pendingwithdrawals) {
		__WEBPACK_IMPORTED_MODULE_3__pendingwithdrawals_index_js__["a" /* default */].close();
	}
	if (step.payment) {
		__WEBPACK_IMPORTED_MODULE_4__payment_index_js__["a" /* default */].close();
	}
}

function closebtnDepositBonusNpCb() {
	__WEBPACK_IMPORTED_MODULE_1__bonus_index_js__["a" /* default */].close();
	__WEBPACK_IMPORTED_MODULE_2__navdeposit_index_js__["a" /* default */].close();
}

function closebtnDepositWithdrawCb() {
	__WEBPACK_IMPORTED_MODULE_3__pendingwithdrawals_index_js__["a" /* default */].close();
	__WEBPACK_IMPORTED_MODULE_2__navdeposit_index_js__["a" /* default */].close();
}

function closebtnAccountPendingWithdrawalsCb() {
	__WEBPACK_IMPORTED_MODULE_3__pendingwithdrawals_index_js__["a" /* default */].close();
	__WEBPACK_IMPORTED_MODULE_2__navdeposit_index_js__["a" /* default */].close();
}
/* see mobile-core-assets/templates/html/account/deposit-main.mustache */
function getConfig(addToConfig) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge_js__["a" /* default */])({
		wrap: {
			selector: '#js-deposit-flow'
		},
		skip: {
			selector: '#js-deposit-skip-btn',
			url: null,
			cb: null,
			isPush: true
		},
		close: {
			selector: '#js-deposit-close-btn',
			url: null,
			cb: null,
			isPush: true
		},
		back: {
			selector: '#js-deposit-back-btn',
			url: null,
			cb: null,
			isPush: true
		},
		title: {
			selector: '#js-deposit-header-title'
		},
		textkeys: {
			selector: '.textkeys__payments'
		}
	}, addToConfig);
}

var confAccountPendingWithdrawals = getConfig({
	flowname: 'account/pendingwithdrawals',
	close: {
		selector: '#js-deposit-close-btn',
		url: '/account',
		cb: closebtnAccountPendingWithdrawalsCb
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-pendingwithdrawals-header-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

var confDepositBonus = getConfig({
	/* configuration for bonus when pendingwithdrawals exist */
	flowname: 'deposit/bonus',
	skip: {
		url: '/account/deposit/payment',
		cb: __WEBPACK_IMPORTED_MODULE_1__bonus_index_js__["a" /* default */].close()
	},
	back: {
		url: '/account/deposit/withdraw',
		cb: __WEBPACK_IMPORTED_MODULE_1__bonus_index_js__["a" /* default */].close()
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-bonus-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

/* see mobile-core-assets/templates/html/account/deposit-main.mustache */
var confDepositBonusNp = getConfig({
	/* configuration for bonus when no pendingwithdrawals exist (Np)*/
	flowname: 'deposit/bonusnp',
	skip: {
		url: '/account/deposit/paymentnp',
		cb: __WEBPACK_IMPORTED_MODULE_1__bonus_index_js__["a" /* default */].close()
	},
	close: {
		url: '/account',
		cb: closebtnDepositBonusNpCb
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-bonus-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

var confDepositBonusFromRegister = getConfig({
	/* configuration for bonus when arriving from registration. No close button exits. */
	flowname: 'deposit/bonusFromRegister',
	skip: {
		url: '/account/deposit/payment?referrer=register',
		/* skip must go with referrer parameter identical to the line set in register/register.js:  ('/account/deposit/bonus?referrer=register');*/
		cb: __WEBPACK_IMPORTED_MODULE_1__bonus_index_js__["a" /* default */].close()
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-bonus-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

/* see mobile-core-assets/templates/html/account/deposit-main.mustache */
var confDepositWithdraw = getConfig({
	flowname: 'deposit/withdraw',
	skip: {
		url: '/account/deposit/bonus',
		cb: __WEBPACK_IMPORTED_MODULE_3__pendingwithdrawals_index_js__["a" /* default */].close()
	},
	close: {
		url: '/account',
		cb: closebtnDepositWithdrawCb
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-pendingwithdrawals-header-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

/* see mobile-core-assets/templates/html/account/deposit-main.mustache */
var confDepositPayment = getConfig({
	/* configuration for deposit when pendingwithdrawals and bonus exist */
	flowname: 'deposit/payment',
	back: {
		selector: '#js-deposit-back-btn',
		url: '/account/deposit/bonus',
		cb: __WEBPACK_IMPORTED_MODULE_4__payment_index_js__["a" /* default */].close()
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-payment-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

/* see mobile-core-assets/templates/html/account/deposit-main.mustache */
var confDepositPaymentNb = getConfig({
	/* configuration for deposit when no bonus exist (Nb)*/
	flowname: 'deposit/paymentnb',
	back: {
		url: '/account/deposit/withdraw',
		cb: __WEBPACK_IMPORTED_MODULE_4__payment_index_js__["a" /* default */].close()
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-payment-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

/* see mobile-core-assets/templates/html/account/deposit-main.mustache */
var confDepositPaymentNp = getConfig({
	/* configuration for deposit when no pendingwithdrawals exist (Np)*/
	flowname: 'deposit/paymentnp',
	back: {
		url: '/account/deposit/bonusnp',
		cb: __WEBPACK_IMPORTED_MODULE_4__payment_index_js__["a" /* default */].close()
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-payment-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

var confDepositPaymentFromRegister = getConfig({
	/* configuration for deposit when arriving from bonus which was entered during the registration */
	flowname: 'deposit/paymentregister',
	close: {
		url: '/global',
		isPush: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__store_cookies_js__["a" /* lastProduct */])() || !isLandingPage
	},
	skip: {
		url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__store_cookies_js__["a" /* lastProduct */])() || !isLandingPage ? '/' : '/global',
		isPush: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__store_cookies_js__["a" /* lastProduct */])() || !isLandingPage,
		cb: __WEBPACK_IMPORTED_MODULE_4__payment_index_js__["a" /* default */].close()
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-payment-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

var confDepositPaymentFromShop = getConfig({
	/* configuration for deposit when arriving from bonus which was entered during the registration */
	/* the textkeys.title is replaced by the title in payment method view. */
	flowname: 'deposit/paymentregister',
	back: {
		selector: '#js-deposit-back-btn',
		url: '/shop',
		cb: __WEBPACK_IMPORTED_MODULE_4__payment_index_js__["a" /* default */].close()
	},
	skip: {
		url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__store_cookies_js__["a" /* lastProduct */])() || !isLandingPage ? '/' : '/global',
		isPush: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__store_cookies_js__["a" /* lastProduct */])() || !isLandingPage,
		cb: __WEBPACK_IMPORTED_MODULE_4__payment_index_js__["a" /* default */].close()
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		// title: 'deposit-payment-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});

var confDepositPaymentNpNb = getConfig({
	/* configuration for deposit when no pendingwithdrawals (Np) and no bonus exist (Nb)*/
	flowname: 'deposit/paymentnpnb',
	close: {
		url: '/account'
	},
	textkeys: {
		/* the domobject containing all parsed textstrings */
		title: 'deposit-payment-title' /* see textkeys-payment.mustache for the keys to the textkeys */
	}
});



/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_paymentform_js__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_spinner_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonview_lib_view_wrap_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_paymentmessage_js__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonview_lib_view_confirmationmessage_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonview_lib_view_binaryquestion_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/*
 payment/payment/view

 create and handle all dom-nodes for the payments
 all dom-updates are routed from this module.
 */










var create = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].create;
/* elements are set from the selectorsobject, which is set in the global navigation, router.js*/
var selectors = {
	textkeys: 'not set',
	wrap: null
};
var ageverifycb = void 0;
var agedontverifycb = void 0;
var elements = {};
var viewSpinnerInstance = void 0;
var textkeysObj = void 0;
var complianceverifycb = void 0;
var compliancedontverifycb = void 0;

function ageBinaryQuestionConfirmCb() {
	__WEBPACK_IMPORTED_MODULE_7__commonview_lib_view_binaryquestion_js__["a" /* default */].close();
	__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].view({
		ageverification: {
			confirm: true
		}
	});
	ageverifycb(); // this is for example only used by the navigation to reroute
}

function ageBinaryQuestionRejectCb() {
	__WEBPACK_IMPORTED_MODULE_7__commonview_lib_view_binaryquestion_js__["a" /* default */].close();
	__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].view({
		ageverification: {
			confirm: false
		}
	});
	agedontverifycb(); // this is for example only used by the navigation to reroute
}

function complianceBinaryQuestionConfirmCb() {
	__WEBPACK_IMPORTED_MODULE_7__commonview_lib_view_binaryquestion_js__["a" /* default */].close();
	__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewPaymentform({
		ukcompliance: {
			confirm: true
		}
	});
	complianceverifycb(); // this is for example only used by the navigation to reroute
}

function complianceBinaryQuestionRejectCb() {
	__WEBPACK_IMPORTED_MODULE_7__commonview_lib_view_binaryquestion_js__["a" /* default */].close();
	__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewPaymentform({
		ukcompliance: {
			confirm: false
		}
	});
	compliancedontverifycb(); // this is for example only used by the navigation to reroute
}

function deleteAllElements() {
	if (elements) {
		elements.assembled = false;
	}
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys'], 'payment/view:32');
}

function createWrapPaymentform() {
	return create({
		type: 'div',
		class: 'js-wrap-paymentform u-height-100'
	});
}

function createWrapContent() {
	return create({
		type: 'main',
		class: 'payment__content-wrapper grid-u-sm-1 u-relative'
	});
}

function assembleElements() {
	if (!elements.assembled) {
		elements.wrapContent = elements.wrapContent || createWrapContent();
		elements.wrapPaymentform = elements.wrapPaymentform || createWrapPaymentform();
		elements.wrapContent.appendChild(elements.wrapPaymentform);
		elements.wrap.appendChild(elements.wrapContent);
		elements.assembled = true;
	}
}

function cleanupView() {
	deleteAllElements();
	__WEBPACK_IMPORTED_MODULE_6__commonview_lib_view_confirmationmessage_js__["a" /* default */].close();
	if (viewSpinnerInstance) {
		viewSpinnerInstance.close();
	}
	__WEBPACK_IMPORTED_MODULE_2__view_paymentform_js__["a" /* default */].close();
	__WEBPACK_IMPORTED_MODULE_5__view_paymentmessage_js__["a" /* default */].close();
	__WEBPACK_IMPORTED_MODULE_4__commonview_lib_view_wrap_js__["a" /* default */].hide(elements && elements.wrap);
}
/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(conf) {
		selectors.wrap = conf.wrap || selectors.wrap;
		ageverifycb = conf.ageverifycb || function empty() {};
		agedontverifycb = conf.agedontverifycb || function empty() {};
		complianceverifycb = conf.complianceverifycb || function empty() {};
		compliancedontverifycb = conf.compliancedontverifycb || function empty() {};

		elements = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].selectElements(selectors, 'payment:view:55');
		textkeysObj = __WEBPACK_IMPORTED_MODULE_8__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		viewSpinnerInstance = __WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_spinner_js__["a" /* default */].create({
			wrap: elements.wrap
		});
		assembleElements();
		__WEBPACK_IMPORTED_MODULE_4__commonview_lib_view_wrap_js__["a" /* default */].show(elements && elements.wrap);
		/* inject area for messages */
		__WEBPACK_IMPORTED_MODULE_5__view_paymentmessage_js__["a" /* default */].init({
			wrapElm: elements.wrap,
			wrap: elements.wrap
		});
		/* inject area for payments: methods and selected form */
		__WEBPACK_IMPORTED_MODULE_2__view_paymentform_js__["a" /* default */].init({
			wrap: elements.wrapPaymentform
		});
	},
	update: function update(state) {
		/* Data modules send their state with the modulename as property. i.e 'state.foomodule. A 'view_foobar' uses 'state.foomodule'. */
		var failTitle = void 0;
		var failText = void 0;
		var failBtn = void 0;
		var confirmCb = void 0;
		var acceptButtonTxt = void 0;
		var denyButtonTxt = void 0;
		if (state) {
			if (state.fetch_paymentmethods) {
				if (state.fetch_paymentmethods.error) {
					failTitle = 'something went wrong..';
					failText = 'during initialization of payments';
					failBtn = 'ok';
					confirmCb = cleanupView;
					__WEBPACK_IMPORTED_MODULE_6__commonview_lib_view_confirmationmessage_js__["a" /* default */].show('default-failure', failTitle, failText, failBtn, confirmCb);
				}
			}
			if (state.paymentmethods) {
				if (state.paymentmethods.error) {
					failTitle = 'something went wrong...';
					failText = 'during fetch of methods';
					failBtn = 'ok';
					__WEBPACK_IMPORTED_MODULE_6__commonview_lib_view_confirmationmessage_js__["a" /* default */].show('default-failure', failTitle, failText, failBtn, confirmCb);
				} else {
					__WEBPACK_IMPORTED_MODULE_2__view_paymentform_js__["a" /* default */].update(state);
				}
			}
			if (state.fetch_amounts) {
				__WEBPACK_IMPORTED_MODULE_2__view_paymentform_js__["a" /* default */].update(state);
			}
			if (state.fetch_methoddetails) {
				__WEBPACK_IMPORTED_MODULE_2__view_paymentform_js__["a" /* default */].update(state);
			}
			if (state.fetch_currencies) {
				__WEBPACK_IMPORTED_MODULE_2__view_paymentform_js__["a" /* default */].update(state);
			}
			if (state.fetch_fees_and_limits) {
				__WEBPACK_IMPORTED_MODULE_2__view_paymentform_js__["a" /* default */].update(state);
			}
			if (state.fee) {
				__WEBPACK_IMPORTED_MODULE_2__view_paymentform_js__["a" /* default */].update(state);
			}
			if (state.submit_payment) {
				if (state.submit_payment.pending) {
					viewSpinnerInstance.show();
				} else if (state.submit_payment.success) {
					viewSpinnerInstance.hide();
				} else {
					viewSpinnerInstance.hide();
				}
				if (state.submit_payment.error && !state.submit_payment.ageverifyerror) {
					failTitle = state.submit_payment.title;
					failText = state.submit_payment.message;
					failBtn = 'ok';
					__WEBPACK_IMPORTED_MODULE_6__commonview_lib_view_confirmationmessage_js__["a" /* default */].show('default-failure', failTitle, failText, failBtn);
				} else if (state.submit_payment.ageverifyerror) {
					failTitle = state.submit_payment.title || '';
					failText = state.submit_payment.message || '';
					acceptButtonTxt = textkeysObj['verify-age-accept-text'];
					// acceptButtonTxt = state.submit_payment.buttontext || 'verify-age-accept-text';
					denyButtonTxt = textkeysObj['verify-age-deny-text'];
					__WEBPACK_IMPORTED_MODULE_7__commonview_lib_view_binaryquestion_js__["a" /* default */].show(failText, acceptButtonTxt, denyButtonTxt, ageBinaryQuestionConfirmCb, ageBinaryQuestionRejectCb, failTitle);
				} else if (state.submit_payment.complianceerror) {
					acceptButtonTxt = textkeysObj['uk-verify-accept-text'];
					denyButtonTxt = textkeysObj['uk-verify-deny-text'];
					failText = state.submit_payment.message || '';
					failTitle = state.submit_payment.title || '';
					__WEBPACK_IMPORTED_MODULE_7__commonview_lib_view_binaryquestion_js__["a" /* default */].show(failText, acceptButtonTxt, denyButtonTxt, complianceBinaryQuestionConfirmCb, complianceBinaryQuestionRejectCb, failTitle);
				}
				if (state.submit_payment) {
					__WEBPACK_IMPORTED_MODULE_2__view_paymentform_js__["a" /* default */].update(state);
				}
			}
			if (state.get_payment_result) {
				__WEBPACK_IMPORTED_MODULE_5__view_paymentmessage_js__["a" /* default */].update(state);
				__WEBPACK_IMPORTED_MODULE_2__view_paymentform_js__["a" /* default */].update(state);
			}
			if (state.first_time_uk_deposit) {
				/* this info is used by viewPaymentform and may be recieved
    after or before the viewPaymentform is created */
				__WEBPACK_IMPORTED_MODULE_2__view_paymentform_js__["a" /* default */].update(state);
			}
			if (state.external_panel_and_window_handler) {
				if (state.external_panel_and_window_handler.pending) {
					// viewSpinnerInstance.show();
				} else {
						// viewSpinnerInstance.hide();
					}
			}
		} else {
			console.warn('payment/view:27:update:can not update, no state object provided.', state);
		}
	},
	close: function close() {
		cleanupView();
	}
};

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mitt__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mitt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mitt__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleDoubleEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return emitter; });

/**
 * Created by dilip on 2017-01-03.
 */

var eventCounter = 0;
var singleClickTimer = void 0;
var emitter = __WEBPACK_IMPORTED_MODULE_0_mitt___default()();
function handleDoubleEvents(e, element, singleEventHandler, doubleEventHandler) {
	eventCounter += 1;
	// if there´s no other click in the next 300ms this is going to be a single click
	if (eventCounter === 1) {
		singleClickTimer = setTimeout(function () {
			eventCounter = 0;
			singleEventHandler(element);
		}, 300);

		// otherwise is a double click
	} else if (eventCounter === 2) {
		clearTimeout(singleClickTimer);
		eventCounter = 0;
		doubleEventHandler(element);
	}
}



/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_rest_js__ = __webpack_require__(214);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var defaultPath = function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
		var path;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__services_rest_js__["a" /* getDefaultPath */])();

					case 2:
						path = _context.sent;
						return _context.abrupt('return', path.toLowerCase());

					case 4:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function defaultPath() {
		return _ref.apply(this, arguments);
	};
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }


var _window = window,
    config = _window.config;

delete window.config;

/* harmony default export */ __webpack_exports__["a"] = _extends({}, config, { defaultPath: '/' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__services_rest_js__["a" /* getDefaultPath */])() });

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__account_settings_email_js__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_currency_formatter_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_locale_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__websocket_websocket_event_esm_js__ = __webpack_require__(145);









var $accountMenu = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.account-menu');
var $myAccountSettingsMenu = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.my-account-settings');
var $verifiedEmailSvg = $accountMenu.find('#verifiedEmailSvg');
var $notVerifiedEmailSvg = $accountMenu.find('#notVerifiedEmailSvg');
var $emailVerifyLinkListSpinner = $accountMenu.find('#emailVerifyLinkListSpinner');
var $verifiedNumberSvg = $accountMenu.find('#verifiedNumberSvg');
var $notVerifiedNumberSvg = $accountMenu.find('#notVerifiedNumberSvg');
var $phoneVerifyLinkListSpinner = $accountMenu.find('#mobileVerifyLinkListSpinner');
var $verifyPhoneWrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-verify_phone-number');
var $editPhoneWrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-verify_phone-number');
var $editEmailWrapper = $myAccountSettingsMenu.find('.js-edit_email');
var $newPhoneCode = $editPhoneWrapper.find('#new-phone-cc');
var $newPhone = $editPhoneWrapper.find('#new-phone');
var $newEmail = $editEmailWrapper.find('#new-email');
var $verifyMobileButton = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-verify-get-code');

function showVerificationSpinner($spinner, show) {
	if (show) {
		$spinner.removeClass('u-hide');
		$verifiedEmailSvg.addClass('u-hide');
		$notVerifiedEmailSvg.addClass('u-hide');
	} else {
		$spinner.addClass('u-hide');
		$verifiedEmailSvg.removeClass('u-hide');
		$notVerifiedEmailSvg.removeClass('u-hide');
	}
}

//Set Verified email on/off
function setVerificationEmail(isVerified) {

	showVerificationSpinner($emailVerifyLinkListSpinner, false);

	if (isVerified) {
		$verifiedEmailSvg.removeClass('u-hide');
		$notVerifiedEmailSvg.addClass('u-hide');
	} else {
		$verifiedEmailSvg.addClass('u-hide');
		$notVerifiedEmailSvg.removeClass('u-hide');
	}
}

//Set Verified number on/off
function setVerificationNumber(isVerified) {

	showVerificationSpinner($phoneVerifyLinkListSpinner, false);

	if (isVerified) {
		$verifiedNumberSvg.removeClass('u-hide');
		$notVerifiedNumberSvg.addClass('u-hide');
		$verifyMobileButton.attr('disabled', true).data('isVerified', true);
	} else {
		$verifiedNumberSvg.addClass('u-hide');
		$notVerifiedNumberSvg.removeClass('u-hide');
		$verifyMobileButton.attr('disabled', false).data('isVerified', false);
	}
}

function populatePlayerData(resultData) {
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('nav > .js-menu__close .page-head__title').text(resultData.result.firstName + ' ' + resultData.result.lastName);

	$verifyPhoneWrapper.data({
		mobileCountryCode: resultData.result.mobileCountryCode,
		mobile: resultData.result.mobile
	});

	$newPhoneCode.attr('placeholder', resultData.result.mobileCountryCode);
	$newPhoneCode.val(resultData.result.mobileCountryCode);
	$newPhone.attr('placeholder', resultData.result.mobile);
	$newPhone.val(resultData.result.mobile);

	__WEBPACK_IMPORTED_MODULE_1__account_settings_email_js__["a" /* default */].setUserMail(resultData.result.email, resultData.result.unconfEmail);
	__WEBPACK_IMPORTED_MODULE_1__account_settings_email_js__["a" /* default */].setMailVerificationStatus(resultData.result.playerVerificationsVO.emailStatus);
	$newEmail.attr('placeholder', resultData.result.email);
	$newEmail.val(resultData.result.email);

	setVerificationNumber(resultData.result.playerVerificationsVO.mobileStatus);
	setVerificationEmail(resultData.result.playerVerificationsVO.emailStatus);
}

function fetchPlayerInfo() {
	var url = '/player/account';
	var options = {
		method: 'GET',
		credentials: 'include',
		headers: new Headers({
			'Content-Type': 'application/json'
		})
	};

	return fetch(url, options).then(function (response) {
		return response.json();
	});
}

// Get Player Info
function getPlayerInfo() {
	showVerificationSpinner($emailVerifyLinkListSpinner, true);
	showVerificationSpinner($phoneVerifyLinkListSpinner, true);

	return __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		url: '/player/account',
		type: 'GET',
		dataType: 'json',
		crossDomain: true,
		contentType: 'application/json; charset=utf-8'
	}).done(function (resultData) {
		if (resultData.status === 'SUCCESS') {
			populatePlayerData(resultData);
		}
		if (resultData.status === 'FAILURE') {
			console.error(resultData.errorDescription + '. Code: ' + resultData.errorCode);
			showVerificationSpinner($emailVerifyLinkListSpinner, false);
			showVerificationSpinner($phoneVerifyLinkListSpinner, false);
			__WEBPACK_IMPORTED_MODULE_3__login_js__["a" /* default */].doLogout();
			__WEBPACK_IMPORTED_MODULE_4__notifications_js__["a" /* default */].showNotification(resultData.errorDescription, 'red', true);
		}
	}).fail(function (jqXHR, textStatus, errorThrown) {
		console.error(jqXHR, textStatus, errorThrown);
	});
}

//Get Player Balance
function getPlayerBalance() {
	__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		url: '/player/balance',
		type: 'GET',
		contentType: 'application/json; charset=utf-8'
	}).done(function (resultData) {
		if (resultData.status === 'SUCCESS') {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_ajax_json_js__["a" /* fetchJson */])('/player/currency').then(function (response2) {
				var formattedBalance = __WEBPACK_IMPORTED_MODULE_5__libs_currency_formatter_js__["a" /* default */].format(resultData.result.amount, response2.result, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__libs_locale_js__["a" /* getLocale */])());
				$accountMenu.find('.user-balance .user-balance__sum--balance').html(formattedBalance);
			});
		}
		if (resultData.status === 'FAILURE') {
			console.error(resultData.errorDescription + '. Code: ' + resultData.errorCode);
		}
	}).fail(function (jqXHR, textStatus, errorThrown) {
		console.error(jqXHR, textStatus, errorThrown);
	});
}

__WEBPACK_IMPORTED_MODULE_7__websocket_websocket_event_esm_js__["a" /* default */].on('player.update', function (event, message) {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_ajax_json_js__["a" /* fetchJson */])('/player/currency').then(function (response) {
		var formattedBalance = __WEBPACK_IMPORTED_MODULE_5__libs_currency_formatter_js__["a" /* default */].format(message.totalBalance, response.result, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__libs_locale_js__["a" /* getLocale */])());
		$accountMenu.find('.user-balance .user-balance__sum--balance').html(formattedBalance);
	});
});

// Get Player Points
function getPlayerPoints() {
	__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		url: '/player/points',
		type: 'GET',
		dataType: 'json',
		crossDomain: true,
		contentType: 'application/json; charset=utf-8'
	}).done(function (resultData) {
		if (resultData.status === 'SUCCESS') {
			$accountMenu.find('.user-balance .user-balance__sum--points').text(resultData.result.amount);
		}
		if (resultData.status === 'FAILURE') {
			console.error(resultData.errorDescription + '. Code: ' + resultData.errorCode);
		}
	}).fail(function (jqXHR, textStatus, errorThrown) {
		console.error(jqXHR, textStatus, errorThrown);
	});
}

/* harmony default export */ __webpack_exports__["a"] = {
	fetchPlayerInfo: fetchPlayerInfo,
	getPlayerInfo: getPlayerInfo,
	getPlayerBalance: getPlayerBalance,
	getPlayerPoints: getPlayerPoints,
	setVerificationEmail: setVerificationEmail,
	setVerificationNumber: setVerificationNumber
};

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_cookies_js__ = __webpack_require__(10);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }





// TODO PropTypes validation for component is throwing error so overlooking at the moment
var MatchHydrate = function MatchHydrate(_ref) {
	var data = _ref.data,
	    authenticate = _ref.authenticate,
	    Component = _ref.component,
	    rest = _objectWithoutProperties(_ref, ['data', 'authenticate', 'component']);

	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], _extends({}, rest, { render: function render(props) {
			return authenticate && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["c" /* sessionKey */])() ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */], { to: { pathname: '/login', state: { from: props.location } } }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({ data: data }, props));
		}
	}));
};

MatchHydrate.propTypes = {
	data: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
	authenticate: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].bool,
	location: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
	component: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].func
};
/*
MatchHydrate.contextTypes = {
  router: React.PropTypes.object
}*/

/* harmony default export */ __webpack_exports__["a"] = MatchHydrate;

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_asynchronous_result_after_single_call_js__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_fetch_fees_and_limits_js__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_fetch_paymentmethods_js__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_fetch_methoddetails_js__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib_immediate_payment_result_router_js__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib_first_time_uk_deposit_js__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib_paymentmethods_js__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib_submit_payment_js__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib_view_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib_result_after_single_call_js__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lib_external_panel_and_window_handler_js__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib_send_handler_controller_js__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_lib_dataflow_js__ = __webpack_require__(20);
/*
payment/payment/index

usage:

*/











/* view contains all dom-elements and updates the rendering */






var register = __WEBPACK_IMPORTED_MODULE_14__common_lib_dataflow_js__["a" /* default */].register;
var conf = {
	methodsUrl: '/PaymentFormDataService/getDepositPaymentMethods?isMobileDevice=true',
	feesAndLimitsUrl: '/PaymentFormDataService/getDepositFeesAndLimits/forMobile'
};

function initialization() {
	/* most modules used in the app are init from here. They are then connected */
	__WEBPACK_IMPORTED_MODULE_3__lib_fetch_fees_and_limits_js__["a" /* default */].init(conf.feesAndLimitsUrl);
	__WEBPACK_IMPORTED_MODULE_4__lib_fetch_paymentmethods_js__["a" /* default */].init(conf.methodsUrl);
	__WEBPACK_IMPORTED_MODULE_5__lib_fetch_methoddetails_js__["a" /* default */].init();
	__WEBPACK_IMPORTED_MODULE_8__lib_paymentmethods_js__["a" /* default */].init();
	__WEBPACK_IMPORTED_MODULE_9__lib_submit_payment_js__["a" /* default */].init();
	__WEBPACK_IMPORTED_MODULE_10__lib_view_js__["a" /* default */].init(conf);
	/* fetchPaymentmethods gets the first necessary data from ajaxcall. These
  *  data are then distributed to the 'stores' via an action and the connected views (all visual dom-nodes) are then updated.
  * this action starts the fetchPaymentmethods and other stores registered for the action */
	__WEBPACK_IMPORTED_MODULE_11__lib_result_after_single_call_js__["a" /* default */].init();
	__WEBPACK_IMPORTED_MODULE_12__lib_external_panel_and_window_handler_js__["a" /* default */].init();
	__WEBPACK_IMPORTED_MODULE_1__lib_asynchronous_result_after_single_call_js__["a" /* default */].init();
	__WEBPACK_IMPORTED_MODULE_13__lib_send_handler_controller_js__["a" /* default */].init();
	__WEBPACK_IMPORTED_MODULE_6__lib_immediate_payment_result_router_js__["a" /* default */].init();
	__WEBPACK_IMPORTED_MODULE_7__lib_first_time_uk_deposit_js__["a" /* default */].init();
	__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].setupPayment();
}

function registerActions() {
	function paymentinit(payload) {
		if (payload.type === __WEBPACK_IMPORTED_MODULE_2__common_lib_utils_constants_js__["a" /* default */].SUBMIT_PAYMENT) {
			if (payload.success) {
				/* The depositflow is done */
				__WEBPACK_IMPORTED_MODULE_10__lib_view_js__["a" /* default */].close();
			}
		}
	}
	register(paymentinit);
}

function initializationForShopDepositBonus() {
	__WEBPACK_IMPORTED_MODULE_3__lib_fetch_fees_and_limits_js__["a" /* default */].init(conf.feesAndLimitsUrl);
	__WEBPACK_IMPORTED_MODULE_9__lib_submit_payment_js__["a" /* default */].init();
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(p) {
		conf.wrap = p.wrapElmSelector || null;
		conf.isEmptyCallback = p.isEmptyCallback || null;
		conf.ageverifycb = p.ageverifycb || null;
		conf.agedontverifycb = p.agedontverifycb || null;
		conf.complianceverifycb = p.complianceverifycb || null;
		conf.compliancedontverifycb = p.compliancedontverifycb || null;
		registerActions();
		initialization();
	},
	shopInit: function shopInit() {
		initializationForShopDepositBonus();
	},
	close: function close() {
		__WEBPACK_IMPORTED_MODULE_10__lib_view_js__["a" /* default */].close();
	}
};

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_diffhtml__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_diffhtml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_diffhtml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_custom_events_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_tabs_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__templates_games_games_grid_empty_handlebars__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__templates_games_games_grid_empty_handlebars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__templates_games_games_grid_empty_handlebars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__services_rest_js__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_api_js__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__selectors_js__ = __webpack_require__(132);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return handleLoveEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setRecentlyPlayedGame; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var setRecentlyPlayedGame = function () {
	var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee(gamecode) {
		var recentGame;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.next = 2;
						return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__services_rest_js__["b" /* setRecentGames */])({ string: gamecode });

					case 2:
						recentGame = _context.sent;
						return _context.abrupt('return', recentGame);

					case 4:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function setRecentlyPlayedGame(_x2) {
		return _ref3.apply(this, arguments);
	};
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












var TIMEOUT = 500;
// timeout for effects
__WEBPACK_IMPORTED_MODULE_1__utils_custom_events_js__["a" /* emitter */].on('tabbed', styleGameItemHeart);

function toggleClass(element, classNameToToggle) {
	element.classList.toggle(classNameToToggle);
}

function toggleClassWithTimeout(element, classNameToToggle) {
	var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : TIMEOUT;

	window.setTimeout(function () {
		toggleClass(element, classNameToToggle);
	}, 500);
}

function applyClickEffect(element) {
	var effectClass = 'click-effect';
	toggleClass(element, effectClass);
	toggleClassWithTimeout(element, effectClass);
}

function renderUpdatedLoveCount(gamecode) {
	var all = __WEBPACK_IMPORTED_MODULE_8__store_js__["a" /* store */].get().gameResource.gameData.all;

	var game = all.find(function (game) {
		return game.code === gamecode;
	});

	var instances = document.querySelectorAll('.game-item[data-gamecode="' + gamecode + '"] .game-item__love');
	for (var _iterator = instances, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
		var _ref;

		if (_isArray) {
			if (_i >= _iterator.length) break;
			_ref = _iterator[_i++];
		} else {
			_i = _iterator.next();
			if (_i.done) break;
			_ref = _i.value;
		}

		var instance = _ref;

		if (game.loved && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_cookies_js__["c" /* sessionKey */])()) {
			instance.classList.add('game-item__love--selected');
		} else {
			instance.classList.remove('game-item__love--selected');
		}
		var rating = instance.querySelector('.game-item__love-counter');
		rating.textContent = game.likes || 0;
	}
}

/* This runs in O(m*n)
 */
function styleGameItemHeart() {
	var storeAllGames = __WEBPACK_IMPORTED_MODULE_8__store_js__["a" /* store */].get().gameResource.gameData.all;
	// 1. n iterations to get m games
	var games = storeAllGames.filter(function (game) {
		return game.loved;
	});
	if (games && games.length > 0) {
		// 2.1. m iterations to...
		games.forEach(function (game) {
			// 2.2 ... run n iterations
			renderUpdatedLoveCount(game.gamecode);
		});
	}
}

function handleLoveEvents(_ref2) {
	var target = _ref2.target;

	if (target.classList.contains('game-item__love')) {
		if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_cookies_js__["c" /* sessionKey */])()) {
			//target.classList.toggle('game-item__love--selected');
			applyClickEffect(target);
			var gamecode = target.closest('.game-item').dataset.gamecode;

			var game = __WEBPACK_IMPORTED_MODULE_8__store_js__["a" /* store */].get().gameResource.gameData.all.find(function (game) {
				return game.code === gamecode;
			});
			var loved = !game.loved;
			loved ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__services_rest_js__["c" /* loveGame */])({ string: gamecode }) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__services_rest_js__["d" /* unLoveGame */])({ string: gamecode });
			var likes = loved ? (parseInt(game.likes, 10) || 0) + 1 : (parseInt(game.likes, 10) || 0) - 1;
			game.set({ loved: loved, likes: likes });
			renderUpdatedLoveCount(gamecode);
			// target.classList.toggle('game-item__love--selected');
			return false;
		} else {
			var $pusher = document.getElementsByClassName('pusher')[0];
			var text = $pusher.dataset.lovegamesLogout;
			__WEBPACK_IMPORTED_MODULE_2__notifications_js__["a" /* default */].showNotification(text, 'green', true);
			return false;
		}
	}
}

function markup() {
	var _emptyGameTemplate2;

	var filteredGames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__selectors_js__["a" /* gamesSelector */])(__WEBPACK_IMPORTED_MODULE_8__store_js__["a" /* store */].get());

	var _document$querySelect = document.querySelector('#section3 .filters input[type="radio"]:checked'),
	    _document$querySelect2 = _document$querySelect.dataset,
	    titleEmpty = _document$querySelect2.titleEmpty,
	    messageEmpty = _document$querySelect2.messageEmpty,
	    titleAuth = _document$querySelect2.titleAuth,
	    messageAuth = _document$querySelect2.messageAuth,
	    value = _document$querySelect.value;

	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_cookies_js__["c" /* sessionKey */])()) {
		var _emptyGameTemplate;

		if (filteredGames.length > 0) {
			var templateContext = _extends({}, __WEBPACK_IMPORTED_MODULE_8__store_js__["a" /* store */].get().gameResource, {
				gameData: {
					all: filteredGames
				}
			});
			return __WEBPACK_IMPORTED_MODULE_8__store_js__["a" /* store */].get().templates.games(templateContext);
		}
		return __WEBPACK_IMPORTED_MODULE_5__templates_games_games_grid_empty_handlebars___default()((_emptyGameTemplate = { title: titleEmpty, message: messageEmpty }, _emptyGameTemplate[value] = value, _emptyGameTemplate));
	}
	return __WEBPACK_IMPORTED_MODULE_5__templates_games_games_grid_empty_handlebars___default()((_emptyGameTemplate2 = { title: titleAuth, message: messageAuth }, _emptyGameTemplate2[value] = value, _emptyGameTemplate2));
}

function render() {
	if (document.getElementById('section3') && !document.getElementById('section3').getAttribute('aria-hidden')) {
		var grid = document.querySelector('#section3 .game-grid');
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_diffhtml__["innerHTML"])(grid, markup());
		styleGameItemHeart();

		window.lazySizes.loader.checkElems();
	}
}

__WEBPACK_IMPORTED_MODULE_1__utils_custom_events_js__["a" /* emitter */].on('logout', render);
__WEBPACK_IMPORTED_MODULE_8__store_js__["a" /* store */].on('update', function (currentState, prevState) {
	if (currentState !== prevState) {
		render();
	}
});

function init() {
	render();
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__libs_tabs_js__["a" /* open */])('section3');
}



/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_freezer_js__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_freezer_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_freezer_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index_js__ = __webpack_require__(52);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });



/* Refactor necessary
   - Do not use a single store for different types of data. E.g. calling it
     ”store” (generic) and having both game data & filter data in it.
   	 Reason: Separation of concerns & single responsibility: there should only be one reason
   	 to modify something
   - There should not be direct access to the store.
   	 E.g. provide access through getter functions:
   	 	getAllgames() instead of store.get().foo.bar.allGames
     Reason: When data structure changes, there should be no need
     to modify other code.
     Example: This commit. There was a need to change what data was retrieved from server
     	for all games, which resulted in a need to modify:
     		this file, bundles.js, mygames.js, providergames.js, allgames.js, selectors.js
     	(Only this file should need to change)

   - Do not use freezer for gameData & templates if they are not meant to change
     Reason: The code is written so that gameData never changes (after initial load),
     which means using freezer for gameData is completely pointless.
 */
var initialState = {
  templates: {
    games: function games() {
      return '';
    }
  },
  gameResource: {
    gameData: {
      all: []
    },
    i18n: {},
    siteCode: __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].siteCode
  },
  filters: {
    key: null,
    provider: null
  }
};

var store = new __WEBPACK_IMPORTED_MODULE_0_freezer_js___default.a(initialState);



/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_custom_events_js__ = __webpack_require__(47);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return open; });


// The class for the container div
var $container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tabs-container');

var $tabList = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-bottom-wrapper .tabs-bar');
var $searchBar = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pusher .search');
var $pageHeadTitle = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pusher .page-head .page-head__title')[0]);

function init() {
	// The setup
	$tabList.attr('role', 'tablist').find('li').attr('role', 'presentation').find('a').attr({ role: 'tab', tabindex: '-1' });

	// Make each aria-controls correspond id of targeted section (re href)
	$tabList.find('a').each(function () {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('aria-controls', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href'));
	});

	// Make each section focusable and give it the tabpanel role
	$container.find('section').attr({ role: 'tabpanel' });

	// Make first child of each panel focusable programmatically
	$container.find('section > *:first-child').attr({ tabindex: '0' });

	// Change focus between tabs with arrow keys
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('[role="tab"]').on('keydown.tabs', function (e) {

		// define current, previous and next (possible) tabs
		var $original = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
		var $prev = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parents('li').prev().children('[role="tab"]');
		var $next = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parents('li').next().children('[role="tab"]');
		var $target = void 0;

		// find the direction (prev or next)
		switch (e.keyCode) {
			case 37:
				$target = $prev;
				break;
			case 39:
				$target = $next;
				break;
			default:
				$target = false;
				break;
		}

		if ($target.length) {
			$original.attr({ tabindex: '-1', 'aria-selected': null });
			$target.attr({ tabindex: '0', 'aria-selected': true }).focus();
		}

		// Hide panels
		$container.find('[role="tabpanel"]').attr('aria-hidden', 'true');

		// Show panel which corresponds to target

		__WEBPACK_IMPORTED_MODULE_0_jquery___default()('' + __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('href').replace('/', '')).attr('aria-hidden', null);
	});
}

// Handle click on tab to show + focus tabpanel

function open(tab) {
	var $item = $tabList.find('.js-tab-' + tab);
	$pageHeadTitle.text($item.find('span').text());

	// remove focusability [sic] and aria-selected
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('[role="tab"]').attr({ tabindex: '-1', 'aria-selected': null });

	// replace above on clicked tab
	$item.attr({ 'aria-selected': true, tabindex: '0' });

	// Hide panels
	$container.find('[role="tabpanel"]').attr('aria-hidden', 'true');

	// show corresponding panel
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#' + tab).attr('aria-hidden', null);

	// hide/show search bar
	if ($item.attr('aria-selected') && $item.attr('aria-controls') === '/casino/all-games') {
		$searchBar.removeClass('search--js-hide');
		$searchBar.siblings('h2').removeClass('u-show').addClass('u-hide');
	} else {
		$searchBar.addClass('search--js-hide');
		$searchBar.siblings('h2').removeClass('u-hide').addClass('u-show');
	}
	window.lazySizes.loader.checkElems();
	__WEBPACK_IMPORTED_MODULE_1__utils_custom_events_js__["a" /* emitter */].emit('tabbed');
}



/* unused harmony default export */ var _unused_webpack_default_export = {
	init: init,
	open: open
};

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__account_info_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_settings_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__bonus_progress_js__ = __webpack_require__(306);






/* These menues are unique, and are therefore selected by id. The intention is
to open the main menues from the first page. To open sublevels of these menues
 see the specific files prefixed by 'menues_'
 for example:
 menues_account.js
 menues_global.js
 */
var accountMenuElm = document.querySelector('#js-account-menu');

var globalMenuElm = document.querySelector('#js-global-menu');
var bottomWrapperElm = document.querySelector('.js-bottom-wrapper');
// let mysettingsElm = document.querySelector('.my-account-settings');
var mysettingsElm = document.querySelector('#js-account-menu');
var notifyIsOpenClassname = 'notify--is-open';
var menuIsOpenClassname = 'menu--is-open';
var bottomWrapperLoginOpenClassname = 'log-in--open';
var prevScrollPos = void 0;
var verifyEmail = void 0;
var globalBackIsBound = false;

function addIsOpenclassScrollToTop(elm, openClassname) {
	/* add open-class, note scrollposition, scroll to top */
	elm.classList.add(openClassname);
	window.scrollTo(0, 0);
}

function makeBackgroundUnscrollable() {
	// TODO set css on pusherelement to prevent scrolling of background when menu is open
}

function makeBackgroundScrollable() {
	// TODO reset css on pusherelement to accept scrolling of background when menu is closed
}

function noteCurrentScroll() {
	prevScrollPos = {
		x: window.scrollX,
		y: window.scrollY
	};
}

function scrollToPrevious() {
	if (prevScrollPos) {
		window.scroll(prevScrollPos.x, prevScrollPos.y);
	}
}

function removeIsOpenClass(elem, openClassname) {
	if (elem) {
		elem.classList.remove(openClassname);
	}
}

if (mysettingsElm) {
	verifyEmail = mysettingsElm.querySelector('.js-verify_email');
}

accountMenuElm.querySelector('.js-menu__close .icon-close--back').addEventListener('click', __WEBPACK_IMPORTED_MODULE_1__store_history_js__["g" /* pushBasePathname */], false);

function close() {
	if (globalMenuElm && accountMenuElm) {
		removeIsOpenClass(globalMenuElm, menuIsOpenClassname);
		removeIsOpenClass(accountMenuElm, menuIsOpenClassname);
	}

	removeIsOpenClass(bottomWrapperElm, bottomWrapperLoginOpenClassname);
	scrollToPrevious();
}

function closeMenuesExceptGlobalMenu() {
	if (accountMenuElm) {
		removeIsOpenClass(accountMenuElm, menuIsOpenClassname);
	}
	removeIsOpenClass(bottomWrapperElm, bottomWrapperLoginOpenClassname);
	scrollToPrevious();
}

/* harmony default export */ __webpack_exports__["a"] = {
	openGlobalMenu: function openGlobalMenu() {
		var closeButton = document.querySelector('.js-menu__close .icon-close--back');
		closeButton.setAttribute('href', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["d" /* basePathname */])());
		/*
  if (!globalBackIsBound) {
  	closeButton.addEventListener(eventType, pushBasePathname);
  	globalBackIsBound = true;
  }
  */

		noteCurrentScroll();
		// this puts odds at top of list if it exists
		if (globalMenuElm) {
			var sbListItem = globalMenuElm.querySelector("li[data-product='sportsbook']");
			if (sbListItem) {
				sbListItem.parentNode.insertBefore(sbListItem, sbListItem.parentNode.firstChild);
			}
			addIsOpenclassScrollToTop(globalMenuElm, menuIsOpenClassname);
		}
	},
	openAccountMenu: function openAccountMenu() {
		noteCurrentScroll();
		addIsOpenclassScrollToTop(accountMenuElm, menuIsOpenClassname);
		/* update accountInfo module*/
		__WEBPACK_IMPORTED_MODULE_0__account_info_js__["a" /* default */].getPlayerInfo();
		__WEBPACK_IMPORTED_MODULE_0__account_info_js__["a" /* default */].getPlayerBalance();
		__WEBPACK_IMPORTED_MODULE_0__account_info_js__["a" /* default */].getPlayerPoints();
	},
	openLoginMenu: function openLoginMenu() {
		noteCurrentScroll();
		/* the login is child of bottomwrapper. Also the login functionality and some ui is handled by login.js*/
		addIsOpenclassScrollToTop(bottomWrapperElm, bottomWrapperLoginOpenClassname);
	},

	close: close,
	closeMenuesExceptGlobalMenu: closeMenuesExceptGlobalMenu,
	openMySettings: function openMySettings() {
		noteCurrentScroll();
		addIsOpenclassScrollToTop(mysettingsElm, menuIsOpenClassname);
	},
	openVerifyEmail: function openVerifyEmail() {
		noteCurrentScroll();
		addIsOpenclassScrollToTop(verifyEmail, notifyIsOpenClassname);
	},
	closeVerifyEmail: function closeVerifyEmail() {
		removeIsOpenClass(verifyEmail, notifyIsOpenClassname);
		scrollToPrevious();
	},
	closeMySettings: function closeMySettings() {
		removeIsOpenClass(mysettingsElm, menuIsOpenClassname);
	}
};

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_tomcat_cookies_js__ = __webpack_require__(23);



var pixelTracking = {
	push: function push(name, amountValue, cb) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__["a" /* fetchJson */])('/tracking/', { amount: amountValue }).then(function (response) {
			var scriptHTML = response.result[name];
			if (scriptHTML === undefined) {
				console.error('Can not load pixel tracking');
			} else {
				scriptHTML = scriptHTML.replace('<script>', '');
				scriptHTML = scriptHTML.replace('</script>', '');
				var scriptElement = document.createElement('script');
				scriptElement.innerHTML = scriptHTML;
				document.body.appendChild(scriptElement);
			}
			if (cb !== undefined) {
				cb();
			}
		});
	},
	pushFromCookies: function pushFromCookies() {
		if (__WEBPACK_IMPORTED_MODULE_1__libs_tomcat_cookies_js__["a" /* default */].get('login') === 'true') {
			pixelTracking.push('login');
			__WEBPACK_IMPORTED_MODULE_1__libs_tomcat_cookies_js__["a" /* default */].set('login', false);
		}
	}
};

/* harmony default export */ __webpack_exports__["a"] = pixelTracking;

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


var spinner = {};

spinner.show = function (parentElement) {
    var $spinner = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(parentElement).find('.spinner');
    $spinner.removeClass('u-hide').addClass('u-show');
};

spinner.hide = function (parentElement) {
    var $spinner = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(parentElement).find('.spinner');
    $spinner.removeClass('u-show').addClass('u-hide');
};

/* harmony default export */ __webpack_exports__["a"] = spinner;

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// http://coveroverflow.com/a/11381730/989439
function mobilecheck() {
    var check = function check(a) {
        if (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
            return true;
        }
        return false;
    };

    //;

    return check(navigator.userAgent || navigator.vendor || window.opera);
}

// Reference http://davidwalsh.name/essential-javascript-functions

// Debounce
// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
    var timeout = void 0;
    return function () {
        var context = this;
        var args = arguments;

        var later = function later() {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };

        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}

/* Usage
	var myEfficientFn = debounce(function() {
	// All the taxing stuff you do
	}, 250);
	window.addEventListener('resize', myEfficientFn);
	*/

//Poll
function poll(fn, callback, errback, timeout, interval) {
    var endTime = Number(new Date()) + (timeout || 2000);
    interval = interval || 100;

    (function p() {
        // If the condition is met, we're done!
        if (fn()) {
            callback();
        } else if (Number(new Date()) < endTime) {
            // If the condition isn't met but the timeout hasn't elapsed, go again
            setTimeout(p, interval);
        } else {
            // Didn't match and too much time, reject!
            errback(new Error('timed out for ' + fn + ': ' + arguments));
        }
    })();
}

// Usage:  ensure element is visible
/*poll(
	function() {
	return document.getElementById('lightbox').offsetWidth > 0;
	},
	function() {
	// Done, success callback
	},
	function() {
	// Error, failure callback
	}
	);
	*/

// Once
// There are times when you prefer a given functionality only happen once,
// similar to the way you'd use an onload event
// The once function ensures a given function can only be called once, thus prevent duplicate initialization!
function once(fn, context) {
    var result = void 0;

    return function () {
        if (fn) {
            result = fn.apply(context || this, arguments);
            fn = null;
        }

        return result;
    };
}

var executeFunctionByName = function executeFunctionByName(functionName, context) {
    /*
    http://stackoverflow.com/questions/359788/how-to-execute-a-javascript-function-when-i-have-its-name-as-a-string
    The benefit of this method is to pass a function as a name that may be passed as a object-reference.
    The functionName can be anObject.aSubObject.aMethod,
    After the context-argument additional arguments may be passed:
    i.e executeFunctionByName('anObject.aSubObject.aMethod', aWrappingObject, 'arg1','arg2','argN')
    This method then goes from the parent-object to into the separate
    subobjects and replaces the context with the
    last one:
    (selectedContext = context['anObject']['aSubObject'])
    Finally the last key ('aMethod') is referred to from inside its closest parent-object, and invoked with its passed arguments.
    */
    var i = void 0;

    var additionalArgs = [].slice.call(arguments).splice(2);
    var namespaces = functionName.split('.');
    var func = namespaces.pop();
    var ctx = context || window;
    // context = (context || window);
    for (i = 0; i < namespaces.length; i += 1) {
        ctx = ctx[namespaces[i]];
        // context = context[namespaces[i]];
    }
    return ctx[func].apply(ctx, additionalArgs);
};

// Usage
/*var canOnlyFireOnce = once(function() {
 console.log('Fired!');
 });
 canOnlyFireOnce(); // "Fired!"
 canOnlyFireOnce(); // nada
 */

// getAbsoluteUrl
// getting an absolute URL from and string input
var getAbsoluteUrl = function () {
    // Usage
    /*
    getAbsoluteUrl('/something'); // http://davidwalsh.name/something
    */
    var a = void 0;

    return function (url) {
        if (!a) {
            a = document.createElement('a');
        }
        a.href = url;

        return a.href;
    };
}();

var containsWord = function containsWord(string, word) {
    /*eventhandling system copied from payment/common/lib/utils/events.js*/
    return new RegExp('\\b' + word + '\\b').test(string);
};

var checkParentForFilterHit = function checkParentForFilterHit(element, filter, addFilter) {
    var node = element;
    var additionalFilterHit = false;
    var parentNode = node.parentNode;
    var className = element.className;
    var wrapFilterHit = false;
    var wrapFilter = 'adcont';
    var seq = 0;
    var parentTargetHit = false;
    while (parentNode !== null && !(seq > 15 || wrapFilterHit || parentTargetHit)) {
        node = parentNode;
        className = parentNode.className;
        parentTargetHit = containsWord(className, filter);
        wrapFilterHit = containsWord(className, wrapFilter);
        if (!additionalFilterHit) {
            additionalFilterHit = containsWord(className, addFilter);
        }
        seq += 1;
        parentNode = node.parentNode;
    }
    return {
        filterHit: parentTargetHit,
        targetElem: node,
        className: className
    };
};

var handle = function handle(e, classSelectorFilter, sendFkn, checkParent) {
    var handler = function () {
        e = e || window.event;
        var targetElem = e.target || e.srcElement;
        var filterHit = false;
        var className = targetElem.className;
        var data = e.detail;
        var checkParentObj = void 0;
        var filterClassName = classSelectorFilter.slice(1);
        filterHit = containsWord(className, filterClassName);
        if (!filterHit && checkParent) {
            checkParentObj = checkParentForFilterHit(targetElem, filterClassName);
            filterHit = checkParentObj.filterHit;
            className = checkParentObj.className;
            targetElem = checkParentObj.targetElem;
        }
        if (filterHit && sendFkn) {
            sendFkn({
                elm: targetElem,
                data: data,
                e: e
            });
        }
        return {
            getEventObj: function getEventObj() {
                return {
                    className: className,
                    data: data,
                    filterHit: filterHit,
                    filter: filterClassName
                };
            }
        };
    }();
    return handler;
};

var utils = {
    eventhandler: function eventhandler(event, classSelectorFilter, sendFkn, checkParentFilterHit) {
        return handle(event, classSelectorFilter, sendFkn, checkParentFilterHit);
    },

    mobilecheck: mobilecheck,
    getAbsoluteUrl: getAbsoluteUrl,
    once: once,
    poll: poll,
    debounce: debounce,
    executeFunctionByName: executeFunctionByName
};

/* harmony default export */ __webpack_exports__["a"] = utils;

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flow_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mobile_config_js__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__register_signup_validation_js__ = __webpack_require__(212);




var instance = void 0;

function MobileVerify() {
	var view = document.querySelector('.js-verify_phone-number');

	__WEBPACK_IMPORTED_MODULE_0__flow_js__["a" /* default */].call(this, view, __WEBPACK_IMPORTED_MODULE_1__mobile_config_js__["a" /* default */], {
		stepSelector: '.js-verify-phone--step',
		openClass: 'menu--is-open'
	});

	__WEBPACK_IMPORTED_MODULE_2__register_signup_validation_js__["a" /* default */].setupMobileValidation();
}

MobileVerify.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_0__flow_js__["a" /* default */].prototype);
MobileVerify.prototype.constructor = MobileVerify;

function get() {
	if (!(instance instanceof MobileVerify)) {
		instance = new MobileVerify();
	}
	return instance;
}

/* harmony default export */ __webpack_exports__["a"] = get;

/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__navigation_js__ = __webpack_require__(369);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Header = function (_Component) {
	_inherits(Header, _Component);

	function Header() {
		_classCallCheck(this, Header);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Header.prototype.componentWillMount = function componentWillMount() {
		// presumably temp fix to avoid initializing header on landing page
		if (!__WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].page || __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].page && __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */].page !== 'landing') {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__navigation_js__["a" /* default */])();
		}
	};

	Header.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'header' });
	};

	return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = Header;

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_index_js__ = __webpack_require__(52);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* The methods in configuration (below) are providing the prefixed url to make the switch between local and remote envirnoments during development. */
/* Mainly used from 'mock-api.js' */

var configuration = {
	mobileCheck: __WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* default */].mobilecheck()
};

/* harmony default export */ __webpack_exports__["a"] = _extends({}, __WEBPACK_IMPORTED_MODULE_1__store_index_js__["a" /* default */], configuration);

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_bonuses_js__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_fetch_bonuses_js__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_view_js__ = __webpack_require__(134);
/*
payment/bonus/index
*/




/* view contains all dom-elements and updates the rendering */


// TODO: this configuration will later go outside of this module and the 'mobile-core',
// to gain independency and reusability of the module, and this update will be possible
// when the router.js is replaced by react-components.
var conf = {
	/* these are the bonuses used in depositflow*/
	bonusUrl: '/bonus/depositbonuses',
	/* take this as an inparameter?*/
	/* these are the bonuses used in the registrationflow showing both deposit and other bonus*/
	allBonusesUrl: '/bonus/availablebonusesonregistration',
	/* selector to the element that will wrap the dom-elements rendered by the module */
	wrap: null,
	/* when the confirm-button is clicked this will affect the navigation, and this redirection is provided by router.js*/
	confirmCallback: null,
	/* when the bonuslist is empty this will affect the navigation, and this redirection is provided by router.js*/
	isEmptyCallback: null,
	/* bonus Id from shop if the module is initialized from shop */
	selectedShopBonusId: null,
	/* call back for shop deposit bonus */
	shopDepositBonusCallback: null,
	/* payment methods applicable for the bonus*/
	paymentMethods: null
};

function initialization(url, inRegistrationFlow) {
	/* modules in payments are initialized from here.
 After 'init' they are ready to recieve actions.
 They are then connected from the actions following the flux-architecture.*/
	__WEBPACK_IMPORTED_MODULE_2__lib_fetch_bonuses_js__["a" /* default */].init(url, conf.isEmptyCallback);
	__WEBPACK_IMPORTED_MODULE_1__lib_bonuses_js__["a" /* default */].init({
		isEmptyCallback: conf.isEmptyCallback
	});
	__WEBPACK_IMPORTED_MODULE_3__lib_view_js__["a" /* default */].init(conf.wrap, conf.confirmCallback, inRegistrationFlow);
	/* this action starts the fetchPaymentmethods and other stores registered for the action */
	__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].setupBonus();
}

function initializationForShopDepositBonus(url) {
	/* We do not initilize the view as the plan is to transition to deposit action page after the bonus selection steps*/
	__WEBPACK_IMPORTED_MODULE_2__lib_fetch_bonuses_js__["a" /* default */].init(url, conf.isEmptyCallback);
	__WEBPACK_IMPORTED_MODULE_1__lib_bonuses_js__["a" /* default */].init({
		isEmptyCallback: conf.isEmptyCallback,
		shopDepositBonusCallback: conf.shopDepositBonusCallback
	});
	__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].shopHandleBonusForDeposit({
		selectedBonusId: conf.selectedShopBonusId,
		bonusPaymentMethods: conf.paymentMethods
	});
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(p) {
		/* Initializing bonus module for shop deposit bonus*/
		if (p.selectedShopBonusId) {
			conf.selectedShopBonusId = p.selectedShopBonusId;
			conf.shopDepositBonusCallback = p.shopDepositBonusCallback;
			conf.paymentMethods = p.paymentMethods;
			initializationForShopDepositBonus(conf.bonusUrl);
		} else {
			/* when the bonus are init in the registrationflow */
			var inRegistrationFlow = p && p.url === 'register';
			// const url = (p.url === 'register' ? conf.allBonusesUrl : conf.bonusUrl);
			var url = inRegistrationFlow ? conf.allBonusesUrl : conf.bonusUrl;
			/* callbacks are parsed from router.js for navigation purposes */
			conf.isEmptyCallback = p.isEmptyCallback || null;
			conf.confirmCallback = p.confirmCallback || null;
			conf.wrap = p.wrapElmSelector || null;
			initialization(url, inRegistrationFlow);
		}
	},
	close: function close() {
		__WEBPACK_IMPORTED_MODULE_3__lib_view_js__["a" /* default */].close();
	}
};

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/* payment/commonview/lib/view-binaryquestion.js */

/* This is an updated extraction of the notifications module to be loaded using commonJS */


var elements = {};
var removeListeners = null;
var confirmationCallback = null;
var rejectionCallback = null;
var confirmButtonText = void 0;
var rejectButtonText = void 0;
var messageText = void 0;
var messageTitle = void 0;

function selectElements() {
	elements.wrap = elements.wrap || document.querySelector('.js-global-notification'); /* this wrapper is put into below the #container div and in one occurence per casino, shop and ... */
	elements.wrapSubContent = elements.wrapSubContent || elements.wrap.querySelector('.js-binary-question');
	elements.mainTitle = elements.mainTitle || elements.wrapSubContent.querySelector('.js-title');
	elements.text = elements.text || elements.wrapSubContent.querySelector('.js-text');
	elements.btnYes = elements.btnYes || elements.wrapSubContent.querySelector('.js-button-wrap-yes');
	elements.btnNo = elements.btnNo || elements.wrapSubContent.querySelector('.js-button-wrap-no');
}

function setTexts() {
	elements.btnYes.innerHTML = confirmButtonText;
	elements.btnNo.innerHTML = rejectButtonText;
	elements.mainTitle.innerHTML = messageTitle;
	elements.text.innerHTML = messageText;
}

function openWrappers() {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.wrap, 'global-notification--is-open');
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.wrapSubContent, 'notify--is-open');
}

function closeWrappers() {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.wrap, 'global-notification--is-open');
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.wrapSubContent, 'notify--is-open');
}

function _close() {
	removeListeners();
	closeWrappers();
}

function clickNoHandler() {
	_close();
	rejectionCallback();
}

function clickYesHandler() {
	_close();
	confirmationCallback();
}

function addListeners() {
	elements.btnNo.addEventListener('click', clickNoHandler);
	elements.btnYes.addEventListener('click', clickYesHandler);
}
/* this function is stored with a name different from the containing variable,
to solve the 'no-shadow' and the 'no use before define' linting rules.
*/
removeListeners = function removeListenersFkn() {
	if (elements && elements.btnNo) {
		elements.btnNo.removeEventListener('click', clickNoHandler);
	}
	if (elements && elements.btnYes) {
		elements.btnYes.removeEventListener('click', clickYesHandler);
	}
};

/* harmony default export */ __webpack_exports__["a"] = {
	show: function show(msgTxt, confirmTxt, rejectTxt, confirmCb, rejectCb) {
		var msgTitle = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';

		confirmationCallback = confirmCb || function empty() {};
		rejectionCallback = rejectCb || function empty() {};
		messageTitle = msgTitle;
		messageText = msgTxt || 'Continue?';
		confirmButtonText = confirmTxt || 'Yes';
		rejectButtonText = rejectTxt || 'No';
		selectElements();
		setTexts();
		addListeners();
		openWrappers();
	},
	close: function close() {
		_close();
	}
};

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications_js__ = __webpack_require__(16);
/* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }]*/





function insertDocument(element, doc) {
	var dateTemplate = element.getElementsByClassName('js-template-document-date')[0];
	var infoTemplate = element.getElementsByClassName('js-template-document-info')[0];
	var newDateElement = dateTemplate.cloneNode(true);
	newDateElement.classList.remove('u-hide');

	var date = new Date(doc.playerTimestamp);
	newDateElement.getElementsByTagName('small')[0].innerHTML = date.toLocaleDateString(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["g" /* locale */])().replace('_', '-'), {
		weekday: 'long',
		year: 'numeric',
		month: 'long',
		day: 'numeric',
		hour: 'numeric',
		minute: 'numeric',
		second: 'numeric'
	});

	// Only possible to delete approved documents
	if (doc.state === '1') {
		var removeButton = newDateElement.getElementsByClassName('js-remove-button')[0];
		removeButton.dataset.id = doc.id;
		removeButton.classList.remove('u-hide');
	}

	var newInfoElement = infoTemplate.cloneNode(true);
	newInfoElement.getElementsByClassName('js-filename')[0].innerHTML = doc.filename;
	newInfoElement.getElementsByClassName('js-status')[0].innerHTML = doc.status;

	newInfoElement.classList.remove('u-hide');

	infoTemplate.parentNode.insertBefore(newDateElement, infoTemplate.nextSibling);
	newDateElement.parentNode.insertBefore(newInfoElement, newDateElement.nextSibling);
}

function setTextAndIcon(numberOfDocuments, element) {
	var mainTitle = element.getElementsByClassName('js-main-title')[0];
	var supportTitle = element.getElementsByClassName('js-support-title')[0];
	var iconDiv = element.getElementsByClassName('js-icon')[0];
	var hasDocumentsIcon = iconDiv.getElementsByClassName('js-has-documents')[0];
	var emptyDocumentsIcon = iconDiv.getElementsByClassName('js-empty-documents')[0];
	if (numberOfDocuments > 0) {
		mainTitle.innerHTML = mainTitle.dataset.existsText;
		supportTitle.innerHTML = supportTitle.dataset.existsText;
		hasDocumentsIcon.classList.remove('u-hide');
		emptyDocumentsIcon.classList.add('u-hide');
	} else {
		mainTitle.innerHTML = mainTitle.dataset.emptyText;
		supportTitle.innerHTML = supportTitle.dataset.emptyText;
		hasDocumentsIcon.classList.add('u-hide');
		emptyDocumentsIcon.classList.remove('u-hide');
	}
}

function fetchUploadedDocuments(element) {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__["a" /* fetchJson */])('/doc').then(function (response) {
		var table = element.getElementsByClassName('js-documents-table')[0];
		var tableRows = table.getElementsByTagName('tr');
		var removeNodes = [];
		for (var i = 0; i < tableRows.length; i++) {
			var tableRow = tableRows[i];
			if (tableRow.classList.contains('u-hide') === false) {
				removeNodes.push(tableRow);
			}
		}

		var parent = tableRows[0].parentNode;
		for (var _i = 0; _i < removeNodes.length; _i++) {
			var removeNode = removeNodes[_i];
			parent.removeChild(removeNode);
		}

		setTextAndIcon(response.result.length, element);
		for (var _i2 = response.result.length - 1; _i2 >= 0; _i2--) {
			var doc = response.result[_i2];
			insertDocument(element, doc);
		}
		var removeButtons = element.getElementsByClassName('js-remove-button');
		for (var _i3 = 0; _i3 < removeButtons.length; _i3 += 1) {
			removeButtons[_i3].onclick = function (event) {
				var headers = new Headers();
				headers.append('Content-Type', 'application/json');
				var options = {
					headers: headers,
					method: 'DELETE',
					credentials: 'include',
					body: event.currentTarget.dataset.id
				};

				fetch('/doc', options).then(function () {
					fetchUploadedDocuments(element);
				});
			};
		}
	});
}

function bindBackButton(element, doneCallback) {
	var backButtonElement = element.getElementsByClassName('icon-close')[0];
	backButtonElement.onclick = function () {
		doneCallback();
	};
}

function uploadDocument(file, element) {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__["f" /* postFile */])('/doc', file).then(function (response) {
		if (response.status === 'SUCCESS') {
			fetchUploadedDocuments(element);
		} else {
			__WEBPACK_IMPORTED_MODULE_3__notifications_js__["a" /* default */].showNotification(response.errorDescription, 'red', true);
		}
	}).catch(function (e) {
		console.error('upload-documents:Post url-encoded form failed. error:', e);
		return Promise.reject(e);
	});
}

function bindUploadButton(element) {
	var uploadButtonElement = element.getElementsByClassName('js-upload-button')[0];
	uploadButtonElement.onchange = function () {
		uploadDocument(uploadButtonElement.files[0], element);
	};
}

function setBackIcon(element) {
	element.getElementsByClassName('icon-close')[0].classList.add('icon-close--back');
}

function init(referrer) {
	var template = document.getElementsByClassName('upload-menu')[0];
	var newElement = template.cloneNode(true);

	if (referrer) {
		bindBackButton(newElement, function () {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["c" /* push */])('/account');
		});
	} else {
		// if page has not a referrer show back button, bind push back
		setBackIcon(newElement);

		bindBackButton(newElement, function () {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["e" /* pushBack */])();
		});
	}

	bindUploadButton(newElement);
	fetchUploadedDocuments(newElement);
	newElement.classList.remove('u-hide');
	template.parentNode.insertBefore(newElement, template);
	newElement.classList.add('menu--is-open');
	newElement.classList.add('u-transform-none');
	return newElement;
}

function setCloseIcon(element) {
	element.getElementsByClassName('icon-close')[0].classList.remove('icon-close--back');
}

function view(viewReadyPromise) {
	var viewDoneResolver = void 0;
	var viewDonePromise = new Promise(function (resolve) {
		viewDoneResolver = resolve;
	});

	viewReadyPromise.then(function (contextElement) {
		setCloseIcon(contextElement);
		fetchUploadedDocuments(contextElement);
		bindBackButton(contextElement, function () {
			viewDoneResolver({ status: 'close' });
		});
		bindUploadButton(contextElement);
	});

	var element = document.getElementsByClassName('upload-menu')[0].cloneNode(true);
	return Promise.resolve({
		html: element.innerHTML,
		viewDonePromise: viewDonePromise
	});
}

function fetchHasDocuments() {
	return new Promise(function (resolve) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__["a" /* fetchJson */])('/doc').then(function (response) {
			resolve(response.result.length > 0);
		});
	});
}

function setAccountLinkUploadDocumentsIcon() {
	fetchHasDocuments().then(function (hasDocuments) {
		var uploadDocumentLink = document.getElementsByClassName('js-upload-documents-link')[0];
		if (hasDocuments) {
			uploadDocumentLink.getElementsByClassName('js-has-documents')[0].classList.remove('u-hide');
			uploadDocumentLink.getElementsByClassName('js-empty-documents')[0].classList.add('u-hide');
		} else {
			uploadDocumentLink.getElementsByClassName('js-has-documents')[0].classList.add('u-hide');
			uploadDocumentLink.getElementsByClassName('js-empty-documents')[0].classList.remove('u-hide');
		}
	});
}

/* harmony default export */ __webpack_exports__["a"] = {
	view: view,
	init: init,
	setAccountLinkUploadDocumentsIcon: setAccountLinkUploadDocumentsIcon,
	fetchHasDocuments: fetchHasDocuments
};

/***/ }),
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_custom_events_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_tabs_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_handlebars__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_handlebars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_handlebars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_currency_formatter_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_locale_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectors_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__search_js__ = __webpack_require__(312);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return init; });
/* unused harmony export getGamebyId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAllGames; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/* global define, sessionStorage, JSON, console */

/* Refactor needed
   Single Responsibility Principle (there is a lot of mixed stuff in this file)
   - fetching templates and game data
   - fetching currency
   - formatting currency in game data (format data on output; alt: format data on server)
   - creating html output for games

   Other
   Using both store and emitter for games updated event is redundant
 */











function gameList() {
	var d = new Date();
	var hourlyCacheBuster = d.getYear() + '-' + d.getMonth() + '-' + d.getDay() + '-' + d.getHours();
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_ajax_json_js__["a" /* fetchJson */])('/rest/casino/game/list?t=' + hourlyCacheBuster);
}

function getAllGames() {
	var allGames = void 0;

	try {
		allGames = __WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* store */].get().gameResource.gameData.all;
		if (allGames.length > 0) {
			return;
		}
	} catch (e) {
		console.error('Failed retrieving allGames from store. Fetching from server');
	}

	return Promise.all([gameList(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_ajax_json_js__["a" /* fetchJson */])('/player/currency')]).then(function (_ref) {
		var gameResource = _ref[0],
		    currency = _ref[1];

		/* Refactor
  	 Skip the call to .map() entirely. The only thing it does is format currency,
  	 which should be done when either
  	 	- producing output (best bet)
  	 	- when producing the game data array on the server (would need one cached version per combination of currency and language)
   */
		gameResource.result.rootContext.gameData.all = gameResource.result.rootContext.gameData.all.map(function (game) {
			if (game.jackpot) {
				game.jackpot = __WEBPACK_IMPORTED_MODULE_5__libs_currency_formatter_js__["a" /* default */].format(parseInt(game.jackpot, 10), currency.result, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__libs_locale_js__["a" /* getLocale */])());
			}
			return game;
		});

		var tpls = gameResource.result.templates;

		__WEBPACK_IMPORTED_MODULE_3_handlebars___default.a.registerPartial('game-tags', tpls['game-tags']);
		__WEBPACK_IMPORTED_MODULE_3_handlebars___default.a.registerPartial('game-ref', tpls['games-ref']);
		__WEBPACK_IMPORTED_MODULE_3_handlebars___default.a.registerPartial('explore-game-small', tpls['explore-game-small']);

		__WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* store */].get().templates.set({
			games: __WEBPACK_IMPORTED_MODULE_3_handlebars___default.a.compile(tpls.games)
		});

		var gameStore = {
			gameResource: gameResource.result.rootContext
		};

		__WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* store */].get().set(gameStore);
		__WEBPACK_IMPORTED_MODULE_0__utils_custom_events_js__["a" /* emitter */].emit('allGamesFetchedAndStored');
	}).catch();
}

function getGamebyId($gameId) {
	return __WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* store */].get().gameResource.gamedata.all.find(function (game) {
		return game.gameId === $gameId;
	});
}

/* Refactor needed:
	Generic naming
	- ”render”. Specify what is being rendered: renderGames or renderGameList

	Code duplication (providergames.js)
	- The same logic is used to render things regardless of the data subset
	- The same logic is used to add things to the dom regardless of the target element
	- The same logic is used to decide if things should be rendered regardless of the target element
	Instead use
	- one function to render stuff, parameters: gamesData
	- one function to enter things into the dom, parameters: html, target element
	- one function deciding if need for render, parameters: target element
	 	this one should be called from the callback to ”store.on('update', callback => { call-from-here(targetEl) }
 */
function render() {
	var ariaHidden = document.getElementById('section2') && document.getElementById('section2').getAttribute('aria-hidden');
	var wrapElm = document.getElementById('all-games-wrapper');
	if (!ariaHidden && wrapElm) {
		var storage = __WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* store */].get();
		var games = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__selectors_js__["a" /* gamesSelector */])(storage);
		var templateContext = _extends({}, __WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* store */].get().gameResource, {
			gameData: {
				all: games
			}
		});

		wrapElm.innerHTML = __WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* store */].get().templates.games(templateContext);
		__WEBPACK_IMPORTED_MODULE_8__search_js__["a" /* default */].setup();
		window.lazySizes.loader.checkElems();
	}
}

__WEBPACK_IMPORTED_MODULE_2__store_js__["a" /* store */].on('update', function (currentState, prevState) {
	if (currentState !== prevState) {
		render();
	}
});

function init() {
	__WEBPACK_IMPORTED_MODULE_8__search_js__["a" /* default */].init({
		input: '.search .search__input',
		content: '#section2 .game-grid'
	});
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_tabs_js__["a" /* open */])('section2');
}



/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_jquery_touch_js__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_settings_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_custom_events_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mygames_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__allgames_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_js__ = __webpack_require__(81);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return init; });
/* unused harmony export gamesFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return checkSessionAndLoadGame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return processDoubleEvents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return doubleClickOnGameItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return processSupportNavEvents; });








/**
 * This is similar to Higher Order Component (HOC) @see https://facebook.github.io/react/docs/higher-order-components.html
 * It's important that this module doesn't have any side effects as there is no view mapped to it.
 * Though it must setup common needs of children modules/components.
 * If a setup is not common to more than one child or setup can be delayed,
 * it's a sign that this module might not be right place for that setup.
 *
 * ## Children modules
 * - Explore (the default view)
 * - All Games
 * - My games
 * - Live Casino
 *
 * ## Setup list
 * - Preload all games data
 * - Add common EventListeners
 */

/**
 * All Games and My Games both views filter and render games depending on which tab is selected
 * value of tab(which is a radio button) === value of game object key, which is used as filter
 * if value is empty string all game result will be returned
 *
 * ## All Games view - Tab <==> Filter
 * - All === ""
 * - Jackpots === 'jackpot'
 * - Hot === 'isHot'
 * - New === 'isNew'
 *
 * Game filter is changed on each main tab change using 'tabbed' event and for sub tabs using 'change' event on radio buttons.
 */
function gamesFilter() {
  var filter = document.querySelector('.tabs-container section[role="tabpanel"]:not([aria-hidden="true"]) .user-options .filters input[type="radio"]:checked');
  if (filter) {
    return filter.value;
  }
  return null;
}

function setGamesFilter() {
  return __WEBPACK_IMPORTED_MODULE_7__store_js__["a" /* store */].get().filters.set({ key: gamesFilter() });
}
/**
 * Double click Handlers for game items.
 * @param {object} $game - game DOM node on which double click was observed
 */
function doubleClickOnGameItem($game) {
  var $heart = $game.getElementsByClassName('game-item__love')[0];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__mygames_js__["c" /* handleLoveEvents */])({ target: $heart });
  $heart.classList.toggle('shown');

  setTimeout(function () {
    $heart.classList.remove('shown');
    $heart.classList.add('fade');
    setTimeout(function () {
      $heart.classList.remove('fade');
    }, 500);
  }, 1000);
}

/**
 * Gets session from cookie and call loadGame with parameters
 * @param {object} game - game DOM node, on which click event was fired.
 * @param {string} mode - One of 'fun' or 'real'. Default is 'real'.
 * 'real' mode requires user to be authenticated.
 * @todo
 * right now if user is not authenticated and requests to play 'real' mode game,
 * user is presented with login page but it doesn't redirect user back to game play page.
 * This is problem in many other private routes.
 */
function checkSessionAndLoadGame(game) {
  var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'real';

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["c" /* push */])('/casino/game/' + encodeURIComponent(game.dataset.gamecode) + '/' + mode);
}

/**
 * Event is captured from bubbeling.
 * In case there is a doble click within timespan of 300  milisecond and target is game title or game image,
 * then it will love the target game item else it will navigate to game play page.
 * @param {object} e - event object
 */
function processDoubleEvents(e) {
  var target = e.target;
  var classList = target.classList;

  if (classList.contains('game-item__img') || classList.contains('main-title') && target.parentElement.classList.contains('game-item__title-wrapper')) {
    e.preventDefault();
    var $game = target.closest('.game-item');
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_custom_events_js__["b" /* handleDoubleEvents */])(e, $game, checkSessionAndLoadGame, doubleClickOnGameItem);
  }
}

/**
 * Event is captured from bubbeling.
 * Opens support navigation overlay {'.support-nav'} on click of kebab menu (three dots) {'.dots-container'} on game item.
 * Support navigation overlay features three action links.
 * 	- .js-real-mode a - onclick of this link navigate to game play page in real mode.
 * 	- .js-fun-mode a - onclick of this link navigate to game play page in fun mode.
 * 	- .js-close-support-nav - onclick of this link close the support-navigation overlay
 *
 * Using event listener option 'once: true' will remove event listener after first invocation
 * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Parameters
 * @param {object} e - event object
 */
function processSupportNavEvents(e) {
  var target = e.target;
  var classList = target.classList;

  if (classList.contains('dots-container')) {
    e.preventDefault();
    var supportNav = document.getElementsByClassName('support-nav')[0];
    supportNav.classList.toggle('support-nav--is-open');
    var $game = target.closest('.game-item');

    supportNav.querySelector('.js-real-mode a').addEventListener(__WEBPACK_IMPORTED_MODULE_2__config_settings_js__["a" /* eventType */], function () {
      checkSessionAndLoadGame($game);
    }, {
      capture: true,
      once: true
    });

    supportNav.querySelector('.js-fun-mode a').addEventListener(__WEBPACK_IMPORTED_MODULE_2__config_settings_js__["a" /* eventType */], function () {
      checkSessionAndLoadGame($game, 'fun');
    }, {
      capture: true,
      once: true
    });

    supportNav.querySelector('.js-close-support-nav').addEventListener(__WEBPACK_IMPORTED_MODULE_2__config_settings_js__["a" /* eventType */], function () {
      supportNav.classList.toggle('support-nav--is-open');
    }, {
      capture: true,
      once: true
    });
  }
}

/**
 * Initialize event handlers for casino.
 * Handler to love/like a game is defined in mygames.js
 * Using function as event handler will not add duplicate handler as opposed to anonymous functions.
 * It also leverages event bubbeling. So event listener is added to parent with presumebly is .tabs-container.
 * @listens {click} listens for eventType defined in './../config/settings.js', which is click event
 */
function initEventListners() {
  var tabContainer = document.getElementsByClassName('tabs-container');
  if (tabContainer && tabContainer.length > 0) {
    tabContainer[0].addEventListener(__WEBPACK_IMPORTED_MODULE_2__config_settings_js__["a" /* eventType */], processSupportNavEvents);
    tabContainer[0].addEventListener(__WEBPACK_IMPORTED_MODULE_2__config_settings_js__["a" /* eventType */], __WEBPACK_IMPORTED_MODULE_5__mygames_js__["c" /* handleLoveEvents */]);
    tabContainer[0].addEventListener(__WEBPACK_IMPORTED_MODULE_2__config_settings_js__["a" /* eventType */], processDoubleEvents);
    __WEBPACK_IMPORTED_MODULE_3__utils_custom_events_js__["a" /* emitter */].on('tabbed', setGamesFilter);
  }

  var filters = document.querySelectorAll('.user-options .filters input[type="radio"]');
  if (filters && filters.length > 0) {
    for (var _iterator = filters, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var filter = _ref;

      filter.addEventListener('change', setGamesFilter);
    }
  }
}

/**
 * Initialize Casino module.
 *
 * @todo create a destroy function
 * @example
 * import { init } from ./path/to/casino.js;
 * init();
 */
function init() {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__allgames_js__["b" /* getAllGames */])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["b" /* setNavigationCookies */])('casino');
  initEventListners();
}



/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return gamesSelector; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return providerSelector; });


/* Refactor
	When direct access to data in store has been replaced with getter functions,
	those getter functions can replace allGames, keyFilter & providerFilter
 */
var allGames = function allGames(store) {
	return store.gameResource;
};
var keyFilter = function keyFilter(store) {
	return store.filters.key;
};
var providerFilter = function providerFilter(store) {
	return store.filters.provider;
};

var gamesSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([allGames, keyFilter], function (gameResource, filter) {
	var games = void 0;
	if (filter) {
		games = gameResource.gameData.all.filter(function (game) {
			console.log(game[filter]);
			return game[filter];
		});
	} else {
		games = gameResource.gameData.all;
	}
	return games;
});

var providerSelector = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])(allGames, providerFilter, function (gameResource, filter) {
	var games = void 0;
	if (filter) {
		games = gameResource.gameData.all.filter(function (game) {
			return game.provider.code === filter;
		});
	} else {
		games = gameResource.gameData.all;
	}
	return games;
});



/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_handlebars__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_handlebars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_handlebars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_ajax_json_js__ = __webpack_require__(13);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setButtonConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return flowView; });
/* unused harmony export childSpinnerOnAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return siblingSpinnerOnAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return spinnerOff; });
/* unused harmony export spinnerOn */



// Create config object for navigation and title
function setButtonConfig(buttons) {
	var SHOW = 'u-show';
	var HIDE = 'u-hide';
	var buttonConfig = {
		close: HIDE,
		back: HIDE,
		next: HIDE
	};
	if (buttons && buttons.forEach) {
		buttons.forEach(function (button) {
			if (!buttonConfig.hasOwnProperty(button)) {
				throw new Error('No matching button for specified button config "' + button + '"');
			}
			buttonConfig[button] = SHOW;
		});
	}
	return buttonConfig;
}

/*
 * Todo: Move html to mustache file
 */
function renderFlowView(fetchResult, title, buttons, context) {
	__WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.registerHelper('flow-content', function (contentContext) {
		var contextPath = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.escapeExpression(contentContext.path);

		return new __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.SafeString('<div class="u-height-100" id="' + contextPath + '-content">' + contentContext.content + '</div>');
	});
	var flowViewTemplate = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.compile(fetchResult.templates['flow-view']);
	var rootContext = fetchResult.rootContext || {};
	rootContext.context = context;
	rootContext.title = title;
	rootContext.buttons = buttons;
	return flowViewTemplate(rootContext);
}

function childSpinnerOnAction(parentNode) {
	if (parentNode && parentNode.querySelector) {
		return spinnerOn(parentNode.querySelector('.spinner'));
	}
	return undefined;
}
function siblingSpinnerOnAction(spinnerSibling) {
	if (spinnerSibling && spinnerSibling.parentNode) {
		return childSpinnerOnAction(spinnerSibling.parentNode);
	}
	return undefined;
}
function spinnerOn(spinnerElement) {
	if (spinnerElement && spinnerElement.classList) {
		spinnerElement.classList.remove('u-hide');
		return spinnerElement;
	}
	return undefined;
}
function spinnerOff(spinnerElement) {
	if (spinnerElement && spinnerElement.classList) {
		spinnerElement.classList.add('u-hide');
	}
}

function flowView(title, buttons, context) {
	var url = '/template/flow-view';

	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_ajax_json_js__["a" /* fetchJson */])(url).then(function (restResult) {
		if (restResult.status === 'SUCCESS') {
			return renderFlowView(restResult.result, title, buttons, context);
		}

		throw new Error('Rest result status: ' + restResult.status);
	});
}



/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_bonus_js__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_spinner_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_wrap_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_scroll_position_js__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/*
payment/bonusview

create and handle all dom-nodes for the bonus
*/







var selectors = {
	wrap: null
	/* parse selector from navigation, router.js.
  template: app/packages/mobile-core-assets/templates/html/deposit/deposit-bonus.mustache
  */
};
var elements = void 0;
var callbackOnConfirm = function callbackOnConfirm() {/* callbackOnConfirm may be passed from router.js to direct the flow to next step on click on submit-button */};
var viewSpinnerInstance = void 0;

function changeNavDepositTitle(text) {
	// TODO; this is a temporary solution in wait for a new created by react components
	// This title belongs to the navigation, which means that each new view (pendingwithdraw,
	// bonus, payment, result) will have it's separate title.
	elements.navdeposittitle = elements.navdeposittitle || document.querySelector('#js-deposit-header-title');
	if (elements.navdeposittitle && text) {
		elements.navdeposittitle.innerHTML = text;
	}
}

function deleteAllElements() {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys', 'navdeposittitle'], 'bonus/view:23');
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init() {
		var wrapSelector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
		var confirmCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
		var inRegistrationFlow = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

		selectors.wrap = wrapSelector || selectors.wrap;
		callbackOnConfirm = confirmCallback || callbackOnConfirm;
		elements = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].selectElements(selectors, 'deposit/bonus/view:33');
		__WEBPACK_IMPORTED_MODULE_1__view_bonus_js__["a" /* default */].init({
			wrap: elements.wrap,
			callbackOnConfirm: callbackOnConfirm
		});
		viewSpinnerInstance = __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_spinner_js__["a" /* default */].create({
			wrap: elements.wrap
		});
		__WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_wrap_js__["a" /* default */].show(elements && elements.wrap);
		var textkeysObj = __WEBPACK_IMPORTED_MODULE_5__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		// TODO: the setting of this title shall probably be set in coordination with
		// react-router and template-system.
		// currently the chain to control is too long:
		// react-router: components, navdeposit.init(config) - where config is fetched
		// from payments/common/utils/router-config which points to an index
		// in mobile-core-assets/templates/html/account/textkeys-payment.mustache
		if (inRegistrationFlow) {
			changeNavDepositTitle(textkeysObj['deposit-bonus-fromregister-title']);
		} else {
			changeNavDepositTitle(textkeysObj['deposit-bonus-title']);
		}
		viewSpinnerInstance.show();
	},
	update: function update(state) {
		/* Data modules send their state with the modulename as property. i.e 'state.foomodule. A 'view_foobar' uses 'state.foomodule'. */
		if (state) {
			if (state.bonuses) {
				__WEBPACK_IMPORTED_MODULE_1__view_bonus_js__["a" /* default */].update(state);
			}
			if (state.fetch_bonuses) {
				if (state.fetch_bonuses.pending) {
					viewSpinnerInstance.show();
				} else {
					__WEBPACK_IMPORTED_MODULE_4__utils_scroll_position_js__["a" /* default */].restore('deposit-bonus', document.querySelector('.js-deposit-bonus'));
					viewSpinnerInstance.hide();
				}
			}
		} else {
			console.warn('deposit/bonus/view: can not update, no state object provided.', state);
		}
	},
	updateFreeMoneyBonusSucces: function updateFreeMoneyBonusSucces(state) {
		__WEBPACK_IMPORTED_MODULE_1__view_bonus_js__["a" /* default */].updateFreeMoneyBonusSuccess(state);
	},
	close: function close() {
		deleteAllElements();
		if (viewSpinnerInstance) {
			viewSpinnerInstance.close();
		}
		__WEBPACK_IMPORTED_MODULE_1__view_bonus_js__["a" /* default */].close();
		__WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_wrap_js__["a" /* default */].hide(elements && elements.wrap);
	}
};

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/* payment/commonview/lib/view-notification.js */

/* This is an updated extraction of the notifications module to be loaded using commonJS */


var elements = {};
var removeListeners = null;
var confirmationCallback = null; //= confirmCallback || function empty() {};
var messageText = void 0;
var color = void 0; // color classes:
var openGlobalClassname = 'global-notification--is-open';
var openClassname = 'notification-wrap--open';
var closeClassname = 'notification-wrap--close';

// TODO: copied from original notification code. Use when adding autohide.
// TODO; this commented code is kept for a while (oct 14 2016) until autohide is implemented
// function showNotification(message, color, autoHide, customTimer) {
// 	const $notification = $globalNotificationsContainer.find('.notification-wrap');
// 	const notificationColor = (color && $.inArray(color, validColors) >= 0) ? color : 'yellow';
//
// 	$notification.find('.notification-wrap__error-text-msg').text(message);
//
// 	$globalNotificationsContainer.addClass('global-notification--is-open');
// 	$notification.removeClass('notification-wrap--close red green yellow').addClass(`notification-wrap--open ${notificationColor}`);
//
// 	// add click handler to close the notification
// 	$notification.find('.icon-close ').on('click', (event) => {
// 		event.preventDefault();
// 		event.stopPropagation();
// 		hideNotification();
// 	});
//
// 	if (autoHide) {
// 		setTimeout(() => {
// 			hideNotification();
// 		}, (customTimer || timerForMessageAutoHide));
// 	}
// }

function selectElements() {
	elements.wrap = elements.wrap || document.querySelector('.js-global-notification'); /* this wrapper is put into below the #container div and in one occurence per casino, shop and ... */
	elements.wrapSubContent = elements.wrapSubContent || elements.wrap.querySelector('.js-notification');
	elements.mainText = elements.mainText || elements.wrapSubContent.querySelector('.js-text');
	elements.wrapBtnYes = elements.wrapBtnYes || elements.wrap.querySelector('.js-button-wrap-yes');
	elements.btnYes = elements.btnYes || elements.wrapSubContent.querySelector('button');
}

function setTexts() {
	elements.mainText.innerHTML = messageText;
}

function openWrappers() {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.wrap, openGlobalClassname);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.wrapSubContent, closeClassname);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.wrapSubContent, openClassname);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.wrapSubContent, color);
}

function closeWrappers() {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.wrap, openGlobalClassname);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.wrapSubContent, closeClassname);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.wrapSubContent, openClassname);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.wrapSubContent, color);
}

function _close() {
	removeListeners();
	closeWrappers();
}

function clickYesHandler() {
	_close();
	confirmationCallback();
}

function addListeners() {
	elements.wrapBtnYes.addEventListener('click', clickYesHandler);
}
/* this function is stored with a name different from the containing variable,
to solve the 'no-shadow' and the 'no use before define' linting rules.
*/
removeListeners = function removeListenersFkn() {
	if (elements && elements.wrapBtnYes) {
		elements.wrapBtnYes.removeEventListener('click', clickYesHandler);
	}
};

/* harmony default export */ __webpack_exports__["a"] = {
	show: function show(p) {
		confirmationCallback = p.confirmCb || function empty() {};
		messageText = p.mainTxt || 'The action you requested could not be fulfilled. Try again later or contact customerservice.';
		color = p.color || 'red'; // alternatively 'neutral'
		selectElements();
		setTexts();
		addListeners();
		openWrappers();
	},
	close: function close() {
		_close();
	}
};

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/*
commonview/view_spinner

usage:
this module returnes a dom-element and some controls to display it

import viewSpinner from './view_spinner';
let mySpinner = viewSpinner.create({wrap:myDomElement});
mySpinner.show();

*/


var elements = {
	wrap: null,
	spinner: null,
	assembled: false
};
var classnameHide = 'u-hide';
var classnameShow = 'u-show';
var classnameDim = 'dim';
var create = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].create; /* create elements that can be inserted into the dom */

function createSpinner() {
	return create({
		type: 'div',
		class: 'spinner u-hide'
		/* set the z-index correctly with _z-index.scss. A value below 9 hides it due to the z-index of '.overlay' */
	});
}

function showSpinner() {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.spinner, classnameHide);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.spinner, classnameShow);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.wrap, classnameDim);
}

function hideSpinner() {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.spinner, classnameShow);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.spinner, classnameHide);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.wrap, classnameDim);
}

function assembleElements() {
	/* create elements*/
	elements.spinner = createSpinner();
	elements.wrap.appendChild(elements.spinner);
	elements.assembled = true;
}

function deleteAllElements() {
	/* The object-property must either contain an element or an array with elements*/
	/* The wrapper is not deleted.*/
	if (elements && elements.assembled) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, ['wrap'], 'view_spinner:46');
		elements.assembled = false;
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create(p) {
		elements.wrap = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].getElementIfValid(p, 'wrap', 'view_spinner:57');
		assembleElements();
		return {
			show: function show() {
				showSpinner();
			},
			hide: function hide() {
				hideSpinner();
			},
			close: function close() {
				/* hide the spinner if the spinner is closed before hidden.
    Otherwise the '.dim' element will remain on the parent */
				hideSpinner();
				deleteAllElements();
			}
		};
	}
};

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/*
commonview/view_wrap

this module handles the classnames for the wrapping elements of the depositflow.
It adds and removes classnames when transitions are complete.

usage:
import viewWrap from './view_wrap';
viewWrap.show(myWrapElement);
viewWrap.hide(myWrapElement);
*/



var classnameOpen = 'slide-in-up';
var classnameClose = 'slide-out-down';
var classnameClose2 = 'u-hide-off-canvas';
var classnameNoTransform = 'u-transform-none'; /* must be added on the wrapper to enable scrolling, which otherwise hides the content with the continue button */
function showWrap(elm) {
	function cancelTransform() {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameNoTransform);
	}
	/* the close- and no-transform may have been added while skipping the steps back and forward and
 have to be removed */
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameNoTransform);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameClose);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameClose2);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameOpen);
	/* remove transform when transform is finished to enable scrolling */
	setTimeout(cancelTransform, __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].TRANSITION_DEFAULT_TIME);
}

function hideWrap(elm) {
	/* enable transform before applying classnames dependent on transform
 this is done twice to hack away the postponed execution sometimes
 done by the other timeout above. */
	function extraEnableTransform() {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameNoTransform);
	}
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameNoTransform);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameOpen);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameClose);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameClose2);
	/* enable transform when transform is finished to enable scrolling */
	setTimeout(extraEnableTransform, __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].TRANSITION_DEFAULT_TIME);
}

/* harmony default export */ __webpack_exports__["a"] = {
	show: function show(elm) {
		showWrap(elm);
	},
	hide: function hide(elm) {
		hideWrap(elm);
	}
};

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_creditcard_js__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_paysafecard_js__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_nofields_js__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_skrill_js__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_dotpay_js__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonview_lib_view_notification_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonview_lib_view_textkeys_js__ = __webpack_require__(14);








/* the formTemplateCodeToFormTemplate has info about params that is important for the amounpage, other inputfields are done on the
 method-page, for example all input required for creditcard, or peselnumber for dotpay */
var formTemplateCodeToFormTemplate = {

	'CREDIT-CARD': { // 1
		// Credit Card
		paymentmodule: __WEBPACK_IMPORTED_MODULE_0__view_creditcard_js__["a" /* default */]
	},
	'EMAIL-CURRENCIES': { // 4
		// Skrill/ MoneyBookers
		paymentmodule: __WEBPACK_IMPORTED_MODULE_3__view_skrill_js__["a" /* default */],
		currencyselector: true
	},
	'ONLY-CURRENCIES': { // 6
		// PaySafeCard
		paymentmodule: __WEBPACK_IMPORTED_MODULE_1__view_paysafecard_js__["a" /* default */],
		currencyselector: true
	},
	trustly: { // 23, desktop had special form template for Trustly (without amount), but we use no-fields
		// Trustly
		paymentmodule: __WEBPACK_IMPORTED_MODULE_2__view_nofields_js__["a" /* default */]
	},
	'NO-FIELDS': { // 47
		paymentmodule: __WEBPACK_IMPORTED_MODULE_2__view_nofields_js__["a" /* default */]
	},
	'BANK-WIRE-WITHDRAW': { // 57
		// DotPay
		paymentmodule: __WEBPACK_IMPORTED_MODULE_4__view_dotpay_js__["a" /* default */]
	}
};

var currentPaymentMethodId = 1;

function validModule(formTemplateCode) {
	var elm = formTemplateCodeToFormTemplate[formTemplateCode] || null;
	var apiMustExist = ['create'];
	var valid = true;
	var method = null;
	if (formTemplateCode) {
		// TODO: refactoring
		apiMustExist.forEach(function (m) {
			if (elm) {
				if (elm.paymentmodule && !elm.paymentmodule[m]) {
					valid = false;
					// console.warn(`view-paymentform:109:check: module:${elm.name}: missing method :${m}`);
				}
			} else {
				valid = false;
			}
		});
	} else {
		valid = false;
	}
	if (valid) {
		method = formTemplateCodeToFormTemplate[formTemplateCode].paymentmodule;
	}
	return method;
}

function getSelected() {
	var keys = [];
	var formTemplateCode = null;
	var paymentmodule = null;
	var currencyselector = false;
	Object.keys(formTemplateCodeToFormTemplate).forEach(function (key) {
		if (formTemplateCodeToFormTemplate[key].selected) {
			keys.push(key);
		}
	});
	if (keys.length && keys.length > 1) {
		console.error('method-formTemplateCode-to-name:136:getSelected: can not have two methods as current methods:', keys);
	} else {
		formTemplateCode = keys[0] || null;
		paymentmodule = validModule(formTemplateCode);
		currencyselector = paymentmodule ? formTemplateCodeToFormTemplate[formTemplateCode] && formTemplateCodeToFormTemplate[formTemplateCode].currencyselector : false;
	}
	return {
		formTemplateCode: formTemplateCode,
		paymentmodule: paymentmodule,
		currencyselector: currencyselector
	};
}

function closeAll() {
	Object.keys(formTemplateCodeToFormTemplate).forEach(function (key) {
		if (formTemplateCodeToFormTemplate[key].paymentmodule && formTemplateCodeToFormTemplate[key].paymentmodule.close) {
			formTemplateCodeToFormTemplate[key].paymentmodule.close();
		}
	});
	if (__WEBPACK_IMPORTED_MODULE_5__commonview_lib_view_notification_js__["a" /* default */]) {
		__WEBPACK_IMPORTED_MODULE_5__commonview_lib_view_notification_js__["a" /* default */].close();
	}
}

function initCurrentSelected(p, paymentMethodId) {
	var selected = getSelected();
	var module = selected.paymentmodule;
	/* add the paymentMethodId to initial parameters */
	var created = null;
	/* the paymentMethodId of the paymentmethod is parsed to the selected module, to reduce the positions of setting this parameter */
	if (module && module.init) {
		module.init(p, paymentMethodId);
	} else if (module && module.create) {
		created = module.create(p, paymentMethodId);
	}
	return created;
}
/* harmony default export */ __webpack_exports__["a"] = {
	displayAmountSelector: function displayAmountSelector() {
		/* TODO: siru is a method that requires preselected amounts that has template code 'NO-FIELDS' together with
  some other methods. Currently Siru is treated as a special case and has a method to return . */
		var selected = getSelected();
		return selected && selected.paymentmodule.displayAmountSelector && selected.paymentmodule.displayAmountSelector();
	},
	displayCurrencySelector: function displayCurrencySelector(id) {
		var requireSelector = void 0;
		if (id) {
			requireSelector = Boolean(formTemplateCodeToFormTemplate[id] && formTemplateCodeToFormTemplate[id].currencyselector);
		} else {
			var currentFormTemplateCode = getSelected().formTemplateCode;
			var currentFormTemplate = formTemplateCodeToFormTemplate[currentFormTemplateCode];
			requireSelector = currentFormTemplate && currentFormTemplate.currencyselector;
		}
		return requireSelector;
	},
	disableamountinput: function disableamountinput() {
		/* siru is a method that does not allow typing of input into amountfield*/
		var selected = getSelected();
		return selected && typeof selected.paymentmodule.disableAmountInput !== 'undefined' && selected.paymentmodule.disableAmountInput();
	},
	getCurrentPaymentMethodId: function getCurrentPaymentMethodId() {
		var selected = getSelected();
		return selected && currentPaymentMethodId;
	},
	getCurrentPaymentModule: function getCurrentPaymentModule() {
		return getSelected().paymentmodule;
	},
	init: function init(newPaymentMethodId, newFormTemplateCode, p) {
		var currentFormTemplateCode = getSelected().formTemplateCode;
		var currentFormTemplate = formTemplateCodeToFormTemplate[currentFormTemplateCode];
		var newFormTemplate = formTemplateCodeToFormTemplate[newFormTemplateCode];
		var textkeysObj = __WEBPACK_IMPORTED_MODULE_6__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		var currentModule = null;
		var couldSetValidModule = true;
		if (currentFormTemplate) {
			formTemplateCodeToFormTemplate[currentFormTemplateCode].selected = false;
		}
		if (newFormTemplate) {
			formTemplateCodeToFormTemplate[newFormTemplateCode].selected = true;
		}
		couldSetValidModule = validModule(newFormTemplateCode);
		if (couldSetValidModule) {
			// init with provided params
			currentModule = initCurrentSelected(p, newPaymentMethodId);
			currentPaymentMethodId = newPaymentMethodId;
		} else {
			console.warn('method-newPaymentMethodId-to-name:createCurrentForm: method newPaymentMethodId does not match to a valid method', newPaymentMethodId);
			__WEBPACK_IMPORTED_MODULE_5__commonview_lib_view_notification_js__["a" /* default */].show({
				titleTxt: newFormTemplateCode,
				// color: 'neutral', // awaiting designers input before using this setting - Sunny jan 2017
				mainTxt: textkeysObj['deposit-payment-method-not-supported'] + ' ' + newFormTemplateCode
			});
		}
		return currentModule;
	},
	isValid: function isValid(formTemplateCode) {
		return validModule(formTemplateCode);
	},
	updateCurrent: function updateCurrent(state) {
		var module = getSelected().paymentmodule;
		if (module && module.update) {
			module.update(state);
		}
	},
	evalInput: function evalInput() {
		var module = getSelected().paymentmodule;
		var evalatedInput = null;
		if (module && module.evalInput) {
			evalatedInput = module.evalInput();
		}
		return evalatedInput;
	},
	close: function close() {
		closeAll();
		return null;
	},
	closeCurrent: function closeCurrent() {
		var selected = getSelected();
		var module = selected.paymentmodule;
		if (module && module.close) {
			module.close();
		}
	}
};

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_fetch_pending_withdrawals_js__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_pending_withdrawals_js__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_fetch_cancel_withdraw_js__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_view_js__ = __webpack_require__(140);
/*
  payments/pendingwithdrawals/index
 */






var conf = {
	pendingWithdrawalsUrl: '/PaymentFormDataService/getPendingWithdrawals?useDateFormat=true',
	cancelPendingWithdrawalsUrl: '/PaymentFormDataService/cancelWithdraw?id=',
	wrap: null,
	isEmptyCallback: null,
	origin: null
};

function initialization() {
	__WEBPACK_IMPORTED_MODULE_4__lib_view_js__["a" /* default */].init(conf);
	__WEBPACK_IMPORTED_MODULE_2__lib_pending_withdrawals_js__["a" /* default */].init();
	__WEBPACK_IMPORTED_MODULE_1__lib_fetch_pending_withdrawals_js__["a" /* default */].init(conf.pendingWithdrawalsUrl, conf.isEmptyCallback);
	__WEBPACK_IMPORTED_MODULE_3__lib_fetch_cancel_withdraw_js__["a" /* default */].init(conf.cancelPendingWithdrawalsUrl);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].setupPendingWithdrawals();
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(p) {
		conf.isEmptyCallback = p.isEmptyCallback || null;
		conf.wrap = p.wrapElmSelector || null;
		conf.origin = p.origin || null;
		initialization();
	},
	close: function close() {
		__WEBPACK_IMPORTED_MODULE_4__lib_view_js__["a" /* default */].close();
	}
};

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__view_pending_withdrawals_js__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_spinner_js__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_wrap_js__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonview_lib_view_binaryquestion_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/*
pendingWithdrawals/view.js

create and handle all dom-nodes for the pending withdrawals
all dom-updates are routed from this module.

*/







var selectors = {
	textkeys: '.textkeys__payments',
	wrap: null
	// set selector to wrapper in navigation files, router.js.
	// template: app/packages/mobile-core-assets/templates/html/deposit/withdrawal-cancel.mustache
};
var elements = void 0;
var textkeysObj = {};
var viewSpinnerInstance = null;

function deleteAllElements() {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys'], 'pendingwithdrawals/view:23'); /* the 'selectors' object contains the keys to all elements */
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(conf) {
		selectors.wrap = conf.wrap || selectors.wrap;
		selectors.textkeys = conf.textkeys || selectors.textkeys;
		elements = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].selectElements(selectors, 'pendingwithdrawals:view');
		textkeysObj = __WEBPACK_IMPORTED_MODULE_5__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();

		__WEBPACK_IMPORTED_MODULE_1__view_pending_withdrawals_js__["a" /* default */].init({
			wrap: elements.wrap,
			origin: conf.origin || null,
			textkeysObj: textkeysObj
		});
		viewSpinnerInstance = __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_spinner_js__["a" /* default */].create({
			wrap: elements.wrap
		});
		__WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_wrap_js__["a" /* default */].show(elements && elements.wrap);
		viewSpinnerInstance.show();
	},
	update: function update(state) {
		/* Data modules send their state with the modulename as property. i.e 'state.foomodule. A 'view_foobar' uses 'state.foomodule'. */
		var textKeyFailure = textkeysObj['cancel-withdraw-general-failure'] || 'textkey-missing-cancel-withdraw';
		if (state && state.pending_withdrawals) {
			__WEBPACK_IMPORTED_MODULE_1__view_pending_withdrawals_js__["a" /* default */].update(state);
			viewSpinnerInstance.hide();
		}
		if (state && state.fetch_cancel_withdraw) {
			viewSpinnerInstance.hide();
			if (state.failure) {
				__WEBPACK_IMPORTED_MODULE_4__commonview_lib_view_binaryquestion_js__["a" /* default */].showNotification(textKeyFailure, 'red', true);
			} else {
				__WEBPACK_IMPORTED_MODULE_1__view_pending_withdrawals_js__["a" /* default */].update(state);
			}
		}
	},
	close: function close() {
		deleteAllElements();
		if (viewSpinnerInstance) {
			viewSpinnerInstance.close();
		}
		__WEBPACK_IMPORTED_MODULE_1__view_pending_withdrawals_js__["a" /* default */].close();
		__WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_wrap_js__["a" /* default */].hide(elements && elements.wrap);
	}
};

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__ = __webpack_require__(13);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchPendingWithdraws; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return fetchWithdrawPaymentMethods; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchTemplateDataForMethod; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchFeesAndLimits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchBalance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isKycNeeded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isMobileVerifyNeeded; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return preparePaymentFormDataServiceCache; });


function preparePaymentFormDataServiceCache() {
	var url = '/PaymentFormDataService/formEvent/playerEnterForm';
	var data = { deposit: false, mobileDevice: true };

	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__["b" /* postJson */])(url, data);
}

function fetchWithdrawPaymentMethods() {
	var url = '/PaymentFormDataService/getWithdrawPaymentMethods';
	var mobileDevice = 'isMobileDevice=true';

	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__["a" /* fetchJson */])(url + '?' + mobileDevice);
}
function fetchTemplateDataForMethod(url, params) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__["c" /* postFormUrlEncoded */])(url, params + '&isMobile=true').catch(function (e) {
		console.log('Failed fetching credit card data. e=' + e + ' url=' + url + ', post data:', params);
		return Promise.reject(e);
	});
}
/* With header { cache: no-store }, url cache busting should not be needed. nginx proxy conf?
 * Solving the problem with url cache busting for now.
 * TODO: Investigate cache no-store header post MVP
 */
function fetchFeesAndLimits(data) {
	var url = '/PaymentFormDataService/geWithdrawFeesAndLimits/forMobile?t=' + Date.now();
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__["d" /* postObjectAsFormUrlEncoded */])(url, data);
}
/* With header { cache: no-store }, url cache busting should not be needed. nginx proxy conf?
 * Solving the problem with url cache busting for now.
 * TODO: Investigate cache no-store header post MVP
 */
function fetchBalance() {
	var url = '/PaymentFormDataService/getWithdrawBalance?t=' + Date.now();
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__["a" /* fetchJson */])(url);
}

function fetchPendingWithdraws() {
	return new Promise(function (resolve) {
		setTimeout(function () {
			var POSSIBLE_WITHDRAWS = [{
				amount: 80,
				currency: 'SEK'
			}, {
				amount: 120,
				currency: 'SEK'
			}, {
				amount: 150,
				currency: 'SEK'
			}, {
				amount: 200,
				currency: 'SEK'
			}];
			var MIN = 0;
			var MAX = 0; // POSSIBLE_WITHDRAWS.length;
			var pendingCount = Math.random() * (MAX - MIN) + MIN;
			resolve(POSSIBLE_WITHDRAWS.slice(0, pendingCount));
		}, 50);
	});
}
function isKycNeeded(paymentMethodData) {
	var kycCheckParameters = paymentMethodData;
	kycCheckParameters.isMobileDevice = true;
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__["a" /* fetchJson */])('/PaymentFormDataService/getValidateKYCStatus', kycCheckParameters);
	/* - Mock to Force KYC
 	.then(() => {
 		const kycResponse = {
 			needValidation: true,
 			kycPopup: {
 				contentKYC: {
 					uploadTitle: 'Upload Title',
 					message: 'Kyc upload message.',
 					uploadDocuments: ['Passport', 'National ID'],
 				},
 				confirm: 'Confirm KYC',
 			}
 		};
 		return kycResponse;
 	});
 */
}

function isMobileVerifyNeeded() {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__["a" /* fetchJson */])('/PaymentFormDataService/getWithdrawVerification');
}



/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__libs_tomcat_cookies_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reality_check_view_js__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notifications_js__ = __webpack_require__(16);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initRealityCheck; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setRealityCheckDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return disableRealityCheckDuration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return resetRealityCheckDuration; });






var SECOND_IN_MS = 1000;
var MINUTE_IN_MS = 60 * SECOND_IN_MS;
var MAX_TIMEOUT = 60 * MINUTE_IN_MS;
var REALITY_CONTROL_COOKIE = 'RCCC';

var timeoutId = void 0;

function timerOff() {
	window.clearTimeout(timeoutId);
	timeoutId = null;
}

function setTimer() {
	if (isNaN(parseInt(__WEBPACK_IMPORTED_MODULE_0__libs_tomcat_cookies_js__["a" /* default */].get(REALITY_CONTROL_COOKIE), 10))) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_ajax_json_js__["e" /* putJson */])('/player/limits/reality-check').then(function () {
			setTimer();
		});
		return;
	}

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_ajax_json_js__["a" /* fetchJson */])('/player/limits/reality-check/duration').then(function (responseDuration) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_ajax_json_js__["a" /* fetchJson */])('/player/limits/reality-check/date').then(function (response) {
			var offset = response.result.date - Date.parse(new Date().toUTCString());
			var durationInMs = responseDuration.result.timerDuration * 60 * 1000;
			var endTime = parseInt(__WEBPACK_IMPORTED_MODULE_0__libs_tomcat_cookies_js__["a" /* default */].get(REALITY_CONTROL_COOKIE), 10) + durationInMs;
			var clientTimeMs = Date.parse(new Date().toUTCString());
			var timeoutTimeLeft = endTime - (clientTimeMs + offset);
			timerOn(timeoutTimeLeft);
		});
	});
}

function resetRealityCheckDuration() {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_ajax_json_js__["e" /* putJson */])('/player/limits/reality-check').then(function (response) {
		var texts = response.result;
		__WEBPACK_IMPORTED_MODULE_4__notifications_js__["a" /* default */].showConfirmationMessage('default-success', texts.title, texts.message, texts.button);
		setTimer();
	});
}

function timerOn(timeoutParameter) {
	var timeout = timeoutParameter;
	if (timeoutId) {
		timerOff();
	}

	if (timeout < SECOND_IN_MS && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["c" /* sessionKey */])()) {
		__WEBPACK_IMPORTED_MODULE_1__reality_check_view_js__["a" /* default */].show();
	} else {
		timeout = Math.min(timeout, MAX_TIMEOUT);
		timeoutId = window.setTimeout(function () {
			setTimer();
		}, timeout);
	}
}

function setRealityCheckDuration(minutes) {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_ajax_json_js__["b" /* postJson */])('/player/limits/reality-check', { duration: parseInt(minutes, 10) }).then(function (response) {
		var texts = response.result;
		__WEBPACK_IMPORTED_MODULE_4__notifications_js__["a" /* default */].showConfirmationMessage('default-success', texts.title, texts.message, texts.button);
		if (minutes > 0) {
			setTimer();
		}
	});
}

function disableRealityCheckDuration() {
	setRealityCheckDuration(-1);
}

function initResetRealityCheckDuration(cb) {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_ajax_json_js__["e" /* putJson */])('/player/limits/reality-check').then(function () {
		cb();
	});
}

function start() {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_ajax_json_js__["a" /* fetchJson */])('/player/limits/reality-check/duration').then(function (response) {
		if (response.result.timerDuration !== null) {
			setTimeout(function () {
				setTimer();
			}, 2000);
		}
	});
}

function initRealityCheck() {
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["c" /* sessionKey */])()) {
		if (__WEBPACK_IMPORTED_MODULE_0__libs_tomcat_cookies_js__["a" /* default */].get('reality-check-login') === 'true') {
			__WEBPACK_IMPORTED_MODULE_0__libs_tomcat_cookies_js__["a" /* default */].set('reality-check-login', false);
			initResetRealityCheckDuration(start);
		} else {
			start();
		}
	}
}



/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_settings_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__payment_common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_currency_formatter_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_locale_js__ = __webpack_require__(31);











var $pusher = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pusher');
var $offerContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.shop-detail');
var $shopContainer = $pusher.find('.shop');
var $getBonusButton = $offerContainer.find('.js-btn-bonus-get');
var $getBonusButtonSpinner = $getBonusButton.find('.spinner');
var $voucherContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.shop__voucher-container');
var $voucherInputButton = $voucherContainer.find('.btn-voucher-code-input');
var $bonusDetail = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.accordion');
var $bonusDetailContent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.accordion__content');
var $headerWrapperShop = $offerContainer.find('.header-wrapper');
var $pageHeadOfferShop = $offerContainer.find('.page-head');
var $pageHeadShop = $pusher.find('.page-head');
var prevScrollPos = [0, 0];
var needsMobVerErrCode = 'BONUS_ADD_NEEDS_VERIFIED_MOBILE';
var textkeysObj = [];
var lastCheckedBonusType = '';
var lastCheckedBonusId = '';
var lastCheckedBonusPaymentMethods = '';

function clearBonusDetails() {
	$offerContainer.find('#shop-bonus-title').html('');
	$offerContainer.find('#shop-bonus-type').html('');
	$offerContainer.find('#shop-bonus-header').html('');
	$offerContainer.find('#shop-bonus-description').html('');
	$offerContainer.find('#shop-bonus-valid-products').html('');
	$offerContainer.find('#shop-bonus-days-to-play').html('');
	$offerContainer.find('#shop-bonus-expiry-date').html('');
	$offerContainer.find('#shop-bonus-min-deposit').html('');
	$offerContainer.find('#shop-bonus-max-deposit').html('');
	$offerContainer.find('#shop-bonus-percentage').html('');
	$offerContainer.find('#shop-bonus-amount').html('');
	$offerContainer.find('#bonus-casino-x-factor').html('');
	$offerContainer.find('#bonus-sports-x-factor').html('');
	$offerContainer.find('#bonus-sports-minimum-odds').html('');
	$offerContainer.find('#bonus-sports-minimum-selections').html('');
	$offerContainer.removeAttr('data-bonus-type');
}

function setCommonFields($bonusContainer) {
	// Setting common fields
	$offerContainer.find('#shop-bonus-title').html($bonusContainer.data('bonus-title'));
	$offerContainer.attr('data-bonus-type', $bonusContainer.data('bonus-title'));
	$offerContainer.find('#shop-bonus-type').html($bonusContainer.data('text-bonus-title'));
	var bonusTag = $bonusContainer.find('.u-dib').clone();
	$offerContainer.find('.u-dib').replaceWith(bonusTag);
	$offerContainer.find('#shop-bonus-image').attr('src', $bonusContainer.data('bonus-image'));
	$offerContainer.find('#shop-bonus-header-title').html($bonusContainer.data('bonus-header'));
	$offerContainer.find('#shop-bonus-header-description').html($bonusContainer.data('bonus-header'));
	$offerContainer.find('#shop-bonus-description').html($bonusContainer.data('bonus-description'));
	$offerContainer.find('#shop-bonus-valid-products').html($bonusContainer.data('bonus-valid-products'));
	$offerContainer.find('#shop-bonus-days-to-play').html(parseInt($bonusContainer.data('bonus-days-to-play'), 10));
	$offerContainer.find('#shop-sports-bonus-requirements').show();
	$offerContainer.find('#shop-casino-bonus-requirements').show();
}

function populateDepositBonusDetails($bonusContainer) {
	$offerContainer.find('#shop-bonus-amount').parent().hide();
	$offerContainer.find('#shop-bonus-percentage').parent().show();
	$offerContainer.find('#shop-bonus-expiry-date').parent().show();
	$offerContainer.find('#shop-bonus-min-deposit').parent().show();
	$offerContainer.find('#shop-bonus-max-deposit').parent().show();
	$offerContainer.find('#shop-bonus-expiry-date').html($bonusContainer.data('bonus-expiry-date'));
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_ajax_json_js__["a" /* fetchJson */])('/player/currency').then(function (response) {
		var currencyIsoCode = response.result;
		$offerContainer.find('#shop-bonus-min-deposit').html(__WEBPACK_IMPORTED_MODULE_8__libs_currency_formatter_js__["a" /* default */].format($bonusContainer.data('bonus-min-deposit'), currencyIsoCode, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__libs_locale_js__["a" /* getLocale */])()));
		$offerContainer.find('#shop-bonus-max-deposit').html(__WEBPACK_IMPORTED_MODULE_8__libs_currency_formatter_js__["a" /* default */].format($bonusContainer.data('bonus-max-deposit'), currencyIsoCode, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__libs_locale_js__["a" /* getLocale */])()));
		$offerContainer.find('#shop-bonus-percentage').html($bonusContainer.data('bonus-percentage'));
		if ($bonusContainer.data('casino-x-factor') && parseFloat($bonusContainer.data('casino-x-factor')) > 0) {
			if (!($bonusContainer.data('sports-x-factor') && parseFloat($bonusContainer.data('sports-x-factor')) > 0 && parseFloat($bonusContainer.data('minimum-odds')) > 0 && parseFloat($bonusContainer.data('minimum-selections')) > 0)) {
				$offerContainer.find('#shop-sports-bonus-requirements').hide();
			}
			$offerContainer.find('#bonus-casino-x-factor').html($bonusContainer.data('casino-x-factor') + 'x ' + $bonusContainer.data('casino-bonus-x-factor-suffix'));
		}
		if ($bonusContainer.data('sports-x-factor') && parseFloat($bonusContainer.data('sports-x-factor')) > 0 && parseFloat($bonusContainer.data('minimum-odds')) > 0 && parseFloat($bonusContainer.data('minimum-selections')) > 0) {
			if (!($bonusContainer.data('casino-x-factor') && parseFloat($bonusContainer.data('casino-x-factor')) > 0)) {
				$offerContainer.find('#shop-casino-bonus-requirements').hide();
			}
			$offerContainer.find('#bonus-sports-x-factor').html($bonusContainer.data('sports-x-factor') + 'x ' + $bonusContainer.data('sports-bonus-x-factor-suffix'));
			$offerContainer.find('#bonus-sports-minimum-odds').html($bonusContainer.data('minimum-odds'));
			$offerContainer.find('#bonus-sports-minimum-selections').html(parseInt($bonusContainer.data('minimum-selections'), 10));
		}
	});
}

function populateFreeMoneyBonusDetails($bonusContainer) {
	// hiding fields specific to deposit bonus and displaying fields for free money bonus
	$offerContainer.find('#shop-bonus-percentage').parent().hide();
	$offerContainer.find('#shop-bonus-min-deposit').parent().hide();
	$offerContainer.find('#shop-bonus-max-deposit').parent().hide();
	$offerContainer.find('#shop-bonus-expiry-date').parent().show();
	$offerContainer.find('#shop-bonus-amount').parent().show();
	$offerContainer.find('#shop-bonus-expiry-date').html($bonusContainer.data('bonus-expiry-date'));
	$offerContainer.find('#shop-bonus-min-deposit').html($bonusContainer.data('bonus-expiry-date'));
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__core_ajax_json_js__["a" /* fetchJson */])('/player/currency').then(function (response) {
		var currencyIsoCode = response.result;
		$offerContainer.find('#shop-bonus-amount').html(__WEBPACK_IMPORTED_MODULE_8__libs_currency_formatter_js__["a" /* default */].format($bonusContainer.data('bonus-amount-value'), currencyIsoCode, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__libs_locale_js__["a" /* getLocale */])()));
		if ($bonusContainer.data('casino-x-factor') && parseFloat($bonusContainer.data('casino-x-factor')) > 0) {
			if (!($bonusContainer.data('sports-x-factor') && parseFloat($bonusContainer.data('sports-x-factor')) > 0)) {
				$offerContainer.find('#shop-sports-bonus-requirements').hide();
			}
			$offerContainer.find('#bonus-casino-x-factor').html(__WEBPACK_IMPORTED_MODULE_8__libs_currency_formatter_js__["a" /* default */].format($bonusContainer.data('casino-x-factor'), currencyIsoCode, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__libs_locale_js__["a" /* getLocale */])()));
		}
		if ($bonusContainer.data('sports-x-factor') && parseFloat($bonusContainer.data('sports-x-factor')) > 0) {
			if (!($bonusContainer.data('casino-x-factor') && parseFloat($bonusContainer.data('casino-x-factor')) > 0)) {
				$offerContainer.find('#shop-casino-bonus-requirements').hide();
			}
			$offerContainer.find('#bonus-sports-x-factor').html($bonusContainer.data('sports-x-factor') + 'x ' + $bonusContainer.data('sports-bonus-x-factor-suffix'));
			$offerContainer.find('#bonus-sports-minimum-odds').html($bonusContainer.data('minimum-odds'));
			$offerContainer.find('#bonus-sports-minimum-selections').html(parseInt($bonusContainer.data('minimum-selections'), 10));
		}
	});
}

function hideDetailsForCashBonus() {
	$offerContainer.find('#shop-bonus-expiry-date').parent().hide();
	$offerContainer.find('#shop-bonus-amount').parent().parent().parent().hide();
	$offerContainer.find('#shop-casino-bonus-requirements').parent().parent().hide();
}
function showDetailsForNonCashBonus() {
	$offerContainer.find('#shop-bonus-amount').parent().parent().parent().show();
	$offerContainer.find('#shop-casino-bonus-requirements').parent().parent().show();
}

function populateBonusDetails($bonusContainer) {
	// Clearing any preset field
	clearBonusDetails();
	setCommonFields($bonusContainer);

	/* hiding fields specific to free money bonus and displaying fields for deposit bonus
    Bonus Requirement handling for deposit bonuses is different from Free money bonuses. Hence, we use different conditions */
	if ($bonusContainer.data('bonus-title') === 'DepositBonus') {
		populateDepositBonusDetails($bonusContainer);
		lastCheckedBonusType = 'DepositBonus';
	} else {
		populateFreeMoneyBonusDetails($bonusContainer);
		lastCheckedBonusType = 'FreeMoneyBonus';
	}
	if ($bonusContainer.data('bonus-title') === 'CashBonus') {
		hideDetailsForCashBonus();
	} else {
		showDetailsForNonCashBonus();
	}
	$offerContainer.find('.js-btn-bonus-get').attr('data-bonus-id', $bonusContainer.data('bonus-id'));
	$offerContainer.find('.js-btn-bonus-get').attr('data-payment-methods', $bonusContainer.data('payment-methods'));
	lastCheckedBonusId = $bonusContainer.data('bonus-id');
	lastCheckedBonusPaymentMethods = $bonusContainer.data('payment-methods');
}

function openDetail() {
	$shopContainer.find('.shop-item').on('click', function () {
		// save the previous scroll position
		prevScrollPos[0] = window.scrollX;
		prevScrollPos[1] = window.scrollY;
		populateBonusDetails(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
		$offerContainer.addClass('shop-detail--open');
		document.querySelector('.pusher').classList.toggle('u-lock-parent-view');
		// scroll to top to make sure we show the title
		window.scrollTo(0, 0);
		// Remove transform so that position: fixed will work within this area
		setTimeout(function () {
			$offerContainer.addClass('u-transform-none');
		}, 300);
	});
}

function openShopItem(itemId) {
	var $item = $shopContainer.find('[bonus-id=\'' + itemId + '\']');
	if ($item.length > 0) {
		$item.trigger('click');
	} else {
		console.error('shop item not found for id: ' + itemId);
	}
}

function getOpenedShopItem() {
	$getBonusButton.trigger('click');
}

function closeDetailAction() {
	if ($offerContainer) {
		$offerContainer.removeClass('u-transform-none').removeClass('shop-detail--open');
		$pusher.removeClass('u-lock-parent-view');
		window.scrollTo(prevScrollPos[0], prevScrollPos[1]);
	}
}

function closeDetail() {
	$offerContainer.find('.icon-close').on('click', function () {
		// Put back transform so that we can close this view
		closeDetailAction();
	});
}

function removeBonusFromShop(bonusId) {
	if ($shopContainer) {
		$shopContainer.find('.shop-item').each(function () {
			if (parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('bonus-id'), 10) === bonusId) {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).hide();
			}
		});
	}
}

function redeemVoucher(voucherCode) {
	var data = {
		string: voucherCode
	};
	__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		url: '/bonus/redeemvoucher',
		type: 'POST',
		data: JSON.stringify(data),
		dataType: 'json',
		crossDomain: true,
		contentType: 'application/json; charset=utf-8'
	}).done(function response(resultData) {
		if (resultData.status === 'SUCCESS') {
			var result = JSON.parse(resultData.result);
			__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].showInformationMessage('success', result.headerText, result.message);
			if (result.isFreeMoneyConditional === true || result.isDepositBonus === true) {
				setTimeout(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.proxy(function () {
					location.reload();
				}, this), 3500);
			}
		}
		if (resultData.status === 'FAILURE') {
			__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].showNotification(resultData.errorDescription, 'red', true);
		}
	}).fail(function (jqXHR, textStatus, errorThrown) {
		console.error(jqXHR, textStatus, errorThrown);
	});
}

function openMobileVerNotification(notificationText) {
	var pushToMobileVerify = function pushToMobileVerify() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_history_js__["c" /* push */])('/account/mysettings/verify-mobile/', { bonusId: lastCheckedBonusId, referrer: 'shop' });
	};
	__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].showBinaryQuestion(notificationText, textkeysObj['verify-mobile'], textkeysObj['not-now'], pushToMobileVerify, __WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].hideNotification);
}
function redeemFreeMoneyBonus(bonusId) {
	var data = {
		value: bonusId
	};
	__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		url: '/bonus/redeemfreemoneybonus',
		type: 'POST',
		data: JSON.stringify(data),
		dataType: 'json',
		crossDomain: true,
		contentType: 'application/json; charset=utf-8'
	}).done(function (resultData) {
		if (resultData.status === 'SUCCESS') {
			closeDetailAction();
			var result = JSON.parse(resultData.result);
			// showInformationMessage(type, titleText, messageText, effect)
			__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].showInformationMessage('success', result.headerText, result.message, null, -1);
			removeBonusFromShop(bonusId);
		}

		if (resultData.status === 'FAILURE') {
			closeDetailAction();
			if (resultData.errorCode === needsMobVerErrCode) {
				openMobileVerNotification(resultData.errorDescription);
			} else {
				__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].showNotification(resultData.errorDescription, 'red', true);
			}
			console.error('FAILURE:' + resultData.errorDescription + '. Code: ' + resultData.errorCode);
		}
	}).fail(function (jqXHR, textStatus, errorThrown) {
		console.error(jqXHR, textStatus, errorThrown);
	}).always(function () {
		$getBonusButtonSpinner.addClass('u-hide');
	});
}

function redeemDepositBonus(bonusId, bonusPaymentMethods) {
	__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].hideNotification();

	__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		url: '/bonus/isDepositBonusOK',
		type: 'GET'
	}).done(function (resultData) {
		if (resultData.status === 'SUCCESS') {
			closeDetailAction();
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_history_js__["c" /* push */])('/account/deposit/shoppayment?referrer=shop&bonusId=' + bonusId + '&bonusPaymentMethods=' + bonusPaymentMethods);
		}

		if (resultData.status === 'FAILURE') {
			closeDetailAction();
			if (resultData.errorCode === needsMobVerErrCode) {
				openMobileVerNotification(resultData.errorDescription);
			} else {
				__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].showNotification(resultData.errorDescription, 'red', true);
			}
			console.error('FAILURE:' + resultData.errorDescription + '. Code: ' + resultData.errorCode);
		}
	}).always(function () {
		$getBonusButtonSpinner.addClass('u-hide');
	});
}

function setupClickHandlers() {
	$getBonusButton.on(__WEBPACK_IMPORTED_MODULE_2__config_settings_js__["a" /* eventType */], function (e) {
		e.stopPropagation();
		e.preventDefault();
		$getBonusButtonSpinner.removeClass('u-hide');
		var bonusType = lastCheckedBonusType;
		var bonusId = lastCheckedBonusId;
		var bonusPaymentMethods = lastCheckedBonusPaymentMethods || 'ALL';
		if (bonusType === 'FreeMoneyBonus') {
			redeemFreeMoneyBonus(bonusId);
		} else if (bonusType === 'DepositBonus') {
			redeemDepositBonus(bonusId, bonusPaymentMethods);
		}
	});

	$voucherInputButton.on(__WEBPACK_IMPORTED_MODULE_2__config_settings_js__["a" /* eventType */], function (e) {
		e.stopPropagation();
		e.preventDefault();
		var voucherCode = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().find('.input-wrap__input').val().trim();
		redeemVoucher(voucherCode);
	});
}

function toggleBonusDetails() {
	$bonusDetail.find('.js-bonus-detail-wrapper__link').on('click', function (event) {
		event.preventDefault();
		$bonusDetail.toggleClass('accordion--is-open');
		$bonusDetailContent.toggleClass('u-hide');
	});
}

function getAvailableBonuses() {
	__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		url: '/bonus/availablebonuses',
		type: 'GET',
		dataType: 'json',
		crossDomain: true,
		contentType: 'application/json; charset=utf-8'
	}).done(function (resultData) {
		if (resultData.status === 'SUCCESS') {
			var jsonStr = JSON.stringify(resultData.result.list);
			console.info('Available bonuses: ' + jsonStr);
		}
		if (resultData.status === 'FAILURE') {
			console.error(resultData.errorDescription + '. Code: ' + resultData.errorCode);
		}
	}).fail(function (jqXHR, textStatus, errorThrown) {
		console.error(jqXHR, textStatus, errorThrown);
	});
}

function getAvailableBonusesOnRegistration() {
	__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		url: '/bonus/availablebonusesonregistration',
		type: 'GET',
		dataType: 'json',
		crossDomain: true,
		contentType: 'application/json; charset=utf-8'
	}).done(function (resultData) {
		if (resultData.status === 'SUCCESS') {
			var jsonStr = JSON.stringify(resultData.result.list);
			console.info('Available bonuses on registration: ' + jsonStr);
		}
		if (resultData.status === 'FAILURE') {
			console.error(resultData.errorDescription + '. Code: ' + resultData.errorCode);
		}
	}).fail(function (jqXHR, textStatus, errorThrown) {
		console.error(jqXHR, textStatus, errorThrown);
	});
}

function getDepositBonuses() {
	__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		url: '/bonus/depositbonuses',
		type: 'GET',
		dataType: 'json',
		crossDomain: true,
		contentType: 'application/json; charset=utf-8'
	}).done(function (resultData) {
		if (resultData.status === 'SUCCESS') {
			var jsonStr = JSON.stringify(resultData.result.list);
			console.info('Available bonuses: ' + jsonStr);
		}
		if (resultData.status === 'FAILURE') {
			console.error(resultData.errorDescription + '. Code: ' + resultData.errorCode);
		}
	}).fail(function (jqXHR, textStatus, errorThrown) {
		console.error(jqXHR, textStatus, errorThrown);
	});
}

function setUpScrollHandlers() {
	$offerContainer.scroll(function () {
		$headerWrapperShop.find('img').css('opacity', 1 - __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop() / 200);
	});

	var changeHeaderWhenScroll = __WEBPACK_IMPORTED_MODULE_5__utils_js__["a" /* default */].debounce(function () {

		if ($offerContainer.scrollTop() > 0) {
			$headerWrapperShop.find('.header__title').addClass('header__title--hide');
		} else {
			$headerWrapperShop.find('.header__title').removeClass('header__title--hide');
		}
		if ($offerContainer.scrollTop() > 25) {
			$pageHeadOfferShop.addClass('page-head--opac');
			$pageHeadOfferShop.find('.page-head__title').addClass('page-head--opac');
			$pageHeadShop.addClass('page-head--opac');
		} else {
			$pageHeadOfferShop.removeClass('page-head--opac');
			$pageHeadOfferShop.find('.page-head__title').removeClass('page-head--opac');
			$pageHeadShop.removeClass('page-head--opac');
		}
	}, 100);

	$offerContainer.scroll(changeHeaderWhenScroll);
}

function init() {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_cookies_js__["b" /* setNavigationCookies */])('shop');
	openDetail();
	closeDetail();
	setupClickHandlers();
	toggleBonusDetails();
	setUpScrollHandlers();
	textkeysObj = __WEBPACK_IMPORTED_MODULE_6__payment_common_lib_core_js__["a" /* default */].getTextkeysFromElement(document.getElementById('js-textkeys-depositflow'));
}

var shop = {
	openShopItem: openShopItem,
	getOpenedShopItem: getOpenedShopItem,
	getAvailableBonuses: getAvailableBonuses,
	getAvailableBonusesOnRegistration: getAvailableBonusesOnRegistration,
	getDepositBonuses: getDepositBonuses,
	closeDetailAction: closeDetailAction,
	removeBonusFromShop: removeBonusFromShop,
	init: init
};

/* harmony default export */ __webpack_exports__["default"] = shop;

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cache = [];
function save(id, container) {
	if (container) {
		cache[id] = container.scrollTop;
	}
}

function restore(id, container) {
	if (cache[id]) {
		container.scrollTop = cache[id];
		delete cache[id];
	}
}

/* harmony default export */ __webpack_exports__["a"] = { save: save, restore: restore };

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_atmosphere_js__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_atmosphere_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_atmosphere_js__);



// const socket = atmosphere;

var websocketEvent = {};
var $wsEvent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(websocketEvent);

function isLocal() {
	var url = window.location.href;
	var arr = url.split("/");
	var urlDomain = arr[2];
	return urlDomain.search("local") >= 0;
}

function makeRequest(path) {
	if (path.length === 0) {
		throw new Error('Can\'t connect with empty path');
	}

	var pathRegexp = /[^-_\w/]/;
	if (pathRegexp.test(path)) {
		throw new Error('Only ' + pathRegexp + ' in path please!');
	}

	if (isLocal()) {
		return;
	}

	var request = {
		url: '/websocket/connect/' + path,
		transport: 'websocket',
		fallbackTransport: 'long-polling',
		contentType: 'application/json'
	};

	request.onOpen = function (response) {
		console.info('websocket-event-esm:Websocket connected using transport:', response.transport);
	};

	request.onMessage = function (response) {
		var message = response.responseBody;

		var json = {};
		try {
			json = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.parseJSON(message);
		} catch (e) {
			console.warn('That wasn\'t valid JSON:', message, e.message);
		}
		for (var name in json) {
			if (json.hasOwnProperty(name)) {
				$wsEvent.triggerHandler(name, json[name]);
			}
		}
	};

	request.onError = function (response) {
		console.warn('Websocket error:', response);
	};

	return request;
}

function on() {
	$wsEvent.on.apply($wsEvent, arguments);
}

function off() {
	$wsEvent.off.apply($wsEvent, arguments);
}

function connect() {
	disconnect();
	var path = Array.prototype.slice.call(arguments).join('/');
	websocketEvent.request = makeRequest(path);
	if (websocketEvent.request) {
		__WEBPACK_IMPORTED_MODULE_1_atmosphere_js___default.a.subscribe(websocketEvent.request);
	}
}

function disconnect() {
	if (websocketEvent.request) {
		__WEBPACK_IMPORTED_MODULE_1_atmosphere_js___default.a.unsubscribe(websocketEvent.request);
	}
}

websocketEvent.on = on;
websocketEvent.off = off;
websocketEvent.connect = connect;
websocketEvent.disconnect = disconnect;

/* harmony default export */ __webpack_exports__["a"] = websocketEvent;

/***/ }),
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_settings_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__account_info_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__menues_rootview_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__spinner_js__ = __webpack_require__(85);









var $verifyEmailMenu = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-verify_email');
var $myAccountSettings = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.my-account-settings-content');
var $verifyEmailWrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-verify_email');
var $editEmailWrapper = $myAccountSettings.find('.js-edit_email');
var $newEmail = $editEmailWrapper.find('#new-email');
var $verifyEmailCloseBttn = $verifyEmailWrapper.find('.icon-close');
var $sendBttn = $verifyEmailWrapper.find('.btn-send-mail');
var $alreadyVerifiedResponse = $verifyEmailMenu.find('#mail-verify-already-text');
var changedMailMessage = $verifyEmailWrapper.find('.mail-change').data('value');
var sentVerifyMailMessage = $verifyEmailWrapper.find('.mail-sent-verify').data('value');
var $mailField = $verifyEmailWrapper.find('#verify-email');
var userMail = '';
var unconfMail = '';
var userMailVerificationStatus = false;

$verifyEmailCloseBttn.click(function (e) {
	e.preventDefault();
	e.stopPropagation();
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_history_js__["e" /* pushBack */])();
});

function changeEmail(changeMessage, optionalCallback) {
	var newEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $newEmail;

	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_cookies_js__["c" /* sessionKey */])()) {
		var email = newEmail;

		var data = {
			string: email
		};

		__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
			url: '/player/email',
			type: 'POST',
			data: JSON.stringify(data),
			contentType: 'application/json; charset=utf-8'
		}).done(function (resultData) {
			if (resultData.status === 'SUCCESS' && resultData.result) {
				__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].showNotification(changeMessage, 'green', true);
				$verifyEmailWrapper.find('.email-to-verify').text(resultData.result);
				$newEmail.attr('placeholder', resultData.result);
				$editEmailWrapper.removeClass('notify--is-open');
				optionalCallback && optionalCallback.call();
			}
			if (resultData.status === 'FAILURE') {
				__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].showNotification(resultData.errorDescription, 'red', true);
				console.error('Error changeEmail: ' + resultData.errorDescription + '. Code: ' + resultData.errorCode);
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.error(jqXHR, textStatus, errorThrown);
		}).always(function () {
			__WEBPACK_IMPORTED_MODULE_7__spinner_js__["a" /* default */].hide($sendBttn.parent());
		});
	}
}

function resendEmailVerify(resendMessage) {
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_cookies_js__["c" /* sessionKey */])()) {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
			url: '/player/email/verify/resend/',
			type: 'POST',
			contentType: 'application/json; charset=utf-8'
		}).done(function (resultData) {
			if (resultData.status === 'SUCCESS' && resultData.result) {
				//  Show green notification with message
				__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].showNotification(resendMessage, 'green', true);
			}
			if (resultData.status === 'FAILURE') {
				__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].showNotification(resultData.errorDescription, 'red', true);
				console.error('Error resendEmailVerify ' + resultData.errorDescription + '. Code: ' + resultData.errorCode);
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.error(jqXHR, textStatus, errorThrown);
		}).always(function () {
			__WEBPACK_IMPORTED_MODULE_7__spinner_js__["a" /* default */].hide($sendBttn.parent());
		});
	}
}

function verifyEmail(verifyMessage, verifyStatusErrorMessage) {
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_cookies_js__["c" /* sessionKey */])()) {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
			url: '/player/email/verify',
			type: 'GET',
			contentType: 'application/json; charset=utf-8'
		}).done(function (resultData) {
			if (resultData.status === 'SUCCESS') {
				if (resultData.result) {
					__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].showNotification(verifyMessage, 'green', true);
					__WEBPACK_IMPORTED_MODULE_5__account_info_js__["a" /* default */].setVerificationEmail(true);
					__WEBPACK_IMPORTED_MODULE_6__menues_rootview_js__["a" /* default */].closeVerifyEmail();
				} else {
					__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].showNotification(verifyStatusErrorMessage, 'red', true);
				}
			}
			if (resultData.status === 'FAILURE') {
				__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].showNotification(resultData.errorDescription, 'red', true);
				console.error('Error verifyEmail ' + resultData.errorDescription + '. Code: ' + resultData.errorCode);
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.error(jqXHR, textStatus, errorThrown);
		});
	}
}

$sendBttn.click(function () {
	var mailToSend = $mailField.val().toLowerCase();
	function resend() {
		resendEmailVerify(sentVerifyMailMessage + ' ' + mailToSend);
		__WEBPACK_IMPORTED_MODULE_5__account_info_js__["a" /* default */].getPlayerInfo();
	}

	function showAlreadyVerifiedNotification() {
		__WEBPACK_IMPORTED_MODULE_1__notifications_js__["a" /* default */].showNotification($alreadyVerifiedResponse.text(), 'red', true);
		__WEBPACK_IMPORTED_MODULE_7__spinner_js__["a" /* default */].hide($sendBttn.parent());
	}

	__WEBPACK_IMPORTED_MODULE_7__spinner_js__["a" /* default */].show($sendBttn.parent());

	if (userMailVerificationStatus) {
		if (mailToSend === userMail) {
			showAlreadyVerifiedNotification();
		} else if (unconfMail && mailToSend === unconfMail) {
			resend();
		} else {
			changeEmail(changedMailMessage + ' ' + mailToSend, resend, mailToSend);
		}
	} else {
		if (mailToSend === userMail || unconfMail && mailToSend === unconfMail) {
			resend();
		} else {
			changeEmail(changedMailMessage + ' ' + mailToSend, resend, mailToSend);
		}
	}
});

function setUserMail(mail, unconf) {
	userMail = mail;
	unconf && (unconfMail = unconf);
	$mailField.attr('value', userMail);
}

function setMailVerificationStatus(isVerified) {
	userMailVerificationStatus = isVerified;
}

function setActive(bool) {
	if (bool) {
		if (!$mailField.val()) {

			__WEBPACK_IMPORTED_MODULE_5__account_info_js__["a" /* default */].getPlayerInfo();
		}
		$verifyEmailWrapper.addClass('menu--is-open');
		document.documentElement.classList.add('overlay--open');
		$verifyEmailWrapper.find('.js-mail-verify-step1').addClass('slide-in-left');
	} else {
		$verifyEmailWrapper.removeClass('menu--is-open');
		document.documentElement.classList.remove('overlay--open');
		$verifyEmailWrapper.find('.js-mail-verify-step1').removeClass('slide-in-left');
	}
}

// open edit email modal window
$verifyEmailWrapper.find('.js-editemail').on(__WEBPACK_IMPORTED_MODULE_2__config_settings_js__["a" /* eventType */], function () {
	$editEmailWrapper.addClass('notify--is-open');
	return false;
});

// change email
$editEmailWrapper.find('.js-changeemail').on(__WEBPACK_IMPORTED_MODULE_2__config_settings_js__["a" /* eventType */], function () {
	var changeMessage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('message');
	changeEmail(changeMessage);
	return false;
});

// resend email
$verifyEmailWrapper.find('.js-resendemail').on(__WEBPACK_IMPORTED_MODULE_2__config_settings_js__["a" /* eventType */], function () {
	var resendMessage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('message');
	resendEmailVerify(resendMessage);
	return false;
});

// verify email
$verifyEmailWrapper.find('.js-verifyemail').on(__WEBPACK_IMPORTED_MODULE_2__config_settings_js__["a" /* eventType */], function () {
	var verifyMessage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('message');
	var verifyStatusErrorMessage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('status-error');
	verifyEmail(verifyMessage, verifyStatusErrorMessage);
	return false;
});

/* harmony default export */ __webpack_exports__["a"] = {
	changeEmail: changeEmail,
	resendEmailVerify: resendEmailVerify,
	verifyEmail: verifyEmail,
	setActive: setActive,
	setUserMail: setUserMail,
	setMailVerificationStatus: setMailVerificationStatus
};

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slick_carousel__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__allgames_js__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__templates_games_handlebars__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__templates_games_handlebars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__templates_games_handlebars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_custom_events_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__casino_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mygames_js__ = __webpack_require__(80);
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }












var $bundleContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.games-by-bundle-container');
var $headerWrapperForBundles = $bundleContainer.find('.header-wrapper');
var $pageHeadForBundles = $bundleContainer.find('.page-head');
var $bundleImage = $bundleContainer.find('#bundle-page-image');
var $exploreContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#section1');
var $bundleCarousels = $exploreContainer.find('.bundle-carousel');
var $bundleCells = $exploreContainer.find('.bundle-cell');
var eventType = 'click';
var prevScrollPos = [0, 0];

// This adding an effect to fade away the bundle image / Martin
__WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scroll(function () {
	$headerWrapperForBundles.find('img').css('opacity', 1 - __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scrollTop() / 200);
});

// debounce the scroll event to put a background on the header and avoid overlapping
var changeHeaderWhenScroll = __WEBPACK_IMPORTED_MODULE_2__utils_js__["a" /* default */].debounce(function () {
	if ($bundleContainer.scrollTop() > 0) {
		$headerWrapperForBundles.find('.header__title').addClass('header__title--hide');
	} else {
		$headerWrapperForBundles.find('.header__title').removeClass('header__title--hide');
	}
	if ($bundleContainer.scrollTop() > 25) {
		$pageHeadForBundles.addClass('page-head--opac');
		$pageHeadForBundles.find('.page-head__title').addClass('page-head--opac');
	} else {
		$pageHeadForBundles.removeClass('page-head--opac');
		$pageHeadForBundles.find('.page-head__title').removeClass('page-head--opac');
	}
}, 100);

$bundleContainer.scroll(changeHeaderWhenScroll);

function togglePusherScrollability() {
	document.querySelector('.pusher').classList.toggle('u-lock-parent-view');
}

$bundleContainer.find('.icon-close').on(eventType, function () {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_history_js__["c" /* push */])('/casino/explore');
});

function closePage() {
	$bundleContainer.removeClass('games-by-bundle-container--is-open u-transform-none');
	togglePusherScrollability();
	window.scrollTo(prevScrollPos[0], prevScrollPos[1]);
}

function moveBundles() {
	// we want to show a different bundle every time a bundle carousel is shown
	$bundleCarousels.each(function (i) {
		var carousel = $bundleCarousels.eq(i).find('.gallery');
		carousel.hasClass('slick-initialized') && carousel.slick('slickGoTo', i);
	});
}

function bindClickEvents() {
	$bundleContainer.off('click.openGame').on('click.openGame', function (e) {
		var classList = e.target.classList;
		if (classList.contains('game-item__img') || classList.contains('main-title') && target.parentElement.classList.contains('game-item__title-wrapper')) {
			e.preventDefault();
			var $game = e.target.closest('.game-item');
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_custom_events_js__["b" /* handleDoubleEvents */])(e, $game, __WEBPACK_IMPORTED_MODULE_8__casino_js__["d" /* checkSessionAndLoadGame */], __WEBPACK_IMPORTED_MODULE_8__casino_js__["e" /* doubleClickOnGameItem */]);
		}
	});

	$bundleContainer.off('click.supportNav').on('click.supportNav', function (e) {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__casino_js__["c" /* processSupportNavEvents */])(e);
	});

	$bundleContainer.off('click.love').on('click.love', __WEBPACK_IMPORTED_MODULE_9__mygames_js__["c" /* handleLoveEvents */]);
}

// set up click handler for bundles module
function open(name) {
	var displayBundleGames = function () {
		var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
			var elementsToAdd;
			return regeneratorRuntime.wrap(function _callee$(_context) {
				while (1) {
					switch (_context.prev = _context.next) {
						case 0:
							_context.next = 2;
							return __WEBPACK_IMPORTED_MODULE_4__allgames_js__["b" /* getAllGames */]();

						case 2:

							gamesToBeDisplayed = gamesToBeDisplayed.map(function (v) {
								return parseInt(v.match(/\d+/g)[0]);
							});

							elementsToAdd = {
								'gameData': {
									'all': []
								}
							};


							elementsToAdd.gameData.all = __WEBPACK_IMPORTED_MODULE_5__store_js__["a" /* store */].get().gameResource.gameData.all.filter(function (v) {
								return gamesToBeDisplayed.indexOf(v.gameSiteId) !== -1;
							});

							$bundlePageContainer.find('#bundle-page-grid').html(__WEBPACK_IMPORTED_MODULE_6__templates_games_handlebars___default()(elementsToAdd));

						case 6:
						case 'end':
							return _context.stop();
					}
				}
			}, _callee, this);
		}));

		return function displayBundleGames() {
			return _ref.apply(this, arguments);
		};
	}();

	//save the previous scroll position
	prevScrollPos[0] = window.scrollX;
	prevScrollPos[1] = window.scrollY;

	var bundleCell = null;
	$bundleCells.each(function () {
		if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('.bundle-cell__image').data('game') === name) {
			bundleCell = this;
		}
	});

	if (!bundleCell) {
		return;
	}

	// add the class to make the bundle info appear
	var $bundlePageContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.games-by-bundle-container');
	$bundlePageContainer.addClass('games-by-bundle-container--is-open');
	togglePusherScrollability();
	setTimeout(function () {
		$bundleContainer.addClass('u-transform-none');
	}, 300);

	var bundleName = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(bundleCell).find('.bundle-carousel__main-title').text().trim();
	var bundleSubTitle = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(bundleCell).find('.bundle-carousel__sub-title').text().trim();

	// scroll to top to make sure we show bundle title
	window.scrollTo(0, 0);

	// add the title and sub-title to the bundle info
	$bundlePageContainer.find('#bundle-page-title').text(bundleName);
	$bundlePageContainer.find('#bundle-page-sub-title').text(bundleSubTitle);

	var $replacingImage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(bundleCell).find('img');

	$bundleImage.attr({
		'data-srcset': $replacingImage.attr('data-srcset'),
		'data-src': $replacingImage.attr('data-src')
	});
	$bundleImage.addClass('lazyload');

	// add the games from all games to gamebundles game grid
	var gamesToBeDisplayed = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(bundleCell).attr('data-games').split(',');

	$bundlePageContainer.find('.game-grid').empty();
	displayBundleGames();
	bindClickEvents();
}

/* harmony default export */ __webpack_exports__["a"] = {
	open: open,
	moveBundles: moveBundles,
	closePage: closePage
};

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__spinner_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mygames_js__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__providers_provider_loader_js__ = __webpack_require__(311);
/*jslint node:false*/
/*jslint browser: true, devel:true*/
/*global $, define, module, test, ok*/







var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);

function load(result) {
	var $ingame = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.ingame');
	var $game = $ingame.find('.game');

	var $flashGame = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('<iframe>', {
		id: 'iframe-game',
		src: result.data.URL,
		scrolling: 'no'
	});

	if (result.gameLoadType === 'REDIRECTION') {
		window.location.replace(result.data.URL);
	} else if (result.gameLoadType === 'JSON') {
		__WEBPACK_IMPORTED_MODULE_4__providers_provider_loader_js__["a" /* default */].load(result.data.JSON);
	} else {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.container').addClass('u-hide');
		$ingame.addClass('u-show');
		$game.empty();

		$flashGame.css({
			width: $window.width(),
			height: $window.height()
		});
		$flashGame.appendTo($game);

		__WEBPACK_IMPORTED_MODULE_0_jquery___default()('body').bind('orientationchange', function (event) {
			if (event.orientation === 'portrait') {
				$flashGame.css('width', $window.width());
			} else if (event.orientation === 'landscape') {
				$flashGame.css('height', $window.height());
				$flashGame.css('width', $window.width());
			}
		});
	}
}
/**
 * Do an ajax call to the game-loader-service and process response to load game
 * @param $game, game object to extract data from
 * @param funMode, boolean false by default
 * @param invalidSessionErrorCallback, callback to execute when session no longer valid
 */
function loadGame(gameCode) {
	var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'REAL';
	var invalidSessionErrorCallback = arguments[2];

	var w = window.innerWidth;
	var h = window.innerHeight;

	var jqxhr = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		url: '/load/' + encodeURIComponent(gameCode) + '/' + mode.toUpperCase() + '/' + w + '/' + h,
		type: 'GET'
	});
	var escapedGameCode = gameCode.replace(/[!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~]/g, "\\\\$&");
	var $game = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-game="' + escapedGameCode + '"]').parent();
	__WEBPACK_IMPORTED_MODULE_1__spinner_js__["a" /* default */].show($game);

	jqxhr.done(function (response) {
		if (response.status === 'SUCCESS') {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__mygames_js__["a" /* setRecentlyPlayedGame */])(escapedGameCode).then(function () {
				load(response.result);
			});
		} else if (response.errorCode === '00003') {
			//session not valid
			if (invalidSessionErrorCallback) {
				invalidSessionErrorCallback();
			}
		} else {
			console.error('Game loader Error: ' + response.errorDescription + ', code: ' + response.errorCode);
			__WEBPACK_IMPORTED_MODULE_3__notifications_js__["a" /* default */].showNotification(response.errorDescription, 'red', true);
		}
	}).fail(function () {
		console.error('Error calling game loader service');
		__WEBPACK_IMPORTED_MODULE_3__notifications_js__["a" /* default */].showNotification(response.errorDescription, 'red', true);
	}).always(function () {
		__WEBPACK_IMPORTED_MODULE_1__spinner_js__["a" /* default */].hide($game);
	});
}

/* harmony default export */ __webpack_exports__["a"] = {
	loadGame: loadGame
};

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_diffhtml__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_diffhtml___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_diffhtml__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_currency_formatter_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_locale_js__ = __webpack_require__(31);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setupJackpot; });





function setupJackpot(sectionElement) {
	var jackpotElements = sectionElement.getElementsByClassName('game-item__jackpot');
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_ajax_json_js__["a" /* fetchJson */])('/player/currency').then(function (response) {
		var currency = response.result;
		for (var i = 0; i < jackpotElements.length; i += 1) {
			var jackpotAmount = jackpotElements[i].dataset.amount;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_diffhtml__["innerHTML"])(jackpotElements[i], __WEBPACK_IMPORTED_MODULE_2__libs_currency_formatter_js__["a" /* default */].format(jackpotAmount, currency, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__libs_locale_js__["a" /* getLocale */])()));
		}
	});
}



/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payment_result_payment_result_view_js__ = __webpack_require__(351);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var globalNotificationElem = void 0;
var paymentResultElem = void 0;

function openResult() {
	globalNotificationElem.classList.add('global-notification--is-open');
	paymentResultElem.classList.add('notify--is-open');
}

function removeOpenClasses() {
	globalNotificationElem.classList.remove('global-notification--is-open');
	paymentResultElem.classList.remove('notify--is-open');
}

function _openDeposit(urlParams) {
	globalNotificationElem = document.getElementsByClassName('js-global-notification')[0];
	paymentResultElem = document.getElementsByClassName('js-payment-result-information-message')[0];
	openResult();
	var type = 'deposit';
	__WEBPACK_IMPORTED_MODULE_2__payment_result_payment_result_view_js__["a" /* default */].init(type, urlParams);
}

var PaymentResult = function (_Component) {
	_inherits(PaymentResult, _Component);

	function PaymentResult(props) {
		_classCallCheck(this, PaymentResult);

		var _this = _possibleConstructorReturn(this, _Component.call(this, props));

		globalNotificationElem = document.getElementsByClassName('js-global-notification')[0];
		paymentResultElem = document.getElementsByClassName('js-payment-result-information-message')[0];
		return _this;
	}

	PaymentResult.prototype.componentWillMount = function componentWillMount() {
		var _props = this.props,
		    type = _props.match.params.type,
		    location = _props.location;

		var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["b" /* parseQueryString */])(location);
		openResult();
		__WEBPACK_IMPORTED_MODULE_2__payment_result_payment_result_view_js__["a" /* default */].init(type, query);
	};

	PaymentResult.prototype.componentWillUnmount = function componentWillUnmount() {
		removeOpenClasses();
	};

	PaymentResult.prototype.openDeposit = function openDeposit() {
		_openDeposit();
	};

	PaymentResult.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'payment-result' });
	};

	return PaymentResult;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

PaymentResult.propTypes = {
	params: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
	location: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
	match: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

PaymentResult.functions = {
	open: _openDeposit
};

/* harmony default export */ __webpack_exports__["a"] = PaymentResult;

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_tabs_js__ = __webpack_require__(82);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Tabs = function (_Component) {
	_inherits(Tabs, _Component);

	function Tabs() {
		_classCallCheck(this, Tabs);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Tabs.prototype.componentWillMount = function componentWillMount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_tabs_js__["b" /* init */])();
	};

	Tabs.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'tabs' });
	};

	return Tabs;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = Tabs;

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/*jslint browser: true, devel:true */
/*global define*/


var floatingLabels = {};

//persistent labels pattern
floatingLabels.setupPersistentLabels = function ($form) {
    // Persistent labels on fields
    $form.find('input').on('focus', function () {
        var input = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
        var label = input.prev('label');
        input.data('holder', input.attr('placeholder'));
        input.attr('placeholder', '');
        label.addClass('input-wrap__label--show input-wrap__label--on');
    }).on('blur', function () {
        var input = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
        var label = input.prev('label');
        if (this.value === '') {
            input.attr('placeholder', input.data('holder'));
            label.removeClass('input-wrap__label--show input-wrap__label--on');
        } else {
            label.removeClass('input-wrap__label--on');
        }
    });
};

/* harmony default export */ __webpack_exports__["a"] = floatingLabels;

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tabbable__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tabbable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tabbable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_transition_end_js__ = __webpack_require__(445);





var defaultOptions = {
	openClass: 'module--open',
	skipSelector: '.js-skip',
	backSelector: '.js-back',
	closeSelector: '.js-close',
	titleSelector: '.js-title',
	stepSelector: '.js-step',
	stepTitleSelector: '.js-step-title',
	openCallback: undefined
};

function rollbackTabKey() {
	var items = Array.prototype.slice.call(document.querySelectorAll('[tabindex="-1"]'));

	items.forEach(function (item) {
		var savedTabIndex = item.dataset.tabIndex;
		if (savedTabIndex != undefined) {
			item.dataset.tabIndex = null;
			item.setAttribute('tabindex', savedTabIndex);
		}
	});
}

function prepareTabKey(container) {
	rollbackTabKey();

	var allItems = Array.prototype.slice.call(__WEBPACK_IMPORTED_MODULE_1_tabbable___default()(document));
	var currentItems = Array.prototype.slice.call(__WEBPACK_IMPORTED_MODULE_1_tabbable___default()(container));

	allItems.forEach(function (item) {
		var tabindex = item.getAttribute('tabindex') || 0;
		if (currentItems.indexOf(item) === -1) {
			if (tabindex !== -1) {
				item.dataset.tabIndex = tabindex;
				item.setAttribute('tabindex', '-1');
			}
		}
	});
}

function Flow(view, content, options) {
	this.view = view;

	this.options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, defaultOptions, options);

	this.skipButton = this.view.querySelector(this.options.skipSelector);
	this.backButton = this.view.querySelector(this.options.backSelector);
	this.closeButton = this.view.querySelector(this.options.closeSelector);
	this.title = this.view.querySelector(this.options.titleSelector);

	this.$steps = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.options.stepSelector);

	__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.backButton).on('click.flowBack', function () {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_history_js__["e" /* pushBack */])();
	});

	__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.closeButton).on('click.flowClose', function () {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_history_js__["f" /* replace */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_history_js__["d" /* basePathname */])());
	});

	this.steps = content;

	this.currentStep = undefined;
}

Flow.prototype.open = function (step) {
	if (this.currentStep == null) {
		this.view.classList.add(this.options.openClass);
	}
	if (this.currentStep === step) {
		// same step
		return;
	}

	this.currentStepView = null;

	this.update(this.currentStep, step);
	this.options.openCallback && this.options.openCallback.call(this);
	this.currentStep = step;

	document.documentElement.classList.add('overlay--open');
};

Flow.prototype.getStepIndex = function (step) {
	return Object.keys(this.steps).indexOf(step);
};

Flow.prototype.update = function (previousStep, currentStep) {
	this.previousState = this.steps[previousStep];
	this.currentState = this.steps[currentStep];

	var $currentStep = this.$steps.eq(this.currentState.order);
	var $previousStep = this.previousState && this.$steps.eq(this.previousState.order);
	var title = $currentStep.find(this.options.stepTitleSelector).html();

	this.toggle(this.backButton, this.currentState.back);
	this.toggle(this.closeButton, this.currentState.close);
	this.toggle(this.skipButton, this.currentState.skip);

	this.title.innerHTML = title || '';

	if (!this.isOpened) {
		this.view.classList.add(this.options.openClass);
		this.isOpened = true;
	}

	this.previousState && $previousStep.removeClass(this.previousState.openClass).addClass(this.previousState.closeClass);
	$currentStep.removeClass(this.currentState.closeClass).addClass(this.currentState.openClass);

	this.currentState.action && this.currentState.action.call(this, this.view);

	this.currentStepView = $currentStep[0];

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_transition_end_js__["a" /* default */])(this.currentStepView, prepareTabKey);
};

Flow.prototype.toggle = function (element, toggle) {
	if (element && element.classList) {
		element.classList.toggle('u-show', toggle);
		element.classList.toggle('u-hide', !toggle);
	}
};

Flow.prototype.close = function () {
	this.isOpened = false;
	this.currentStep = null;

	this.$steps.eq(this.currentState.order).removeClass(this.currentState.openClass).addClass(this.currentState.closeClass);

	// @TODO fix
	this.view.classList.remove(this.options.openClass);

	this.options.closeCallback && this.options.closeCallback.call(this);
	document.documentElement.classList.remove('overlay--open');

	rollbackTabKey();
};

/* harmony default export */ __webpack_exports__["a"] = Flow;

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_history_js__ = __webpack_require__(6);
/*
view_bonus
*/




 // better use the one in commonview


var textkeysObj = {};
var elements = {
	wrap: null,
	form: null,
	wrapmethods: null,
	select: null,
	bonuses: [],
	bonusesref: {},
	nextbtn: null,
	nextbtnwrap: null,
	assembled: false
};
var callbackOnConfirm = void 0;
var classSelect = 'bonus--is-selected';
var classUnselect = 'bonus--is-unselected';
var nodetree = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].nodetree;
var create = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].create; // create elements that can be inserted into the dom
var needsMobVerErrCode = 'BONUS_ADD_NEEDS_VERIFIED_MOBILE';
// const needsEmailVerErrCode = 'BONUS_ADD_NEEDS_VERIFIED_EMAIL';

function createContentWrap() {
	return create({
		type: 'main',
		class: 'payment__content-wrapper grid-r content'
	});
}

function createBonus(bonusid) {
	return create({
		type: 'figure',
		class: 'js-event-filter js-bonus shop-item bonus u-m0 grid-u-sm-1-2 grid-u-md-1-4',
		bonusid: bonusid
	});
}

function createBonusLink() {
	return create({
		type: 'div',
		class: 'shop-item-aspect-ratio'
	});
}

function createBonusImagewrapper() {
	return create({
		type: 'div',
		class: 'aspect-ratio__content shop-item__image-wrapper u-b-radius'
	});
}

function createBonusImagewrapperInner() {
	return create({
		type: 'a',
		href: '#',
		class: 'checkmark-wrapper u-p2'
	});
}

function createBonusTextwrapper(descr, txt) {
	var bonusTextWrapper = create({
		type: 'figcaption',
		class: 'shop-item__caption u-p1 u-relative u-box-bg u-b-radius-bottom'
	});
	var info = create({
		type: 'div',
		class: 'bonus__info-wrap u-hide'
	});
	var descriptionElm = create({
		type: 'h4',
		class: 'bonus__info-description'
	});
	var textElm = create({
		type: 'p',
		class: 'bonus__info-text'
	});
	textElm.innerHTML = txt;
	descriptionElm.innerHTML = descr;
	info.appendChild(descriptionElm);
	info.appendChild(textElm);
	bonusTextWrapper.appendChild(info);
	return bonusTextWrapper;
}

function createBonustypeTitle(txt) {
	var elm = create({
		type: 'small',
		class: 'support-title'
	});
	elm.innerHTML = txt;
	return elm;
}

function createMaintitle(txt) {
	var elm = create({
		type: 'h2',
		class: 'main-title u-m0' /*  to remove text that don't fit the box use : u-truncate */
	});
	elm.innerHTML = txt;
	return elm;
}

function createBonusImage(url) {
	return create({
		type: 'img',
		class: 'shop-item__image u-div-c',
		src: url
	});
}

function createCheckmarkWrapper() {
	var pathIconCheck = void 0;
	var svg = void 0;
	try {
		pathIconCheck = create({
			type: 'path',
			d: 'M12.28 21.56C11.04 21.57 9.81 21.32 8.67 20.83 3.95 18.84 1.74 13.4 3.73 8.67 5.73 3.95 11.17 1.74 15.89 3.73 16.44 3.97 16.97 4.26 17.47 4.6 17.65 4.72 17.7 4.97 17.58 5.15 17.45 5.33 17.2 5.38 17.02 5.26 16.56 4.95 16.08 4.68 15.57 4.47 13.47 3.58 11.1 3.58 9 4.47 5.85 5.79 3.81 8.87 3.81 12.28 3.81 15.69 5.85 18.77 9 20.09 11.1 20.98 13.47 20.98 15.57 20.09 17.61 19.22 19.23 17.6 20.1 15.57 20.54 14.53 20.76 13.42 20.75 12.29 20.76 11.55 20.66 10.8 20.47 10.08 20.41 9.87 20.53 9.66 20.74 9.6 20.95 9.54 21.17 9.66 21.23 9.87 21.44 10.66 21.55 11.47 21.55 12.29 21.56 13.53 21.31 14.76 20.82 15.9 19.88 18.12 18.11 19.89 15.88 20.84 14.74 21.32 13.52 21.57 12.28 21.56ZM12.09 15.63C11.87 15.63 11.66 15.53 11.52 15.36L7.8 11.08C7.67 10.92 7.69 10.68 7.84 10.54 7.99 10.4 8.23 10.4 8.38 10.54L8.38 10.56 12.09 14.84 20.34 5.38C20.49 5.21 20.74 5.2 20.91 5.34 21.07 5.49 21.09 5.74 20.94 5.9L12.66 15.37C12.52 15.53 12.31 15.63 12.09 15.63Z' // eslint-disable-line max-len
		});
		svg = create({
			type: 'svg',
			class: 'checkmark-wrapper__checkmark u-pos-c',
			viewBox: '0 0 24 24'
		});
		svg.appendChild(pathIconCheck);
	} catch (err) {
		console.warn('payments/view_bonus:createCheckmarkWrapper', err);
	}
	return svg;
}

function createOffertag() {
	var offertag = void 0;
	var pathIconHeart = void 0;
	var svg = void 0;
	try {
		pathIconHeart = create({
			type: 'path',
			class: 'icon__heart',
			d: 'M29.68 54.92q-2.69-1.8-7.6-5.6a63.17 63.17 0 0 1-9.25-8.86A41 41 0 0 1 6 29.55a15.15 15.15 0 0 1-.18-11.73 14.89 14.89 0 0 1 4.67-6.28 14.46 14.46 0 0 1 7.18-3.05q0.48-.06 1-0.09l1 0a14.57 14.57 0 0 1 11.55 5.57 12.87 12.87 0 0 1 1.17 1.77 14.53 14.53 0 0 1 .87 1.89 11.7 11.7 0 0 1 .39 1.29q0.15 0.63.27 1.23a0.49 0.49 0 0 0 0 .15 3.11 3.11 0 0 0 .15.33 1.27 1.27 0 0 0 .48.54 1.26 1.26 0 0 0 .66.18 1.42 1.42 0 0 0 .69-0.18 1.18 1.18 0 0 0 .51-0.6 4.19 4.19 0 0 0 .06-0.69V19.19q-0.12-.78-0.3-1.56a11.6 11.6 0 0 0-.48-1.56l-0.36-.84L35 14.4a2.22 2.22 0 0 1-.3-1.5 2.44 2.44 0 0 1 .72-1.38h0.06a13.9 13.9 0 0 1 4.25-2.36 14.72 14.72 0 0 1 4.85-.81 8.45 8.45 0 0 1 1 .06l1 0.12a14.06 14.06 0 0 1 7.07 3.05 14.63 14.63 0 0 1 4.55 6.28A15.42 15.42 0 0 1 58 29.61 39.61 39.61 0 0 1 51.17 40.5a66.12 66.12 0 0 1-9.25 8.83q-4.88 3.8-7.57 5.6a3.41 3.41 0 0 1-1.08.54 4.49 4.49 0 0 1-2.51 0A3.41 3.41 0 0 1 29.68 54.92Z' // eslint-disable-line max-len
		});
		svg = create({
			type: 'svg',
			class: 'bonus__svg-offer-tag u-dib',
			viewBox: '0 0 64 64'
		});
		offertag = create({
			type: 'div',
			class: 'bonus__offer-tag offer-tag u-box-bg u-pos-c u-text-c u-b-radius-round'
		});
		svg.appendChild(pathIconHeart);
		offertag.appendChild(svg);
	} catch (err) {
		console.warn('payments/view_bonus:createOffertag', err);
	}
	return offertag;
}

function createWrapSubmit() {
	return create({
		type: 'div',
		class: 'u-btn-wrapper u-absolute u-pos-bl0 grid-u-sm-1'
	});
}

function createHiddenPaymentMethodsField(paymentMethods) {
	var elm = create({
		type: 'hidden',
		class: 'payment-methods',
		value: paymentMethods
	});
	return elm;
}

function toggleSelectClass(id) {
	Object.keys(elements.bonusesref).forEach(function (key) {
		if (id === -1) {
			/* nor classUnselect or classSelect should be present when nothing is selected */
			__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elements.bonusesref[key], classSelect);
			__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elements.bonusesref[key], classUnselect);
		} else if (id !== -1 && id.toString() === key) {
			/* select */
			__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elements.bonusesref[key], classUnselect);
			__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elements.bonusesref[key], classSelect);
		} else if (id !== -1 && id.toString() !== key) {
			/* deselect */
			__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elements.bonusesref[key], classUnselect);
			__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elements.bonusesref[key], classSelect);
		}
	});
}

function handleBonusRedeemFailure(data, bonusId) {
	if (data.errorCode === needsMobVerErrCode) {
		var pushToMobileVerify = function pushToMobileVerify() {
			var referrer = location && location.search && location.search.indexOf('register') !== -1 ? 'register' : 'deposit';
			var referrerUrl = void 0;
			if (location && location.pathname) {
				referrerUrl = location.pathname;
			}
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_history_js__["c" /* push */])('/account/mysettings/verify-mobile/', { bonusId: bonusId, referrer: referrer, referrerUrl: referrerUrl });
		};

		__WEBPACK_IMPORTED_MODULE_4__notifications_js__["a" /* default */].showBinaryQuestion(data.errorDescription, textkeysObj['verify-mobile'], textkeysObj['not-now'], pushToMobileVerify, __WEBPACK_IMPORTED_MODULE_4__notifications_js__["a" /* default */].hideNotification);
	} else {
		__WEBPACK_IMPORTED_MODULE_4__notifications_js__["a" /* default */].showNotification(data.errorDescription, 'red', true);
	}
	console.error('view-bonus:230:FAILURE:' + data.errorDescription + '. Code: ' + data.errorCode);
}

function submitbtnCallbackForFreeMoney(bonusId) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewBonus({
		confirmed: true
	});

	redeemFreeMoneyBonusFromDepositFlow(bonusId);
}

function redeemFreeMoneyBonusFromDepositFlow(bonusId) {
	var redeemFreeMoneyBonusUrl = '/bonus/redeemfreemoneybonus';
	var params = {
		value: bonusId
	};
	function successHandler(data) {
		if (data.status === 'SUCCESS') {
			var result = JSON.parse(data.result);
			__WEBPACK_IMPORTED_MODULE_4__notifications_js__["a" /* default */].showInformationMessage('success', result.headerText, result.message, null, -1);
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].reloadBonusesAfterFreeMoneyBonusSuccess();
		}
		if (data.status === 'FAILURE') {
			handleBonusRedeemFailure(data, bonusId);
		}
		__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].showSpinner(false);
	}
	function failHandler(err) {
		console.error(err);
		__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].showSpinner(false);
	}

	__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].showSpinner(true);
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].post(redeemFreeMoneyBonusUrl, JSON.stringify(params), successHandler, failHandler, 'application/json; charset=UTF-8');
}

function clickBonusHandler(e) {
	function cb(p) {
		var bonusid = p.elm.getAttribute('bonusid');
		var paymentMethods = p.elm.getElementsByClassName('payment-methods')[0].getAttribute('value');
		p.e.stopPropagation();
		p.e.preventDefault();
		__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewBonus({
			selected: bonusid,
			paymentMethods: paymentMethods || 'ALL',
			confirmed: false
		});
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].handle(e, '.js-event-filter', cb, true);
}

function submitbtnCallbackForDeposit(bonusId) {
	/* the callbackOnConfirm is used by router.js to enter next step */

	var isDepositOK = '/bonus/isDepositBonusOK';

	function successHandler(data) {
		if (data.status === 'SUCCESS') {
			callbackOnConfirm();
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewBonus({
				confirmed: true
			});
		} else if (data.status === 'FAILURE') {
			handleBonusRedeemFailure(data, bonusId);
		}
		__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].showSpinner(false);
	}

	function failHandler() {
		__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].showSpinner(false);
	}

	__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].showSpinner(true);
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].get(isDepositOK, successHandler, failHandler);
}

function addListeners() {
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addListener(elements.wrap, 'click', clickBonusHandler);
}

function removeListeners() {
	/* the core.removeListener-method allows the method to be used also if the elements.wrap is not there or the handler which prevents errors thrown. */
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeListener(elements.wrap, 'click', clickBonusHandler);
}

function assembleStaticElements() {
	elements.contentwrapper = elements.contentwrapper || createContentWrap();
	elements.wrap.appendChild(elements.contentwrapper);
	elements.wrapsubmit = elements.wrapsubmit || createWrapSubmit();
	elements.wrap.appendChild(elements.wrapsubmit);
	elements.assembledStatic = true;
}

function assembleDynamicElements(p) {
	var bonusElements = [];
	var temp = {
		temp_checkmarkwrapper: null,
		temp_bonusimagewrapper: null,
		temp_bonusimage: null,
		temp_bonustextwrapper: null,
		temp_maintitle: null,
		temp_offertag: null,
		temp_bonusLink: null,
		temp_bonus: null,
		temp_bonustypetitle: null,
		temp_paymentmethods: null
	};
	/* Loop through bonus-data and create a bonus-element for each property. */
	elements.bonusesref = elements.bonusesref || [];
	Object.keys(p).forEach(function (key) {
		temp.temp_bonus = createBonus(p[key].id);
		temp.temp_bonus.setAttribute('bonusType', p[key].bonusType);
		temp.temp_bonusimagewrapper = createBonusImagewrapper();
		temp.temp_checkmarkwrapper = createCheckmarkWrapper();
		temp.temp_bonusimagewrapperInner = createBonusImagewrapperInner();
		/* save a reference */
		elements.bonusesref[p[key].id] = temp.temp_bonus;
		elements.bonusesref[p[key].id].selected = false;
		/* create all elements */
		temp.temp_bonusLink = createBonusLink();
		temp.temp_bonusimage = createBonusImage(p[key].resourceURL);
		temp.temp_bonustextwrapper = createBonusTextwrapper(p[key].description, p[key].text);
		temp.temp_maintitle = createMaintitle(p[key].header);
		temp.temp_offertag = createOffertag();
		temp.temp_bonustypetitle = createBonustypeTitle(p[key].textBonusType);
		temp.temp_paymentmethods = createHiddenPaymentMethodsField(p[key].paymentMethodIdsStr);
		/* arrange hierarchy */
		temp.temp_bonusimagewrapperInner.insertBefore(temp.temp_checkmarkwrapper, temp.temp_bonusimagewrapperInner.firstChild);
		temp.temp_bonusimagewrapper.appendChild(temp.temp_bonusimagewrapperInner);
		temp.temp_bonusimagewrapperInner.appendChild(temp.temp_checkmarkwrapper);
		temp.temp_bonusimagewrapper.appendChild(temp.temp_bonustextwrapper);
		temp.temp_bonusimagewrapperInner.appendChild(temp.temp_bonusimage);
		temp.temp_bonusLink.appendChild(temp.temp_bonusimagewrapper);
		temp.temp_bonustextwrapper.appendChild(temp.temp_offertag);
		temp.temp_bonustextwrapper.appendChild(temp.temp_bonustypetitle);
		temp.temp_bonustextwrapper.appendChild(temp.temp_maintitle);
		temp.temp_bonus.appendChild(temp.temp_bonusLink);
		temp.temp_bonus.appendChild(temp.temp_paymentmethods);
		bonusElements.push(temp.temp_bonus);
		/* delete temporary elements */
		Object.keys(temp).forEach(function (tempKey) {
			temp[tempKey] = null;
		});
	});
	/* add the bonus elements to a document fragment, and insert into the wrapper */
	/* save a reference to the bonus in the elements.bonus array to prepare for cleaning the module */
	elements.bonuses = nodetree(bonusElements);
	elements.contentwrapper.appendChild(elements.bonuses);
	elements.assembledDynamic = true;
}

function createEmptyMsgWrap(txt) {
	var elm = create({
		type: 'h2',
		class: 'deposit__content-msgwrap grid-u-sm-1 u-p1 u-text-c'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function showMsgIfEmpty(isEmpty) {
	var emptylistTextkey = textkeysObj['bonus-emptylist-feedback'] || 'textkey-missing-bonus-emptylist-feedback';
	if (isEmpty) {
		elements.emptymsgwrap = elements.emptymsgwrap || createEmptyMsgWrap(emptylistTextkey);
		elements.wrap.appendChild(elements.emptymsgwrap);
	} else if (!isEmpty && elements.emptymsgwrap) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].deleteElement(elements.emptymsgwrap, 'view_bonus:361');
	}
}

function deleteAllElements() {
	/* The object-property must either contain an element or an array with elements*/
	/* The wrapper is not deleted.*/
	elements = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys'], 'view_bonus:405');
	elements.assembled = false;
	elements.assembledStatic = false;
	elements.assembledDynamic = false;
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(p) {
		callbackOnConfirm = p.callbackOnConfirm || null;
		/* clean the area if necessary after skipping back and forth in the depositflow */
		deleteAllElements();
		/* Validate input */
		/* store reference to wrapper */
		/* test module and dependencies for basic requirements */
		/* attach listeners to the wrapper and use bubbling to catch events making it possible to create new child elements without loosing the handlers. */
		elements.wrap = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].getElementIfValid(p, 'wrap', 'view_bonus:368');
		textkeysObj = __WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		assembleStaticElements();
		__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].init({
			wrap: elements.wrapsubmit,
			buttonText: textkeysObj['bonus-continue'],
			cb: submitbtnCallbackForDeposit
		});
		__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].hide();
		addListeners();
	},
	update: function update(state) {
		/* Build dom-nodes if not already done. */
		/* View.js selects which view_sub.js that shall be updated. The sub_module also checks that this connection is set.
  The state is recieved and send unmodified to the selected views. */
		var selectedId = state && state.bonuses.selected && state.bonuses.selected.id;
		var listOfBonuses = state && state.bonuses && state.bonuses.by_id;
		var deselectedBonus = Boolean(selectedId && selectedId === -1); // gets value when toggeling a bonus from select to unselect
		var selectedBonus = selectedId && listOfBonuses && listOfBonuses[selectedId];
		var bonusType = selectedBonus && selectedBonus.bonusType;
		var isFreeMoneyBonus = Boolean(bonusType === 'FreeMoneyBonus');
		if (listOfBonuses) {
			if (elements.assembledStatic && !elements.assembledDynamic) {
				assembleDynamicElements(state.bonuses.by_id);
			} else if (!elements.assembledStatic && !elements.assembledDynamic) {
				assembleStaticElements();
				assembleDynamicElements(state.bonuses.by_id);
			}
		}

		if (deselectedBonus) {
			/* if a bonus is selected, then show the button to continue, and mark the selected */
			__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].hide();
			toggleSelectClass(selectedId); // is this necessary?
		} else if (isFreeMoneyBonus) {
			__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].changeText(textkeysObj['bonus-claim']);
			var callback = function cb() {
				submitbtnCallbackForFreeMoney(selectedId);
			};
			__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].init({
				wrap: elements.wrapsubmit,
				buttonText: textkeysObj['bonus-claim'],
				cb: callback
			});
			__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].show();
			toggleSelectClass(selectedId);
		} else if (selectedId) {
			__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].changeText(textkeysObj['bonus-continue']);
			var _callback = function cb() {
				submitbtnCallbackForDeposit(selectedId);
			};
			__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].init({
				wrap: elements.wrapsubmit,
				buttonText: textkeysObj['bonus-continue'],
				cb: _callback
			});
			__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].show();
			toggleSelectClass(selectedId);
		}
		showMsgIfEmpty(state.empty);
	},
	updateFreeMoneyBonusSuccess: function updateFreeMoneyBonusSuccess(state) {
		/* Special handling for free money bonus in registration flow */
		deleteAllElements();
		assembleStaticElements();
		var callback = function cb() {
			submitbtnCallbackForFreeMoney(state.bonuses.selected.id);
		};
		__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].init({
			wrap: elements.wrapsubmit,
			buttonText: textkeysObj['bonus-continue'],
			cb: callback
		});
		__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].hide();
		assembleDynamicElements(state.bonuses.by_id);
		addListeners();
	},
	close: function close() {
		removeListeners();
		__WEBPACK_IMPORTED_MODULE_2__view_submitbtn_js__["a" /* default */].close();
		deleteAllElements();
	},

	submitbtnCallbackForFreeMoney: submitbtnCallbackForFreeMoney,
	submitbtnCallbackForDeposit: submitbtnCallbackForDeposit
};

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dispatch; });
/*
	payment/common/lib/utils/dispatcher

	Only named functions with unique name can be registered.
*/

var callback = [];

function isRegistered(cb) {
	/* The some() method tests whether some element in the array passes the test implemented by the provided function.
 the function compares the equality of two functions after convertion to strings. This was introduced since the compressionstep
 during buildprocess deleted the name info.  */
	return callback.some(function (value, key) {
		return callback[key].toString() === cb.toString();
	});
}

function dispatch(payload) {
	callback.forEach(function (cb) {
		cb(payload);
	});
}



/* harmony default export */ __webpack_exports__["b"] = {
	register: function register(cb) {
		if (!isRegistered(cb)) {
			callback.push(cb);
		}
		return callback.length;
	},
	unregister: function unregister(index) {
		delete callback[index];
	},
	dispatch: function dispatch(payload) {
		function handler(cb) {
			cb(payload);
		}
		callback.forEach(handler);
	}
};

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/* payment/commonview/lib/view-confirmationmessage.js */

/* This is an updated extraction of the notifications module to be loaded using commonJS */


var elements = {};
var removeListeners = null;
var confirmationCallback = null;
var confirmButtonText = void 0;
var iconId = null;
var messageText = void 0;
var mainTitleText = void 0;

// TODO; this commented code is kept for a while (oct 14 2016) until autohide is implemented
// function showConfirmationMessage(iconIdentifier, titleText, messageText, buttonText, confirmCallback, effect) {
// 	const $confirmationWrapper = $globalNotificationsContainer.find('.js-confirm-modal');

// 	const titleElement = $confirmationWrapper.find('.js-notify__main-title');

// 	const messageElement = $confirmationWrapper.find('.js-notify__p');

// 	const buttonElement = $confirmationWrapper.find('.js-notify__button-wrapper');
// 	const confirmationCallback = confirmCallback || function empty() {};
// 	const confirmationEffect = (effect && $.inArray(effect, validEffects) >= 0) ? effect : '';
// 	titleElement.text(titleText);
// 	messageElement.text(messageText);
// 	buttonElement.find('button').text(buttonText).removeClass('u-hide')
// 		.addClass('u-show');
// 	$globalNotificationsContainer.addClass('global-notification--is-open');
// 	$confirmationWrapper.addClass(`notify--is-open ${confirmationEffect}`);
// 	/* setTimeout(function () {
// 		$confirmationWrapper.removeClass('notify--is-open');
// 		$(titleElement, messageElement, buttonElement.find('button')).text('');
// 		buttonElement.removeClass('u-show').addClass('u-hide');
// 		}, 3000); */
// 	buttonElement.on('click', (e) => {
// 		e.preventDefault();
// 		confirmationCallback();
// 		closeNotifyWrapper($confirmationWrapper);
// 	});
// }

function selectElements() {
	elements.wrap = elements.wrap || document.querySelector('.js-global-notification');
	/* this wrapper is put into below the #container div and in one occurence per casino, shop and ... */
	elements.wrapSubContent = elements.wrapSubContent || elements.wrap.querySelector('.js-confirm-modal');
	elements.iconWrapper = elements.wrapSubContent.querySelector('.js-notify__icon-wrapper');
	elements.icon = elements.iconWrapper.querySelector('.' + iconId);
	elements.mainTitle = elements.mainTitle || elements.wrapSubContent.querySelector('.js-title');
	elements.mainText = elements.mainText || elements.wrapSubContent.querySelector('.js-text');
	elements.buttonWrapper = elements.buttonWrapper || elements.wrapSubContent.querySelector('.js-notify__button-wrapper');
	elements.buttonElement = elements.buttonElement || elements.buttonWrapper.querySelector('.js-button ');
}

function showIcon() {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.icon, 'u-show');
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.icon, 'u-hide');
}

function setTexts() {
	elements.mainTitle.innerHTML = mainTitleText;
	elements.buttonElement.innerHTML = confirmButtonText;
	elements.mainText.innerHTML = messageText;
}

function openWrappers() {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.wrap, 'global-notification--is-open');
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.wrapSubContent, 'notify--is-open');
}

function closeWrappers() {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.wrap, 'global-notification--is-open');
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.wrapSubContent, 'notify--is-open');
}

function _close() {
	removeListeners();
	closeWrappers();
}

function clickYesHandler() {
	_close();
	confirmationCallback();
}

function addListeners() {
	elements.buttonElement.addEventListener('click', clickYesHandler);
}
/* this function is stored with a name different from the containing variable,
to solve the 'no-shadow' and the 'no use before define' linting rules.
*/
removeListeners = function removeListenersFkn() {
	if (elements && elements.buttonElement) {
		elements.buttonElement.removeEventListener('click', clickYesHandler);
	}
};

/* harmony default export */ __webpack_exports__["a"] = {
	show: function show(iconIdentifier, titleTxt, mainTxt, okBtnTxt, confirmCb) {
		confirmationCallback = confirmCb || function empty() {};
		iconId = iconIdentifier || 'default-success';
		messageText = mainTxt || 'The action you requested could not be fulfilled. Try again later or contact customerservice.';
		confirmButtonText = okBtnTxt || 'Ok';
		mainTitleText = titleTxt || 'Could not complete.';
		selectElements();
		setTexts();
		showIcon();
		addListeners();
		openWrappers();
	},
	close: function close() {
		_close();
	}
};

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
    see test-spec for usecases
*/

function filterAwayNonDigits(str) {
	/* filter away all but 0-9 */
	var nonDigitStr = str && str.replace ? str.replace(/[^(0-9)]/g, '') : '';
	return nonDigitStr;
}

function removeSpace(str) {
	// TODO add unit test to confirm functionality!!
	// remove one or more spaces from beginning and end
	// const trailspace = new RegExp(/^[\s]+|[\s]+$/g);
	var trailspace = new RegExp(/[\s]/g);
	return str && str.replace ? str.replace(trailspace, '') : '';
}

// function stringWithDotsToDecimal(str) {
// 	/* the string is split on decimalpoint,
// 	and its two first values are filtered all
// 	 but digits. This acts as a conversion
// 	 from some input to a two decimal number
// 	 in string format, '0.00'*/
// 	const arr = (str && str.split) && str.split('.');
// 	let first = (arr && arr[0]);
// 	let second = (arr && arr[1]);
// 	first = removeSpace(first);
// 	second = removeSpace(second);
// 	first = filterAwayNonDigits(first);
// 	second = filterAwayNonDigits(second);
// 	first = (first || '0');
// 	second = (second || '00');
// 	second = ((second.length < 2) ? `${second}0` : second);
// 	second = ((second.length > 2) ? `${second[0]}${second[1]}` : second);
// 	const asdecimal = `${first}.${second}`;
// 	return asdecimal;
// }

function hasDecimalPoint(t) {
	var str = (t || t === 0) && t.toString ? t.toString() : null;
	return str && str.match ? str.match(/[.]+/g) : false;
}

function restrictMaxLength(t) {
	// '234' gives '23'
	// '2' gives 2
	// null gives ''
	var str = (t || t === 0) && t.toString ? t.toString() : null;
	var first = str && str[0] ? str[0] : '';
	var second = str && str[1] ? str[1] : '';
	var twoDigitStr = '' + first + second;
	return twoDigitStr;
}

function toDigitsAndDecimalPoint(t) {
	// filter away all but a decimal number from a string
	// append the period if it was input
	// if '23.' is input, return 23.
	// if '23' is input, return 23
	var str = (t || t === 0) && t.toString ? t.toString() : null;
	var containsDecimal = hasDecimalPoint(t);
	var arr = str && str.split && str.split('.');
	var first = arr && arr[0];
	var second = arr && arr[1];
	var nospaceFirst = removeSpace(first);
	var nospaceSecond = removeSpace(second);
	var onlyDigitsFirst = filterAwayNonDigits(nospaceFirst);
	var onlyDigitsSecond = filterAwayNonDigits(nospaceSecond);
	var secondOnlyTwo = restrictMaxLength(onlyDigitsSecond);
	var noLeadingZeros = parseInt(onlyDigitsFirst, 10) || 0;
	noLeadingZeros = noLeadingZeros.toString ? noLeadingZeros.toString() : '0';
	var asdecimal = containsDecimal ? noLeadingZeros + '.' + secondOnlyTwo : '' + noLeadingZeros;
	return asdecimal;
}

/* harmony default export */ __webpack_exports__["a"] = {
	keepDigits: function keepDigits(t) {
		return toDigitsAndDecimalPoint(t);
	},
	__testRemoveSpace: function __testRemoveSpace(str) {
		return removeSpace(str);
	},
	__testFilterAwayNonDigits: function __testFilterAwayNonDigits(str) {
		return filterAwayNonDigits(str);
	},
	__testRestrictMaxLength: function __testRestrictMaxLength(str) {
		return restrictMaxLength(str);
	},
	__testHasDecimalPoint: function __testHasDecimalPoint(str) {
		return hasDecimalPoint(str);
	}
};

// function validAmount() {
// 	const theInput = core.trailspace(elements.inputamount.value || null);
// 	return ((validateCreditcard.amount(theInput) && !containsWord(elements.inputamount.className, errorClass)) ? theInput : null);
// }

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
validate_creditcard

usage:
validate_creditcard.cvc(anyInput)
validate_creditcard.cardnumber(anyInput)
validate_creditcard.cardowner(anyInput)
validate_creditcard.amount(anyInput)
validate_creditcard.day(anyInput)
validate_creditcard.month(anyInput)
validate_creditcard.year(anyInput)


return:
{
    'result': true / false,
    'msg': 'only 3 numbers'
}

*/
function containsOnlyDigits(t) {
	var nums = new RegExp(/^\+?[0-9]+$/);
	return nums.test(t);
}

function hasStringLength(t, n) {
	return t && t.length && t.length === n;
}

function _cardid(t) {
	return containsOnlyDigits(t);
}

function _cvc(t) {
	return hasStringLength(t, 3) && containsOnlyDigits(t);
}

function splitIntoArrOfDigitsBelowTen(t) {
	// convert a number to an array with each number
	// input:1234123412341234
	// output:[1,2,3,4,1,2,3,4,1,2,3,4,1,2,3,4]
	var str = t && t.toString ? t.toString() : null;
	var spl = str ? str.split('') : null;
	var arr = [];
	var L = spl && spl.length ? spl.length : 0;
	for (var i = 0; i < L; i += 1) {
		arr[i] = Number(spl[i]) || 0;
	}
	return arr;
}

function luhnCheck() {
	var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	// argument shall be a number separated into an array: [1,2,3,4]
	// https://en.wikipedia.org/wiki/Luhn_algorithm
	// The formula verifies a number against its included check digit, which is usually appended
	// to a partial account number to generate the full account number. This number must pass the following test:
	// 1.From the rightmost digit, which is the check digit, and moving left, double the value of
	// every second digit. If the result of this doubling operation is greater than 9 (e.g., 8 × 2 = 16), then
	// either...
	// a) add the digits of the product (e.g., 16: 1 + 6 = 7, 18: 1 + 8 = 9)
	// or alternatively...
	// b) subtract 9 from the product (e.g., 16: 16 - 9 = 7, 18: 18 - 9 = 9).
	// 2. Take the sum of all the digits.
	// 3. If the total modulo 10 is equal to 0 (if the total ends in zero) then the number is valid according to the Luhn formula; else it is not valid.
	var L = arr.length;
	var isSecond = true;
	var cDigit = 0;
	var cSum = 0;
	while (L) {
		L -= 1;
		isSecond = !isSecond;
		cDigit = arr[L];
		if (isSecond) {
			cDigit *= 2;
			cDigit = cDigit > 9 ? cDigit - 9 : cDigit;
		}
		cSum += cDigit;
	}
	return cSum && cSum % 10 === 0;
}

var cardtypes = {
	Amex: {
		reg: '^3[47][0-9]{13}$',
		check: true
	},
	AustralianBankcard: {
		reg: '^5610-?[0-9]{4}-?[0-9]{4}-?[0-9]{4}$',
		check: true
	},
	BCGlobal: {
		reg: '^(6541|6556)[0-9]{12}$',
		check: true
	},
	CarteBlanche: {
		reg: '^389[0-9]{11}$',
		check: true
	},
	DinersClub: {
		reg: '^3(?:0[0-5]|[68][0-9])[0-9]{11}$',
		check: true
	},
	DiscoverCard: {
		reg: '^65[4-9][0-9]{13}|64[4-9][0-9]{13}|6011[0-9]{12}|(622(?:12[6-9]|1[3-9][0-9]|[2-8][0-9][0-9]|9[01][0-9]|92[0-5])[0-9]{10})$',
		check: true
	},
	InstaPayment: {
		reg: '^63[7-9][0-9]{13}$',
		check: true
	},
	JCB: {
		reg: '^(?:2131|1800|35[0-9]{3})[0-9]{11}$',
		check: true
	},
	KoreanLocal: {
		reg: '^9[0-9]{15}$',
		check: true
	},
	Laser: {
		reg: '^(6304|6706|6709|6771)[0-9]{12,15}$',
		check: true
	},
	Maestro: {
		reg: '^(?:5[0678][0-9][0-9]|6304|6390|67[0-9][0-9])[0-9]{8,15}$',
		check: true
	},
	Mastercard: {
		reg: '^5[1-5][0-9]{14}$',
		check: true
	},
	Solo: {
		reg: '^(6334|6767)[0-9]{12}|(6334|6767)[0-9]{14}|(6334|6767)[0-9]{15}$',
		check: true
	},
	Switch: {
		reg: '^(4903|4905|4911|4936|6333|6759)[0-9]{12}|(4903|4905|4911|4936|6333|6759)[0-9]{14}|(4903|4905|4911|4936|6333|6759)[0-9]{15}|564182[0-9]{10}|564182[0-9]{12}|564182[0-9]{13}|633110[0-9]{10}|633110[0-9]{12}|633110[0-9]{13}$', // eslint-disable-line max-len
		check: true
	},
	UnionPay: {
		reg: '^(62[0-9]{14,17})$',
		check: true
	},
	Visa: {
		reg: '^4[0-9]{12}(?:[0-9]{3})?$',
		check: true
	},
	VisaMaster: {
		reg: '^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14})$',
		check: true
	}
};

function checkForPatterns() {
	var cardtypesObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var str = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

	/* loop through object, compare regexp to string, if the cardnumber validates to any of the specified patterns
 it is considered valid */
	var validations = [];
	var foundMatch = false;
	Object.keys(cardtypesObj).forEach(function (key) {
		if (cardtypesObj[key].check && cardtypesObj[key].reg) {
			/* compare string to regexp, if not valid type key into console */
			var pattern = new RegExp(cardtypesObj[key].reg);
			var valid = pattern.test(str);
			var info = valid ? key : false;
			foundMatch = valid || foundMatch;
			validations.push(info);
		}
	});
	/*
 // debug-script to print matches to a method
 validations.forEach((elm) => {
 	if (elm) {
 		console.log('match:', str, elm);
 	}
 });*/
	return Boolean(foundMatch);
}

function hasCreditcardFormat(t) {
	var str = t && t.toString ? t.toString() : null;
	var validPattern = checkForPatterns(cardtypes, str);
	var valid = str && validPattern;
	return Boolean(valid);
}

function cardnumber(t) {
	var possibleCard = hasCreditcardFormat(t);
	var splitValue = possibleCard ? splitIntoArrOfDigitsBelowTen(t) : null;
	var validCard = splitValue ? luhnCheck(splitValue) : false;
	return validCard;
}

function cardowner(t) {
	// TODO preliminary method of validation
	// desktopsite: customWordCount 2
	var twowords = new RegExp(/^[a-zåäöA-ZÅÄÖ]{1,20}\s[a-zåäöA-ZÅÄÖ]{1,20}$/);
	return twowords.test(t);
	// return (/^[a-zåäöA-ZÅÄÖ]{1,20}\s[a-zåäöA-ZÅÄÖ]{1,20}$/).test(t);
}

function _month(t) {
	return containsOnlyDigits(t) && parseInt(t, 10) < 13;
}

function _year(t) {
	return containsOnlyDigits(t) && parseInt(t, 10) > 2000 && parseInt(t, 10) < 3000;
}

function noEarlierThan(m, y) {
	var valMonth = _month(m) ? parseInt(m, 10) : null;
	var valYear = _year(y) ? parseInt(y, 10) : null;
	var valid = false;
	var currentYear = new Date().getFullYear();
	var currentMonth = new Date().getMonth();
	if (valMonth && valYear) {
		if (valYear < currentYear) {
			valid = false;
		} else if (valYear === currentYear) {
			/* if the input year is this year, then the month must be minimum this month
   important:
   The months go from 0 - 11 and input might be 1-12*/
			valid = Boolean(valMonth > currentMonth);
		} else {
			valid = true;
		}
	}
	return valid;
}
/* harmony default export */ __webpack_exports__["a"] = {
	cardid: function cardid(t) {
		return _cardid(t);
	},
	cvc: function cvc(t) {
		return _cvc(t);
	},
	number: function number(t) {
		return cardnumber(t);
	},
	owner: function owner(t) {
		return cardowner(t);
	},
	date: function date(m, y) {
		return noEarlierThan(m, y);
	},
	month: function month(t) {
		return _month(t);
	},
	year: function year(t) {
		return _year(t);
	},
	__testHasCreditcardFormat: function __testHasCreditcardFormat(t) {
		return hasCreditcardFormat(t);
	},
	__testSplitIntoArrOfDigitsBelowTen: function __testSplitIntoArrOfDigitsBelowTen(t) {
		return splitIntoArrOfDigitsBelowTen(t);
	},
	__testLuhnCheck: function __testLuhnCheck(t) {
		var splitNum = splitIntoArrOfDigitsBelowTen(t);
		return luhnCheck(splitNum);
	}
};

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return paymentMethodFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createStore; });
function immutableDescriptor(value) {
	return {
		configurable: false,
		enumerable: true,
		writable: true,
		value: value
	};
}

// For example Trustly (direct bank transfer) uses this
function externalHandler(executeWithdrawResult) {
	var handlerInfo = executeWithdrawResult.sendHandlerData.handler;
	var action = handlerInfo.externalUrl;
	var sendData = JSON.parse(handlerInfo.pageGsonParameter);

	var doc = window.document;
	var form = doc.createElement('form');
	form.action = action;
	form.method = 'POST';

	var fd = new FormData();
	Object.keys(sendData).forEach(function (key) {
		fd.append(key, sendData[key]);
	});
	form.formData = fd;
	var body = doc.getElementsByTagName('body')[0];
	body.appendChild(form);
	form.target = '_self';
	form.submit();
}

// {"successful":true,"sendHandlerData":{"sendHandlerData":{"parameterMap":{}},"actualSendHandler":"PENDING_RESULT_AFTER_SINGLE_CALL"},"paymentFetchResultFlow":"/pp?flow\u003dGetWithdrawResult","accHistRef":"ST-0216823301468-369","errorMessage":{"title":"","message":""}}
function resultAfterSingleCallHandler() {}

function pendingAfterSingleCallHandler(executeWithdrawResult) {
	var res = executeWithdrawResult;
	var AHR = 'accHistRef';
	var PFRF = 'paymentFetchResultFlow';
	var accHistParam = AHR + '=' + encodeURIComponent(res[AHR]);
	var resultFetchParam = PFRF + '=' + encodeURIComponent(res[PFRF]);
	window.location = '/payment/result/withdraw?' + accHistParam + '&' + resultFetchParam + '&fetch_type=fetch_type_synch&handlePaymentResultCallback=pendingAfterSingleCallback';
}

function sendHandlerController() {}

function internalPanelHandler() {}

function asynchronousResultAfterSingleCallHandler() {}

function externalWindowIframeHandler() {}

var SEND_HANDLERS = {
	RESULT_AFTER_SINGLE_CALL: resultAfterSingleCallHandler,
	PENDING_RESULT_AFTER_SINGLE_CALL: pendingAfterSingleCallHandler,
	EXTERNAL_PANEL: externalHandler,
	EXTERNAL_WINDOW: externalHandler,
	SEND_HANDLER_CONTROLLER: sendHandlerController,
	INTERNAL_PANEL: internalPanelHandler,
	ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL: asynchronousResultAfterSingleCallHandler,
	EXTERNAL_WINDOW_IFRAME: externalWindowIframeHandler
};

/*
const zeData = {
	"methodId": 23,
	"methodName": "Trustly",
	"methodInfo": "??GLUEPAY_INFO_WITHDRAW??",
	"methodText": "Trustly",
	"executeUrl": "/TrustlyIntegration/executeWithdraw",
	"sendHandlerType": "EXTERNAL_PANEL",
	"logoImgClasses": ["gluepay en_gb"],
	"formTemplateCode": "NO-FIELDS",
	"formTemplateUrlParams": "\u0026paymentMethodId\u003d23\u0026paymentType\u003dwithdraw",
	"paymentType": "withdraw",
	"extraParameters": {}
};
*/
function paymentMethodFactory(methodData) {
	var data = {
		methodId: immutableDescriptor(methodData.methodId),
		methodText: immutableDescriptor(methodData.methodText),
		executeUrl: immutableDescriptor(methodData.executeUrl),
		sendHandlerType: immutableDescriptor(methodData.sendHandlerType),
		logoImgClasses: immutableDescriptor(methodData.logoImgClasses),
		formTemplateCode: immutableDescriptor(methodData.formTemplateCode),
		formTemplateUrl: immutableDescriptor(methodData.formTemplateUrl),
		formTemplateUrlParams: immutableDescriptor(methodData.formTemplateUrlParams),
		extraParameters: immutableDescriptor(methodData.extraParameters),
		accountId: immutableDescriptor(methodData.extraParameters)
	};

	var api = {
		send: function send(executeResult) {
			/*
   const ccExecuteResult = {
   	"successful": true,
   	"sendHandlerData": {
   		"sendHandlerData": { "parameterMap": {} },
   		"actualSendHandler": "PENDING_RESULT_AFTER_SINGLE_CALL"
   	},
   	"paymentFetchResultFlow": "/pp?flow\u003dGetWithdrawResult",
   	"accHistRef": "ST-0216823301468-369",
   	"errorMessage": { "title": "", "message": "" }
   };
   const trustlyExecuteResult = {
   	"successful": true,
   	"sendHandlerData": {
   		"HANDLER_CLASS": "se.cd.web.player.logic.payment.ExternalPanelInformation",
   		"handler": {
   			"externalUrl": "https://test.trustly.com/_/orderclient.php?SessionID\u003dd253f7b9-e034-4564-942c-e52d9b6fb9ee\u0026OrderID\u003d3770537931\u0026Locale\u003den_GB\u0026headerTextKey\u003dEXTERNAL_TRUSTLY_WITHDRAW_PANEL_HEADER",
   			"externalParameters": {},
   			"headerTextKey": "EXTERNAL_TRUSTLY_WITHDRAW_PANEL_HEADER",
   			"openExternalPanelFlow": "providerAmountWithdrawPage",
   			"pageGsonParameter": "{\"max_wd_amount\":\"362.92 SEK\",\"fee_amount\":\"0.00 SEK\",\"min_wd_amount\":\"198.00 SEK\"}",
   			"actualSendHandler": "EXTERNAL_PANEL"
   		}
   	},
   	"paymentFetchResultFlow": "/pp?flow\u003dGetTrustlyWithdrawResult",
   	"accHistRef": "e49119c9-4885-411c-8810-9b864f55fe37",
   	"errorMessage": { "title": "", "message": "" }
   };
   const piq = {
   	"successful": true,
   	"sendHandlerData": {
   		"HANDLER_CLASS": "se.cd.web.player.logic.payment.SendHandlerControllerData",
   		"handler": {
   			"sendHandlerData": { "HANDLER_CLASS": "se.cd.web.player.logic.payment.SendHandlerMap", "handler": { "parameterMap": {} } },
   			"actualSendHandler": "PENDING_RESULT_AFTER_SINGLE_CALL"
   		}
   	},
   	"paymentFetchResultFlow": "/PaymentFormDataService/getWithdrawResultService",
   	"accHistRef": "ST-0217076301791-30",
   	"errorMessage": { "title": "", "message": "" }
   };
   */

			if (!executeResult.successful) {
				throw new Error(executeResult.errorMessage.title + ': ' + executeResult.errorMessage.message);
			}
			var sendHandlerName = executeResult.sendHandlerData.actualSendHandler || executeResult.sendHandlerData.handler.actualSendHandler;
			SEND_HANDLERS[sendHandlerName](executeResult);
		}
	};

	return Object.create(api, data);
}
function createStore() {
	var methodTextReplacementString = {
		'CREDIT-CARD': function CREDITCARD(account) {
			return account.cardNo;
		}
	};
	var props = {
		account: {
			configurable: false,
			enumerable: true,
			writable: true,
			value: undefined
		},
		currency: {
			configurable: false,
			enumerable: true,
			writable: true,
			value: undefined
		},
		method: {
			configurable: false,
			enumerable: true,
			writable: true,
			value: undefined
		}
	};
	var api = {
		// kjbase.payment_method: Trustly, Credit Card...
		setMethod: function setMethod(paymentMethod) {
			this.method = paymentMethod;
			this.account = null;
		},
		getMethod: function getMethod() {
			return this.method;
		},

		/* User may have stored ”accounts” for some payment methods.
   * For the Credit Card method, ”account” would be an actual card (card no, expiry etc)
   */
		setAccount: function setAccount(account) {
			var getString = methodTextReplacementString[this.method.formTemplateCode];
			if (getString) {
				this.method.methodText = getString(account);
			}
			this.account = account;
		},
		getAccount: function getAccount() {
			return this.account;
		},
		setCurrency: function setCurrency(currency) {
			this.currency = currency;
		},
		getCurrency: function getCurrency() {
			return this.currency;
		},
		setLastUsedAmount: function setLastUsedAmount(value) {
			this.lastAmount = value;
		},
		getLastUsedAmount: function getLastUsedAmount() {
			return this.lastAmount;
		}
	};
	return Object.create(api, props);
}



/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getDelayedFormInputHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return validateFormElements; });
function isElementOk(element, validator) {
	if (element.dataset.validatedValue === element.value) {
		return element.dataset.validationResult === 'true';
	}

	var amountValidation = validator(element.value);
	element.dataset.validationResult = amountValidation.inRange;
	element.dataset.isGreaterThanMax = amountValidation.isGreater;
	element.dataset.validatedValue = element.value;

	return element.dataset.validationResult === 'true';
}

// Does not handle groups of inputs, e.g. checkboxes / radio
function validateFormElements(formElement, validators) {
	var validationResult = {
		success: undefined,
		errors: 0,
		fail: {},
		pass: {}
	};

	Object.keys(validators).forEach(function (elementName) {
		var element = formElement[elementName];
		if (element) {
			var validator = validators[element.name];
			if (validator) {
				var scopedValidator = validator.bind(validators);
				var elementOk = isElementOk(element, scopedValidator);
				if (elementOk) {
					validationResult.pass[element.name] = element;
				} else {
					validationResult.fail[element.name] = element;
					validationResult.errors += 1;
				}
			}
		}
	});
	validationResult.ok = validationResult.errors === 0;

	return validationResult;
}

function getDelayedHandler() {
	var timeoutMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 500;

	var delayedHandlerData = {
		TIMEOUT_DELAY_MS: timeoutMs,
		timeoutId: undefined
	};

	var delayedHandler = function delayedHandler(formHandler) {
		if (delayedHandlerData.timeoutId) {
			window.clearTimeout(delayedHandlerData.timeoutId);
		}
		delayedHandlerData.timeoutId = window.setTimeout(formHandler, delayedHandlerData.TIMEOUT_DELAY_MS);
	};
	return delayedHandler;
}

function getDelayedFormInputHandler(formHandler) {
	var timeoutMs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

	var delayedHandlingOf = getDelayedHandler(timeoutMs);

	var delayedFormInputHandler = function delayedFormInputHandler(_formHandler, event) {
		if (event.currentTarget.tagName === 'FORM') {
			event.stopPropagation();

			event.target.dataset.edited = true;
			delayedHandlingOf(_formHandler);
		}
	};
	return delayedFormInputHandler.bind(null, formHandler);
}



/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isBetween; });
/* unused harmony export isEmpty */
/* unused harmony export notEmpty */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return onlyDigits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isGreater; });
function isBetween(value, min, max) {
	return min <= value && value <= max;
}
function isEmpty(value) {
	return value === '';
}
function notEmpty(value) {
	return !this.isEmpty(value);
}
function onlyDigits(value) {
	var onlyDigits = /^\d+$/;
	return onlyDigits.test(value);
}
function isGreater(value, max) {
	return value > max;
}



/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__ = __webpack_require__(13);


function calculateCheckNumber(peselNumber) {
	var a = parseInt(peselNumber.substring(0, 1), 10);
	var b = parseInt(peselNumber.substring(1, 2), 10);
	var c = parseInt(peselNumber.substring(2, 3), 10);
	var d = parseInt(peselNumber.substring(3, 4), 10);
	var e = parseInt(peselNumber.substring(4, 5), 10);
	var f = parseInt(peselNumber.substring(5, 6), 10);
	var g = parseInt(peselNumber.substring(6, 7), 10);
	var h = parseInt(peselNumber.substring(7, 8), 10);
	var i = parseInt(peselNumber.substring(8, 9), 10);
	var j = parseInt(peselNumber.substring(9, 10), 10);

	var sum = a * 1 + b * 3 + c * 7 + d * 9 + e * 1 + f * 3 + g * 7 + h * 9 + i * 1 + j * 3;
	var calculatedChecksum = sum % 10;
	return (10 - calculatedChecksum) % 10;
}

function belongsInArray(elem, array) {
	for (var x = 0; x <= array.length; x += 1) {
		if (array[x] === elem) {
			return true;
		}
	}
	return false;
}

function isValid(peselNumber) {
	if (peselNumber.length !== 11) {
		return false;
	}

	if (peselNumber % 1 !== 0) {
		return false;
	}
	var year = parseInt(peselNumber.substring(0, 2), 10);
	var monthRaw = parseInt(peselNumber.substring(2, 4), 10);
	var month = monthRaw % 20;
	var bigMonth = [1, 3, 5, 7, 8, 10, 12];
	var smallMonth = [4, 6, 9, 11];
	var february = [2];
	var day = peselNumber.substring(4, 6);

	if (belongsInArray(month, bigMonth)) {
		if (parseInt(day, 10) > 31 || parseInt(day, 10) < 1) {
			return false;
		}
	} else if (belongsInArray(month, smallMonth)) {
		if (parseInt(day, 10) > 30 || parseInt(day, 10) < 1) {
			return false;
		}
	} else if (belongsInArray(month, february)) {
		if (year % 100 === 0 && monthRaw === 22) {
			if (parseInt(day, 10) > 29 || parseInt(day, 10) < 1) {
				return false;
			}
		} else if (year % 100 !== 0 && year % 4 === 0) {
			if (parseInt(day, 10) > 29 || parseInt(day, 10) < 1) {
				return false;
			}
		} else if (parseInt(day, 10) > 28 || parseInt(day, 10) < 1) {
			return false;
		}
	} else {
		return false;
	}

	var sumCheck = peselNumber.substring(10);
	var calculatedChecksum = calculateCheckNumber(peselNumber);
	if (calculatedChecksum !== parseInt(sumCheck, 10)) {
		return false;
	}
	return true;
}

function checkPeselFromServer(peselNumber) {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__["a" /* fetchJson */])('/rest/register/personalnumber/pesel/' + peselNumber);
}

function show() {
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__["a" /* fetchJson */])('/pzbuk');
}

/* harmony default export */ __webpack_exports__["a"] = {
	checkPeselFromServer: checkPeselFromServer,
	isValid: isValid,
	show: show
};

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flow_js__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_js__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__floating_labels_js__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__signup_validation_js__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_js__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pesel_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_block_ui_js__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_tomcat_cookies_js__ = __webpack_require__(23);












var instance = void 0;

function Register() {
	var self = this;

	// Restore values saved during registration
	if (__WEBPACK_IMPORTED_MODULE_10__libs_tomcat_cookies_js__["a" /* default */].get('registrationStepOne')) {
		var savedInfo = JSON.parse(__WEBPACK_IMPORTED_MODULE_10__libs_tomcat_cookies_js__["a" /* default */].get('registrationStepOne'));
		document.getElementById('signup-username').value = savedInfo.username;
		document.getElementById('signup-email').value = savedInfo.email;
		document.getElementById('reg-password').value = savedInfo.password;
	}

	__WEBPACK_IMPORTED_MODULE_8__pesel_js__["a" /* default */].show().then(function (shouldShow) {
		var peselElement = document.getElementsByClassName('js-pesel')[0];
		if (shouldShow.result) {
			peselElement.classList.remove('u-hide');
		} else {
			peselElement.remove();
		}
	});
	var view = document.querySelector('.signup');
	this.container = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(view).closest('.js-bottom-wrapper').get(0);
	var changeHeaderWhenScroll = __WEBPACK_IMPORTED_MODULE_6__utils_js__["a" /* default */].debounce(function (event) {
		if (event.target.scrollTop > 25) {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(view).find('.page-head').addClass('page-head--opac');
		} else {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(view).find('.page-head').removeClass('page-head--opac');
		}
	}, 100);

	__WEBPACK_IMPORTED_MODULE_1__flow_js__["a" /* default */].call(this, view, __WEBPACK_IMPORTED_MODULE_3__config_js__["a" /* default */], {
		titleSelector: '.page-head__title',
		stepSelector: '.signup-step',
		openClass: 'u-show',
		openCallback: function openCallback() {
			this.container.classList.add('signup--open');
			this.toggle(this.container.querySelector('.log-in'), false);
		},
		closeCallback: function closeCallback() {
			self = this;
			setTimeout(function () {
				self.container.classList.remove('menu--is-open', 'signup--open');
				self.view.classList.add('signup--is-not');
			}, 250);
		}
	});

	__WEBPACK_IMPORTED_MODULE_4__floating_labels_js__["a" /* default */].setupPersistentLabels(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.view).find('form'));
	__WEBPACK_IMPORTED_MODULE_5__signup_validation_js__["a" /* default */].setupValidation(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.view));
	__WEBPACK_IMPORTED_MODULE_5__signup_validation_js__["a" /* default */].getInfoAndPopulateLists();

	__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.view).find('.signup-step').scroll(changeHeaderWhenScroll);

	__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.view).find('.signup-basic .btn').on('click.signupBasicValidate', function (e) {
		e.preventDefault();

		var blocker = new __WEBPACK_IMPORTED_MODULE_9__utils_block_ui_js__["a" /* default */](self.view.querySelector('.signup-basic form'));
		blocker.show();

		__WEBPACK_IMPORTED_MODULE_5__signup_validation_js__["a" /* default */].validationsServerSideForStepOne(function () {
			return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__store_history_js__["c" /* push */])('/register/details');
		}, function () {
			console.error('step one fail');
		}, function () {
			blocker.destroy();
		});
	});

	__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.view).find('.signup-details .btn').on('click.signupDetailValidate', function (e) {
		e.preventDefault();

		var blocker = new __WEBPACK_IMPORTED_MODULE_9__utils_block_ui_js__["a" /* default */](self.view.querySelector('.signup-details form'));
		blocker.show();

		__WEBPACK_IMPORTED_MODULE_5__signup_validation_js__["a" /* default */].validationsServerSideForStepTwo(function () {
			__WEBPACK_IMPORTED_MODULE_2__notifications_js__["a" /* default */].hideNotification();
			__WEBPACK_IMPORTED_MODULE_5__signup_validation_js__["a" /* default */].resetRegisterForm();
		}, function () {
			console.error('step two fail');
			// TODO Login the user (change icons and populate account menu) get user info with sessionKey
		}, function () {
			blocker.destroy();
		});

		//Remove the values saved during registration.
		if (__WEBPACK_IMPORTED_MODULE_10__libs_tomcat_cookies_js__["a" /* default */].get('registrationStepTwo')) {
			__WEBPACK_IMPORTED_MODULE_10__libs_tomcat_cookies_js__["a" /* default */].remove('registrationStepTwo');
		}
		if (__WEBPACK_IMPORTED_MODULE_10__libs_tomcat_cookies_js__["a" /* default */].get('registrationStepOne')) {
			__WEBPACK_IMPORTED_MODULE_10__libs_tomcat_cookies_js__["a" /* default */].remove('registrationStepOne');
		}
	});

	__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this.view).find('.header-icon--login').on('click.openLogin', function () {
		self.close();
		setTimeout(function () {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__store_history_js__["f" /* replace */])('/login');
		}, 1000);
	});
}

Register.prototype = Object.create(__WEBPACK_IMPORTED_MODULE_1__flow_js__["a" /* default */].prototype);
Register.prototype.constructor = Register;

function get() {
	if (!(instance instanceof Register)) {
		instance = new Register();
	}
	return instance;
}

/* harmony default export */ __webpack_exports__["a"] = get;

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__spinner_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toggle_password_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_js__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__login_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__account_info_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pesel_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_intent_js__ = __webpack_require__(442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__pixel_tracking_pixel_tracking_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__core_ajax_json_js__ = __webpack_require__(13);















var $signUp = {};
var $signUpBasic = void 0;
var $signUpDetails = void 0;
var $mobileVerification = void 0;
var $mobileVerificationButton = void 0;
var $signUpBasicForm = void 0;
var $signUpDetailsForm = void 0;
var $birthDate = void 0;
var $gender = void 0;
var $countryCodeField = void 0;
var $localization = void 0;
var $voucher = void 0;
var countryIsoCode = __WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].locale.substr(__WEBPACK_IMPORTED_MODULE_5__config_js__["a" /* default */].locale.length - 2).toLowerCase();
var player = {};
var $PhNumber = void 0;
var $callingCode = void 0;
var currentMobile = null;
var isMobileVerified = null;
var ERROR_CLASS = 'input-wrap__error';
var VALID_CLASS = 'is-valid';
var MIN_LENGTH_USERNAME = 5;
var MAX_LENGTH_USERNAME = 16;
var MIN_LENGTH_EMAIL = 5;
var MAX_LENGTH_EMAIL = 50;
var MIN_LENGTH_PASSWORD = 6;
var MAX_LENGTH_PASSWORD = 15;
var MIN_LENGTH_NAMES = 2;
var MAX_LENGTH_NAMES = 20;
var MIN_LENGTH_ADDRESS = 2;
var MAX_LENGTH_ADDRESS = 50;
var MIN_LENGTH_CITY = 2;
var MAX_LENGTH_CITY = 30;
var MAX_LENGTH_COUNTRY_CODE = 7;
var DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE = 'content-dynamic-error';
var currentYear = new Date().getFullYear();
var currentMonth = new Date().getMonth() + 1;
var currentDay = new Date().getDate();

//Save the selected values, so they can be restored after clicking T&C.
var selectedValues = {
	year: 0,
	month: 0,
	day: 0,
	gender: 0,
	country: null,
	currency: null
};

/**
 * will display error message in a span under the field
 * @param field, input having an error
 */
function displayError(field, customError) {
	var $inputField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(field);
	var $inputFieldParent = $inputField.parent();
	var errorMessage = customError ? $inputFieldParent.data(customError) : $inputFieldParent.data('content-error');
	if ($inputFieldParent.data('content-dynamic-error') !== undefined) {
		errorMessage = $inputFieldParent.data('content-dynamic-error');
	}
	$inputFieldParent.find('.js-input-error-display').html(errorMessage);
}

/**
 * Add/Remove error class on invalid input field
 * @param $input field
 */
function markInvalid($input, customError) {
	$input.addClass(ERROR_CLASS).removeClass(VALID_CLASS);
	displayError($input, customError);
}

function getMobileNumber($code, $mobile) {
	var callingCode = $code.val();
	var mobile = $mobile.val();
	return '' + callingCode + mobile;
}

function checkUnique(field, flow, value) {
	var $field = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(field);
	var $inputParent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($field).parent();
	var $container = $inputParent.closest('.js-step-container');
	var val = value || $field.val();
	__WEBPACK_IMPORTED_MODULE_1__spinner_js__["a" /* default */].show($container);

	var checkUniquePromise = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		async: true,
		type: 'GET',
		url: '/' + flow + val,
		dataType: 'json',
		contentType: 'application/json; charset=utf-8'
	}).done(function (data) {
		if (data.status === 'SUCCESS') {
			/* && data.result && data.result.value*/
			player[$field.attr('map')] = $field.val();
			$field.removeClass(ERROR_CLASS).addClass(VALID_CLASS);
			$inputParent.removeData(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE);
		} else {
			$field.removeClass(VALID_CLASS).addClass(ERROR_CLASS);
			$inputParent.data(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE, data.errorDescription);
			markInvalid($field);
			displayError($field);
			// notifications.showNotification(`Error: ${flow} FAILED: ${data.errorCode}`, 'red', true);
		}
	}).fail(function (jqXHR, textStatus, errorThrown) {
		console.error(jqXHR, textStatus, errorThrown);
		displayError($field);

		// notifications.showNotification(`Error: ${flow} FAILED${errorThrown}`, 'red', true);
	}).always(function () {
		__WEBPACK_IMPORTED_MODULE_1__spinner_js__["a" /* default */].hide($container);
	});

	return checkUniquePromise;
}

/**
 * Removes error message from span under field
 * @param field to clean
 */
function removeErrorMessage(field) {
	var $inputField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(field);
	var $inputFieldParent = $inputField.parent();
	$inputFieldParent.find('.js-input-error-display').text('');
}

function markValid($input) {
	$input.addClass(VALID_CLASS).removeClass(ERROR_CLASS);
	removeErrorMessage($input);
}

/**
 *
 * @param $field, form input field - jQuery object
 * @param minLength, usually from constants
 * @param maxLength, usually from constants
 * @returns {boolean}
 */
function checkFieldLength($field, minLength, maxLength) {
	return $field.val().length <= maxLength && $field.val().length >= minLength;
}

/**
 *
 * @param $field, form input field - jQuery object
 * @returns {*} - Promise from ajax call in checkUnique
 */
function checkUniqueUsername($field) {
	return checkUnique($field, 'rest/register/username/');
}

function checkUniqueEmail($field) {
	return checkUnique($field, 'rest/register/email/');
}

function adjustPhoneNumber(phoneNumber) {
	return phoneNumber.replace(/^[0]+/, '');
}

function checkUniquePhoneNumber($field1, $field2) {
	var val = $field1.val();
	var str = 'rest/register/phone/' + val + '/';
	return checkUnique($field2, str, adjustPhoneNumber($field2.val()));
}

/**
 * Returns true if value contains letters and numbers
 * @param value, input field value
 * @returns {boolean}
 */
function notOnlyLetters(value) {
	var i = void 0;
	var x = void 0;
	var code = void 0;
	var valid = true;
	var hasAsciiLetter = false;
	var hasNumber = false;

	for (i = 0, x = value.length; i < x; i += 1) {
		code = value.charCodeAt(i);
		// ASCII printable characters without DEL and SPACE http://www.ascii-code.com/
		if (code < 33 || code > 126) {
			valid = false;
			break;
		}
		if (!hasAsciiLetter && (code < 91 && code > 64 || code < 123 && code > 96)) {
			hasAsciiLetter = true;
		} else if (!hasNumber && code > 47 && code < 58) {
			hasNumber = true;
		}
	}
	if (!hasAsciiLetter) {
		valid = false;
	}
	if (valid && !hasNumber) {
		valid = false;
	}
	return valid;
}

function isOnlyLettersSpacesDashes(value) {
	/* refactored to follow common guidelines and linting rules
 saving old code until confirmed ok //Sunny jan 2017*/
	var L = value.length;
	var valid = true;
	for (var i = 0; i < L; i += 1) {
		// for (i = 0, x = value.length; i < x; i += 1) {
		var val1 = value.charCodeAt(i) >= 0 && value.charCodeAt(i) < 32;
		var val2 = value.charCodeAt(i) > 32 && value.charCodeAt(i) < 44;
		var val3 = value.charCodeAt(i) > 45 && value.charCodeAt(i) < 65;
		var val4 = value.charCodeAt(i) > 90 && value.charCodeAt(i) < 97;
		var val5 = value.charCodeAt(i) > 122 && value.charCodeAt(i) < 128;
		var val6 = !isSpacesValid(value);
		var hasNonvalidChars = val1 || val2 || val3 || val4 || val5 || val6;
		if (hasNonvalidChars) {
			valid = false;
		}
	}
	return valid;
}

// REGEX VALIDATIONS
function customEmailValidation(value) {
	return (/^[_A-Za-z0-9-+]+(\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/.test(value)
	);
	// return (/^[_A-Za-z0-9-\+]+(\.[_A-Za-z0-9\-]+)*@[A-Za-z0-9\-]+(\.[A-Za-z0-9]+)*(\.[A-Za-z]{2,})$/).test(value);
}

function isSpacesValid(value) {
	return !/(^\s|\s\s+|\s$)/g.test(value);
}

function isOnlyNumbersAndLetters(value) {
	return (/^[a-zA-Z\d]+$/.test(value)
	);
}

function isOnlyNumbers(value) {
	return (/^[\d]+$/.test(value)
	);
}

function isGenderValid($field) {
	var isValid = false;
	if (Number($field.val()) > 0) {
		markValid($field);
		isValid = true;
	} else {
		markInvalid($field);
	}
	return isValid;
}

function areSecondStepInputFieldsValid() {
	return $signUpDetailsForm.find('input').length === $signUpDetailsForm.find('input.' + VALID_CLASS).length;
}

function areSecondStepSelectFieldsValid() {
	return $signUpDetailsForm.find('select').length === $signUpDetailsForm.find('select.' + VALID_CLASS).length;
}

/**
 * Returns true if all input fields have a VALID_CLASS
 * @returns {boolean}
 */
function isFirstStepFormValid() {
	return $signUpBasicForm.find('input').length === $signUpBasicForm.find('input.' + VALID_CLASS).length;
}

function isSecondStepFormValid() {
	var formValid = false;
	var inputFieldsValid = areSecondStepInputFieldsValid();
	var selectFieldsValid = areSecondStepSelectFieldsValid();

	if (inputFieldsValid && selectFieldsValid) {
		formValid = true;
	}
	return formValid;
}

function enableContinueButton() {
	$signUp.find('#continue').attr('disabled', false);
}

function disableContinueButton() {
	$signUp.find('#continue').attr('disabled', true);
}

function enableOpenAccountButton() {
	$signUp.find('#open-account-button').attr('disabled', false);
}

function disableOpenAccountButton() {
	$signUp.find('#open-account-button').attr('disabled', true);
}

function populatePlayerObject() {
	var $elementsInSecondStep = $signUpDetailsForm.find('input, select');

	$elementsInSecondStep.each(function nameToBeLintvalid() {
		var mappingName = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('map');
		var paramValue = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).val();
		if (mappingName) {
			if (mappingName === 'gender') {
				paramValue = paramValue === '1' ? 'MALE' : 'FEMALE';
			}
			player[mappingName] = paramValue;
		}
	});

	// TODO add deviceId generator and save in localStorage
	player.deviceId = 'mydevice1';
}

/**
 * Validates form fields in step 2 of registration
 * @param field
 * @returns {object}
 */
function validate(field) {
	return new Promise(function (resolve) {
		var $field = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(field);
		var fieldValid = false;

		if ($field.attr('name') === 'PARAM_USR_NAME') {
			if (checkFieldLength($field, MIN_LENGTH_USERNAME, MAX_LENGTH_USERNAME) && isOnlyNumbersAndLetters($field.val())) {
				checkUniqueUsername($field).done(function (data) {
					if (data.status === 'SUCCESS') {
						markValid($field);
						fieldValid = true;
					} else {
						markInvalid($field);
					}
					resolve(fieldValid);
				});
			} else {
				markInvalid($field);
				resolve(fieldValid);
			}
		}

		if ($field.attr('name') === 'PARAM_EMAIL') {
			if (checkFieldLength($field, MIN_LENGTH_EMAIL, MAX_LENGTH_EMAIL) && customEmailValidation($field.val())) {
				checkUniqueEmail($field).done(function (data) {
					if (data.status === 'SUCCESS') {
						markValid($field);
						fieldValid = true;
					} else {
						markInvalid($field);
					}
					resolve(fieldValid);
				});
			} else {
				markInvalid($field);
				resolve(fieldValid);
			}
		}

		if ($field.attr('name') === 'PARAM_USR_PASS') {
			if (checkFieldLength($field, MIN_LENGTH_PASSWORD, MAX_LENGTH_PASSWORD) && notOnlyLetters($field.val())) {
				if ($field.val() === $signUpBasicForm.find('input[name="PARAM_USR_NAME"]').val()) {
					markInvalid($field, 'same-username-error');
				} else {
					markValid($field);
					fieldValid = true;
				}
			} else {
				markInvalid($field);
			}
			resolve(fieldValid);
		}

		// validate first and last name
		if ($field.attr('name') === 'PARAM_FIRST_NAME' || $field.attr('name') === 'PARAM_SURNAME') {
			if (checkFieldLength($field, MIN_LENGTH_NAMES, MAX_LENGTH_NAMES) && isOnlyLettersSpacesDashes($field.val())) {
				markValid($field);
				fieldValid = true;
			} else {
				markInvalid($field);
			}
			resolve(fieldValid);
		}

		if ($field.attr('name') === 'personalnumber') {
			if (checkFieldLength($field, 11, 11) && isOnlyNumbers($field.val()) && __WEBPACK_IMPORTED_MODULE_8__pesel_js__["a" /* default */].isValid($field.val())) {
				__WEBPACK_IMPORTED_MODULE_8__pesel_js__["a" /* default */].checkPeselFromServer($field.val()).then(function (response) {
					if (response.status === 'SUCCESS') {
						markValid($field);
						fieldValid = true;
					} else {
						var $inputParent = __WEBPACK_IMPORTED_MODULE_0_jquery___default()($field).parent();

						$inputParent.data(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE, response.errorDescription);
						markInvalid($field);
						$inputParent.removeData(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE);
					}
					resolve(fieldValid);
				});
			} else {
				markInvalid($field);
				resolve(fieldValid);
			}
		}

		if ($field.attr('name') === 'PARAM_ADDRESS1') {
			if (checkFieldLength($field, MIN_LENGTH_ADDRESS, MAX_LENGTH_ADDRESS) && isSpacesValid($field.val())) {
				markValid($field);
				fieldValid = true;
			} else {
				markInvalid($field);
			}
			resolve(fieldValid);
		}
		if ($field.attr('name') === 'PARAM_POST_CODE') {
			// length rules are the same as first and last name
			if (checkFieldLength($field, MIN_LENGTH_NAMES, MAX_LENGTH_NAMES) && isSpacesValid($field.val())) {
				markValid($field);
				fieldValid = true;
			} else {
				markInvalid($field);
			}
			resolve(fieldValid);
		}
		if ($field.attr('name') === 'PARAM_CITY') {
			if (checkFieldLength($field, MIN_LENGTH_CITY, MAX_LENGTH_CITY) && isOnlyLettersSpacesDashes($field.val())) {
				markValid($field);
				fieldValid = true;
			} else {
				markInvalid($field);
			}
			resolve(fieldValid);
		}
		if ($field.attr('name') === 'PARAM_GENDER') {
			if ($field.val() !== 0 && !isNaN(Number($field.val()))) {
				fieldValid = isGenderValid($field);
			}
			resolve(fieldValid);
		}
		if ($field.attr('name') === 'PARAM_CALLING_CODE') {
			if (!isNaN($field.val())) {
				if ($PhNumber.val() !== '' && currentMobile && currentMobile !== getMobileNumber($field, $PhNumber)) {
					checkUniquePhoneNumber($field, $PhNumber).done(function (data) {
						if (data.status === 'SUCCESS') {
							markValid($PhNumber);
							markValid($field);
							fieldValid = true;
						} else {
							markInvalid($field);
						}
						resolve(fieldValid);
					});
				} else {
					markValid($field);
					fieldValid = true;
					resolve(fieldValid);
				}
			} else {
				markInvalid($field);
				resolve(fieldValid);
			}
		}
		if ($field.attr('name') === 'PARAM_PH_NUMBER') {
			if (!isNaN($field.val())) {
				if ($callingCode.val() !== '' && currentMobile !== getMobileNumber($callingCode, $field)) {
					checkUniquePhoneNumber($callingCode, $field).done(function (data) {
						if (data.status === 'SUCCESS') {
							markValid($callingCode);
							markValid($field);
							fieldValid = true;
						} else {
							markInvalid($field);
						}
						resolve(fieldValid);
					});
				} else {
					markValid($field);
					fieldValid = true;
					resolve(fieldValid);
				}
			} else {
				markInvalid($field);
				resolve(fieldValid);
			}
		}
		if ($field.attr('name') === 'PARAM_BONUS_CODE') {
			// TODO is there any validation here?
			if (!$field.val()) {
				markValid($field);
				fieldValid = true;
			}
			resolve(fieldValid);
		}
	});
}

function setupFocusOutHandlersForFirstStep() {
	function isValid() {
		if (isFirstStepFormValid()) {
			enableContinueButton();
		} else {
			disableContinueButton();
		}
	}

	function callback() {
		var $field = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
		$field.parent().removeData('content-dynamic-error');

		if ($field.val() !== '') {
			validate($field).then(function () {
				isValid();
			});
		} else {
			markInvalid(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
			isValid();
		}
	}

	var instance = new __WEBPACK_IMPORTED_MODULE_9__utils_intent_js__["a" /* default */]();
	var $inputs = $signUpBasicForm.find('input');

	$inputs.on('input.signUpBasic focusout.signUpBasic', function (e) {
		if (e.type === 'focusout') {
			instance.clear();
			callback.call(e.currentTarget);
		} else {
			instance.exec(callback.bind(e.currentTarget));
		}
	});

	$inputs.each(function (i, field) {
		if (field.value.length > 0) {
			callback.call(field);
		}
	});
}

function checkValidationSecondStep() {
	if (isSecondStepFormValid()) {
		populatePlayerObject();
		enableOpenAccountButton();
	} else {
		disableOpenAccountButton();
	}
}

function setupFocusOutHandlersForSecondStep() {
	function callback() {
		var $field = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
		var isRequired = $field.attr('required');
		if ($field.val() !== '') {
			validate($field).then(function () {
				checkValidationSecondStep();
			});
		} else if (isRequired) {
			markInvalid($field);
			checkValidationSecondStep();
		} else {
			checkValidationSecondStep();
		}
	}
	var instance = new __WEBPACK_IMPORTED_MODULE_9__utils_intent_js__["a" /* default */]();
	$signUpDetailsForm.find('input').on('input.signUpDetails focusout.signUpDetails', function (e) {
		if (e.type === 'focusout') {
			instance.clear();
			callback.call(e.currentTarget);
		} else {
			instance.exec(callback.bind(e.currentTarget));
		}
	});
}

function allowedAgeToPlay(isoCode) {
	// returns 21 for Estonia
	return isoCode === 'ee' ? 21 : 18;
}

function maxYearAllowed(isoCode) {
	var allowedAge = allowedAgeToPlay(isoCode);
	return currentYear - allowedAge;
}

function maxMonthAllowed(yearSelected, isoCode) {
	var allowedAge = allowedAgeToPlay(isoCode);
	if (yearSelected === currentYear - allowedAge) {
		$signUpDetailsForm.find('select[name=PARAM_DAY]').parent().removeClass(ERROR_CLASS).addClass(VALID_CLASS);
		$signUpDetailsForm.find('select[name=PARAM_MONTH]').parent().removeClass(ERROR_CLASS).addClass(VALID_CLASS);
		$signUpDetailsForm.find('select[name=PARAM_YEAR]').parent().removeClass(ERROR_CLASS).addClass(VALID_CLASS);
		return currentMonth;
	}
	return 12;
}

function maxDayAllowed(monthSelected, yearSelected, isoCode) {
	if (isoCode === 'ee') {
		if (yearSelected === currentYear - 21 && monthSelected === currentMonth) {
			return currentDay;
		}
		return 31;
	}
	if (yearSelected === currentYear - 18 && monthSelected === currentMonth) {
		return currentDay;
	}
	return 31;
}

function onChangeDateOfBirth() {
	$birthDate.find('select').change(function () {
		getDateOfBirthValues();
	});
}

function getDateOfBirthValues() {
	var $yearField = $birthDate.find('select[name=PARAM_YEAR]');
	var $monthField = $birthDate.find('select[name=PARAM_MONTH]');
	var $dayField = $birthDate.find('select[name=PARAM_DAY]');
	var yearSelected = Number($birthDate.find('select[name=PARAM_YEAR] option:selected').text());
	var monthSelected = Number($birthDate.find('select[name=PARAM_MONTH] option:selected').text());
	var daySelected = Number($birthDate.find('select[name=PARAM_DAY] option:selected').text());
	var isLeap = void 0;

	if (countryIsoCode === '' || countryIsoCode === '**') {
		countryIsoCode = 'se';
	}

	if (!isNaN(yearSelected) && !isNaN(monthSelected) && !isNaN(daySelected)) {
		if (yearSelected > maxYearAllowed(countryIsoCode)) {
			markInvalid($yearField);
		} else if (monthSelected > maxMonthAllowed(yearSelected, countryIsoCode)) {
			markInvalid($monthField);
		} else if (daySelected > maxDayAllowed(monthSelected, yearSelected, countryIsoCode)) {
			markInvalid($dayField);
		} else if ((monthSelected === 4 || monthSelected === 6 || monthSelected === 9 || monthSelected === 11) && daySelected === 31) {
			markInvalid($dayField);
		} else if (monthSelected === 2) {
			isLeap = yearSelected % 4 === 0 && (yearSelected % 100 !== 0 || yearSelected % 400 === 0);
			if (daySelected > 29 || daySelected === 29 && !isLeap) {
				markInvalid($dayField);
			} else {
				selectedValues.year = $yearField.val();
				selectedValues.month = $monthField.val();
				selectedValues.day = $dayField.val();
				__WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__["a" /* default */].set('registrationStepTwo', JSON.stringify(selectedValues));
				markValid($yearField);
				markValid($monthField);
				markValid($dayField);
			}
		} else {
			selectedValues.year = $yearField.val();
			selectedValues.month = $monthField.val();
			selectedValues.day = $dayField.val();
			__WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__["a" /* default */].set('registrationStepTwo', JSON.stringify(selectedValues));
			markValid($yearField);
			markValid($monthField);
			markValid($dayField);
		}
	} else {
		markInvalid($yearField);
		markInvalid($monthField);
		markInvalid($dayField);
	}
	checkValidationSecondStep();
}

function onChangeGenderHandler() {
	$gender.find('select').change(function nameToBeLintvalid2() {
		validateGender(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
	});

	// Not sure where else to put this. Checks if the value has been loaded and validates it.
	if ($gender.find('select[name="PARAM_GENDER"] option:selected').val() !== 0) {
		validateGender($gender.find('select[name="PARAM_GENDER"]'));
	}
}

function validateGender($genderSelected) {
	isGenderValid($genderSelected);
	checkValidationSecondStep();
}

function onChangeLocalization() {
	$localization.find('select').change(function () {
		getLocalizationValues();
	});
}

function getLocalizationValues(check) {
	var $countrySelected = $localization.find('select[name=PARAM_COUNTRY]');
	var $currencySelected = $localization.find('select[name=PARAM_CURRENCY]');
	var countryValid = false;
	var currencyValid = false;

	if ($countrySelected.val() !== '0' && $countrySelected.val().length === 2) {
		countryValid = true;
		selectedValues.country = $countrySelected.val();
		__WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__["a" /* default */].set('registrationStepTwo', JSON.stringify(selectedValues));
		markValid($countrySelected);
	} else {
		markInvalid($countrySelected);
	}
	if ($currencySelected.val() !== '0' && $currencySelected.val().length === 3) {
		currencyValid = true;
		selectedValues.currency = $currencySelected.val();
		__WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__["a" /* default */].set('registrationStepTwo', JSON.stringify(selectedValues));
		markValid($currencySelected);
	} else {
		markInvalid($currencySelected);
	}
	if (countryValid && currencyValid) {
		checkValidationSecondStep();
	}
}

function addOptionsToArray(array, value, textToDisplay, selectedFlag) {
	var opt = document.createElement('option');
	opt.value = opt.innerHTML = value;
	if (textToDisplay) {
		opt.innerHTML = textToDisplay;
	}
	if (selectedFlag) {
		opt.selected = true;
	}
	array.push(opt);
}

function populateCountries(listOfCountries) {
	var countriesArray = [];
	var $countrySelect = $signUpDetailsForm.find('#countries-holder');
	var i = void 0;
	var validateValues = false;

	if (__WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__["a" /* default */].get('registrationStepTwo')) {
		selectedValues = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__["a" /* default */].get('registrationStepTwo'));
		validateValues = true;
	}

	for (i = 0; i < listOfCountries.length; i += 1) {
		if (selectedValues.country) {
			addOptionsToArray(countriesArray, listOfCountries[i].countryCode, listOfCountries[i].text, selectedValues.country === listOfCountries[i].countryCode);
		} else {
			addOptionsToArray(countriesArray, listOfCountries[i].countryCode, listOfCountries[i].text, listOfCountries[i].selected);
		}
	}

	$countrySelect.html('');

	// Append values
	$countrySelect.append(countriesArray);

	if (validateValues && $signUpDetailsForm.find('#currency-holder').length > 1) {
		getLocalizationValues();
	}
}

function populateCurrencies(listOfCurrencies) {
	var currenciesArray = [];
	var $currencySelect = $signUpDetailsForm.find('#currency-holder');
	var i = void 0;
	var validateValues = false;

	if (__WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__["a" /* default */].get('registrationStepTwo')) {
		selectedValues = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__["a" /* default */].get('registrationStepTwo'));
		validateValues = true;
	}

	for (i = 0; i < listOfCurrencies.length; i += 1) {
		if (selectedValues.currency) {
			addOptionsToArray(currenciesArray, listOfCurrencies[i].text, false, selectedValues.currency === listOfCurrencies[i].text);
		} else {
			addOptionsToArray(currenciesArray, listOfCurrencies[i].text, false, listOfCurrencies[i].selected);
		}
	}

	$currencySelect.html('');

	// Append values
	$currencySelect.append(currenciesArray);
	if (validateValues && $signUpDetailsForm.find('#countries-holder').length > 1) {
		getLocalizationValues();
	}
}

function populateCountryCodeIfEnabled(callingcode, isBlacklisted) {
	$countryCodeField.attr('placeholder', callingcode);
	if (isBlacklisted) {
		//TODO needed or fixed by disableCountryCallingCode?
		//Blacklisted countries shouldn't be able to edit.
		disableCountryCallingCode();
	}
	$countryCodeField.val(callingcode);
	$countryCodeField.addClass(VALID_CLASS);
}

function disableCountryCallingCode() {
	$countryCodeField.attr('disabled', 'disabled');
	$localization.find('input[name=PARAM_CALLING_CODE]').parent().addClass('custom-select--disabled');
	$localization.find('input[name=PARAM_CALLING_CODE]').attr('disabled', 'disabled');
}

function disableCountrySelection() {
	$countryCodeField.attr('disabled', 'disabled');
	$localization.find('select[name=PARAM_COUNTRY]').parent().addClass('custom-select--disabled');
	$localization.find('select[name=PARAM_COUNTRY]').attr('disabled', 'disabled');
}

/* function addOptionsToArrayWithSameKayValue(array, value) {
	var opt = document.createElement('option');
	opt.value = opt.innerHTML = value;
	array.push(opt);
	}*/

function setupDateLimits() {

	var maxYear = maxYearAllowed(countryIsoCode);
	var minYear = 1900;
	var $yearField = $birthDate.find('select[name=PARAM_YEAR]');
	var $monthField = $birthDate.find('select[name=PARAM_MONTH]');
	var $dayField = $birthDate.find('select[name=PARAM_DAY]');

	var yearsArray = [];
	var monthsArray = [];
	var daysArray = [];
	var i = void 0;
	var validateValues = false;

	if (__WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__["a" /* default */].get('registrationStepTwo')) {
		selectedValues = JSON.parse(__WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__["a" /* default */].get('registrationStepTwo'));
		validateValues = true;
	}

	// populate year, month and day lists
	for (i = maxYear; i >= minYear; i -= 1) {
		addOptionsToArray(yearsArray, i, null, parseInt(selectedValues.year, 10) === i);
	}
	for (i = 1; i < 13; i += 1) {
		addOptionsToArray(monthsArray, i, null, parseInt(selectedValues.month, 10) === i);
	}
	for (i = 1; i < 32; i += 1) {
		addOptionsToArray(daysArray, i, null, parseInt(selectedValues.day, 10) === i);
	}

	// Append values
	$yearField.append(yearsArray);
	$monthField.append(monthsArray);
	$dayField.append(daysArray);

	if (validateValues) {
		getDateOfBirthValues();
	}
}

function tryRegisterNewUser(playerIn) {
	console.log('Trying to register');
	console.log(playerIn);
	// noinspection JSDuplicatedDeclaration
	var newPlayer = playerIn;
	newPlayer.phoneNumber = adjustPhoneNumber(newPlayer.phoneNumber);
	// $phoneNumber = $($phone).find('input[name=PARAM_PH_NUMBER]'),

	__WEBPACK_IMPORTED_MODULE_1__spinner_js__["a" /* default */].show($signUpDetails);
	disableOpenAccountButton();

	var tryRegisterNewUserPromise = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		async: true,
		type: 'PUT',
		url: '/rest/register/player/',
		data: JSON.stringify(newPlayer),
		dataType: 'json',
		contentType: 'application/json; charset=utf-8'
	}).done(function (data) {
		// const timetoshowresult = 1000; // 1 Second
		if (data.status === 'SUCCESS' && data.result) {
			var title = data.result.map && data.result.map.title || null;
			var message = data.result.map && data.result.map.message || null;
			/* the notification is not directly controlled from here, since it gets overly complex to keep track of the
   mix of timers, global overlaying elements, navigation routing, notifications-module used by many modules and asynchrononus calls.
   The notifications module is therefore extended (temporarily) to keep the information and access it later. /Sunny jan 2017*/
			// notifications.showInformationMessage('success', data.result.map.title, data.result.map.message, null, timetoshowresult);
			__WEBPACK_IMPORTED_MODULE_3__notifications_js__["a" /* default */].storeInfo({
				posting: 'signup-validation',
				type: 'success',
				success: true,
				message: message,
				title: title
			});
			__WEBPACK_IMPORTED_MODULE_6__login_js__["a" /* default */].changeHeaderIcon();
			__WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__["a" /* default */].set('sessionId', data.result.map.sessionKey, { domain: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__store_cookies_js__["e" /* rootDomain */])() });
			__WEBPACK_IMPORTED_MODULE_7__account_info_js__["a" /* default */].getPlayerInfo();
			__WEBPACK_IMPORTED_MODULE_7__account_info_js__["a" /* default */].getPlayerBalance();
			__WEBPACK_IMPORTED_MODULE_7__account_info_js__["a" /* default */].getPlayerPoints();
			__WEBPACK_IMPORTED_MODULE_12__pixel_tracking_pixel_tracking_js__["a" /* default */].push('fullReg');
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__store_history_js__["f" /* replace */])('/account/deposit/bonus?referrer=register');
		} else {
			// TODO Error Handling

			console.error('Signup failed!');

			// Mobile number PLAYER_EXCEPTION_MOBILE_FORMAT_ERROR, PLAYER_EXCEPTION_MOBILE_INVALID_BY_TELESIGN, PLAYER_EXCEPTION_PHONE_EXIST,
			// Country PLAYER_EXCEPTION_INVALID_COUNTRY, PLAYER_EXCEPTION_COUNTRY_STATE_WRONG
			// Currency PLAYER_EXCEPTION_INVALID_CURRENCY

			// PLAYER_EXCEPTION_VALIDATION_ERROR_FIRST_NAME
			// PLAYER_EXCEPTION_VALIDATION_ERROR_LASTNAME
			// PLAYER_EXCEPTION_ESTONIAN_UNDER_AGE
			// PLAYER_EXCEPTION_UNDER_AGE
			// PLAYER_EXCEPTION_PLAYER_EXCEPTION_LEAP_SHORT_MONTH
			// PLAYER_EXCEPTION_VALIDATION_ERROR_GENDER
			// PLAYER_EXCEPTION_VALIDATION_ERROR_ADDRESS1
			// PLAYER_EXCEPTION_VALIDATION_ERROR_POST_CODE
			// PLAYER_EXCEPTION_VALIDATION_ERROR_CITY
			// PLAYER_EXCEPTION_VALIDATION_MOBILE_PHONE_COUNTRY_CODE
			// PLAYER_EXCEPTION_VALIDATION_ERROR_NOT_ALLOWED_COUNTRY

			// Add this ones? PLAYER_EXCEPTION_DUPLICATE_PLAYERS_UK_EXISTS,

			// $phone.removeClass(VALID_CLASS).addClass(ERROR_CLASS);
			// $phone.data(DYNAMIC_ERROR_MESSAGE_DATA_ATTRIBUTE, data.errorDescription);
			__WEBPACK_IMPORTED_MODULE_3__notifications_js__["a" /* default */].showNotification('' + data.errorDescription, 'red', true);
		}
	}).fail(function (jqXHR, textStatus, errorThrown) {
		console.error(jqXHR, textStatus, errorThrown);
		var continueButton = document.getElementsByClassName('js-registration-continue-button');
		__WEBPACK_IMPORTED_MODULE_3__notifications_js__["a" /* default */].showNotification(continueButton[0].getAttribute('data-error-message-ajax-failure'), 'red', true);
	}).always(function () {
		__WEBPACK_IMPORTED_MODULE_1__spinner_js__["a" /* default */].hide($signUp);
		enableContinueButton();
	});

	return tryRegisterNewUserPromise;
}

/**
 * ajax call that will save data in unregistered_players
 * @param player, object with player data
 */
function saveUserData(p) {
	var saveThis = {
		username: p.username,
		password: p.password,
		email: p.email
	};

	__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
		async: true,
		type: 'POST',
		url: '/rest/register/token/',
		data: JSON.stringify(saveThis),
		dataType: 'json',
		contentType: 'application/json; charset=utf-8'
	}).done(function (data) {
		if (data.status === 'SUCCESS') {
			// what to do here?
			console.info('SaveUserData succeeded!');
			//Save to cookies as well in case we need to restore these values again.
			__WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__["a" /* default */].set('registrationStepOne', JSON.stringify({ username: p.username, password: p.password, email: p.email }));
		} else {
			console.error('SaveUserData failed!');
		}
	}).fail(function (jqXHR, textStatus, errorThrown) {
		console.error(jqXHR, textStatus, errorThrown);
		console.error('SaveUserData call failed!');
	});
}

/**
 * will call checkUnique functions to validate fields server side and it will wait for the promise to resolve.
 * @param handleSuccess, success callback
 * @param handleFail, fail callback
 */
function validationsServerSideForStepOne(handleSuccess, handleFail, handleAlways) {
	var $username = $signUpBasicForm.find('input[name="PARAM_USR_NAME"]');
	var $email = $signUpBasicForm.find('input[name="PARAM_EMAIL"]');
	var $pass = $signUpBasicForm.find('input[name="PARAM_USR_PASS"]');

	// it waits for both promises before executing function,
	__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.when(checkUniqueUsername($username), checkUniqueEmail($email), $pass).done(function (args1, args2) {
		// args1 and args2 are arguments resolved for the usernameValid and emailValid ajax requests, respectively.
		// Each argument is an array with the following structure: [ data, statusText, jqXHR ]
		if (args1[0].status === 'SUCCESS' && args2[0].status === 'SUCCESS') {
			// username and email are set inside the ajax call response, if both are success we add the password to player object
			player[$pass.attr('map')] = $pass.val();
			saveUserData(player);
			handleSuccess();
		} else {
			handleFail();
			disableContinueButton();
		}
	}).always(function () {
		if (handleAlways) {
			handleAlways();
		}
	});
}

/**
 *
 * @param handleSuccess, success callback
 * @param handleFail, fail callback
 */
function validationsServerSideForStepTwo(handleSuccess, handleFail, handleAlways) {
	// Will do only one call with the new player info and return an error on the first field failing if any (skip the others)
	__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.when(tryRegisterNewUser(player)).done(function (args) {
		// args is an array with the following structure: [ data, statusText, jqXHR ]
		if (args.status === 'SUCCESS') {
			handleSuccess();
		} else {
			// markFailingField()
			handleFail();
			disableContinueButton();
		}
	}).always(function () {
		if (handleAlways) {
			handleAlways();
		}
	});
}

function setUpVoucherTogglerClick() {
	$voucher.find('.js-voucher__link').on('click', function nameToBeLintvalid3(event) {
		var $voucherField = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).next();
		event.preventDefault();
		$voucher.toggleClass('accordion--is-open');
		$voucherField.toggleClass('u-hide');
	});
}

function countryCodeValidator() {
	$countryCodeField.on('input', function nameToBeLintvalid4() {
		if (this.value.length > MAX_LENGTH_COUNTRY_CODE) {
			this.value = this.value.slice(0, MAX_LENGTH_COUNTRY_CODE);
		}
		checkValidationSecondStep();
	});
}

function markDefaultOptionsAsValid() {
	var $countrySelected = $localization.find('select[name=PARAM_COUNTRY]');
	var $currencySelected = $localization.find('select[name=PARAM_CURRENCY]');

	if ($countrySelected.val() !== '0' && $countrySelected.val().length === 2) {
		markValid($countrySelected);
	}

	if ($currencySelected.val() !== '0' && $currencySelected.val().length === 3) {
		markValid($currencySelected);
	}
}

function getInfoAndPopulateLists() {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__core_ajax_json_js__["a" /* fetchJson */])('/geoip').then(function (geoipData) {
		var geoipResult = JSON.parse(geoipData.result);
		if (geoipData.status === 'SUCCESS') {
			var countryCode = geoipResult.countryCode;

			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__core_ajax_json_js__["a" /* fetchJson */])('/registerbox/?countryCode=' + countryCode).then(function (registerboxData) {
				var countries = {};
				var currencies = {};
				var mapping = registerboxData.result.map;
				if (registerboxData.status === 'SUCCESS') {
					countries = mapping.countries.list;
					currencies = mapping.currencies.list;
					populateCountries(countries);
					populateCurrencies(currencies);
					populateCountryCodeIfEnabled(mapping.callingcode.integer);
					markDefaultOptionsAsValid();
					//Disable calling code and country if blacklisted.
					if (mapping.disablecountrycallingcode.value) {
						disableCountryCallingCode();
						disableCountrySelection();
					}
				} else {
					console.error('Error getting registerbox data in getInfoAndPopulateLists');
				}
			});
		} else {
			console.error('Error getting registerbox data in getInfoAndPopulateLists');
		}
	});
}

function setupFormSelectors(signUp) {
	// var $boxes = signUpAccount.$box.parent();
	$signUpBasic = signUp.find('.signup-basic');
	$signUpDetails = signUp.find('.signup-details');
	$signUpBasicForm = $signUpBasic.find('form');
	$signUpDetailsForm = $signUpDetails.find('form');
	$birthDate = $signUpDetailsForm.find('#birthdate-wrapper-id');
	$gender = $signUpDetailsForm.find('#gender-wrapper-id');
	$countryCodeField = $signUpDetailsForm.find('input[name=PARAM_CALLING_CODE]');
	$localization = $signUpDetailsForm.find('#localization-wrapper-id');
	$voucher = $signUpDetailsForm.find('#voucher-wrapper-id');
	$PhNumber = $signUpDetailsForm.find('input[name="PARAM_PH_NUMBER"]');
	$callingCode = $signUpDetailsForm.find('input[name="PARAM_CALLING_CODE"]');
}

function setUpValidationsStep1() {
	// First step
	setupFocusOutHandlersForFirstStep();
}

function setUpValidationsStep2() {
	// Second step
	setupFocusOutHandlersForSecondStep();
	onChangeDateOfBirth();
	onChangeGenderHandler();
	onChangeLocalization();
	setupDateLimits();
	setUpVoucherTogglerClick();
	countryCodeValidator();
}

function setupValidation(signUp) {
	$signUp = signUp;
	setupFormSelectors($signUp);
	setUpValidationsStep1();
	setUpValidationsStep2();
	__WEBPACK_IMPORTED_MODULE_4__toggle_password_js__["a" /* default */].setupInForm($signUpBasicForm);
}

function isMobileVerificationValid() {
	return $mobileVerification.find('input').length === $mobileVerification.find('input.' + VALID_CLASS).length && (currentMobile !== getMobileNumber($callingCode, $PhNumber) || !isMobileVerified);
}

function setupFocusOutHandlersForMobileVerification() {
	$mobileVerification = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-verify-phone--step-1');
	var $fields = $mobileVerification.find('input');

	function callback() {
		var $field = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
		var isRequired = $field.attr('required');

		function isValid() {
			if (isMobileVerificationValid()) {
				$mobileVerificationButton.attr('disabled', false);
			} else {
				$mobileVerificationButton.attr('disabled', true);
			}
		}

		if ($field.val() !== '') {
			validate($field).then(function () {
				isValid();
			});
		} else if (isRequired) {
			markInvalid($field);
			isValid();
		} else {
			isValid();
		}
	}

	var instance = new __WEBPACK_IMPORTED_MODULE_9__utils_intent_js__["a" /* default */]();

	$fields.on('input.mobileVerification focusout.mobileVerification', function (e) {
		if (e.type === 'focusout') {
			instance.clear();
			callback.call(e.currentTarget);
		} else {
			instance.exec(callback.bind(e.currentTarget));
		}
	});
}

function setupFocusOutHandlersForCodeVerification() {
	var $verifyCode = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-verify_code');
	var $verifyCodeButton = $verifyCode.find('.js-verifymobile');

	$verifyCode.find('#new-code').on('input.mobileVerification', function (e) {
		var $field = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(e.currentTarget);

		if (/^[0-9]{6}$/.test($field.val())) {
			markValid($field);
			$verifyCodeButton.attr('disabled', false);
		} else {
			markInvalid($field);
			$verifyCodeButton.attr('disabled', true);
		}
	});
}

function setupMobileValidation() {
	__WEBPACK_IMPORTED_MODULE_7__account_info_js__["a" /* default */].getPlayerInfo().done(function (resultData) {
		if (resultData.status === 'SUCCESS') {
			$mobileVerification = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-verify-phone--step-1');
			$mobileVerificationButton = $mobileVerification.find('.js-verify-get-code');
			$PhNumber = $mobileVerification.find('#new-phone');
			$callingCode = $mobileVerification.find('#new-phone-cc');
			currentMobile = '' + resultData.result.mobileCountryCode + resultData.result.mobile;
			isMobileVerified = resultData.result.playerVerificationsVO.mobileStatus;
			setupFocusOutHandlersForMobileVerification();
			setupFocusOutHandlersForCodeVerification();
		}

		if (resultData.status === 'FAILURE') {
			console.error(resultData.errorDescription + '. Code: ' + resultData.errorCode);
		}
	});
}

function resetRegisterForm() {
	resetSignupBasicForm();
	resetSignupDetailForm();
	//we do this so that the next time register is opened, we get pre-selected country+currency+country_code
	getInfoAndPopulateLists();
	//and we mark them as valid
	markValid($countryCodeField);
	$signUpDetailsForm.find('#signup-voucher').addClass('is-valid');
	$signUpDetailsForm.find('#states-holder').addClass('is-valid');
	markDefaultOptionsAsValid();
	//we make sure the open account button is disabled on page load
	checkValidationSecondStep();
}

function resetSignupBasicForm() {
	if ($signUpBasicForm && $signUpBasicForm[0] && $signUpBasicForm[0].reset) {
		$signUpBasicForm[0].reset();
	}

	$signUpBasicForm.find('input').each(function (i, e) {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e).removeClass('is-valid');
	});

	disableContinueButton();
}

function resetSignupDetailForm() {
	if ($signUpDetailsForm && $signUpDetailsForm[0] && $signUpDetailsForm[0].reset) {
		$signUpDetailsForm[0].reset();
	}

	//we have to get rid of valid classes in case the form is re-opened without being re-created
	$signUpDetailsForm.find('input').each(function (i, e) {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e).removeClass('is-valid');
	});

	$signUpDetailsForm.find('select').each(function (i, e) {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(e).removeClass('is-valid');
	});
}

var api = {
	setupValidation: setupValidation,
	isFirstStepFormValid: isFirstStepFormValid,
	isSecondStepFormValid: isSecondStepFormValid,
	validationsServerSideForStepOne: validationsServerSideForStepOne,
	validationsServerSideForStepTwo: validationsServerSideForStepTwo,
	getInfoAndPopulateLists: getInfoAndPopulateLists,
	setupMobileValidation: setupMobileValidation,
	resetRegisterForm: resetRegisterForm
};

/* harmony default export */ __webpack_exports__["a"] = api;

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return requestApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return throwError; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var requestApi = function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
		var endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
		var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
		var headers, response, json;
		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						headers = getFetchHeaders(payload, method);
						_context.next = 4;
						return fetch(endpoint, headers);

					case 4:
						response = _context.sent;
						json = response.json();
						return _context.abrupt('return', json);

					case 9:
						_context.prev = 9;
						_context.t0 = _context['catch'](0);

						throwError(_context.t0);

					case 12:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 9]]);
	}));

	return function requestApi() {
		return _ref.apply(this, arguments);
	};
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function getFetchHeaders() {
	var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	var method = arguments[1];

	var headers = {
		headers: {
			'Content-Type': 'application/json; charset=utf-8'
		},
		credentials: 'include'
	};

	if (method === 'GET' || method === 'HEAD') {
		return headers;
	}

	return _extends({}, headers, {
		method: method,
		body: JSON.stringify(payload)
	});
}

function throwError(err) {
	var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

	console.error(err);
	if (message) {
		console.error(message);
	};
}



/***/ }),
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_js__ = __webpack_require__(213);
/* unused harmony export login */
/* unused harmony export logout */
/* unused harmony export lovedGames */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loveGame; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return unLoveGame; });
/* unused harmony export recentGames */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setRecentGames; });
/* unused harmony export sportsbookStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDefaultPath; });
var getDefaultPath = function () {
	var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
		var _ref2, result;

		return regeneratorRuntime.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						_context.prev = 0;
						_context.next = 3;
						return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* requestApi */])(endpoints.site);

					case 3:
						_ref2 = _context.sent;
						result = _ref2.result;
						return _context.abrupt('return', result);

					case 8:
						_context.prev = 8;
						_context.t0 = _context['catch'](0);

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["b" /* throwError */])(_context.t0);

					case 11:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this, [[0, 8]]);
	}));

	return function getDefaultPath() {
		return _ref.apply(this, arguments);
	};
}();
/**
 * @todo following shall be refactored to dry up a bit.
 * For now repetetion will do.
 */


var login = function () {
	var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(payload) {
		var response;
		return regeneratorRuntime.wrap(function _callee2$(_context2) {
			while (1) {
				switch (_context2.prev = _context2.next) {
					case 0:
						_context2.prev = 0;
						_context2.next = 3;
						return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* requestApi */])(endpoints.login, payload, 'POST');

					case 3:
						response = _context2.sent;
						return _context2.abrupt('return', response);

					case 7:
						_context2.prev = 7;
						_context2.t0 = _context2['catch'](0);

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["b" /* throwError */])(_context2.t0);

					case 10:
					case 'end':
						return _context2.stop();
				}
			}
		}, _callee2, this, [[0, 7]]);
	}));

	return function login(_x) {
		return _ref3.apply(this, arguments);
	};
}();

var logout = function () {
	var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(payload) {
		var response;
		return regeneratorRuntime.wrap(function _callee3$(_context3) {
			while (1) {
				switch (_context3.prev = _context3.next) {
					case 0:
						_context3.prev = 0;
						_context3.next = 3;
						return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* requestApi */])(endpoints.logout);

					case 3:
						response = _context3.sent;
						return _context3.abrupt('return', response);

					case 7:
						_context3.prev = 7;
						_context3.t0 = _context3['catch'](0);

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["b" /* throwError */])(_context3.t0);

					case 10:
					case 'end':
						return _context3.stop();
				}
			}
		}, _callee3, this, [[0, 7]]);
	}));

	return function logout(_x2) {
		return _ref4.apply(this, arguments);
	};
}();

var sportsbookStatus = function () {
	var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4() {
		var response;
		return regeneratorRuntime.wrap(function _callee4$(_context4) {
			while (1) {
				switch (_context4.prev = _context4.next) {
					case 0:
						_context4.prev = 0;
						_context4.next = 3;
						return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* requestApi */])(endpoints.sportsbookStatus);

					case 3:
						response = _context4.sent;
						return _context4.abrupt('return', response);

					case 7:
						_context4.prev = 7;
						_context4.t0 = _context4['catch'](0);

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["b" /* throwError */])(_context4.t0);

					case 10:
					case 'end':
						return _context4.stop();
				}
			}
		}, _callee4, this, [[0, 7]]);
	}));

	return function sportsbookStatus() {
		return _ref5.apply(this, arguments);
	};
}();

var lovedGames = function () {
	var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5() {
		var response;
		return regeneratorRuntime.wrap(function _callee5$(_context5) {
			while (1) {
				switch (_context5.prev = _context5.next) {
					case 0:
						_context5.prev = 0;
						_context5.next = 3;
						return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* requestApi */])(endpoints.lovedGames);

					case 3:
						response = _context5.sent;
						return _context5.abrupt('return', response);

					case 7:
						_context5.prev = 7;
						_context5.t0 = _context5['catch'](0);

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["b" /* throwError */])(_context5.t0);

					case 10:
					case 'end':
						return _context5.stop();
				}
			}
		}, _callee5, this, [[0, 7]]);
	}));

	return function lovedGames() {
		return _ref6.apply(this, arguments);
	};
}();

var loveGame = function () {
	var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(payload) {
		var response;
		return regeneratorRuntime.wrap(function _callee6$(_context6) {
			while (1) {
				switch (_context6.prev = _context6.next) {
					case 0:
						_context6.prev = 0;
						_context6.next = 3;
						return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* requestApi */])(endpoints.toggleLoveGame, payload, 'PUT');

					case 3:
						response = _context6.sent;
						return _context6.abrupt('return', response);

					case 7:
						_context6.prev = 7;
						_context6.t0 = _context6['catch'](0);

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["b" /* throwError */])(_context6.t0);

					case 10:
					case 'end':
						return _context6.stop();
				}
			}
		}, _callee6, this, [[0, 7]]);
	}));

	return function loveGame(_x3) {
		return _ref7.apply(this, arguments);
	};
}();

var unLoveGame = function () {
	var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(payload) {
		var response;
		return regeneratorRuntime.wrap(function _callee7$(_context7) {
			while (1) {
				switch (_context7.prev = _context7.next) {
					case 0:
						_context7.prev = 0;
						_context7.next = 3;
						return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* requestApi */])(endpoints.toggleLoveGame, payload, 'DELETE');

					case 3:
						response = _context7.sent;
						_context7.next = 9;
						break;

					case 6:
						_context7.prev = 6;
						_context7.t0 = _context7['catch'](0);

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["b" /* throwError */])(_context7.t0);

					case 9:
					case 'end':
						return _context7.stop();
				}
			}
		}, _callee7, this, [[0, 6]]);
	}));

	return function unLoveGame(_x4) {
		return _ref8.apply(this, arguments);
	};
}();

var recentGames = function () {
	var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8() {
		var response;
		return regeneratorRuntime.wrap(function _callee8$(_context8) {
			while (1) {
				switch (_context8.prev = _context8.next) {
					case 0:
						_context8.prev = 0;
						_context8.next = 3;
						return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* requestApi */])(endpoints.recentGames);

					case 3:
						response = _context8.sent;
						return _context8.abrupt('return', response);

					case 7:
						_context8.prev = 7;
						_context8.t0 = _context8['catch'](0);

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["b" /* throwError */])(_context8.t0);

					case 10:
					case 'end':
						return _context8.stop();
				}
			}
		}, _callee8, this, [[0, 7]]);
	}));

	return function recentGames() {
		return _ref9.apply(this, arguments);
	};
}();

var setRecentGames = function () {
	var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(payload) {
		var response;
		return regeneratorRuntime.wrap(function _callee9$(_context9) {
			while (1) {
				switch (_context9.prev = _context9.next) {
					case 0:
						_context9.prev = 0;
						_context9.next = 3;
						return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["a" /* requestApi */])(endpoints.toggleRecentGames, payload, 'PUT');

					case 3:
						response = _context9.sent;
						return _context9.abrupt('return', response);

					case 7:
						_context9.prev = 7;
						_context9.t0 = _context9['catch'](0);

						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__api_js__["b" /* throwError */])(_context9.t0);

					case 10:
					case 'end':
						return _context9.stop();
				}
			}
		}, _callee9, this, [[0, 7]]);
	}));

	return function setRecentGames(_x5) {
		return _ref10.apply(this, arguments);
	};
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* Refactor
	Don't bundle calls for separate parts of the application in one place.
	Reason: separation of concerns and single responsibility principle
 */


// import config from './../store/index.js';
var host = '/'; // config.siteHostname;

var endpoints = {
	login: host + 'player/session/login',
	logout: host + 'player/session/logout',
	toggleLoveGame: host + 'rest/mygames/lovedgames',
	lovedGames: host + 'rest/mygames/lovedgames/mobile',
	toggleRecentGames: host + 'rest/mygames/recentlyplayedgames',
	recentGames: host + 'rest/mygames/recentlyplayedgames/mobile',
	sportsbookStatus: host + 'sportsbook/status',
	site: host + 'site'
};




/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom_ready_js__ = __webpack_require__(218);


var iframe = void 0;

function nop() {}

var logoutCallback = nop;
var statusCallback = nop;
var refreshCallback = nop;

function isNumeric(n) {
	return !isNaN(parseFloat(n)) && isFinite(n);
}

function changeIframeHeight(data) {
	if (data.newHeight !== undefined && isNumeric(data.newHeight)) {
		iframe.parentNode.style.height = data.newHeight + 'px';
	}
}

function setBetslipItemsCount(data) {
	if (data.newItemsCount !== undefined && isNumeric(data.newItemsCount)) {
		var betslipCounter = document.getElementById('footerlink_bs_count');
		betslipCounter.textContent = data.newItemsCount;
		var bottomWrapper = document.querySelector('.js-bottom-wrapper');
		bottomWrapper.classList.remove('bottom-wrapper--is-hidden');
		var event = new CustomEvent('betsCounterChange');
		betslipCounter.dispatchEvent(event);
	}
}

function setOpenBetsItemCount(data) {
	if (data.openBetsCount !== undefined && isNumeric(data.openBetsCount)) {
		var openBetsCounter = document.getElementById('open_bets_counter');
		openBetsCounter.textContent = data.openBetsCount;
	}
}

function logoutFromIframeHandler() {
	logoutCallback();
}

function statusHandler() {
	statusCallback();
}

function refreshSessionHandler() {
	refreshCallback();
}

var eventHandlers = {
	CHANGE_IFRAME_SIZE_EVENT: changeIframeHeight,
	SET_BETSLIP_ITEMS_EVENT: setBetslipItemsCount,
	SET_OPENBETS_ITEMS_EVENT: setOpenBetsItemCount,
	LOGOUT_FROM_IFRAME_EVENT: logoutFromIframeHandler,
	STATUS_EVENT: statusHandler,
	REFRESH_EVENT: refreshSessionHandler
};

function receiveMessage(event) {
	var data = JSON.parse(event.data);
	console.info('Parent got message: ' + data.eventType, data.eventData);
	if (eventHandlers[data.eventType]) {
		eventHandlers[data.eventType](data.eventData);
	}
}

function status(data) {
	iframe.contentWindow.postMessage(JSON.stringify({
		eventType: 'STATUS_EVENT',
		eventData: {
			status: data
		}
	}), '*');
}

function registerLogoutCallback(logoutFn) {
	logoutCallback = logoutFn;
}

function registerStatusCallback(statusFn) {
	statusCallback = statusFn;
}

function login(token) {
	iframe.contentWindow.postMessage(JSON.stringify({
		eventType: 'LOGIN_EVENT',
		eventData: {
			token: token
		}
	}), '*'); // TODO restrict domains here?
}

function logout() {
	iframe.contentWindow.postMessage(JSON.stringify({
		eventType: 'LOGOUT_EVENT'
	}), '*');
}

function refreshIframe(newHash) {
	var iframeSrc = iframe.src;
	var iframeParent = iframe.parentNode;
	var iframeHeight = iframe.style.height;
	var newIframe = document.createElement('iframe');
	var newUrl = iframeSrc;

	if (newUrl.indexOf('#') >= 0) {
		newUrl = newUrl.substring(0, newUrl.indexOf('#'));
	}
	if (newHash) {
		newUrl = newUrl + '#' + newHash;
	}
	iframeParent.removeChild(iframe);
	newIframe.setAttribute('id', 'sbtech-iframe');
	newIframe.setAttribute('frameborder', '0');
	newIframe.setAttribute('framespacing', '0');
	newIframe.style.height = iframeHeight;
	newIframe.src = newUrl;
	iframeParent.appendChild(newIframe);
	iframe = newIframe;
}

function gotoHome() {
	refreshIframe();
}

function gotoSearch() {
	refreshIframe('search');
}

function gotoBetslip() {
	iframe.contentWindow.postMessage(JSON.stringify({
		eventType: 'GOTO_BETSLIP_EVENT'
	}), '*');
}

function gotoSettings() {
	iframe.contentWindow.postMessage(JSON.stringify({
		eventType: 'GOTO_SETTINGS_EVENT'
	}), '*');
}

function gotoBettingsHistory() {
	iframe.contentWindow.postMessage(JSON.stringify({
		eventType: 'GOTO_BETTING_HISTORY_EVENT'
	}), '*');
}

function init() {
	__WEBPACK_IMPORTED_MODULE_0__utils_dom_ready_js__["a" /* default */].then(function () {
		iframe = document.getElementById('sbtech-iframe');
		if (iframe) {
			window.addEventListener('message', receiveMessage, false);
		}
	});
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: init,
	api: {
		client: {
			login: login,
			logout: logout,
			gotoHome: gotoHome,
			gotoSearch: gotoSearch,
			gotoBetslip: gotoBetslip,
			gotoSettings: gotoSettings,
			gotoBettingsHistory: gotoBettingsHistory,
			registerLogoutCallback: registerLogoutCallback,
			registerStatusCallback: registerStatusCallback,
			status: status
		}
	}
};

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sbtech_api_client_1_0_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_ajax_json_js__ = __webpack_require__(13);



function fetchToken(newLocation) {
	var goToLocation = '/';
	if (newLocation) {
		goToLocation = newLocation;
	}
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_ajax_json_js__["a" /* fetchJson */])('/sportsbook/status').then(function (data) {
		if (data.result.status === 'real') {
			__WEBPACK_IMPORTED_MODULE_0__sbtech_api_client_1_0_js__["a" /* default */].api.client.login(data.result.token);
		} else {
			console.info(data.result);
		}
		window.location.pathname = goToLocation;
	});
}

function getStatus() {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_ajax_json_js__["a" /* fetchJson */])('/sportsbook/status').then(function (data) {
		__WEBPACK_IMPORTED_MODULE_0__sbtech_api_client_1_0_js__["a" /* default */].api.client.status(data.result);
	});
}

/* harmony default export */ __webpack_exports__["a"] = {
	fetchToken: fetchToken,
	getStatus: getStatus
};

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_js__ = __webpack_require__(107);



var togglePassword = {};
var eventType = 'click';

// Toggle Password (show/hide)
togglePassword.setupInForm = function ($form) {
    var $password = $form.find('input[type=password]');
    $form.find('.toggle-password').on(eventType, function () {
        var iconHidePassword = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('svg')[0];
        var iconShowPassword = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('svg')[1];
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(iconHidePassword).attr('class') === 'u-show') {
            $password.attr("type", "text");
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(iconHidePassword).attr('class', 'u-hide');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(iconShowPassword).attr('class', 'u-show');
        } else if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(iconHidePassword).attr('class') === 'u-hide') {
            $password.attr("type", "password");
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('icon-eye-closed-fill').addClass('icon-eye-stroke');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(iconHidePassword).attr('class', 'u-show');
            __WEBPACK_IMPORTED_MODULE_0_jquery___default()(iconShowPassword).attr('class', 'u-hide');
        }
    });
};

/* harmony default export */ __webpack_exports__["a"] = togglePassword;

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var domReady = new Promise(function (resolve, reject) {
	var _document = document,
	    readyState = _document.readyState;


	function onReady() {
		resolve();
		document.removeEventListener('DOMContentLoaded', onReady, true);
		window.removeEventListener('load', onReady, true);
	}

	if (readyState === 'interactive' || readyState === 'complete') {
		resolve(document);
	} else {
		document.addEventListener('DOMContentLoaded', onReady, true);
		window.addEventListener('load', onReady, true);
	}
});

/* harmony default export */ __webpack_exports__["a"] = domReady;

/***/ }),
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_polyfills_js__ = __webpack_require__(443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_globals_js__ = __webpack_require__(441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_android_focus_js__ = __webpack_require__(438);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router_router_js__ = __webpack_require__(434);







/**
 * Entry point for application.
 */

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__router_router_js__["a" /* default */], null), document.querySelector('#app'));

/***/ }),
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_history_js__ = __webpack_require__(6);
/**
 * Created by Fatih on 18.08.2016.
 */




function setPageActive(bool) {
	var $aboutUsPage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.about-menu');
	$aboutUsPage.find('.icon-close').click(function () {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["f" /* replace */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["d" /* basePathname */])());
	});
	if (bool) {
		$aboutUsPage.addClass('menu--is-open');
		setTimeout(function () {
			$aboutUsPage.css('transform', 'initial');
			//this part is for smooth scrolling in iOS
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tabs-container').addClass('u-dn');
			if (window.location.href.indexOf('shop') !== -1) {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pusher').children().each(function () {
					__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('u-dn');
				});
			}
		}, 500);
	} else {
		$aboutUsPage.removeClass('menu--is-open');
		$aboutUsPage.removeAttr('style');
		//this part is for smooth scrolling in iOS
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tabs-container').removeClass('u-dn');
		if (window.location.href.indexOf('shop') !== -1) {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pusher').children().each(function () {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('u-dn');
			});
		}
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	setPageActive: setPageActive
};

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__account_info_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_settings_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_history_js__ = __webpack_require__(6);
/*jslint browser: true, devel:true */
/*global define*/







var mobile = void 0;
var mobileCountryCode = void 0;
var $myAccountSettings = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.my-account-notifications');
var $verifyPhoneNumberWrapper = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-verify_phone-number');
var $editPhoneNumberWrapper = $myAccountSettings.find('.js-edit_phone-number');
var $verifyCodeWrapper = $verifyPhoneNumberWrapper.find('.js-verify_code');
var $editPhoneNumberForm = $editPhoneNumberWrapper.find('form');
var $numberToVerifyCC = $verifyPhoneNumberWrapper.find('.phone-number-cc-to-verify');
var $numberToVerify = $verifyPhoneNumberWrapper.find('.phone-number-to-verify');
var data = void 0;

function updatePhone(number) {
	var deferred = void 0;
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["c" /* sessionKey */])() && number) {
		deferred = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
			url: '/player/phone',
			type: 'POST',
			data: JSON.stringify(number),
			contentType: 'application/json; charset=utf-8'
		});
	}

	return deferred;
}

function changePhoneNumber(changeMessage) {
	mobile = $editPhoneNumberForm.find("input[id='new-phone']").val();
	mobileCountryCode = $editPhoneNumberForm.find("input[id='new-phone-cc']").val();

	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["c" /* sessionKey */])()) {
		data = {
			mobile: mobile,
			mobileCountryCode: mobileCountryCode
		};
		console.info('init changePhoneNumber ' + data.mobileCountryCode + data.mobile);

		updatePhone(data).done(function (resultData) {
			if (resultData.status === 'SUCCESS' && resultData.result) {
				__WEBPACK_IMPORTED_MODULE_2__notifications_js__["a" /* default */].showNotification(changeMessage, 'green', true);
				$numberToVerify.text(mobile);
				$numberToVerifyCC.text(mobileCountryCode);
				$editPhoneNumberWrapper.removeClass('notify--is-open');
			}
			if (resultData.status === 'FAILURE') {
				__WEBPACK_IMPORTED_MODULE_2__notifications_js__["a" /* default */].showNotification(resultData.errorDescription, 'red', true);
				console.error('Error changePhoneNumber ' + resultData.errorDescription + '. Code: ' + resultData.errorCode);
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.error(jqXHR, textStatus, errorThrown);
		});
	}
}

function sendSMSVerifyPhoneNumber() {
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["c" /* sessionKey */])()) {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
			url: '/player/phone/verify/',
			type: 'POST',
			contentType: 'application/json; charset=utf-8'
		}).done(function (resultData) {
			if (resultData.status === 'SUCCESS' && resultData.result) {
				// Show green notification and display Verify Code screen
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_history_js__["c" /* push */])('/account/mysettings/verify-mobile/enter-code');
			}
			if (resultData.status === 'FAILURE') {
				//will this ever fail?
				__WEBPACK_IMPORTED_MODULE_2__notifications_js__["a" /* default */].showNotification(resultData.errorDescription, 'red', true);
				console.error('Error sendSMSVerifyPhoneNumber ' + resultData.errorDescription + '. Code: ' + resultData.errorCode);
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.error(jqXHR, textStatus, errorThrown);
		});
	}
}

function verifyPhoneNumber() {
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["c" /* sessionKey */])()) {
		var code = $verifyCodeWrapper.find("input[id='new-code']").val();
		__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
			url: '/player/phone/verify/' + code,
			type: 'GET',
			contentType: 'application/json; charset=utf-8'
		}).done(function (resultData) {
			if (resultData.status === 'SUCCESS' && resultData.result) {
				__WEBPACK_IMPORTED_MODULE_1__account_info_js__["a" /* default */].setVerificationNumber(true);
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_history_js__["c" /* push */])('/account/mysettings/verify-mobile/verified');
			}
			if (resultData.status === 'FAILURE') {
				console.error('Error verifyPhoneNumber ' + resultData.errorDescription + '. Code: ' + resultData.errorCode);
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_history_js__["c" /* push */])('/account/mysettings/verify-mobile/error');
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.error(jqXHR, textStatus, errorThrown);
		});
	}
}

function openVerifyCode() {
	sendSMSVerifyPhoneNumber();
}

function setMobileVerifyPageActive(bool) {
	// we want to make sure the first item shown is the info menu
	// not the code verification menu
	$verifyCodeWrapper.removeClass('notify--is-open');
	if (bool) {
		$myAccountSettings.addClass('my-account-notifications--is-open');
		$verifyPhoneNumberWrapper.addClass('notify--is-open');
		$verifyCodeWrapper.removeClass('notify--is-open');
		sendSMSVerifyPhoneNumber();
	} else {
		$myAccountSettings.removeClass('my-account-notifications--is-open');
		$verifyPhoneNumberWrapper.removeClass('notify--is-open');
	}
}

__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.js-verify-get-code').on('click.verifyPhone', function () {

	mobile = $verifyPhoneNumberWrapper.find("input[id='new-phone']").val();
	mobileCountryCode = $verifyPhoneNumberWrapper.find("input[id='new-phone-cc']").val();

	data = {
		mobile: mobile,
		mobileCountryCode: mobileCountryCode
	};

	var phoneData = $verifyPhoneNumberWrapper.data();

	__WEBPACK_IMPORTED_MODULE_1__account_info_js__["a" /* default */].fetchPlayerInfo().then(function (resultData) {
		if (resultData.status === 'SUCCESS') {
			if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["c" /* sessionKey */])() && !(data.mobile === phoneData.mobile && data.mobileCountryCode === phoneData.mobileCountryCode)) {
				updatePhone(data).done(function (resultData) {
					if (resultData.status === 'SUCCESS' && resultData.result) {
						openVerifyCode();
					}
					if (resultData.status === 'FAILURE') {
						__WEBPACK_IMPORTED_MODULE_2__notifications_js__["a" /* default */].showNotification(resultData.errorDescription, 'red', true);
					}
				});
			} else {
				openVerifyCode();
			}
		}
	});
});

// Account setting mobile number
// opens the modal window for verify phone number
// we no longer need this event
// navigation directs the user to verify_number page

// open verify number
$verifyPhoneNumberWrapper.find('.js-edit_verifymobile').on(__WEBPACK_IMPORTED_MODULE_3__config_settings_js__["a" /* eventType */], function () {
	$verifyCodeWrapper.addClass('notify--is-open');
	return false;
});

// open edit phone number
$verifyPhoneNumberWrapper.find('.js-editphone').on(__WEBPACK_IMPORTED_MODULE_3__config_settings_js__["a" /* eventType */], function () {
	$editPhoneNumberWrapper.addClass('notify--is-open');
	return false;
});

// change phone number
$editPhoneNumberWrapper.find('.js-changephone').on(__WEBPACK_IMPORTED_MODULE_3__config_settings_js__["a" /* eventType */], function () {
	var changeMessage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).data('message');
	changePhoneNumber(changeMessage);
	return false;
});

// send sms
$verifyPhoneNumberWrapper.find('.js-resendsms').on(__WEBPACK_IMPORTED_MODULE_3__config_settings_js__["a" /* eventType */], function () {
	sendSMSVerifyPhoneNumber();
	return false;
});

// verify number
$verifyCodeWrapper.find('.js-verifymobile').on(__WEBPACK_IMPORTED_MODULE_3__config_settings_js__["a" /* eventType */], function () {
	verifyPhoneNumber();
	return false;
});

// TODO REMOVE THIS CLICKHANDLERS AND ADD THEM TO ROUTER.JS WHEN NAVIGATION IS COMPLETED
$verifyPhoneNumberWrapper.find('.js-icon-close').on(__WEBPACK_IMPORTED_MODULE_3__config_settings_js__["a" /* eventType */], function () {
	// we use window.history.back because we will allow users to enter the mobile verification flow from any other flow
	// therefore we want users to be able to go back to where they came from when they close this menu


	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_history_js__["f" /* replace */])('/account');
});

$editPhoneNumberWrapper.find('.js-icon-close').on(__WEBPACK_IMPORTED_MODULE_3__config_settings_js__["a" /* eventType */], function () {
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).parent().removeClass('notify--is-open');
	return false;
});

$verifyCodeWrapper.find('.js-icon-close').on(__WEBPACK_IMPORTED_MODULE_3__config_settings_js__["a" /* eventType */], function () {
	$myAccountSettings.removeClass('notify--is-open');
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_history_js__["f" /* replace */])('/account');
	//push('/account');
	return false;
});

/* unused harmony default export */ var _unused_webpack_default_export = {
	changePhoneNumber: changePhoneNumber,
	sendSMSVerifyPhoneNumber: sendSMSVerifyPhoneNumber,
	verifyPhoneNumber: verifyPhoneNumber,
	setMobileVerifyPageActive: setMobileVerifyPageActive
};

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/*jslint browser: true, devel:true */
/*global define, G_vmlCanvasManager*/



var activeBonus = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.active-bonus');

activeBonus.each(function () {
    var canvas = document.createElement('canvas');
    var span = document.createElement('span');
    var ctx = void 0;
    var radius = void 0;
    var drawCircle = void 0;

    var options = {
        percent: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('data-percent'),
        size: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('data-size') || 70,
        lineWidth: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('data-line') || 2
    };

    span.textContent = options.percent + '%';

    if (window.G_vmlCanvasManager) {
        window.G_vmlCanvasManager.initElement(canvas);
    }

    ctx = canvas.getContext('2d');
    canvas.width = canvas.height = options.size;

    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).prepend(span);
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).prepend(canvas);

    ctx.translate(options.size / 2, options.size / 2); // change center

    radius = (options.size - options.lineWidth) / 2;

    drawCircle = function drawCircle(color, lineWidth, percent) {
        percent = Math.min(Math.max(0, percent || 1), 1);
        ctx.beginPath();
        ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false);
        ctx.strokeStyle = color;
        ctx.lineCap = 'round';
        ctx.lineWidth = lineWidth;
        ctx.stroke();
    };

    drawCircle('#525252', options.lineWidth, 1);
    drawCircle('#8eb50d', options.lineWidth, options.percent / 100);
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_settings_js__ = __webpack_require__(29);



function setHandlersForCampaigns() {
	var $exploreContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#section1');
	var $campaignItems = $exploreContainer.find('.campaign__item');
	$campaignItems.each(function (i) {
		$campaignItems.eq(i).on(__WEBPACK_IMPORTED_MODULE_1__config_settings_js__["a" /* eventType */], function (e) {
			e.stopPropagation();
			e.preventDefault();
			if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('popup') === 'false') {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()(location).attr('href', __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('campaign-url'));
			} else {
				window.open(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('campaign-url'), '_blank');
			}
		});
	});
}

/* harmony default export */ __webpack_exports__["a"] = {
	setHandlersForCampaigns: setHandlersForCampaigns
};

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slick_carousel__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_slick_carousel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_slick_carousel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bundles_js__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__winners_js__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__campaigns_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_tabs_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jackpot_render_js__ = __webpack_require__(197);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return destroy; });








function setupGallery() {
	var $exploreContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#section1');
	$exploreContainer.find('.gallery').each(function slickGallery() {
		var $cells = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('.gallery__cell');
		var galleryLength = $cells.length;

		if (galleryLength > 0) {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).slick({
				lazyLoad: 'ondemand',
				slidesToShow: 2,
				variableWidth: true,
				arrows: false,
				mobileFirst: true,
				initialSlide: 1,
				infinite: true
			});
			// we make sure we have minimum of 4 items on bundles
			// in order for the carousels to work properly

			var i = 0;

			while (galleryLength < 4) {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).slick('slickAdd', $cells[i % $cells.length].outerHTML);
				galleryLength += 1;
				i += 1;
			}
		}
	});

	// we unhide the carousels because they are initialized at this point
	// and get rid of the loading div
	$exploreContainer.find('.winner-carousel, .bundle-carousel').each(function unHideCarousel() {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('.spinner').remove();
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('.gallery').removeClass('u-hide');
	});
}

function destroy() {
	var $exploreContainer = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#section1');
	$exploreContainer.find('.gallery').each(function slickGallery() {
		var $slickItem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
		if ($slickItem.hasClass('slick-initialized')) {
			$slickItem.slick('unslick');
		}
	});
}

function init(exploreElement) {
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__jackpot_render_js__["a" /* setupJackpot */])(exploreElement);
	setupGallery();
	__WEBPACK_IMPORTED_MODULE_2__bundles_js__["a" /* default */].moveBundles();
	__WEBPACK_IMPORTED_MODULE_3__winners_js__["a" /* default */].setupWinnerItems();
	__WEBPACK_IMPORTED_MODULE_4__campaigns_js__["a" /* default */].setHandlersForCampaigns();
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__libs_tabs_js__["a" /* open */])('section1');
}



/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_settings_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__selectors_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__casino_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mygames_js__ = __webpack_require__(80);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return destroy; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








var prevScrollPos = [0, 0];
var scrollEvent = new UIEvent('scroll', {
	view: window,
	bubbles: true,
	cancelable: true
});

function setPreviousScrollPos(x, y) {
	prevScrollPos[0] = x;
	prevScrollPos[1] = y;
}

/* Refactor
	The rendering part is the same as in allgames.js - don't duplicate
	The rest belongs in other functions

 */
function render() {
	/* Refator
 	providerSelector in selectors.js already provides this functionality...
  */
	if (!__WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* store */].get().filters.provider) {
		return;
	}

	var providerGames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__selectors_js__["b" /* providerSelector */])(__WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* store */].get());

	if (providerGames.length > 0) {
		var name = providerGames[0].provider.name;

		document.getElementById('provider-title').textContent = name;
	}

	setPreviousScrollPos(window.scrollX, window.scrollY);
	var $tabsContainer = document.getElementsByClassName('tabs-container')[0];
	setTimeout(function () {
		$tabsContainer.classList.add('u-dn');
	}, 500);

	var providerGamesGrid = document.getElementById('provider-game-grid');
	var gamesTemplate = __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* store */].get().templates.games;
	var templateContext = _extends({}, __WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* store */].get().gameResource, {
		gameData: {
			all: providerGames
		}
	});
	var gamesHtml = gamesTemplate(templateContext);
	providerGamesGrid.innerHTML = gamesHtml;

	var providerContainer = document.getElementsByClassName('games-by-provider-container')[0];
	providerContainer.classList.add('games-by-provider-container--is-open');
	setTimeout(function () {
		providerContainer.classList.add('u-transform-none');
	}, 300);

	return;
}

function bindScrollToWindow() {
	window.dispatchEvent(scrollEvent);
}

function destroy() {
	var providerContainer = document.getElementsByClassName('games-by-provider-container')[0];
	var closeButton = providerContainer.getElementsByClassName('icon-close')[0];
	closeButton.removeEventListener(__WEBPACK_IMPORTED_MODULE_0__config_settings_js__["a" /* eventType */], destroy);
	//providerContainer.removeEventListener('scroll', bindScrollToWindow);

	providerContainer.removeEventListener('click', __WEBPACK_IMPORTED_MODULE_4__casino_js__["b" /* processDoubleEvents */]);
	providerContainer.removeEventListener('click', __WEBPACK_IMPORTED_MODULE_4__casino_js__["c" /* processSupportNavEvents */]);

	providerContainer.classList.remove('games-by-provider-container--is-open', 'u-transform-none');
	var $tabsContainer = document.getElementsByClassName('tabs-container')[0];
	$tabsContainer.classList.remove('u-dn');
	window.scrollTo(prevScrollPos[0], prevScrollPos[1]);
	__WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* store */].get().filters.set({ provider: '' });
}

function initEventListners() {
	var providerContainer = document.getElementsByClassName('games-by-provider-container')[0];
	var closeButton = providerContainer.getElementsByClassName('icon-close')[0];
	closeButton.addEventListener(__WEBPACK_IMPORTED_MODULE_0__config_settings_js__["a" /* eventType */], __WEBPACK_IMPORTED_MODULE_3__store_history_js__["e" /* pushBack */]);
	//providerContainer.addEventListener('scroll', bindScrollToWindow, { passive: true });

	providerContainer.removeEventListener('click', __WEBPACK_IMPORTED_MODULE_4__casino_js__["b" /* processDoubleEvents */]);
	providerContainer.removeEventListener('click', __WEBPACK_IMPORTED_MODULE_4__casino_js__["c" /* processSupportNavEvents */]);
	providerContainer.removeEventListener('click', __WEBPACK_IMPORTED_MODULE_5__mygames_js__["c" /* handleLoveEvents */]);

	providerContainer.addEventListener('click', __WEBPACK_IMPORTED_MODULE_4__casino_js__["b" /* processDoubleEvents */]);
	providerContainer.addEventListener('click', __WEBPACK_IMPORTED_MODULE_4__casino_js__["c" /* processSupportNavEvents */]);
	providerContainer.addEventListener('click', __WEBPACK_IMPORTED_MODULE_5__mygames_js__["c" /* handleLoveEvents */]);
}

__WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* store */].on('update', function (currentState, prevState) {
	if (currentState !== prevState) {
		render();
	}
});

function init(providerCode) {
	initEventListners();
	__WEBPACK_IMPORTED_MODULE_1__store_js__["a" /* store */].get().filters.set({ provider: providerCode });
	render();
}



/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function loadGameWithScript(optionParams) {
	var token = optionParams.token;
	var gameContainer = document.getElementById('gameloader');

	var options = {
		operator: optionParams.operator,
		language: optionParams.language,
		environment: optionParams.environment,
		currency: optionParams.currency,
		game: optionParams.game,
		device: 'mobile',
		target: gameContainer
	};

	gameContainer.setAttribute('style', 'display:block;background: #000;position: absolute;top: 0;right: 0;left: 0;bottom: 0;z-index: 100000;');

	if (!(!token || token.length === 0)) {
		options.token = token;
	}

	var api = nolimit.load(options);

	api.on('exit', function () {
		history.back();
	});
}

function load(params) {
	var script = document.getElementById('nolimit');
	if (script === null) {
		script = document.createElement('script');
		script.src = '//nolimitcity.github.io/nolimit.js/dist/nolimit-latest.min.js';
		script.id = 'nolimit';
		document.getElementsByTagName('head')[0].appendChild(script);
		if (script.readyState) {
			script.onreadystatechange = function () {
				if (script.readyState === 'loaded' || script.readyState === 'complete') {
					script.onreadystatechange = null;
					loadGameWithScript(params);
				}
			};
		} else {
			script.onload = function () {
				loadGameWithScript(params);
			};
		}
	} else {
		loadGameWithScript(params);
	}
}

/* harmony default export */ __webpack_exports__["a"] = { load: load };

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nolimit_js__ = __webpack_require__(310);


var providers = {
	nolimitcity: __WEBPACK_IMPORTED_MODULE_0__nolimit_js__["a" /* default */]
};

function load(providerAndParametersString) {
	var providerAndParameters = JSON.parse(providerAndParametersString);
	providers[providerAndParameters.provider].load(providerAndParameters.parameters);
}

/* harmony default export */ __webpack_exports__["a"] = { load: load };

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jets__ = __webpack_require__(589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jets___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jets__);


var selectors = {
	input: '',
	content: ''
};
var elements = void 0;
var INPUT = 'input';
var CLICK = 'click';
var TOUCHSTART = 'touchstart';
var inputHandler = void 0;
var clickHandler = void 0;
var touchstartHandler = void 0;
var bodyHandler = void 0;
var bodyElm = void 0;
var jetsSearch = void 0;

function setupJets(inputSelector, contentWrapSelector) {
	var jets = new __WEBPACK_IMPORTED_MODULE_0_jets___default.a({
		searchTag: inputSelector,
		contentTag: contentWrapSelector
	});
	return jets;
}

function addHandler(elm, type, cb, capture) {
	var handler = function handler(e) {
		if (cb) {
			cb(e);
		}
	};
	elm.addEventListener(type, handler, capture);
	return handler;
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(p) {
		/* initialize with selectors for search-input-field and content-wrapper,
   * currently for example with '.search .search__input', and '#section2 .game-grid'
   * forother requirements and settings: see the imported module 'Jets' */
		selectors.input = p.input;
		selectors.content = p.content;
		/*
  TODO: create all elements dynamically to quit the dependency on selectors
  * then only provide the contentWrapSelector, and the module using this
  * module may insert the wrapping element
  */
		var wrap = document.querySelector('.search'); // see mustache file header.mustache
		var input = document.querySelector(selectors.input); // this element is created in mustache, but can be generated dynamically to detach a dependency on the searchpath from the arguments
		var activeicon = document.querySelector('.search__search-lens'); // this element is created in mustache, but can be generated dynamically
		var clearicon = document.querySelector('.search__search-clear'); // this element is created in mustache, but can be generated dynamically
		var hide = 'u-hide';
		var expand = 'search--expanded';
		bodyElm = document.querySelector('body');
		elements = {
			wrap: wrap,
			input: input,
			activeicon: activeicon,
			clearicon: clearicon
		};

		function activateField() {
			elements.wrap.classList.add(expand);
			elements.activeicon.classList.remove(hide);
		}

		function deactivateField() {
			elements.wrap.classList.remove(expand);
			elements.activeicon.classList.add(hide);
		}
		function clearSearch() {
			/* update the search with empty value to display all items and clean the searchfield */
			elements.input.value = '';
			elements.input.focus();
			jetsSearch.search();
			clearicon.classList.add(hide);
		}

		function showClearicon(e) {
			window.lazySizes.loader.checkElems();
			if (!e.target.value) {
				clearicon.classList.add(hide);
				return;
			}
			clearicon.classList.remove(hide);
		}

		function touchstartCb(e) {
			activateField();
			e.stopPropagation();
		}

		function bodytouchCb(e) {
			deactivateField();
		}

		// TODO: the touch-events may be completed to handler pointer-events and
		// later a desktop-solution may acivate the field without touch at all
		inputHandler = addHandler(elements.wrap, INPUT, showClearicon);
		clickHandler = addHandler(elements.clearicon, CLICK, clearSearch);
		touchstartHandler = addHandler(elements.wrap, TOUCHSTART, touchstartCb);
		bodyHandler = addHandler(bodyElm, TOUCHSTART, bodytouchCb);
	},
	setup: function setup() {
		if (jetsSearch) {
			jetsSearch.update();
		} else {
			jetsSearch = setupJets(selectors.input, selectors.content);
		}
	},
	close: function close() {
		elements.wrap.removeEventListener(INPUT, inputHandler);
		elements.clearicon.removeEventListener(CLICK, clickHandler);
		elements.wrap.removeEventListener(TOUCHSTART, touchstartHandler);
		bodyElm.removeEventListener(TOUCHSTART, bodyHandler);
		jetsSearch = null;
	}
};

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


var $allGameElements = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#section2').find('.game-item');
var $winnerCarousels = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#section1').find('.winner-carousel');

function isScrolledIntoView(elem) {
	var $elem = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(elem);
	var $window = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(window);
	var docViewTop = $window.scrollTop();
	var docViewBottom = docViewTop + $window.height();
	var elemTop = $elem.offset().top;
	var elemBottom = elemTop + $elem.height();

	return elemBottom <= docViewBottom && elemTop >= docViewTop;
}

__WEBPACK_IMPORTED_MODULE_0_jquery___default()(window).scroll(function () {
	$winnerCarousels.each(function (index, value) {
		if (isScrolledIntoView(value)) {
			if (!__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).prop('no-slide')) {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).find('.gallery').slick('slickNext');
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).prop('no-slide', true);
			}
		}
	});
});

function setupClickHandler($winnerItemCell) {
	$winnerItemCell.on('click', function (e) {
		console.log(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
		var gameId = $winnerItemCell.attr('data-gameid');
		var $game = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#section2').find('[data-gameid=\'' + gameId + '\']');

		//trigger click on game item
		$game.find('img').trigger('click');
	});
}

function setupWinnerItems() {
	$allGameElements = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#section2').find('.game-item');
	var $winnerCells = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.winners');

	$winnerCells.each(function (i, value) {
		var $winnerCell = $winnerCells.eq(i);
		var gameId = $winnerCell.attr('data-gameid');

		//setup game name and image

		$allGameElements.filter(function () {
			return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).attr('data-gameid') === gameId;
		});

		//add click handlers to this item
		setupClickHandler(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
	});
}

/* harmony default export */ __webpack_exports__["a"] = {
	setupWinnerItems: setupWinnerItems
};

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__about_js__ = __webpack_require__(304);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var About = function (_Component) {
	_inherits(About, _Component);

	function About() {
		_classCallCheck(this, About);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	About.prototype.componentWillMount = function componentWillMount() {
		__WEBPACK_IMPORTED_MODULE_1__about_js__["a" /* default */].setPageActive(true);
	};

	About.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_1__about_js__["a" /* default */].setPageActive(false);
	};

	About.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'about' });
	};

	return About;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = About;

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payment_navdeposit_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payment_pendingwithdrawals_index_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_common_lib_utils_router_config_js__ = __webpack_require__(39);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AccountPendingWithdrawals = function (_Component) {
	_inherits(AccountPendingWithdrawals, _Component);

	function AccountPendingWithdrawals() {
		_classCallCheck(this, AccountPendingWithdrawals);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	AccountPendingWithdrawals.prototype.componentWillMount = function componentWillMount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__payment_common_lib_utils_router_config_js__["a" /* closeStepsDepositflow */])({
			bonus: true,
			pendingwithdrawals: false,
			payment: true
		});
		__WEBPACK_IMPORTED_MODULE_1__payment_navdeposit_index_js__["a" /* default */].init(__WEBPACK_IMPORTED_MODULE_3__payment_common_lib_utils_router_config_js__["l" /* confAccountPendingWithdrawals */]);
		__WEBPACK_IMPORTED_MODULE_2__payment_pendingwithdrawals_index_js__["a" /* default */].init({
			wrapElmSelector: '#js-deposit-pendingwithdrawals',
			origin: 'account'
		});
	};

	AccountPendingWithdrawals.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'upload-documents' });
	};

	return AccountPendingWithdrawals;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = AccountPendingWithdrawals;

/***/ }),
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__account_settings_email_js__ = __webpack_require__(194);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AccountSettingsEmail = function (_Component) {
	_inherits(AccountSettingsEmail, _Component);

	function AccountSettingsEmail() {
		_classCallCheck(this, AccountSettingsEmail);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	AccountSettingsEmail.prototype.componentWillMount = function componentWillMount() {
		__WEBPACK_IMPORTED_MODULE_1__account_settings_email_js__["a" /* default */].setActive(true);
	};

	AccountSettingsEmail.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_1__account_settings_email_js__["a" /* default */].setActive(false);
	};

	AccountSettingsEmail.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'account-verify-email' });
	};

	return AccountSettingsEmail;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = AccountSettingsEmail;

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verification_mobile_verify_js__ = __webpack_require__(87);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AccountSettingsMobileEnterCode = function (_Component) {
	_inherits(AccountSettingsMobileEnterCode, _Component);

	function AccountSettingsMobileEnterCode() {
		_classCallCheck(this, AccountSettingsMobileEnterCode);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	AccountSettingsMobileEnterCode.prototype.componentWillMount = function componentWillMount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__verification_mobile_verify_js__["a" /* default */])().open('verify_code');
	};

	AccountSettingsMobileEnterCode.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'account-verify-mobile-enter-code' });
	};

	return AccountSettingsMobileEnterCode;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = AccountSettingsMobileEnterCode;

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verification_mobile_verify_js__ = __webpack_require__(87);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AccountSettingsMobileError = function (_Component) {
	_inherits(AccountSettingsMobileError, _Component);

	function AccountSettingsMobileError() {
		_classCallCheck(this, AccountSettingsMobileError);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	AccountSettingsMobileError.prototype.componentWillMount = function componentWillMount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__verification_mobile_verify_js__["a" /* default */])().open('error');
	};

	AccountSettingsMobileError.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'account-verify-mobile-error' });
	};

	return AccountSettingsMobileError;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = AccountSettingsMobileError;

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verification_mobile_verify_js__ = __webpack_require__(87);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AccountSettingsMobileVerified = function (_Component) {
	_inherits(AccountSettingsMobileVerified, _Component);

	function AccountSettingsMobileVerified() {
		_classCallCheck(this, AccountSettingsMobileVerified);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	AccountSettingsMobileVerified.prototype.componentWillMount = function componentWillMount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__verification_mobile_verify_js__["a" /* default */])().open('success');
	};

	AccountSettingsMobileVerified.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'account-verify-mobile-verified' });
	};

	return AccountSettingsMobileVerified;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = AccountSettingsMobileVerified;

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verification_mobile_verify_js__ = __webpack_require__(87);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AccountSettingsMobileVerify = function (_Component) {
	_inherits(AccountSettingsMobileVerify, _Component);

	function AccountSettingsMobileVerify() {
		_classCallCheck(this, AccountSettingsMobileVerify);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	AccountSettingsMobileVerify.prototype.componentWillMount = function componentWillMount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__verification_mobile_verify_js__["a" /* default */])().open('get_the_code');
	};

	AccountSettingsMobileVerify.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'account-verify-mobile-verify' });
	};

	return AccountSettingsMobileVerify;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = AccountSettingsMobileVerify;

/***/ }),
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__match_hydrate_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__verification_mobile_verify_js__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_settings_mobile_number_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__account_settings_mobile_verify_js__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__account_settings_mobile_enter_code_js__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__account_settings_mobile_verified_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__account_settings_mobile_error_js__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shop_js__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__payment_bonus_lib_view_bonus_js__ = __webpack_require__(202);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }













var AccountSettingsMobile = function (_Component) {
	_inherits(AccountSettingsMobile, _Component);

	function AccountSettingsMobile() {
		_classCallCheck(this, AccountSettingsMobile);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	AccountSettingsMobile.prototype.componentWillMount = function componentWillMount() {
		this.bonusId = this.props.location.state && this.props.location.state.hasOwnProperty('bonusId') ? this.props.location.state.bonusId : '';
		this.referrer = this.props.location.state && this.props.location.state.hasOwnProperty('referrer') ? this.props.location.state.referrer : '';
		this.referrerUrl = this.props.location.state && this.props.location.state.referrerUrl ? this.props.location.state.referrerUrl : '';
		var okBttn = document.querySelector('.verify-phone').querySelectorAll('.js-verify-phone--step')[2].querySelector('a');

		if (this.bonusId !== '' && this.referrer !== '') {
			if (this.referrer === 'shop') {
				okBttn.setAttribute('href', '/shop');
			} else if (this.referrer === 'register') {
				okBttn.setAttribute('href', '/account/deposit/bonus?referrer=register');
			}
		} else if (this.referrer === 'withdraw') {
			okBttn.setAttribute('href', '/account/withdraw/');
		} else {
			okBttn.setAttribute('href', '/');
		}

		if (this.referrerUrl) {
			okBttn.setAttribute('href', this.referrerUrl);
		}
	};

	AccountSettingsMobile.prototype.componentWillUnmount = function componentWillUnmount() {

		var id = this.bonusId;
		var referrer = this.referrer;
		if (this.bonusId !== '' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__verification_mobile_verify_js__["a" /* default */])().currentStep === 'success') {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__verification_mobile_verify_js__["a" /* default */])().close();
			if (referrer === 'shop') {
				__WEBPACK_IMPORTED_MODULE_9__shop_js__["default"].openShopItem(id);
				__WEBPACK_IMPORTED_MODULE_9__shop_js__["default"].getOpenedShopItem();
			} else if (referrer === 'register') {
				__WEBPACK_IMPORTED_MODULE_10__payment_bonus_lib_view_bonus_js__["a" /* default */].submitbtnCallbackForFreeMoney(id);
			} else if (referrer === 'deposit') {
				__WEBPACK_IMPORTED_MODULE_10__payment_bonus_lib_view_bonus_js__["a" /* default */].submitbtnCallbackForDeposit(id);
			}
		} else {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__verification_mobile_verify_js__["a" /* default */])().close();
		}
	};

	AccountSettingsMobile.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			'div',
			{ id: 'account-verify-mobile' },
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Switch */],
				null,
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/mysettings/verify-mobile/verify', component: __WEBPACK_IMPORTED_MODULE_5__account_settings_mobile_verify_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/mysettings/verify-mobile/enter-code', component: __WEBPACK_IMPORTED_MODULE_6__account_settings_mobile_enter_code_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/mysettings/verify-mobile/verified', component: __WEBPACK_IMPORTED_MODULE_7__account_settings_mobile_verified_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/mysettings/verify-mobile/error', component: __WEBPACK_IMPORTED_MODULE_8__account_settings_mobile_error_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { render: function render() {
						return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */], { to: '/account/mysettings/verify-mobile/verify' });
					} })
			)
		);
	};

	return AccountSettingsMobile;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = AccountSettingsMobile;

/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reality_check_reality_check_js__ = __webpack_require__(142);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var timeLimitElement = void 0;
var selectedDuration = void 0;

var RealityCheckSetTimeLimit = function (_Component) {
	_inherits(RealityCheckSetTimeLimit, _Component);

	function RealityCheckSetTimeLimit() {
		_classCallCheck(this, RealityCheckSetTimeLimit);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	RealityCheckSetTimeLimit.prototype.componentWillMount = function componentWillMount() {
		timeLimitElement = document.getElementsByClassName('time-limit')[0];
		var backButtonElement = timeLimitElement.getElementsByClassName('js-close-button')[0];
		backButtonElement.onclick = function () {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["e" /* pushBack */])();
		};
		var selectBoxElement = timeLimitElement.getElementsByClassName('js-select-box')[0];
		var okButtonElement = timeLimitElement.getElementsByClassName('js-ok-button')[0];
		okButtonElement.onclick = function () {
			selectedDuration = selectBoxElement.children[selectBoxElement.selectedIndex].value;
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__reality_check_reality_check_js__["b" /* setRealityCheckDuration */])(selectedDuration);
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["e" /* pushBack */])();
		};
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__core_ajax_json_js__["a" /* fetchJson */])('/player/limits/reality-check/duration').then(function (response) {
			if (response.result.timerDuration !== null) {
				for (var i = 0; i < selectBoxElement.children.length; i += 1) {
					var option = selectBoxElement.children[i];
					if (response.result.timerDuration === parseInt(option.value, 10)) {
						option.selected = true;
						break;
					}
				}
			}
			timeLimitElement.classList.add('menu--is-open');
		});
	};

	RealityCheckSetTimeLimit.prototype.componentWillUnmount = function componentWillUnmount() {
		timeLimitElement.classList.remove('menu--is-open');
	};

	RealityCheckSetTimeLimit.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'reality-check-set-limit' });
	};

	return RealityCheckSetTimeLimit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = RealityCheckSetTimeLimit;

/***/ }),
/* 323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_hydrate_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_settings_email_js__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_settings_mobile_js__ = __webpack_require__(321);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var AccountSettings = function (_Component) {
	_inherits(AccountSettings, _Component);

	function AccountSettings() {
		_classCallCheck(this, AccountSettings);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	AccountSettings.prototype.componentWillMount = function componentWillMount() {
		//menuesRootview.openMySettings();

	};

	AccountSettings.prototype.componentWillUnmount = function componentWillUnmount() {
		//menuesRootview.closeMySettings();

	};

	AccountSettings.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			'div',
			{ id: 'account-settings' },
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/mysettings/verify-email', component: __WEBPACK_IMPORTED_MODULE_2__account_settings_email_js__["a" /* default */] }),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/mysettings/verify-mobile', component: __WEBPACK_IMPORTED_MODULE_3__account_settings_mobile_js__["a" /* default */] })
		);
	};

	return AccountSettings;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = AccountSettings;

/***/ }),
/* 324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__upload_documents_js__ = __webpack_require__(110);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var currentElement = void 0;

var AccountUpload = function (_Component) {
	_inherits(AccountUpload, _Component);

	function AccountUpload() {
		_classCallCheck(this, AccountUpload);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	AccountUpload.prototype.componentWillMount = function componentWillMount() {
		currentElement = __WEBPACK_IMPORTED_MODULE_1__upload_documents_js__["a" /* default */].init(this.props.match.params.page);
	};

	AccountUpload.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_1__upload_documents_js__["a" /* default */].setAccountLinkUploadDocumentsIcon();
		currentElement.classList.remove('menu--is-open');
		currentElement.parentNode.removeChild(currentElement);
	};

	AccountUpload.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'upload-documents' });
	};

	return AccountUpload;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

AccountUpload.propTypes = {
	params: __WEBPACK_IMPORTED_MODULE_0_react___default.a.PropTypes.object
};

/* harmony default export */ __webpack_exports__["a"] = AccountUpload;

/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_hydrate_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menues_rootview_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__account_pending_withdrawals_js__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__account_settings_js__ = __webpack_require__(323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__account_upload_js__ = __webpack_require__(324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__upload_documents_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__account_settings_reality_check_set_time_limit_js__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__deposit_js__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withdraw_js__ = __webpack_require__(361);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Account = function (_Component) {
	_inherits(Account, _Component);

	function Account() {
		_classCallCheck(this, Account);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Account.prototype.componentWillMount = function componentWillMount() {
		__WEBPACK_IMPORTED_MODULE_6__upload_documents_js__["a" /* default */].setAccountLinkUploadDocumentsIcon();
		__WEBPACK_IMPORTED_MODULE_2__menues_rootview_js__["a" /* default */].openAccountMenu();
	};

	Account.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_2__menues_rootview_js__["a" /* default */].closeMenuesExceptGlobalMenu();
	};

	Account.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			'div',
			{ id: 'account' },
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/pendingwithdrawals', component: __WEBPACK_IMPORTED_MODULE_3__account_pending_withdrawals_js__["a" /* default */] }),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/mysettings', component: __WEBPACK_IMPORTED_MODULE_4__account_settings_js__["a" /* default */] }),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/upload/:page?', component: __WEBPACK_IMPORTED_MODULE_5__account_upload_js__["a" /* default */] }),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/reality-check-set-time-limit', component: __WEBPACK_IMPORTED_MODULE_7__account_settings_reality_check_set_time_limit_js__["a" /* default */] }),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/deposit', component: __WEBPACK_IMPORTED_MODULE_8__deposit_js__["a" /* default */] }),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/withdraw', component: __WEBPACK_IMPORTED_MODULE_9__withdraw_js__["a" /* default */] })
		);
	};

	return Account;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = Account;

/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__casino_allgames_js__ = __webpack_require__(130);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var AllGames = function (_Component) {
	_inherits(AllGames, _Component);

	function AllGames() {
		_classCallCheck(this, AllGames);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	AllGames.prototype.componentWillMount = function componentWillMount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__casino_allgames_js__["a" /* init */])();
	};

	AllGames.prototype.componentDidMount = function componentDidMount() {
		document.getElementsByClassName('content pusher')[0].scrollTop = 0;
	};

	AllGames.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'all-games' });
	};

	return AllGames;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = AllGames;

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__casino_bundles_js__ = __webpack_require__(195);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Bundle = function (_Component) {
	_inherits(Bundle, _Component);

	function Bundle() {
		_classCallCheck(this, Bundle);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Bundle.prototype.componentWillMount = function componentWillMount() {
		__WEBPACK_IMPORTED_MODULE_1__casino_bundles_js__["a" /* default */].open(this.props.match.params.bundle);
	};

	Bundle.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_1__casino_bundles_js__["a" /* default */].closePage();
	};

	Bundle.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'bundle' });
	};

	return Bundle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Bundle.propTypes = {
	params: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = Bundle;

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__header_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tabs_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__explore_js__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__provider_js__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__all_games_js__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__my_games_js__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__game_js__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__live_casino_js__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__casino_casino_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_scroll_hidebars_js__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__libs_scroll_hidebars_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__libs_scroll_hidebars_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__pixel_tracking_pixel_tracking_js__ = __webpack_require__(84);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
















var Casino = function (_Component) {
	_inherits(Casino, _Component);

	function Casino() {
		_classCallCheck(this, Casino);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Casino.prototype.componentWillMount = function componentWillMount() {
		__WEBPACK_IMPORTED_MODULE_13__pixel_tracking_pixel_tracking_js__["a" /* default */].push('casino');
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__casino_casino_js__["a" /* init */])();
	};

	Casino.prototype.render = function render() {
		var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_history_js__["b" /* parseQueryString */])(this.props.location);
		var url = query && query.url ? query.url : '/casino/explore';
		//const { gameMode, providerName } = this.props.params;
		//const shouldAuthenticate = gameMode && gameMode.toUpperCase() === 'REAL';
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			'div',
			null,
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__header_js__["a" /* default */], null),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__tabs_js__["a" /* default */], null),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Switch */],
				null,
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/casino/explore', component: __WEBPACK_IMPORTED_MODULE_5__explore_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/casino/provider/:providerName', component: __WEBPACK_IMPORTED_MODULE_6__provider_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/casino/all-games', component: __WEBPACK_IMPORTED_MODULE_7__all_games_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/casino/my-games', component: __WEBPACK_IMPORTED_MODULE_8__my_games_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/casino/live-casino', component: __WEBPACK_IMPORTED_MODULE_10__live_casino_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/casino/game/:gameCode/:gameMode', component: __WEBPACK_IMPORTED_MODULE_9__game_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { render: function render() {
						return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */], { to: url });
					} })
			)
		);
	};

	return Casino;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = Casino;

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payment_navdeposit_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_bonus_index_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_scroll_position_js__ = __webpack_require__(144);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DepositBonusNP = function (_Component) {
	_inherits(DepositBonusNP, _Component);

	function DepositBonusNP() {
		_classCallCheck(this, DepositBonusNP);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	DepositBonusNP.prototype.componentWillMount = function componentWillMount() {
		var push = this.props.history.push;

		// navDeposit.preparePaymentFormDataService();
		/* close any previously opened modules */

		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__["a" /* closeStepsDepositflow */])({
			bonus: false,
			pendingwithdrawals: true,
			payment: true,
			depositResult: true
		});
		__WEBPACK_IMPORTED_MODULE_2__payment_navdeposit_index_js__["a" /* default */].init(__WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__["h" /* confDepositBonusNp */]);
		__WEBPACK_IMPORTED_MODULE_3__payment_bonus_index_js__["a" /* default */].init({
			wrapElmSelector: '#js-deposit-bonus',
			url: null, // (referrer === 'register' ? 'allBonusesUrl' : null),
			textkeys: __WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__["h" /* confDepositBonusNp */].textkeys.selector,
			isEmptyCallback: function isEmptyCallback() {
				/* If no pending withdrawals exist, the step shall be skipped.
    When this is done the bonus-page is shown, and
    the backbutton must be updated  to close the flow or
    not go back to pending withdrawals, which creates a looping back button.*/
				push('/account/deposit/paymentnpnb');
			},
			confirmCallback: function confirmCallback() {
				/* If a bonus is selected the 'continue'-button will be shown, and then the next step is entered. .*/
				push('/account/deposit/paymentnp');
			}
		});
	};

	DepositBonusNP.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_4__utils_scroll_position_js__["a" /* default */].save('deposit-bonus', document.querySelector('.js-deposit-bonus'));
	};

	DepositBonusNP.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'deposit-bonus-np' });
	};

	return DepositBonusNP;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DepositBonusNP.propTypes = {
	history: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = DepositBonusNP;

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payment_common_lib_utils_router_config_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_navdeposit_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__payment_bonus_index_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_scroll_position_js__ = __webpack_require__(144);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var DepositBonus = function (_Component) {
	_inherits(DepositBonus, _Component);

	function DepositBonus() {
		_classCallCheck(this, DepositBonus);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	DepositBonus.prototype.componentWillMount = function componentWillMount() {
		var _props = this.props,
		    push = _props.history.push,
		    location = _props.location;

		var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["b" /* parseQueryString */])(location);
		var referrer = query && query.referrer && query.referrer === 'register' ? 'register' : null;
		var isEmptyCallback = void 0;
		var confirmCallback = void 0;
		/* close any previously opened modules */
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__payment_common_lib_utils_router_config_js__["a" /* closeStepsDepositflow */])({
			bonus: false,
			pendingwithdrawals: true,
			payment: true,
			depositResult: true
		});

		/*  setup the wrapping context for the depositflow: skip, close, skip- buttons */
		if (referrer === 'register') {
			/* when arriving from register the conf is new. See src/register/register.js that
   sets the url to /account/deposit/bonus?referrer=register */
			isEmptyCallback = function emptyCb() {
				push('/account/deposit/payment?referrer=register&bonus=empty');
			};
			confirmCallback = function confirmCb() {
				push('/account/deposit/payment?referrer=register');
			};
			__WEBPACK_IMPORTED_MODULE_3__payment_navdeposit_index_js__["a" /* default */].init(Object.assign(__WEBPACK_IMPORTED_MODULE_2__payment_common_lib_utils_router_config_js__["i" /* confDepositBonusFromRegister */], {
				referrer: referrer
			}));
		} else {
			/* this conf is used for an already registered user */
			isEmptyCallback = function emptyCb() {
				/* when no bonuses exist automatically redirect to paymentform */
				push('/account/deposit/paymentnb');
			};
			confirmCallback = function confirmCb() {
				/* when a bonus is selected and confirmed with the 'continue' button,
    automatically redirect to paymentform */
				push('/account/deposit/payment');
			};
			__WEBPACK_IMPORTED_MODULE_3__payment_navdeposit_index_js__["a" /* default */].init(Object.assign(__WEBPACK_IMPORTED_MODULE_2__payment_common_lib_utils_router_config_js__["j" /* confDepositBonus */], {
				referrer: referrer
			}));
		}

		/* setup the bonus view and data-modules that displays inside the wrapper
  controlled by navDeposit above.*/
		__WEBPACK_IMPORTED_MODULE_4__payment_bonus_index_js__["a" /* default */].init({
			wrapElmSelector: '#js-deposit-bonus',
			url: referrer,
			textkeys: __WEBPACK_IMPORTED_MODULE_2__payment_common_lib_utils_router_config_js__["j" /* confDepositBonus */].textkeys.selector,
			isEmptyCallback: isEmptyCallback,
			confirmCallback: confirmCallback
		});
	};

	DepositBonus.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_5__utils_scroll_position_js__["a" /* default */].save('deposit-bonus', document.querySelector('js-deposit-bonus'));
	};

	DepositBonus.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'deposit-bonus' });
	};

	return DepositBonus;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DepositBonus.propTypes = {
	history: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
	location: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = DepositBonus;

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payment_navdeposit_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_payment_index_js__ = __webpack_require__(62);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DepositPaymentNB = function (_Component) {
	_inherits(DepositPaymentNB, _Component);

	function DepositPaymentNB() {
		_classCallCheck(this, DepositPaymentNB);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	DepositPaymentNB.prototype.componentWillMount = function componentWillMount() {
		var push = this.props.history.push;

		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__["a" /* closeStepsDepositflow */])({
			bonus: true,
			pendingwithdrawals: true,
			payment: false,
			depositResult: true
		});
		__WEBPACK_IMPORTED_MODULE_2__payment_navdeposit_index_js__["a" /* default */].init(__WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__["d" /* confDepositPaymentNb */]);
		__WEBPACK_IMPORTED_MODULE_3__payment_payment_index_js__["a" /* default */].init({
			wrapElmSelector: '#js-deposit-action',
			textkeys: __WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__["d" /* confDepositPaymentNb */].textkeys.selector,
			ageverifycb: function ageverifycb() {
				__WEBPACK_IMPORTED_MODULE_3__payment_payment_index_js__["a" /* default */].close();
				__WEBPACK_IMPORTED_MODULE_2__payment_navdeposit_index_js__["a" /* default */].close();
				push('/account/upload/age-verify');
			},
			agedontverifycb: function agedontverifycb() {
				__WEBPACK_IMPORTED_MODULE_3__payment_payment_index_js__["a" /* default */].close();
				__WEBPACK_IMPORTED_MODULE_2__payment_navdeposit_index_js__["a" /* default */].close();
				push('/account');
			},
			compliancedontverifycb: function compliancedontverifycb() {
				//navDeposit.close();
				//push('/account');
			}
		});
	};

	DepositPaymentNB.prototype.componentWillUnmount = function componentWillUnmount() {};

	DepositPaymentNB.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'deposit-payment-nb' });
	};

	return DepositPaymentNB;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DepositPaymentNB.propTypes = {
	history: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};
/* harmony default export */ __webpack_exports__["a"] = DepositPaymentNB;

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payment_navdeposit_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_payment_index_js__ = __webpack_require__(62);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DepositPaymentNP = function (_Component) {
	_inherits(DepositPaymentNP, _Component);

	function DepositPaymentNP() {
		_classCallCheck(this, DepositPaymentNP);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	DepositPaymentNP.prototype.componentWillMount = function componentWillMount() {
		var push = this.props.history.push;


		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__["a" /* closeStepsDepositflow */])({
			bonus: true,
			pendingwithdrawals: true,
			payment: false,
			depositResult: true
		});
		__WEBPACK_IMPORTED_MODULE_2__payment_navdeposit_index_js__["a" /* default */].init(__WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__["c" /* confDepositPaymentNp */]);
		__WEBPACK_IMPORTED_MODULE_3__payment_payment_index_js__["a" /* default */].init({
			wrapElmSelector: '#js-deposit-action',
			textkeys: __WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__["c" /* confDepositPaymentNp */].textkeys.selector,
			ageverifycb: function ageverifycb() {
				__WEBPACK_IMPORTED_MODULE_3__payment_payment_index_js__["a" /* default */].close();
				__WEBPACK_IMPORTED_MODULE_2__payment_navdeposit_index_js__["a" /* default */].close();
				push('/account/upload/age-verify');
			},
			agedontverifycb: function agedontverifycb() {
				__WEBPACK_IMPORTED_MODULE_3__payment_payment_index_js__["a" /* default */].close();
				__WEBPACK_IMPORTED_MODULE_2__payment_navdeposit_index_js__["a" /* default */].close();
				push('/account');
			},
			compliancedontverifycb: function compliancedontverifycb() {
				// navDeposit.close();
				// push('/account');
			}
		});
	};

	DepositPaymentNP.prototype.componentWillUnmount = function componentWillUnmount() {};

	DepositPaymentNP.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'deposit-payment-np' });
	};

	return DepositPaymentNP;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DepositPaymentNP.propTypes = {
	history: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};
/* harmony default export */ __webpack_exports__["a"] = DepositPaymentNP;

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payment_navdeposit_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_payment_index_js__ = __webpack_require__(62);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DepositPaymentNPNB = function (_Component) {
	_inherits(DepositPaymentNPNB, _Component);

	function DepositPaymentNPNB() {
		_classCallCheck(this, DepositPaymentNPNB);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	DepositPaymentNPNB.prototype.componentWillMount = function componentWillMount() {
		var push = this.props.history.push;


		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__["a" /* closeStepsDepositflow */])({
			bonus: true,
			pendingwithdrawals: true,
			payment: false,
			depositResult: true
		});
		__WEBPACK_IMPORTED_MODULE_2__payment_navdeposit_index_js__["a" /* default */].init(__WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__["b" /* confDepositPaymentNpNb */]);
		__WEBPACK_IMPORTED_MODULE_3__payment_payment_index_js__["a" /* default */].init({
			wrapElmSelector: '#js-deposit-action',
			textkeys: __WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_router_config_js__["b" /* confDepositPaymentNpNb */].textkeys.selector,
			ageverifycb: function ageverifycb() {
				__WEBPACK_IMPORTED_MODULE_3__payment_payment_index_js__["a" /* default */].close();
				__WEBPACK_IMPORTED_MODULE_2__payment_navdeposit_index_js__["a" /* default */].close();
				push('/account/upload/age-verify');
			},
			agedontverifycb: function agedontverifycb() {
				__WEBPACK_IMPORTED_MODULE_3__payment_payment_index_js__["a" /* default */].close();
				__WEBPACK_IMPORTED_MODULE_2__payment_navdeposit_index_js__["a" /* default */].close();
				push('/account');
			},
			compliancedontverifycb: function compliancedontverifycb() {
				// navDeposit.close();
				// push('/account');
			}
		});
	};

	DepositPaymentNPNB.prototype.componentWillUnmount = function componentWillUnmount() {};

	DepositPaymentNPNB.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'deposit-bonus-npnb' });
	};

	return DepositPaymentNPNB;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DepositPaymentNPNB.propTypes = {
	history: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object.isRequired
};
/* harmony default export */ __webpack_exports__["a"] = DepositPaymentNPNB;

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payment_common_lib_utils_router_config_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_navdeposit_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__payment_payment_index_js__ = __webpack_require__(62);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var DepositPayment = function (_Component) {
	_inherits(DepositPayment, _Component);

	function DepositPayment() {
		_classCallCheck(this, DepositPayment);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	DepositPayment.prototype.componentWillMount = function componentWillMount() {
		var _props = this.props,
		    push = _props.history.push,
		    location = _props.location;

		var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["b" /* parseQueryString */])(location);
		var referrer = query && query.referrer ? query.referrer : null;
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__payment_common_lib_utils_router_config_js__["a" /* closeStepsDepositflow */])({
			bonus: true,
			pendingwithdrawals: true,
			payment: false,
			depositResult: true
		});
		/* navDeposit sets routes and callbacks for navigation, skip, back, close */
		if (referrer === 'register') {
			__WEBPACK_IMPORTED_MODULE_3__payment_navdeposit_index_js__["a" /* default */].init(__WEBPACK_IMPORTED_MODULE_2__payment_common_lib_utils_router_config_js__["e" /* confDepositPaymentFromRegister */]);
		} else if (referrer === 'shop') {
			__WEBPACK_IMPORTED_MODULE_4__payment_payment_index_js__["a" /* default */].close(); // this navigation enters or re-enters the depositflow and elements have to removed to avoid duplication. This action is covered by '.close()'
			__WEBPACK_IMPORTED_MODULE_3__payment_navdeposit_index_js__["a" /* default */].init(__WEBPACK_IMPORTED_MODULE_2__payment_common_lib_utils_router_config_js__["f" /* confDepositPaymentFromShop */]);
		} else {
			__WEBPACK_IMPORTED_MODULE_3__payment_navdeposit_index_js__["a" /* default */].init(__WEBPACK_IMPORTED_MODULE_2__payment_common_lib_utils_router_config_js__["g" /* confDepositPayment */]);
		}
		__WEBPACK_IMPORTED_MODULE_4__payment_payment_index_js__["a" /* default */].init({
			wrapElmSelector: '#js-deposit-action',
			textkeys: __WEBPACK_IMPORTED_MODULE_2__payment_common_lib_utils_router_config_js__["g" /* confDepositPayment */].textkeys.selector,
			ageverifycb: function ageverifycb() {
				__WEBPACK_IMPORTED_MODULE_4__payment_payment_index_js__["a" /* default */].close();
				__WEBPACK_IMPORTED_MODULE_3__payment_navdeposit_index_js__["a" /* default */].close();
				push('/account/upload/age-verify');
			},
			agedontverifycb: function agedontverifycb() {
				__WEBPACK_IMPORTED_MODULE_4__payment_payment_index_js__["a" /* default */].close();
				__WEBPACK_IMPORTED_MODULE_3__payment_navdeposit_index_js__["a" /* default */].close();
				push('/account');
			}
		});
	};

	DepositPayment.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'deposit-payment' });
	};

	return DepositPayment;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
// TODO: disabling linter: the propTypes currently are not used according to full purpose and
// may later be filled correctly.
/* eslint-disable*/


DepositPayment.propTypes = {
	history: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
	location: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};
/* eslint-enable */
/* harmony default export */ __webpack_exports__["a"] = DepositPayment;

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payment_common_lib_utils_router_config_js__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_navdeposit_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__payment_bonus_index_js__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__payment_payment_index_js__ = __webpack_require__(62);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var DepositShopPayment = function (_Component) {
	_inherits(DepositShopPayment, _Component);

	function DepositShopPayment() {
		_classCallCheck(this, DepositShopPayment);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	DepositShopPayment.prototype.componentWillMount = function componentWillMount() {
		var _props = this.props,
		    push = _props.history.push,
		    location = _props.location;

		var query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["b" /* parseQueryString */])(location);
		/* TODO: the navigation is set from components/deposit-payment.js
   navDeposit.init(conf);
   */
		__WEBPACK_IMPORTED_MODULE_5__payment_payment_index_js__["a" /* default */].shopInit();
		__WEBPACK_IMPORTED_MODULE_4__payment_bonus_index_js__["a" /* default */].init({
			selectedShopBonusId: query.bonusId,
			paymentMethods: query.bonusPaymentMethods,
			shopDepositBonusCallback: function shopDepositBonusCallback() {
				/* Transition to payment action if the flow is deposit bonus selected from shop*/
				var queryString = query.referrer ? '?referrer=' + query.referrer : '';
				push('/account/deposit/payment' + queryString);
			}
		});
	};

	DepositShopPayment.prototype.componentWillUnmount = function componentWillUnmount() {
		//
	};

	DepositShopPayment.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'deposit-shop-payment' });
	};

	return DepositShopPayment;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DepositShopPayment.propTypes = {
	history: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object,
	location: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = DepositShopPayment;

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payment_navdeposit_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payment_pendingwithdrawals_index_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__payment_common_lib_utils_router_config_js__ = __webpack_require__(39);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var DepositWithdraw = function (_Component) {
	_inherits(DepositWithdraw, _Component);

	function DepositWithdraw() {
		_classCallCheck(this, DepositWithdraw);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	DepositWithdraw.prototype.componentWillMount = function componentWillMount() {
		var push = this.props.history.push;
		/* close any previously opened modules */

		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__payment_common_lib_utils_router_config_js__["a" /* closeStepsDepositflow */])({
			bonus: true,
			pendingwithdrawals: false,
			payment: true,
			depositResult: true
		});
		__WEBPACK_IMPORTED_MODULE_1__payment_navdeposit_index_js__["a" /* default */].init(__WEBPACK_IMPORTED_MODULE_3__payment_common_lib_utils_router_config_js__["k" /* confDepositWithdraw */]);
		__WEBPACK_IMPORTED_MODULE_2__payment_pendingwithdrawals_index_js__["a" /* default */].init({
			wrapElmSelector: '#js-deposit-pendingwithdrawals',
			textkeys: __WEBPACK_IMPORTED_MODULE_3__payment_common_lib_utils_router_config_js__["k" /* confDepositWithdraw */].textkeys.selector,
			origin: 'deposit',
			isEmptyCallback: function isEmptyCallback() {
				/* If no pending withdrawals exist, the step shall be skipped.
    When this is done the bonus-page is shown, and
    the backbutton must be updated  to close the flow or
    not go back to pending withdrawals, which creates a looping back button.*/
				//dispatchRoute('DEPOSIT_BONUS_NOPENDING');
				//replaceRoute('DEPOSIT_BONUS_NOPENDING');
				push('/account/deposit/bonusnp');
			}
		});
	};

	DepositWithdraw.prototype.componentWillUnmount = function componentWillUnmount() {};

	DepositWithdraw.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'deposit-withdraw' });
	};

	return DepositWithdraw;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

DepositWithdraw.propTypes = {
	history: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = DepositWithdraw;

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__match_hydrate_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deposit_withdraw_js__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deposit_bonus_js__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deposit_bonus_np_js__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__deposit_payment_js__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__deposit_payment_nb_js__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__deposit_payment_np_js__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__deposit_payment_npnb_js__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__deposit_shop_payment_js__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__payment_navdeposit_index_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__login_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__libs_tomcat_cookies_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__core_ajax_json_js__ = __webpack_require__(13);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }


















var Deposit = function (_Component) {
	_inherits(Deposit, _Component);

	function Deposit() {
		_classCallCheck(this, Deposit);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Deposit.prototype.componentWillMount = function componentWillMount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15__core_ajax_json_js__["a" /* fetchJson */])('/player/balance').then(function (resultData) {
			__WEBPACK_IMPORTED_MODULE_14__libs_tomcat_cookies_js__["a" /* default */].set('lastBalance', resultData.result.amount);
		});

		if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__store_cookies_js__["a" /* lastProduct */])()) {
			__WEBPACK_IMPORTED_MODULE_13__login_js__["a" /* default */].getDefaultPath(function () {
				return;
			});
		}
	};

	Deposit.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_11__payment_navdeposit_index_js__["a" /* default */].close();
	};

	Deposit.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			'div',
			{ id: 'deposit' },
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
				__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Switch */],
				null,
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/deposit/withdraw', component: __WEBPACK_IMPORTED_MODULE_3__deposit_withdraw_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/deposit/bonus', component: __WEBPACK_IMPORTED_MODULE_4__deposit_bonus_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/deposit/bonusnp', component: __WEBPACK_IMPORTED_MODULE_5__deposit_bonus_np_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/deposit/payment', component: __WEBPACK_IMPORTED_MODULE_6__deposit_payment_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/deposit/paymentnb', component: __WEBPACK_IMPORTED_MODULE_7__deposit_payment_nb_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/deposit/paymentnp', component: __WEBPACK_IMPORTED_MODULE_8__deposit_payment_np_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/deposit/paymentnpnb', component: __WEBPACK_IMPORTED_MODULE_9__deposit_payment_npnb_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__match_hydrate_js__["a" /* default */], { authenticate: true, path: '/account/deposit/shoppayment', component: __WEBPACK_IMPORTED_MODULE_10__deposit_shop_payment_js__["a" /* default */] }),
				__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { render: function render() {
						return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */], { to: '/account/deposit/withdraw' });
					} })
			)
		);
	};

	return Deposit;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = Deposit;

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__email_verify_result_js__ = __webpack_require__(363);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var EmailVerifyResult = function (_Component) {
	_inherits(EmailVerifyResult, _Component);

	function EmailVerifyResult() {
		_classCallCheck(this, EmailVerifyResult);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	EmailVerifyResult.prototype.componentWillMount = function componentWillMount() {
		var param = this.props.match.params[0];
		__WEBPACK_IMPORTED_MODULE_1__email_verify_result_js__["a" /* default */].setActive(true, param);
	};

	EmailVerifyResult.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_1__email_verify_result_js__["a" /* default */].setActive(false);
	};

	EmailVerifyResult.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'mail-verify-result' });
	};

	return EmailVerifyResult;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = EmailVerifyResult;

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__casino_explore_js__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bundle_js__ = __webpack_require__(327);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Explore = function (_Component) {
	_inherits(Explore, _Component);

	function Explore() {
		_classCallCheck(this, Explore);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Explore.prototype.componentWillMount = function componentWillMount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__casino_explore_js__["a" /* init */])(document.getElementById('section1'));
	};

	Explore.prototype.componentDidMount = function componentDidMount() {
		document.getElementsByClassName('content pusher')[0].scrollTop = 0;
	};

	Explore.prototype.componentWillUnmount = function componentWillUnmount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__casino_explore_js__["b" /* destroy */])();
	};

	Explore.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/casino/explore/:bundle', component: __WEBPACK_IMPORTED_MODULE_3__bundle_js__["a" /* default */] });
	};

	return Explore;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = Explore;

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__casino_ingame_js__ = __webpack_require__(196);



var GameLoader = function GameLoader(props) {
	var _props$match$params = props.match.params,
	    gameMode = _props$match$params.gameMode,
	    gameCode = _props$match$params.gameCode;


	__WEBPACK_IMPORTED_MODULE_1__casino_ingame_js__["a" /* default */].loadGame(gameCode, gameMode);

	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'gameloader' });
};

GameLoader.propTypes = {
	params: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = GameLoader;

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__match_hydrate_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__game_loader_js__ = __webpack_require__(340);




var Game = function Game(props) {
	var authenticate = props.match.params.gameMode.toUpperCase() === 'REAL';
	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
		'div',
		{ id: 'game' },
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__match_hydrate_js__["a" /* default */], { authenticate: authenticate, path: '/casino/game/:gameCode/:gameMode', component: __WEBPACK_IMPORTED_MODULE_2__game_loader_js__["a" /* default */] })
	);
};

Game.propTypes = {
	params: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = Game;

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__landing_page_js__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_ajax_json_js__ = __webpack_require__(13);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Home = function (_Component) {
	_inherits(Home, _Component);

	function Home() {
		_classCallCheck(this, Home);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Home.prototype.componentWillMount = function componentWillMount() {
		if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["c" /* sessionKey */])() || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["a" /* lastProduct */])()) {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_ajax_json_js__["a" /* fetchJson */])('/site').then(function (response) {
				var defaultPath = response.result.toLowerCase();
				location.pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_history_js__["d" /* basePathname */])(defaultPath);
			});
		} else {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__landing_page_js__["a" /* init */])();
		}
	};

	Home.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'home' });
	};

	return Home;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Home.propTypes = {
	router: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = Home;

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var icon = "<svg viewBox=\"0 0 24 24\" class=\"js-icon-selected link-list__continue-icon\" aria-hidden=\"true\">\n\t<title>Checkmark Circle</title>\n\t<path d=\"M12.5 21.77C11.26 21.78 10.03 21.53 8.89 21.04 4.17 19.05 1.96 13.6 3.95 8.88 5.95 4.16 11.39 1.95 16.11 3.94 16.67 4.18 17.19 4.47 17.69 4.81 17.87 4.93 17.92 5.18 17.8 5.36 17.67 5.54 17.42 5.59 17.24 5.47 16.79 5.16 16.3 4.89 15.79 4.68 13.69 3.79 11.32 3.79 9.22 4.68 6.07 6 4.03 9.08 4.03 12.49 4.03 15.9 6.07 18.98 9.22 20.3 11.32 21.18 13.69 21.18 15.79 20.3 17.83 19.43 19.45 17.81 20.32 15.78 20.76 14.74 20.98 13.63 20.97 12.5 20.98 11.75 20.88 11.01 20.69 10.29 20.63 10.08 20.75 9.87 20.96 9.81 21.17 9.75 21.39 9.87 21.45 10.08 21.66 10.87 21.77 11.68 21.77 12.5 21.78 13.74 21.53 14.97 21.04 16.11 20.1 18.33 18.33 20.1 16.1 21.05 14.96 21.53 13.74 21.78 12.5 21.77ZM12.31 15.84C12.09 15.84 11.88 15.74 11.74 15.57L8.02 11.29C7.89 11.13 7.91 10.89 8.06 10.75 8.21 10.61 8.45 10.61 8.61 10.75L8.61 10.77 12.31 15.05 20.56 5.59C20.71 5.42 20.96 5.4 21.13 5.55 21.29 5.69 21.31 5.95 21.16 6.11L12.88 15.57C12.74 15.74 12.53 15.84 12.31 15.84Z\"\n\t/>\n</svg>";

/* harmony default export */ __webpack_exports__["a"] = icon;

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_tabs_js__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__casino_jackpot_render_js__ = __webpack_require__(197);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var LiveCasino = function (_Component) {
	_inherits(LiveCasino, _Component);

	function LiveCasino() {
		_classCallCheck(this, LiveCasino);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	LiveCasino.prototype.componentWillMount = function componentWillMount() {
		var sectionName = 'section4';
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__casino_jackpot_render_js__["a" /* setupJackpot */])(document.getElementById(sectionName));
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__libs_tabs_js__["a" /* open */])(sectionName);
	};

	LiveCasino.prototype.componentDidMount = function componentDidMount() {
		document.getElementsByClassName('content pusher')[0].scrollTop = 0;
	};

	LiveCasino.prototype.render = function render() {
		return false;
	};

	return LiveCasino;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = LiveCasino;

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menues_rootview_js__ = __webpack_require__(83);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var LoginForm = function (_Component) {
	_inherits(LoginForm, _Component);

	function LoginForm() {
		_classCallCheck(this, LoginForm);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	LoginForm.prototype.componentWillMount = function componentWillMount() {
		__WEBPACK_IMPORTED_MODULE_1__login_js__["a" /* default */].openLoginFrom();
		__WEBPACK_IMPORTED_MODULE_2__menues_rootview_js__["a" /* default */].openLoginMenu();
	};

	LoginForm.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_1__login_js__["a" /* default */].closeLoginForm();
		__WEBPACK_IMPORTED_MODULE_2__menues_rootview_js__["a" /* default */].close();
	};

	LoginForm.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'login' });
	};

	return LoginForm;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = LoginForm;

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__login_form_js__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_cookies_js__ = __webpack_require__(10);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Login = function (_Component) {
	_inherits(Login, _Component);

	function Login() {
		_classCallCheck(this, Login);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Login.prototype.render = function render() {
		var _ref = this.props.location.state || { from: { pathname: '/' } },
		    from = _ref.from;

		if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__store_cookies_js__["c" /* sessionKey */])()) {
			return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* Redirect */], { to: from });
		}
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__login_form_js__["a" /* default */], null);
	};

	return Login;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = Login;

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_js__ = __webpack_require__(38);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Logout = function (_Component) {
	_inherits(Logout, _Component);

	function Logout() {
		_classCallCheck(this, Logout);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Logout.prototype.componentWillMount = function componentWillMount() {
		__WEBPACK_IMPORTED_MODULE_1__login_js__["a" /* default */].doLogout();
	};

	Logout.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'logout' });
	};

	return Logout;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = Logout;

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__menues_rootview_js__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header_js__ = __webpack_require__(106);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var MenuGlobal = function (_Component) {
	_inherits(MenuGlobal, _Component);

	function MenuGlobal() {
		_classCallCheck(this, MenuGlobal);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	MenuGlobal.prototype.componentWillMount = function componentWillMount() {
		__WEBPACK_IMPORTED_MODULE_1__menues_rootview_js__["a" /* default */].openGlobalMenu();
	};

	MenuGlobal.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_1__menues_rootview_js__["a" /* default */].close();
	};

	MenuGlobal.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			'div',
			{ id: 'menu-global' },
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__header_js__["a" /* default */], null)
		);
	};

	return MenuGlobal;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = MenuGlobal;

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__casino_mygames_js__ = __webpack_require__(80);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var MyGames = function (_Component) {
	_inherits(MyGames, _Component);

	function MyGames() {
		_classCallCheck(this, MyGames);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	MyGames.prototype.componentWillMount = function componentWillMount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__casino_mygames_js__["b" /* init */])();
	};

	MyGames.prototype.componentDidMount = function componentDidMount() {
		document.getElementsByClassName('content pusher')[0].scrollTop = 0;
	};

	MyGames.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'my-games' });
	};

	return MyGames;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = MyGames;

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__payment_common_lib_utils_constants_js__ = __webpack_require__(9);



var PENDING_STATE = 'pending';
var NOT_FOUND_STATE = 'notFound';
var defaultServerUrl = void 0;
var viewUpdateCallback = void 0;
var defaultHandlePaymentResultCallback = void 0;

function defaultHandleDepositResultCallback(paymentResultData) {
	var SUCCESSFUL_STATE = 'successful';
	var state = paymentResultData.state;
	var temporaryOrUnknownPendingState = Boolean(state === PENDING_STATE && paymentResultData.willStayInPending === false || state === NOT_FOUND_STATE);
	var nonTemporaryPendingState = Boolean(paymentResultData.willStayInPending === true);
	var successState = Boolean(state === SUCCESSFUL_STATE);
	var handleIsDone = false;
	if (temporaryOrUnknownPendingState) {
		// Show that we want another poll by returning false
		handleIsDone = false;
	} else if (nonTemporaryPendingState) {
		viewUpdateCallback(paymentResultData, __WEBPACK_IMPORTED_MODULE_0__payment_common_lib_utils_constants_js__["a" /* default */].PENDING);
		// Show that we are happy by returning true, so no need for another poll
		handleIsDone = true;
	} else if ((!temporaryOrUnknownPendingState || !nonTemporaryPendingState) && successState) {
		viewUpdateCallback(paymentResultData, __WEBPACK_IMPORTED_MODULE_0__payment_common_lib_utils_constants_js__["a" /* default */].SUCCESS);
		// Show that we are happy by returning true, so no need for another poll
		handleIsDone = true;
	} else {
		viewUpdateCallback(paymentResultData, __WEBPACK_IMPORTED_MODULE_0__payment_common_lib_utils_constants_js__["a" /* default */].CANCELLED);
		// Show that we are happy by returning true, so no need for another poll
		handleIsDone = true;
	}
	return handleIsDone;
}

function removeBonusFromShop(bonusId) {
	Promise.resolve().then(__webpack_require__.bind(null, 143)).then(function (shop) {
		shop.default.removeBonusFromShop(bonusId);
	}).catch(function (err) {
		console.error(err);
	});
}

function pollPaymentResult(p) {
	var serverUrl = p.serverUrl || null;
	var handlePaymentResultCallback = p.handlePaymentResultCallback || null;
	var numberOfTimesToTry = p.numberOfTimesToTry || null;
	var waitTimeBetweenTriesMs = p.waitTimeBetweenTriesMs || null;
	var accHistRef = p.accHistRef || null;
	var doneCallback = p.doneCallback || null;
	var continuePollingCallback = p.continuePollingCallback || null;
	var playerCancel = p.playerCancel || null;
	var playerRedirectedToFailUrl = p.playerRedirectedToFailUrl || null;
	setTimeout(function () {
		jQuery.post(serverUrl, {
			accHistRef: accHistRef,
			playerCancel: playerCancel,
			playerRedirectedToFailUrl: playerRedirectedToFailUrl,
			numberOfTimesToTry: numberOfTimesToTry
		}, function (data) {
			//Clear bonus from shop if successul deposit with bonus
			if (data.bonusId > 0) {
				removeBonusFromShop(data.bonusId);
			}
			if (handlePaymentResultCallback(data)) {
				// Here we have started to show successful or cancelled final result for the player
				doneCallback();
				return;
			}
			numberOfTimesToTry -= 1;
			if (numberOfTimesToTry > 0 && continuePollingCallback() === true) {
				// pollPaymentResult(serverUrl, handlePaymentResultCallback, numberOfTimesToTry,
				// waitTimeBetweenTriesMs, accHistRef, doneCallback,
				// continuePollingCallback, playerCancel, playerRedirectedToFailUrl);
				pollPaymentResult({
					serverUrl: serverUrl,
					handlePaymentResultCallback: handlePaymentResultCallback,
					numberOfTimesToTry: numberOfTimesToTry,
					waitTimeBetweenTriesMs: waitTimeBetweenTriesMs,
					accHistRef: accHistRef,
					doneCallback: doneCallback,
					continuePollingCallback: continuePollingCallback,
					playerCancel: playerCancel,
					playerRedirectedToFailUrl: playerRedirectedToFailUrl
				});
			} else {
				// paymentController.trigger(paymentEvent.REMOVE_LOADING);
				// Out of luck? Show playerCancel, or pending final result or error msg if the transaction is not found yet
				if (data.state === PENDING_STATE) {
					viewUpdateCallback(data, __WEBPACK_IMPORTED_MODULE_0__payment_common_lib_utils_constants_js__["a" /* default */].PENDING);
				} else if (data.state === NOT_FOUND_STATE && continuePollingCallback() === true) {
					viewUpdateCallback(data, __WEBPACK_IMPORTED_MODULE_0__payment_common_lib_utils_constants_js__["a" /* default */].CANCELLED);
				}
				doneCallback();
			}
		});
	}, waitTimeBetweenTriesMs);
}

function getAsynchronousPaymentResultAndShowFinalResult(p) {
	function returnTrueFkn() {
		return true;
	}

	var accHistRef = p.accHistRef || null;
	var serverUrl = p.serverUrl || defaultServerUrl;
	var playerCancel = p.playerCancel || null;
	var playerRedirectedToFailUrl = p.playerRedirectedToFailUrl || null;
	var totalTimeToWaitInMs = p.totalTimeToWaitInMs || null;
	var handlePaymentResultCallback = p.handlePaymentResultCallback || defaultHandlePaymentResultCallback;
	var doneCallback = p.doneCallback || null;
	var continuePollingCallback = p.continuePollingCallback || returnTrueFkn;
	var DEFAULT_TOTAL_TIME_TO_WAIT_MS = 15000;
	var DEFAULT_TOTAL_TIME_TO_WAIT_MS_FAILED_TRANSACTION = 6000;
	var DEFAULT_WAIT_TIME_BEETWEEN_TRIES_MS = 3000;
	var numberOfTimesToTry = null;

	function emptyFkn() {}

	if (!totalTimeToWaitInMs) {
		if (playerRedirectedToFailUrl) {
			totalTimeToWaitInMs = DEFAULT_TOTAL_TIME_TO_WAIT_MS_FAILED_TRANSACTION;
		} else {
			totalTimeToWaitInMs = DEFAULT_TOTAL_TIME_TO_WAIT_MS;
		}
	}

	doneCallback = doneCallback || emptyFkn;
	numberOfTimesToTry = Math.floor(totalTimeToWaitInMs / DEFAULT_WAIT_TIME_BEETWEEN_TRIES_MS);
	pollPaymentResult({
		serverUrl: serverUrl,
		handlePaymentResultCallback: handlePaymentResultCallback,
		numberOfTimesToTry: numberOfTimesToTry,
		waitTimeBetweenTriesMs: DEFAULT_WAIT_TIME_BEETWEEN_TRIES_MS,
		accHistRef: accHistRef,
		doneCallback: doneCallback,
		continuePollingCallback: continuePollingCallback,
		playerCancel: playerCancel,
		playerRedirectedToFailUrl: playerRedirectedToFailUrl
	});
}

var callbacks = {
	pendingAfterSingleCallback: function pendingAfterSingleCallback(paymentResultData) {
		var state = paymentResultData.state;
		if (state === PENDING_STATE) {
			viewUpdateCallback(paymentResultData, __WEBPACK_IMPORTED_MODULE_0__payment_common_lib_utils_constants_js__["a" /* default */].PENDING);
		} else {
			viewUpdateCallback(paymentResultData, __WEBPACK_IMPORTED_MODULE_0__payment_common_lib_utils_constants_js__["a" /* default */].CANCELLED);
		}
	}
};

function getResultCallback(handlePaymentResultCallback) {
	if (handlePaymentResultCallback) {
		if (callbacks[handlePaymentResultCallback]) {
			return callbacks[handlePaymentResultCallback];
		}
	}
	return defaultHandlePaymentResultCallback;
}

function getSynchronousDepositResultAndShowFinalResult(accHistRef, serverUrl, handlePaymentResultCallback) {
	var sUrl = serverUrl || defaultServerUrl;
	var paymentResultCb = getResultCallback(handlePaymentResultCallback);
	viewUpdateCallback();
	jQuery.post(sUrl, {
		accHistRef: accHistRef
	}, function (data) {
		if (data.bonusId > 0) {
			removeBonusFromShop(data.bonusId);
		}
		paymentResultCb(data);
		viewUpdateCallback();
	});
}

function getPaymentResult(hashParams) {
	// TODO Fetch the right section to show in deposit result page.
	// hashParams looks like
	// fetch_type=fetch_type_asynch
	// &accHistRef=PR-0205601139806-7
	// &paymentFetchResultFlow=%2FPaymentFormDataService%2FgetDepositResult

	// view update will show the spinner
	viewUpdateCallback();

	var fetchUrl = hashParams.paymentFetchResultFlow || hashParams.serverUrl || defaultServerUrl;

	if (hashParams.fetch_type === __WEBPACK_IMPORTED_MODULE_0__payment_common_lib_utils_constants_js__["a" /* default */].FETCH_TYPE_ASYNCH) {
		getAsynchronousPaymentResultAndShowFinalResult({
			accHistRef: hashParams.accHistRef,
			serverUrl: fetchUrl,
			playerCancel: hashParams.playerCancel,
			playerRedirectedToFailUrl: hashParams.playerRedirectedToFailUrl,
			totalTimeToWaitInMs: hashParams.totalTimeToWaitInMs,
			handlePaymentResultCallback: hashParams.handlePaymentResultCallback,
			doneCallback: hashParams.doneCallback,
			continuePollingCallback: hashParams.continuePollingCallback
		});
	} else {
		getSynchronousDepositResultAndShowFinalResult(hashParams.accHistRef, fetchUrl, hashParams.handlePaymentResultCallback);
	}
}

function getDefaultServerUrl(paymentType) {
	if (paymentType === 'deposit') {
		return '/PaymentFormDataService/getDepositResult';
	}
	return '/PaymentFormDataService/getWithdrawResultService';
}

function getDefaultHandlePaymentResultCallback(paymentType) {
	if (paymentType === 'deposit') {
		return defaultHandleDepositResultCallback;
	}
	return callbacks.pendingAfterSingleCallback;
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(hashParams, viewUpdate, paymentType) {
		defaultServerUrl = getDefaultServerUrl(paymentType);
		viewUpdateCallback = viewUpdate;
		defaultHandlePaymentResultCallback = getDefaultHandlePaymentResultCallback(paymentType);
		getPaymentResult(hashParams);
	}
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch_payment_result_js__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__payment_util_count_up_js__ = __webpack_require__(422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__pixel_tracking_pixel_tracking_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__libs_currency_formatter_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_locale_js__ = __webpack_require__(31);












var globalNotificationElem = void 0;
var paymentResultElem = void 0;
var paymentType = void 0; // deposit or withdraw

var countUpOptions = {
	useEasing: true,
	useGrouping: false,
	separator: '',
	decimal: '',
	prefix: '',
	suffix: ''
};

function showBalance() {
	var balanceElem = paymentResultElem.getElementsByClassName('js-balance')[0];
	var formattedBalance = void 0;
	function setFormattedBalance() {
		balanceElem.innerHTML = formattedBalance;
	}
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_ajax_json_js__["a" /* fetchJson */])('/player/balance').then(function (response) {
		balanceElem.classList.remove('u-hide');
		var balanceTextElem = paymentResultElem.getElementsByClassName('js-balance-text')[0];
		balanceTextElem.classList.remove('u-hide');
		paymentResultElem.getElementsByClassName('js-progress-bar')[0].classList.add('notify__progress-bar--fill-success');
		var tickerElement = paymentResultElem.getElementsByClassName('js-balance-ticker')[0];
		var uniqueId = new Date().getTime().toString();
		tickerElement.id = uniqueId;
		var startValue = __WEBPACK_IMPORTED_MODULE_2__libs_tomcat_cookies_js__["a" /* default */].get('lastBalance') || 0;
		var ticker = new __WEBPACK_IMPORTED_MODULE_6__payment_util_count_up_js__["a" /* default */](uniqueId, startValue, response.result.amount, 0, 2, countUpOptions);
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_ajax_json_js__["a" /* fetchJson */])('/player/currency').then(function (response2) {
			formattedBalance = __WEBPACK_IMPORTED_MODULE_9__libs_currency_formatter_js__["a" /* default */].format(response.result.amount, response2.result, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__libs_locale_js__["a" /* getLocale */])());
			ticker.start(setFormattedBalance);
		});
	});
}

function showSuccessIcon() {
	paymentResultElem.getElementsByClassName('js-icon-success')[0].classList.remove('u-hide');
}

function showSuccess() {
	showSuccessIcon();
	var titleElem = paymentResultElem.getElementsByClassName('js-notify__main-title')[0];
	if (paymentType === 'withdraw') {
		titleElem.innerHTML = titleElem.dataset.withdrawSuccessTitle;
	} else {
		titleElem.innerHTML = titleElem.dataset.depositSuccessTitle;
	}
	var textElem = paymentResultElem.getElementsByClassName('js-notify__main-text')[0];
	if (paymentType === 'withdraw') {
		textElem.innerHTML = textElem.dataset.withdrawSuccessText;
	} else {
		textElem.innerHTML = textElem.dataset.depositSuccessText;
	}
	showBalance();
}

function cleanUp() {
	document.querySelector('.notify--is-open').classList.remove('notify--is-open');
	globalNotificationElem.classList.remove('global-notification--is-open');
}

function setupCloseButtonClickHandler() {
	var closeButtonElem = paymentResultElem.getElementsByClassName('js-close')[0];
	var isLandingPage = __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */].page && __WEBPACK_IMPORTED_MODULE_3__store_index_js__["a" /* default */].page === 'landing';

	closeButtonElem.onclick = function () {
		cleanUp();
		paymentResultElem.remove();
		if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["a" /* lastProduct */])() && !isLandingPage) {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_history_js__["c" /* push */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_history_js__["d" /* basePathname */])());
		} else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["a" /* lastProduct */])() && isLandingPage) {
			// Weird hack to remove querystring from URL during refresh
			window.history.replaceState({}, 'Payment Result', window.location.pathname.split('?')[0]);
			window.location.pathname = '/global';
		} else {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__core_ajax_json_js__["a" /* fetchJson */])('/site').then(function (response) {
				var defaultPath = response.result.toLowerCase();
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["b" /* setNavigationCookies */])(defaultPath);
				window.history.replaceState({}, 'Payment Result', window.location.pathname.split('?')[0]);
				window.location.pathname = '/global';
			});
		}
	};
}

function showFailedButtons() {
	var buttonWrapperElem = paymentResultElem.getElementsByClassName('js-notify__button-wrapper')[0];
	buttonWrapperElem.classList.remove('u-hide');

	var tryAgainButtonElem = buttonWrapperElem.getElementsByClassName('js-try-again-button')[0];
	tryAgainButtonElem.onclick = function tryAgainClickHandler() {
		if (paymentType === 'withdraw') {
			window.location.pathname = '/account/withdraw';
		} else {
			window.location.pathname = '/' + paymentType;
		}
	};
	var supportButtonElem = buttonWrapperElem.getElementsByClassName('js-support-button')[0];
	supportButtonElem.onclick = function supportClickHandler() {
		var link = supportButtonElem.dataset.link;
		window.open(link);
	};
}

function showFailedProgressBar() {
	paymentResultElem.getElementsByClassName('js-progress-bar')[0].classList.add('notify__progress-bar--fill-fail');
}

function showFailedIcon() {
	paymentResultElem.getElementsByClassName('js-icon-fail')[0].classList.remove('u-hide');
}

function showFailed() {
	showFailedIcon();
	var titleElem = paymentResultElem.getElementsByClassName('js-notify__main-title')[0];
	if (paymentType === 'withdraw') {
		titleElem.innerHTML = titleElem.dataset.withdrawFailTitle;
	} else {
		titleElem.innerHTML = titleElem.dataset.depositFailTitle;
	}
	var textElem = paymentResultElem.getElementsByClassName('js-notify__main-text')[0];
	if (paymentType === 'withdraw') {
		textElem.innerHTML = textElem.dataset.withdrawFailText;
	} else {
		textElem.innerHTML = textElem.dataset.depositFailText;
	}
	showFailedButtons();
	showFailedProgressBar();
}

function showTextArea() {
	paymentResultElem.getElementsByClassName('js-text-wrapper')[0].classList.remove('u-hide');
}

function hideSpinner() {
	paymentResultElem.getElementsByClassName('spinner')[0].classList.add('u-hide');
}

function showDepositPending() {
	paymentResultElem.getElementsByClassName('js-icon-pending-deposit')[0].classList.remove('u-hide');
	var titleElem = paymentResultElem.getElementsByClassName('js-notify__main-title')[0];
	titleElem.innerHTML = titleElem.dataset.depositPendingTitle;
	var textElem = paymentResultElem.getElementsByClassName('js-notify__main-text')[0];
	textElem.innerHTML = textElem.dataset.depositPendingText;
	showBalance();
}

function extractValue(str, searchStr) {
	var startOfSection = str.indexOf(searchStr);
	var startOfValue = str.indexOf('\': \'', startOfSection) + 4;
	var endOffValue = str.indexOf('\'', startOfValue);

	return str.substring(startOfValue, endOffValue);
}

function viewUpdateCallback(data, state) {
	if (data === undefined) {
		return;
	}
	hideSpinner();
	if (paymentType === 'deposit' && state === __WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_constants_js__["a" /* default */].PENDING) {
		showDepositPending();
	} else if (state === __WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_constants_js__["a" /* default */].PENDING || state === __WEBPACK_IMPORTED_MODULE_1__payment_common_lib_utils_constants_js__["a" /* default */].SUCCESS) {
		showSuccess();
		if (paymentType === 'deposit') {
			var amount = extractValue(data.pixelTrackingData, 'pixel_depositAmount');
			__WEBPACK_IMPORTED_MODULE_7__pixel_tracking_pixel_tracking_js__["a" /* default */].push('deposit', amount);
		}
	} else {
		showFailed();
	}
	showTextArea();
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(type, queryParameters) {
		paymentType = type;

		globalNotificationElem = document.getElementsByClassName('js-global-notification')[0];
		var paymentResultElemTemplate = document.getElementsByClassName('js-payment-result-information-message')[0];
		paymentResultElemTemplate.classList.add('u-hide');
		paymentResultElem = paymentResultElemTemplate.cloneNode(true);
		paymentResultElem.classList.remove('u-hide');
		paymentResultElemTemplate.parentNode.insertBefore(paymentResultElem, paymentResultElemTemplate.nextSibling);
		setupCloseButtonClickHandler();

		__WEBPACK_IMPORTED_MODULE_0__fetch_payment_result_js__["a" /* default */].init(queryParameters, viewUpdateCallback, paymentType);
	}
};

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__privacy_policy_js__ = __webpack_require__(430);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var PrivacyPolicy = function (_Component) {
	_inherits(PrivacyPolicy, _Component);

	function PrivacyPolicy() {
		_classCallCheck(this, PrivacyPolicy);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	PrivacyPolicy.prototype.componentWillMount = function componentWillMount() {
		__WEBPACK_IMPORTED_MODULE_1__privacy_policy_js__["a" /* default */].setPrivacyPolicyPageActive(true);
	};

	PrivacyPolicy.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_1__privacy_policy_js__["a" /* default */].setPrivacyPolicyPageActive(false);
	};

	PrivacyPolicy.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'privacy-policy' });
	};

	return PrivacyPolicy;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = PrivacyPolicy;

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__casino_providergames_js__ = __webpack_require__(309);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var Provider = function (_Component) {
	_inherits(Provider, _Component);

	function Provider() {
		_classCallCheck(this, Provider);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Provider.prototype.componentWillMount = function componentWillMount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__casino_providergames_js__["a" /* init */])(this.props.match.params.providerName);
	};

	Provider.prototype.componentWillUnmount = function componentWillUnmount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__casino_providergames_js__["b" /* destroy */])();
	};

	Provider.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'provider' });
	};

	return Provider;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Provider.propTypes = {
	params: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = Provider;

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_history_js__ = __webpack_require__(6);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var PushStateAnchorHistory = function (_HTMLAnchorElement) {
	_inherits(PushStateAnchorHistory, _HTMLAnchorElement);

	function PushStateAnchorHistory() {
		_classCallCheck(this, PushStateAnchorHistory);

		return _possibleConstructorReturn(this, _HTMLAnchorElement.apply(this, arguments));
	}

	PushStateAnchorHistory.prototype.connectedCallback = function connectedCallback() {
		this.state = this.getAttribute('state');
		this.title = this.getAttribute('title') || '';
		this.href = this.getAttribute('href');
		this.refresh = this.getAttribute('refresh');
		this.addEventListener('click', this.onClick);
	};

	PushStateAnchorHistory.prototype.attributeChangedCallback = function attributeChangedCallback(name, oldVal, newVal) {
		if (this[name] !== newVal) {
			this[name] = newVal;
		}
	};

	PushStateAnchorHistory.prototype.disconnectedCallback = function disconnectedCallback() {
		this.removeEventListener('click', this.onClick);
	};

	PushStateAnchorHistory.prototype.onClick = function onClick(event) {
		var invalidLink = !this.href;
		var refresh = !!JSON.parse(this.refresh);
		var externalLink = this.href.startsWith('http') && window.location.host !== new URL(this.href).host;
		var openNewTab = event.ctrlKey || event.metaKey || event.which === 2;
		if (invalidLink || externalLink || openNewTab || refresh) {
			return;
		}

		// push state into the history stack
		__WEBPACK_IMPORTED_MODULE_0__store_history_js__["a" /* history */].push(this.href, JSON.parse(this.state) || { from: __WEBPACK_IMPORTED_MODULE_0__store_history_js__["a" /* history */].location });
		event.preventDefault();
	};

	_createClass(PushStateAnchorHistory, [{
		key: 'state',
		get: function get() {
			return this._state;
		},
		set: function set(value) {
			this._state = value;
			this.setAttribute('state', value);
		}
	}, {
		key: 'title',
		get: function get() {
			return this._title;
		},
		set: function set(value) {
			this._title = value;
			this.setAttribute('title', value);
		}
	}, {
		key: 'href',
		get: function get() {
			return this._href;
		},
		set: function set(value) {
			this._href = value;
			this.setAttribute('href', value);
		}
	}, {
		key: 'refresh',
		get: function get() {
			return this._refresh;
		},
		set: function set(value) {
			this._refresh = value;
			this.setAttribute('refresh', value);
		}
	}], [{
		key: 'observedAttributes',
		get: function get() {
			return ['state', 'title', 'href', 'refresh'];
		}
	}]);

	return PushStateAnchorHistory;
}(HTMLAnchorElement);

customElements.define('pushstate-anchor', PushStateAnchorHistory, { extends: 'a' });

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__register_register_js__ = __webpack_require__(211);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var RegisterDetails = function (_Component) {
	_inherits(RegisterDetails, _Component);

	function RegisterDetails() {
		_classCallCheck(this, RegisterDetails);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	RegisterDetails.prototype.componentWillMount = function componentWillMount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__register_register_js__["a" /* default */])().open('register_details');
	};

	RegisterDetails.prototype.componentWillUnmount = function componentWillUnmount() {
		if (window.location.pathname === '/register') {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__register_register_js__["a" /* default */])().open('register');
		} else {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__register_register_js__["a" /* default */])().close();
		}
	};

	RegisterDetails.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'register-details' });
	};

	return RegisterDetails;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

RegisterDetails.propTypes = {
	router: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = RegisterDetails;

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__register_register_js__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_tomcat_cookies_js__ = __webpack_require__(23);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var Register = function (_Component) {
	_inherits(Register, _Component);

	function Register() {
		_classCallCheck(this, Register);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Register.prototype.componentWillMount = function componentWillMount() {
		// Remove cookie entry from previous registration.
		if (this.props.location.pathname === '/register') {
			if (__WEBPACK_IMPORTED_MODULE_4__libs_tomcat_cookies_js__["a" /* default */].get('registrationStepTwo')) {
				__WEBPACK_IMPORTED_MODULE_4__libs_tomcat_cookies_js__["a" /* default */].remove('registrationStepTwo');
			}
		}

		var push = this.props.history.push;

		if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_cookies_js__["c" /* sessionKey */])()) {
			push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_history_js__["d" /* basePathname */])());
		} else {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__register_register_js__["a" /* default */])().open('register');
		}
	};

	Register.prototype.componentWillUnmount = function componentWillUnmount() {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__register_register_js__["a" /* default */])().close();
	};

	Register.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'register' });
	};

	return Register;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Register.propTypes = {
	history: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].object
};

/* harmony default export */ __webpack_exports__["a"] = Register;

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__responsible_gaming_js__ = __webpack_require__(433);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var ResponsibleGaming = function (_Component) {
	_inherits(ResponsibleGaming, _Component);

	function ResponsibleGaming() {
		_classCallCheck(this, ResponsibleGaming);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	ResponsibleGaming.prototype.componentWillMount = function componentWillMount() {
		__WEBPACK_IMPORTED_MODULE_1__responsible_gaming_js__["a" /* default */].setResponsibleGamingPageActive(true);
	};

	ResponsibleGaming.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_1__responsible_gaming_js__["a" /* default */].setResponsibleGamingPageActive(false);
	};

	ResponsibleGaming.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'responsible-gaming' });
	};

	return ResponsibleGaming;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = ResponsibleGaming;

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabs_js__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__shop_js__ = __webpack_require__(143);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Shop = function (_Component) {
	_inherits(Shop, _Component);

	function Shop() {
		_classCallCheck(this, Shop);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Shop.prototype.componentWillMount = function componentWillMount() {
		__WEBPACK_IMPORTED_MODULE_3__shop_js__["default"].init();
	};

	Shop.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			'div',
			{ id: 'shop-component' },
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* default */], null),
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__tabs_js__["a" /* default */], null)
		);
	};

	return Shop;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = Shop;

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sportsbook_sportsbook_js__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pixel_tracking_pixel_tracking_js__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_currency_formatter_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_locale_js__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_custom_events_js__ = __webpack_require__(47);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var headerTitle = document.getElementById('casino-header-title');
var titleText = document.getElementById('container').dataset.title;
function setTitle() {
	headerTitle.innerHTML = titleText || '';
}

var Sportsbook = function (_Component) {
	_inherits(Sportsbook, _Component);

	function Sportsbook() {
		_classCallCheck(this, Sportsbook);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Sportsbook.prototype.componentWillMount = function componentWillMount() {
		if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_cookies_js__["c" /* sessionKey */])()) {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_ajax_json_js__["a" /* fetchJson */])('/player/balance').then(function (response) {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__core_ajax_json_js__["a" /* fetchJson */])('/player/currency').then(function (response2) {
					var formattedBalance = __WEBPACK_IMPORTED_MODULE_6__libs_currency_formatter_js__["a" /* default */].format(response.result.amount, response2.result, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__libs_locale_js__["a" /* getLocale */])());
					headerTitle.innerHTML = formattedBalance;
				});
			});
		} else {
			setTitle();
		}

		__WEBPACK_IMPORTED_MODULE_8__utils_custom_events_js__["a" /* emitter */].on('logout', setTitle);

		__WEBPACK_IMPORTED_MODULE_3__pixel_tracking_pixel_tracking_js__["a" /* default */].push('sports');
		__WEBPACK_IMPORTED_MODULE_2__sportsbook_sportsbook_js__["a" /* default */].init();
	};

	Sportsbook.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_8__utils_custom_events_js__["a" /* emitter */].off('logout', setTitle);
	};

	Sportsbook.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
			'div',
			{ id: 'sportsbook-component' },
			__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__header_js__["a" /* default */], null)
		);
	};

	return Sportsbook;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = Sportsbook;

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__terms_and_conditions_js__ = __webpack_require__(437);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var TermsConditions = function (_Component) {
	_inherits(TermsConditions, _Component);

	function TermsConditions() {
		_classCallCheck(this, TermsConditions);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	TermsConditions.prototype.componentWillMount = function componentWillMount() {
		__WEBPACK_IMPORTED_MODULE_1__terms_and_conditions_js__["a" /* default */].setTermsAndConditionsPageActive(true);
	};

	TermsConditions.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_1__terms_and_conditions_js__["a" /* default */].setTermsAndConditionsPageActive(false);
	};

	TermsConditions.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'terms-conditions' });
	};

	return TermsConditions;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = TermsConditions;

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payment_withdraw_withdraw_controller_js__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_info_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications_js__ = __webpack_require__(16);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var Withdraw = function (_Component) {
	_inherits(Withdraw, _Component);

	function Withdraw() {
		_classCallCheck(this, Withdraw);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	Withdraw.prototype.componentWillMount = function componentWillMount() {
		__WEBPACK_IMPORTED_MODULE_1__payment_withdraw_withdraw_controller_js__["a" /* init */](this.props.pathname, 'js-withdrawal-flow', '/casino');
		__WEBPACK_IMPORTED_MODULE_1__payment_withdraw_withdraw_controller_js__["b" /* withdrawFlow */]();

		/* withdraw.withdrawFlow()
  	.then(flowDone => {
  		withdraw.cleanup();
  	}).error()
  	*/

		document.documentElement.classList.add('overlay--open');
	};

	Withdraw.prototype.componentWillUnmount = function componentWillUnmount() {
		__WEBPACK_IMPORTED_MODULE_1__payment_withdraw_withdraw_controller_js__["c" /* cleanup */]();

		document.documentElement.classList.remove('overlay--open');
	};

	Withdraw.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'withdraw' });
	};

	return Withdraw;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Withdraw.propTypes = {
	pathname: __WEBPACK_IMPORTED_MODULE_0_react__["PropTypes"].string
};

/* harmony default export */ __webpack_exports__["a"] = Withdraw;

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var WithTemp = function (_Component) {
	_inherits(WithTemp, _Component);

	function WithTemp() {
		_classCallCheck(this, WithTemp);

		return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	}

	WithTemp.prototype.componentWillMount = function componentWillMount() {
		document.getElementById('js-withdrawal-flow-temp').classList.add('withdrawal--open');
	};

	WithTemp.prototype.componentWillUnmount = function componentWillUnmount() {};

	WithTemp.prototype.render = function render() {
		return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { id: 'withtemp' });
	};

	return WithTemp;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = WithTemp;

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_history__ = __webpack_require__(6);
/**
 * Created by Fatih on 11.11.2016.
 * Careless whisper
 */


var $verifyResultWrapper = document.getElementsByClassName('js-verify_email_result')[0];
var $successResponse = $verifyResultWrapper.querySelector('#mail-verify-success-text');
var $failResponse = $verifyResultWrapper.querySelector('#mail-verify-fail-text');
var $alreadyVerifiedResponse = $verifyResultWrapper.querySelector('#mail-verify-already-text');
var $resultOkBttn = $verifyResultWrapper.querySelector('.btn-ok');
var $verifyEmailResultCloseBttn = $verifyResultWrapper.querySelector('.icon-close');

function setActive(bool, param) {
	if (bool && param) {
		handleResponse(param);
		$verifyResultWrapper.classList.add('menu--is-open');
	} else {
		$verifyResultWrapper.classList.remove('menu--is-open');
	}
}

function handleResponse(response) {
	$successResponse.classList.add('u-hide');
	$alreadyVerifiedResponse.classList.add('u-hide');
	$failResponse.classList.add('u-hide');

	switch (response) {
		case 'success':
			$successResponse.classList.remove('u-hide');
			break;
		case 'already-verified':
			$alreadyVerifiedResponse.classList.remove('u-hide');
			break;
		case 'failed':
			$failResponse.classList.remove('u-hide');
			break;
		default:
			$failResponse.classList.remove('u-hide');
			break;
	}

	$resultOkBttn.classList.remove('u-hide');
}

$verifyEmailResultCloseBttn.addEventListener('click', function (e) {
	e.preventDefault();
	e.stopPropagation();
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__store_history__["e" /* pushBack */])();
});

/* harmony default export */ __webpack_exports__["a"] = {
	setActive: setActive
};

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__login_js__ = __webpack_require__(38);




function getTextValues(forgottenPasswordElement) {
	return {
		title: forgottenPasswordElement.dataset.title,
		message: forgottenPasswordElement.dataset.message,
		button: forgottenPasswordElement.dataset.button,
		desktopLink: forgottenPasswordElement.dataset.desktopLink,
		desktopLinkButtonText: forgottenPasswordElement.dataset.desktopButtonText
	};
}

function getForgottenPasswordConfirmationClickHandler(forgottenPasswordElement) {
	var texts = getTextValues(forgottenPasswordElement);
	return function forgottenPasswordButtonClickHandler(event) {
		__WEBPACK_IMPORTED_MODULE_0__notifications_js__["a" /* default */].showBinaryQuestion(texts.title, texts.desktopLinkButtonText, texts.button, function () {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_cookies_js__["f" /* setDesktopCookies */])();
			window.location.href = texts.desktopLink;
		}, function () {
			__WEBPACK_IMPORTED_MODULE_0__notifications_js__["a" /* default */].hideNotification();
			__WEBPACK_IMPORTED_MODULE_2__login_js__["a" /* default */].openLoginFrom();
		}, texts.message);
		__WEBPACK_IMPORTED_MODULE_2__login_js__["a" /* default */].closeLoginForm();
		event.preventDefault();
		event.stopPropagation();
	};
}

function init(loginElem) {
	var forgottenPasswordElement = loginElem.getElementsByClassName('js-forgotten-password')[0];
	forgottenPasswordElement.onclick = getForgottenPasswordConfirmationClickHandler(forgottenPasswordElement);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: init
};

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_debounce_js__ = __webpack_require__(653);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_index_js__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_tomcat_cookies__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_settings_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_language_selector_icon_selected_js__ = __webpack_require__(343);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return init; });
/* unused harmony export destroy */








var initialPos = -1;

function updateScrollPosition() {
	var $wrapper = document.getElementsByClassName('js-logo-wrapper')[0];
	var targetScale = 0.5;
	var scrolled = window.scrollY;

	if (initialPos < 0) {
		initialPos = document.getElementsByClassName('landing-page-wrapper__logo-wrapper')[0] ? $wrapper.getBoundingClientRect().top : 0;
	}

	if (scrolled - 2.0 > initialPos) {
		$wrapper.classList.add('is-collapsed');

		$wrapper.getElementsByClassName('svg-logo')[0].style.transform = 'scale(' + targetScale + ')';
	} else {
		var scale = void 0;
		scale = 1.0 - scrolled / initialPos;
		scale = scale * 1.2 + targetScale;

		// bounds
		scale = scale > 1.0 ? 1.0 : scale;
		scale = scale < targetScale ? targetScale : scale;
		$wrapper.classList.remove('is-collapsed');
		$wrapper.getElementsByClassName('svg-logo')[0].style.transform = 'scale(' + scale + ') translate(0%, -' + scrolled / (scale * scrolled) + '%)';
	}
}

function getIsoCode() {
	if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["g" /* locale */])()) {
		return 'se';
	}
	var isoCodeStr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["g" /* locale */])().substring(3, 6).toLowerCase();
	return isoCodeStr && isoCodeStr === 'xx' ? 'en' : isoCodeStr;
}
function changeLanguageFlag() {
	document.getElementsByClassName('landing-page__language-section-icon')[0].classList.add('flag__' + getIsoCode() + '--square', 'flag--square');
}

function changeLanguage(selectedLocale) {
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["h" /* isoCode */])() !== selectedLocale) {
		__WEBPACK_IMPORTED_MODULE_3__libs_tomcat_cookies__["a" /* default */].set('locale', selectedLocale, { path: '/' });
		changeLanguageFlag();
		location.reload();
	}
}

function init() {
	try {
		changeLanguageFlag();
		var $languageSelectionButton = document.getElementsByClassName('landing-page__language-section-icon')[0];
		var $languageSelectionPanel = document.getElementsByClassName('language-selector')[0];

		if ($languageSelectionButton && $languageSelectionPanel) {
			//we add the close event no matter what and make sure to clean the previously bound click event
			var $langSelPanelCloseBttn = $languageSelectionPanel.getElementsByClassName('icon-close')[0];
			var closeLangSelPanel = function closeLangSelPanel() {
				$languageSelectionPanel.classList.remove('notify--is-open', 'slide-in-up');
				$languageSelectionPanel.classList.add('slide-out-down');
			};
			$langSelPanelCloseBttn.removeEventListener(__WEBPACK_IMPORTED_MODULE_5__config_settings_js__["a" /* eventType */], closeLangSelPanel);
			$langSelPanelCloseBttn.addEventListener(__WEBPACK_IMPORTED_MODULE_5__config_settings_js__["a" /* eventType */], closeLangSelPanel);

			//if there aren't any other language buttons, we dont need to bind any events here
			if ($languageSelectionPanel.getElementsByClassName('landing-page__language-section-icon')) {
				$languageSelectionButton.addEventListener(__WEBPACK_IMPORTED_MODULE_5__config_settings_js__["a" /* eventType */], function () {
					var selectedLink = document.querySelector('a[data-locale=' + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["g" /* locale */])() + ']');
					var ifAlreadySelected = selectedLink.querySelector('.js-icon-selected');
					if (!ifAlreadySelected) {
						selectedLink.innerHTML += __WEBPACK_IMPORTED_MODULE_6__components_language_selector_icon_selected_js__["a" /* default */];
					}
					$languageSelectionPanel.classList.add('notify--is-open', 'slide-in-up');
					$languageSelectionPanel.classList.remove('slide-out-down');
				});
				// need to debounce this event so it doesn't trigger several times while scrolling.
				[].slice.call($languageSelectionPanel.getElementsByClassName('link-list__item')).forEach(function (v) {
					v.addEventListener(__WEBPACK_IMPORTED_MODULE_5__config_settings_js__["a" /* eventType */], function (e) {
						changeLanguage(e.target.getAttribute('data-locale'));
						return false;
					});
				});
			}
		}
	} catch (e) {
		console.error('language selection error', e);
	}

	if (__WEBPACK_IMPORTED_MODULE_2__store_index_js__["a" /* default */].page === 'landing') {
		window.addEventListener('scroll', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_debounce_js__["a" /* default */])(updateScrollPosition, 5));
	}

	var $productButtons = document.getElementById('products').getElementsByClassName('product-button');
	if ($productButtons.length > 3) {
		var $shopButton = document.getElementById('shop');
		$shopButton.parentNode.removeChild($shopButton);
	}

	document.getElementById('products').classList.remove('u-hide');
}

function destroy() {
	//document.getElementsByClassName('landing-page__language-section-icon')[0].removeEventListener(eventType);
	//document.getElementsByClassName('language-selector')[0].removeEventListener(eventType);

	if (__WEBPACK_IMPORTED_MODULE_2__store_index_js__["a" /* default */].page === 'landing') {
		window.removeEventListener('scroll');
	}
}



/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);


__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.extend({
	clickEffect: function clickEffect(element) {
		var effect = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'circle';


		function addCircleEffect() {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).addClass('click-effect').delay(500).queue(function () {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()(element).removeClass('click-effect').dequeue();
			});
		}

		if (effect === 'circle') {
			addCircleEffect();
		}
		return this; // maintain jQuery chainability
	}
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*! jquery-touchSwipe v0.0.1 ~ (c) 2015-2016 mattbryson ~ https://github.com/mattbryson/TouchSwipe-Jquery-Plugin */

var VERSION = '0.0.1';
var LEFT = 'left';
var RIGHT = 'right';
var UP = 'up';
var DOWN = 'down';
var IN = 'in';
var OUT = 'out';

var NONE = 'none';
var AUTO = 'auto';

var SWIPE = 'swipe';
var PINCH = 'pinch';
var TAP = 'tap';
var DOUBLE_TAP = 'doubletap';
var LONG_TAP = 'longtap';
var HOLD = 'hold';

var HORIZONTAL = 'horizontal';
var VERTICAL = 'vertical';

var ALL_FINGERS = 'all';

var DOUBLE_TAP_THRESHOLD = 10;

var PHASE_START = 'start';
var PHASE_MOVE = 'move';
var PHASE_END = 'end';
var PHASE_CANCEL = 'cancel';

var SUPPORTS_TOUCH = 'ontouchstart' in window;

var SUPPORTS_POINTER_IE10 = window.navigator.msPointerEnabled && !window.navigator.pointerEnabled && !SUPPORTS_TOUCH;

var SUPPORTS_POINTER = (window.navigator.pointerEnabled || window.navigator.msPointerEnabled) && !SUPPORTS_TOUCH;

var PLUGIN_NS = 'TouchSwipe';
var defaults = {
    fingers: 1, // 滑动时监控有几根手指触摸
    threshold: 75, // 触发滑动的最小距离
    cancelThreshold: null,
    pinchThreshold: 20,
    maxTimeThreshold: null,
    fingerReleaseThreshold: 250,
    longTapThreshold: 500,
    doubleTapThreshold: 200,
    swipe: null,
    swipeLeft: null,
    swipeRight: null,
    swipeUp: null,
    swipeDown: null,
    swipeStatus: null,
    pinchIn: null,
    pinchOut: null,
    pinchStatus: null,
    click: null,
    tap: null,
    doubleTap: null,
    longTap: null,
    hold: null,
    triggerOnTouchEnd: true,
    triggerOnTouchLeave: false,
    allowPageScroll: "auto",
    fallbackToMouseEvents: true,
    excludedElements: "label, button, input, select, textarea, a, .noSwipe",
    preventDefaultEvents: true
};
/**
 * Applies TouchSwipe behaviour to one or more jQuery objects.
 * The TouchSwipe plugin can be instantiated via this method, or methods within
 * TouchSwipe can be executed via this method as per jQuery plugin architecture.
 * An existing plugin can have its options changed simply by re calling .swipe(options)
 * @see TouchSwipe
 * @class
 * @param {Mixed} method If the current DOMNode is a TouchSwipe object, and <code>method</code> is a TouchSwipe method, then
 * the <code>method</code> is executed, and any following arguments are passed to the TouchSwipe method.
 * If <code>method</code> is an object, then the TouchSwipe class is instantiated on the current DOMNode, passing the
 * configuration properties defined in the object. See TouchSwipe
 *
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.swipe = function (method) {
    var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);
    var plugin = $this.data(PLUGIN_NS);

    //Check if we are already instantiated and trying to execute a method
    if (plugin && typeof method === 'string') {
        if (plugin[method]) {
            return plugin[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.error('Method ' + method + ' does not exist on jQuery.swipe');
        }
    }

    //Else update existing plugin with new options hash
    else if (plugin && (typeof method === 'undefined' ? 'undefined' : _typeof(method)) === 'object') {
            plugin['option'].apply(this, arguments);
        }

        //Else not instantiated and trying to pass init object (or nothing)
        else if (!plugin && ((typeof method === 'undefined' ? 'undefined' : _typeof(method)) === 'object' || !method)) {
                return init.apply(this, arguments);
            }

    return $this;
};

/**
 * The version of the plugin
 * @readonly
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.swipe.version = VERSION;

//Expose our defaults so a user could override the plugin defaults
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.swipe.defaults = defaults;

/**
 * The phases that a touch event goes through.  The <code>phase</code> is passed to the event handlers.
 * These properties are read only, attempting to change them will not alter the values passed to the event handlers.
 * @namespace
 * @readonly
 * @property {string} PHASE_START Constant indicating the start phase of the touch event. Value is <code>"start"</code>.
 * @property {string} PHASE_MOVE Constant indicating the move phase of the touch event. Value is <code>"move"</code>.
 * @property {string} PHASE_END Constant indicating the end phase of the touch event. Value is <code>"end"</code>.
 * @property {string} PHASE_CANCEL Constant indicating the cancel phase of the touch event. Value is <code>"cancel"</code>.
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.swipe.phases = {
    PHASE_START: PHASE_START,
    PHASE_MOVE: PHASE_MOVE,
    PHASE_END: PHASE_END,
    PHASE_CANCEL: PHASE_CANCEL
};

/**
 * The direction constants that are passed to the event handlers.
 * These properties are read only, attempting to change them will not alter the values passed to the event handlers.
 * @namespace
 * @readonly
 * @property {string} LEFT Constant indicating the left direction. Value is <code>"left"</code>.
 * @property {string} RIGHT Constant indicating the right direction. Value is <code>"right"</code>.
 * @property {string} UP Constant indicating the up direction. Value is <code>"up"</code>.
 * @property {string} DOWN Constant indicating the down direction. Value is <code>"cancel"</code>.
 * @property {string} IN Constant indicating the in direction. Value is <code>"in"</code>.
 * @property {string} OUT Constant indicating the out direction. Value is <code>"out"</code>.
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.swipe.directions = {
    LEFT: LEFT,
    RIGHT: RIGHT,
    UP: UP,
    DOWN: DOWN,
    IN: IN,
    OUT: OUT
};

/**
 * The page scroll constants that can be used to set the value of <code>allowPageScroll</code> option
 * These properties are read only
 * @namespace
 * @readonly
 * @see $.fn.swipe.defaults#allowPageScroll
 * @property {string} NONE Constant indicating no page scrolling is allowed. Value is <code>"none"</code>.
 * @property {string} HORIZONTAL Constant indicating horizontal page scrolling is allowed. Value is <code>"horizontal"</code>.
 * @property {string} VERTICAL Constant indicating vertical page scrolling is allowed. Value is <code>"vertical"</code>.
 * @property {string} AUTO Constant indicating either horizontal or vertical will be allowed, depending on the swipe handlers registered. Value is <code>"auto"</code>.
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.swipe.pageScroll = {
    NONE: NONE,
    HORIZONTAL: HORIZONTAL,
    VERTICAL: VERTICAL,
    AUTO: AUTO
};

/**
 * Constants representing the number of fingers used in a swipe.  These are used to set both the value of <code>fingers</code> in the
 * options object, as well as the value of the <code>fingers</code> event property.
 * These properties are read only, attempting to change them will not alter the values passed to the event handlers.
 * @namespace
 * @readonly
 * @see $.fn.swipe.defaults#fingers
 * @property {string} ONE Constant indicating 1 finger is to be detected / was detected. Value is <code>1</code>.
 * @property {string} TWO Constant indicating 2 fingers are to be detected / were detected. Value is <code>2</code>.
 * @property {string} THREE Constant indicating 3 finger are to be detected / were detected. Value is <code>3</code>.
 * @property {string} FOUR Constant indicating 4 finger are to be detected / were detected. Not all devices support this. Value is <code>4</code>.
 * @property {string} FIVE Constant indicating 5 finger are to be detected / were detected. Not all devices support this. Value is <code>5</code>.
 * @property {string} ALL Constant indicating any combination of finger are to be detected.  Value is <code>"all"</code>.
 */
__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.swipe.fingers = {
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    ALL: ALL_FINGERS
};
/**
 * Initialise the plugin for each DOM element matched
 * This creates a new instance of the main TouchSwipe class for each DOM element, and then
 * saves a reference to that instance in the elements data property.
 * @internal
 */
function init(options) {
    //Prep and extend the options
    if (options && options.allowPageScroll === undefined && (options.swipe !== undefined || options.swipeStatus !== undefined)) {
        options.allowPageScroll = NONE;
    }

    //Check for deprecated options
    //Ensure that any old click handlers are assigned to the new tap, unless we have a tap
    if (options.click !== undefined && options.tap === undefined) {
        options.tap = options.click;
    }

    if (!options) {
        options = {};
    }

    //pass empty object so we dont modify the defaults
    options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.fn.swipe.defaults, options);

    //For each element instantiate the plugin
    return this.each(function () {
        var $this = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(this);

        //Check we havent already initialised the plugin
        var plugin = $this.data(PLUGIN_NS);

        if (!plugin) {
            plugin = new TouchSwipe(this, options);
            $this.data(PLUGIN_NS, plugin);
        }
    });
}
/**
 * Main TouchSwipe Plugin Class.
 * Do not use this to construct your TouchSwipe object, use the jQuery plugin method $.fn.swipe(); {@link $.fn.swipe}
 * @private
 * @name TouchSwipe
 * @param {DOMNode} element The HTML DOM object to apply to plugin to
 * @param {Object} options The options to configure the plugin with.  @link {$.fn.swipe.defaults}
 * @see $.fh.swipe.defaults
 * @see $.fh.swipe
 * @class
 */
function TouchSwipe(element, options) {
    //take a local/instacne level copy of the options - should make it this.options really...
    var options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend({}, options);

    var useTouchEvents = SUPPORTS_TOUCH || SUPPORTS_POINTER || !options.fallbackToMouseEvents;
    var START_EV = useTouchEvents ? SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? 'MSPointerDown' : 'pointerdown' : 'touchstart' : 'mousedown';
    var MOVE_EV = useTouchEvents ? SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? 'MSPointerMove' : 'pointermove' : 'touchmove' : 'mousemove';
    var END_EV = useTouchEvents ? SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? 'MSPointerUp' : 'pointerup' : 'touchend' : 'mouseup';

    //we manually detect leave on touch devices, so null event here
    var LEAVE_EV = useTouchEvents ? SUPPORTS_POINTER ? 'mouseleave' : null : 'mouseleave';

    var CANCEL_EV = SUPPORTS_POINTER ? SUPPORTS_POINTER_IE10 ? 'MSPointerCancel' : 'pointercancel' : 'touchcancel';

    //touch properties
    var distance = 0;

    var direction = null;
    var currentDirection = null;
    var duration = 0;
    var startTouchesDistance = 0;
    var endTouchesDistance = 0;
    var pinchZoom = 1;
    var pinchDistance = 0;
    var pinchDirection = 0;
    var maximumsMap = null;

    //jQuery wrapped element for this instance
    var $element = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(element);

    //Current phase of th touch cycle
    var phase = "start";

    // the current number of fingers being used.
    var fingerCount = 0;

    //track mouse points / delta
    var fingerData = {};

    //track times
    var startTime = 0;

    var endTime = 0;
    var previousTouchEndTime = 0;
    var fingerCountAtRelease = 0;
    var doubleTapStartTime = 0;

    //Timeouts
    var singleTapTimeout = null;

    var holdTimeout = null;

    // Add gestures to all swipable areas if supported
    try {
        $element.bind(START_EV, touchStart);
        $element.bind(CANCEL_EV, touchCancel);
    } catch (e) {
        __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.error('events not supported ' + START_EV + ',' + CANCEL_EV + ' on jQuery.swipe');
    }

    //
    //Public methods
    //

    /**
     * re-enables the swipe plugin with the previous configuration
     * @function
     * @name $.fn.swipe#enable
     * @return {DOMNode} The Dom element that was registered with TouchSwipe
     * @example $("#element").swipe("enable");
     */
    this.enable = function () {
        $element.bind(START_EV, touchStart);
        $element.bind(CANCEL_EV, touchCancel);
        return $element;
    };

    /**
     * disables the swipe plugin
     * @function
     * @name $.fn.swipe#disable
     * @return {DOMNode} The Dom element that is now registered with TouchSwipe
     * @example $("#element").swipe("disable");
     */
    this.disable = function () {
        removeListeners();
        return $element;
    };

    /**
     * Destroy the swipe plugin completely. To use any swipe methods, you must re initialise the plugin.
     * @function
     * @name $.fn.swipe#destroy
     * @example $("#element").swipe("destroy");
     */
    this.destroy = function () {
        removeListeners();
        $element.data(PLUGIN_NS, null);
        $element = null;
    };

    /**
     * Allows run time updating of the swipe configuration options.
     * @function
     * @name $.fn.swipe#option
     * @param {String} property The option property to get or set, or a has of multiple options to set
     * @param {Object} [value] The value to set the property to
     * @return {Object} If only a property name is passed, then that property value is returned. If nothing is passed the current options hash is returned.
     * @example $("#element").swipe("option", "threshold"); // return the threshold
     * @example $("#element").swipe("option", "threshold", 100); // set the threshold after init
     * @example $("#element").swipe("option", {threshold:100, fingers:3} ); // set multiple properties after init
     * @example $("#element").swipe({threshold:100, fingers:3} ); // set multiple properties after init - the "option" method is optional!
     * @example $("#element").swipe("option"); // Return the current options hash
     * @see $.fn.swipe.defaults
     *
     */
    this.option = function (property, value) {

        if ((typeof property === 'undefined' ? 'undefined' : _typeof(property)) === 'object') {
            options = __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.extend(options, property);
        } else if (options[property] !== undefined) {
            if (value === undefined) {
                return options[property];
            } else {
                options[property] = value;
            }
        } else if (!property) {
            return options;
        } else {
            __WEBPACK_IMPORTED_MODULE_0_jquery___default.a.error('Option ' + property + ' does not exist on jQuery.swipe.options');
        }

        return null;
    };
    //
    // EVENTS
    //
    /**
     * Event handler for a touch start event.
     * Stops the default click event from triggering and stores where we touched
     * @inner
     * @param {object} jqEvent The normalised jQuery event object.
     */
    function touchStart(jqEvent) {
        //If we already in a touch event (a finger already in use) then ignore subsequent ones..
        if (getTouchInProgress()) {
            return;
        }

        //Check if this element matches any in the excluded elements selectors,  or its parent is excluded, if so, DON'T swipe
        if (__WEBPACK_IMPORTED_MODULE_0_jquery___default()(jqEvent.target).closest(options.excludedElements, $element).length > 0) {
            return;
        }

        //As we use Jquery bind for events, we need to target the original event object
        //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
        var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;

        var ret = void 0;
        var touches = event.touches;
        var evt = touches ? touches[0] : event;

        phase = PHASE_START;

        //If we support touches, get the finger count
        if (touches) {
            // get the total number of fingers touching the screen
            fingerCount = touches.length;
        }
        //Else this is the desktop, so stop the browser from dragging content
        else if (options.preventDefaultEvents !== false) {
                jqEvent.preventDefault(); //call this on jq event so we are cross browser
            }

        //clear vars..
        distance = 0;
        direction = null;
        currentDirection = null;
        pinchDirection = null;
        duration = 0;
        startTouchesDistance = 0;
        endTouchesDistance = 0;
        pinchZoom = 1;
        pinchDistance = 0;
        maximumsMap = createMaximumsData();
        cancelMultiFingerRelease();

        //Create the default finger data
        createFingerData(0, evt);

        // check the number of fingers is what we are looking for, or we are capturing pinches
        if (!touches || fingerCount === options.fingers || options.fingers === ALL_FINGERS || hasPinches()) {
            // get the coordinates of the touch
            startTime = getTimeStamp();

            if (fingerCount == 2) {
                //Keep track of the initial pinch distance, so we can calculate the diff later
                //Store second finger data as start
                createFingerData(1, touches[1]);
                startTouchesDistance = endTouchesDistance = calculateTouchesDistance(fingerData[0].start, fingerData[1].start);
            }

            if (options.swipeStatus || options.pinchStatus) {
                ret = triggerHandler(event, phase);
            }
        } else {
            //A touch with more or less than the fingers we are looking for, so cancel
            ret = false;
        }

        //If we have a return value from the users handler, then return and cancel
        if (ret === false) {
            phase = PHASE_CANCEL;
            triggerHandler(event, phase);
            return ret;
        } else {
            if (options.hold) {
                holdTimeout = setTimeout(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.proxy(function () {
                    //Trigger the event
                    $element.trigger('hold', [event.target]);
                    //Fire the callback
                    if (options.hold) {
                        ret = options.hold.call($element, event, event.target);
                    }
                }, this), options.longTapThreshold);
            }

            setTouchInProgress(true);
        }

        return null;
    }

    /**
     * Event handler for a touch move event.
     * If we change fingers during move, then cancel the event
     * @inner
     * @param {object} jqEvent The normalised jQuery event object.
     */
    function touchMove(jqEvent) {
        //As we use Jquery bind for events, we need to target the original event object
        //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
        var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;

        //If we are ending, cancelling, or within the threshold of 2 fingers being released, don't track anything..
        if (phase === PHASE_END || phase === PHASE_CANCEL || inMultiFingerRelease()) return;

        var ret = void 0;
        var touches = event.touches;
        var evt = touches ? touches[0] : event;

        //Update the  finger data
        var currentFinger = updateFingerData(evt);
        endTime = getTimeStamp();

        if (touches) {
            fingerCount = touches.length;
        }

        if (options.hold) clearTimeout(holdTimeout);

        phase = PHASE_MOVE;

        //If we have 2 fingers get Touches distance as well
        if (fingerCount == 2) {

            //Keep track of the initial pinch distance, so we can calculate the diff later
            //We do this here as well as the start event, in case they start with 1 finger, and the press 2 fingers
            if (startTouchesDistance == 0) {
                //Create second finger if this is the first time...
                createFingerData(1, touches[1]);

                startTouchesDistance = endTouchesDistance = calculateTouchesDistance(fingerData[0].start, fingerData[1].start);
            } else {
                //Else just update the second finger
                updateFingerData(touches[1]);

                endTouchesDistance = calculateTouchesDistance(fingerData[0].end, fingerData[1].end);
                pinchDirection = calculatePinchDirection(fingerData[0].end, fingerData[1].end);
            }

            pinchZoom = calculatePinchZoom(startTouchesDistance, endTouchesDistance);
            pinchDistance = Math.abs(startTouchesDistance - endTouchesDistance);
        }

        if (fingerCount === options.fingers || options.fingers === ALL_FINGERS || !touches || hasPinches()) {

            //The overall direction of the swipe. From start to now.
            direction = calculateDirection(currentFinger.start, currentFinger.end);

            //The immediate direction of the swipe, direction between the last movement and this one.
            currentDirection = calculateDirection(currentFinger.last, currentFinger.end);

            //Check if we need to prevent default event (page scroll / pinch zoom) or not
            validateDefaultEvent(jqEvent, currentDirection);

            //Distance and duration are all off the main finger
            distance = calculateDistance(currentFinger.start, currentFinger.end);
            duration = calculateDuration();

            //Cache the maximum distance we made in this direction
            setMaxDistance(direction, distance);

            //Trigger status handler
            ret = triggerHandler(event, phase);

            //If we trigger end events when threshold are met, or trigger events when touch leaves element
            if (!options.triggerOnTouchEnd || options.triggerOnTouchLeave) {

                var inBounds = true;

                //If checking if we leave the element, run the bounds check (we can use touchleave as its not supported on webkit)
                if (options.triggerOnTouchLeave) {
                    var bounds = getbounds(this);
                    inBounds = isInBounds(currentFinger.end, bounds);
                }

                //Trigger end handles as we swipe if thresholds met or if we have left the element if the user has asked to check these..
                if (!options.triggerOnTouchEnd && inBounds) {
                    phase = getNextPhase(PHASE_MOVE);
                }
                //We end if out of bounds here, so set current phase to END, and check if its modified
                else if (options.triggerOnTouchLeave && !inBounds) {
                        phase = getNextPhase(PHASE_END);
                    }

                if (phase == PHASE_CANCEL || phase == PHASE_END) {
                    triggerHandler(event, phase);
                }
            }
        } else {
            phase = PHASE_CANCEL;
            triggerHandler(event, phase);
        }

        if (ret === false) {
            phase = PHASE_CANCEL;
            triggerHandler(event, phase);
        }
    }

    /**
     * Event handler for a touch end event.
     * Calculate the direction and trigger events
     * @inner
     * @param {object} jqEvent The normalised jQuery event object.
     */
    function touchEnd(jqEvent) {
        //As we use Jquery bind for events, we need to target the original event object
        //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
        var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;

        var touches = event.touches;

        //If we are still in a touch with the device wait a fraction and see if the other finger comes up
        //if it does within the threshold, then we treat it as a multi release, not a single release and end the touch / swipe
        if (touches) {
            if (touches.length && !inMultiFingerRelease()) {
                startMultiFingerRelease(event);
                return true;
            } else if (touches.length && inMultiFingerRelease()) {
                return true;
            }
        }

        //If a previous finger has been released, check how long ago, if within the threshold, then assume it was a multifinger release.
        //This is used to allow 2 fingers to release fractionally after each other, whilst maintaining the event as containing 2 fingers, not 1
        if (inMultiFingerRelease()) {
            fingerCount = fingerCountAtRelease;
        }

        //Set end of swipe
        endTime = getTimeStamp();

        //Get duration incase move was never fired
        duration = calculateDuration();

        //If we trigger handlers at end of swipe OR, we trigger during, but they didnt trigger and we are still in the move phase
        if (didSwipeBackToCancel() || !validateSwipeDistance()) {
            phase = PHASE_CANCEL;
            triggerHandler(event, phase);
        } else if (options.triggerOnTouchEnd || options.triggerOnTouchEnd == false && phase === PHASE_MOVE) {
            //call this on jq event so we are cross browser
            if (options.preventDefaultEvents !== false) {
                jqEvent.preventDefault();
            }
            phase = PHASE_END;
            triggerHandler(event, phase);
        }
        //Special cases - A tap should always fire on touch end regardless,
        //So here we manually trigger the tap end handler by itself
        //We dont run trigger handler as it will re-trigger events that may have fired already
        else if (!options.triggerOnTouchEnd && hasTap()) {
                //Trigger the pinch events...
                phase = PHASE_END;
                triggerHandlerForGesture(event, phase, TAP);
            } else if (phase === PHASE_MOVE) {
                phase = PHASE_CANCEL;
                triggerHandler(event, phase);
            }

        setTouchInProgress(false);

        return null;
    }

    /**
     * Event handler for a touch cancel event.
     * Clears current vars
     * @inner
     */
    function touchCancel() {
        // reset the variables back to default values
        fingerCount = 0;
        endTime = 0;
        startTime = 0;
        startTouchesDistance = 0;
        endTouchesDistance = 0;
        pinchZoom = 1;

        //If we were in progress of tracking a possible multi touch end, then re set it.
        cancelMultiFingerRelease();

        setTouchInProgress(false);
    }

    /**
     * Event handler for a touch leave event.
     * This is only triggered on desktops, in touch we work this out manually
     * as the touchleave event is not supported in webkit
     * @inner
     */
    function touchLeave(jqEvent) {
        //If these events are being programmatically triggered, we don't have an original event object, so use the Jq one.
        var event = jqEvent.originalEvent ? jqEvent.originalEvent : jqEvent;

        //If we have the trigger on leave property set....
        if (options.triggerOnTouchLeave) {
            phase = getNextPhase(PHASE_END);
            triggerHandler(event, phase);
        }
    }

    /**
     * Removes all listeners that were associated with the plugin
     * @inner
     */
    function removeListeners() {
        $element.unbind(START_EV, touchStart);
        $element.unbind(CANCEL_EV, touchCancel);
        $element.unbind(MOVE_EV, touchMove);
        $element.unbind(END_EV, touchEnd);

        //we only have leave events on desktop, we manually calculate leave on touch as its not supported in webkit
        if (LEAVE_EV) {
            $element.unbind(LEAVE_EV, touchLeave);
        }

        setTouchInProgress(false);
    }

    /**
     * Checks if the time and distance thresholds have been met, and if so then the appropriate handlers are fired.
     */
    function getNextPhase(currentPhase) {

        var nextPhase = currentPhase;

        // Ensure we have valid swipe (under time and over distance  and check if we are out of bound...)
        var validTime = validateSwipeTime();
        var validDistance = validateSwipeDistance();
        var didCancel = didSwipeBackToCancel();

        //If we have exceeded our time, then cancel
        if (!validTime || didCancel) {
            nextPhase = PHASE_CANCEL;
        }
        //Else if we are moving, and have reached distance then end
        else if (validDistance && currentPhase == PHASE_MOVE && (!options.triggerOnTouchEnd || options.triggerOnTouchLeave)) {
                nextPhase = PHASE_END;
            }
            //Else if we have ended by leaving and didn't reach distance, then cancel
            else if (!validDistance && currentPhase == PHASE_END && options.triggerOnTouchLeave) {
                    nextPhase = PHASE_CANCEL;
                }

        return nextPhase;
    }

    /**
     * Trigger the relevant event handler
     * The handlers are passed the original event, the element that was swiped, and in the case of the catch all handler, the direction that was swiped, "left", "right", "up", or "down"
     * @param {object} event the original event object
     * @param {string} phase the phase of the swipe (start, end cancel etc) {@link $.fn.swipe.phases}
     * @inner
     */
    function triggerHandler(event, phase) {
        var ret = void 0;
        var touches = event.touches;

        // SWIPE GESTURES
        if (didSwipe() || hasSwipes()) {
            ret = triggerHandlerForGesture(event, phase, SWIPE);
        }

        // PINCH GESTURES (if the above didn't cancel)
        if ((didPinch() || hasPinches()) && ret !== false) {
            ret = triggerHandlerForGesture(event, phase, PINCH);
        }

        // CLICK / TAP (if the above didn't cancel)
        if (didDoubleTap() && ret !== false) {
            //Trigger the tap events...
            ret = triggerHandlerForGesture(event, phase, DOUBLE_TAP);
        }

        // CLICK / TAP (if the above didn't cancel)
        else if (didLongTap() && ret !== false) {
                //Trigger the tap events...
                ret = triggerHandlerForGesture(event, phase, LONG_TAP);
            }

            // CLICK / TAP (if the above didn't cancel)
            else if (didTap() && ret !== false) {
                    //Trigger the tap event..
                    ret = triggerHandlerForGesture(event, phase, TAP);
                }

        // If we are cancelling the gesture, then manually trigger the reset handler
        if (phase === PHASE_CANCEL) {
            if (hasSwipes()) {
                ret = triggerHandlerForGesture(event, phase, SWIPE);
            }

            if (hasPinches()) {
                ret = triggerHandlerForGesture(event, phase, PINCH);
            }
            touchCancel(event);
        }

        // If we are ending the gesture, then manually trigger the reset handler IF all fingers are off
        if (phase === PHASE_END) {
            //If we support touch, then check that all fingers are off before we cancel
            if (touches) {
                if (!touches.length) {
                    touchCancel(event);
                }
            } else {
                touchCancel(event);
            }
        }

        return ret;
    }

    /**
     * Trigger the relevant event handler
     * The handlers are passed the original event, the element that was swiped, and in the case of the catch all handler, the direction that was swiped, "left", "right", "up", or "down"
     * @param {object} event the original event object
     * @param {string} phase the phase of the swipe (start, end cancel etc) {@link $.fn.swipe.phases}
     * @param {string} gesture the gesture to trigger a handler for : PINCH or SWIPE {@link $.fn.swipe.gestures}
     * @return Boolean False, to indicate that the event should stop propagation, or void.
     * @inner
     */
    function triggerHandlerForGesture(event, phase, gesture) {

        var ret = void 0;

        //SWIPES....
        if (gesture == SWIPE) {
            //Trigger status every time..
            $element.trigger('swipeStatus', [phase, direction || null, distance || 0, duration || 0, fingerCount, fingerData, currentDirection]);

            if (options.swipeStatus) {
                ret = options.swipeStatus.call($element, event, phase, direction || null, distance || 0, duration || 0, fingerCount, fingerData, currentDirection);
                //If the status cancels, then dont run the subsequent event handlers..
                if (ret === false) return false;
            }

            if (phase == PHASE_END && validateSwipe()) {

                //Cancel any taps that were in progress...
                clearTimeout(singleTapTimeout);
                clearTimeout(holdTimeout);

                $element.trigger('swipe', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

                if (options.swipe) {
                    ret = options.swipe.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
                    //If the status cancels, then dont run the subsequent event handlers..
                    if (ret === false) return false;
                }

                //trigger direction specific event handlers
                switch (direction) {
                    case LEFT:
                        $element.trigger('swipeLeft', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

                        if (options.swipeLeft) {
                            ret = options.swipeLeft.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
                        }
                        break;

                    case RIGHT:
                        $element.trigger('swipeRight', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

                        if (options.swipeRight) {
                            ret = options.swipeRight.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
                        }
                        break;

                    case UP:
                        $element.trigger('swipeUp', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

                        if (options.swipeUp) {
                            ret = options.swipeUp.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
                        }
                        break;

                    case DOWN:
                        $element.trigger('swipeDown', [direction, distance, duration, fingerCount, fingerData, currentDirection]);

                        if (options.swipeDown) {
                            ret = options.swipeDown.call($element, event, direction, distance, duration, fingerCount, fingerData, currentDirection);
                        }
                        break;
                }
            }
        }

        //PINCHES....
        if (gesture == PINCH) {
            $element.trigger('pinchStatus', [phase, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]);

            if (options.pinchStatus) {
                ret = options.pinchStatus.call($element, event, phase, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData);
                //If the status cancels, then dont run the subsequent event handlers..
                if (ret === false) return false;
            }

            if (phase == PHASE_END && validatePinch()) {

                switch (pinchDirection) {
                    case IN:
                        $element.trigger('pinchIn', [pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]);

                        if (options.pinchIn) {
                            ret = options.pinchIn.call($element, event, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData);
                        }
                        break;

                    case OUT:
                        $element.trigger('pinchOut', [pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData]);

                        if (options.pinchOut) {
                            ret = options.pinchOut.call($element, event, pinchDirection || null, pinchDistance || 0, duration || 0, fingerCount, pinchZoom, fingerData);
                        }
                        break;
                }
            }
        }

        if (gesture == TAP) {
            if (phase === PHASE_CANCEL || phase === PHASE_END) {

                clearTimeout(singleTapTimeout);
                clearTimeout(holdTimeout);

                //If we are also looking for doubelTaps, wait incase this is one...
                if (hasDoubleTap() && !inDoubleTap()) {
                    doubleTapStartTime = getTimeStamp();

                    //Now wait for the double tap timeout, and trigger this single tap
                    //if its not cancelled by a double tap
                    singleTapTimeout = setTimeout(__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.proxy(function () {
                        doubleTapStartTime = null;
                        $element.trigger('tap', [event.target]);

                        if (options.tap) {
                            ret = options.tap.call($element, event, event.target);
                        }
                    }, this), options.doubleTapThreshold);
                } else {
                    doubleTapStartTime = null;
                    $element.trigger('tap', [event.target]);
                    if (options.tap) {
                        ret = options.tap.call($element, event, event.target);
                    }
                }
            }
        } else if (gesture == DOUBLE_TAP) {
            if (phase === PHASE_CANCEL || phase === PHASE_END) {
                clearTimeout(singleTapTimeout);
                clearTimeout(holdTimeout);
                doubleTapStartTime = null;
                $element.trigger('doubletap', [event.target]);

                if (options.doubleTap) {
                    ret = options.doubleTap.call($element, event, event.target);
                }
            }
        } else if (gesture == LONG_TAP) {
            if (phase === PHASE_CANCEL || phase === PHASE_END) {
                clearTimeout(singleTapTimeout);
                doubleTapStartTime = null;

                $element.trigger('longtap', [event.target]);
                if (options.longTap) {
                    ret = options.longTap.call($element, event, event.target);
                }
            }
        }

        return ret;
    }
    //
    // GESTURE VALIDATION
    //

    /**
     * Checks the user has swipe far enough
     * @return Boolean if <code>threshold</code> has been set, return true if the threshold was met, else false.
     * If no threshold was set, then we return true.
     * @inner
     */
    function validateSwipeDistance() {
        var valid = true;
        //If we made it past the min swipe distance..
        if (options.threshold !== null) {
            valid = distance >= options.threshold;
        }

        return valid;
    }

    /**
     * Checks the user has swiped back to cancel.
     * @return Boolean if <code>cancelThreshold</code> has been set, return true if the cancelThreshold was met, else false.
     * If no cancelThreshold was set, then we return true.
     * @inner
     */
    function didSwipeBackToCancel() {
        var cancelled = false;
        if (options.cancelThreshold !== null && direction !== null) {
            cancelled = getMaxDistance(direction) - distance >= options.cancelThreshold;
        }

        return cancelled;
    }

    /**
     * Checks the user has pinched far enough
     * @return Boolean if <code>pinchThreshold</code> has been set, return true if the threshold was met, else false.
     * If no threshold was set, then we return true.
     * @inner
     */
    function validatePinchDistance() {
        if (options.pinchThreshold !== null) {
            return pinchDistance >= options.pinchThreshold;
        }
        return true;
    }

    /**
     * Checks that the time taken to swipe meets the minimum / maximum requirements
     * @return Boolean
     * @inner
     */
    function validateSwipeTime() {
        var result = void 0;
        //If no time set, then return true
        if (options.maxTimeThreshold) {
            if (duration >= options.maxTimeThreshold) {
                result = false;
            } else {
                result = true;
            }
        } else {
            result = true;
        }

        return result;
    }

    /**
     * Checks direction of the swipe and the value allowPageScroll to see if we should allow or prevent the default behaviour from occurring.
     * This will essentially allow page scrolling or not when the user is swiping on a touchSwipe object.
     * @param {object} jqEvent The normalised jQuery representation of the event object.
     * @param {string} direction The direction of the event. See {@link $.fn.swipe.directions}
     * @see $.fn.swipe.directions
     * @inner
     */
    function validateDefaultEvent(jqEvent, direction) {

        //If the option is set, allways allow the event to bubble up (let user handle weirdness)
        if (options.preventDefaultEvents === false) {
            return;
        }

        if (options.allowPageScroll === NONE) {
            jqEvent.preventDefault();
        } else {
            var auto = options.allowPageScroll === AUTO;

            switch (direction) {
                case LEFT:
                    if (options.swipeLeft && auto || !auto && options.allowPageScroll != HORIZONTAL) {
                        jqEvent.preventDefault();
                    }
                    break;

                case RIGHT:
                    if (options.swipeRight && auto || !auto && options.allowPageScroll != HORIZONTAL) {
                        jqEvent.preventDefault();
                    }
                    break;

                case UP:
                    if (options.swipeUp && auto || !auto && options.allowPageScroll != VERTICAL) {
                        jqEvent.preventDefault();
                    }
                    break;

                case DOWN:
                    if (options.swipeDown && auto || !auto && options.allowPageScroll != VERTICAL) {
                        jqEvent.preventDefault();
                    }
                    break;
            }
        }
    }

    // PINCHES
    /**
     * Returns true of the current pinch meets the thresholds
     * @return Boolean
     * @inner
     */
    function validatePinch() {
        var hasCorrectFingerCount = validateFingers();
        var hasEndPoint = validateEndPoint();
        var hasCorrectDistance = validatePinchDistance();
        return hasCorrectFingerCount && hasEndPoint && hasCorrectDistance;
    }

    /**
     * Returns true if any Pinch events have been registered
     * @return Boolean
     * @inner
     */
    function hasPinches() {
        //Enure we dont return 0 or null for false values
        return !!(options.pinchStatus || options.pinchIn || options.pinchOut);
    }

    /**
     * Returns true if we are detecting pinches, and have one
     * @return Boolean
     * @inner
     */
    function didPinch() {
        //Enure we dont return 0 or null for false values
        return !!(validatePinch() && hasPinches());
    }

    // SWIPES
    /**
     * Returns true if the current swipe meets the thresholds
     * @return Boolean
     * @inner
     */
    function validateSwipe() {
        //Check validity of swipe
        var hasValidTime = validateSwipeTime();
        var hasValidDistance = validateSwipeDistance();
        var hasCorrectFingerCount = validateFingers();
        var hasEndPoint = validateEndPoint();
        var didCancel = didSwipeBackToCancel();

        // if the user swiped more than the minimum length, perform the appropriate action
        // hasValidDistance is null when no distance is set
        var valid = !didCancel && hasEndPoint && hasCorrectFingerCount && hasValidDistance && hasValidTime;

        return valid;
    }

    /**
     * Returns true if any Swipe events have been registered
     * @return Boolean
     * @inner
     */
    function hasSwipes() {
        //Enure we dont return 0 or null for false values
        return !!(options.swipe || options.swipeStatus || options.swipeLeft || options.swipeRight || options.swipeUp || options.swipeDown);
    }

    /**
     * Returns true if we are detecting swipes and have one
     * @return Boolean
     * @inner
     */
    function didSwipe() {
        //Enure we dont return 0 or null for false values
        return !!(validateSwipe() && hasSwipes());
    }

    /**
     * Returns true if we have matched the number of fingers we are looking for
     * @return Boolean
     * @inner
     */
    function validateFingers() {
        //The number of fingers we want were matched, or on desktop we ignore
        return fingerCount === options.fingers || options.fingers === ALL_FINGERS || !SUPPORTS_TOUCH;
    }

    /**
     * Returns true if we have an end point for the swipe
     * @return Boolean
     * @inner
     */
    function validateEndPoint() {
        //We have an end value for the finger
        return fingerData[0].end.x !== 0;
    }

    // TAP / CLICK
    /**
     * Returns true if a click / tap events have been registered
     * @return Boolean
     * @inner
     */
    function hasTap() {
        //Enure we dont return 0 or null for false values
        return !!options.tap;
    }

    /**
     * Returns true if a double tap events have been registered
     * @return Boolean
     * @inner
     */
    function hasDoubleTap() {
        //Enure we dont return 0 or null for false values
        return !!options.doubleTap;
    }

    /**
     * Returns true if any long tap events have been registered
     * @return Boolean
     * @inner
     */
    function hasLongTap() {
        //Enure we dont return 0 or null for false values
        return !!options.longTap;
    }

    /**
     * Returns true if we could be in the process of a double tap (one tap has occurred, we are listening for double taps, and the threshold hasn't past.
     * @return Boolean
     * @inner
     */
    function validateDoubleTap() {
        if (doubleTapStartTime == null) {
            return false;
        }
        var now = getTimeStamp();
        return hasDoubleTap() && now - doubleTapStartTime <= options.doubleTapThreshold;
    }

    /**
     * Returns true if we could be in the process of a double tap (one tap has occurred, we are listening for double taps, and the threshold hasn't past.
     * @return Boolean
     * @inner
     */
    function inDoubleTap() {
        return validateDoubleTap();
    }

    /**
     * Returns true if we have a valid tap
     * @return Boolean
     * @inner
     */
    function validateTap() {
        return (fingerCount === 1 || !SUPPORTS_TOUCH) && (isNaN(distance) || distance < options.threshold);
    }

    /**
     * Returns true if we have a valid long tap
     * @return Boolean
     * @inner
     */
    function validateLongTap() {
        //slight threshold on moving finger
        return duration > options.longTapThreshold && distance < DOUBLE_TAP_THRESHOLD;
    }

    /**
     * Returns true if we are detecting taps and have one
     * @return Boolean
     * @inner
     */
    function didTap() {
        //Enure we dont return 0 or null for false values
        return !!(validateTap() && hasTap());
    }

    /**
     * Returns true if we are detecting double taps and have one
     * @return Boolean
     * @inner
     */
    function didDoubleTap() {
        //Enure we dont return 0 or null for false values
        return !!(validateDoubleTap() && hasDoubleTap());
    }

    /**
     * Returns true if we are detecting long taps and have one
     * @return Boolean
     * @inner
     */
    function didLongTap() {
        //Enure we dont return 0 or null for false values
        return !!(validateLongTap() && hasLongTap());
    }

    // MULTI FINGER TOUCH
    /**
     * Starts tracking the time between 2 finger releases, and keeps track of how many fingers we initially had up
     * @inner
     */
    function startMultiFingerRelease(event) {
        previousTouchEndTime = getTimeStamp();
        fingerCountAtRelease = event.touches.length + 1;
    }

    /**
     * Cancels the tracking of time between 2 finger releases, and resets counters
     * @inner
     */
    function cancelMultiFingerRelease() {
        previousTouchEndTime = 0;
        fingerCountAtRelease = 0;
    }

    /**
     * Checks if we are in the threshold between 2 fingers being released
     * @return Boolean
     * @inner
     */
    function inMultiFingerRelease() {

        var withinThreshold = false;

        if (previousTouchEndTime) {
            var diff = getTimeStamp() - previousTouchEndTime;
            if (diff <= options.fingerReleaseThreshold) {
                withinThreshold = true;
            }
        }

        return withinThreshold;
    }

    /**
     * gets a data flag to indicate that a touch is in progress
     * @return Boolean
     * @inner
     */
    function getTouchInProgress() {
        //strict equality to ensure only true and false are returned
        return !!($element.data(PLUGIN_NS + '_intouch') === true);
    }

    /**
     * Sets a data flag to indicate that a touch is in progress
     * @param {boolean} val The value to set the property to
     * @inner
     */
    function setTouchInProgress(val) {

        //If destroy is called in an event handler, we have no el, and we have already cleaned up, so return.
        if (!$element) {
            return;
        }

        //Add or remove event listeners depending on touch status
        if (val === true) {
            $element.bind(MOVE_EV, touchMove);
            $element.bind(END_EV, touchEnd);

            //we only have leave events on desktop, we manually calcuate leave on touch as its not supported in webkit
            if (LEAVE_EV) {
                $element.bind(LEAVE_EV, touchLeave);
            }
        } else {

            $element.unbind(MOVE_EV, touchMove, false);
            $element.unbind(END_EV, touchEnd, false);

            //we only have leave events on desktop, we manually calcuate leave on touch as its not supported in webkit
            if (LEAVE_EV) {
                $element.unbind(LEAVE_EV, touchLeave, false);
            }
        }

        //strict equality to ensure only true and false can update the value
        $element.data(PLUGIN_NS + '_intouch', val === true);
    }

    /**
     * Creates the finger data for the touch/finger in the event object.
     * @param {int} id The id to store the finger data under (usually the order the fingers were pressed)
     * @param {object} evt The event object containing finger data
     * @return finger data object
     * @inner
     */
    function createFingerData(id, evt) {
        var f = {
            start: {
                x: 0,
                y: 0
            },
            last: {
                x: 0,
                y: 0
            },
            end: {
                x: 0,
                y: 0
            }
        };
        f.start.x = f.last.x = f.end.x = evt.pageX || evt.clientX;
        f.start.y = f.last.y = f.end.y = evt.pageY || evt.clientY;
        fingerData[id] = f;
        return f;
    }

    /**
     * Updates the finger data for a particular event object
     * @param {object} evt The event object containing the touch/finger data to upadte
     * @return a finger data object.
     * @inner
     */
    function updateFingerData(evt) {
        var id = evt.identifier !== undefined ? evt.identifier : 0;
        var f = getFingerData(id);

        if (f === null) {
            f = createFingerData(id, evt);
        }

        f.last.x = f.end.x;
        f.last.y = f.end.y;

        f.end.x = evt.pageX || evt.clientX;
        f.end.y = evt.pageY || evt.clientY;

        return f;
    }

    /**
     * Returns a finger data object by its event ID.
     * Each touch event has an identifier property, which is used
     * to track repeat touches
     * @param {int} id The unique id of the finger in the sequence of touch events.
     * @return a finger data object.
     * @inner
     */
    function getFingerData(id) {
        return fingerData[id] || null;
    }

    /**
     * Sets the maximum distance swiped in the given direction.
     * If the new value is lower than the current value, the max value is not changed.
     * @param {string}  direction The direction of the swipe
     * @param {int}  distance The distance of the swipe
     * @inner
     */
    function setMaxDistance(direction, distance) {
        distance = Math.max(distance, getMaxDistance(direction));
        maximumsMap[direction].distance = distance;
    }

    /**
     * gets the maximum distance swiped in the given direction.
     * @param {string}  direction The direction of the swipe
     * @return int  The distance of the swipe
     * @inner
     */
    function getMaxDistance(direction) {
        if (maximumsMap[direction]) return maximumsMap[direction].distance;
        return undefined;
    }

    /**
     * Creats a map of directions to maximum swiped values.
     * @return Object A dictionary of maximum values, indexed by direction.
     * @inner
     */
    function createMaximumsData() {
        var maxData = {};
        maxData[LEFT] = createMaximumVO(LEFT);
        maxData[RIGHT] = createMaximumVO(RIGHT);
        maxData[UP] = createMaximumVO(UP);
        maxData[DOWN] = createMaximumVO(DOWN);

        return maxData;
    }

    /**
     * Creates a map maximum swiped values for a given swipe direction
     * @param {string} The direction that these values will be associated with
     * @return Object Maximum values
     * @inner
     */
    function createMaximumVO(dir) {
        return {
            direction: dir,
            distance: 0
        };
    }
    //
    // MATHS / UTILS
    //

    /**
     * Calculate the duration of the swipe
     * @return int
     * @inner
     */
    function calculateDuration() {
        return endTime - startTime;
    }

    /**
     * Calculate the distance between 2 touches (pinch)
     * @param {point} startPoint A point object containing x and y co-ordinates
     * @param {point} endPoint A point object containing x and y co-ordinates
     * @return int;
     * @inner
     */
    function calculateTouchesDistance(startPoint, endPoint) {
        var diffX = Math.abs(startPoint.x - endPoint.x);
        var diffY = Math.abs(startPoint.y - endPoint.y);

        return Math.round(Math.sqrt(diffX * diffX + diffY * diffY));
    }

    /**
     * Calculate the zoom factor between the start and end distances
     * @param {int} startDistance Distance (between 2 fingers) the user started pinching at
     * @param {int} endDistance Distance (between 2 fingers) the user ended pinching at
     * @return float The zoom value from 0 to 1.
     * @inner
     */
    function calculatePinchZoom(startDistance, endDistance) {
        var percent = endDistance / startDistance * 1;
        return percent.toFixed(2);
    }

    /**
     * Returns the pinch direction, either IN or OUT for the given points
     * @return string Either {@link $.fn.swipe.directions.IN} or {@link $.fn.swipe.directions.OUT}
     * @see $.fn.swipe.directions
     * @inner
     */
    function calculatePinchDirection() {
        if (pinchZoom < 1) {
            return OUT;
        } else {
            return IN;
        }
    }

    /**
     * Calculate the length / distance of the swipe
     * @param {point} startPoint A point object containing x and y co-ordinates
     * @param {point} endPoint A point object containing x and y co-ordinates
     * @return int
     * @inner
     */
    function calculateDistance(startPoint, endPoint) {
        return Math.round(Math.sqrt(Math.pow(endPoint.x - startPoint.x, 2) + Math.pow(endPoint.y - startPoint.y, 2)));
    }

    /**
     * Calculate the angle of the swipe
     * @param {point} startPoint A point object containing x and y co-ordinates
     * @param {point} endPoint A point object containing x and y co-ordinates
     * @return int
     * @inner
     */
    function calculateAngle(startPoint, endPoint) {
        var x = startPoint.x - endPoint.x;
        var y = endPoint.y - startPoint.y;
        var r = Math.atan2(y, x); //radians
        var angle = Math.round(r * 180 / Math.PI); //degrees

        //ensure value is positive
        if (angle < 0) {
            angle = 360 - Math.abs(angle);
        }

        return angle;
    }

    /**
     * Calculate the direction of the swipe
     * This will also call calculateAngle to get the latest angle of swipe
     * @param {point} startPoint A point object containing x and y co-ordinates
     * @param {point} endPoint A point object containing x and y co-ordinates
     * @return string Either {@link $.fn.swipe.directions.LEFT} / {@link $.fn.swipe.directions.RIGHT} / {@link $.fn.swipe.directions.DOWN} / {@link $.fn.swipe.directions.UP}
     * @see $.fn.swipe.directions
     * @inner
     */
    function calculateDirection(startPoint, endPoint) {
        var angle = calculateAngle(startPoint, endPoint);

        if (angle <= 45 && angle >= 0) {
            return LEFT;
        } else if (angle <= 360 && angle >= 315) {
            return LEFT;
        } else if (angle >= 135 && angle <= 225) {
            return RIGHT;
        } else if (angle > 45 && angle < 135) {
            return DOWN;
        } else {
            return UP;
        }
    }

    /**
     * Returns a MS time stamp of the current time
     * @return int
     * @inner
     */
    function getTimeStamp() {
        var now = new Date();
        return now.getTime();
    }

    /**
     * Returns a bounds object with left, right, top and bottom properties for the element specified.
     * @param {DomNode} The DOM node to get the bounds for.
     */
    function getbounds(el) {
        el = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(el);
        var offset = el.offset();

        var bounds = {
            left: offset.left,
            right: offset.left + el.outerWidth(),
            top: offset.top,
            bottom: offset.top + el.outerHeight()
        };

        return bounds;
    }

    /**
     * Checks if the point object is in the bounds object.
     * @param {object} point A point object.
     * @param {int} point.x The x value of the point.
     * @param {int} point.y The x value of the point.
     * @param {object} bounds The bounds object to test
     * @param {int} bounds.left The leftmost value
     * @param {int} bounds.right The righttmost value
     * @param {int} bounds.top The topmost value
     * @param {int} bounds.bottom The bottommost value
     */
    function isInBounds(point, bounds) {
        return point.x > bounds.left && point.x < bounds.right && point.y > bounds.top && point.y < bounds.bottom;
    }
}

/***/ }),
/* 368 */
/***/ (function(module, exports) {

(function (document, window) {
	// Reference: http://osvaldas.info/auto-hide-sticky-header
	var topBar = '.pusher .page-head';
	var topBarClassHidden = 'page-head--is-hidden';
	var bottomWrapper = '.bottom-wrapper';
	var bottomWrapperClassHidden = 'bottom-wrapper--is-hidden';
	var throttleTimeout = 500;
	var elementtopBar = document.querySelector(topBar);
	var elementBottomWrapper = document.querySelector(bottomWrapper);
	var container = document.querySelector('.content');

	var dHeight = 0;
	var wHeight = 0;
	var wScrollCurrent = 0;
	var wScrollBefore = 0;
	var wScrollDiff = 0;

	function addElementClass(element, className) {
		element.classList ? element.classList.add(className) : element.className += ' ' + className;
	}

	function removeElementClass(element, className) {
		element.classList ? element.classList.remove(className) : element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
	}

	function hideHeader() {
		if (elementtopBar) {
			addElementClass(elementtopBar, topBarClassHidden);
		}
	}

	function hideFooter() {
		if (elementBottomWrapper) {
			addElementClass(elementBottomWrapper, bottomWrapperClassHidden);
		}
	}

	function showHeader() {
		if (elementtopBar) {
			removeElementClass(elementtopBar, topBarClassHidden);
		}
	}

	function showFooter() {
		if (elementBottomWrapper) {
			removeElementClass(elementBottomWrapper, bottomWrapperClassHidden);
		}
	}

	function throttle(delay, fn) {
		var last = void 0;
		var deferTimer = void 0;
		return function timerHideBars() {
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}

			var context = this;
			var now = +new Date();
			if (last && now < last + delay) {
				clearTimeout(deferTimer);
				deferTimer = setTimeout(function () {
					last = now;
					fn.apply(context, args);
				}, delay);
			} else {
				last = now;
				fn.apply(context, args);
			}
		};
	}

	container && container.addEventListener('scroll', throttle(throttleTimeout, function (e) {
		dHeight = e.target.scrollHeight;
		wHeight = window.innerHeight;
		wScrollCurrent = e.target.scrollTop;
		wScrollDiff = wScrollBefore - wScrollCurrent;

		if (wScrollCurrent <= 0 || wScrollDiff > 0) {
			// scrolled to the very top; element sticks to the top
			showHeader();
			showFooter();
		} else if (wScrollDiff < 0) {
			// when scroll down
			if (wScrollCurrent + wHeight >= dHeight) {
				// scrolled to the very bottom; element slides in
				showHeader();
				showFooter();
			} else {
				// scrolled down; element slides out
				hideHeader();
				hideFooter();
			}
		}

		wScrollBefore = wScrollCurrent;
	}));
})(document, window);

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_tomcat_cookies_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_settings_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__websocket_websocket_event_esm_js__ = __webpack_require__(145);







var $globalNavigation = document.getElementsByClassName('global-menu')[0];
var $languageSelector = document.getElementById('language-settings-container');
var $switchToWebsite = document.getElementById('switchToWebsite');

// close support nav
function closeSupportNav() {
	document.querySelector('.support-nav').classList.remove('support-nav--is-open');
}

function menuItemSelected($menuItem) {
	$globalNavigation.getElementsByClassName('link-list__item')[0].classList.remove('link-list__item--is-selected');
	$menuItem.addClass('link-list__item--is-selected');
}

function selectMenuItem($menuItem) {
	if (!$menuItem[0].classList.contains('link-list__item--is-selected')) {
		var link = $menuItem.children('.link-list__item a').attr('href');
		if (link !== '#' && link) {
			__WEBPACK_IMPORTED_MODULE_1__libs_tomcat_cookies_js__["a" /* default */].set('navigation', $menuItem.data('product'), {
				path: '/'
			});
		}
		menuItemSelected($menuItem);
	}
}

function checkSessionCookieAndChangeIcon() {
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["c" /* sessionKey */])()) {
		var $pageHead = document.getElementsByClassName('pusher')[0].getElementsByClassName('page-head')[0];
		var pageHeadIconLogin = $pageHead.getElementsByClassName('header-icon--login')[0];
		pageHeadIconLogin.classList.remove('u-show');
		pageHeadIconLogin.classList.add('u-hide');

		var pageHeadIconAccount = $pageHead.getElementsByClassName('header-icon--account')[0];
		pageHeadIconAccount.classList.remove('logged-out', 'u-hide');
		pageHeadIconAccount.classList.add('u-show');
	}
}

function changeLanguage(newLocale) {
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["g" /* locale */])() !== newLocale) {
		__WEBPACK_IMPORTED_MODULE_1__libs_tomcat_cookies_js__["a" /* default */].set('locale', newLocale, {
			path: '/'
		});

		var url = '/locale/change';
		var options = {
			method: 'POST',
			credentials: 'include',
			headers: {
				"Content-type": "application/x-www-form-urlencoded; charset=UTF-8"
			},
			body: 'locale=' + newLocale
		};

		if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["c" /* sessionKey */])()) {
			fetch(url, options).then(location.reload());
		} else {
			location.reload();
		}
	}
}

function switchToWebsite() {
	__WEBPACK_IMPORTED_MODULE_4__websocket_websocket_event_esm_js__["a" /* default */].disconnect();
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["f" /* setDesktopCookies */])();
	var desktopHostname = location.host.replace('mobile.', '').replace('mobile-', '');
	window.location.href = location.protocol + "//" + desktopHostname + "/";
}

function displayLanguageList(menuItem) {
	menuItem.getElementsByClassName('custom-select')[0].classList.remove('u-hide');

	var options = $languageSelector.getElementsByTagName('option');
	for (var i = 0; i < options.length; i += 1) {
		var option = options[i];
		if (option.dataset.locale === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["g" /* locale */])()) {
			option.selected = true;
		} else {
			option.selected = false;
		}
	}
}

// Add scrollscope to deactivate scrolls on menus
// myScrollScopeInstance.bind(document);
function init() {
	//websocket connection
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["c" /* sessionKey */])()) {
		__WEBPACK_IMPORTED_MODULE_4__websocket_websocket_event_esm_js__["a" /* default */].connect(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["c" /* sessionKey */])());
	}

	// CLICK HANDLERS
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()($switchToWebsite).click(function (event) {
		switchToWebsite();
		event.stopPropagation();
	});

	/* Select language selector */
	var languageSelectorItem = document.getElementsByClassName('js-language-selector')[0];
	languageSelectorItem.onclick = function (event) {
		displayLanguageList(event.currentTarget);
		event.stopPropagation();
		$globalNavigation.getElementsByClassName('link-list__item')[0].classList.remove('link-list__item--is-selected');
		event.currentTarget.classList.add('link-list__item--is-selected');
	};

	var languageSelectElem = languageSelectorItem.getElementsByTagName('select')[0];
	languageSelectElem.onchange = function (event) {
		changeLanguage(event.currentTarget.selectedOptions[0].dataset.locale);
		event.stopPropagation();
	};

	// will avoid re-trigger the click handler on the menus
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()($languageSelector).on(__WEBPACK_IMPORTED_MODULE_3__config_settings_js__["a" /* eventType */], function (event) {
		event.stopPropagation();
		event.preventDefault();
	});

	__WEBPACK_IMPORTED_MODULE_0_jquery___default()($globalNavigation).on(__WEBPACK_IMPORTED_MODULE_3__config_settings_js__["a" /* eventType */], '.link-list__item', function (event) {
		if (event.currentTarget === this) {
			//event.preventDefault();
			event.stopPropagation();
			selectMenuItem(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
		}
	});

	// check cookie to highlight menu
	if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["d" /* navigation */])()) {
		menuItemSelected(__WEBPACK_IMPORTED_MODULE_0_jquery___default()($globalNavigation).find(".link-list__item[data-product=\"" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__store_cookies_js__["d" /* navigation */])() + "\"]"));
	}

	// check cookie to show account menu icon
	checkSessionCookieAndChangeIcon();
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.support-nav').on(__WEBPACK_IMPORTED_MODULE_3__config_settings_js__["a" /* eventType */], '.js-close-support-nav', function (e) {
		e.preventDefault();
		closeSupportNav();
	});

	// Swipe events for menues - close menues when user swipe on them
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.global-menu').swipe({
		// Generic swipe handler for all directions, parameters: (event, direction, distance, duration, fingerCount, fingerData)
		swipe: function swipe(direction) {
			if (direction === 'left') {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('menu--is-open');
			}
		}
	});

	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.account-menu').swipe({
		swipe: function swipe(direction) {
			if (direction === 'right') {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('menu--is-open');
			}
		}
	});
}

/* harmony default export */ __webpack_exports__["a"] = init;

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__view_js__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__ = __webpack_require__(20);
/*
bonuses
parse data from rest-api into app-specific format
*/






var register = __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__["a" /* default */].register;

var state = {
	selected: {
		id: -1,
		confirmed: false,
		validPaymentMethods: ''
	},
	by_id: null,
	amount_in: null,
	selectedPaymentMethod: null
};

function isEmptyCallback() {
	/* router.js may use this callback to enter next step if no bonuses exist */
}

function shopDepositBonusCallback() {
	/* callback for shop deposit bonus after completing bonus related steps*/
}

function viewUpdate() {
	__WEBPACK_IMPORTED_MODULE_0__view_js__["a" /* default */].update({
		bonuses: state
	});
}

function viewUpdateForSpinner() {
	__WEBPACK_IMPORTED_MODULE_0__view_js__["a" /* default */].update({
		completedBonusesFetch: true
	});
}

function bonusesToState(arr) {
	var filled = void 0;
	state.by_id = {};
	if (arr && arr.length > 0) {
		/* sort bonuses on bonusid */
		arr.forEach(function (elm) {
			if (elm.id) {
				state.by_id[elm.id] = elm;
			} else {
				console.error('bonuses:70:bonusesToState: can not get id from element', elm);
			}
		});
		filled = true;
		state.empty = false;
	} else {
		filled = false;
		state.empty = true;
	}
	return filled;
}

function sortMethodsToState() {
	var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	var bonuslistFilled = bonusesToState(data);
	viewUpdate();
	__WEBPACK_IMPORTED_MODULE_1__common_lib_utils_actions_js__["a" /* default */].bonuses(state);
	return bonuslistFilled;
}

function sortMethodsToStateFreeMoneyBonusSuccess() {
	var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	var bonuslistFilled = bonusesToState(data);
	__WEBPACK_IMPORTED_MODULE_0__view_js__["a" /* default */].updateFreeMoneyBonusSucces({
		bonuses: state
	});
	return bonuslistFilled;
}

function parseToStateAmountIn(amount, selectedPaymentMethod) {
	state.amount_in = amount;
	state.selectedPaymentMethod = selectedPaymentMethod;
}

function storeConfirmed() {
	if (state.selected) {
		if (state.selected.confirmed && state.selected.id && state.selected.id !== -1) {
			state.bonusid = state.selected.id;
			if (state.by_id && state.by_id[state.bonusid]) {
				state.selected.bonus = state.by_id[state.bonusid];
			}
		}
	} else {
		console.warn('bonuses:69:setSelected: empty property "selected" in state', state);
	}
}

function toPostfix(t) {
	// TODO add unit test to confirm functionality!!
	var noncharacters = new RegExp(/[^a-zA-Z]+/g);
	var str = t ? t.toString() : '';
	return str.replace(noncharacters, '');
}

function getAnyUnit(arr) {
	/* finds any letters in the input array, and returns the last of them as a unit */
	var unit = null;
	arr.forEach(function (val) {
		var lastletters = toPostfix(val);
		if (lastletters && lastletters.length > 0) {
			unit = lastletters;
		}
	});
	return unit;
}

function zeroOutsideLimits(val, min, max) {
	// if value is below min the returned value is zero.
	var adjusted = void 0;
	if (state.selectedPaymentMethod) {
		if (!(state.selected.validPaymentMethods.indexOf(state.selectedPaymentMethod.toString()) > -1)) {
			return 0;
		}
	}
	if (min && max) {
		/* return the value if within limits */
		adjusted = val >= min && val <= max ? val : 'check_limit';
		/* if returned value is zero, check against max limit */
		if (adjusted === 'check_limit') {
			if (val < min) {
				adjusted = 0;
			} else if (val >= max) {
				adjusted = max;
			}
		}
	} else if (min && !max) {
		adjusted = val >= min ? val : 0;
	} else if (!min && max) {
		adjusted = val <= max ? val : max;
	} else {
		/* no limits exist */
		adjusted = val;
	}
	return adjusted;
}

function percToValue(val, perc) {
	var value = 0;
	if (perc > 100) {
		console.warn('bonuses:percToValue: bonus larger than 100%', perc);
	}
	if (val && perc) {
		value = val * perc / 100;
	}
	return value;
}

function setConditionsMsg() {
	var bonus = void 0;
	var msg = '';
	if (state.selected && state.selected.bonus && state.selected.bonus.bonusPercentage) {
		bonus = state.selected.bonus;
		msg = ' ->' + (bonus.bonusPercentage || '') + ' x ' + (bonus.minDeposit || '') + '-' + (bonus.maxDeposit || '');
	}
	state.condition = msg;
}

function applyConditions() {
	/* if a percent is set, and min-max values exist, then calculate bonusAmount from amount_in and clamp between limits */
	/* if no rules are applicable return zero */
	var bonus = state.selected.bonus;
	var minDeposit = parseFloat(bonus.minDepositAmount);
	var maxDeposit = parseFloat(bonus.maxDepositAmount);
	var percent = parseFloat(bonus.bonusPercentageValue);
	var bonusAmount = parseFloat(bonus.bonusAmountValue) || 0;
	/* fixed, preset value */
	var amountIn = parseFloat(state.amount_in);
	var bonusAmountOut = zeroOutsideLimits(amountIn, minDeposit, maxDeposit);
	/* compare input amount to conditions in selected bonus */
	if (bonusAmount) {
		bonusAmountOut = bonusAmount;
	} else if (percent) {
		bonusAmountOut = percToValue(bonusAmountOut, percent);
	}
	state.condition = ' ->' + (bonus.bonusPercentage || '') + ' x ' + (bonus.minDeposit || '') + '-' + (bonus.maxDeposit || '');
	state.amount_out = bonusAmountOut;
	state.currency = getAnyUnit([bonus.minDeposit, bonus.maxDeposit, bonus.bonusAmount]);
	__WEBPACK_IMPORTED_MODULE_1__common_lib_utils_actions_js__["a" /* default */].bonuses(state);
	return bonusAmountOut;
}

function setSelectedAndPublishStateForShopDepositBonus(data, selectedBonusId, paymentMethods) {
	bonusesToState(data);
	state.selected.id = selectedBonusId;
	state.selected.validPaymentMethods = paymentMethods;
	state.selected.confirmed = true;
	storeConfirmed();
	applyConditions();
	viewUpdateForSpinner();
}

function setSelected(bonusid, paymentMethods) {
	if (state.selected.id != null && bonusid.toString() === state.selected.id.toString()) {
		/* bonuses:already selected::deselect */
		state.selected.id = -1;
	} else {
		state.selected.id = bonusid;
		state.selected.validPaymentMethods = paymentMethods;
	}
	viewUpdate();
	/* Publish the state */
	__WEBPACK_IMPORTED_MODULE_1__common_lib_utils_actions_js__["a" /* default */].bonuses(state);
}

function registerActions() {
	var bonuses = function bonuses(payload) {
		var bonusListIsFilled = void 0;
		if (payload.type === __WEBPACK_IMPORTED_MODULE_2__common_lib_utils_constants_js__["a" /* default */].FETCH_BONUSES) {
			if (payload.data && payload.data.list) {
				bonusListIsFilled = sortMethodsToState(payload.data.list);
				if (!bonusListIsFilled) {
					isEmptyCallback();
				}
			}
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_2__common_lib_utils_constants_js__["a" /* default */].FETCH_BONUSES_FREE_MONEY_BONUS_SUCCESS) {
			if (payload.data && payload.data.list) {
				bonusListIsFilled = sortMethodsToStateFreeMoneyBonusSuccess(payload.data.list);
				if (!bonusListIsFilled) {
					isEmptyCallback();
				}
			}
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_2__common_lib_utils_constants_js__["a" /* default */].VIEW_BONUS) {
			if (payload.data && payload.data.selected) {
				setSelected(payload.data.selected, payload.data.paymentMethods);
			}
			state.selected.confirmed = payload.data && payload.data.confirmed;
			if (state.selected.confirmed) {
				/* selected bonus is confirmed, keep. */
				/* an amount may be already input into the deposit-action form */
				storeConfirmed();
				applyConditions();
				setConditionsMsg();
				/* Publish the state. */
				__WEBPACK_IMPORTED_MODULE_1__common_lib_utils_actions_js__["a" /* default */].bonuses(state);
			}
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_2__common_lib_utils_constants_js__["a" /* default */].FETCH_BONUSES_FOR_SHOP_DEPOSIT) {
			if (payload.data && payload.data.list) {
				setSelectedAndPublishStateForShopDepositBonus(payload.data.list, payload.selectedBonusId, payload.bonusPaymentMethods);
				shopDepositBonusCallback();
			}
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_2__common_lib_utils_constants_js__["a" /* default */].VIEW_NAV) {
			/* skipbutton was pressed, deselect all bonuses */
			if (!state.selected.confirmed) {
				state.selected.id = -1;
			}
			/* Publish the state */
			__WEBPACK_IMPORTED_MODULE_1__common_lib_utils_actions_js__["a" /* default */].bonuses(state);
			viewUpdate();
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_2__common_lib_utils_constants_js__["a" /* default */].VIEW_PAYMENTFORM) {
			/* When the depositform is displayed, the input amount can be combined with the selected bonus. */
			if (payload.data && payload.data.amount) {
				parseToStateAmountIn(payload.data.amount, payload.data.selectedPaymentMethod);
				if (state.selected && state.selected.bonus) {
					applyConditions();
				}
			}
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_2__common_lib_utils_constants_js__["a" /* default */].SUBMIT_PAYMENT) {
			if (payload.success) {
				state.selected.id = null;
			}
		}
	};
	register(bonuses);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(p) {
		isEmptyCallback = p.isEmptyCallback || isEmptyCallback;
		shopDepositBonusCallback = p.shopDepositBonusCallback || null;
		registerActions();
	}
};

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_js__ = __webpack_require__(134);
/*
fetch-bonuses.js
*/







var register = __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__["a" /* default */].register;
var state = {
	/* list of bonusobject */
	list: null,
	pending: false
};
var requestUrl = void 0;
var callbackIfEmpty = null;

function viewUpdate() {
	__WEBPACK_IMPORTED_MODULE_4__view_js__["a" /* default */].update({
		fetch_bonuses: state
	});
}

function parseToState(data, freeMoneyBonusSuccess) {
	var successful = Boolean(data && data.status && data.status.toLowerCase && data.status.toLowerCase() === 'success');
	var result = Boolean(data && data.result && Array.isArray(data.result));
	var successfulResult = Boolean(successful && result);
	if (successfulResult) {
		state.list = data.result;
		if (freeMoneyBonusSuccess) {
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].fetchBonusesFreeMoneyBonusSuccess(state);
		} else {
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].fetchBonuses(state);
		}
	} else {
		console.error('fetch_bonuses:parseToState:46:can not read data:', data);
	}
	return successfulResult;
}

function parseToStateForShopDepositBonus(data, selectedBonusId, bonusPaymentMethods) {
	if (data) {
		if (data.status && data.status.toLowerCase() === 'success') {
			if (data.result) {
				if (Array.isArray(data.result)) {
					state.list = data.result;
					__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].fetchBonusesForShopDeposit(state, selectedBonusId, bonusPaymentMethods);
				}
			}
		}
	} else {
		console.error('Error in retrieved bonus data', data);
	}
}

function getDataAndReplaceState(freeMoneyBonusSuccess) {
	state.pending = false;
	var successHandler = function successHandler(data) {
		var bonusExist = parseToState(data, freeMoneyBonusSuccess);
		// Skipping to deposit action if there are no available bonuses
		if (!bonusExist) {
			callbackIfEmpty();
		}
		viewUpdate();
	};
	var failHandler = function failHandler(err) {
		viewUpdate();
		console.error('fetch_bonuses:getDataAndReplaceState:67:failHandler:', err);
	};
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].get(requestUrl, successHandler, failHandler);
}

function getDataAndReplaceStateForShopDepositBonus(selectedBonusId, bonusPaymentMethods) {
	var successHandler = function successHandler(data) {
		parseToStateForShopDepositBonus(data, selectedBonusId, bonusPaymentMethods);
	};
	var failHandler = function failHandler(err) {
		if (err.status && err.status === 500) {
			console.warn('log in before sending request.', err);
		} else {
			console.error('error:', err);
		}
	};
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].get(requestUrl, successHandler, failHandler);
}

function registerActions() {
	function fetchBonuses(payload) {
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].SETUP_BONUS) {
			state.pending = true;
			viewUpdate();
			getDataAndReplaceState();
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].SHOP_HANDLE_BONUS_FOR_DEPOSIT) {
			// viewUpdate(); -- why do we need a view update?
			getDataAndReplaceStateForShopDepositBonus(payload.data.selectedBonusId, payload.data.bonusPaymentMethods);
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].RELOAD_BONUSES_FREE_MONEY_BONUS_SUCCESS) {
			getDataAndReplaceState(true);
		}
	}
	register(fetchBonuses);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(url, isEmptyCallback) {
		/* the init method prepares the module to respond to the actions and attach the provided urls. */
		if (url) {
			requestUrl = url;
			callbackIfEmpty = typeof isEmptyCallback === 'function' ? isEmptyCallback : function doNothing() {};
		} else {
			console.error('init: no url provided', url);
		}
		registerActions();
	}
};

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/*
payment/bonus/view_submitbtn

import view_submitbtn from ...

-- supply wrapper and callback to invoke on click --
view_submitbtn.init({cb, wrap:'domElm'});

 --delete button and eventhandlers --
 view_submitbtn.close();
*/



var classnameOpen = 'u-show';
var classnameClose = 'u-hide';
var create = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].create;
var buttonText = 'submit texkey';
var theCallback = function theCallback() {
	console.info('view_submitbtn:18: no callback provided');
};
var elements = {};

function createSubmit(txt) {
	var elm = create({
		type: 'button',
		class: 'js-event-filter-payment-submit payment__submit-deposit btn u-b-radius'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createSpinner() {
	var elm = create({
		type: 'div',
		class: 'spinner u-hide'
	});

	return elm;
}

function showSpinner(bool) {
	if (bool) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.spinner, classnameClose);
	} else {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.spinner, classnameClose);
	}
}

function changeText(newTxt) {
	if (elements.submit) {
		elements.submit.innerHTML = newTxt;
	} else {
		console.error('submit button does not exist');
	}
}

function assembleElements() {
	elements.submit = elements.submit || createSubmit(buttonText);
	elements.spinner = createSpinner();
	elements.submit.appendChild(elements.spinner);
	elements.wrap.appendChild(elements.submit);
}

function deleteAllElements() {
	elements = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys'], 'view_submitbtn:39');
}

function showWrap() {
	document.documentElement.classList.add('overlay--open');

	if (elements && elements.wrap) {
		if (__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].hasClass(elements.wrap, classnameClose)) {
			__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.wrap, classnameClose);
		}
		if (!__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].hasClass(elements.wrap, classnameOpen)) {
			__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.wrap, classnameOpen);
		}
	}
}

function hideWrap() {
	document.documentElement.classList.remove('overlay--open');

	if (__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].hasClass(elements.wrap, classnameOpen)) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.wrap, classnameOpen);
	}
	if (!__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].hasClass(elements.wrap, classnameClose)) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.wrap, classnameClose);
	}
}

function clickBtnHandler(e) {
	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		theCallback();
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].handle(e, '.js-event-filter-payment-submit', cb, true);
}

function addListeners() {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addListener(elements.wrap, 'click', clickBtnHandler);
}

function removeListeners() {
	if (elements && elements.wrap) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeListener(elements.wrap, 'click', clickBtnHandler);
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(p) {
		elements.wrap = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].getElementIfValid(p, 'wrap', 'view_submitbtn:90');
		theCallback = p.cb || theCallback;
		buttonText = p.buttonText || buttonText;
		assembleElements();
		addListeners();
		/* the button is displayed by default,
   hide it actively from .hide() */
		showWrap();
	},
	show: function show() {
		showWrap();
	},
	hide: function hide() {
		hideWrap();
	},
	close: function close() {
		deleteAllElements();
		removeListeners();
	},

	changeText: changeText,
	showSpinner: showSpinner
};

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*

payments/common/lib/utils/addremoveclass

usage:
add a class if it is not already there
remove a class if it is there

return:
the modified input dom node

TODO:
update to use: (support?)
element.classList.add('someClass')

*/

function containsWord(string, word) {
	// string can be:  js-payment__input-cvc-creditcard payment__input-cvc-creditcard input-wrap__input
	// word can be: js-payment__input-cvc-creditcard
	// word is then part of string
	// if word is 'js-payment' then word is not part of string
	var hasValues = Boolean(string && word);
	var anyWordMatches = false;
	if (hasValues) {
		var wordsInString = string.split(/\s/); // separated on space-character
		wordsInString.forEach(function (w) {
			if (w === word) {
				anyWordMatches = true;
			}
		});
	}
	return anyWordMatches;
}

function _hasClass(elm, classname) {
	var hasIt = false;
	if (elm && elm.className) {
		hasIt = containsWord(elm.className, classname);
	}
	return hasIt;
}

function addClass(elm, classname) {
	if (elm && elm.className) {
		if (!containsWord(elm.className, classname)) {
			elm.className += ' ' + classname;
		}
	}
	return elm;
}

function removeClass(elm, classname) {
	/* classname must be word characters and not å,ä,ö
 All extra spaces are removed.*/
	var reg = new RegExp(classname, 'g');
	if (elm && elm.className) {
		if (containsWord(elm.className, classname)) {
			elm.className = elm.className.replace(reg, ' ').replace(/\s{1,}/g, ' ');
		}
	}
	return elm;
}
/* harmony default export */ __webpack_exports__["a"] = {
	add: function add(elm, classname) {
		return addClass(elm, classname);
	},
	remove: function remove(elm, classname) {
		return removeClass(elm, classname);
	},
	hasClass: function hasClass(elm, classname) {
		return _hasClass(elm, classname);
	}
};

/*
TEST
var containsWord = function (string, word) {
	return new RegExp('\\b' + word + '\\b').test(string);
},
	addClass = function (elm, classname) {
		if (!containsWord(elm.className, classname)) {
			elm.className += ' ' + classname;
		}
		return elm;
	},
	removeClass = function (elm, classname) {
		var reg = new RegExp(classname, 'g');
		if (containsWord(elm.className, classname)) {
			elm.className = elm.className.replace(reg,' ').replace(/\s{1,}/g, ' ');
		}
		return elm;
	};
	var elm = document.createElement('div');
	elm.className = 'ett tva tre fyra fem';
	removeClass(elm,'tre');*/

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*

	aspectheight

	usage:

	the height is calculated to preserve the aspect ratio from a provided image or given value

	return:
	height
*/

var _refSize = {
	w: 160,
	h: 90
};

var MATHROUND = Math.round;

var heightFromAspectRatio = function heightFromAspectRatio(w, refW, refH) {
	var rw = refW || _refSize.w;
	var rh = refH || _refSize.h;
	return MATHROUND(rh / rw * w);
};

/* harmony default export */ __webpack_exports__["a"] = {
	refSize: function refSize() {
		return _refSize;
	},
	scaledHeight: function scaledHeight(w, refH, refW) {
		/*optional refH, refW - If not provided the preset format is used*/
		_refSize.w = refW || _refSize.w;
		_refSize.h = refH || _refSize.h;
		return heightFromAspectRatio(w, refW, refH);
	}
};

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
create

usage:
object-argument:
window.CORE.control.create({
    type: 'div',
    class: 'an_example other_class',
    id: null,
    other: 'other_attribute',
    other2: 'yet_other'
});
list-argument:
window.CORE.control.create('div','some classes','some_id')

return:
a dom node with attributes
*/

var node = void 0;

function createNode(type) {
	var elm = void 0;
	if (type === 'svg' || type === 'use' || type === 'path' || type === 'g') {
		elm = document.createElementNS('http://www.w3.org/2000/svg', type);
	} else {
		elm = document.createElement(type);
	}
	return elm;
}

function addProperties(p, classname, id) {
	if ((typeof p === 'undefined' ? 'undefined' : _typeof(p)) === 'object') {
		Object.keys(p).forEach(function (key) {
			if (key !== 'type' && key !== 'input-type' && key !== 'xlink:href') {
				node.setAttribute(key, p[key]);
			} else if (key === 'input-type') {
				node.setAttribute('type', p[key]);
			} else if (key === 'xlink:href') {
				node.setAttributeNS('http://www.w3.org/1999/xlink', 'href', p[key]);
			}
		});
	} else {
		if (classname) {
			node.setAttribute('class', classname);
		}
		if (id) {
			node.setAttribute('id', id);
		}
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	basicElement: function basicElement(p, classname, id) {
		var type = p.type || p;
		node = createNode(type);
		addProperties(p, classname, id);
		return node;
	}
};

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_dom_ready_js__ = __webpack_require__(218);

/*
usage:
domready(app_init);

The 'app_init' will execute when dom state is 'interactive' or 'complete'.
if  is enabled the initial load has to be done after readyState is ok.
If the  configuration does not dispatch 'loading' the 'isViewable' check is used as fallback.
*/



var applyWhenDomIsReady = function applyWhenDomIsReady(func) {

	(function pollCheck() {
		var state = document.readyState;
		if (state === 'interactive' || state === 'complete') {
			func();
		} else {
			setTimeout(pollCheck, 200);
		}
	})();
};

/* harmony default export */ __webpack_exports__["a"] = {
	run: function run(func) {
		if (typeof func === 'function') {
			__WEBPACK_IMPORTED_MODULE_0__utils_dom_ready_js__["a" /* default */].then(function () {
				return func();
			});
		} else {
			console.error('domready: argument must be a function: ' + func);
		}
	}
};

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
common/lib/utils/elements

usage:

return:
*/
function matchInArr(str, arrWithStrings) {
	var L = arrWithStrings && arrWithStrings.length;
	var i = void 0;
	var indexMatch = false;
	if (L) {
		for (i = 0; i < L; i += 1) {
			if (arrWithStrings[i] === str && !indexMatch) {
				indexMatch = true;
				// exit the loop preferrably
			}
		}
	}
	return indexMatch;
}

function isObject(obj) {
	/* a separation of object and array, '{}' vs '[]'*/
	return Boolean(obj && obj === Object(obj) && Object.prototype.toString.call(obj) !== '[object Array]');
}

function _isElement(elm) {
	return Boolean(elm && elm.nodeType && elm.nodeType === 1);
}

function validElement(p, key, modulenameUsingTheMethod) {
	var element = null;
	var errorMsg = modulenameUsingTheMethod + ' :core:elements:validElement: not valid';
	// if (p[key] && p[key].nodeType && p[key].nodeType === 1) {
	if (_isElement(p[key])) {
		element = p[key];
	} else {
		console.error(errorMsg, key);
	}
	return element;
}

function _deleteElement(elm) {
	// modulenameUsingTheMethod) {
	// const errorMsg = `${modulenameUsingTheMethod} :core:elements:deleteElement: can not delete`;
	// let element = ((elm.nodeType && elm.nodeType === 1 && elm.parentNode) ? elm : null);
	var element = _isElement(elm) ? elm : null;
	if (element) {
		element.parentNode.removeChild(element);
		element = null;
	} else {
		// console.warn(errorMsg, elm);
	}
	return element;
}

function deleteElements(arrObjElm) {
	var newElm = null;
	if (Array.isArray(arrObjElm)) {
		newElm = [];
		arrObjElm.forEach(function (elm) {
			newElm[elm] = _deleteElement(elm);
		});
	} else if (!_isElement(arrObjElm) && isObject(arrObjElm)) {
		newElm = {};
		Object.keys(arrObjElm).forEach(function (elm) {
			newElm[elm] = _deleteElement(arrObjElm[elm]);
		});
	} else if (_isElement(arrObjElm)) {
		newElm = _deleteElement(arrObjElm);
	}
	return newElm;
}

function deleteElementsInObject(elements, exceptKeysArr) {
	// , modulenameUsingTheMethod) {
	// const errorMsg = `${modulenameUsingTheMethod} : deleteElementsInObject: error:`;
	var newElements = {};
	if (elements) {
		Object.keys(elements).forEach(function (key) {
			try {
				if (matchInArr(key, exceptKeysArr)) {
					newElements[key] = elements[key];
				} else {
					newElements[key] = deleteElements(elements[key]);
				}
			} catch (err) {
				// silent catch
				// console.warn(errorMsg + key, err);
				newElements[key] = null;
			}
		});
	}
	return newElements;
}

function _selectElements(selectors, modulenameUsingTheMethod) {
	/* return selected dom-nodes from an object of selectors */
	var elements = {};
	var errorMsg = modulenameUsingTheMethod + ' : can not find element';
	Object.keys(selectors).forEach(function (key) {
		var selector = selectors[key];
		if (selector) {
			try {
				if (selector[0] === '#') {
					elements[key] = document.querySelector(selector);
				} else if (selector[0] === '.') {
					elements[key] = document.querySelectorAll(selector);
				}
			} catch (err) {
				console.error(errorMsg, selector);
			}
		}
	});
	return elements;
}

/* harmony default export */ __webpack_exports__["a"] = {
	deleteElement: function deleteElement(elm, modulenameUsingTheMethod) {
		return _deleteElement(elm, modulenameUsingTheMethod);
	},
	deleteElementsInObjectExcept: function deleteElementsInObjectExcept(obj, keysToIgnoreArr, modulenameUsingTheMethod) {
		/* OBSERVE that this method currently only works for almost flat objects. There
  is no recursion done to traverse a complex object. */
		return deleteElementsInObject(obj, keysToIgnoreArr, modulenameUsingTheMethod);
	},
	getElementInObjectIfValid: function getElementInObjectIfValid(obj, key, modulenameUsingTheMethod) {
		return validElement(obj, key, modulenameUsingTheMethod);
	},
	selectElements: function selectElements(objWithSelectors, modulenameUsingTheMethod) {
		return _selectElements(objWithSelectors, modulenameUsingTheMethod);
	},
	isElement: function isElement(elm) {
		return _isElement(elm);
	}
};

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
	events
	usage:

	return:
*/

/*
//Usage of the events-module
var fetch_child_4_click_same,
	fetch_child_4_click_below,
	html = '';
html += '<div id="parent" class="fkn_parent" name="ADD LISTENER TO THIS" val="0">';
html += ' <div id="child_1" class="fkn_child_1" val="1">';
html += ' 	<div id="child_2" class="fkn_child_2" val="2">';
html += ' 		<div id="child_3" class="fkn_child_3" val="3">';
html += ' 			<div id="child_4" class="fkn_child_4" val="4" name="CATCH THIS ELEMENT WITH THE FILTER CLASS NAME">';
html += '				<p id="content_A" class="fkn_content_A" val="5" name="CLICK ON THIS ELEMENT"></p>';
html += '				<p id="content_B" class="fkn_content_A" val="6" name="OR CLICK ON THIS ELEMENT">';
html += '					<span id="inner_content" class="fkn_inner_content" val="7" name="OR CLICK ON THIS ELEMENT"></span>';
html += '				</p>';
html += '				<p id="content_C" name="OR CLICK ON THIS ELEMENT" val="8"></p>';
html += '				<p id="content_D" name="OR CLICK ON THIS ELEMENT" val="9"></p>';
html += '			</div>';
html += '		</div>';
html += '	</div>';
html += '</div>';

document.querySelector('body').innerHTML += html;*/

// This custom eventhandling system allows attachment of an eventlistener to a common parent, and
// at the same time fetch any of its children. For example click inside a containers child elements
// is registered higher up in the hierarchy, but still fetching the child element. If the last argument
// is set to 'false' in handle.(eventobject,'.filterclass',callback, false|true) only the precise click on the child element is registered.

/* fetch_child_4_click_same = function (e) {
	var cb = function (p) {
		// p.e gets the event object
		p.e.stopPropagation();
		var elm = p.elm,
			id = (elm.getAttribute('id'));
	};
	// This handler function runs the callback only if the .fkn_child_4 element is clicked
	core.handle(e, '.fkn_child_4', cb, false);
};

fetch_child_4_click_below = function (e) {
	var cb = function (p) {
		//p.e gets the event object
		p.e.stopPropagation();
		var elm = p.elm,
			id = (elm.getAttribute('id'));
	};

	//If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked
	core.handle(e, '.fkn_child_4', cb, true);
};


// Listener is added to the parent element, the handler-function determines the result
core.addListener(document.querySelector('#parent'), 'click', fetch_child_4_click_same);
core.addListener(document.querySelector('#parent'), 'click', fetch_child_4_click_below);


// Click is invoked on the innermost element

setTimeout(function () {
	$('#inner_content').click();
}, 600);
*/

function containsWord(string, word) {
	// string can be:  js-payment__input-cvc-creditcard payment__input-cvc-creditcard input-wrap__input
	// word can be: js-payment__input-cvc-creditcard
	// word is then part of string
	// if word is 'js-payment' then word is not part of string
	var hasValues = Boolean(string && word);
	var anyWordMatches = false;
	if (hasValues) {
		var wordsInString = string.split(/\s/); // separated on space-character
		wordsInString.forEach(function (w) {
			if (w === word) {
				anyWordMatches = true;
			}
		});
	}
	return anyWordMatches;
}

function checkParentForFilterHit(element, filter, addFilter) {
	var node = element;
	var additionalFilterHit = false;
	var parentNode = node.parentNode;
	var className = element.className;
	var wrapFilterHit = false;
	var wrapFilter = 'adcont';
	var seq = 0;
	var parentTargetHit = false;
	while (parentNode !== null && !(seq > 15 || wrapFilterHit || parentTargetHit)) {
		node = parentNode;
		className = parentNode.className;
		parentTargetHit = containsWord(className, filter);
		wrapFilterHit = containsWord(className, wrapFilter);
		if (!additionalFilterHit) {
			additionalFilterHit = containsWord(className, addFilter);
		}
		seq += 1;
		parentNode = node.parentNode;
	}
	return {
		filterHit: parentTargetHit,
		targetElem: node,
		className: className
	};
}

function _handle(e, classSelectorFilter, sendFkn, checkParent) {
	var handler = function theHandler() {
		var evObject = e || window.event;
		var targetElem = evObject.target || evObject.srcElement;
		var filterHit = false;
		var className = targetElem.className;
		var data = evObject.detail;
		var checkParentObj = void 0;
		var filterClassName = classSelectorFilter.slice(1);
		filterHit = containsWord(className, filterClassName);
		if (!filterHit && checkParent) {
			checkParentObj = checkParentForFilterHit(targetElem, filterClassName);
			filterHit = checkParentObj.filterHit;
			className = checkParentObj.className;
			targetElem = checkParentObj.targetElem;
		}
		if (filterHit && sendFkn) {
			sendFkn({
				elm: targetElem,
				data: data,
				e: evObject
			});
		}
		return {
			getEventObj: function getEventObj() {
				return {
					className: className,
					data: data,
					filterHit: filterHit,
					filter: filterClassName
				};
			}
		};
	}();
	return handler;
}

function startListening(parentElement, eType, eventHandler) {
	var eventType = eType;
	try {
		if (parentElement.addEventListener) {
			parentElement.addEventListener(eventType, eventHandler, false);
		} else if (parentElement.attachEvent) {
			eventType = 'on' + eventType;
			parentElement.attachEvent(eventType, eventHandler);
		} else {
			parentElement['on' + eventType] = eventHandler;
		}
	} catch (e) {
		console.error('events:' + e);
		if (console.trace) {
			console.trace();
		}
	}
}

function removeListenerIfElementExist(parentElm, eventType, eventHandler) {
	if (parentElm && parentElm.removeEventListener) {
		parentElm.removeEventListener(eventType, eventHandler);
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	add: function add(parentElm, eventType, eventHandler) {
		startListening(parentElm, eventType, eventHandler);
	},
	handle: function handle(event, classSelectorFilter, sendFkn, checkParentFilterHit) {
		return _handle(event, classSelectorFilter, sendFkn, checkParentFilterHit);
	},
	remove: function remove(parentElm, eventType, eventHandler) {
		removeListenerIfElementExist(parentElm, eventType, eventHandler);
	}
};

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*

	imagesize

	usage:

	the height is calculated to preserve the aspect ratio from a provided image or given value

	return:
	height
*/

var sizeFromImage = function sizeFromImage(src, cb) {
	var img = new Image();
	var size = {};
	img.onload = function () {
		size.w = this.width;
		size.h = this.height;
		cb(this.height, this.width);
	};
	img.onerror = function () {
		console.warn("aspectheight:onerror:can not use image: " + src);
		cb();
	};
	img.src = src;
	return size;
};

/* harmony default export */ __webpack_exports__["a"] = {
	onsize: function onsize(src, cb) {
		return sizeFromImage(src, cb);
	}
};

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
jqajx-post.js
requires jQuery

usage:
Invokes callbacks on result.

return:
--
*/
/* harmony default export */ __webpack_exports__["a"] = {
	submit: function submit(the_url, data, successhandler, err_handler, content_type) {
		var errorhandler = null;
		var contentType = null;
		var data_str = void 0;
		if (err_handler && typeof err_handler === 'function') {
			errorhandler = err_handler;
		} else {
			errorhandler = function errorhandler(err) {
				/*if the errorhandler is not passed then create a default handler*/
				if (err.status && err.status === 500) {
					console.warn('jqajx_post:26:try log in before sending request.', err);
				} else {
					console.error('jqajx_post:28:failure:', err);
				}
			};
		}
		/*To submit post request with data as queryParameters then specify content type as an argument*/
		contentType = content_type || 'application/json; charset=UTF-8';

		/*Data shall be of type string*/
		if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
			data_str = JSON.stringify(data);
		} else if (typeof data === 'string') {
			data_str = data;
		} else {
			console.warn('jqajx_post:26: data has to be a string. Can not convert:', data);
		}

		jQuery.ajax({
			type: "POST",
			url: the_url,
			headers: {
				Accept: 'application/json, text/javascript, */*; q=0.01',
				'Content-Type': contentType,
				'Cache-Control': 'no-cache, no-store, must-revalidate',
				'Pragma': 'no-cache',
				'Expires': '0'
			},
			data: data_str,
			xhrFields: {
				withCredentials: true /*adds the cookie*/
			},
			crossDomain: false
		}).done(function (res) {
			successhandler(res);
		}).fail(function (err) {
			errorhandler(err);
		});
	}
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/*
jqajx.js
requires jQuery

usage:
Invokes callbacks on result.

return:
--
*/

/* harmony default export */ __webpack_exports__["a"] = {
	getData: function getData(the_url, successhandler, errorhandler) {
		jQuery.ajax({
			url: the_url,
			// url: 'http://localhost:9090/betping/rest/api/dummy',
			crossDomain: true
		}).done(function (res) {
			successhandler(res);
		}).fail(function (err) {
			errorhandler(err);
		});
	}
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
	usage:
	array-argument:
	window.CORE.nodetree.fragment([nodeA,nodeB,...,nodeN])

	or
	window.CORE.nodetree.fragment(nodeA]);

	or
	window.CORE.nodetree.fragment();

	return:
	a document-fragment
*/
var isArray = function isArray(o) {
    return Object.prototype.toString.call(o) === '[object Array]';
};

var createTree = function createTree(nodes) {
    var docf = document.createDocumentFragment();
    try {
        if (nodes && isArray(nodes)) {
            nodes.forEach(function (elm) {
                docf.appendChild(elm);
            });
        } else if (nodes) {
            docf.appendChild(nodes);
        }
    } catch (e) {
        console.error(e);
    }
    return docf;
};

/*api*/
/* harmony default export */ __webpack_exports__["a"] = {
    fragment: function fragment(nodes) {
        if (arguments.length > 1) {
            console.warn('nodetree: arguments must be sent as an array or only the first argument will be used');
        }
        return createTree(nodes);
    }
};

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
  stringtrim

usage:
  var stringtrim = require('./stringtrim'):
  var trimmed = stringtrim.innermultiplespace('some   string with    lots of  space');
  //'some string with lots of space'

return:
  the modified string
*/

var filterAwayNonDigits = function filterAwayNonDigits(str) {
	/*filter away all but 0-9*/
	return str.replace(/[^(0-9)]/g, '');
};

var multipleSpaceToSingle = function multipleSpaceToSingle(str) {
	//TODO add unit test to confirm functionality!!
	var multispace = new RegExp(/\s{2,}/g);
	return str.replace(multispace, ' ');
};

var removeTrailingSpace = function removeTrailingSpace(str) {
	//TODO add unit test to confirm functionality!!
	// compare native 'String.trim' method
	var trailspace = new RegExp(/^[ \s]+|[ \s]+$/g);
	return str.replace(trailspace, '');
};

/* harmony default export */ __webpack_exports__["a"] = {
	multispace: function multispace(str) {
		// var trimmed = return (str? multipleSpaceToSingle(str) : null);
		// return multipleSpaceToSingle(str);
		return str ? multipleSpaceToSingle(str) : null;
	},
	trailspace: function trailspace(str) {
		return str ? removeTrailingSpace(str) : null;
		// return removeTrailingSpace(str);
	},
	keepdigits: function keepdigits(t) {
		/*returns all digits from a string*/
		var str = void 0;

		var digits = void 0;
		var num = void 0;
		if (t) {
			str = t.toString();
			digits = filterAwayNonDigits(str);
			num = parseInt(digits, 10);
		} else {
			num = null;
		}
		return num;
	}
};

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
common/lib/utils/textkeys

usage:
To split a string containing ':' and ',' so that some of these chars
are preserved, some custom separators are used:
"key:value, key2:value" is then supplied with custom separators:
"key__ENDOFKEY__value__ENDOFVALUE"
see also 'textkeys-payment.mustache'
TODO: this solution is considered a workaround in wait for a post-mvp solution where
textkeys are provided in consistency with other parts of the site. This workaround
is here to get serverside rendered data.
*/

function stringToObject(str, endofkey, endofvalue) {
	var obj = {};
	var keyvalues = str && str.split && str.trim ? str.trim().split(endofvalue) : null;
	keyvalues.forEach(function (keyvalue) {
		var spl = keyvalue.split && keyvalue.trim ? keyvalue.trim().split(endofkey) : null;
		var key = spl && spl[0];
		var val = spl && spl[1];
		val = val && val.length && val.length > 0 ? val : 'MISSING-KEY-' + key;
		obj[key] = val;
	});
	return obj;
}

/* harmony default export */ __webpack_exports__["a"] = {
	objFromString: function objFromString(str, endofkey, endofvalue) {
		return stringToObject(str, endofkey, endofvalue);
	},
	__testStringToObject: function __testStringToObject(str) {
		var endofkey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ':';
		var endofvalue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ',';

		/* To split a string containing ':' and ',' so that some of these chars
  are preserved, some custom separators are used:
  "key:value, key2:value" is then supplied with custom separators:
  "key__ENDOFKEY__value__ENDOFVALUE"*/
		return stringToObject(str, endofkey, endofvalue);
	}
};

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/*
view-inputpopup.js
*/

/*
This is an example of the popup structure:
<div class="menu notify">
    <div class="binary-question u-box-bg u-pos-c u-b-radius grid-u-sm-3-4">
        <h2 class="notify__main-title u-mb0 u-text-c">TITLE</h2>
        <p class="notify__p u-m0 u-pl2 u-pr2 u-text-c">TEXT</p>

        <form>
            <fieldset class="input-wrap u-relative u-p2" data-content-error="XXXXX">
                <label for="set-limit-input" class="input-wrap__label">SET DAILY LIMIT</label>
                <input type="number" id="set-daily-limit" placeholder="AMOUNT" class="input-wrap__input input-wrap__input--placeholder">
                <span class="input-wrap__error-display js-input-error-display"></span>
            </fieldset>
        </form>
        <div class="binary-question__button-container u-relative grid-r">
            <div class="binary-question__no grid-u-sm-1-2">
                <button class="btn">CLOSE</button>
            </div>
            <div class="or u-absolute u-b-radius-round u-text-c u-div-c">OR</div>
            <div class="binary-question__yes grid-u-sm-1-2">
                <button class="btn">YES</button>
            </div>
        </div>
    </div>
</div>
*/

/* this is used for first time uk deposit for setting daily limit */



var create = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].create; // creates basic elements not inserted into the dom

function createPopUpWrapper() {
	return create({
		type: 'div',
		class: 'js-payment-set-limit-wrapper notify u-absolute u-pos-tl0'
	});
}

function createTitle(txt) {
	var elm = create({
		type: 'h2',
		class: 'notify__main-title u-mb0 u-text-c js-payment-set-limit-title'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createMessage(txt) {
	var elm = create({
		type: 'p',
		class: 'u-pl2 u-pr2 u-text-c js-payment-set-limit-message'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createForm() {
	return create({
		type: 'form'
	});
}

function createFieldset() {
	return create({
		type: 'fieldset',
		class: 'input-wrap u-relative u-p2'
	});
}

function createInputLimitLabel(txt) {
	var elm = create({
		type: 'label',
		class: 'input-wrap__label',
		for: 'set-limit-input'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createInputLimitField(placeholder) {
	return create({
		type: 'input',
		class: 'payment__input-set-limit-input input-wrap__input u-mb2 js-payment-set-limit-input',
		name: 'limit',
		'input-type': 'tel',
		placeholder: placeholder
	});
}

function createInputLimitFeedback(txt) {
	var elm = create({
		type: 'label',
		class: 'input-wrap__label',
		for: 'set-limit-input'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createButtonWrapper() {
	return create({
		type: 'div',
		class: 'binary-question__button-container u-relative grid-r'
	});
}

function createCancelButtonWrapper() {
	return create({
		type: 'div',
		class: 'binary-question__no grid-u-sm-1-2'
	});
}

function createCancelbutton(eventFilter, txt) {
	var cName = eventFilter + ' btn';
	var elm = create({
		type: 'button',
		class: cName
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createConfirmButtonWrapper() {
	return create({
		type: 'div',
		class: 'binary-question__yes grid-u-sm-1-2'
	});
}

function createConfirmButton(eventFilter, txt) {
	var cName = eventFilter + ' btn';
	var elm = create({
		type: 'button',
		class: cName
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createButtonSeparator(txt) {
	var elm = create({
		type: 'div',
		class: 'or u-absolute u-b-radius-round u-text-c u-div-c'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function assembleElements(elements, textkeysObj, classNameEventFilter) {
	/* create elements if not already existing */
	// elements.wrap = (elements.wrap || document.querySelector('.js-global-notification'));
	var elms = {};
	elms.wrap = elements.wrap || document.querySelector('.js-global-notification');

	if (elms.wrap) {
		elms.popUpWrapper = elements.popUpWrapper || createPopUpWrapper();
		elms.title = elements.title || createTitle(textkeysObj['set-limit-title']);
		elms.message = elements.message || createMessage(textkeysObj['set-limit-message']);
		elms.form = elements.form || createForm();
		elms.fieldset = elements.fieldset || createFieldset();
		elms.inputLimitLabel = elements.inputLimitLabel || createInputLimitLabel(textkeysObj['set-limit-amount-label']);
		elms.inputLimitField = elements.inputLimitField || createInputLimitField(textkeysObj['set-limit-amount-label']);
		elms.inputLimitFeedback = elements.inputLimitFeedback || createInputLimitFeedback(textkeysObj['set-limit-amount-feedback']);
		elms.buttonWrapper = elements.buttonWrapper || createButtonWrapper();
		elms.cancelButtonWrapper = elements.cancelButtonWrapper || createCancelButtonWrapper();
		elms.cancelButton = elements.cancelButton || createCancelbutton(classNameEventFilter, textkeysObj['set-limit-not-now']);
		elms.buttonSeparator = elements.buttonSeparator || createButtonSeparator(textkeysObj.or);
		elms.confirmButtonWrapper = elements.confirmButtonWrapper || createConfirmButtonWrapper();
		elms.confirmButton = elements.confirmButton || createConfirmButton(classNameEventFilter, textkeysObj['set-limit-ok']);

		/* hierarchy */
		elms.popUpWrapper.appendChild(elms.message);
		elms.popUpWrapper.appendChild(elms.title);
		elms.popUpWrapper.appendChild(elms.form);
		elms.popUpWrapper.appendChild(elms.buttonWrapper);
		elms.form.appendChild(elms.fieldset);
		elms.fieldset.appendChild(elms.inputLimitLabel);
		elms.fieldset.appendChild(elms.inputLimitField);
		elms.fieldset.appendChild(elms.inputLimitFeedback);
		elms.buttonWrapper.appendChild(elms.cancelButtonWrapper);
		elms.buttonWrapper.appendChild(elms.buttonSeparator);
		elms.buttonWrapper.appendChild(elms.confirmButtonWrapper);
		elms.cancelButtonWrapper.appendChild(elms.cancelButton);
		elms.confirmButtonWrapper.appendChild(elms.confirmButton);
		// add to DOM, prepend in global notification wrapper
		// elements.wrap.insertBefore(elements.popUpWrapper, elements.wrap.firstChild);
		elms.wrap.insertBefore(elms.popUpWrapper, elms.wrap.firstChild);
	}
	return elms;
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	var eventFilterSelector = '.' + eventFilterSeparatorClassname;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		onEventCb();
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeListener(elm, eventType, handler);
	}
}

function _show(elm, classnameShow, classnameHide) {
	if (classnameHide) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameHide);
	}
	if (classnameShow) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameShow);
	}
}

function _hide(elm, classnameShow, classnameHide) {
	if (classnameShow) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameShow);
	}
	if (classnameHide) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameHide);
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create(p) {
		var elements = {};
		var classNameEventFilter = 'js-eventfilter-viewinputpopup';
		var openGlobalClassName = 'global-notification--is-open';
		var openClassName = 'notify--is-open';
		var mainEventType = 'click';
		var textkeysObj = __WEBPACK_IMPORTED_MODULE_1__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		var cleanRemoveReset = null;
		var cbConf = p.confirmCb || function empty() {};
		var cbReject = p.rejectCb || function empty() {};
		elements = assembleElements(elements, textkeysObj, classNameEventFilter);
		var confirmCb = function temp() {
			var val = elements.inputLimitField.value;
			cbConf(val);
			_hide(elements.wrap, openGlobalClassName);
			_hide(elements.popUpWrapper, openClassName);
			// cleanRemoveReset();
		};
		var denyCb = function temp() {
			cbReject();
			_hide(elements.wrap, openGlobalClassName);
			_hide(elements.popUpWrapper, openClassName);
			// cleanRemoveReset();
		};
		var handlerMain = addListeners(elements.wrap, confirmCb, classNameEventFilter, mainEventType);
		// const handlerMain = addListeners(elements.confirmButton, confirmCb, classNameEventFilter, mainEventType);
		var handlerAlt = addListeners(elements.cancelButton, denyCb, classNameEventFilter, mainEventType);

		cleanRemoveReset = function fkn() {
			_hide(elements.wrap, openGlobalClassName);
			_hide(elements.popUpWrapper, openClassName);
			removeListeners(elements.confirmButton, handlerMain, mainEventType);
			removeListeners(elements.cancelButton, handlerAlt, mainEventType);
			elements = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys'], 'view-inputpopup:363');
		};
		// core.addListener(elements.confirmButton, 'click', confirmClickHandler);
		// core.addListener(elements.cancelButton, 'click', cancelClickHandler);

		return {
			wrap: elements.wrap,
			show: function show() {
				_show(elements.wrap, openGlobalClassName);
				_show(elements.popUpWrapper, openClassName);
				// openWrappers(elements);
			},
			hide: function hide() {
				_hide(elements.wrap, openGlobalClassName);
				_hide(elements.popUpWrapper, openClassName);
				// closeWrappers(elements);
			},
			update: function update() {},
			close: function close() {
				cleanRemoveReset();
			}
		};
	}
};

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/*
commonview/view-spinnersmall

usage:
this module returnes a dom-element and some controls to display it

import viewSpinner from './view-spinnersmall';
let mySpinner = viewSpinner.create({wrap:myDomElement});
mySpinner.show();

*/


var classnameHide = 'u-hide';
var classnameShow = 'u-show';
var classnameDim = 'btn--is-loading';
var create = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].create; /* create elements that can be inserted into the dom */

function createSpinner() {
	return create({
		type: 'div',
		class: 'spinner u-hide'
		/* set the z-index correctly with _z-index.scss. A value below 9 hides it due to the z-index of '.overlay' */
	});
}

function showSpinner(spinElm, siblingElm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(spinElm, classnameHide);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(spinElm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(siblingElm, classnameDim);
}

function hideSpinner(spinElm, siblingElm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(spinElm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(spinElm, classnameHide);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(siblingElm, classnameDim);
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create(p) {
		var elements = {};
		elements.wrap = createSpinner();
		elements.sibling = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].getElementIfValid(p, 'sibling', 'view-spinnersmall:57');
		return {
			wrap: elements.wrap,
			show: function show() {
				showSpinner(elements.wrap, elements.sibling);
			},
			hide: function hide() {
				hideSpinner(elements.wrap, elements.sibling);
			},
			close: function close() {
				/* hide the spinner if the spinner is closed before hidden.
    Otherwise the '.dim' element will remain on the parent */
				hideSpinner(elements.wrap, elements.sibling);
				__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, ['wrap'], 'view-spinnersmall:46');
				elements = null;
			}
		};
	}
};

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/*
payment/commonview/view_submitbtn

import view_submitbtn from ...

-- supply callback to invoke on click --
view_submitbtn.init({cb });

return:
see api

 --delete button and eventhandlers --
 view_submitbtn.close();
*/



var classnameOpen = 'u-show';
var classnameClose = 'u-hide';
var create = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].create;

function createButton(txt, eventFilter) {
	var elm = create({
		type: 'button',
		class: eventFilter + ' payment__submit-deposit btn u-b-radius'
	});
	/* txt is essential input and if it is empty throw error */
	elm.innerHTML = txt;
	return elm;
}

function deleteAllElements(elmObj) {
	return __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elmObj, [], 'view_submitbtn:39');
}

function _show(elm) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameClose);
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameOpen);
	}
}

function _hide(elm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameOpen);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameClose);
}

function clickBtnHandler(e, onClickCb, eventFilterSeparatorClassname) {
	var eventFilterSelector = '.' + eventFilterSeparatorClassname;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		onClickCb();
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, handler, eventFilter) {
	function handleCreator(e) {
		clickBtnHandler(e, handler, eventFilter);
	}
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addListener(elm, 'click', handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeListener(elm, 'click', handler);
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create(p) {
		var buttonText = p.buttonText;
		// const classNameEventFilter = `.js-event-filter-submitbtn-${buttonText}`;
		var classNameEventFilter = 'js-event-filter-submitbtn';
		var enabled = true;
		var callbackOnSubmitBtn = function callbackOnSubmitBtn() {
			if (p && p.cb && enabled) {
				p.cb();
			}
		};
		var elements = {};
		elements.wrap = createButton(buttonText, classNameEventFilter);

		var handler = addListeners(elements.wrap, callbackOnSubmitBtn, classNameEventFilter);
		/* the button is displayed by default,
   hide it actively from .hide() */
		_show(elements.wrap);
		return {
			wrap: elements.wrap,
			show: function show() {
				_show(elements.wrap);
			},
			hide: function hide() {
				_hide(elements.wrap);
			},
			enable: function enable() {
				// execute callback on main event
				enabled = true;
				if (elements && elements.wrap) {
					elements.wrap.disabled = false;
				}
			},
			disable: function disable() {
				// do not execute callback on main event
				enabled = false;
				if (elements && elements.wrap) {
					elements.wrap.disabled = true;
				}
			},
			close: function close() {
				/* hide the spinner if the spinner is closed before hidden.
    Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler);
				deleteAllElements(elements);
			}
		};
	}
};

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_js__ = __webpack_require__(86);
/*
nav_deposit/view_nav
create and handle all dom-nodes for the depositflow navigation: skip, close, back, title.

the selectors are set in the global navigation and can be:
// root: '#js-deposit-flow',
// btn_back: '#js-deposit-back-btn',
// btn_close: '#js-deposit-close-btn',
// btn_skip: '#js-deposit-skip-btn',
// header_title: '#js-deposit-header-title',
// nextbtnwrap: '.js-next-btn-wrap'
*/




var callbacks = {};
var selectors = {};
var elements = null;
var textkeysObj = {};
var classnameOpen = 'deposit--open';
var listenersAdded = false;
var srollHandlerAdded = false;

/* set title of wrapping page */
function updateContent(elm, text) {
	var node = elm;
	if (node) {
		node.innerHTML = text;
	} else {
		console.warn('view_nav:29:updateContent: no element provided', elm);
	}
	return node;
}

function showParentWrap() {
	if (!__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].hasClass(elements.wrap, classnameOpen)) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elements.wrap, classnameOpen);
	}
}

function hideParentWrap() {
	if (__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].hasClass(elements.wrap, classnameOpen)) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elements.wrap, classnameOpen);
	}
}

function backListener() {
	if (callbacks.back) {
		callbacks.back();
	}
}

function closeListener() {
	if (callbacks.close) {
		callbacks.close();
	}
}

function skipListener() {
	if (callbacks.skip) {
		callbacks.skip();
	}
}

function addListeners() {
	if (!listenersAdded) {
		if (elements.back) {
			elements.back.addEventListener('click', backListener);
		}
		if (elements.close) {
			elements.close.addEventListener('click', closeListener);
		}
		if (elements.skip) {
			elements.skip.addEventListener('click', skipListener);
		}
		listenersAdded = true;
	}
}

function removeListeners() {
	if (listenersAdded && elements) {
		if (elements.back) {
			__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeListener(elements.back, 'click', backListener);
		}
		if (elements.close) {
			__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeListener(elements.close, 'click', closeListener);
		}
		if (elements.skip) {
			__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeListener(elements.skip, 'click', skipListener);
		}
		listenersAdded = false;
	}
}

function hideNavElm(elm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, 'u-show');
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, 'u-hide');
}

function showNavElm(elm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, 'u-hide');
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, 'u-show');
}

function setUpScrollHandlers() {
	// add scroll listener to deposit steps, it will add a class to the header to avoid text overlapping
	// TODO; this eventhandler should be possible to remove, and included in the 'add-/removeListeners' above
	if (!srollHandlerAdded && elements) {
		var pageHead = elements.wrap.querySelector('.page-head');
		var changeHeaderWhenScroll = __WEBPACK_IMPORTED_MODULE_2__utils_js__["a" /* default */].debounce(function (e) {
			if (e.target.scrollTop > 25) {
				__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(pageHead, 'page-head--opac');
			} else {
				__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(pageHead, 'page-head--opac');
			}
		}, 100);
		elements.wrap.addEventListener('scroll', changeHeaderWhenScroll, true);
		srollHandlerAdded = true;
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(conf) {
		var textkeyIndexTitle = conf && conf.textkeys && conf.textkeys.title;
		var titleText = 'titletext';
		/* the key of the selector is the same as the name of the key in the elements:
  selectors.wrap = '#js-foo' elements.wrap = [a dom node]
  */
		selectors.wrap = conf.wrap.selector;
		selectors.back = conf.back.selector;
		selectors.close = conf.close.selector;
		selectors.skip = conf.skip.selector;
		selectors.title = conf.title.selector;
		selectors.textkeys = conf.textkeys.selector;
		/* update navigation according to conf */
		elements = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].selectElements(selectors, 'view_nav:init:120');
		textkeysObj = __WEBPACK_IMPORTED_MODULE_1__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		titleText = textkeyIndexTitle && textkeysObj[textkeyIndexTitle] || '';

		function showHideNav(cfig, keys) {
			/* this function assumes that selectors-keys are identical to elements-keys
   If either a url or a callback function is parsed the nav-element will be shown. */
			keys.forEach(function (key) {
				if (cfig[key].url || cfig[key].cb) {
					showNavElm(elements[key]);
				} else {
					hideNavElm(elements[key]);
				}
			});
		}

		showHideNav(conf, ['back', 'close', 'skip']);
		showParentWrap();

		/* set titletext of page */
		updateContent(elements.title, titleText);

		/* parse callbacks and urls*/
		function parseCallbacks(cfig, keys) {
			keys.forEach(function (key) {
				if (cfig[key].cb) {
					callbacks[key] = cfig[key].cb;
				}
			});
		}

		parseCallbacks(conf, ['back', 'close', 'skip']);

		/* if urls are provided then set them to the nav-buttons (only valid if the nav-button is an anchor-element) */
		function replaceUrls(cfig, keys) {
			keys.forEach(function (key) {
				if (cfig[key].url && elements[key] && elements[key].setAttribute) {
					elements[key].setAttribute('href', cfig[key].url);
					if (!cfig[key].isPush) {
						elements[key].setAttribute('refresh', '');
					}
				}
			});
		}

		replaceUrls(conf, ['back', 'close', 'skip']);
		addListeners();
		setUpScrollHandlers();
	},
	close: function close() {
		removeListeners();
		hideParentWrap();
	}
};

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_dataflow_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_utils_constants_js__ = __webpack_require__(9);
/*
 asynchronous_result_after_single_call
 */





var register = __WEBPACK_IMPORTED_MODULE_0__common_lib_dataflow_js__["a" /* default */].register;

function registerActions() {
	function asynchronousResultAfterSingleCall(payload) {
		var accHistRef = void 0;
		var paymentFetchResultFlow = void 0;
		if (payload.type === __WEBPACK_IMPORTED_MODULE_2__common_lib_utils_constants_js__["a" /* default */].SUBMIT_PAYMENT) {
			/* the handling of the submit and result is filtered by sendHandlerType */
			if (payload && payload.sendHandlerType === __WEBPACK_IMPORTED_MODULE_2__common_lib_utils_constants_js__["a" /* default */].ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL) {
				accHistRef = payload.accHistRef;
				paymentFetchResultFlow = payload.paymentFetchResultFlow;
				__WEBPACK_IMPORTED_MODULE_1__common_lib_utils_actions_js__["a" /* default */].asynchronousResultAfterSingleCall({
					fetch_type: __WEBPACK_IMPORTED_MODULE_2__common_lib_utils_constants_js__["a" /* default */].FETCH_TYPE_ASYNCH,
					accHistRef: accHistRef,
					paymentFetchResultFlow: paymentFetchResultFlow
				});
			}
		}
	}
	register(asynchronousResultAfterSingleCall);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init() {
		registerActions();
	}
};

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_dataflow_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__view__ = __webpack_require__(46);
/*
 payment/lib/external-panel-and-window-handler.js
 */





var register = __WEBPACK_IMPORTED_MODULE_1__common_lib_dataflow_js__["a" /* default */].register;
var state = {
	pending: false
};

function viewUpdate() {
	__WEBPACK_IMPORTED_MODULE_2__view__["a" /* default */].update({
		external_panel_and_window_handler: state
	});
}

function addInputFromObjectToForm(form, paramsObject) {
	jQuery.each(paramsObject, function (name, value) {
		var $input = null;
		if (name === 'method') {
			return;
		}
		$input = jQuery('<input>').attr({
			type: 'hidden',
			name: name,
			value: value
		});
		form.append($input);
	});
}

function showProviderContentInMainWindowByPost(providerUrl, parametersToProviderUrl) {
	var target = '_self';
	var form = jQuery('<form>').attr({
		action: providerUrl,
		method: 'POST',
		target: target,
		id: 'postToIframeForm'
	});
	if (parametersToProviderUrl) {
		addInputFromObjectToForm(form, parametersToProviderUrl);
	}
	jQuery(document.body).append(form);
	form.submit().remove();
}

function showProviderContentInMainWindowByGet(providerUrl, parametersToProviderUrl) {
	var urlWithParameters = createUrlWithParameters(providerUrl, parametersToProviderUrl);
	top.location = urlWithParameters;
}

function createUrlWithParameters(url, parameters) {
	var character = void 0;
	if (url.indexOf('?') > -1) {
		character = '&';
	} else {
		character = '?';
	}

	var urlWithParameters = url + character + jQuery.param(parameters);
	return urlWithParameters;
}

function registerActions() {
	function externalPanelAndWindowHandler(payload) {
		var sendHandlerData = void 0;
		var externalParameters = void 0;
		var externalUrl = void 0;
		var methodFunction = {
			post: showProviderContentInMainWindowByPost,
			get: showProviderContentInMainWindowByGet
		};
		var defaultMethod = {
			method: 'get'
		};

		if (payload.type === __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_constants_js__["a" /* default */].SUBMIT_PAYMENT) {
			/* the handling of the submit and result is filtered by sendHandlerType */
			if (payload && (payload.sendHandlerType === __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_constants_js__["a" /* default */].EXTERNAL_PANEL || payload.sendHandlerType === __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_constants_js__["a" /* default */].EXTERNAL_WINDOW)) {
				state.pending = true;
				viewUpdate();
				sendHandlerData = payload.sendHandlerData; // what to do with this?
				if (sendHandlerData.handler) {
					externalParameters = sendHandlerData.handler.externalParameters;
					externalUrl = sendHandlerData.handler.externalUrl;
				} else {
					externalParameters = sendHandlerData.externalParameters;
					externalUrl = sendHandlerData.externalUrl;
				}
				/* spinner is displayed from the connected view */
				state.pending = false;
				viewUpdate();

				externalParameters = jQuery.extend(defaultMethod, externalParameters);

				methodFunction[externalParameters.method](externalUrl, externalParameters);
			}
		}
	}
	register(externalPanelAndWindowHandler);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init() {
		registerActions();
	}
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deposit_form_template_conf_js__ = __webpack_require__(138);
/*
 fetch_fees_and_limits
 */







var state = {
	depositLimitsAndFeesData: null,
	bonusId: '',
	bonus_condition: '',
	bonusPaymentMethods: ''
};

var presetIndex = 0; // Siru for example preselects the first value in the defaultlist
var register = __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__["a" /* default */].register;
var requestUrl = null;
var fetchAgainForPresetAmount = false;

function viewUpdate() {
	__WEBPACK_IMPORTED_MODULE_4__view_js__["a" /* default */].update({
		fetch_fees_and_limits: state
	});
}

function checkAmountLimits(amount, max, min) {
	var am = amount || amount === 0 ? Number(amount) : 0;
	var maxLimit = max || max === 0 ? Math.floor(Number(max)) : 0; // round down max limit
	var minLimit = min || min === 0 ? Math.ceil(Number(min)) : 0; // round up min limit
	var validRange = minLimit < maxLimit;
	var within = validRange && am && am <= maxLimit && am >= minLimit;
	var above = validRange && am > maxLimit;
	var below = validRange && am < minLimit;
	var aboveIsZero = maxLimit === 0; // a convention used on the desktop site when the higher limit is zero
	/* returns booleans */
	return {
		above: above,
		below: below,
		within: within,
		aboveIsZero: aboveIsZero
	};
}

function filterFrom(filterThis, from) {
	var filtered = void 0;
	if (filterThis && filterThis.replace) {
		filtered = filterThis.replace(from, '');
	} else {
		filtered = '';
	}
	return filtered;
}

function equalsNumber(str) {
	var num = new RegExp(/^[0-9]+/g);
	return str && str.match && str.match(num);
}

function formatAmountList(amountselectlist, selectedindex) {
	/*
 parse the format of
 {PARAM_AMOUNT1: 35, PARAM_AMOUNT2: 70 ..., PARAM_AMOUNT_NUM: valN, currency:'kr'}
 to {1:{value:35:text:'35 kr'}}
 Select the indexes with keys PARAM_AMOUNT1:value1...PARAM_AMOUNT_N:value2 and add its value to an array
 */
	var amounts = [];
	var str = void 0;
	var text = void 0;
	var currency = amountselectlist && amountselectlist.PARAM_CURRENCY || null;
	Object.keys(amountselectlist).forEach(function (index) {
		/* A reference to the element is saved. */
		/* The uninserted nodes are returned as a list to be inserted with 'nodetree'-function. */
		str = index;
		str = filterFrom(str, 'PARAM_AMOUNT');
		if (equalsNumber(str)) {
			text = amountselectlist[index] + ' ' + currency;
			amounts.push({
				value: amountselectlist[index],
				text: text
			});
		}
	});
	if (amounts[selectedindex]) {
		amounts[selectedindex].selected = true;
	}
	return amounts;
}

function parseToState(data) {
	/* the response is filtered here instead of in the view. */
	var bonus = data && data.bonusAmountsData;
	var limit = data && data.depositLimitData;
	var defaultDepositAmounts = data && data.defaultDepositAmounts;
	var fee = data && data.depositFeeAmounts;
	var newBalance = data && data.newBalance;
	var limitMax = limit && limit.PARAM_MAX_OPERATION;
	var limitMin = limit && limit.PARAM_MIN_OPERATION;
	// const depositLimitReached = (parseInt(limitMax,10) === 0);
	// const feeBasedOn = (fee && fee.PARAM_AMOUNT);
	var limitCheck = checkAmountLimits(state.feeBasedOn, limitMax, limitMin);
	/* Bonusfield: conditions: when bonusamount is calculated from conditions
 build from percentage and max/min-values */
	var bonusCondition = data && data.bonus_condition;
	state.bonusAmount = bonus && bonus.PARAM_BONUS_AMOUNT;
	state.bonus_condition = bonusCondition;
	state.bonusTotal = bonus && bonus.PARAM_BONUS_TOTAL;
	state.bonusWasFound = bonus && bonus.bonusWasFound;
	state.defaultAmounts = defaultDepositAmounts;
	// state.feeBasedOn = feeBasedOn;
	state.fee = fee && fee.PARAM_FEE;
	state.feeUnit = fee && fee.PARAM_FEE_EXT;
	state.feeAmount = fee && fee.PARAM_FEE_AMOUNT;
	state.feeEnabled = fee && fee.PARAM_FEE_TYPE;
	state.feeRate = fee && fee.PARAM_RATE;
	state.feeSumAmount = fee && fee.PARAM_TOTAL_AMOUNT;
	state.limitFee = limit.PARAM_FEE_LIMIT;
	state.limitMax = limitMax;
	state.limitMin = limitMin;
	state.playerCurrency = limit.PARAM_PLAYER_CURRENCY;
	state.selectedCurrency = limit.PARAM_CURRENCY_ISO;
	state.limitResponsiveGaming = limit.PARAM_RESPONSIBLE_GAMING_LIMIT;
	state.newBalance = newBalance;
	state.limitWithin = limitCheck.within;
	state.limitAbove = limitCheck.above;
	state.limitBelow = limitCheck.below;
	state.limitReached = limitCheck.aboveIsZero;
	state.defaultAmountsFormatted = formatAmountList(defaultDepositAmounts, presetIndex);
}

function doesSelectedMethodExistInBonusPaymentMethods(selectedMethodId) {
	return state.bonusPaymentMethods.split(',').indexOf(selectedMethodId.toString()) > -1;
}

function resolveBonusIdFromValidBonusPaymentMethods(p) {
	var selectedMethodId = p && p.paymentMethodId || state.paymentMethodId;
	if (state.bonusPaymentMethods && selectedMethodId && (doesSelectedMethodExistInBonusPaymentMethods(selectedMethodId) || state.bonusPaymentMethods === 'ALL')) {
		return p && p.bonusId ? p.bonusId : state.bonusId;
	}
	return null;
}

function getDataAndAddToState(p, repeatFetchCb, validateFeesAndLimitsPromiseResolver) {
	var params = {
		paymentMethodId: p && p.paymentMethodId || state.paymentMethodId,
		creditCardNumber: p && p.creditCardNumber || state.cardNo,
		playerCardId: p && (p.playerCardId || p.playerCardId === 0) ? p.playerCardId : state.playerCardId,
		amount: p && p.amount || state.amount,
		isMobileDevice: true,
		isInstantDeposit: false,
		currency: p && p.currency ? p.currency : state.selectedCurrency,
		bonusId: resolveBonusIdFromValidBonusPaymentMethods(p)
	};
	state.feeBasedOn = params.amount;
	var jQueryParams = jQuery.param(params); // What does this do? http://api.jquery.com/jquery.param/
	function successHandler(data) {
		state.error = false;
		state.pending = false;
		parseToState(data);
		if (repeatFetchCb) {
			/* resend the request */
			repeatFetchCb();
		} else {
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].fetchFeesAndLimits(state);
			viewUpdate();
			if (validateFeesAndLimitsPromiseResolver) {
				validateFeesAndLimitsPromiseResolver('feesAndLimitsValidatedAtSubmit');
			}
		}
	}

	function errorHandler(err) {
		console.error('fetch_fees_and_limits:57:error:', err);
		state.pending = false;
		state.error = true;
	}
	if (params.paymentMethodId) {
		// Also fetch defaultAmounts from getDepositFeesAndLimits even in case of amount = 0
		// core.post(requestUrl, jQuery.param(params), (data) => {
		/* update the view to inform about a new request is send*/
		state.pending = true;
		state.error = false;
		viewUpdate();
		__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].post(requestUrl, jQueryParams, successHandler, errorHandler, 'application/x-www-form-urlencoded; charset=UTF-8');
	}
}

function registerActions() {
	function fetchFeesAndLimits(payload) {
		var data = void 0;
		var amount = void 0;
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].FETCH_METHODDETAILS) {
			/* details from a possible earlier used account */
			// TODO:if a new method is selected which differs from the last, then only use new amount and method.
			var lastAmount = payload.data && payload.data.lastAmount || state.lastAmount;
			var selectedAccountIdx = payload.data.selectedAccountIdx;
			var paymentAccounts = payload.data.accounts;
			if (lastAmount && state.amountManuallyAdded) {
				lastAmount = state.amountManuallyAdded;
			}
			state.cardNo = payload.data && payload.data.creditcardlast;
			state.playerCardId = payload.data && payload.data.lastCardId;
			state.accountId = payload.data && (payload.data.accountId || payload.data.accountId === 0) ? payload.data.accountId : null;
			state.amount = lastAmount;

			// if a last amount exists and payment method has currency selector, then update its selected currency with last selected currency
			if (selectedAccountIdx != null && paymentAccounts != null && Array.isArray(paymentAccounts)) {
				state.selectedCurrency = paymentAccounts[selectedAccountIdx].cu;
			}

			/*  messy but the intention is to fetch the fees and limits for a preset amount, which is
   retrieved with data from the first request. This shall only be done when the method is selected
   or re-selected */
			var repeatForPresetAmountCb = null;
			if (fetchAgainForPresetAmount) {
				fetchAgainForPresetAmount = false;
				repeatForPresetAmountCb = function cb() {
					var presetAmount = state && state.defaultAmountsFormatted && state.defaultAmountsFormatted[presetIndex] && state.defaultAmountsFormatted[presetIndex].value || null;
					state.amount = presetAmount;
					state.amountManuallyAdded = presetAmount;
					state.presetIndex = presetIndex;
					getDataAndAddToState({
						creditCardNumber: state.cardNo,
						playerCardId: state.playerCardId,
						accountId: state.accountId,
						amount: presetAmount,
						currency: state.selectedCurrency,
						bonusId: state.bonusId
					});
				};
			}
			getDataAndAddToState({
				creditCardNumber: state.cardNo,
				playerCardId: state.playerCardId,
				accountId: state.accountId,
				amount: lastAmount,
				currency: state.selectedCurrency || state.lastCurrency, // if a last amount exists, the lastCurrency has the unit for a new fees-and-limit request
				bonusId: state.bonusId
			}, repeatForPresetAmountCb);
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].PAYMENTMETHODS) {
			/* payload.data && payload.data.amountmanuallyset shall override other methods and
    only be adjusted by the limits.*/
			state.paymentMethodId = payload.data && payload.data.selectedId;
			state.lastAmount = payload.data && payload.data.lastAmount;
			state.lastCurrency = payload.data && payload.data.lastCurrency;
			state.playerCurrency = payload.data && payload.data.playerCurrency;
			if (__WEBPACK_IMPORTED_MODULE_5__deposit_form_template_conf_js__["a" /* default */].displayAmountSelector()) {
				fetchAgainForPresetAmount = true;
			}
			if (payload.data.lastCurrency && payload.data.selectedId === payload.data.lastUsedMethodId && __WEBPACK_IMPORTED_MODULE_5__deposit_form_template_conf_js__["a" /* default */].displayCurrencySelector(payload.data.methods.by_id[payload.data.selectedId].formTemplateCode)) {
				state.selectedCurrency = state.lastCurrency;
			} else {
				state.selectedCurrency = state.playerCurrency;
			}
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_CURRENCYSELECT) {
			// TODO: update backend service(?) to update from currency which happens for some paymentmethods (skrill)
			state.selectedCurrency = payload.data;
			getDataAndAddToState();
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_METHODS) {
			// method changed by user: reset parameters and wait for paymentMethods to update.
			// There will be a new payload of FETCH_METHODDETAILS comming, then we fetch fees and limits
			// The update of method is set by paymentmethods-module.
			state.paymentMethodId = null;
			state.cardNo = null;
			state.playerCardId = null;
			state.selectedCurrency = null;
		}

		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_CREDITCARDLAST) {
			data = payload.data;
			state.playerCardId = data.cardid;
			state.cardNo = data.cn;
			getDataAndAddToState();
		}

		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_CREDITCARDNEW) {
			data = payload.data;
			state.cardNo = data;
			state.playerCardId = null;
			getDataAndAddToState({
				amount: state.amount || state.lastAmount
			});
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_AMOUNTINPUT && payload.data) {
			/* The paymentforms amount-input is updated and the fee has to be compared to the amount.
       start or stop a timer to compare when the call was last done.
       The view_paymentform dispatches actions each time a new value is typed into the field.
       count number of calls to the getDataAndReplaceState-function
       check timer to see when last call was done.
       if time was less than x-milliseconds then add to the counter and wait for more input
       if more input is recieved then wait further, and when wait is over call for the las recieved amount.
         */
			amount = payload.data.amount || payload.data.amount === 0 ? payload.data.amount : null;
			if (amount) {
				state.amount = amount;
				state.amountManuallyAdded = amount; // overrides other amounts until adjusted by limits
				if (!state.limitReached) {
					getDataAndAddToState();
				}
			}
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_AMOUNTSELECT) {
			state.amount = payload.data && payload.data.amount;
			state.amountManuallyAdded = payload.data && payload.data.amount;
			getDataAndAddToState();
		}
		// if (payload.type === constants.VIEW_PAYMENTFORM) {
		// console.log('fetch_fees_and_limits:VIEW_PAYMENTFORM', payload);
		// setupmethod
		// }
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].BONUSES) {
			/* Confirmed selected bonus. */
			if (payload.data && {}.hasOwnProperty.call(payload.data, 'selected') && {}.hasOwnProperty.call(payload.data.selected, 'id')) {
				state.bonusId = payload.data.selected.id;
			}
			if (payload.data && payload.data.selected && payload.data.selected.validPaymentMethods) {
				state.bonusPaymentMethods = payload.data.selected.validPaymentMethods;
			}

			if (payload.data && payload.data.condition) {
				state.bonus_condition = payload.data.condition;
			}
			// We could skip this extra fetch of fees and limits if fetch_fees_and_limits is initialized before bonus is selected,
			// because then we would already have the bonusId when fetching fees and limits after call to get form template data
			getDataAndAddToState();
		}

		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VALIDATE_FEES_AND_LIMITS_AT_SUBMIT) {
			var validateFeesAndLimitsPromiseResolver = payload.data;
			getDataAndAddToState(null, null, validateFeesAndLimitsPromiseResolver);
		}
	}

	register(fetchFeesAndLimits);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(url) {
		if (url) {
			requestUrl = url;
		} else {
			console.error('fetch_fees_and_limits:89:init: no url provided', url);
		}
		registerActions();
	},
	__testCheckAmountLimits: function __testCheckAmountLimits(amount, max, min) {
		return checkAmountLimits(amount, max, min);
	},
	__testCheckFormatAmountList: function __testCheckFormatAmountList(obj, currency) {
		return formatAmountList(obj, currency);
	}
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_js__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__deposit_form_template_conf_js__ = __webpack_require__(138);
/*
 fetch-methoddetails
 Last method is any of the methods described in 'paymentMethods' module.

 an alternative name for this module is:
 "fetch-methoddetails"
 */







var register = __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__["a" /* default */].register;
var state = {
	accounts: {
		by_id: {}
	},
	creditcardlast: null,
	selectedAccountIdx: null,
	lastAmount: null
};

function viewUpdate() {
	__WEBPACK_IMPORTED_MODULE_4__view_js__["a" /* default */].update({
		fetch_methoddetails: state
	});
}

function sortById(accounts) {
	var byId = {};
	if (accounts) {
		accounts.forEach(function (elm) {
			if (elm.id) {
				byId[elm.id] = elm;
			}
		});
	}
	return byId;
}

function filterAccountResponse(data) {
	var hasAccounts = data && data.hasAccounts;
	var currencies = data && data.currencies;
	var accounts = data && data.accounts;
	var accountsById = sortById(accounts);
	var lastUsedAccountIdx = data && (data.lastUsedAccountIdx || data.lastUsedAccountIdx === 0) ? data.lastUsedAccountIdx : null;
	var lastAccount = (lastUsedAccountIdx || lastUsedAccountIdx === 0) && accounts && accounts[lastUsedAccountIdx];
	var lastAmount = lastAccount && lastAccount.amount;
	var lastCardNo = lastAccount && lastAccount.cardNo;
	var lastCardId = lastAccount && lastAccount.id;
	return {
		accounts: accounts,
		accountsById: accountsById,
		currencies: currencies,
		selectedAccountIdx: lastUsedAccountIdx,
		lastUsedAccountIdx: lastUsedAccountIdx,
		selectedAccount: lastAccount,
		lastAmount: lastAmount,
		creditcardlast: lastCardNo,
		lastCardId: lastCardId,
		lastCardNo: lastCardNo,
		hasAccounts: hasAccounts
	};
}

function getDataAndReplaceState(url, params, methodName) {
	state.error = null;

	function successHandler(data) {
		// TODO: merge the 'filterAccountResponse' with this 'successHandler'
		var res = filterAccountResponse(data);
		var accounts = res.accounts || {};
		var currencies = res.currencies || {};
		var lastUsedAccountIdx = res.lastUsedAccountIdx;
		var lastAmount = res.lastAmount;
		var creditcardlast = res.creditcardlast;
		var hasAccounts = res.hasAccounts;
		var lastCardId = res.lastCardId;
		accounts.by_id = res.accountsById;

		state.accounts = accounts; /* used in view-creditcard*/
		state.currencies = currencies;
		state.lastAmount = lastAmount;
		state.creditcardlast = creditcardlast; // the number like '***********1111'
		state.lastCardId = lastCardId;
		state.accountId = lastUsedAccountIdx;
		state.lastUsedAccountIdx = lastUsedAccountIdx;
		state.selectedAccountIdx = lastUsedAccountIdx; /* used in view-creditcardlast*/
		state.hasAccounts = hasAccounts;
		__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].fetchMethodDetails(state);
		viewUpdate();
	}

	function errorHandler(err) {
		console.error('fetch-methoddetails:57:failure:', err);
		state.error = ':' + methodName; // contains a ':' (colon) to give true from Boolean(state.error)
		viewUpdate();
	}

	if (url) {
		__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].post(url, params, successHandler, errorHandler, 'application/x-www-form-urlencoded; charset=UTF-8');
	} else {
		// Pretend we fetched form data so that we set some state without accounts and sends the right action
		successHandler({
			hasAccounts: false,
			lastAmount: 0
		});
	}
}

function getFormTemplateData(url, params, methodName, methodId, formTemplateCode) {
	if (__WEBPACK_IMPORTED_MODULE_5__deposit_form_template_conf_js__["a" /* default */].isValid(formTemplateCode)) {
		/* confirm that a module exist for the selected method */
		var allParams = 'isMobile=true' + params;
		getDataAndReplaceState(url, allParams, methodName);
	} else {
		console.warn('fetch-methoddetails:146:getFormTemplateData: no valid method id provided for returning deposit:', methodId);
	}
}

function registerActions() {
	function fetchMethodDetails(payload) {
		var currentAccount = null;
		var currentCardNo = null;
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].PAYMENTMETHODS) {
			/* see structure of data in 'paymentmethods module' */
			/* when a new method is selected the paymentmethods.js-module updates
   and this action is recieved*/
			var currentPaymentMethodId = payload.data && payload.data.selectedId;
			if (payload.data) {
				var formTemplateUrl = payload.data && payload.data.selectedDetailsUrl;
				var methodName = payload.data && payload.data.selectedMethodName;
				var params = payload.data && payload.data.selectedDetailsParams;
				var formTemplateCode = payload.data.methods.by_id[currentPaymentMethodId].formTemplateCode;
				getFormTemplateData(formTemplateUrl, params, methodName, currentPaymentMethodId, formTemplateCode);
			} else {
				console.warn('fetch-methoddetails:137:registerActions: PAYMENTMETHODS: no property "data" of payload', payload);
			}
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_METHODS) {
			// method change: reset parameters and wait for paymentMethods to update.
			state.accounts = null; /* used in view-creditcard*/
			state.currencies = null;
			state.lastAmount = null;
			state.creditcardlast = null; // the number like '***********1111'
			state.lastCardId = null;
			state.accountId = null;
			state.lastUsedAccountIdx = null;
			state.selectedAccountIdx = null; /* used in view-creditcardlast*/
			state.hasAccounts = null;
		}

		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_CREDITCARDLAST) {
			currentAccount = payload.data;
			currentCardNo = currentAccount && currentAccount.cn;
			state.creditcardlast = currentCardNo;
			viewUpdate();
		}
	}

	register(fetchMethodDetails);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init() {
		registerActions();
	}
};

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_js__ = __webpack_require__(46);
/*
payments/fetch_paymentmethods
Gets the data and dispatches action when done.

*/






var state = {};
var register = __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__["a" /* default */].register;
var requestUrl = null;

function viewUpdate() {
	__WEBPACK_IMPORTED_MODULE_4__view_js__["a" /* default */].update({
		fetch_paymentmethods: state
	});
}

function parseToState(data) {
	if (data) {
		state = data;
		__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].fetchPaymentmethods(state);
	} else {
		console.error('fetch_paymentmethods:50:parseToState:can not read data', data);
	}
}

function getDataAndReplaceState() {
	state.error = false;
	function successHandler(data) {
		state.error = false;
		parseToState(data);
	}

	function errorHandler(err) {
		console.error('fetch_paymentmethods:error:', err);
		state.error = true;
		viewUpdate();
	}
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].get(requestUrl, successHandler, errorHandler);
}

function registerActions() {
	function fetchPaymentmethods(payload) {
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].SETUP_PAYMENT) {
			getDataAndReplaceState();
		}
	}
	register(fetchPaymentmethods);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(url) {
		/* set the ajax url to the paymentmethods*/
		requestUrl = url;
		registerActions();
	}
};

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_dataflow_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_js__ = __webpack_require__(46);
/*
 * Created by patricio on 11/10/16.
 */

/*
first_time_uk_deposit
*/






var conf = {
	showDepositLimitOptionUrl: '/UkComplianceService/ukShowDepositLimitOption',
	ukSetResponsibleGamingDepositLimitUrl: '/UkComplianceService/ukSetResponsibleGamingDepositLimit'
};

var state = {
	isFirstTime: null
};
var register = __WEBPACK_IMPORTED_MODULE_2__common_lib_dataflow_js__["a" /* default */].register;

function viewUpdate() {
	__WEBPACK_IMPORTED_MODULE_3__view_js__["a" /* default */].update({
		first_time_uk_deposit: state
	});
}

function parseToState(data) {
	if (data) {
		if (data.JSON_UK_DEPOSIT_SHOW_LIMIT_OPTION === 'YES') {
			state.isFirstTime = true;
			viewUpdate();
		} else if (data.JSON_UK_DEPOSIT_SHOW_LIMIT_OPTION === 'NO') {
			state.isFirstTime = false;
			viewUpdate();
		} else {
			console.warn('first_time_uk_deposit:parseToState: can not get "JSON_UK_DEPOSIT_SHOW_LIMIT_OPTION"', data);
		}
	} else {
		console.error('first_time_uk_deposit:50:parseToState:can not read data:', data);
	}
}

function getDataAndReplaceState() {
	function successHandler(data) {
		parseToState(data);
	}

	function errorHandler(err) {
		console.error('first_time_uk_deposit:error:', err);
	}

	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].get(conf.showDepositLimitOptionUrl, successHandler, errorHandler);
}

function sendDailyLimit() {
	var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	// send POST request to set new limit up
	function successHandler(data) {
		console.info('first_time_uk_deposit:sendDailyLimit:successHandler:limited updated', data);
	}

	function errorHandler(err) {
		console.error('first_time_uk_deposit:error:limit not updated', err);
	}

	var data = {
		depositLimitValue: amount,
		isMobileDevice: true,
		limitType: 'deposit-daily',
		firstDeposit: true
	};

	var url = conf.ukSetResponsibleGamingDepositLimitUrl;
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].post(url, jQuery.param(data), successHandler, errorHandler, 'application/x-www-form-urlencoded');
}

function registerActions() {
	function firstTimeUkDepositActions(payload) {
		if (payload.type === __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_constants_js__["a" /* default */].SETUP_PAYMENT) {
			/* initialize the request to check it the link shall be present in the view */
			getDataAndReplaceState();
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_constants_js__["a" /* default */].VIEW_UK_FIRST_TIME_DEPOSIT_LINK) {
			/* it this action is dispatched from the view, for example a click on the link, the
   new request to set the limit will be done. */
			// We don't do anything with the response of this call (in desktop) but we could
			// use notifications.informationMessage feature
			var amount = payload.data || null;
			if (amount) {
				sendDailyLimit(amount);
			} else {
				console.info('first-time-uk-deposit: no limit is set, amount was zero or nothing');
			}
		}
	}

	register(firstTimeUkDepositActions);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init() {
		registerActions();
	}
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_dataflow_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_payment_result_js__ = __webpack_require__(198);
/*
 payment/payment/lib/immediate_payment_result_router
 */




// TODO: use view_spinner from view module. All domupdates are routed from the 'view.js'.
// import viewSpinner from './view-spinner.js';
// import viewSpinner from '../../commonview/lib/view-spinner.js';

var register = __WEBPACK_IMPORTED_MODULE_1__common_lib_dataflow_js__["a" /* default */].register;

function registerActions() {
	function immediatePaymentResultRouter(payload) {
		// Only used for immediate results (in situations when not showing the provider page)
		if (payload.type === __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_constants_js__["a" /* default */].ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL || payload.type === __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_constants_js__["a" /* default */].RESULT_AFTER_SINGLE_CALL) {
			__WEBPACK_IMPORTED_MODULE_2__components_payment_result_js__["a" /* default */].functions.open(payload.paymentHandled);
		}
	}
	register(immediatePaymentResultRouter);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init() {
		registerActions();
	}
};

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_dataflow_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_js__ = __webpack_require__(46);
/*
 paymentmethods
 parse data from rest-api into app-specific format
 */
// "paymentMethods": [{
//     "sendHandlerType": "SEND_HANDLER_CONTROLLER",
//     "logoImgClasses": ["visa",
//         "mastercard",
//         "visa_electron",
//         "maestro",
//         "default"
//     ],
//     "methodText": "Credit Card",
//     "methodId": 1,
//     "methodName": "Credit Card",
//     "executeUrl": "/CreditCardIntegration/executeDeposit",
//     "methodInfo": "Type in your card details or select a previously saved card, choose your bonus, select the amount and make a deposit.",
//     "formTemplateCode": "CREDIT-CARD",
//     "formTemplateUrlParams": "\u0026paymentMethodId\u003d1\u0026paymentType\u003ddeposit",
//     "paymentType": "deposit"
// },...





var register = __WEBPACK_IMPORTED_MODULE_2__common_lib_dataflow_js__["a" /* default */].register;

var state = {
	formTemplateCode: {},
	lastUsedMethodDetails: null,
	playerCurrency: null,
	methods: {
		by_id: {},
		by_name: {}
	},
	selected: {
		id: 1,
		text: 'default' // this reflects the name of the method, and may be changed according to textkeys. 'default' method is selected by the id: 1;
	},
	selectedId: null
};

function viewUpdate() {
	__WEBPACK_IMPORTED_MODULE_3__view_js__["a" /* default */].update({
		paymentmethods: state
	});
}

function lastUsedName(id, methodsById) {
	var name = id && methodsById ? methodsById[id] && methodsById[id].methodName : null;
	return name;
}

function sortByName(arr) {
	var obj = null;
	var key = null;
	if (arr && arr.length > 0) {
		obj = {};
		arr.forEach(function (elm) {
			key = elm.methodName;
			obj[key] = elm;
		});
	}
	return obj;
}

function sortById(arr) {
	var obj = null;
	var key = null;
	if (arr && arr.length > 0) {
		obj = {};
		arr.forEach(function (elm) {
			key = elm.methodId;
			obj[key] = elm;
		});
	}
	return obj;
}

function sortByFormTemplateCode(arr) {
	/*
 Sort on method-template-type.
 templatecode is the type of the method, for example
 CREDIT-CARD, EMAIL-CURRENCIES, CLICK-TO-PAY, TWO-FIELDS, NETELLER, BANKWIRE
 A selected method has one of these types.
 */
	var obj = {};
	if (arr && arr.length > 0) {
		arr.forEach(function (elm) {
			var key = elm.formTemplateCode;
			obj[key] = elm.formTemplateMobileUrl;
		});
	}
	return obj;
}

function registerActions() {
	function paymentmethods(payload) {
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].FETCH_PAYMENTMETHODS) {
			/* the non-modified response from the ajax-call*/
			var payloadDataPaymentMethods = payload.data && payload.data.paymentMethods;
			var payloadDataFormTemplateTypes = payload.data && payload.data.formTemplateTypes;
			var templateTypesByCode = sortByFormTemplateCode(payloadDataFormTemplateTypes);
			var methodsByName = sortByName(payloadDataPaymentMethods);
			var methodsById = sortById(payloadDataPaymentMethods);
			// const payloadDataFormTemplateCode
			var validData = payloadDataPaymentMethods.length && payloadDataPaymentMethods.length > 0;
			var payloadDataPlayerCurrency = payload.data && payload.data.playerCurrency;
			var lastUsedMethodDetails = payload.data && payload.data.lastUsedMethodDetails;
			var lastAmount = lastUsedMethodDetails && lastUsedMethodDetails.lastAmount;
			var lastCurrency = lastUsedMethodDetails && lastUsedMethodDetails.lastCurrency;
			var lastUsedMethodId = lastUsedMethodDetails && lastUsedMethodDetails.lastPaymentMethodId;
			var lastUsedMethod = lastUsedMethodId && methodsById && methodsById[lastUsedMethodId];
			var lastUsedTypeCode = lastUsedMethod && lastUsedMethod.formTemplateCode;
			var lastUsedDetailsUrl = templateTypesByCode && lastUsedTypeCode && templateTypesByCode[lastUsedTypeCode];
			var lastUsedDetailsParams = lastUsedMethod && lastUsedMethod.formTemplateUrlParams;
			// const lastUsedDetailsUrl = ();
			var lastUsedMethodName = lastUsedName(lastUsedMethodId, methodsById);
			// const lastUsedMethodDetailsUrl =
			var firstDeposit = Boolean(lastUsedMethodDetails && lastUsedMethodDetails.firstDeposit);
			if (validData) {
				state.methods.by_id = methodsById;
				state.methods.by_name = methodsByName;
				state.formTemplateCode = templateTypesByCode;
				state.playerCurrency = payloadDataPlayerCurrency;
				state.lastUsedMethodDetails = lastUsedMethodDetails;
				state.lastAmount = lastAmount;
				state.lastCurrency = lastCurrency;
				state.lastUsedMethodId = lastUsedMethodId;
				state.selectedId = lastUsedMethodId;
				state.lastUsedMethodEqualsNew = true; /* reset */
				state.selected.id = lastUsedMethodId;
				state.selectedId = lastUsedMethodId; // To simplify the reading of this state, the id is stored at a less deep level
				state.selectedText = lastUsedMethodName;
				state.selected.text = lastUsedMethodName;
				state.selectedMethodName = lastUsedMethodName;
				state.selectedDetailsUrl = lastUsedDetailsUrl;
				state.selectedDetailsParams = lastUsedDetailsParams;
				// state.selectedTemplateUrl = lastUsedTypeCode;
				state.firstDeposit = firstDeposit;
				viewUpdate();
				__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].paymentmethods(state);
			} else {
				console.error('paymentmethods:128:FETCH_PAYMENTMETHODS: response has no methods', payload);
				state.error = true;
			}
			viewUpdate();
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_METHODS) {
			/* publish details about the new selected method, update view*/
			var selectedId = payload.id;
			var selectedName = payload.text;
			state.selected.id = selectedId;
			state.selectedId = selectedId; // To simplify the reading of this state, the id is stored at a less deep level
			state.selectedText = selectedName;
			state.selected.text = selectedName;

			var paymentMethodSelected = state.methods.by_id[selectedId];
			state.selectedDetailsParams = paymentMethodSelected.formTemplateUrlParams;
			var formTemplateCodeSelectedMethod = paymentMethodSelected.formTemplateCode;
			state.selectedDetailsUrl = state.formTemplateCode[formTemplateCodeSelectedMethod];
			state.selectedMethodName = paymentMethodSelected.methodName;

			state.lastUsedMethodEqualsNew = state.lastUsedMethodId === selectedId;
			state.methodswitch = true;
			viewUpdate();
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].paymentmethods(state);
			state.methodswitch = false;
		}
		// if (payload.type === constants.VIEW_AMOUNTINPUT && payload.data) {
		// a new amount is manually added in the amountinput field
		// this value should be prioritized over 'last used for an account'
		// when selecting a new method.
		// key 'amountmanuallyset' is preferrably changed or maybe the
		// state.lastAmount is used.
		// state.amountmanuallyset = payload.data.amount;
		// the next time fees and limits is fetched this amount can be used.
		// }
	}
	register(paymentmethods);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init() {
		registerActions();
	}
};

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_dataflow_js__ = __webpack_require__(20);
/*
 payments/payments/result_after_single_call
 */





var register = __WEBPACK_IMPORTED_MODULE_2__common_lib_dataflow_js__["a" /* default */].register;
var state = {
	paymentmethods: null, // see structure in 'paymentmethods.js'
	paymentResultData: null
};

function registerActions() {
	function resultAfterSingleCall(payload) {
		var accHistRef = void 0;

		var paymentFetchResultFlow = void 0;
		var paymentHandled = void 0;
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].PAYMENTMETHODS) {
			state.paymentmethods = payload.data;
		}

		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].SUBMIT_PAYMENT) {
			if (payload && payload.sendHandlerType === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].RESULT_AFTER_SINGLE_CALL) {
				// sendHandlerData = payload.sendHandlerData;
				accHistRef = payload.accHistRef;
				paymentFetchResultFlow = payload.paymentFetchResultFlow;
				paymentHandled = {
					fetch_type: __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].FETCH_TYPE_SYNCH,
					accHistRef: accHistRef,
					paymentFetchResultFlow: paymentFetchResultFlow
				};
				// actions.paymentHandled(paymentHandled);
				__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].resultAfterSingleCall(paymentHandled);
			}
		}
	}
	register(resultAfterSingleCall);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init() {
		registerActions();
	}
};

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_dataflow_js__ = __webpack_require__(20);
/*
 send_handler_controller
 */




var register = __WEBPACK_IMPORTED_MODULE_2__common_lib_dataflow_js__["a" /* default */].register;

var state = {
	paymentmethods: null, // see structure in 'paymentmethods.js'
	paymentResultData: null
};

function registerActions() {
	function sendHandlerController(payload) {
		var accHistRef = void 0;
		var paymentFetchResultFlow = void 0;
		var sendHandlerControllerData = void 0;
		var actualSendHandlerData = void 0;
		var actualSendHandler = void 0;
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].PAYMENTMETHODS) {
			/* Get details about payment */

			state.paymentmethods = payload.data;
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].SUBMIT_PAYMENT) {
			if (payload && payload.sendHandlerType === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].SEND_HANDLER_CONTROLLER) {

				// Alternative code below for actualSendHandler is for Emp having GsonJerseyProvider to be able to deliver data to CreditCardIntegration as well
				sendHandlerControllerData = payload.sendHandlerData.actualSendHandler !== undefined ? payload.sendHandlerData : payload.sendHandlerData.handler;
				actualSendHandlerData = typeof sendHandlerControllerData.sendHandlerData !== 'undefined' ? sendHandlerControllerData.sendHandlerData : payload.sendHandlerData;

				accHistRef = payload.accHistRef;

				paymentFetchResultFlow = payload.paymentFetchResultFlow;

				actualSendHandler = sendHandlerControllerData.actualSendHandler;

				__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].submitPayment({
					type: __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].SUBMIT_PAYMENT,
					sendHandlerData: actualSendHandlerData,
					accHistRef: accHistRef,
					paymentFetchResultFlow: paymentFetchResultFlow,
					sendHandlerType: actualSendHandler
				});
			}
		}
	}
	register(sendHandlerController);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init() {
		registerActions();
	}
};

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__webpack_provided_window_dot_jQuery) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__validate_amount_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_js__ = __webpack_require__(46);
/*
 submit-payment.js

 */







var jQuery = __webpack_provided_window_dot_jQuery; // TODO: todo...

var register = __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__["a" /* default */].register;
var state = {
	methodId: null,
	methodName: null, // used to confirm id and method
	success: null,
	title: null,
	message: null,
	cardnumber: null,
	bonusPaymentMethods: ''
};

function viewUpdate() {
	__WEBPACK_IMPORTED_MODULE_5__view_js__["a" /* default */].update({
		submit_payment: state
	});
}

function resetInput() {
	state.sendDepositParameters = null;
	state.error = null;
	state.ageverifyerror = null;
	state.complianceerror = null;
	state.buttontext = null;
	state.success = null;
	state.title = null;
	state.currentcard = null;
	state.verificationmsg = null;
}

function hasEqualMethodIds(obj) {
	/* if object has two keys referring to the same payment method, these must be equal */
	var versionA = obj.methodId && obj.methodId.toString && obj.methodId.toString();
	var versionB = obj.paymentMethodId && obj.paymentMethodId.toString && obj.paymentMethodId.toString();
	var equal = Boolean(versionA === versionB);
	if (!equal) {
		console.error('submit_payment:83:hasEqualMethodIds: paymentMethodId and methodId does not correlate:', obj);
	}
	return equal;
}

function errorHandler(err) {
	state.error = true;
	state.title = 'submit-payment:error';
	state.message = 'network connection or remote problems, confirm that you are logged in and connected and try again. Otherwise contact support!';
	console.error('submit-payment:176:errorHandler', err);
	viewUpdate();
}

function noResponseHandler(err) {
	state.success = false;
	state.title = 'The server is not responding.';
	state.message = 'Make sure you are logged in and try again, please.';
	console.error('submit-payment:61:', err);
	viewUpdate();
}

function executePaymentMethod() {
	state.error = false;
	var sendHandlerType = state.sendHandlerType;

	function responseHandler(res) {
		if (res && res.successful) {
			state.success = true;
			state.pending = false;
			viewUpdate();
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].submitPayment({
				success: true
			});
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].submitPayment({
				success: true,
				sendHandlerData: res.sendHandlerData,
				accHistRef: res.accHistRef,
				paymentFetchResultFlow: res.paymentFetchResultFlow,
				sendHandlerType: sendHandlerType
			});
		} else {
			state.pending = false;
			console.info('submit_payment:56:can not complete the transaction.', res);
			state.error = true;
			if (res.errorMessage) {
				state.success = false;
				state.title = res.errorMessage.title || 'some values might be missing';
				state.message = res.errorMessage.message || 'please try again';
				__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].submitPayment(false);
			}
			viewUpdate();
		}
		resetInput();
		viewUpdate();
	}
	// During redirect for some methods the network info may be lost, so the
	// following console output makes certain values visible. Check the 'preserve log'
	// in chrome devtools console.
	console.info('submit-payment:105:executePaymentMethod: methodUrl', state.methodUrl);
	console.info('submit-payment:104:executePaymentMethod: sendDepositParameters', state.sendDepositParameters);
	console.info('submit-payment:104:executePaymentMethod: sendDepositParameters.am', state.sendDepositParameters.am);
	console.info('submit-payment:104:executePaymentMethod: sendDepositParameters.cu', state.sendDepositParameters.cu);
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].post(state.methodUrl, state.sendDepositParameters, responseHandler, noResponseHandler);
}

function updateUKCompliance() {
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].post('/UkComplianceService/ukDepositTandCAgreementRemoveDepositPopup', {
		isMobileDevice: true
	}, function (data) {
		console.info('Response from ukDepositTandCAgreementRemoveDepositPopup');
		console.info(data);
	}, function () {
		console.error('Error from ukDepositTandCAgreementRemoveDepositPopup');
	}, 'application/x-www-form-urlencoded; charset=UTF-8');
}

function requestUseraction(tAndCResponse) {
	/* regarding compliance*/
	state.complianceerror = true;
	state.message = tAndCResponse && tAndCResponse.UK_DEPOSIT_TERMS_UPDATED || 'UK_DEPOSIT_TERMS_UPDATED';
	state.title = tAndCResponse && tAndCResponse.UK_DEPOSIT_TERMS_UPDATED_HEADER || 'UK_DEPOSIT_TERMS_UPDATED_HEADER';
	viewUpdate();
}

function checkComplianceStatus() {
	state.complianceerror = false;

	function okCb() {
		executePaymentMethod();
	}

	function notOkCb(tAndCResponse) {
		state.pending = false;
		viewUpdate();
		requestUseraction(tAndCResponse);
		//resetInput();
	}

	function compResultHandler(tAndCResponse) {
		if (tAndCResponse.RESULT === 'OK') {
			okCb();
		} else {
			notOkCb(tAndCResponse);
		}
	}
	var requestAndParam = '/UkComplianceService/ukDepositTandCAgreementCheckService?' + jQuery.param({
		isMobileDevice: true
	});
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].get(requestAndParam, compResultHandler, errorHandler);
}

function showVerifyAgeError(verifyAgeData) {
	state.error = true;
	state.ageverifyerror = true;
	state.title = verifyAgeData.ERROR_HEADER || 'CALL_CREDIT_AGE_VERIFY_ERROR_HEADER'; // see comeon-payment-services/comeon-ukcompliance: … UkAgeVeriyfLogic.java
	state.message = verifyAgeData.ERROR || 'CALL_CREDIT_AGE_VERIFY_ERROR';
	// state.buttontext = verifyAgeData.BUTTON_TEXT || 'SIDE_MENU_UPLOAD';
	viewUpdate();
}

function verifyAgeSuccesHandler(verifyAgeData) {
	if (verifyAgeData.RESULT === 'OK') {
		checkComplianceStatus();
	} else {
		state.pending = false;
		resetInput();
		showVerifyAgeError(verifyAgeData);
	}
	viewUpdate();
}

function verifyAgeAndSendDeposit(amount, methodId) {
	state.ageverifyerror = false;
	var ageParameters = {
		am: amount,
		paymentMethod: methodId,
		cu: 'USERSESSIONS_CURRENCY',
		isMobileDevice: true
	};
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].get('/UkComplianceService/verifyAgeService?' + jQuery.param(ageParameters), verifyAgeSuccesHandler, errorHandler);
}

function registerActions() {
	function submitPayment(payload) {
		var amount = null;
		var creditcardlast = null;
		var card = null;
		var pData = null;
		var mId = null;
		var methodsById = null;
		var selected = null;
		var selectedmethod = null;
		var sendHandlerType = null;
		var methodName = null;
		var methodUrl = null;
		var ukcompliance = payload.data && payload.data.ukcompliance;
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].PAYMENTMETHODS) {
			/* Get details about payment to prepare for submit.*/
			var currency = payload.data && payload.data.playerCurrency;
			pData = payload.data;
			selected = pData && pData.selected;
			methodName = selected && selected.text;
			// mId = (selected && selected.id);
			mId = payload.data && payload.data.selectedId;
			methodsById = pData && pData.methods && pData.methods.by_id;
			selectedmethod = mId && methodsById && methodsById[mId];
			methodUrl = selectedmethod && selectedmethod.executeUrl;
			sendHandlerType = selectedmethod && selectedmethod.sendHandlerType;
			state.methodId = mId;
			state.methodName = methodName;
			state.methodUrl = methodUrl;
			state.sendHandlerType = sendHandlerType;
			state.currency = currency;
		}

		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].BONUSES) {
			/* Confirmed selected bonus. */
			if (payload.data && {}.hasOwnProperty.call(payload.data, 'selected')) {
				if ({}.hasOwnProperty.call(payload.data.selected, 'id')) {
					state.bid = payload.data.selected.id;
					state.bonusPaymentMethods = payload.data.selected.validPaymentMethods;
				} else {
					console.warn('submit_payment:174:registerActions: property "id" is not in object', payload);
				}
			} else {
				console.warn('submit_payment:167:registerActions: property "selected" is not in object', payload);
			}
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_CURRENCYSELECT) {
			// TODO: update backend service(?) to update from currency which happens for some paymentmethods (skrill)
			state.currency = payload.data;
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_AMOUNTSELECT) {
			amount = payload.data && payload.data.amount;
			amount = __WEBPACK_IMPORTED_MODULE_4__validate_amount_js__["a" /* default */].keepDigits(amount);
			if (amount) {
				state.amount = amount;
				viewUpdate();
			}
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_CREDITCARD) {
			state.currentcard = payload.data;
			card = payload.data && payload.data.card;
			state.cardnumber = card && card.cn || state.cardnumber;
			viewUpdate();
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_CREDITCARDLAST) {
			state.currentcard = payload.data;
			state.cardnumber = payload.data && payload.data.cn || null;
			state.error = null;
			state.success = null;
			state.title = null;
			viewUpdate();
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].FETCH_METHODDETAILS) {
			creditcardlast = payload.data && payload.data.creditcardlast;
			state.cardnumber = creditcardlast || null;
		}

		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_PAYMENT_METHOD_LINK) {
			if (state.currentcard && state.currentcard.card) {
				if (state.currentcard.card.cc) {
					state.currentcard.card.cc = null;
					state.refreshinput = true;
				}
			}
			/* reset critical info, like cvc if method is creditcard. */
			viewUpdate();
			/* reset flag after use */
			state.refreshinput = false;
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW) {
			if (payload.data && payload.data.ageverification && payload.data.ageverification.confirm) {
				resetInput();
			} else if (payload.data && payload.data.ageverification && !payload.data.ageverification.confirm) {
				resetInput();
			}
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_PAYMENTFORM) {
			if (ukcompliance && ukcompliance.confirm) {
				updateUKCompliance();
				executePaymentMethod();
			} else if (ukcompliance && !ukcompliance.confirm) {
				// enableDepositButton?
			}
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_PAYMENTFORM_SUBMIT) {
			if (payload && payload.data) {
				/* Properties all time present are 'methodId' and 'methodName'. Other properties varies depending on the method. */
				state.sendDepositParameters = payload.data;
				state.sendDepositParameters.isMobileDevice = true;
				state.sendDepositParameters.cu = state.currency;
				/* bonus id */
				if (state.bid !== -1 && state.bonusPaymentMethods && (state.bonusPaymentMethods.split(',').indexOf(String(payload.data.methodId)) > -1 || state.bonusPaymentMethods === 'ALL')) {
					state.sendDepositParameters.bid = state.bid;
				}
				state.pending = true;
				viewUpdate();
				amount = state.sendDepositParameters.am;
				if (state.methodUrl && hasEqualMethodIds(state.sendDepositParameters)) {
					/* both the keys 'methodId' and 'paymentMethodId' are used, once in 'getDepositPaymentMethods' and once in the required structure for creditcard. */
					verifyAgeAndSendDeposit(amount, state.methodId);
				}
			} else {
				console.warn('submit_payment:34: can not read payload:', payload);
			}
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].FETCH_FEES_AND_LIMITS) {
			if (payload && payload.data) {
				state.currency = payload.data.selectedCurrency;
			}
		}
	}

	register(submitPayment);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init() {
		registerActions();
	}
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4)))

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
validate-dotpay
*/

function _containsOnlyDigits(t) {
	// const nums = new RegExp(/^\+?\d+$/);
	var nums = new RegExp(/^\+?[0-9]+$/);
	return Boolean(nums.test(t));
	// return (/^\+?\d+$/).test(t);
}

function hasStringLength(t, n) {
	var str = (t || t === 0) && t.toString();
	return Boolean(str && str.length && str.length === n);
}

function _hasStringLengthLessThan(t, n) {
	var str = (t || t === 0) && t.toString();
	var L = str.length;
	return Boolean(str && L < n);
}

function _code(t) {
	return hasStringLength(t, 6) && _containsOnlyDigits(t);
}

function filterNonDigits(t) {
	/* does not allow exponential char 'e'*/
	var str = t && t.toString();
	var nums = str && str.replace(/[^0-9]/g, '');
	return nums;
}

function restrictToLength(t, n) {
	return t && t.substring(0, n) || null;
}
/* harmony default export */ __webpack_exports__["a"] = {
	code: function code(t) {
		return _code(t);
	},
	containsOnlyDigits: function containsOnlyDigits(t) {
		return _containsOnlyDigits(t);
	},
	hasStringLengthLessThan: function hasStringLengthLessThan(t, n) {
		return _hasStringLengthLessThan(t, n);
	},
	filterAwayNotValid: function filterAwayNotValid(t) {
		var digitsAsString = filterNonDigits(t);
		var limited = restrictToLength(digitsAsString, 6);
		var num = parseInt(limited, 10);
		// return restrictToLength(digitsAsString, 6);
		return num;
	}
};

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_spinnersmall_js__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_currency_formatter_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__libs_locale_js__ = __webpack_require__(31);
/*
 view-amountfee

 table-basic
 <table class="table-basic u-mb2 u-pr1">
 <tfoot>
 <tr>
 <td>Updated Balance</td>
 <td class="u-text-r">£456,10</td>
 </tr>
 </tfoot>
 <tbody>
 <tr>
 <td>Deposit Amount:</td>
 <td class="u-text-r">100.00 SEK</td>
 </tr>
 <tr>
 <td>Deposit Fee (2.5%):</td>
 <td class="u-text-r">2.50 SEK</td>
 </tr>
 <tr>
 <td>Earned Points</td>
 <td class="u-text-r">8</td>
 </tr>
 </tbody>
 </table>

 */






var classnameOpen = 'u-show';
var classnameClose = 'u-hide';
var create = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].create;
var textkeysObj = {};
var ABSENTVALUE = '-';

function createBonustitleHead(txt) {
	var elm = create({
		type: 'span',
		class: 'payment__bonus-titlehead'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createTableCellStart(txt) {
	var elm = create({
		type: 'td'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function assembleElements() {
	var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	var elms = {};
	/* create elements if not already existing */
	elms.wrap = elements.wrap || create('div', 'amountfee-wrap');
	elms.wrapTable = elements.wrapTable || create('table', 'table-basic');
	elms.tablefoot = elements.tablefoot || create('tfoot');
	elms.tablebody = elements.tablebody || create('tbody');
	/**/
	elms.wrapbalance = elements.wrapbalance || create('tr');
	elms.wrapbonus = elements.wrapbonus || create('tr');
	elms.wrapfee = elements.wrapfee || create('tr');
	elms.wrapbillingamount = elements.wrapbillingamount || create('tr');
	elms.wrapdepositamount = elements.wrapdepositamount || create('tr');
	/* bonus amount added to deposit */
	elms.bonustitle = elements.bonustitle || createTableCellStart();
	elms.bonustitlehead = elements.bonustitlehead || createBonustitleHead(textkeysObj['bonus-amount']);
	elms.bonusconditionmsg = elements.bonusconditionmsg || create('span', 'payment__bonus-condition');
	elms.bonuscontent = elements.bonuscontent || create('td', 'u-text-r');
	/* amount to be added to users account */
	elms.depositamounttitle = elements.depositamounttitle || createTableCellStart(textkeysObj['deposit-amount']);
	elms.depositamountcontent = elements.depositamountcontent || create('td', 'u-text-r');
	/* fee in percent and currence */
	elms.feetitle = elements.feetitle || createTableCellStart(textkeysObj['deposit-fee']);
	elms.feecontent = elements.feecontent || create('td', 'u-text-r');
	/* amount to be payed by user */
	elms.billingamounttitle = elements.billingamounttitle || createTableCellStart(textkeysObj['debited-amount']);
	elms.billingamountcontent = elements.billingamountcontent || create('td', 'u-text-r');
	/* new balance after deposit is done */
	elms.balancetitle = elements.balancetitle || createTableCellStart(textkeysObj['new-balance']);
	elms.balancecontent = elements.balancecontent || create('td', 'u-text-r');
	/* hierachy */
	elms.bonustitle.appendChild(elms.bonustitlehead);
	elms.bonustitle.appendChild(elms.bonusconditionmsg);
	elms.wrapbonus.appendChild(elms.bonustitle);
	elms.wrapbonus.appendChild(elms.bonuscontent);
	elms.wrapbalance.appendChild(elms.balancetitle);
	elms.wrapbalance.appendChild(elms.balancecontent);
	elms.wrapdepositamount.appendChild(elms.depositamounttitle);
	elms.wrapdepositamount.appendChild(elms.depositamountcontent);
	elms.wrapbillingamount.appendChild(elms.billingamounttitle);
	elms.wrapbillingamount.appendChild(elms.billingamountcontent);
	elms.wrapfee.appendChild(elms.feetitle);
	elms.wrapfee.appendChild(elms.feecontent);
	elms.tablebody.appendChild(elms.wrapbonus);
	elms.tablebody.appendChild(elms.wrapdepositamount);
	elms.tablebody.appendChild(elms.wrapfee);
	elms.tablebody.appendChild(elms.wrapbillingamount);
	elms.tablefoot.appendChild(elms.wrapbalance);
	elms.wrapTable.appendChild(elms.tablefoot);
	elms.wrapTable.appendChild(elms.tablebody);
	elms.wrap.appendChild(elms.wrapTable);
	elms.assembled = true;
	return elms;
}

function setContent(elm, txt) {
	if (elm) {
		elm.innerHTML = txt; // eslint-disable-line no-param-reassign
	}
}

function getFormattedAmount(amount, currency) {
	if (amount === undefined && currency === '') {
		return '...';
	}
	return __WEBPACK_IMPORTED_MODULE_3__libs_currency_formatter_js__["a" /* default */].format(amount, currency, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__libs_locale_js__["a" /* getLocale */])());
}

function updateDepositSummary(elements, stateFromFetchFeesAndLimits) {
	/* Bonusfield: conditions: when bonusamount is calculated from conditions build from percentage and max/min-values */
	var st = stateFromFetchFeesAndLimits;
	var amountAndFee = st.amountAndFee;
	var amountWithoutFee = st.amountWithoutFee;
	var bonusAmount = st.bonusAmount;
	var bonusCondition = st.bonusCondition || '';
	var bonusWasFound = st.bonusWasFound;
	var feeAmount = st.feeAmount;
	var newBalance = st.newBalance;
	var playerCurrency = st.playerCurrency || '';
	var selectedCurrency = st.selectedCurrency || '';
	var formattedBonus = bonusWasFound && bonusAmount ? getFormattedAmount(bonusAmount, selectedCurrency) : ABSENTVALUE;
	var formattedAmount = getFormattedAmount(amountWithoutFee, selectedCurrency);
	var formattedFee = getFormattedAmount(feeAmount, selectedCurrency);
	var formattedTotal = getFormattedAmount(amountAndFee, playerCurrency);
	var formattedNewBalance = getFormattedAmount(newBalance || 0, playerCurrency);
	formattedAmount = formattedAmount || ABSENTVALUE;
	formattedFee = formattedFee || ABSENTVALUE;
	formattedTotal = formattedTotal || ABSENTVALUE;
	formattedNewBalance = formattedNewBalance || ABSENTVALUE;
	/* Bonusfield: show conditions for percentage */
	setContent(elements.bonusconditionmsg, bonusCondition);
	/* Bonusfield: show amount and conditions. */
	setContent(elements.bonuscontent, formattedBonus);
	/* CreditAmountfield: show the same as typed into the inputfield and with currency unit. For some reason two fields for credit amount? */
	setContent(elements.depositamountcontent, formattedAmount);
	setContent(elements.feecontent, formattedFee);
	setContent(elements.billingamountcontent, formattedTotal);
	/* New balance: the amount from the inputfield added with selected bonus */
	setContent(elements.balancecontent, formattedNewBalance);
}

function _show(elm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameClose);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameOpen);
}

function _hide(elm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameOpen);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameClose);
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create() {
		var elements = {};
		textkeysObj = __WEBPACK_IMPORTED_MODULE_1__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		elements = assembleElements(elements);
		var viewSpinner = __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_spinnersmall_js__["a" /* default */].create({
			sibling: elements.wrap
		});
		elements.wrap.appendChild(viewSpinner.wrap);
		return {
			wrap: elements.wrap,
			show: function show() {
				_show(elements.wrap);
			},
			hide: function hide() {
				_hide(elements.wrap);
			},
			update: function update(state) {
				if (state.fetch_fees_and_limits) {
					var st = state.fetch_fees_and_limits;
					var pending = st.pending;
					var err = st.error;
					var exceededLimits = st.limitAbove || st.limitReached || st.limitBelow;
					var amountAndFee = pending || err || exceededLimits ? null : st.feeSumAmount;
					var amountWithoutFee = pending || err || exceededLimits ? null : st.feeBasedOn;
					var bonusAmount = pending || err || exceededLimits ? null : st.bonusAmount;
					var bonusCondition = pending || err || exceededLimits ? null : st.bonus_condition || '';
					var bonusWasFound = pending || err || exceededLimits ? null : st.bonusWasFound;
					var feeAmount = pending || err || exceededLimits ? null : st.feeAmount;
					var playerCurrency = pending || err || exceededLimits ? null : st.playerCurrency;
					var newBalance = pending || err || exceededLimits ? null : st.newBalance;
					var selectedCurrency = pending || err || exceededLimits ? null : st.selectedCurrency || '';
					var stData = {
						amountAndFee: amountAndFee,
						amountWithoutFee: amountWithoutFee,
						bonusAmount: bonusAmount,
						bonusCondition: bonusCondition,
						bonusWasFound: bonusWasFound,
						feeAmount: feeAmount,
						playerCurrency: playerCurrency,
						newBalance: newBalance,
						selectedCurrency: selectedCurrency
					};
					if (pending) {
						viewSpinner.show();
					} else {
						viewSpinner.hide();
					}
					updateDepositSummary(elements, stData);
				}
			},
			close: function close() {
				elements = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, [], 'view-amounfee:276');
				viewSpinner.close();
				return null;
			}
		};
	}
};

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validate_amount_js__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_ukFirstTimeDepositLink_js__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_currency_formatter_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__libs_locale_js__ = __webpack_require__(31);
/*
 payment/view-amountinput.js

 import view-amountinput from ...

 -- supply callback to invoke on click --
 view-amountinput.init({cb });

 return:
 see api

 --delete button and eventhandlers --
 view-amountinput.close();
 */








var classnameShow = 'u-show';
var classnameHide = 'u-hide';
var classnameInputerror = 'input-wrap__error';
var _create = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].create;
var delayToProcessAmountField = 500;
var viewFirstTimeUkDepositLink = void 0;
var textkeysObj = {};

function createInputamount(eventFilter) {
	var cName = eventFilter + ' payment__input-amount input-wrap__input input-wrap__input--large u-text-c u-pl1 u-pr1';
	return _create({
		type: 'input',
		class: cName,
		autocomplete: 'off',
		name: 'amount',
		'input-type': 'tel',
		placeholder: textkeysObj['deposit-amount']
	});
}

function createLimitsFeedback(txt) {
	var elm = _create({
		type: 'small',
		class: 'payment__amount-info u-pos-c u-text-c'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function _show(elm) {
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameHide);
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameShow);
}

function _hide(elm) {
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameHide);
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	/* this handler is a wrapper that filters out values from the target element,
 and then applies the callback-argument on these values */
	var eventFilterSelector = '.' + eventFilterSeparatorClassname;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		var elm = p.elm;
		var value = elm && elm.value;
		var text = elm && elm.text;
		onEventCb({
			value: value,
			text: text
		});
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].handle(e, eventFilterSelector, cb, true);
}

function displayFeedback(feedbackelm, txt) {
	if (txt) {
		feedbackelm.innerHTML = txt; // eslint-disable-line no-param-reassign
		_show(feedbackelm);
	} else {
		feedbackelm.innerHTML = ''; // eslint-disable-line no-param-reassign
		_hide(feedbackelm);
	}
}

function publishOrFeedback(digits, amFeedback) {
	if (digits || digits === 0) {
		/* a valid amount */
		__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewAmountInput({
			amount: digits
		});
	} else {
		/* hide feedback if amount is empty. */
		displayFeedback(amFeedback, null);
	}
}

function createLimitFeedback(p) {
	/* arguments:
  within,above, below, limitReached, within, above, below, -- booleans
  reachmessage: textkeysObj['mobile-deposit-limit-reached-text'],
  belowmessage: textkeysObj['min-limit-exceeded'],
  withinmessage: textkeysObj['max-limit-exceeded'],
 */
	var currency = p.currency;
	var minLimit = __WEBPACK_IMPORTED_MODULE_5__libs_currency_formatter_js__["a" /* default */].format(p.min, currency, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__libs_locale_js__["a" /* getLocale */])());
	var maxLimit = __WEBPACK_IMPORTED_MODULE_5__libs_currency_formatter_js__["a" /* default */].format(p.max, currency, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__libs_locale_js__["a" /* getLocale */])());
	var abovemessage = p.abovemessage || 'amount is above';
	var belowmessage = p.belowmessage || 'amount is below';
	var reachmessage = p.reachmessage || 'limit is reached';
	var withinmessage = p.withinmessage; // normally empty
	var amountLimitFeedback = '';
	if (p.limitReached) {
		amountLimitFeedback = reachmessage;
	} else if (p.above) {
		amountLimitFeedback = abovemessage + ' ' + maxLimit;
	} else if (p.below) {
		amountLimitFeedback = belowmessage + ' ' + minLimit;
	} else if (p.within) {
		amountLimitFeedback = withinmessage;
	}
	return {
		amountLimitFeedback: amountLimitFeedback
	};
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeListener(elm, eventType, handler);
	return null;
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create(p) {
		var elements = {};
		var userHasStartedTyping = false;
		// const CHANGE = 'change'; // 'change' event submits when a new value is assigned, for example when the user clicks outside the amountfield
		var CLICK = 'click';
		var FOCUSIN = 'focusin'; // 'focusin' event submits when the element is about to get focus, and bubbles (only difference from 'focus'event)
		var INPUT = 'input'; // 'input' event submits whenever the inputfields input is altered
		var classNameEventFilter = 'js-eventfilter-viewamountinput';
		var clickcb = p && p.clickcb || function empty() {};
		var limitReached = false;
		var previousInputEventTime = null;
		var lastTimeOutIdForAmountField = null;
		textkeysObj = __WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		elements.wrap = elements.wrap || _create('label', 'payment__label-amount input-wrap u-mb1 u-db u-relative u-full-width-break-container'); // createLabelamount()); // wrapper
		elements.inputamount = elements.inputamount || createInputamount(classNameEventFilter);
		elements.amountLimitsFeedback = elements.amountLimitsFeedback || createLimitsFeedback('Min/Max: ');
		elements.amountfeedback = elements.amountfeedback || _create('div', 'input-wrap__error-display payment__feedback grid-u-sm-1 u-hide'); // createFeedback('amount feedback is written here'));
		elements.wrap.appendChild(elements.inputamount);
		elements.wrap.appendChild(elements.amountLimitsFeedback);
		elements.wrap.appendChild(elements.amountfeedback);
		viewFirstTimeUkDepositLink = __WEBPACK_IMPORTED_MODULE_4__view_ukFirstTimeDepositLink_js__["a" /* default */].create();
		elements.wrap.appendChild(viewFirstTimeUkDepositLink.wrap);
		viewFirstTimeUkDepositLink.hide();

		function callbackOnClick() {
			/* generally used to display an preset list of amounts, for example Siru-method*/
			clickcb();
		}

		function callbackOnFocusin() {
			/* focusin */
			elements.inputamount.value = '';
			elements.inputamount.placeholder = '';
		}

		function callbackOnInput() {
			/* input: fires when the elements input value changed.*/
			/* this or the focusinhandler or for siru the clickhandler indicates
   that the user begun typing, and then the inputfield won't be updated
   from fees-and-limits until 'hide' is invoked. */
			userHasStartedTyping = true;
			var val = elements.inputamount.value;
			var digits = __WEBPACK_IMPORTED_MODULE_2__validate_amount_js__["a" /* default */].keepDigits(val);
			var currentInputEventTime = new Date();
			elements.inputamount.value = digits;
			/*  --------delay------------------  */
			// after some time the amountfield is evaluated even tough the focus may still be in the field
			previousInputEventTime = previousInputEventTime || currentInputEventTime;
			var timeIsOut = currentInputEventTime.getMilliseconds() - previousInputEventTime.getMilliseconds() <= delayToProcessAmountField;
			if (timeIsOut && lastTimeOutIdForAmountField) {
				window.clearTimeout(lastTimeOutIdForAmountField);
			}
			lastTimeOutIdForAmountField = setTimeout(function () {
				publishOrFeedback(digits, elements.amountfeedback, elements.inputamount);
				lastTimeOutIdForAmountField = null;
			}, delayToProcessAmountField);
			/*  --------------------------  */
		}
		var clickHandler = addListeners(elements.wrap, callbackOnClick, classNameEventFilter, CLICK);
		var focusinHandler = addListeners(elements.wrap, callbackOnFocusin, classNameEventFilter, FOCUSIN);
		var inputHandler = addListeners(elements.wrap, callbackOnInput, classNameEventFilter, INPUT);

		return {
			wrap: elements.wrap,
			show: function show(disabled) {
				/* for some paymentmethods (Siru) the inputfield is only allowed to be updated from a selectionlist
    and thus the inputfield is disabled.
     If the limit is reached, the inputfield is disabled anyhow. */
				var disVal = limitReached || disabled;
				//elements.inputamount.disabled = disVal;
				if (disabled) {
					userHasStartedTyping = false;
				}
				_show(elements.wrap);
			},
			hide: function hide() {
				// userHasStartedTyping = false;
				_hide(elements.wrap);
			},
			getValidAmount: function getValidAmount() {
				var val = elements.inputamount.value;
				var digits = __WEBPACK_IMPORTED_MODULE_2__validate_amount_js__["a" /* default */].keepDigits(val);
				return digits || null;
			},
			update: function update(state) {
				var firstTimeUk = state && state.first_time_uk_deposit && state.first_time_uk_deposit.isFirstTime;
				if (state.first_time_uk_deposit) {
					/* this state will tell if the link shall be present or not */
					if (firstTimeUk) {
						viewFirstTimeUkDepositLink.show();
					}
				}
				if (state.paymentmethods) {
					var newMethodSelected = state.paymentmethods.methodswitch;
					if (newMethodSelected) {
						userHasStartedTyping = false;
					}
				}
				if (state.fetch_fees_and_limits) {
					var feeBasedOn = state.fetch_fees_and_limits.feeBasedOn;
					var within = state.fetch_fees_and_limits.limitWithin;
					var above = state.fetch_fees_and_limits.limitAbove;
					var below = state.fetch_fees_and_limits.limitBelow;
					limitReached = state.fetch_fees_and_limits.limitReached;

					if (!userHasStartedTyping && (feeBasedOn || feeBasedOn === '0')) {
						/* this will update the value in the inputfield according to the value used to create the summary below.
      This will only be done until the user inputs a new value.
      */
						elements.inputamount.value = feeBasedOn;
					}
					/*
      when value is within limits, the 'max...min...' text is displayed
      when value is outside limits the 'max...min...' text is replaced by '...limit exceeded...' text.
      the element used for feedback is elements.amountLimitsFeedback
      elements.amountLimitsFeedback.innerHTML = (limitReached ? textkeysObj['mobile-deposit-limit-reached-text'] : res.amountLimitFeedback);
      */
					var res = createLimitFeedback({
						max: state.fetch_fees_and_limits.limitMax,
						min: state.fetch_fees_and_limits.limitMin,
						currency: state.fetch_fees_and_limits.selectedCurrency,
						reachmessage: textkeysObj['mobile-deposit-limit-reached-text'],
						belowmessage: textkeysObj['min-limit-exceeded'],
						abovemessage: textkeysObj['max-limit-exceeded'],
						withinmessage: '',
						limitReached: limitReached,
						above: above,
						below: below,
						within: within
					});
					//elements.inputamount.disabled = limitReached;
					displayFeedback(elements.amountLimitsFeedback, res.amountLimitFeedback);
					/* set text to feedback message and toggle error-style class to inputamount */
					if (limitReached || below || above) {
						__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elements.inputamount, classnameInputerror);
					} else if (within) {
						__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elements.inputamount, classnameInputerror);
					}
				}
			},
			close: function close() {
				// changeHandler = removeListeners(elements.wrap, changeHandler, CHANGE);
				clickHandler = removeListeners(elements.wrap, clickHandler, CLICK);
				focusinHandler = removeListeners(elements.wrap, focusinHandler, FOCUSIN);
				inputHandler = removeListeners(elements.wrap, inputHandler, INPUT);
				elements = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, [], 'view-amountinput:224');
				if (viewFirstTimeUkDepositLink) {
					viewFirstTimeUkDepositLink.close();
				}
			}
		};
	}
};

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/*
 view_amountselect.js
 */




var _create = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].create; // creates basic elements not inserted into the dom
var nodetree = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].nodetree; // inserts an array of elements into a document-fragment which later may be inserted into the dom
var classnameShow = 'notify--is-open'; // 'u-show';
var classnameHide = 'u-hide';
var textkeysObj = {};
var initializedForMethodId = void 0;

function createWrap() {
	return _create({
		type: 'div',
		class: 'view-amountselect__wrap deposit-siru notify'
	});
}

function createHeadline() {
	var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'h2';
	var txt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'some text';

	var elm = _create({
		type: type,
		class: 'notify__main-title'
	});
	elm.innerHTML = txt;
	return elm;
}

function createText() {
	var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'p';
	var txt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'some text';

	var elm = _create({
		type: type,
		class: 'notify__p'
	});
	elm.innerHTML = txt;
	return elm;
}

function createCloseButton() {
	var eventFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	var txt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'close';

	var cName = eventFilter + ' btn btn--secondary u-b-radius-bottom';
	var elm = _create({
		type: 'button',
		class: cName,
		value: 'close'
	});
	elm.innerHTML = txt;
	return elm;
}

function createOptions(p) {
	// args: p.obj, p.keytoval, p.keytotext, p.selectedId
	var eventFilter = p.eventFilter || '';
	var cName = 'js-the-label ' + eventFilter + ' filters__filter u-text-c u-cursor-hand grid-u-sm-1-4';
	var amounts = p.amounts;
	var keytoval = p.keytoval;
	var keytotext = p.keytotext;
	var selectedId = p.selectedId || null;
	var nodes = [];
	var elmRef = {};
	var labelsRef = {};
	Object.keys(amounts).forEach(function (index) {
		/* A reference to the element is saved. */
		var value = amounts[index] && amounts[index][keytoval] || keytoval + ' missing';
		var id = 'f-' + value;
		var elm = _create({
			type: 'input',
			'input-type': 'radio',
			id: id,
			class: 'js-the-input',
			name: 'siru-predetermined-deposit-amounts',
			value: amounts[index] && amounts[index][keytoval] || keytoval + ' missing'
		});
		var elm2 = _create({
			type: 'label',
			for: id,
			class: cName
		});
		elm2.innerHTML = amounts[index] && amounts[index][keytotext] || keytoval + ' missing';
		if ((selectedId || selectedId === 0) && (amounts[index].id || amounts[index].id === 0)) {
			if (amounts[index].id && amounts[index].id === selectedId) {
				elm.checked = 'checked';
			}
		}
		/* The uninserted nodes are returned as a list to be inserted with 'nodetree'-function. */
		elmRef[id] = elm;
		labelsRef[id] = elm2;
		nodes.push(elm, elm2);
	});
	/* to evaluate the input-elements with information from the label-elements, a reference
 is stored to each input, sorted on its 'id'. */
	return {
		nodes: nodes,
		elmRef: elmRef,
		labelsRef: labelsRef
	};
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	var eventFilterSelector = '.' + eventFilterSeparatorClassname;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		var labelElm = p.elm;
		var close = Boolean(labelElm && labelElm.value && labelElm.value === 'close');
		var inputid = labelElm.getAttribute('for');
		onEventCb({
			inputid: inputid,
			close: close
		});
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeListener(elm, eventType, handler);
	}
}

function _show(elm) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameHide);
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameShow);
	}
}

function _hide(elm) {
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameHide);
}

function checkTheAmount(elms, val) {
	elms.forEach(function (elm) {
		var elmval = parseInt(elm.value, 10);
		var cVal = parseInt(val, 10);
		if (elmval === cVal) {
			elm.checked = true; // eslint-disable-line no-param-reassign
		}
	});
}

function updateSelection(inputElms, labelElms, amounts) {
	/* elements.inputs, elements.labelsRef, amounts) */
	Object.keys(inputElms).forEach(function (key, index) {
		var am = amounts[index] && amounts[index].value || '';
		var txt = amounts[index] && amounts[index].text || '-';
		inputElms[key].value = am; // eslint-disable-line no-param-reassign
		labelElms[key].innerHTML = txt; // eslint-disable-line no-param-reassign
	});
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create() {
		var elements = {};
		var mainEventType = 'click';
		var classNameEventFilter = 'js-eventfilter-viewamountselect';
		textkeysObj = __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		var headlineTxt = textkeysObj['siru-amount-select-headline'];
		var descriptionTxt = textkeysObj['siru-amount-select-description'];
		var buttoncloseText = textkeysObj['verify-amount-selection-button'];
		elements.wrap = elements.wrap || createWrap();
		elements.subwrap = elements.subwrap || _create('div', 'option-box u-text-c u-b-radius u-pos-c grid-u-sm-3-4');
		elements.optionbox = elements.optionbox || _create('div', 'option-box__inner u-p1');
		elements.headline = elements.headline || createHeadline('h2', headlineTxt);
		elements.shortText = elements.shortText || createText('p', descriptionTxt);
		elements.wrapOptions = elements.wrapOptions || _create('div', 'user-options');
		elements.subwrapOptions = elements.subwrapOptions || _create('div', 'filters grid-r u-b-radius');
		elements.buttonclose = elements.buttonclose || createCloseButton(classNameEventFilter, buttoncloseText);
		var callbackOnMainEvent = function callbackOnMainEvent(obj) {
			/*
    * the mainHandler returns the labels 'for'-value, which is used
    * to read the value from the corresponding input. This is a
    * workaround to combine styling and default behaviour of input-element.
    */
			var inputElm = obj.inputid && elements.inputs ? elements.inputs[obj.inputid] : null;
			var value = inputElm && inputElm.value;
			if (inputElm) {
				/* set this element to checked manually (since the default behaviour is blocked)*/
				inputElm.checked = true;
			}
			if (obj && obj.close) {
				_hide(elements.wrap);
			} else if (obj && !obj.close) {
				__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewAmountselect({
					amount: value
				});
			}
		};
		var handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);
		elements.wrap.appendChild(elements.subwrap);
		elements.subwrap.appendChild(elements.optionbox);
		elements.subwrap.appendChild(elements.buttonclose);
		elements.optionbox.appendChild(elements.headline);
		elements.optionbox.appendChild(elements.shortText);
		elements.optionbox.appendChild(elements.wrapOptions);
		elements.wrapOptions.appendChild(elements.subwrapOptions);
		return {
			wrap: elements.wrap,
			show: function show() {
				_show(elements.wrap);
			},
			hide: function hide() {
				_hide(elements.wrap);
			},
			update: function update(state) {
				/* this module accepts the format:
    {'name1':[{'value':'some text'}, ... 'nameN':{'value':'some text other'}]}
     */
				if (state && state.fetch_fees_and_limits) {
					var amounts = state.fetch_fees_and_limits.defaultAmountsFormatted;
					var methodId = state.fetch_fees_and_limits.paymentMethodId;
					var presetIndex = state.fetch_fees_and_limits.presetIndex;
					var feeBasedOn = state.fetch_fees_and_limits.feeBasedOn;
					var elms = void 0;
					var optIndex = null;
					if (initializedForMethodId && initializedForMethodId === methodId) {
						/* elements.options is created
       * refreshSelection(elements.options, amounts);
       */
						updateSelection(elements.inputs, elements.labelsRef, amounts);
						checkTheAmount(elements.options, feeBasedOn);
					} else {
						/* do this once when the method is selected
       * create options for default amounts
       */
						initializedForMethodId = methodId;
						if (amounts) {
							// this should only update when a new list of preset amounts is available
							if (elements.options) {
								// update properties of options to follow the amountlist
								updateSelection(elements.inputs, elements.labelsRef, amounts);
							} else {
								elms = createOptions({
									amounts: amounts,
									keytoval: 'value',
									keytotext: 'text',
									selectedId: optIndex,
									eventFilter: classNameEventFilter
								});
								elements.options = elms.nodes;
								elements.inputs = elms.elmRef;
								elements.labelsRef = elms.labelsRef;
								elements.subwrapOptions.appendChild(nodetree(elements.options));
							}
							if (elements && elements.options && elements.options[presetIndex]) {
								elements.options[presetIndex].checked = true;
							}
						}
					}
				}
			},
			close: function close() {
				/* hide the spinner if the spinner is closed before hidden.
    Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler, mainEventType);
				elements = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, [], 'view_amountselect:248');
			}
		};
	}
};

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib_validate_creditcard_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/*
 view-creditcard-date.js
 create and handle selection list to be inserted in a <form>
 */






var create = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].create; // creates basic elements not inserted into the dom
var nodetree = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].nodetree; // inserts an array of elements into a document-fragment which later may be inserted into the dom
var classnameShow = 'u-show';
var classnameHide = 'u-hide';
var monthDefaultStr = void 0;
var yearDefaultStr = void 0;
var textkeysObj = {};

function createSelectmonth(eventFilter) {
	var cName = eventFilter + ' payment__select-month-creditcard';
	return create({
		type: 'select',
		class: cName
	});
}

function createSelectyear(eventFilter) {
	var cName = eventFilter + ' payment__select-year-creditcard';
	return create({
		type: 'select',
		class: cName
	});
}

function yearList(n) {
	/* return: [currentYear, currentYear+1, ..., currentYear+n]  example: [2016,2017, ... ,2035] */
	var currentYear = new Date().getFullYear();
	var list = [];
	var num = n || 20;
	var i = void 0;
	for (i = 0; i <= num; i += 1) {
		list.push(currentYear + i);
	}
	return list;
}

function createOptionsyear() {
	var nodes = [];
	var values = yearList(20);
	// TODO langage dependant insertion of year-year
	values.splice(0, 0, yearDefaultStr);
	values.forEach(function (value) {
		var elm = create({
			type: 'option',
			class: 'payment__option-year-creditcard',
			value: value

		});
		elm.innerHTML += value;
		/* The uninserted nodes are returned as a list to be inserted with 'nodetree'-function. */
		nodes.push(elm);
	});
	return nodetree(nodes);
}

function createOptionsmonth() {
	var nodes = [];
	var months = [monthDefaultStr, '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
	months.forEach(function (value) {
		var elm = create({
			type: 'option',
			class: 'payment__option-month-creditcard',
			value: value
		});
		elm.innerHTML += value;
		nodes.push(elm);
	});
	return nodetree(nodes);
}

function setInputValues(elm, val) {
	var txt = val || '';
	if (elm) {
		elm.value = txt; // eslint-disable-line no-param-reassign
	}
}

function getSelectedOption(selectElement) {
	var index = Boolean(selectElement && selectElement.options && (selectElement.selectedIndex || selectElement.selectedIndex === '0' || selectElement.selectedIndex === 0));
	var elm = index ? selectElement.options[selectElement.selectedIndex] : null;
	return elm;
}

function _show(elm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameHide);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameShow);
}

function _hide(elm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameHide);
}

function validateMonth(selectElm) {
	var opt = getSelectedOption(selectElm);
	var value = opt && opt.value;
	return __WEBPACK_IMPORTED_MODULE_2__lib_validate_creditcard_js__["a" /* default */].month(value) ? value : null;
}

function validateYear(selectElm) {
	var opt = getSelectedOption(selectElm);
	var value = opt && opt.value;
	return __WEBPACK_IMPORTED_MODULE_2__lib_validate_creditcard_js__["a" /* default */].year(value) ? value : null;
}

function validateDate(mm, yy) {
	return __WEBPACK_IMPORTED_MODULE_2__lib_validate_creditcard_js__["a" /* default */].date(mm, yy);
}

function validateAll(selectMonthElm, selectYearElm, force) {
	var date = null;
	var feedbackDate = null;
	var month = validateMonth(selectMonthElm) || null;
	var year = validateYear(selectYearElm) || null;
	var feedbackYear = year ? null : 'select the expiration year';
	var feedbackMonth = month ? null : 'select the expiration month';
	if (month && year || force) {
		date = validateDate(month, year);
		feedbackDate = date ? null : 'the expiration date must be after this month';
	}
	return {
		month: month,
		year: year,
		date: date,
		feedbackYear: feedbackYear,
		feedbackMonth: feedbackMonth,
		feedbackDate: feedbackDate
	};
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	var eventFilterSelector = '.' + eventFilterSeparatorClassname;

	function cb(p) {
		p.e.stopPropagation();
		onEventCb();
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeListener(elm, eventType, handler);
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create(p) {
		var elements = {};
		var mainEventType = 'change';
		var classNameEventFilter = 'js-eventfilter-viewcreditcarddate';
		var callbackonmainevent = p.callbackonmainevent || function empty() {};
		textkeysObj = __WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		yearDefaultStr = textkeysObj['year-shortcut-yyyy'];
		monthDefaultStr = textkeysObj['month-shortcut-mm'];
		elements.optionsmonth = elements.optionsmonth || createOptionsmonth();
		elements.optionsyear = elements.optionsyear || createOptionsyear();
		elements.wrapMonth = elements.wrapMonth || createSelectmonth(classNameEventFilter);
		elements.wrapYear = elements.wrapYear || createSelectyear(classNameEventFilter);
		elements.wrapMonth.appendChild(elements.optionsmonth);
		elements.wrapYear.appendChild(elements.optionsyear);

		function softvalidateAll() {
			return validateAll(elements.wrapMonth, elements.wrapYear, false);
		}

		function onSelectHandler() {
			var validated = softvalidateAll();
			callbackonmainevent(validated);
		}
		var monthHandler = addListeners(elements.wrapMonth, onSelectHandler, classNameEventFilter, mainEventType);
		var yearHandler = addListeners(elements.wrapYear, onSelectHandler, classNameEventFilter, mainEventType);

		return {
			wrapMonth: elements.wrapMonth,
			wrapYear: elements.wrapYear,
			show: function show() {
				_show(elements.wrapMonth);
				_show(elements.wrapYear);
			},
			hide: function hide() {
				_hide(elements.wrapMonth);
				_hide(elements.wrapYear);
			},
			getValues: function getValues() {
				var hardValidateAll = validateAll(elements.wrapMonth, elements.wrapYear, false);
				return hardValidateAll;
			},
			update: function update(state) {
				var month = state.view_creditcard && state.view_creditcard.month;
				var year = state.view_creditcard && state.view_creditcard.year;
				if (month === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].DEFAULT) {
					setInputValues(elements.wrapMonth, monthDefaultStr);
				} else if (month) {
					setInputValues(elements.wrapMonth, month);
				}
				if (year === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].DEFAULT) {
					setInputValues(elements.wrapYear, yearDefaultStr);
				} else if (year) {
					setInputValues(elements.wrapYear, year);
				}
			},
			close: function close() {
				removeListeners(elements.wrapYear, yearHandler);
				removeListeners(elements.wrapMonth, monthHandler);
				elements = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, [], 'view-creditcardlast:187');
			}
		};
	}
};

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_validate_creditcard_js__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib_view_creditcard_date_js__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib_view_creditcardlast_js__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/*
 view_creditcard

 creditcardmock = {
 "utimestamp": 1458224412998,
 "am": "50",
 "bid": null,
 "paymentMethodId": 1,
 "cid": null,
 "cn": "4444333322221111",
 "co": "bimal james",
 "vm": "06",
 "vy": "2016",
 "cc": "737"
 },

 */








var create = __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].create; // creates basic elements not inserted into the dom
var creditCardMaxLength = 16;
var regexCC = '[0-9]*';
var regexCVC = '[0-3]*';
var classnameShow = 'u-show';
var classnameHide = 'u-hide';
var classnameDisable = 'custom-select—disabled';
var notvalidClass = 'input-wrap__error';

var cardnumberDefaultPlaceholder = void 0;
var dateIsResetForNewCard = void 0;
var textkeysObj = {};
var viewCreditcardlast = void 0;
var viewDate = void 0;

var elements = {
	/* see 'assembleElements' below for more details of the elements object content */
	assembled: false,
	optionscardref: {},
	optionsmonthref: {},
	optionsyearref: {},
	wraplastused: null,
	wrap: null
};

var userInput = {
	allvalid: false,
	amount: null, // am
	cardid: null,
	cardnumber: null, // cn
	cvc: null, // cc
	year: null, // vy
	month: null // vm
};

function toSubmitStructure(uInput) {
	/* This is the structure required by the depositmethod. To not hardcode keys in earlier steps the values are parsed here. */
	/* amount is set in /view-paymentform */
	/* id set if earlier used cards are available */
	return {
		am: uInput.amount,
		cid: uInput.cardid,
		cc: uInput.cvc,
		co: 'not needed',
		cn: uInput.cardnumber,
		utimestamp: new Date().getTime(),
		vy: uInput.year,
		vm: uInput.month,
		paymentMethodId: 1 // this id is the same as in the ajax-response from 'getDepositPaymentMethods' and 'deposit-form-template-conf.js'
	};
}

function createSelectOrAddCardTitle(txt) {
	var elm = create({
		type: 'legend',
		class: 'legend'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createCardnumberTitle(txt) {
	var elm = create({
		type: 'legend',
		class: 'legend'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createYearMonthCvcTitle(txt) {
	var elm = create({
		type: 'legend',
		class: 'legend u-truncate'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createInputcvc() {
	return create({
		type: 'input',
		class: 'js-payment__input-cvc-creditcard payment__input-cvc-creditcard input-wrap__input',
		name: 'cc',
		'input-type': 'text',
		max: 999,
		min: 0,
		placeholder: 'CVC',
		pattern: regexCVC,
		autocomplete: 'off'
	});
}

function createInputCardId() {
	return create({
		type: 'input',
		name: 'cardid',
		'input-type': 'hidden',
		max: 9999,
		min: 1
	});
}

function createInputcardnumber() {
	return create({
		type: 'input',
		class: 'js-payment__input-cn-creditcard payment__input-cn-creditcard input-wrap__input',
		name: 'cn',
		'input-type': 'text',
		maxlength: creditCardMaxLength,
		pattern: regexCC,
		placeholder: cardnumberDefaultPlaceholder
	});
}

function createFeedback(txt) {
	var elm = create({
		type: 'small',
		class: 'input-wrap__error-display payment__feedback grid-u-sm-1 u-hide'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createFieldsetWrapLastused() {
	/* this is used in init outside of createElements also TODO: replace with one  */
	return create({
		type: 'fieldset',
		class: 'js-payments__fieldset-wrap-lastused payments__fieldset-wrap-lastused custom-select u-relative u-mb2'
	});
}

function createElements() {
	elements.wraplastused = elements.wraplastused || createFieldsetWrapLastused();
	elements.wrapnewcard = elements.wrapnewcard || create('div', 'js-payments__fieldset-wrap-newcard payments__fieldset-wrap-newcard input-wrap u-relative');
	elements.cardnumberTitle = elements.cardnumberTitle || createCardnumberTitle(textkeysObj['deposit-inputfieldtitle-cardnumber']);
	elements.yearTitle = elements.yearTitle || createYearMonthCvcTitle(textkeysObj['deposit-inputfieldtitle-year']);
	elements.monthTitle = elements.monthTitle || createYearMonthCvcTitle(textkeysObj['deposit-inputfieldtitle-month']);
	elements.cvcTitle = elements.cvcTitle || createYearMonthCvcTitle(textkeysObj['deposit-inputfieldtitle-cvc']);
	elements.fieldsetwrapmm = elements.fieldsetwrapmm || create('fieldset', 'payments__fieldset-wrap-mm custom-select u-relative');
	elements.fieldsetwrapyy = elements.fieldsetwrapyy || create('fieldset', 'payments__fieldset-wrap-yy custom-select u-relative');
	elements.gridwrapyy = elements.gridwrapyy || create('div', 'payments__grid-wrap-yy grid-u-sm-1-3 u-pr1 u-pl1');
	elements.gridwrapcvc = elements.gridwrapcvc || create('div', 'payments__grid-wrap-cvc grid-u-sm-1-3 u-pl1');
	elements.gridwrapmmyycvc = elements.gridwrapmmyycvc || create('div', 'payments__grid-wrap-mm-cvc grid-r u-mt2');
	elements.gridwrapmm = elements.gridwrapmm || create('div', 'payments__grid-wrap-mm grid-u-sm-1-3 u-pr1');
	elements.inputcardnumber = elements.inputcardnumber || createInputcardnumber();
	elements.cardnumberfeedback = elements.cardnumberfeedback || createFeedback(textkeysObj['cardnumber-feedback']);
	elements.cvcfeedback = elements.cvcfeedback || createFeedback(textkeysObj['cvc-feedback']);
	elements.yyfeedback = elements.yyfeedback || createFeedback(textkeysObj['year-feedback']);
	elements.datefeedback = elements.datefeedback || createFeedback(textkeysObj['the-expiry-date-has-passed']);
	elements.mmfeedback = elements.mmfeedback || createFeedback(textkeysObj['month-feedback']);
	elements.inputcvc = elements.inputcvc || createInputcvc();
	elements.inputcardid = elements.inputcardid || createInputCardId();
	elements.labelcardnumber = elements.labelcardnumber || create('label', 'payment__label-cn-creditcard');
	elements.labelcvc = elements.labelcvc || create('label', 'payment__label-cvc-creditcard');
}

function assembleElements() {
	createElements();
	if (!elements.assembled) {
		elements.fieldsetwrapmm.appendChild(elements.monthTitle);
		elements.gridwrapmm.appendChild(elements.fieldsetwrapmm);
		elements.gridwrapmm.appendChild(elements.datefeedback);
		elements.gridwrapmm.appendChild(elements.mmfeedback);
		elements.fieldsetwrapyy.appendChild(elements.yearTitle);
		elements.gridwrapyy.appendChild(elements.fieldsetwrapyy);
		elements.gridwrapyy.appendChild(elements.yyfeedback);
		elements.labelcvc.appendChild(elements.inputcvc);
		elements.labelcvc.appendChild(elements.cvcfeedback);
		elements.gridwrapcvc.appendChild(elements.cvcTitle);
		elements.gridwrapcvc.appendChild(elements.labelcvc);
		elements.gridwrapmmyycvc.appendChild(elements.gridwrapmm);
		elements.gridwrapmmyycvc.appendChild(elements.gridwrapyy);
		elements.gridwrapmmyycvc.appendChild(elements.gridwrapcvc);
		elements.labelcardnumber.appendChild(elements.cardnumberTitle);
		elements.labelcardnumber.appendChild(elements.inputcardnumber);
		elements.labelcardnumber.appendChild(elements.cardnumberfeedback);
		/* insert selectbox with options */
		// only show the wrapper when it is updated
		__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].addClass(elements.wraplastused, classnameShow);
		// elements.wrapnewcard.appendChild(elements.detailsTitle);
		elements.wrapnewcard.appendChild(elements.labelcardnumber);
		elements.wrapnewcard.appendChild(elements.gridwrapmmyycvc);
		/* inputCard is a hidden inputfield */
		elements.wrapnewcard.appendChild(elements.inputcardid);
		/* insert the created nodes into the provided wrapper */
		if (elements.before) {
			elements.wrap.insertBefore(elements.wraplastused, elements.before);
			elements.wrap.insertBefore(elements.wrapnewcard, elements.before);
		} else {
			elements.wrap.appendChild(elements.wraplastused);
			elements.wrap.appendChild(elements.wrapnewcard);
		}
		elements.assembled = true;
	}
}

function deleteAllElements() {
	/* The object-property must either contain an element or an array with elements */
	/* The wrapper is not deleted. */
	if (elements.assembled) {
		__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, ['wrap', 'before', 'inputamountwrap', 'inputamount', 'amountfeedback', 'textkeys'], '/view-creditcard:385');
		elements.assembled = false;
	}
}

function hideNewcardinputExceptCvc() {
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].addClass(elements.fieldsetwrapmm, classnameDisable);
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].addClass(elements.fieldsetwrapyy, classnameDisable);
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].addClass(elements.labelcardnumber, classnameDisable);
}

function showNewcardinputAndCvc() {
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].removeClass(elements.fieldsetwrapmm, classnameDisable);
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].removeClass(elements.fieldsetwrapyy, classnameDisable);
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].removeClass(elements.labelcardnumber, classnameDisable);
}

function hideLastCardWrap() {
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].removeClass(elements.wraplastused, classnameShow);
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].addClass(elements.wraplastused, classnameHide);
}

function showLastCardWrap() {
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].removeClass(elements.wraplastused, classnameHide);
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].addClass(elements.wraplastused, classnameShow);
}

function show(elm) {
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].removeClass(elm, classnameHide);
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].addClass(elm, classnameShow);
}

function hide(elm) {
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].removeClass(elm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].addClass(elm, classnameHide);
}

function hideElm(elm, yesHideIt) {
	if (yesHideIt) {
		hide(elm);
	} else {
		show(elm);
	}
}

function markValid(element, valid) {
	if (valid) {
		__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].removeClass(element, notvalidClass);
	} else {
		__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].addClass(element, notvalidClass);
	}
}

function feedbackToDate(p, elms) {
	/* when adding a new card, the datefield should not indicate 'not valid' on
 the other field (MM or YYYY) before the other field is selected. But if
 the form is submitted the 'not valid' indication shall be there. */
	var monthHasError = p.monthHasError;
	var dateHasError = p.dateHasError;
	var yearHasError = p.yearHasError;
	if (monthHasError || dateHasError) {
		markValid(elms.fieldsetwrapmm, false);
	} else {
		markValid(elms.fieldsetwrapmm, true);
	}
	if (monthHasError) {
		show(elms.mmfeedback);
	} else {
		hide(elms.mmfeedback);
	}
	if (yearHasError) {
		markValid(elms.fieldsetwrapyy, false);
		show(elms.yyfeedback);
	} else {
		markValid(elms.fieldsetwrapyy, true);
		hide(elms.yyfeedback);
	}
	if (dateHasError) {
		show(elms.datefeedback);
	} else {
		hide(elms.datefeedback);
	}
}

function feedbackToCardnumber(cardNumber, cardId) {
	/* One of these parameters could be empty or null depending on if it's a new card or an existent one
 for adding new card the cardNumber shouldn't be empty or null and cardId could be
 for existent card the cardNumber will be null and cardId will not. */
	if (cardNumber || cardId) {
		markValid(elements.inputcardnumber, true);
		hide(elements.cardnumberfeedback);
	} else {
		markValid(elements.inputcardnumber, false);
		hideElm(elements.cardnumberfeedback, false);
	}
}

function feedbackToCvc(inputIsValid) {
	markValid(elements.inputcvc, inputIsValid);
	hideElm(elements.cvcfeedback, inputIsValid);
}

function markValidAll(uInput) {
	/* depending on validation the inputfields are marked
    with specific classname and messages with feedback are shown
 */
	var validDate = viewDate.getValues();
	var monthHasError = Boolean(validDate.feedbackMonth);
	var yearHasError = Boolean(validDate.feedbackYear);
	var dateHasError = Boolean(validDate.feedbackDate);
	if (uInput) {
		feedbackToDate({
			monthHasError: monthHasError,
			yearHasError: yearHasError,
			dateHasError: dateHasError
		}, elements);
		feedbackToCardnumber(uInput.cardnumber, uInput.cardid);
		// feedbackToAmount(uInput.amount);
		feedbackToCvc(uInput.cvc);
	}
}

function markValidReset() {
	feedbackToDate({
		monthHasError: false,
		yearHasError: false,
		dateHasError: false
	}, elements);
	feedbackToCardnumber(true);
	feedbackToCvc(true);
}

function validCardId() {
	var theInput = elements.inputcardid.value || null;
	return __WEBPACK_IMPORTED_MODULE_3__lib_validate_creditcard_js__["a" /* default */].cardid(theInput) ? theInput : null;
}

function validCardnumber() {
	/* The cardnumber input field has to be of type 'number' to display the numeric keyboard. A preselected cardnumber is presented as a mix of 'x' and digits. */
	/* This is presented through the 'placeholder' attribute. Thus the cardnumber has to be validated together with the 'card id' */
	/* If a cardnumber is present, it must be valid. If a cardnumber is not present, a valid 'card id' must exist. */
	var theInput = __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].trailspace(elements.inputcardnumber.value || null);
	return __WEBPACK_IMPORTED_MODULE_3__lib_validate_creditcard_js__["a" /* default */].number(theInput) ? theInput : null;
}

function validCvc() {
	var theInput = __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].trailspace(elements.inputcvc.value || null);
	return __WEBPACK_IMPORTED_MODULE_3__lib_validate_creditcard_js__["a" /* default */].cvc(theInput) ? theInput : null;
}

function setInputValues(p) {
	/* if adding a new card, the default placeholder shall remain.
 otherwise if using an old card, the default placeholder is
 replaced by '**********1234' */
	var cn = p && p.cn || null;
	var vm = p && p.vm || __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].DEFAULT;
	var vy = p && p.vy || __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].DEFAULT;
	var cardid = p && p.cardid || null; // 'cardid');
	var placeholder = p && p.cn || cardnumberDefaultPlaceholder;
	elements.inputcardnumber.placeholder = placeholder;
	/* If a previously used cardnumber is selected from selectlist, this number is presented */
	/* from the 'placeholder' because of it is a input of type 'number' and won't otherwise not display. */
	elements.inputcardnumber.value = cn;
	elements.inputcvc.value = null; /* this value shall always be reset to nothing*/
	elements.inputcardid.value = cardid;
	viewDate.update({
		view_creditcard: {
			month: vm,
			year: vy
		}
	});
}

function getValidUserInput() {
	/* parse the valid input to the userInput */
	var validatedMMYY = viewDate.getValues();
	var cardnumber = validCardnumber();
	var cardid = validCardId();
	var cvc = validCvc();
	var month = validatedMMYY.month;
	var year = validatedMMYY.year;
	/* 1.If a cardnumber is input, it must be valid.
    2.If no cardnumber is specified, the card id must be valid. */
	var allvalid = Boolean((cardnumber || cardid) && cvc && month && year);
	return {
		allvalid: allvalid,
		cardid: cardid,
		cardnumber: cardnumber,
		cvc: cvc,
		month: month,
		year: year
	};
}

function clickHandler(e) {
	/* clicked add creditcard */
	var cb = function click(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		setInputValues(); /* to empty */
		showNewcardinputAndCvc();
	};
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked*/
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].handle(e, '.js-event-filter__addcreditcard', cb, false);
}

function changeHandler(e) {
	var cb = function change(p) {
		p.e.preventDefault();
		p.e.stopPropagation();
		if (p.elm === elements.inputcardnumber) {
			/* if cardnumber has input then it must be valid.
            if cardnumber has no input then there must be a valid card-id instead.*/
			feedbackToCardnumber(validCardnumber());
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewCreditCardNew(elements.inputcardnumber.value);
		} else if (p.elm === elements.inputcvc) {
			feedbackToCvc(validCvc());
		}
	};
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked*/
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].handle(e, '.js-payment__input-cvc-creditcard', cb, true);
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].handle(e, '.js-payment__input-cn-creditcard', cb, true);
}

function onKeyPressHandler(e) {
	var cb = function click(p) {
		p.e.stopPropagation();
		// only numbers charCode
		if (!(p.e.charCode >= 48 && p.e.charCode <= 57)) {
			p.e.preventDefault();
		}
	};
	var cbCvc = function click(p) {
		p.e.stopPropagation();
		// only numbers charCode and max length 3
		if (!(p.e.charCode >= 48 && p.e.charCode <= 57) || p.e.target.value.length >= 3) {
			p.e.preventDefault();
		}
	};
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].handle(e, '.js-payment__input-cn-creditcard', cb, true);
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].handle(e, '.js-payment__input-cvc-creditcard', cbCvc, true);
}

function addListeners() {
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].addListener(elements.wrap, 'change', changeHandler);
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].addListener(elements.wrap, 'click', clickHandler);
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].addListener(elements.wrap, 'keypress', onKeyPressHandler);
}

function removeListeners() {
	if (elements && elements.wrap) {
		__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].removeListener(elements.wrap, 'change', changeHandler);
		__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].removeListener(elements.wrap, 'click', clickHandler);
		elements.wrap.removeEventListener('keypress', onKeyPressHandler);
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create() {
		// TODO: this method will replace the 'init'. See 'view-methods.js' for an example. The 'create' api method must exist to be a
		// valid paymentmodule. See 'deposit-form-template-conf.js'
		return;
	},
	init: function init(p) {
		// refresh the dom if re-init
		elements = __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, ['wrap', 'before', 'inputamountwrap', 'inputamount', 'amountfeedback', 'textkeys'], '/view-creditcard:385');
		elements.wrap = __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].getElementIfValid(p, 'wrap', 'view-creditcard:init:592');
		/* if a 'before' element is provided the content will be inserted before this*/
		/*
        The inputfield for amount is created by view_paymentform, and is persistant for all paymentmethods.
        The validation may vary, and the formatting into the submitstructure varies between different methods.
        The inputelement is therefore a read-only property outisde view_paymentform.
        */
		textkeysObj = __WEBPACK_IMPORTED_MODULE_6__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		cardnumberDefaultPlaceholder = textkeysObj['enter-cardnumber-please'];

		/* if the user has no previously used cards, the validation shall not trigger too early */
		dateIsResetForNewCard = true;

		function selectLastUsedCb() {
			/* another card is selected and the validation shall reset any previously added feedback */
			var creditCardIdValue = viewCreditcardlast.getValues();
			if (creditCardIdValue.add) {
				setInputValues();
				dateIsResetForNewCard = true; // to prevent the validation on date to trigger to early
			} else {
				setInputValues(creditCardIdValue);
				/* revalidate*/
				userInput = getValidUserInput();
				hideNewcardinputExceptCvc();
			}
			markValidReset();
		}

		function viewDateCb(validation) {
			var monthHasError = Boolean(validation.feedbackMonth);
			var yearHasError = Boolean(validation.feedbackYear);
			var dateHasError = Boolean(validation.feedbackDate);
			if (dateIsResetForNewCard) {
				dateIsResetForNewCard = false; // the first selection is done
			} else {
				feedbackToDate({
					monthHasError: monthHasError,
					yearHasError: yearHasError,
					dateHasError: dateHasError
				}, elements);
			}
		}

		viewCreditcardlast = __WEBPACK_IMPORTED_MODULE_5__lib_view_creditcardlast_js__["a" /* default */].create({
			callbackonmainevent: selectLastUsedCb
		});
		viewDate = __WEBPACK_IMPORTED_MODULE_4__lib_view_creditcard_date_js__["a" /* default */].create({
			callbackonmainevent: viewDateCb
		});

		// the wraplastused-element has to be created, which is also done in 'assembleElements'
		elements.wraplastused = elements.wraplastused || createFieldsetWrapLastused();
		elements.selectoraddcardTitle = elements.selectoraddcardTitle || createSelectOrAddCardTitle(textkeysObj['deposit-inputfieldtitle-selectoraddcard']);
		elements.wraplastused.appendChild(elements.selectoraddcardTitle);
		elements.wraplastused.appendChild(viewCreditcardlast.wrap);
		addListeners();
	},
	update: function update(state) {
		/* delete previously created paymentforms */
		/* sync which type of states that shall be updated from view.js */
		/* the module connected to the view is seen in the key of the state object. 'state.moduleName' */
		var lastMethodExist = Boolean(state && state.fetch_methoddetails && Array.isArray(state.fetch_methoddetails.accounts) && state.fetch_methoddetails.accounts.length > 0);
		var paymentmethodsExist = Boolean(state && state.paymentmethods && state.paymentmethods && state.paymentmethods.methods);
		var paymentmethodsByNameExist = Boolean(paymentmethodsExist && state.paymentmethods.methods.by_name);
		var card = null;
		var cn = null;
		var cardid = null;
		var vm = null;
		var vy = null;
		if (state && state.paymentmethods) {
			if (paymentmethodsByNameExist && !elements.assembled) {
				assembleElements();
				elements.fieldsetwrapmm.appendChild(viewDate.wrapMonth);
				elements.fieldsetwrapyy.appendChild(viewDate.wrapYear);
				userInput.allvalid = false;
			}
			hideLastCardWrap();
			showNewcardinputAndCvc();
		}
		if (state && state.submit_payment) {
			/* reset some of the values in the form */
			if (state.submit_payment.success || state.submit_payment.error) {
				/* if previously used creditcards exist, the list will be reset to 'add new' so
    that the user is forced to actively select an old one or type a new, and
    thereby refresh the input. */
				setInputValues();
				viewCreditcardlast.update(state);
			} else if (state.submit_payment.refreshinput) {
				card = state && state.submit_payment && state.submit_payment.currentcard && state.submit_payment.currentcard.card;
				cn = card && card.cn || state.submit_payment.cardnumber;
				cardid = card && card.cid;
				vm = card && card.vm;
				vy = card && card.vy;
				setInputValues({
					cn: cn,
					cardid: cardid,
					vm: vm,
					vy: vy
				});
			}
		}
		if (state && state.fetch_methoddetails) {
			/* if there are accounts saved then hide the new CC field. */
			if (lastMethodExist) {
				/* display selectionlist of accounts */
				hideNewcardinputExceptCvc();
				showLastCardWrap();
				viewCreditcardlast.update(state);
				/* update the fields for cardnumber, month, year */
				setInputValues(viewCreditcardlast.getValues());
			} else {
				// this condition will rarely be met
				hideLastCardWrap();
				showNewcardinputAndCvc();
			}
		}
	},
	close: function close() {
		userInput.allvalid = false;
		if (viewCreditcardlast) {
			viewCreditcardlast.close();
		}
		if (viewDate) {
			viewDate.close();
		}
		removeListeners();
		deleteAllElements();
		return null;
	},
	evalInput: function evalInput() {
		var structure = null;
		userInput = getValidUserInput();
		markValidAll(userInput);
		if (userInput.allvalid) {
			structure = toSubmitStructure(userInput);
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewCreditcard({
				card: structure
			});
		}
		return structure;
	}
};

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/*
view_creditcardlast.js
create and handle selection list to be inserted in a <form>
*/


// import constants from '../../common/lib/utils/constants.js';



var textkeysObj = {};
var addNewCardAttr = 'addnewcard';
var create = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].create; // creates basic elements not inserted into the dom
var nodetree = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].nodetree; // inserts an array of elements into a document-fragment which later may be inserted into the dom
var classnameShow = 'u-show';
var classnameHide = 'u-hide';

function createSelectMethod(eventFilter) {
	var cName = eventFilter + ' payment__select-lastused';
	return create({
		type: 'select',
		class: cName
	});
}

function createOptionForAdd(text, addAttribute) {
	var elm = create({
		type: 'option',
		class: 'payment__option-lastused',
		add: 'add',
		value: addAttribute
	});
	if (text) {
		elm.innerHTML = text;
	}
	return elm;
}

function createOptions(objById) {
	var nodes = [];
	var options = {};
	if (objById) {
		Object.keys(objById).forEach(function (key) {
			/* A reference to the element is saved. */
			var tempObj = {
				value: objById[key].id || 'id missing',
				vm: objById[key].vm || 'vm missing',
				vy: objById[key].vy || 'vy missing',
				co: objById[key].co || 'co missing',
				cn: objById[key].cardNo || textkeysObj['cardnumber-missing-replacer']
			};
			options[key] = create({
				type: 'option',
				class: 'payment__option-lastused',
				value: tempObj.value,
				vm: tempObj.vm,
				vy: tempObj.vy,
				co: tempObj.co,
				cn: tempObj.cn
			});
			if (objById[key].selected) {
				options[key].selected = true;
			}
			/* the replacement for the cardnumber is injected here, 'xxxxxxx1234' */
			options[key].innerHTML += tempObj.cn;
			/* The uninserted nodes are returned as a list to be inserted with 'nodetree'-function. */
			nodes.push(options[key]);
		});
	} else {
		console.warn('view_creditcardlast:createOptions: can not get last details in object: missing property "by_id"', objById);
	}
	return nodes;
}

function getSelectedOption(selectElement) {
	var index = Boolean(selectElement && selectElement.options && (selectElement.selectedIndex || selectElement.selectedIndex === '0' || selectElement.selectedIndex === 0));
	var elm = index ? selectElement.options[selectElement.selectedIndex] : null;
	return elm;
}

function getCardValues(selectElm) {
	/* this function sometimes throws error during navigation through the depositflow and
 is therefore surrounded with extra property checks */
	var cn = null;
	var co = null;
	var cardid = null;
	var vm = null;
	var vy = null;
	var add = null;
	var elm = null;
	var selectedOption = getSelectedOption(selectElm);
	elm = selectedOption;

	if (elm && elm.getAttribute) {
		cn = elm.getAttribute('cn') || null;
		co = elm.getAttribute('co') || null;
		cardid = elm.getAttribute('value') || null;
		vm = elm.getAttribute('vm') || null;
		vy = elm.getAttribute('vy') || null;
		add = Boolean(elm.getAttribute('add'));
	}
	return {
		vm: vm,
		vy: vy,
		cn: cn,
		co: co,
		cardid: cardid,
		add: add
	};
}

function _show(elm) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameHide);
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameShow);
	}
}

function _hide(elm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameHide);
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	var eventFilterSelector = '.' + eventFilterSeparatorClassname;

	function cb(p) {
		p.e.stopPropagation();
		onEventCb();
		var card = getCardValues(p.elm);
		__WEBPACK_IMPORTED_MODULE_1__common_lib_utils_actions_js__["a" /* default */].viewCreditcardlast(card);
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeListener(elm, eventType, handler);
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create(p) {
		var elements = {};
		var mainEventType = 'change';
		var classNameEventFilter = 'js-eventfilter-viewcreditcardlast';
		textkeysObj = __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		elements.wrap = elements.wrap || createSelectMethod(classNameEventFilter);
		var callbackOnMainEvent = p.callbackonmainevent || function temp() {};
		var handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);
		return {
			wrap: elements.wrap,
			show: function show() {
				_show(elements.wrap);
			},
			hide: function hide() {
				_hide(elements.wrap);
			},
			getValues: function getValues() {
				/* return values from selected option */
				var selectElement = elements.wrap;
				var val = getCardValues(selectElement);
				return val;
			},
			update: function update(state) {
				// const accounts = ((state.fetch_methoddetails && state.fetch_methoddetails.hasAccounts) && state.fetch_methoddetails.accounts);
				var accounts = state.fetch_methoddetails && state.fetch_methoddetails.accounts;
				var accountById = accounts && accounts.by_id;
				var submitWasDone = state && state.submit_payment && (state.submit_payment.success || state.submit_payment.error);
				if (accounts && !elements.options) {
					elements.options = createOptions(accountById);
					elements.options.push(createOptionForAdd(textkeysObj['deposit-paymentmethods-addcard-selecttext'], addNewCardAttr));
					elements.wrap.appendChild(nodetree(elements.options));
				}
				if (submitWasDone) {
					/* the submit was done, and now the selectionlist shall be reset so
     that the user is forced to actively select an old one or type a new, and
     thereby refresh the input. */
					// selectOptionToAdd(elements.wrap, value);
					if (elements && elements.wrap) {
						elements.wrap.value = addNewCardAttr;
					}
				}
			},
			close: function close() {
				/* hide the spinner if the spinner is closed before hidden.
    Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler);
				elements = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, [], 'view_creditcardlast:187');
			}
		};
	}
};

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/*
 view-currencyselect.js
 */




var _create = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].create; // creates basic elements not inserted into the dom
var nodetree = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].nodetree; // inserts an array of elements into a document-fragment which later may be inserted into the dom
var classnameShow = 'u-show';
var classnameHide = 'u-hide';

function createSelect(eventFilter) {
	var cName = eventFilter + ' payment__select';
	return _create({
		type: 'select',
		class: cName
	});
}

function createLegend() {
	var txt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

	var elm = _create({
		type: 'legend',
		class: 'legend'
	});
	elm.innerHTML = txt;
	return elm;
}

function createOptions(p) {
	/* see input format above */
	// obj, keytoval, keytotext, selectedId
	var arr = p.arr;
	var keytoval = p.keytoval;
	var keytotext = p.keytotext;
	var selectedCurrencyValue = p.selectedCurrencyValue || null;
	var nodes = [];
	if (arr && arr.forEach) {
		arr.forEach(function (obj) {
			/* A reference to the element is saved. */
			var elm = _create({
				type: 'option',
				class: 'payment__option',
				value: obj[keytoval] || keytoval + ' missing'
			});
			elm.innerHTML = obj[keytotext] || keytoval + ' missing';
			if (selectedCurrencyValue) {
				if (obj.value && obj.value === selectedCurrencyValue) {
					elm.selected = true;
				}
			} else if (obj.selected) {
				elm.selected = true;
			}
			/* The uninserted nodes are returned as a list to be inserted with 'nodetree'-function. */
			nodes.push(elm);
		});
	}
	return nodes;
}

function valueToOptionIndex(num, arr) {
	var attr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';

	var arrIndex = null;
	var numToStr = num.toString();
	arr.forEach(function (elm, index) {
		if (elm.getAttribute && elm.getAttribute(attr) && elm.getAttribute(attr) === numToStr) {
			arrIndex = index;
		}
	});
	return arrIndex;
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	/* this handler is a wrapper that filters out values from the target element,
 and then applies the callback-argument on these values */
	var eventFilterSelector = '.' + eventFilterSeparatorClassname;

	function cb(p) {
		p.e.stopPropagation();
		/* get method from the selectbox */
		var selectElm = p.elm;
		var selectedOptionIndex = selectElm.selectedIndex;
		var optionElm = selectElm[selectedOptionIndex];
		var value = optionElm.value;
		var text = optionElm.text;
		onEventCb({
			value: value,
			text: text
		});
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeListener(elm, eventType, handler);
	}
}

function _show(elm) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameHide);
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameShow);
	}
}

function _hide(elm) {
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameHide);
}

function getSelectedIndex(arr) {
	var key = null;
	if (arr && arr.forEach) {
		arr.forEach(function (elm, index) {
			if (elm.selected) {
				key = index;
			}
		});
	}
	return key;
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create() {
		var elements = {};
		var mainEventType = 'change';
		var classNameEventFilter = 'js-eventfilter-viewselect';
		var textkeysObj = __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		elements.fieldset = elements.fieldset || _create('fieldset', 'custom-select u-relative u-mb2 u-show');
		elements.legend = elements.legend || createLegend(textkeysObj['select-currency']);
		elements.select = elements.select || createSelect(classNameEventFilter);

		elements.fieldset.appendChild(elements.legend);
		elements.fieldset.appendChild(elements.select);
		elements.wrap = elements.fieldset;

		function callbackOnMainEvent(p) {
			var val = p.value;
			var text = p.text;
			console.log('view-select:callbackOnMainEvent', val, text);
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewCurrencySelect(val, text);
			/* change: updates less times than input: filter value and publish*/
			// const val = elements.inputamount.value;
			// const digits = validateAmount.keepDigits(val);
			// publishOrFeedback(digits, elements.amountfeedback, elements.inputamount);
		}
		var handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);
		return {
			wrap: elements.wrap,
			show: function show() {
				_show(elements.wrap);
			},
			hide: function hide() {
				_hide(elements.wrap);
			},
			update: function update(state) {
				/* this module accepts the format:
    {'name1':[{'value':'some text'}, ... 'nameN':{'value':'some text other'}]}
     */
				if (state && state.fetch_methoddetails.currencies) {
					var currencies = state.fetch_methoddetails.currencies;
					var selectedCurrencyValue = state.fetch_methoddetails.lastUsedAccountIdx != null ? state.fetch_methoddetails.accounts[state.fetch_methoddetails.lastUsedAccountIdx].cu : null;
					var selectedIndex = getSelectedIndex(currencies);
					var optIndex = null;
					if (Array.isArray(currencies)) {
						// TODO: this should only update when a new list of preset amounts is available
						if (elements.options && (selectedIndex || selectedIndex === 0)) {
							/* update selected option if the list list is refreshed programatically */
							if (selectedCurrencyValue != null) {
								optIndex = valueToOptionIndex(selectedCurrencyValue, elements.options);
							} else {
								optIndex = selectedIndex;
							}

							if (elements.options[optIndex]) {
								elements.options[optIndex].selected = true;
							}
						} else {
							elements.options = createOptions({
								arr: currencies,
								keytoval: 'value',
								keytotext: 'text',
								selectedCurrencyValue: selectedCurrencyValue
							});

							elements.select.appendChild(nodetree(elements.options));
						}
					}
				}
			},
			close: function close() {
				/* hide the spinner if the spinner is closed before hidden.
    Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler, mainEventType);
				elements = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, [], 'view_amountselect:248');
				return null;
			}
		};
	}
};

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_validate_dotpay_js__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/*
view_dotpay

dotpay = {
    "utimestamp": 1458224412998,
    "am": "50",
    "bid": null,
    "paymentMethodId": 23,
},
*/


// import validateAmount from '../lib/validate-amount.js';



var create = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].create;
var classnameShow = 'u-show';
var classnameHide = 'u-hide';
var notvalidClass = 'payment__input_notvalid';
var textkeysObj = void 0;

function createNumberTitle(txt) {
	var elm = create({
		type: 'legend',
		class: 'legend'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createLabelNumber() {
	return create({
		type: 'label',
		class: 'payment__label-code-dotpay'
	});
}

function createFeedback(txt) {
	var elm = create({
		type: 'small',
		class: 'input-wrap__error-display payment__feedback grid-u-sm-1 u-hide'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createInputCode(placeholder) {
	return create({
		type: 'input',
		class: 'payment__input-dotpay input-wrap__input',
		name: 'code',
		'input-type': 'tel',
		placeholder: placeholder || 'enter blik code here'
	});
}

function createFieldsetWrapNumber(eventFilter) {
	var cName = eventFilter + ' payments__fieldset-wrap-number u-relative';
	return create({
		type: 'div',
		class: cName
	});
}

function validAmount() {
	/* remove any trailing spaces from all input and validate */
	// const theInput = core.trailspace(elements.inputamount.value || null);
	// checks for amount valid and if errorClass is present in the field.
	// return ((validateAmount.keepDigits(theInput) && !containsWord(elements.inputamount.className, errorClass)) ? theInput : null);
	return 'view_dotpay:93';
}

function replace(elm, val) {
	elm.value = val; // eslint-disable-line no-param-reassign
}

function getInput(elements) {
	/* check if the current input is done with 6 digits, and flag
 for not complete input (123, 12, 1, 12345, 1234) */
	var theInput = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].trailspace(elements.inputcode.value || null);
	var isOnlyDigits = __WEBPACK_IMPORTED_MODULE_1__lib_validate_dotpay_js__["a" /* default */].containsOnlyDigits(theInput);
	var tooShort = __WEBPACK_IMPORTED_MODULE_1__lib_validate_dotpay_js__["a" /* default */].hasStringLengthLessThan(theInput, 6);
	var filteredToValid = __WEBPACK_IMPORTED_MODULE_1__lib_validate_dotpay_js__["a" /* default */].filterAwayNotValid(theInput);
	var isValid = __WEBPACK_IMPORTED_MODULE_1__lib_validate_dotpay_js__["a" /* default */].code(filteredToValid);
	return {
		theInput: theInput,
		isOnlyDigits: isOnlyDigits,
		tooShort: tooShort,
		filteredToValid: filteredToValid,
		isValid: isValid
	};
}

function validCode(elements) {
	/* remove any trailing spaces from all input and validate */
	var theInput = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].trailspace(elements.inputcode.value || null);
	return __WEBPACK_IMPORTED_MODULE_1__lib_validate_dotpay_js__["a" /* default */].code(theInput) ? theInput : null;
}

function userInputToSubmitStructure(elements) {
	/* This is the structure required by the depositmethod. To not hardcode keys in earlier steps the values are parsed here. */
	var am = validAmount(elements);
	var blik = validCode(elements);
	var allvalid = Boolean(am && blik);
	return {
		am: am,
		blik: blik,
		allvalid: allvalid,
		utimestamp: new Date().getTime(),
		paymentMethodId: 57
	};
}

function _show(elm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameHide);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameShow);
}

function _hide(elm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameHide);
}

function hideElm(elm, yesHideIt) {
	if (yesHideIt) {
		_hide(elm);
	} else {
		_show(elm);
	}
}

function markValid(element, valid) {
	if (valid) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(element, notvalidClass);
	} else {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(element, notvalidClass);
	}
}

function feedbackToCode(inputIsValid, elms) {
	if (inputIsValid) {
		markValid(elms.labelcardnumber, true);
		_hide(elms.cardnumberfeedback);
	} else {
		markValid(elms.labelcardnumber, false);
		hideElm(elms.cardnumberfeedback, false);
	}
}

function markValidAll(uInput, elements) {
	/* depending on validation the inputfields are marked
    with specific classname and messages with feedback are shown */
	var code = uInput && uInput.blik;
	feedbackToCode(code, elements);
}
function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	var eventFilterSelector = '.' + eventFilterSeparatorClassname;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		onEventCb();
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeListener(elm, eventType, handler);
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create() {
		var elements = {};
		var mainEventType = 'input';
		var classNameEventFilter = 'js-eventfilter-viewdotpay';
		elements.wrap = elements.wrap || createFieldsetWrapNumber(classNameEventFilter);

		var callbackOnMainEvent = function callbackOnMainEvent() {
			// if the input is more than 6 digits or is not a number 0-9 the input may be erased
			var current = getInput(elements);
			var hasInput = current.theInput;
			var isDigitsAndNotCompleted = !hasInput || current.tooShort && current.isOnlyDigits; // do not set 'not valid' until all numbers are input
			var valid = isDigitsAndNotCompleted || current.isValid;
			replace(elements.inputcode, current.filteredToValid);
			feedbackToCode(valid, elements);
		};
		var handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);

		textkeysObj = __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		elements.inputcode = elements.inputcode || createInputCode(textkeysObj['dotpay-enter-code-placeholder']);
		elements.labelcardnumber = elements.labelcardnumber || createLabelNumber();
		elements.cardnumberTitle = elements.cardnumberTitle || createNumberTitle(textkeysObj['dotpay-code-title']);
		elements.cardnumberfeedback = elements.cardnumberfeedback || createFeedback(textkeysObj['dotpay-code-feedback']);
		elements.labelcardnumber.appendChild(elements.cardnumberTitle);
		elements.labelcardnumber.appendChild(elements.inputcode);
		elements.labelcardnumber.appendChild(elements.cardnumberfeedback);
		elements.wrap.appendChild(elements.labelcardnumber);

		return {
			wrap: elements.wrap,
			show: function show() {
				_show(elements.wrap);
			},
			hide: function hide() {
				_hide(elements.wrap);
			},
			update: function update() {},
			evalInput: function evalInput() {
				var uinput = userInputToSubmitStructure(elements);
				markValidAll(uinput, elements);
				uinput = uinput.allvalid ? uinput : null;
				return uinput;
			},
			close: function close() {
				/* hide the spinner if the spinner is closed before hidden.
    Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler, mainEventType);
				elements = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, [], 'view_dotpay:248');
				return null;
			}
		};
	}
};

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__ = __webpack_require__(2);
/*
 view_methods.js
 create and handle selection list to be inserted in a <form>

 <form action="/foo">

 <select name="cars">
 <option value="volvo">Volvo</option>
 <option value="saab">Saab</option>
 <option value="fiat">Fiat</option>
 <option value="audi">Audi</option>
 </select>

 </form>

 The options are  build from the structure below:
 {
 methodname1: {
 executeUrl: "/pp?flow=EnvoyInitDepositJson"
 formTemplateCode: "NO-FIELDS"
 formTemplateUrlParams: "&paymentMethodId=42&paymentType=deposit"
 logoImgClasses: ["visa","mastercard","other"]
 methodId: 42
 methodInfo: "??BPAY_INFO_DEPOSIT??"
 methodName: "BPay"
 methodText: "bPay"
 paymentType: "deposit"
 sendHandlerType: "EXTERNAL_WINDOW"
 },
 methodname2: {..same structure as above..
 }
 methodnameN: {..same structure as above..
 }
 }
 */


// import viewTextkeys from '../../commonview/lib/view-textkeys.js';

var create = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].create; // creates basic elements not inserted into the dom
var nodetree = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].nodetree; // inserts an array of elements into a document-fragment which later may be inserted into the dom
var classnameShow = 'u-show';
var classnameHide = 'u-hide';
// let textkeysObj = {};

function createSelectMethod(eventFilter) {
	var cName = eventFilter + ' payment__select-methods';
	return create({
		type: 'select',
		class: cName
	});
}

function createOptions(objByName, selectedMethodId) {
	/* see input format above */
	var nodes = [];
	Object.keys(objByName).forEach(function (name) {
		/* A reference to the element is saved. */
		var elm = create({
			type: 'option',
			class: 'payment__option-method',
			value: objByName[name].methodId || 'method-id-missing'
		});
		elm.innerHTML = objByName[name].methodText || 'methodtext missing'; // TODO: textkey?
		if (objByName[name].methodId === selectedMethodId) {
			elm.selected = true;
		}
		/* The uninserted nodes are returned as a list to be inserted with 'nodetree'-function. */
		nodes.push(elm);
	});
	return nodes;
}

function valueToOptionIndex(num, arr) {
	var arrIndex = null;
	var numToStr = num.toString();
	arr.forEach(function (elm, index) {
		if (elm.getAttribute && elm.getAttribute('value') && elm.getAttribute('value') === numToStr) {
			arrIndex = index;
		}
	});
	return arrIndex;
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	var eventFilterSelector = '.' + eventFilterSeparatorClassname;

	function cb(p) {
		p.e.stopPropagation();
		/* get method from the selectbox */
		var selectElm = p.elm;
		var selectedOptionIndex = selectElm.selectedIndex;
		var optionElm = selectElm[selectedOptionIndex];
		var methodId = optionElm.value;
		var methodName = optionElm.text;
		onEventCb();
		__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewMethods(methodId, methodName);
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeListener(elm, eventType, handler);
	}
}

function _show(elm) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameHide);
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameShow);
	}
}

function _hide(elm) {
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameHide);
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create() {
		var elements = {};
		var mainEventType = 'change';
		var classNameEventFilter = 'js-eventfilter-viewmethods';
		// textkeysObj = viewTextkeys.depositflow();
		elements.wrap = elements.wrap || createSelectMethod(classNameEventFilter);
		var callbackOnMainEvent = function temp() {};
		var handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);
		return {
			wrap: elements.wrap,
			show: function show() {
				_show(elements.wrap);
			},
			hide: function hide() {
				_hide(elements.wrap);
			},
			update: function update(state) {
				var payM = state && state.paymentmethods;
				var selectedMethodId = payM && payM.selected && payM.selected.id;
				var byNameList = payM && payM.methods && payM.methods.by_name;
				var optIndex = null;
				if (byNameList) {
					if (elements.options && selectedMethodId) {
						/* update selected option if the list list is refreshed programatically */
						optIndex = valueToOptionIndex(selectedMethodId, elements.options);
						if (elements.options[optIndex]) {
							elements.options[optIndex].selected = true;
						}
					} else {
						elements.options = createOptions(byNameList, selectedMethodId);
						elements.wrap.appendChild(nodetree(elements.options));
					}
				}
			},
			close: function close() {
				/* hide the spinner if the spinner is closed before hidden.
    Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler, mainEventType);
				elements = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, [], 'view_methods:248');
				return null;
			}
		};
	}
};

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/*
 view_pugglepay

 pugglepay = {
 "utimestamp": 1458224412998,
 "am": "50",
 "bid": null,
 "paymentMethodId": 23,
 },
 */

// import validateAmount from '../lib/validate-amount.js';

var elements = {
	/* see 'assembleOnce' below for more details of the elements object content */
	assembled: false,
	wrap: null
};
var userInput = {
	allvalid: false
};
var paymentmethodId = null;

function userInputToSubmitStructure(paymentMethodId) {
	/* This is the structure required by the depositmethod. To not hardcode keys in earlier steps the values are parsed here. */
	return {
		utimestamp: new Date().getTime(),
		paymentMethodId: paymentMethodId
	};
}

function deleteAllElements() {
	/* The object-property must either contain an element or an array with elements*/
	/* The wrapper is not deleted.*/
	if (elements && elements.assembled) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, ['wrap'], 'view_nofields:57');
		elements.assembled = false;
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create() {
		return;
	},
	init: function init(p, id) {
		paymentmethodId = id;
		/*
   The inputfield for amount is created by view_paymentform, and is persistant for all paymentmethods.
   The validation may vary, and the formatting into the submitstructure varies between different methods.
   The inputelement is therefore a read-only property outisde view_paymentform.
   */
		elements.wrap = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].getElementIfValid(p, 'wrap', 'view_nofields:init');
	},
	update: function update() {
		/* delete previously created paymentforms */
		/* sync which type of states that shall be updated from view.js */
	},
	close: function close() {
		userInput.allvalid = false;
		/* this form contains almost or no own elements to delete */
		deleteAllElements();
		return null;
	},
	evalInput: function evalInput() {
		return userInputToSubmitStructure(paymentmethodId);
	},
	disableAmountInput: function disableAmountInput() {
		return paymentmethodId === '47';
	},
	displayAmountSelector: function displayAmountSelector() {
		return paymentmethodId === '47';
	}
};

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/**
 * Created by patricio on 2016-10-28.
 */

/*
payment/view-payment-method-link

Will display selected payment method on deposit page.
It takes the user to the payment methods page when clicked.

<ul class="link-list">
    <li class="link-list__item">
        <a href="#" class="link-list__item-link">
            <span class="link-list__item-text">Payment Method</span>
            <span class="link-list__item-text link-list__item-text-selected">Credit Card</span>
            <span class="link-list__item-text ink-list__item-text-card-number">1234</span>
            <svg viewBox="0 0 64 64" class="link-list__continue-icon" aria-hidden="true">
                <path d="M21.76,51.75a1.08,1.08,0,0,1,0-1.5L40,32,21.88,13.74a1.06,1.06,0,0,1,1.5-1.5
                l18.79,19a0.73,0.73,0,0,1,.27.33,1.17,1.17,0,0,1,0,.9,0.73,0.73,0,0,1-.27.33l-18.85,19A0.
                94,0.94,0,0,1,23,52a1.33,1.33,0,0,1-.42.06A1.42,1.42,0,0,1,22.15,52,0.9,0.9,0,0,1,21.76,51.75Z" />
            </svg>
        </a>
    </li>
</ul>

*/





var classnameOpen = 'u-show';
var classnameClose = 'u-hide';
var create = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].create;
var selectedPaymentMethodText = void 0;
var textKeysObj = void 0;

function createListElement() {
	return create({
		type: 'li',
		class: 'link-list__item link-list__item--single u-b-radius u-m0'
	});
}

function createLinkElement() {
	return create({
		type: 'a',
		class: 'link-list__item-link',
		href: '#'
	});
}

function createTextWrapperForLink() {
	// this is a div that just wraps the texts inside the link (as block element)
	return create({
		type: 'div'
	});
}

function createLinkStaticTextElement(txt) {
	// This display static text "Payment Method".
	var elm = create({
		type: 'span',
		class: 'payment-method-title u-dib'
	});
	/* txt is essential input and if it is empty throw error */
	elm.innerHTML = txt;
	return elm;
}

function createLinkSelectedMethodTextElement(txt) {
	// added this span to update only the text, otherwise the icon is replaced as well.
	var elm = create({
		type: 'span',
		class: 'payment-method-sub-title u-dib'
	});
	/* txt is essential input and if it is empty throw error */
	elm.innerHTML = txt;
	return elm;
}

function createLinkCardNumberText() {
	// This will hold the last 4 digits of the selected credit card if any
	return create({
		type: 'span',
		class: 'payment-method-sub-title'
	});
}

function createSvgIcon() {
	return create({
		type: 'svg',
		viewBox: '0 0 24 24',
		class: 'link-list__continue-icon',
		'aria-hidden': true
	});
}

function createPathForIcon() {
	return create({
		type: 'path',
		d: 'M8.11 19.43C7.96 19.28 7.96 19.03 8.11 18.87L14.95 12.03 8.16 5.18C8 5.02 8 4.77 8.16 4.62 8.31 4.46 8.57 4.46 8.72 4.62L15.77 11.74C15.81 11.77 15.85 11.81 15.87 11.87 15.91 11.97 15.91 12.09 15.87 12.2 15.85 12.25 15.81 12.3 15.77 12.33L8.7 19.45C8.66 19.48 8.62 19.51 8.58 19.53 8.53 19.54 8.47 19.55 8.42 19.55 8.37 19.55 8.32 19.54 8.27 19.53 8.21 19.51 8.16 19.48 8.11 19.43L8.11 19.43Z' // eslint-disable-line max-len
	});
}

function extractLastDigits(str) {
	var no = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 4;

	return str && str.substring(str.length - no);
}

function updateFourDigits(elm, state) {
	var cardNo = null;
	// fetch cardNo coming from last used method or from new added CC
	if (state && state.fetch_methoddetails) {
		cardNo = state.fetch_methoddetails.creditcardlast;
	} else if (state && state.submit_payment) {
		cardNo = state.submit_payment.currentcard.card.cn;
	}
	cardNo = extractLastDigits(cardNo, 4);
	if (elm && cardNo) {
		elm.innerHTML = '' + cardNo; // eslint-disable-line no-param-reassign
	} else if (elm) {
		elm.innerHTML = ''; // eslint-disable-line no-param-reassign
	}
}

function deleteAllElements(elmObj) {
	return __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elmObj, [], 'view-payment-method-link');
}

function _show(elm) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameClose);
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameOpen);
	}
}

function _hide(elm) {
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameOpen);
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameClose);
}

function clickBtnHandler(e, onClickCb, eventFilterSeparatorClassname) {
	var eventFilterSelector = '.' + eventFilterSeparatorClassname;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewPaymentMethodLink();
		onClickCb();
	}

	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, handler, eventFilter) {
	function handleCreator(e) {
		clickBtnHandler(e, handler, eventFilter);
	}

	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addListener(elm, 'click', handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeListener(elm, 'click', handler);
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create(p) {
		var classNameEventFilter = 'js-event-filter-payment-method-link';
		var callbackOnClick = p.cb;
		var elements = {};
		selectedPaymentMethodText = p.paymentMethodText;
		textKeysObj = __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		elements.wrap = createListElement();
		elements.link = elements.link || createLinkElement();
		elements.linkTextWrapper = elements.linkTextWrapper || createTextWrapperForLink();
		elements.linkStaticText = elements.linkStaticText || createLinkStaticTextElement(textKeysObj['deposit-payment-method']);
		elements.linkSelectedPaymentMethodText = elements.linkSelectedPaymentMethodText || createLinkSelectedMethodTextElement(selectedPaymentMethodText);
		elements.linkCardNumber = elements.linkCardNumber || createLinkCardNumberText();
		elements.svg = elements.svg || createSvgIcon();
		elements.path = elements.path || createPathForIcon();
		elements.svg.appendChild(elements.path);
		elements.linkTextWrapper.appendChild(elements.linkStaticText);
		elements.linkTextWrapper.appendChild(elements.linkSelectedPaymentMethodText);
		elements.linkTextWrapper.appendChild(elements.linkCardNumber);
		elements.link.appendChild(elements.linkTextWrapper);
		elements.link.appendChild(elements.svg);
		elements.wrap.appendChild(elements.link);
		var handler = addListeners(elements.wrap, callbackOnClick, classNameEventFilter);
		/* the button is displayed by default,
   hide it actively from .hide() */
		_show(elements.wrap);
		return {
			wrap: elements.wrap,
			show: function show() {
				_show(elements.wrap);
			},
			hide: function hide() {
				_hide(elements.wrap);
			},
			update: function update(state) {
				if (state && state.fetch_methoddetails) {
					updateFourDigits(elements.linkCardNumber, state);
				}
				if (state && state.submit_payment && state.submit_payment.currentcard.card.cn) {
					updateFourDigits(elements.linkCardNumber, state);
				}
				if (state && state.view_paymentform && state.view_paymentform.name) {
					/* update payment method on button */
					elements.linkSelectedPaymentMethodText.innerHTML = state.view_paymentform.name;
				}
			},
			close: function close() {
				/* hide the spinner if the spinner is closed before hidden.
    Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler);
				deleteAllElements(elements);
			}
		};
	}
};

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_amountfee_js__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_amountinput_js__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__view_amountselect_js__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__view_methods_js__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commonview_lib_view_notification_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__view_payment_method_link_js__ = __webpack_require__(411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__view_currencyselect_js__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commonview_lib_view_submitbtn_js__ = __webpack_require__(387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/*
 view_paymentform
 */
/* the methodList-object is tightly coupled to state structure in paymentmethods.js.
 The methodList-object is sorted on keys equal to the id of a paymentmethod.
 This id is also used to define the method to handle data published from this module.(view_paymentform.js)
 This method validate the equality of the actual key and the id in the structure. */













var create = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].create;
var classnameShow = 'u-show';
var classnameHide = 'u-hide';
var currentMethod = void 0;
var textkeysObj = void 0;
var elements = void 0;
var viewConfirmMethodBtn = void 0;
var viewDepositBtn = void 0;
var viewAmountInput = void 0;
var viewAmountselect = void 0;
var viewAmountfee = void 0;
var viewChangeMethodBtn = void 0;
var viewCurrencySelect = void 0;
var viewMethods = void 0;
var limitWithin = void 0;

function createMethodsTitle(txt) {
	var elm = create({
		type: 'legend',
		class: 'legend'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function changeNavDepositTitle(text) {
	// TODO; this is a temporary solution in wait for a new created by react components
	// This title belongs to the navigation, which means that each new view (pendingwithdraw,
	// bonus, payment, result) will have it's separate title. To display a new title when
	// paymentmethod or amount is selected means by this convention that two separate
	// urls have to be specified.
	elements.navdeposittitle = elements.navdeposittitle || document.querySelector('#js-deposit-header-title');
	if (elements.navdeposittitle && text) {
		elements.navdeposittitle.innerHTML = text;
	}
}

function getCurrentMethodId() {
	return __WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__["a" /* default */].getCurrentPaymentMethodId();
}

function show(elm) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameHide);
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameShow);
	}
}

function hide(elm) {
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameHide);
}

function evaluateForm() {
	// during refactoring of the paymentmodules,(view-creditcard, view-trustly etc.) towards
	// a common api and structure, the current method might be used in two ways. The
	// preferred way is the 'currentMethod.evalInput()' below.
	var valA = currentMethod && currentMethod.evalInput ? currentMethod.evalInput() : null;
	var valB = __WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__["a" /* default */].evalInput();
	return valA || valB;
}

function depositBtnCb() {
	/* .... to prevent the form to be submitted with an amount that has not been validated to
 fees and limits, a promise is added to the actions payload, to ... TODO: explanation */
	var validateFeesAndLimitsPromiseResolver = void 0;
	var promise = new Promise(function (resolve) {
		validateFeesAndLimitsPromiseResolver = resolve;
	});

	__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].validateFeesAndLimitsAtSubmit(validateFeesAndLimitsPromiseResolver);

	promise.then(function () {
		/* when all credentials and amount are filled in properly */
		var inputExceptAmount = evaluateForm();
		var validAmount = viewAmountInput.getValidAmount();
		var data = inputExceptAmount;
		if (inputExceptAmount && validAmount && limitWithin) {
			data.methodId = getCurrentMethodId();
			data.am = validAmount;
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewPaymentformSubmit(data);
		}
	});
}

function showAmountSelector() {
	if (__WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__["a" /* default */].displayAmountSelector()) {
		viewAmountselect.show();
	}
}

function showCurrencySelector() {
	if (__WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__["a" /* default */].displayCurrencySelector()) {
		viewCurrencySelect.show();
	} else {
		viewCurrencySelect.hide();
	}
}

function setupForInputMethod(selectedPaymentMethodId) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewPaymentform({
		setupmethod: true,
		selectedPaymentMethod: selectedPaymentMethodId
	});
	changeNavDepositTitle(textkeysObj['deposit-paymentmethods-method-title']);
	show(elements.wrapmethods);
	if (viewAmountselect && viewAmountselect.hide) {
		viewAmountselect.hide();
	}
	showCurrencySelector();
	viewMethods.show();
	viewConfirmMethodBtn.show();
	viewAmountInput.hide();
	viewDepositBtn.hide();
	viewAmountfee.hide();
	viewChangeMethodBtn.hide();
	show(elements.wrapCurrent);
	hide(elements.scrollableContent);
}

function setupForInputAmount() {
	changeNavDepositTitle(textkeysObj['deposit-paymentmethods-amount-title']);
	showAmountSelector();
	if (viewCurrencySelect && viewCurrencySelect.hide) {
		viewCurrencySelect.hide();
	}
	hide(elements.wrapmethods);
	viewMethods.hide();
	viewConfirmMethodBtn.hide();
	viewAmountInput.show(__WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__["a" /* default */].disableamountinput());
	viewDepositBtn.show();
	viewAmountfee.show();
	viewChangeMethodBtn.show();
	hide(elements.wrapCurrent);
	show(elements.scrollableContent);
}

function submitbtnCallback() {
	/* when credentials for the selected method are filled in properly */
	var inputExceptAmount = evaluateForm();
	/* except amountfield*/
	if (inputExceptAmount) {
		setupForInputAmount();
	}
}

function assembleElements() {
	if (!elements.assembled) {
		elements.form = elements.form || create('form', 'payment__form js-payment__form u-height-100');
		elements.wrapCurrent = elements.wrapCurrent || create('fieldset', 'payment__form__wrapcurrent');
		elements.wrapmethods = elements.wrapmethods || create('fieldset', 'payment__fieldset-wrap-methods custom-select u-relative u-mb2');
		elements.wrapsubmit = elements.wrapsubmit || create('div', 'js-payment__btn-deposit u-btn-wrapper u-absolute u-pos-bl0 grid-u-sm-1');
		elements.wrapChangemethod = elements.wrapChangemethod || create('ul', 'link-list js-event-filter-payment-method-link u-mb1');
		elements.wrapamountfee = elements.wrapamountfee || create('div', 'js-payment__wrap-amountfee payment__wrap-amountfee u-height-100');
		elements.scrollableContent = elements.scrollableContent || create('div', 'content-scroller u-oa u-height-100');
		viewAmountselect = viewAmountselect || __WEBPACK_IMPORTED_MODULE_5__view_amountselect_js__["a" /* default */].create();
		viewCurrencySelect = viewCurrencySelect || __WEBPACK_IMPORTED_MODULE_9__view_currencyselect_js__["a" /* default */].create();
		elements.form.appendChild(viewAmountselect.wrap);
		viewAmountInput = viewAmountInput || __WEBPACK_IMPORTED_MODULE_4__view_amountinput_js__["a" /* default */].create({
			clickcb: showAmountSelector
		});
		elements.scrollableContent.appendChild(viewAmountInput.wrap);
		elements.form.appendChild(elements.wrapmethods);
		elements.form.appendChild(viewCurrencySelect.wrap);
		elements.form.appendChild(elements.wrapCurrent);
		elements.scrollableContent.appendChild(elements.wrapamountfee);
		// Move of the method-link out of scrollableContent to be grouped with submitdepositbutton
		elements.form.appendChild(elements.scrollableContent);
		elements.form.appendChild(elements.wrapsubmit);
		/* insert select list with options to update the rest of the form depending on the selected option
  see viewMethods.init() and viewAmountfee.init() below
  */
		viewConfirmMethodBtn = viewConfirmMethodBtn || __WEBPACK_IMPORTED_MODULE_10__commonview_lib_view_submitbtn_js__["a" /* default */].create({
			buttonText: textkeysObj['deposit-payment-method-selected-submitbtn'],
			cb: submitbtnCallback
		});
		viewDepositBtn = viewDepositBtn || __WEBPACK_IMPORTED_MODULE_10__commonview_lib_view_submitbtn_js__["a" /* default */].create({
			buttonText: textkeysObj['deposit-payment-action-submitbtn'],
			cb: depositBtnCb
		});
		viewAmountfee = viewAmountfee || __WEBPACK_IMPORTED_MODULE_3__view_amountfee_js__["a" /* default */].create();
		viewChangeMethodBtn = viewChangeMethodBtn || __WEBPACK_IMPORTED_MODULE_8__view_payment_method_link_js__["a" /* default */].create({
			cb: setupForInputMethod
		});
		viewMethods = viewMethods || __WEBPACK_IMPORTED_MODULE_6__view_methods_js__["a" /* default */].create();
		elements.methodsTitle = elements.methodsTitle || createMethodsTitle(textkeysObj['deposit-inputfieldtitle-selectmethod']);
		elements.wrapmethods.appendChild(elements.methodsTitle);
		elements.wrapmethods.appendChild(viewMethods.wrap);
		elements.wrapChangemethod.appendChild(viewChangeMethodBtn.wrap);
		elements.wrapsubmit.appendChild(elements.wrapChangemethod);
		elements.wrapsubmit.appendChild(viewDepositBtn.wrap);
		elements.wrapsubmit.appendChild(viewConfirmMethodBtn.wrap);
		elements.wrapamountfee.appendChild(viewAmountfee.wrap);
		elements.wrap.appendChild(elements.form);
		elements.assembled = true;
	}
}

function createCurrentForm(p) {
	/* a 'redirect' to implement the selected paymentmethod*/
	var newId = p.newId;
	var paymentMethodsState = p.state;
	var formTemplateCode = paymentMethodsState.paymentmethods.methods.by_id[newId].formTemplateCode;
	// const formTemplateUrl = paymentMethodsState.paymentmethods.formTemplateCode[formTemplateCode];

	var params = {
		wrap: elements.wrapCurrent
	};
	currentMethod = __WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__["a" /* default */].init(newId, formTemplateCode, params);
	if (currentMethod && currentMethod.wrap) {
		elements.wrapCurrent.appendChild(currentMethod.wrap);
	}
	if (currentMethod && currentMethod.update) {
		currentMethod.update(paymentMethodsState);
	} else {
		__WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__["a" /* default */].updateCurrent(paymentMethodsState);
	}
}

function deleteAllElements() {
	/* The object-property must either contain an element or an array with elements*/
	/* The wrapper is not deleted.*/
	viewMethods = viewMethods && viewMethods.close();
	if (__WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__["a" /* default */].close) {
		__WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__["a" /* default */].close();
	}
	viewAmountfee = viewAmountfee && viewAmountfee.close ? viewAmountfee.close() : null;
	viewConfirmMethodBtn = viewConfirmMethodBtn && viewConfirmMethodBtn.close ? viewConfirmMethodBtn.close() : null;
	viewDepositBtn = viewDepositBtn && viewDepositBtn.close ? viewDepositBtn.close() : null;
	viewChangeMethodBtn = viewChangeMethodBtn && viewChangeMethodBtn.close ? viewChangeMethodBtn.close() : null;
	viewAmountInput = viewAmountInput && viewAmountInput.close ? viewAmountInput.close() : null;
	viewAmountselect = viewAmountselect && viewAmountselect.close ? viewAmountselect.close() : null;
	viewCurrencySelect = viewCurrencySelect && viewCurrencySelect.close ? viewCurrencySelect.close() : null;
	__WEBPACK_IMPORTED_MODULE_7__commonview_lib_view_notification_js__["a" /* default */].close();
	if (elements) {
		elements = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, ['wrap', 'textkeys', 'navdeposittitle'], 'view_paymentform:399');
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(p) {
		elements = {};
		elements.wrap = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].getElementIfValid(p, 'wrap', 'view_paymentform:419');
		textkeysObj = __WEBPACK_IMPORTED_MODULE_11__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		// viewCurrencySelect = viewCurrencySelect || viewCurrencySelectCreator.create();
		// elements.form.appendChild(viewCurrencySelect.wrap);
		assembleElements();
		/* 'reset' stage */
		setupForInputMethod();
	},
	update: function update(state) {
		var newId = state.paymentmethods && state.paymentmethods.selected && state.paymentmethods.selected.id;
		var lastMethodError = state.fetch_methoddetails && state.fetch_methoddetails.error;
		var methodName = state.paymentmethods && state.paymentmethods.selected && state.paymentmethods.selected.text;
		var submitPaymentCard = state.submit_payment && state.submit_payment.currentcard && (state.submit_payment.currentcard.card || null);
		var submitPaymentCn = submitPaymentCard && submitPaymentCard.cn;
		var selectlist = void 0;
		assembleElements();

		if (state.paymentmethods) {
			viewMethods.update(state);
			if (newId) {
				/* 'reset' stage */
				setupForInputMethod();
				if (currentMethod && currentMethod.close) {
					currentMethod.close();
				} else {
					__WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__["a" /* default */].closeCurrent();
				}
				createCurrentForm({
					newId: newId,
					methodName: methodName,
					state: state
				});
				setupForInputMethod(newId); // repeated to sync the currencylist display
				// currently the 'viewChangeMethodBtn' can be updated in several ways, from 'update' api with
				// a key tightly connected to this module, or by supplying the 'state' object, and also from the
				// callback attached during initialization with 'view-payment-method-link'. The callback is there
				// to execute something when the button is used, and the update-methods are used to change the
				// text or other content occassionally.

				viewChangeMethodBtn.update({
					view_paymentform: {
						name: methodName || 'methodname:view_paymentform'
					}
				});
				viewAmountInput.update(state);
			}
		}
		/* if the payment method has been used before the current form may be updated.*/
		if (lastMethodError) {
			__WEBPACK_IMPORTED_MODULE_7__commonview_lib_view_notification_js__["a" /* default */].show({
				titleTxt: null,
				mainTxt: textkeysObj['paymentform-error-using-method'] + ' : ' + lastMethodError
			});
		} else if (state.fetch_methoddetails) {
			// replaceAmount(.....find last amount ....)
			/* get current method and update. The modules used are listed in the methodList-array above.*/
			/* details about current selected account is available here */
			if (currentMethod && currentMethod.update) {
				currentMethod.update(state);
			} else {
				__WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__["a" /* default */].updateCurrent(state);
			}
			/* a method that allows currency-shifting is used (skrill, ...)*/
			viewCurrencySelect.update(state);
			viewChangeMethodBtn.update(state);
			viewAmountInput.update(state);
		}
		if (state.fetch_fees_and_limits) {
			viewAmountfee.update(state);
			viewAmountInput.update(state);
			if (__WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__["a" /* default */].displayAmountSelector()) {
				viewAmountselect.update(state);
			}
			limitWithin = state.fetch_fees_and_limits.limitWithin;
			var limitAbove = state.fetch_fees_and_limits.limitAbove;
			var limitBelow = state.fetch_fees_and_limits.limitBelow;
			var limitReached = state.fetch_fees_and_limits.limitReached;
			if (limitAbove || limitBelow || limitReached) {
				viewDepositBtn.disable();
			} else if (limitWithin) {
				viewDepositBtn.enable();
			}
		}
		if (state.submit_payment) {
			/* disable payment on successful payment */
			/* go to method-view if error occurs. */
			if (state.submit_payment.amount) {
				viewAmountInput.update(state);
			}
			if (state.submit_payment.error) {
				setupForInputMethod();
			}
			if (submitPaymentCn) {
				viewChangeMethodBtn.update(state);
			}
			if (currentMethod && currentMethod.update) {
				currentMethod.update(state);
			} else {
				__WEBPACK_IMPORTED_MODULE_2__deposit_form_template_conf_js__["a" /* default */].updateCurrent(state);
			}
		}

		if (state.first_time_uk_deposit) {
			/* Takes care of displaying the set limit link for UK first deposit users */
			viewAmountInput.update(state);
		}
		if (state.fetch_currencies) {
			selectlist = state.fetch_currencies && state.fetch_currencies.selectlist;
			viewCurrencySelect.update({
				selectlist: selectlist
			});
		}
	},
	close: function close() {
		deleteAllElements();
	}
};

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__commonview_lib_view_binaryquestion_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__ = __webpack_require__(2);
/*
view_paymentmessage
*/





var create = __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].create; // creates basic elements not inserted into the dom
var notvalidClass = 'payment__message-not-valid';

var elements = {
	wrap: null,
	subwrap: null,
	message: null,
	title: null
};

function createSubwrap() {
	return create({
		type: 'div',
		class: 'payment__div-wrap-message'
	});
}

function createMessage() {
	return create({
		type: 'p',
		class: 'payment__p-message'
	});
}

function createTitle() {
	return create({
		type: 'p',
		class: 'payment__p-message-title'
	});
}

function assembleElements() {
	/*
 <div>
 	<p>
 	<p>
 </div>
 */
	elements.subwrap = elements.subwrap || createSubwrap();
	elements.message = elements.message || createMessage();
	elements.title = elements.title || createTitle();
	elements.subwrap.appendChild(elements.title);
	elements.subwrap.appendChild(elements.message);
	elements.wrap.appendChild(elements.subwrap);
	elements.assembled = true;
}

function updateContent(p) {
	if (p.title) {
		elements.title.innerHTML = p.title;
	} else {
		console.warn('view_paymentmessage:72:updateContent: can not update title:', p);
	}
	if (p.message) {
		elements.message.innerHTML = p.message;
	} else {
		console.warn('view_paymentmessage:78:updateContent: can not update message:', p);
	}
}

function updateStyle(success) {
	if (!success) {
		__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].addClass(elements.subwrap, notvalidClass);
	} else {
		__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].removeClass(elements.subwrap, notvalidClass);
	}
}

function deleteAllElements() {
	/* The object-property must either contain an element or an array with elements*/
	/* The wrapper is not deleted.*/
	if (elements && elements.assembled) {
		__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys'], 'view_paymentmessage:81');
		elements.assembled = false;
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(p) {
		/* Validate input, store reference to wrapper */
		elements.wrap = __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].getElementIfValid(p, 'wrap', 'view_pending_withdrawals:267');
		if (!elements.assembled) {
			assembleElements();
		}
	},
	update: function update(state) {
		var paymentResultData = null;
		var paymentState = null;
		var providerResultText = null;
		var submitPaymentData = null;

		function emptyFkn() {}

		function doNothing() {}

		if (state.get_payment_result) {
			paymentResultData = state.get_payment_result.paymentResultData;
			paymentState = paymentResultData.state;
			providerResultText = paymentResultData.providerResultText;
			if (paymentState === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].SUCCESS) {
				/* successfulmode is one of:
    * deposit-with-bonus (both money and bonus, not cc)
    * deposit (just money, not cc)
    * no-deposit (just free round bonus, no money, not cc)
    * provider-result (credit card deposit of some kind), and then having providerResultText
    * paymentState may also have the values:
    * constants.CANCELLED
    * constants.PENDING
    */
				__WEBPACK_IMPORTED_MODULE_0__commonview_lib_view_binaryquestion_js__["a" /* default */].showConfirmationMessage('default-success', 'Title', providerResultText, 'OK', emptyFkn);
			}
			updateStyle(paymentState);
			updateContent({
				title: paymentResultData.errorMessage.title,
				message: paymentResultData.errorMessage.message
			});
		}

		if (state.submit_payment) {
			submitPaymentData = state.submit_payment;
			if (!submitPaymentData.success) {
				__WEBPACK_IMPORTED_MODULE_0__commonview_lib_view_binaryquestion_js__["a" /* default */].showConfirmationMessage('default-success', submitPaymentData.title, submitPaymentData.message, 'OK', doNothing);
			}
		}
	},
	close: function close() {
		deleteAllElements();
	}
};

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/*
 view-paysafecard

 paysafecard = {
 "utimestamp": 1458224412998,
 "am": "50",
 "paymentMethodId": ,
 }
 */


var create = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].create;
var classnameShow = 'u-show';
var classnameHide = 'u-hide';
var notvalidClass = 'payment__input_notvalid';

function createFieldsetWrapNumber(eventFilter) {
	var cName = eventFilter + ' payments__fieldset-wrap-number u-relative';
	return create({
		type: 'div',
		class: cName
	});
}

function userInputToSubmitStructure() {
	/* This is the structure required by the depositmethod. To not hardcode keys in earlier steps the values are parsed here. */

	var allvalid = Boolean(true);
	return {
		allvalid: allvalid,
		utimestamp: new Date().getTime(),
		paymentMethodId: 6
	};
}

function _show(elm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameHide);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameShow);
}

function _hide(elm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameHide);
}

function hideElm(elm, yesHideIt) {
	if (yesHideIt) {
		_hide(elm);
	} else {
		_show(elm);
	}
}

function markValid(element, valid) {
	if (valid) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(element, notvalidClass);
	} else {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(element, notvalidClass);
	}
}

function feedbackToCode(inputIsValid, elms) {
	if (inputIsValid) {
		markValid(elms.labelcardnumber, true);
		_hide(elms.cardnumberfeedback);
	} else {
		markValid(elms.labelcardnumber, false);
		hideElm(elms.cardnumberfeedback, false);
	}
}

function markValidAll(uInput, elements) {
	/* depending on validation the inputfields are marked
    with specific classname and messages with feedback are shown */
	var code = uInput && uInput.blik;
	feedbackToCode(code, elements);
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	var eventFilterSelector = '.' + eventFilterSeparatorClassname;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		onEventCb();
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeListener(elm, eventType, handler);
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create() {
		var elements = {};
		var mainEventType = 'input';
		var classNameEventFilter = 'js-eventfilter-viewpaysafecard';
		elements.wrap = elements.wrap || createFieldsetWrapNumber(classNameEventFilter);
		var callbackOnMainEvent = function temp() {};
		var handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);

		return {
			wrap: elements.wrap,
			show: function show() {
				_show(elements.wrap);
			},
			hide: function hide() {
				_hide(elements.wrap);
			},
			update: function update() {},
			evalInput: function evalInput() {
				var uinput = userInputToSubmitStructure(elements);
				markValidAll(uinput, elements);
				uinput = uinput.allvalid ? uinput : null;
				return uinput;
			},
			close: function close() {
				/* hide the spinner if the spinner is closed before hidden.
    Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler, mainEventType);
				elements = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, [], 'view_paysafecard:248');
				return null;
			}
		};
	}
};

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/**
 * Copyright (c) 2017 Comeon. All rights reserved. Company Confidential.
 */




var create = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].create; // creates basic elements not inserted into the dom
var nodetree = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].nodetree; // inserts an array of elements into a document-fragment which later may be inserted into the dom
var classnameShow = 'u-show';
var classnameHide = 'u-hide';
var addNewCardAttr = 'addnewcard';
var textkeysObj = {};
function createSelectMethod(eventFilter) {
	var cName = eventFilter + ' payment__select-skrillaccount';
	return create({
		type: 'select',
		class: cName
	});
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeListener(elm, eventType, handler);
	}
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	/* this handler is a wrapper that filters out values from the target element,
  and then applies the callback-argument on these values */
	var eventFilterSelector = '.' + eventFilterSeparatorClassname;

	function cb(p) {
		p.e.stopPropagation();
		/* get method from the selectbox */
		var selectElm = p.elm;
		var selectedOptionIndex = selectElm.selectedIndex;
		var optionElm = selectElm[selectedOptionIndex];
		var value = optionElm.value;
		var text = optionElm.text;
		onEventCb({
			value: value,
			text: text
		});
		__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewSelectSkrillAccount(value);
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].handle(e, eventFilterSelector, cb, true);
}

function _show(elm) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameHide);
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameShow);
	}
}

function _hide(elm) {
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameHide);
}

function createOptions(objById) {
	var nodes = [];
	var options = {};
	if (objById) {
		Object.keys(objById).forEach(function (key) {
			options[key] = create({
				type: 'option',
				class: 'payment__option-lastused',
				value: objById[key].id
			});
			if (objById[key].selected) {
				options[key].selected = true;
			}
			options[key].innerHTML += objById[key].email;
			nodes.push(options[key]);
		});
	} else {
		console.warn('view_selectskrillaccount:createOptions: can not get last details in object: missing property "by_id"', objById);
	}
	return nodes;
}

function createOptionForAdd(text, addAttribute) {
	var elm = create({
		type: 'option',
		class: 'payment__option-lastused',
		add: 'add',
		value: addAttribute
	});
	if (text) {
		elm.innerHTML = text;
	}
	return elm;
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create(p) {
		textkeysObj = __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		var elements = {};
		var mainEventType = 'change';
		var classNameEventFilter = 'js-eventfilter-viewselectskrillaccount';
		var callbackOnMainEvent = p.callbackonmainevent || function temp() {};
		elements.wrap = elements.wrap || createSelectMethod(classNameEventFilter);
		var handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);
		return {
			wrap: elements.wrap,
			show: function show() {
				_show(elements.wrap);
			},
			hide: function hide() {
				_hide(elements.wrap);
			},
			update: function update(state) {
				var accounts = state.fetch_methoddetails && state.fetch_methoddetails.accounts;
				var accountByIdList = accounts && accounts.by_id;
				var lastUsedAccountIdx = state.fetch_methoddetails.lastUsedAccountIdx;
				if (accountByIdList && !elements.options) {
					elements.options = createOptions(accountByIdList);
					elements.options.push(createOptionForAdd(textkeysObj['skrill-account-dropdown-add-account-placeholder'], addNewCardAttr));
					elements.wrap.appendChild(nodetree(elements.options));
				} else if (lastUsedAccountIdx) {
					elements.options[lastUsedAccountIdx].selected = true;
				}
			},
			close: function close() {
				/* hide the spinner if the spinner is closed before hidden.
     Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler, mainEventType);
				elements = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, [], 'view_selectskirllaccount:139');
			}
		};
	}
};

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__payment_lib_view_selectskrillaccount_js__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__ = __webpack_require__(14);




var _create = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].create;
var classnameShow = 'u-show';
var classnameHide = 'u-hide';
var notvalidClass = 'input-wrap__error';
var paymentMethodId = null;
var textkeysObj = {};
var elements = {
	wrapSkrillAccount: null,
	wrapSkrillEmail: null,
	viewSelectSkrillAccount: null,
	wrap: null
};
var userInput = {
	allvalid: false
};

function createDiv(className) {
	return _create({
		type: 'div',
		class: className
	});
}

function createLabel(className) {
	return _create({
		type: 'label',
		class: className
	});
}

function createSmall(txt) {
	var elm = _create({
		type: 'small',
		class: 'input-wrap__error-display payment__feedback grid-u-sm-1 u-hide'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createLegend(txt) {
	var elm = _create({
		type: 'legend',
		class: 'legend'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createInputCode(placeholder, inputType) {
	return _create({
		type: 'input',
		class: 'js-payment__input-skrill-email payment__input-skrill-email input-wrap__input',
		name: 'code',
		'input-type': inputType,
		placeholder: placeholder
	});
}

function _show(elm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameHide);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameShow);
}

function _hide(elm) {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(elm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(elm, classnameHide);
}

function selectExistingAccount() {
	//hide feedback errors on change of dropdown
	_hide(elements.emailFeedBack);
	markValid(elements.emailInput, true);
	var selectAccountElement = getSelectedOption(elements.viewSelectSkrillAccount.wrap);
	if (selectAccountElement.getAttribute('add')) {
		elements.emailInput.focus();
		elements.emailInput.placeholder = textkeysObj['skrill-email-placeholder'];
		elements.emailInput.value = '';
	} else {
		setInputValues(selectAccountElement);
	}
}

function setInputValues(p) {
	elements.emailInput.placeholder = p.text;
	elements.emailInput.value = p.text;
}

function getSelectedOption(selectElement) {
	var index = Boolean(selectElement && selectElement.options && (selectElement.selectedIndex || selectElement.selectedIndex === '0' || selectElement.selectedIndex === 0));
	var elm = index ? selectElement.options[selectElement.selectedIndex] : null;
	return elm;
}

function getFormInput() {
	var em = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].trailspace(elements.emailInput.value || null);
	return { em: em, paymentMethodId: paymentMethodId };
}

function isValidEmail(email) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

function changeHandler(e) {
	var cb = function change(p) {
		p.e.preventDefault();
		p.e.stopPropagation();
		var skrillAccountOptions = elements.viewSelectSkrillAccount.wrap.options;
		if (p.elm === elements.emailInput) {
			if (elements.emailInput.value === '' && skrillAccountOptions.length > 0 && elements.emailInput.placeholder === skrillAccountOptions[skrillAccountOptions.selectedIndex].text) {
				elements.emailInput.value = elements.emailInput.placeholder;
				markValid(elements.emailInput, true);
				_hide(elements.emailFeedBack);
			} else if (isValidEmail(elements.emailInput.value)) {
				markValid(elements.emailInput, true);
				_hide(elements.emailFeedBack);
			} else {
				markValid(elements.emailInput, false);
				_show(elements.emailFeedBack);
			}
		}
	};
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked*/
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].handle(e, '.js-payment__input-skrill-email', cb, true);
}

function addListeners() {
	__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addListener(elements.wrap, 'change', changeHandler);
}

function markValid(element, valid) {
	if (valid) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].removeClass(element, notvalidClass);
	} else {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].addClass(element, notvalidClass);
	}
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create() {
		textkeysObj = __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		elements.viewSelectSkrillAccount = __WEBPACK_IMPORTED_MODULE_1__payment_lib_view_selectskrillaccount_js__["a" /* default */].create({
			callbackonmainevent: selectExistingAccount
		});
		elements.wrap = elements.wrap || _create('div', 'payments-wrap-skrill');
		elements.wrapSkrillAccount = elements.wrapSkrillAccount || createDiv('js-payments__fieldset-wrap-skrill-account payments__fieldset-wrap-skrill-account custom-select u-relative u-mb2');
		elements.wrapSkrillEmail = elements.wrapSkrillEmail || createDiv('js-payments__fieldset-wrap-skrill-email payments__fieldset-wrap-skrill-email input-wrap u-relative u-mb2');

		//create Account Section
		elements.accountLabel = elements.accountLabel || createLabel('payment__label-cn-accountLabel');
		elements.accountTitle = elements.accountTitle || createLegend(textkeysObj['skrill-select-account']);
		elements.accountLabel.appendChild(elements.accountTitle);
		elements.accountLabel.appendChild(elements.viewSelectSkrillAccount.wrap);
		elements.wrapSkrillAccount.appendChild(elements.accountLabel);

		//create email Section
		elements.emailLabel = elements.emailLabel || createLabel('payment__label-cn-emailLabel');
		elements.emailTitle = elements.emailTitle || createLegend(textkeysObj['skrill-enter-email']);
		elements.emailInput = elements.emailInput || createInputCode(textkeysObj['skrill-email-placeholder'], 'email');
		elements.emailFeedBack = elements.emailFeedBack || createSmall(textkeysObj['skrill-email-validation-error-feedback']);
		elements.emailLabel.appendChild(elements.emailTitle);
		elements.emailLabel.appendChild(elements.emailInput);
		elements.emailLabel.appendChild(elements.emailFeedBack);
		elements.wrapSkrillEmail.appendChild(elements.emailLabel);

		elements.wrap.appendChild(elements.wrapSkrillAccount);
		elements.wrap.appendChild(elements.wrapSkrillEmail);
		addListeners();

		return {
			wrap: elements.wrap,
			show: function show() {
				_show(elements.wrap);
			},
			hide: function hide() {
				_hide(elements.wrap);
			},
			update: function update(state) {
				if (state.paymentmethods && state.paymentmethods.selected) {
					paymentMethodId = state.paymentmethods.selected.id;
				}
				var skrillAccountDataExists = Boolean(state && state.fetch_methoddetails && Array.isArray(state.fetch_methoddetails.accounts) && state.fetch_methoddetails.accounts.length > 0);
				if (state && state.fetch_methoddetails) {
					/* if there are accounts saved then populate and show skrill account. */
					if (skrillAccountDataExists) {
						_show(elements.wrapSkrillAccount);
						elements.viewSelectSkrillAccount.update(state);
						setInputValues(getSelectedOption(elements.viewSelectSkrillAccount.wrap));
					}
				} else if (!state.submit_payment) {
					_hide(elements.wrapSkrillAccount);
				}
			},
			evalInput: function evalInput() {
				var formInput = getFormInput();
				var finalInput = null;
				if (!isValidEmail(formInput.em)) {
					markValid(elements.emailInput, false);
					_show(elements.emailFeedBack);
					userInput.allvalid = false;
					return null;
				}
				finalInput = formInput;
				return finalInput;
			},
			close: function close() {
				/* hide the spinner if the spinner is closed before hidden.
     Otherwise the '.dim' element will remain on the parent */
				//removeListeners(elements.wrap, handler, mainEventType);
				elements = __WEBPACK_IMPORTED_MODULE_0__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, [], 'view_skrill:219');
				return null;
			}
		};
	}
};

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_inputpopup_js__ = __webpack_require__(385);
/*
view_ukFirstTimeDepositLink
*/






var create = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].create; // creates basic elements not inserted into the dom
var classnameShow = 'u-show';
var classnameHide = 'u-hide';
var textkeysObj = void 0;
var viewInputPopup = void 0;

function createWrap(eventFilter) {
	var cName = eventFilter + ' set-limit-wrap ukfirsttimedepositlink';
	return create({
		type: 'div',
		// class: 'set-limit-wrap'
		class: cName
	});
}

function createLink(txt) {
	var elm = create({
		type: 'a',
		class: 'set-limit-link',
		name: 'set-limit-link'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	var eventFilterSelector = '.' + eventFilterSeparatorClassname;

	function cb(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		viewInputPopup.show();
		onEventCb();
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeListener(elm, eventType, handler);
	}
}

function _show(elm) {
	if (elm) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameHide);
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameShow);
	}
}

function _hide(elm) {
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeClass(elm, classnameShow);
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elm, classnameHide);
}

/* harmony default export */ __webpack_exports__["a"] = {
	create: function create() {
		var elements = {};
		var classNameEventFilter = 'js-eventfilter-ukfirsttimedepositlink';
		var mainEventType = 'click';
		textkeysObj = __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		elements.wrap = elements.wrap || createWrap(classNameEventFilter);
		elements.link = elements.link || createLink(textkeysObj['set-limit-link']);
		elements.wrap.appendChild(elements.link);
		var callbackOnMainEvent = function temp() {};
		var handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);

		function confirmCb(value) {
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewUkFirstTimeDepositLink(value);
			// viewInputPopup = viewInputPopup.close();
			viewInputPopup.hide();
		}

		function rejectCb() {
			viewInputPopup.hide();
		}
		viewInputPopup = viewInputPopup || __WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_inputpopup_js__["a" /* default */].create({
			confirmCb: confirmCb,
			rejectCb: rejectCb
		});
		return {
			wrap: elements.wrap,
			show: function show() {
				_show(elements.wrap);
			},
			hide: function hide() {
				_hide(elements.wrap);
			},
			update: function update() {},
			close: function close() {
				removeListeners(elements.wrap, handler, mainEventType);
				elements = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, [], 'view_ukFirstTimeDepositLink:81');
				if (viewInputPopup && viewInputPopup.close) {
					viewInputPopup.close();
					viewInputPopup = null;
				}
			}
		};
	}
};

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__view_js__ = __webpack_require__(140);
/**
 * payment/fetch-cancel-withdraw.js
 */






// const view = {
// 	update() {}
// };

var state = {
	success: null,
	locked: null,
	withdrawId: null
};
var register = __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__["a" /* default */].register;

var requestUrl = void 0;

function viewUpdate() {
	__WEBPACK_IMPORTED_MODULE_4__view_js__["a" /* default */].update({
		fetch_cancel_withdraw: state
	});
}

function parseToState(data) {
	var dataStatusFailure = Boolean(data && data.status) && data.status.toLowerCase && data.status.toLowerCase() === 'failure';
	var dataStatusSuccess = Boolean(data && data.status) && data.status.toLowerCase && data.status.toLowerCase() === 'success';
	state.failure = dataStatusFailure;
	state.success = dataStatusSuccess;
	/* dev: temp setting failure to test succesful ajax response with status.FAILURE */
	// state.failure = true;
	// state.success = !state.failure;
	/* dev: end */
	viewUpdate();
	if (state.success) {
		__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].fetchCancelWithdraw(state);
	}
}

function getDataAndReplaceState(id) {
	/* non-dev*/
	var url = requestUrl + id;
	/* non-dev:end */
	/* dev: temp setting to simulate connection error. Comment away the previous line: url = requestUrl + id */
	// const url = (`${requestUrl + id}tempFailProvoce`);
	/* dev: end */
	state.failure = false; /* this is the flag for a successful response with a status of failure */
	state.success = false; /* this is the flag for a successful response with a status of success */
	state.error = null; /* this is the message for connection errors (example http-responses 404) */
	parseToState(null);
	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].get(url, function (data) {
		parseToState(data);
	}, function (err) {
		state.error = err; /* this is a failure with connection error */
		viewUpdate();
		console.error('fetch_cancel_withdraw:getDataAndReplaceState:55:error:', err);
	});
}

function registerActions() {
	function fetchCancelWithdraw(payload) {
		var definedData = Boolean(payload.data && typeof payload.data !== 'undefined' && payload.data !== 'undefined');
		/* sometimes 'undefined' is returned which evaluates to true beacuse it is a string and not the global */
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_PENDING_WITHDRAWALS) {
			if (definedData) {
				state.withdrawId = payload.data || -1;
				getDataAndReplaceState(state.withdrawId);
			} else {
				console.error('fetch_cancel_withdraw:error no withdraw-id');
			}
		}
	}
	register(fetchCancelWithdraw);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(url) {
		if (url) {
			requestUrl = url;
		} else {
			console.error('fetch_pending_withdrawals:59:init: no url provided', url);
		}
		registerActions();
	}
};

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__ = __webpack_require__(20);
/**
 * payment/pendingWithdrawals/fetch-pending-withdrawals.js
 */





var register = __WEBPACK_IMPORTED_MODULE_3__common_lib_dataflow_js__["a" /* default */].register;
var state = {
	/* list of pending withdrawals*/
};
var requestUrl = null;
var callbackIfEmpty = null;

function parseToState(data) {
	var arrayHasContent = Boolean(Array.isArray(data) && data.length > 0);
	if (arrayHasContent) {
		state.by_id = {};
		data.forEach(function (elm) {
			if (elm.id || elm.id === 0) {
				state.by_id[elm.id] = elm;
			}
		});
	}
	state.empty = !arrayHasContent;
	return arrayHasContent;
}

function getDataAndReplaceState() {
	/* parse and get feedback if exists or not
  * Make the received data accessible to the other modules
  * Execute callback to skip pending withdraw step if no pending withdraws */
	function successHandler(data) {
		var pendingExist = parseToState(data);
		__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].fetchPendingWithdrawals(state);
		if (!pendingExist) {
			//Removing the delay to handle seamless transition to further steps
			callbackIfEmpty();
		}
	}

	function errorHandler(err) {
		console.error('fetch_pending_withdrawals:error:', err);
		callbackIfEmpty();
	}

	__WEBPACK_IMPORTED_MODULE_2__common_lib_core_js__["a" /* default */].get(requestUrl, successHandler, errorHandler);
}

function registerActions() {
	function fetchPendingWithdrawals(payload) {
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].SETUP_PENDING_WITHDRAWALS) {
			getDataAndReplaceState();
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].FETCH_CANCEL_WITHDRAW) {
			getDataAndReplaceState();
		}
	}
	register(fetchPendingWithdrawals);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(url, isEmptyCallback) {
		requestUrl = url || null;
		callbackIfEmpty = typeof isEmptyCallback === 'function' ? isEmptyCallback : function doNothing() {};
		registerActions();
	}
};

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_lib_dataflow_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__view_js__ = __webpack_require__(140);
/*
pending withdrawals.js

This module state contains a list of withdrawals data sorted on id.
Whenever an action is received with an id, the selected is set to this id, and
then the view is updated.

*/






var register = __WEBPACK_IMPORTED_MODULE_2__common_lib_dataflow_js__["a" /* default */].register;

var state = {
	selected: {
		id: -1
	},
	empty: false,
	by_id: null
};

function withdrawalsExists() {
	var exists = false;
	if (state.by_id) {
		Object.keys(state.by_id).forEach(function (key) {
			if (state.by_id[key]) {
				exists = true;
			}
		});
	}
	return exists;
}

function viewUpdate() {
	var exists = withdrawalsExists();
	state.empty = !exists;
	__WEBPACK_IMPORTED_MODULE_3__view_js__["a" /* default */].update({
		pending_withdrawals: state
	});
}

function deleteIfSuccessful(data) {
	var withdrawId = null;
	if (data.success) {
		withdrawId = data.withdrawId;
		if (state.by_id && state.by_id[withdrawId]) {
			state.by_id[withdrawId] = null;
		} else {
			console.warn('pending_withdrawals:deleteIfSuccesful: can not delete:', withdrawId);
		}
		viewUpdate();
	} else {
		console.error('pending_withdrawals:119:deleteIfSuccesful: can not delete', data);
	}
}

function parseToState(data) {
	// the entire state can not be replaced. The by_id sorting and selected key will be deleted. TODO: state.by_id = ...
	state.by_id = data && data.by_id || null;
	viewUpdate();
	__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].pendingWithdrawals(state);
}

function registerActions() {
	function pendingWithdrawals(payload) {
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].FETCH_PENDING_WITHDRAWALS) {
			parseToState(payload.data);
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].FETCH_CANCEL_WITHDRAW) {
			deleteIfSuccessful(payload.data);
		}
		if (payload.type === __WEBPACK_IMPORTED_MODULE_1__common_lib_utils_constants_js__["a" /* default */].VIEW_NAV) {
			state.selected.id = -1;
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].pendingWithdrawals(state);
			viewUpdate();
		}
	}
	register(pendingWithdrawals);
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init() {
		registerActions();
	}
};

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_confirmationmessage_js__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_notification_js__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commonview_lib_view_binaryquestion_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commonview_lib_view_textkeys_js__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_currency_formatter_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__libs_locale_js__ = __webpack_require__(31);
/**
 * view_pending-withdrawals.js
 */










var textkeysObj = {};
var elements = {
	assembled: false
};
var selectors = {};
var nodetree = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].nodetree;
var create = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].create;

function createSvgIcon() {
	return create({
		type: 'svg',
		viewBox: '0 0 24 24',
		class: 'notify__svg-icon u-dib'
	});
}

function createPathForIcon() {
	return create({
		type: 'path',
		d: 'M17.625,10.4698337 C14.6364661,10.4781294 12.2205035,12.9075358 12.2287915,15.8960698 C12.2370796,18.8846037 14.6664798,21.3005725 17.6550137,21.2922921 C20.6435477,21.2840117 23.0595227,18.8546177 23.05125,15.8660837 C23.0472773,14.4309293 22.4733515,13.0561338 21.455731,12.0441395 C20.4381106,11.0321451 19.0601544,10.46585 17.625,10.4698337 L17.625,10.4698337 Z M17.625,20.5423337 C15.0545867,20.5340487 12.9760152,18.446525 12.9787769,15.8760999 C12.9815386,13.3056748 15.064591,11.2226223 17.6350161,11.2198606 C20.2054413,11.217099 22.292965,13.2956705 22.30125,15.8660837 C22.3052515,17.1075247 21.8138616,18.2992735 20.9360257,19.1771094 C20.0581898,20.0549453 18.866441,20.5463352 17.625,20.5423337 Z M16.44,22.2410837 C16.3357285,22.0499305 16.0999132,21.9740739 15.90375,22.0685837 C15.1346762,22.4189089 14.3282397,22.6805919 13.5,22.8485837 C11.3289858,23.2826695 9.0935142,23.2826695 6.9225,22.8485837 C5.95970531,22.6586873 5.02734516,22.338228 4.15125,21.8960837 C3.48523404,21.5802166 2.88670982,21.1383274 2.38875,20.5948337 C2.00583983,20.1874314 1.78568281,19.6537174 1.77,19.0948337 L1.77,16.6160837 C2.02399186,16.9170384 2.31076539,17.1887186 2.625,17.4260837 C2.9782739,17.6897617 3.35482931,17.9207157 3.75,18.1160837 C4.68682121,18.5885097 5.68341162,18.9316396 6.7125,19.1360837 C7.85735095,19.3721519 9.02357129,19.4890253 10.1925,19.4848337 C10.6325,19.4848337 11.06625,19.4685837 11.49375,19.4360837 C11.7161518,19.4200739 11.8837777,19.2273041 11.86875,19.0048337 C11.8527401,18.7824319 11.6599703,18.614806 11.4375,18.6298337 C11.035,18.6598337 10.62375,18.6748337 10.20375,18.6748337 C9.09920056,18.6794064 7.99712315,18.5700783 6.915,18.3485837 C5.94539997,18.1579554 5.00661069,17.8349311 4.125,17.3885837 C3.45898404,17.0727166 2.86045982,16.6308274 2.3625,16.0873337 C1.97958983,15.6799314 1.75943281,15.1462174 1.74375,14.5873337 C1.76685624,13.9823219 2.01884023,13.4086562 2.44875,12.9823337 C3.00790056,12.3996431 3.68047072,11.9376499 4.425,11.6248337 C4.52539771,11.5842186 4.60333341,11.502181 4.63875,11.3998337 C4.68001369,11.2988878 4.68001369,11.1857797 4.63875,11.0848337 C4.59095793,10.992151 4.51093753,10.9201326 4.41375,10.8823337 C4.31384035,10.8360958 4.19865965,10.8360958 4.09875,10.8823337 C3.65163376,11.0949227 3.22378296,11.3458616 2.82,11.6323337 C2.47063612,11.8783239 2.15320271,12.1667852 1.875,12.4910837 C1.59777499,12.7822738 1.36979427,13.1166455 1.2,13.4810837 C1.05207203,13.8097224 0.968076086,14.1635234 0.9525,14.5235837 L0.9525,19.0873337 C0.970963861,19.7985819 1.23609454,20.4812934 1.7025,21.0185837 C2.261039,21.6933025 2.95969954,22.2384113 3.75,22.6160837 C4.68682121,23.0885097 5.68341162,23.4316396 6.7125,23.6360837 C9.00807386,24.0997201 11.3731761,24.0997201 13.66875,23.6360837 C14.5589429,23.4562827 15.4257737,23.1757265 16.2525,22.7998337 C16.4530376,22.7021773 16.5368648,22.4607549 16.44,22.2598337 L16.44,22.2410837 Z M9.91875,13.9235837 C9.9605304,13.9664304 10.0101888,14.0008093 10.065,14.0248337 C10.1573077,14.0698337 10.2651923,14.0698337 10.3575,14.0248337 C10.4123112,14.0008093 10.4619696,13.9664304 10.50375,13.9235837 L15.70875,8.71858374 C15.860195,8.56166452 15.860195,8.31300296 15.70875,8.15608374 C15.6414752,8.06932305 15.5372732,8.01930606 15.4275,8.02108374 C15.3119934,8.02239828 15.2021271,8.07122773 15.12375,8.15608374 L10.62375,12.6560837 L10.62375,2.90608374 C10.6278628,2.79506662 10.58254,2.68794008 10.5,2.61358374 C10.3430808,2.46213875 10.0944192,2.46213875 9.9375,2.61358374 C9.85496001,2.68794008 9.80963724,2.79506662 9.81375,2.90608374 L9.81375,12.6560837 L5.31375,8.15608374 C5.2353729,8.07122773 5.12550664,8.02239828 5.01,8.02108374 C4.90022682,8.01930606 4.79602476,8.06932305 4.72875,8.15608374 C4.57730502,8.31300296 4.57730502,8.56166452 4.72875,8.71858374 L9.91875,13.9235837 Z M20.17875,16.5973337 C20.574324,16.5973337 20.895,16.2766577 20.895,15.8810837 C20.895,15.4855098 20.574324,15.1648337 20.17875,15.1648337 C19.783176,15.1648337 19.4625,15.4855098 19.4625,15.8810837 C19.4625,16.2766577 19.783176,16.5973337 20.17875,16.5973337 Z M17.64,16.5973337 C18.035574,16.5973337 18.35625,16.2766577 18.35625,15.8810837 C18.35625,15.4855098 18.035574,15.1648337 17.64,15.1648337 C17.244426,15.1648337 16.92375,15.4855098 16.92375,15.8810837 C16.92375,16.2766577 17.244426,16.5973337 17.64,16.5973337 Z M15.0975,16.5973337 C15.493074,16.5973337 15.81375,16.2766577 15.81375,15.8810837 C15.81375,15.4855098 15.493074,15.1648337 15.0975,15.1648337 C14.701926,15.1648337 14.38125,15.4855098 14.38125,15.8810837 C14.38125,16.2766577 14.701926,16.5973337 15.0975,16.5973337 Z' // eslint-disable-line max-len
	});
}

function createDiv(classname) {
	return create({
		type: 'div',
		class: classname
	});
}

function createMainTitle(txt) {
	var elm = create({
		type: 'h2',
		class: 'notify__main-title'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createSupportTitle(txt) {
	var elm = create({
		type: 'p',
		class: 'notify__p'
	});
	if (txt) {
		elm.innerHTML = txt;
	}
	return elm;
}

function createPendingWithdrawal(p) {
	var paymentMethod = p.descr;
	var withdrawAmount = p.amount;
	var transactionDate = p.date;
	var withdrawId = p.withdrawId;
	var pendingWithdrawalWrapper = create({
		type: 'div',
		class: 'js-withdraw-event-filter pending-withdrawal u-mb2 u-pb1',
		withdrawid: withdrawId
	});
	var wrapDateIconSpinner = createDiv('pending-withdrawal__row');
	var wrapMethodAmount = createDiv('pending-withdrawal__row');
	var wrapIconSpinner = create({
		type: 'a',
		href: '#',
		class: 'js-cancel-withdraw-btn pending-withdrawal__action u-relative'
	});
	var date = create({
		type: 'small',
		class: 'pending-withdrawal__date'
	});
	var method = createDiv('pending-withdrawal__method');
	var svgIcon = create({
		type: 'svg',
		viewBox: '0 0 24 24',
		class: 'pending-withdrawal__cancel-icon'
	});
	var path = create({
		type: 'path',
		d: 'M12.5,21.772 C11.260608,21.7787885 10.0330797,21.5304372 8.8938,21.0424 C4.82651877,19.3248259 2.53256526,14.9793985 3.40878116,10.6521496 C4.28499707,6.3249007 8.08873066,3.21418162 12.5038,3.21418162 C16.9188693,3.21418162 20.7226029,6.3249007 21.5988188,10.6521496 C22.4750347,14.9793985 20.1810812,19.3248259 16.1138,21.0424 C14.9721701,21.5314607 13.7419492,21.7798334 12.5,21.772 L12.5,21.772 Z M12.5,4.026 C11.3703174,4.01984926 10.2514516,4.24620939 9.213,4.691 C6.06950445,6.01349438 4.02510973,9.09153995 4.02510973,12.5019 C4.02510973,15.91226 6.06950445,18.9903056 9.213,20.3128 C11.3158939,21.1997941 13.6879061,21.1997941 15.7908,20.3128 C18.9342955,18.9903056 20.9786903,15.91226 20.9786903,12.5019 C20.9786903,9.09153995 18.9342955,6.01349438 15.7908,4.691 C14.7511732,4.24569798 13.6309612,4.01932719 12.5,4.026 L12.5,4.026 Z M17.1284,17.155 C17.28387,16.9968038 17.28387,16.7431962 17.1284,16.585 L13.0472,12.5 L17.1246,8.4188 C17.28007,8.26060383 17.28007,8.00699617 17.1246,7.8488 C16.9664038,7.69333002 16.7127962,7.69333002 16.5546,7.8488 L12.4772,11.93 L8.396,7.8526 C8.23780383,7.69713002 7.98419617,7.69713002 7.826,7.8526 C7.67053002,8.01079617 7.67053002,8.26440383 7.826,8.4226 L11.9072,12.5 L7.8298,16.5812 C7.67433002,16.7393962 7.67433002,16.9930038 7.8298,17.1512 C7.98799617,17.30667 8.24160383,17.30667 8.3998,17.1512 L12.4772,13.07 L16.5584,17.1474 C16.714515,17.3049985 16.9681386,17.3083802 17.1284,17.155 L17.1284,17.155 Z' // eslint-disable-line max-len
	});
	var amount = create({
		type: 'span',
		class: 'pending-withdrawal__amount'
	});
	var cancelBtn = create({
		type: 'btn',
		class: 'js-cancel-withdraw-btn'
	});
	method.innerHTML = paymentMethod;
	amount.innerHTML = withdrawAmount;
	date.innerHTML = transactionDate;
	cancelBtn.innerHTML = textkeysObj['cancel-link'] || 'cancel-link-textkey';

	svgIcon.appendChild(path);
	// wrapIconSpinner.appendChild(date);
	wrapDateIconSpinner.appendChild(date);
	wrapIconSpinner.appendChild(svgIcon);
	wrapMethodAmount.appendChild(method);
	wrapMethodAmount.appendChild(amount);
	wrapDateIconSpinner.appendChild(wrapIconSpinner);
	pendingWithdrawalWrapper.appendChild(wrapDateIconSpinner);
	pendingWithdrawalWrapper.appendChild(wrapMethodAmount);
	return pendingWithdrawalWrapper;
}

function clickCancelWithdrawHandler(e) {
	function cancelHandler(p) {
		p.e.stopPropagation();
		p.e.preventDefault();
		var withdrawId = p.elm.getAttribute('withdrawid');
		var offerTextkey = textkeysObj['confirmation-message-pending-withdraw'] || 'confirmation-message-pending-withdraw-textkey-missing';
		var acceptTextkey = textkeysObj['confirmation-message-pending-withdraw-yes'] || 'confirmation-message-pending-withdraw-yes-textkey-missing';
		var denyTextkey = textkeysObj['confirmation-message-pending-withdraw-no'] || 'confirmation-message-pending-withdraw-no-textkey-missing';

		function ifUserConfirm() {
			__WEBPACK_IMPORTED_MODULE_0__common_lib_utils_actions_js__["a" /* default */].viewPendingWithdrawals(withdrawId);
		}
		__WEBPACK_IMPORTED_MODULE_4__commonview_lib_view_binaryquestion_js__["a" /* default */].show(offerTextkey, acceptTextkey, denyTextkey, ifUserConfirm);
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked*/
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].handle(e, '.js-withdraw-event-filter', cancelHandler, true);
}

function addListeners() {
	__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addListener(elements.wrap, 'click', clickCancelWithdrawHandler);
}

function removeListeners() {
	/* the core.removeListener-method allows the method to be used also if the elements.wrap is not there or the handler which prevents errors thrown. */
	if (elements && elements.wrap) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].removeListener(elements.wrap, 'click', clickCancelWithdrawHandler);
	}
}

function getSupportTitle() {
	if (elements.origin) {
		if (elements.origin === 'account') {
			return elements.supportTitle || createSupportTitle(textkeysObj['deposit-pendingwithdrawals-support-title-account']);
		} else if (elements.origin === 'deposit') {
			return elements.supportTitle || createSupportTitle(textkeysObj['deposit-pendingwithdrawals-support-title-deposit']);
		} else if (elements.origin === 'withdraw') {
			return elements.supportTitle || createSupportTitle(textkeysObj['deposit-pendingwithdrawals-support-title-withdraw']);
		}
	}
	return elements.supportTitle || createSupportTitle(textkeysObj['deposit-pendingwithdrawals-support-title-account']);
}
function assembleStaticElements() {
	elements.staticWrap = createDiv('payment__content-wrapper');
	elements.dynamicWrap = createDiv('pendingwithrawals__wrapdynamic');
	elements.svg = elements.svg || createSvgIcon();
	elements.path = elements.path || createPathForIcon();
	elements.staticWrapSub = createDiv('notify__head u-pl2 u-pr2 u-text-c');
	elements.staticWrapIcon = createDiv('notify__icon-wrapper u-text-c');
	elements.mainTitle = elements.mainTitle || createMainTitle(textkeysObj['deposit-pendingwithdrawals-title']);
	elements.supportTitle = getSupportTitle();
	elements.svg.appendChild(elements.path);
	elements.staticWrapIcon.appendChild(elements.svg);
	elements.staticWrapSub.appendChild(elements.staticWrapIcon);
	elements.staticWrapSub.appendChild(elements.mainTitle);
	elements.staticWrapSub.appendChild(elements.supportTitle);
	elements.staticWrap.appendChild(elements.staticWrapSub);
	elements.wrap.appendChild(elements.staticWrap);
	elements.staticWrap.appendChild(elements.dynamicWrap);
	elements.assembledStatic = true;
}

function assembleDynamicElements(withrawalsObj) {
	var pendingWithdrawalElements = [];
	var isAlreadyDisplayed = void 0;
	var wObjKey = void 0;
	var descr = void 0;
	var amount = void 0;
	var date = void 0;
	var withdrawId = void 0;
	var hasWithdrawFormat = void 0;

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__core_ajax_json_js__["a" /* fetchJson */])('/player/currency').then(function (response) {
		if (withrawalsObj) {
			elements.pendingwithdrawals_byid = elements.pendingwithdrawals_byid || {};
			Object.keys(withrawalsObj).forEach(function (key) {
				isAlreadyDisplayed = Boolean(elements.pendingwithdrawals_byid[key]);
				wObjKey = withrawalsObj[key];
				date = wObjKey && wObjKey.time;
				descr = wObjKey && wObjKey.paymentMethodDescr;
				withdrawId = wObjKey && wObjKey.id && wObjKey.id !== 'undefined' ? wObjKey.id : null;
				var formattedAmount = __WEBPACK_IMPORTED_MODULE_7__libs_currency_formatter_js__["a" /* default */].format(wObjKey && wObjKey.amount, response.result, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__libs_locale_js__["a" /* getLocale */])());
				amount = formattedAmount;
				hasWithdrawFormat = Boolean(amount && date && descr && withdrawId);
				/* a withdrawId of 0 or the string version of undefined are not accepted
     replace string versions of undefined in the module that created the state-object instead */
				if (isAlreadyDisplayed) {
					/* remove inactive and already displayed withdrawal */
					elements.pendingwithdrawals_byid[key] = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].deleteElement(elements.pendingwithdrawals_byid[key], 'view_pending_withdrawals:removeInactiveWithdrawals');
				} else if (hasWithdrawFormat) {
					var temp = createPendingWithdrawal({
						amount: amount,
						date: date,
						descr: descr,
						withdrawId: withdrawId
					});
					pendingWithdrawalElements.push(temp);
					/* store a reference to the withdrawal */
					elements.pendingwithdrawals_byid[key] = temp;
				}
			});

			pendingWithdrawalElements = nodetree(pendingWithdrawalElements);
			elements.dynamicWrap.appendChild(pendingWithdrawalElements);
			elements.assembledDynamic = true;
		}
	});
}

function markWithWarnClass(id) {
	var isDisplayed = id && elements && elements.pendingwithdrawals_byid && elements.pendingwithdrawals_byid[id];
	if (isDisplayed) {
		__WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].addClass(elements.pendingwithdrawals_byid[id], 'failed_to_execute');
	}
}

function deleteAllElements() {
	/* The object-property must either contain an element or an array with elements*/
	/* The wrapper is not deleted.*/
	elements = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].deleteElementsInObjectExcept(elements, ['wrap', 'before', 'textkeys'], 'view_pending_withdrawals:271');
}

/* harmony default export */ __webpack_exports__["a"] = {
	init: function init(p) {
		/* clean the area if necessary after skipping back and forth in the depositflow */
		deleteAllElements();
		elements = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].selectElements(selectors, 'pendingwithdrawals:view_pending_withdrawals:265');
		/* add the wrapping element to elements-object */
		elements.wrap = __WEBPACK_IMPORTED_MODULE_1__common_lib_core_js__["a" /* default */].getElementIfValid(p, 'wrap', 'view_pending_withdrawals:267');
		elements.origin = p.origin;
		textkeysObj = __WEBPACK_IMPORTED_MODULE_5__commonview_lib_view_textkeys_js__["a" /* default */].depositflow();
		assembleStaticElements();
		addListeners();
	},
	update: function update(state) {
		var statePendingById = state && state.pending_withdrawals && state.pending_withdrawals.by_id;
		var failure = state && state.fetch_cancel_withdraw && state.fetch_cancel_withdraw.failure;
		var errMsg = state && state.fetch_cancel_withdraw && state.fetch_cancel_withdraw.error;
		var failTitle = void 0;
		var failText = void 0;
		var failBtn = void 0;

		var withdrawId = null;
		if (state && state.pending_withdrawals) {
			if (state.pending_withdrawals.empty) {
				deleteAllElements();
				elements.mainTitle = createMainTitle(textkeysObj['deposit-pendingwithdrawals-empty-title']);
				elements.supportTitle = createSupportTitle(textkeysObj['deposit-pendingwithdrawals-empty-support-title']);
				assembleStaticElements();
			}

			if (elements.assembledStatic) {
				/* if a pending withdrawal shall be removed from the current list, the state is updated from 'pending_withdrawals'-module and not 'fetch_cancel_withdraw'
    because the 'pending_withdrawals'-module shall maintain the complete current state of the list of pending withdrawals.
    */
				assembleDynamicElements(statePendingById);
			} else {
				assembleStaticElements();
				assembleDynamicElements(statePendingById);
			}
		}

		if (state && state.fetch_cancel_withdraw) {
			withdrawId = state.fetch_cancel_withdraw.withdrawId;
			if (errMsg) {
				/* display the red alert message dropping down vertically from top*/
				__WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_notification_js__["a" /* default */].show({
					titleTxt: null,
					mainTxt: 'connection error pending withdrawal:' + withdrawId
				});
			} else if (failure) {
				failTitle = textkeysObj['deposit-pendingwithdrawals-fail-feedbacktitle'] || 'cancel failed';
				failText = textkeysObj['deposit-pendingwithdrawals-fail-feebacktxt'] || 'cancel pending withdrawal was not possible, try again later or call support';
				failBtn = textkeysObj['deposit-pendingwithdrawals-fail-btn'] || 'ok';
				markWithWarnClass(withdrawId);
				__WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_confirmationmessage_js__["a" /* default */].show('default-failure', failTitle, failText, failBtn);
			}
		}
	},
	close: function close() {
		removeListeners();
		deleteAllElements();
		/* these have to be closed or they may remain if a new url is entered*/
		__WEBPACK_IMPORTED_MODULE_2__commonview_lib_view_confirmationmessage_js__["a" /* default */].close();
		__WEBPACK_IMPORTED_MODULE_3__commonview_lib_view_notification_js__["a" /* default */].close();
		__WEBPACK_IMPORTED_MODULE_4__commonview_lib_view_binaryquestion_js__["a" /* default */].close();
	}
};

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*

 countUp.js
 by @inorganik

 */

// target = id of html element or var of previously selected html element where counting occurs
// startVal = the value you want to begin at
// endVal = the value you want to arrive at
// decimals = number of decimal places, default 0
// duration = duration of animation in seconds, default 2
// options = optional object of options (see below)

var CountUp = function CountUp(target, startVal, endVal, decimals, duration, options) {

	// make sure requestAnimationFrame and cancelAnimationFrame are defined
	// polyfill for browsers without native support
	// by Opera engineer Erik Möller
	var lastTime = 0;
	var vendors = ['webkit', 'moz', 'ms', 'o'];
	for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
		window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	}
	if (!window.requestAnimationFrame) {
		window.requestAnimationFrame = function (callback, element) {
			var currTime = new Date().getTime();
			var timeToCall = Math.max(0, 16 - (currTime - lastTime));
			var id = window.setTimeout(function () {
				callback(currTime + timeToCall);
			}, timeToCall);
			lastTime = currTime + timeToCall;
			return id;
		};
	}
	if (!window.cancelAnimationFrame) {
		window.cancelAnimationFrame = function (id) {
			clearTimeout(id);
		};
	}

	var self = this;

	// default options
	self.options = {
		useEasing: true, // toggle easing
		useGrouping: true, // 1,000,000 vs 1000000
		separator: ',', // character to use as a separator
		decimal: '.', // character to use as a decimal
		easingFn: null, // optional custom easing closure function, default is Robert Penner's easeOutExpo
		formattingFn: null // optional custom formatting function, default is self.formatNumber below
	};
	// extend default options with passed options object
	for (var key in options) {
		if (options.hasOwnProperty(key)) {
			self.options[key] = options[key];
		}
	}
	if (self.options.separator === '') {
		self.options.useGrouping = false;
	}
	if (!self.options.prefix) self.options.prefix = '';
	if (!self.options.suffix) self.options.suffix = '';

	self.d = typeof target === 'string' ? document.getElementById(target) : target;
	self.startVal = Number(startVal);
	self.endVal = Number(endVal);
	self.countDown = self.startVal > self.endVal;
	self.frameVal = self.startVal;
	self.decimals = Math.max(0, decimals || 0);
	self.dec = Math.pow(10, self.decimals);
	self.duration = Number(duration) * 1000 || 2000;

	self.formatNumber = function (nStr) {
		nStr = nStr.toFixed(self.decimals);
		nStr += '';
		var x, x1, x2, rgx;
		x = nStr.split('.');
		x1 = x[0];
		x2 = x.length > 1 ? self.options.decimal + x[1] : '';
		rgx = /(\d+)(\d{3})/;
		if (self.options.useGrouping) {
			while (rgx.test(x1)) {
				x1 = x1.replace(rgx, '$1' + self.options.separator + '$2');
			}
		}
		return self.options.prefix + x1 + x2 + self.options.suffix;
	};
	// Robert Penner's easeOutExpo
	self.easeOutExpo = function (t, b, c, d) {
		return c * (-Math.pow(2, -10 * t / d) + 1) * 1024 / 1023 + b;
	};

	self.easingFn = self.options.easingFn ? self.options.easingFn : self.easeOutExpo;
	self.formattingFn = self.options.formattingFn ? self.options.formattingFn : self.formatNumber;

	self.version = function () {
		return '1.7.1';
	};

	// Print value to target
	self.printValue = function (value) {
		var result = self.formattingFn(value);

		if (self.d.tagName === 'INPUT') {
			this.d.value = result;
		} else if (self.d.tagName === 'text' || self.d.tagName === 'tspan') {
			this.d.textContent = result;
		} else {
			this.d.innerHTML = result;
		}
	};

	self.count = function (timestamp) {

		if (!self.startTime) {
			self.startTime = timestamp;
		}

		self.timestamp = timestamp;
		var progress = timestamp - self.startTime;
		self.remaining = self.duration - progress;

		// to ease or not to ease
		if (self.options.useEasing) {
			if (self.countDown) {
				self.frameVal = self.startVal - self.easingFn(progress, 0, self.startVal - self.endVal, self.duration);
			} else {
				self.frameVal = self.easingFn(progress, self.startVal, self.endVal - self.startVal, self.duration);
			}
		} else {
			if (self.countDown) {
				self.frameVal = self.startVal - (self.startVal - self.endVal) * (progress / self.duration);
			} else {
				self.frameVal = self.startVal + (self.endVal - self.startVal) * (progress / self.duration);
			}
		}

		// don't go past endVal since progress can exceed duration in the last frame
		if (self.countDown) {
			self.frameVal = self.frameVal < self.endVal ? self.endVal : self.frameVal;
		} else {
			self.frameVal = self.frameVal > self.endVal ? self.endVal : self.frameVal;
		}

		// decimal
		self.frameVal = Math.round(self.frameVal * self.dec) / self.dec;

		// format and print value
		self.printValue(self.frameVal);

		// whether to continue
		if (progress < self.duration) {
			self.rAF = requestAnimationFrame(self.count);
		} else {
			if (self.callback) {
				self.callback();
			}
		}
	};
	// start your animation
	self.start = function (callback) {
		self.callback = callback;
		self.rAF = requestAnimationFrame(self.count);
		return false;
	};
	// toggles pause/resume animation
	self.pauseResume = function () {
		if (!self.paused) {
			self.paused = true;
			cancelAnimationFrame(self.rAF);
		} else {
			self.paused = false;
			delete self.startTime;
			self.duration = self.remaining;
			self.startVal = self.frameVal;
			requestAnimationFrame(self.count);
		}
	};
	// reset to startVal so animation can be run again
	self.reset = function () {
		self.paused = false;
		delete self.startTime;
		self.startVal = startVal;
		cancelAnimationFrame(self.rAF);
		self.printValue(self.startVal);
	};
	// pass a new endVal and start animation
	self.update = function (newEndVal) {
		cancelAnimationFrame(self.rAF);
		self.paused = false;
		delete self.startTime;
		self.startVal = self.frameVal;
		self.endVal = Number(newEndVal);
		self.countDown = self.startVal > self.endVal;
		self.rAF = requestAnimationFrame(self.count);
	};

	// format startVal on initialization
	self.printValue(self.startVal);
};

/* harmony default export */ __webpack_exports__["a"] = CountUp;

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPendingWithdrawContent; });
function pendingWithdrawBox(withdraw) {
	return '<div style="padding: 5px; flex: 1 1 auto; margin: auto; min-width: 140px; min-height: 140px; outline: 2px solid blue;">\n\t\t\t\t<span>Amount</span> <span>' + withdraw.amount + '</span> <span>' + withdraw.currency + '</span>\n\t\t\t</div>\n\t\t';
}
function boxContainer(withdrawBoxes) {
	return '<div style="display: flex; flex-direction: row;">' + withdrawBoxes + '</div>\n\t\t';
}

function getPendingWithdrawContent(pendingWithdraws) {
	var withdrawBoxes = pendingWithdraws.map(pendingWithdrawBox);
	return new Promise(function (resolve, reject) {
		try {
			resolve(boxContainer(withdrawBoxes.join('')));
		} catch (e) {
			reject(e);
		}
	});
}



/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__upload_documents_js__ = __webpack_require__(110);



var clean = function clean() {
	var children = document.getElementsByClassName('js-confirm-modal')[0].getElementsByClassName('js-notify__text-wrapper')[0].children;

	var removeChildren = [];
	for (var i = 0; i < children.length; i += 1) {
		if (children[i].classList.contains('js-types')) {
			removeChildren.push(children[i]);
		}
	}
	for (var _i = 0; _i < removeChildren.length; _i += 1) {
		removeChildren[_i].parentNode.removeChild(removeChildren[_i]);
	}
};
var addTypes = function addTypes(texts) {
	var htmlTemplate = '';
	if (texts.uploadTitle) {
		htmlTemplate += '<p class="js-types">' + texts.uploadTitle + '</p><ul class="js-types">';
		for (var i = 0; i < texts.uploadDocuments.length; i += 1) {
			htmlTemplate += '<li>' + texts.uploadDocuments[i] + '</li>';
		}
		htmlTemplate += '</ul>';
	}

	document.getElementsByClassName('js-confirm-modal')[0].getElementsByClassName('js-notify__text-wrapper')[0].innerHTML += htmlTemplate;
};

function show(kycResponse, viewDoneResolver, confirmCallback) {
	var texts = kycResponse.kycPopup.contentKYC;

	__WEBPACK_IMPORTED_MODULE_1__upload_documents_js__["a" /* default */].fetchHasDocuments().then(function (hasDocuments) {
		var icon = void 0;
		if (hasDocuments) {
			icon = 'has-documents';
		} else {
			icon = 'empty-documents';
		}
		__WEBPACK_IMPORTED_MODULE_0__notifications_js__["a" /* default */].showConfirmationMessage(icon, texts.message, texts.secondaryMessage, kycResponse.kycPopup.confirm, function () {
			clean();
			confirmCallback();
		}, kycResponse.kycPopup.close, {
			closeCallback: function closeCallback() {
				viewDoneResolver({ status: 'close' });
				clean();
			},
			viewReadyCallback: function viewReadyCallback() {
				clean();
				addTypes(texts);
			}
		});
	});
}

/* harmony default export */ __webpack_exports__["a"] = {
	show: show
};

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export uiErrorFeedback */
/* unused harmony export uiErrorFeedbackOnEditedElement */
function elementFeedback(element, isOk) {
	var ERROR_FEEDBACK = 'payment__input_notvalid';

	if (isOk) {
		element.classList.remove(ERROR_FEEDBACK);
	} else {
		element.classList.add(ERROR_FEEDBACK);
	}
}
function uiContainerFeedback(element, isOk) {
	var UNDERLINE_ERROR = 'payment__input_notvalid';
	var HIDE_ERROR_FEEDBACK = 'u-hide';
	var FEEDBACK_SELECTOR = '.input-wrap__error-display';

	var feedback = element.parentNode.querySelector(FEEDBACK_SELECTOR);
	var parent = element.parentNode;

	if (isOk) {
		feedback && feedback.classList && feedback.classList.add(HIDE_ERROR_FEEDBACK);
		parent && parent.classList && parent.classList.remove(UNDERLINE_ERROR);
	} else {
		feedback && feedback.classList && feedback.classList.remove(HIDE_ERROR_FEEDBACK);
		parent && parent.classList && parent.classList.add(UNDERLINE_ERROR);
	}
}
function hasContainerLabel(element) {
	return element.parentNode.tagName && element.parentNode.tagName === 'LABEL';
}
function uiErrorFeedback(element, isOk) {
	if (hasContainerLabel) {
		uiContainerFeedback(element, isOk);
	} else {
		elementFeedback(element);
	}
}
function uiErrorFeedbackOnEditedElement(element, isElementOk) {
	if (isElementOk) {
		uiErrorFeedback(element, isElementOk);
	} else if (element.dataset.edited === 'true') {
		uiErrorFeedback(element, isElementOk);
	}
}



/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_handlebars__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_handlebars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_handlebars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__upload_documents_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withdraw_services_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__kyc_popup_js__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flow_flow_view_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validation_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__validators_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__validation_ui_feedback_js__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__libs_currency_formatter_js__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__libs_locale_js__ = __webpack_require__(31);
/* unused harmony export getWithdrawFormId */
/* unused harmony export getWithdrawAmountFieldId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withdrawAmountView; });













// view helpers
var amountTemplate = {
	template: undefined,
	rootContext: {}
};
var viewIds = {
	amount: undefined,
	form: undefined,
	feeContextElement: undefined,
	limitContextElement: undefined
};
function getContextBasedId(contextPath, id) {
	return contextPath + '-' + id;
}
function getWithdrawFormId() {
	return viewIds.form;
}
function getFeeElementId() {
	return viewIds.feeContextElement;
}
function getLimitElementId() {
	return viewIds.limitContextElement;
}
function getWithdrawAmountFieldId() {
	return viewIds.amount;
}
function setViewIds(contextPath) {
	viewIds.form = getContextBasedId(contextPath, 'withdraw-form-id');
	viewIds.amount = getContextBasedId(contextPath, 'withdraw-amount-field-id');
	viewIds.feeContextElement = getContextBasedId(contextPath, 'withdraw-fee-context-element');
	viewIds.limitContextElement = getContextBasedId(contextPath, 'withdraw-limit-context-element');
}

function templateDataWithAmountValue(rootContext, feeLimitData, balanceData) {
	var bonusFree = parseFloat(balanceData.PARAM_BONUS_FREE_MONEY_BALANCE);
	var bonusLocked = parseFloat(balanceData.PARAM_BONUS_LOCKED_MONEY_BALANCE);

	var newContext = {};
	var rootContextKeys = Object.keys(rootContext);
	rootContextKeys.forEach(function (key) {
		newContext[key] = rootContext[key];
	});

	newContext.PARAM_AMOUNT = parseFloat(feeLimitData.PARAM_AMOUNT);
	newContext.PARAM_TOTAL_AMOUNT = parseFloat(feeLimitData.PARAM_TOTAL_AMOUNT);
	newContext.PARAM_FEE_AMOUNT = parseFloat(feeLimitData.PARAM_FEE_AMOUNT);
	newContext.SELECTED_CURRENCY = feeLimitData.SELECTED_CURRENCY;
	newContext.PARAM_MIN_OPERATION = parseFloat(feeLimitData.PARAM_MIN_OPERATION);
	newContext.PARAM_MAX_OPERATION = parseFloat(feeLimitData.PARAM_MAX_OPERATION);
	newContext.PARAM_BALANCE_TOTAL = parseFloat(balanceData.PARAM_BALANCE_TOTAL);
	newContext.PARAM_BONUS_BALANCE = bonusFree + bonusLocked;
	newContext.PARAM_AVILABLE_TO_WITHDRAW = newContext.PARAM_BALANCE_TOTAL - newContext.PARAM_BONUS_BALANCE - newContext.PARAM_FEE_AMOUNT;

	if (newContext.PARAM_AVILABLE_TO_WITHDRAW < 0) {
		newContext.PARAM_AVILABLE_TO_WITHDRAW = 0;
	}
	newContext.PARAM_MAX_OPERATION = Math.min(newContext.PARAM_AVILABLE_TO_WITHDRAW, newContext.PARAM_MAX_OPERATION);
	rootContext.SELECTED_CURRENCY = feeLimitData.SELECTED_CURRENCY;
	return newContext;
}
function createFeeLimitVO(withdrawAmount, currency, methodData, accountData) {
	return {
		paymentMethodId: methodData.methodId,
		amount: withdrawAmount,
		aid: accountData && accountData.id,
		isMobileDevice: true,
		currency: currency
	};
}
// js-payment__input-cvc-creditcard payment__input-cvc-creditcard input-wrap__input
var formValidation = {
	amountForm: {
		amountMin: undefined,
		amountMax: undefined,

		am: function am(value) {
			console.log(amountTemplate);
			if (__WEBPACK_IMPORTED_MODULE_7__validators_js__["a" /* isBetween */](parseFloat(value), this.amountMin, this.amountMax)) {
				return {
					inRange: true
				};
			}
			return {
				inRange: false,
				isGreater: __WEBPACK_IMPORTED_MODULE_7__validators_js__["b" /* isGreater */](value, this.amountMax)
			};
		}
	},
	setValidationConstraints: function setValidationConstraints(validationConstraints) {
		this.amountForm.amountMax = validationConstraints.PARAM_MAX_OPERATION;
		this.amountForm.amountMin = validationConstraints.PARAM_MIN_OPERATION;
	},
	onInput: function onInput(formElement) {
		var validationResult = __WEBPACK_IMPORTED_MODULE_6__validation_js__["a" /* validateFormElements */](formElement, this.amountForm);
		uiFeedBackForMinMax(validationResult, formElement, this.amountForm.amountMin, this.amountForm.amountMax);
		return validationResult;
	},
	onSubmit: function onSubmit(formElement) {
		var validationResult = __WEBPACK_IMPORTED_MODULE_6__validation_js__["a" /* validateFormElements */](formElement, this.amountForm);
		uiFeedBackForMinMax(validationResult, formElement, this.amountForm.amountMin, this.amountForm.amountMax);
		return validationResult;
	}
};

/***
 * handlers
 */
function feeLimitUpdate(sharedPaymentMethodStore, formElement) {
	var amountElement = formElement.am;
	var parsedFloat = parseFloat(amountElement.value);
	var withdrawAmount = isNaN(parsedFloat) ? 0 : parsedFloat;

	sharedPaymentMethodStore.setLastUsedAmount(withdrawAmount);

	var methodData = sharedPaymentMethodStore.getMethod();
	var accountData = sharedPaymentMethodStore.getAccount();
	var currency = sharedPaymentMethodStore.getCurrency();
	var feeLimitVO = createFeeLimitVO(withdrawAmount, currency, methodData, accountData);
	return Promise.all([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__withdraw_services_js__["d" /* fetchBalance */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__withdraw_services_js__["e" /* fetchFeesAndLimits */])(feeLimitVO)]).then(function (_ref) {
		var balanceData = _ref[0],
		    feeLimitData = _ref[1];

		var rootContext = templateDataWithAmountValue(amountTemplate.rootContext, feeLimitData, balanceData);
		feeLimitTemplateUpdate(formElement, rootContext);
		formValidation.setValidationConstraints(extractValidationConstraints(rootContext));
	});
}
function feeLimitTemplateUpdate(formElement, templateRootContext) {
	var feeElement = formElement.ownerDocument.getElementById(getFeeElementId());
	feeElement.innerHTML = amountTemplate.feeTemplate(templateRootContext);
}
function extractValidationConstraints(feeLimitData) {
	return {
		PARAM_MAX_OPERATION: feeLimitData.PARAM_MAX_OPERATION,
		PARAM_MIN_OPERATION: feeLimitData.PARAM_MIN_OPERATION
	};
}

function amountFormChange(sharedPaymentMethodStore, formElement) {
	feeLimitUpdate(sharedPaymentMethodStore, formElement).then(function () {
		formValidation.onInput(formElement);
	});
}

/* Only entries explicitly listed in adapters will be used to serialize data from dataArray.
 * Overwrites on key collision
 */
function applyAdapters(adapters, dataArray) {
	if (adapters.length !== dataArray.length) {
		throw new Error('Adapter and data size mismatch when building withdraw request');
	}

	var data = { isMobileDevice: true };

	var _loop = function _loop(i) {
		var adapter = adapters[i];
		var inData = dataArray[i];

		Object.keys(inData).forEach(function (key) {
			if (adapter[key]) {
				data[adapter[key]] = inData[key];
			}
		});
	};

	for (var i = 0; i < adapters.length; i += 1) {
		_loop(i);
	}
	return data;
}
function creditCardWithdrawDataAdapter(method, account) {
	var accountSerializationKeys = {
		id: 'cid'
	};
	var adapterInfo = [accountSerializationKeys];
	var dataToSerialize = [account];

	return applyAdapters(adapterInfo, dataToSerialize);
}
function trustlyAdapter(method, account) {
	var methodSerializationKeys = {
		methodId: 'paymentMethodId'
	};
	var adapterInfo = [methodSerializationKeys];
	var dataToSerialize = [method];

	return applyAdapters(adapterInfo, dataToSerialize);
}
function piqWithdrawDataAdapter(method, account) {
	var methodSerializationKeys = {
		methodId: 'paymentMethodId'
	};
	var accountSerializationKeys = {
		accountNumber: 'nu',
		clearingNumber: 'so',
		country: 'cid1'
	};
	var adapterInfo = [methodSerializationKeys, accountSerializationKeys];
	var dataToSerialize = [method, account];

	return applyAdapters(adapterInfo, dataToSerialize);
}
function withdrawDataUsingAdapter(method, account) {
	var adapters = {
		1: creditCardWithdrawDataAdapter,
		23: trustlyAdapter,
		57: piqWithdrawDataAdapter
	};

	return adapters[method.methodId](method, account);
}

function showKycPopup(kycResponse, contextElement, viewDoneResolver) {
	__WEBPACK_IMPORTED_MODULE_4__kyc_popup_js__["a" /* default */].show(kycResponse, viewDoneResolver, function () {
		var viewReadyResolver = void 0;
		var viewReadyPromise = new Promise(function (resolve) {
			viewReadyResolver = resolve;
		});

		__WEBPACK_IMPORTED_MODULE_2__upload_documents_js__["a" /* default */].view(viewReadyPromise).then(function (uploadDocument) {
			contextElement.innerHTML = '';
			var wrapperElement = document.createElement('div');
			wrapperElement.classList.add('withdrawal-step');
			contextElement.appendChild(wrapperElement);
			wrapperElement.innerHTML = uploadDocument.html;
			viewReadyResolver(wrapperElement);
			return uploadDocument.viewDonePromise;
		}).then(function (kycDone) {
			viewDoneResolver(kycDone);
		});
	});
}
function addActionButtonHandler(contextElement, sharedPaymentMethodStore, viewDoneResolver) {
	var actionButton = contextElement.ownerDocument.getElementById('flow-click-to-action');
	if (actionButton === null) {
		return;
	}

	var form = contextElement.ownerDocument.getElementById(getWithdrawFormId());
	if (form === null) {
		return;
	}

	actionButton.addEventListener('click', function () {
		var spinner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__flow_flow_view_js__["c" /* siblingSpinnerOnAction */])(event.target);

		var validationResult = formValidation.onSubmit(form);

		var url = form.action;
		var method = sharedPaymentMethodStore.getMethod();
		var account = sharedPaymentMethodStore.getAccount();

		var data = withdrawDataUsingAdapter(method, account);
		// add amount from form
		data.am = form.am.value;
		//setting isMobile true by default
		data.mobileDevice = true;

		if (validationResult.ok) {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__withdraw_services_js__["f" /* isKycNeeded */])({
				cid: account && account.id || -1,
				method: method.methodId,
				amount: data.am,
				currency: sharedPaymentMethodStore.getCurrency()
			}).then(function (kycResponse) {
				if (kycResponse.needValidation) {
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__flow_flow_view_js__["d" /* spinnerOff */])(spinner);
					showKycPopup(kycResponse, contextElement, viewDoneResolver);
				} else {
					__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_ajax_json_js__["b" /* postJson */])(url, data).then(function (response) {
						/* method.send() does a full reload to show the result page
       * /payment/result/withdraw, just like an external provider would.
       *
       * If this changes two things may be needed
       *     1. spinnerOff
       *     2. resolve viewDonePromise
       */

						method.send(response);
					}).catch(function (e) {
						__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__flow_flow_view_js__["d" /* spinnerOff */])(spinner);
						console.log('Failed: ' + url, data);
						var errorTitle = e.message.split(':')[0];
						var errorMessage = e.message.split(':')[1];
						console.log(errorTitle + ' ' + errorMessage);
						__WEBPACK_IMPORTED_MODULE_9__notifications_js__["a" /* default */].showInformationMessage('fail', errorTitle, errorMessage, null, -1, null);
					});
				}
			});
		} else {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__flow_flow_view_js__["d" /* spinnerOff */])(spinner);
		}
	});
}

function addFormHandler(contextElement, sharedPaymentMethodStore) {
	var formElement = contextElement.ownerDocument.getElementById(getWithdrawFormId());
	if (formElement) {
		var formHandler = amountFormChange.bind(null, sharedPaymentMethodStore, formElement);
		var delayHandler = __WEBPACK_IMPORTED_MODULE_6__validation_js__["b" /* getDelayedFormInputHandler */](formHandler);
		var focusInHandler = callbackOnFocusin.bind(formElement);
		formElement.addEventListener('input', delayHandler);
		formElement.addEventListener('focusin', focusInHandler);
	}
}

function addHandlers(contextElement, sharedPaymentMethodStore, viewDoneResolver) {
	addActionButtonHandler(contextElement, sharedPaymentMethodStore, viewDoneResolver);
	addFormHandler(contextElement, sharedPaymentMethodStore);
}

function viewReady(sharedPaymentMethodStore, viewDoneResolver, contextElement) {
	addHandlers(contextElement, sharedPaymentMethodStore, viewDoneResolver);
	var amountEl = contextElement.ownerDocument.getElementById(getWithdrawAmountFieldId());

	feeLimitUpdate(sharedPaymentMethodStore, amountEl.form).then(function () {
		if (amountEl.value !== '') {
			formValidation.onInput(amountEl.form);
		}
	});
}

function withdrawAmountView(contextPath, sharedPaymentMethodStore, viewReadyPromise) {
	setViewIds(contextPath);

	var viewTaskDone = void 0;
	var viewDonePromise = new Promise(function (viewDoneResolver) {
		viewTaskDone = viewReady.bind(null, sharedPaymentMethodStore, viewDoneResolver);
	});
	viewReadyPromise.then(function (contextElement) {
		viewTaskDone(contextElement);
		return viewDonePromise;
	});

	var method = sharedPaymentMethodStore.getMethod();
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__core_ajax_json_js__["a" /* fetchJson */])('/template/withdraw/amount-form/' + method.methodId).then(function (restResult) {
		var tpls = restResult.result.templates;
		var rootContext = {
			context: {
				path: contextPath
			},
			'withdraw-form-id': getWithdrawFormId(),
			'withdraw-amount-field-id': getWithdrawAmountFieldId(),
			'withdraw-fee-context-element': getFeeElementId(),
			'withdraw-limit-context-element': getLimitElementId(),
			'method-text': method.methodText,
			'method-id': method.methodId,
			'execute-url': method.executeUrl,
			i18n: restResult.result.rootContext.i18n,
			PARAM_AMOUNT: method.amount || sharedPaymentMethodStore.getLastUsedAmount(),
			SELECTED_CURRENCY: sharedPaymentMethodStore.getCurrency()
		};

		__WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.registerHelper('currency-with-two-digits', function (value, selectedCurrency) {
			if (Number.isNaN(value) || !Number.isFinite(value)) {
				return '';
			}
			return __WEBPACK_IMPORTED_MODULE_10__libs_currency_formatter_js__["a" /* default */].format(value, selectedCurrency, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__libs_locale_js__["a" /* getLocale */])());
		});

		__WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.registerPartial('fee', tpls.fee);
		__WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.registerPartial('withdraw-amount-form', tpls['withdraw-amount-form']);
		var amountTpl = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.compile(tpls['withdraw-amount']);
		amountTemplate.rootContext = rootContext;
		amountTemplate.template = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.compile(tpls['withdraw-amount-form']);
		amountTemplate.feeTemplate = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.compile(tpls.fee);
		return {
			title: restResult.result.rootContext.i18n.MOBILE_WITHDRAW_AMOUNT_PAGE_TITLE,
			html: amountTpl(rootContext),
			viewDonePromise: viewDonePromise
		};
	});
}

function uiFeedBackForMinMax(validationResult, formElement, amountMinLimit, amountMaxLimit) {
	var limitElement = formElement.ownerDocument.getElementById(getLimitElementId());
	if (validationResult.ok) {
		limitElement.innerHTML = '';
	} else {
		var element = validationResult.fail.am;
		if (element.dataset.isGreaterThanMax === 'true') {
			limitElement.innerHTML = amountTemplate.rootContext.i18n.MOBILE_WITHDRAW_FEELMT_SUMMARY_MAX_WITHDRAW + '&nbsp;' + __WEBPACK_IMPORTED_MODULE_10__libs_currency_formatter_js__["a" /* default */].format(amountMaxLimit, amountTemplate.rootContext.SELECTED_CURRENCY, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__libs_locale_js__["a" /* getLocale */])());
		} else {
			limitElement.innerHTML = amountTemplate.rootContext.i18n.MOBILE_WITHDRAW_FEELMT_SUMMARY_MIN_WITHDRAW + '&nbsp;' + __WEBPACK_IMPORTED_MODULE_10__libs_currency_formatter_js__["a" /* default */].format(amountMinLimit, amountTemplate.rootContext.SELECTED_CURRENCY, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__libs_locale_js__["a" /* getLocale */])());
		}
	}
}

function callbackOnFocusin(event) {
	var amountEl = event.target;
	amountEl.value = '';
	amountEl.placeholder = '';
}



/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flow_flow_view_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withdraw_services_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__account_info_js__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cancel_pending_withdraw_js__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__withdraw_method_js__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__withdraw_amount_js__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__payment_method_data_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__notifications_js__ = __webpack_require__(16);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return withdrawFlow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return cleanup; });
var _this = this;

















var mockContent = {
	contentContainer: function contentContainer(title, color, nestedContent) {
		return '<div style="outline:2px solid ' + color + ';">\n\t\t\t\t<h3>' + title + '</h3>\n\t\t\t\t' + nestedContent + '\n\t\t\t</div>';
	}
};

function firstParent(element, tagName) {
	var el = {
		parentNode: element
	};
	while (el = el.parentNode) {
		if (el.tagName === tagName) {
			return el;
		}
	}
	return undefined;
}
var navigation = {
	navigationHandler: function navigationHandler(event) {
		var anchor = firstParent(event.target, 'A');

		if (anchor === undefined) {
			return;
		}

		var navAction = anchor.pathname[0] === '/' ? anchor.pathname.substr(1) : anchor.pathname;

		if (navigation[navAction]) {
			event.stopPropagation();
			event.preventDefault();
			navigation[navAction]();
		}
	},


	close: function close() {
		initData.currentView = undefined;
		__WEBPACK_IMPORTED_MODULE_7__store_history_js__["e" /* pushBack */]();
		__WEBPACK_IMPORTED_MODULE_8__notifications_js__["a" /* default */].hideConfirmationMessage();
	},
	show: function show(view) {
		view = view || initData.currentView;
		initData.currentView = view;
		return navigation[initData.currentView].show();
	},
	back: function back(fromView) {
		var current = navigation[fromView] || navigation[initData.currentView];
		if (current === undefined) {
			return navigation.close();
		}
		var currentOrdinal = -1;
		if (current && current.order > -1) {
			currentOrdinal = current.order;
		}

		var ordinal = currentOrdinal - 1;
		if (ordinal < 0) {
			return navigation.close();
		}

		var view = navigation.order[ordinal];
		return navigation[view].doShow().then(function (showIt) {
			if (showIt) {
				return navigation.show(view);
			}
			return navigation.back(view);
		});
	},
	next: function next(fromView) {
		var current = navigation[fromView] || navigation[initData.currentView];

		var currentOrdinal = -1;
		if (current && current.order > -1) {
			currentOrdinal = current.order;
		}

		var ordinal = currentOrdinal + 1;
		if (ordinal > navigation.order.length) {
			return navigation.close();
		}

		var view = navigation.order[ordinal];
		return navigation[view].doShow().then(function (showIt) {
			if (showIt) {
				return navigation.show(view);
			}
			return navigation.next(view);
		});
	},

	cancelPending: {
		order: 0,
		preFetch: undefined,
		doShow: function doShow() {
			return __WEBPACK_IMPORTED_MODULE_1__withdraw_services_js__["a" /* fetchPendingWithdraws */]().then(function (pendingWithdraws) {
				_this.preFetch = pendingWithdraws;
				return pendingWithdraws.length > 0;
			});
		},
		show: function show() {
			return routeHandlers.cancelPending(_this.preFetch);
		}
	},
	method: {
		order: 1,
		doShow: function doShow() {
			return Promise.resolve(true);
		},
		show: function show() {
			return routeHandlers.method();
		}
	},
	amount: {
		order: 2,
		doShow: function doShow() {
			return Promise.resolve(true);
		},
		show: function show() {
			return routeHandlers.amount();
		}
	},

	order: ['cancelPending', 'method', 'amount']
};

function flowViewDone(viewDone) {
	if (viewDone.status === 'reload') {
		return navigation.show();
	} else if (viewDone.status === 'back') {
		return navigation.back();
	} else if (viewDone.status === 'close') {
		return navigation.close();
	}
	return navigation.next();
}

var initData = {
	/* Mount point for withdraws, e.g. #/withdraw
  * (It would be possible to add withdraw in many places, e.g. #/account/withdraw, #/casino/game/123/withdraw)
  */
	contextPath: undefined,

	/* Context element for withdraw
  * This could be different depending on what part of the application mounts withdraw)
  */
	contextElement: undefined,
	/* Location before calling withdraw. Examples
  * 		/casino
  * 		/withdraw (previous /casino)
  * 		/withdraw/cancel-pending (previous is still /casino)
  * 		/account
  * 		/withdraw (previous /account
  */
	locationBeforeWithdraw: undefined,

	paymentFormDataServiceCachePromise: undefined,

	paymentMethodStore: undefined,

	currentView: undefined,

	verificationMessages: {
		mobileVerifyNotNow: '',
		mobileVerifyNow: '',
		mobileVerifyError: ''
	},

	withdrawConfig: function withdrawConfig(contextPath, contextElement, lastPage) {
		this.contextPath = contextPath;
		this.contextElement = contextElement;
		this.locationBeforeWithdraw = lastPage;

		this.paymentFormDataServiceCachePromise = __WEBPACK_IMPORTED_MODULE_1__withdraw_services_js__["b" /* preparePaymentFormDataServiceCache */]().catch(function (e) {
			console.error('Failed call to withdrawServices.preparePaymentFormDataServiceCache()', e);
		});

		this.paymentMethodStore = __WEBPACK_IMPORTED_MODULE_6__payment_method_data_js__["a" /* createStore */]();
	},
	addNavigationHandlers: function addNavigationHandlers(contextElement) {
		contextElement.addEventListener('click', navigation.navigationHandler, true);
	},
	initialize: function initialize(contextPath, contextElementId, lastPage) {
		var contextElement = document.getElementById(contextElementId);
		if (contextElement === undefined) {
			throw new Error('No such contextElement "' + contextElementId + '"');
		}

		// Generic config for /withdraw
		this.withdrawConfig(contextPath, contextElement, lastPage);

		this.addNavigationHandlers(contextElement);

		var accMenuElement = document.querySelector('#js-account-menu');

		this.verificationMessages.mobileVerifyNotNow = accMenuElement.querySelector('#not-now').innerHTML;
		this.verificationMessages.mobileVerifyNow = accMenuElement.querySelector('#verify-now').innerHTML;
		this.verificationMessages.mobileVerifyError = accMenuElement.querySelector('#needs-verified-mobile').innerHTML;
	},
	cleanup: function cleanup() {
		this.contextPath = undefined;
		this.locationBeforeWithdraw = undefined;
		this.paymentFormDataServiceCachePromise = undefined;
		this.paymentMethodStore = undefined;
		this.currentView = undefined;

		var contextElement = this.contextElement;
		this.contextElement = undefined;

		if (contextElement) {
			contextElement.removeEventListener('click', navigation.navigationHandler);
			contextElement.classList.remove('withdrawal--open');
			contextElement.innerHTML = '';
		}
	}
};

function slideOutTransition(el) {
	return new Promise(function (resolve, reject) {
		var OFF_CANVAS = 'u-hide-off-canvas';
		var OUT_DOWN = 'slide-out-down';
		var IN_UP = 'slide-in-up';
		var TRANSFORM_NONE = 'u-transform-none';

		if (el) {
			el.classList.remove(IN_UP);
			el.classList.remove(TRANSFORM_NONE);

			el.addEventListener('transitionend', function () {
				el.classList.add(OFF_CANVAS);
				resolve(el);
			}, false);

			el.classList.add(OUT_DOWN);
		}
		resolve(undefined);
	});
}
function slideInTransition(el) {
	return new Promise(function (resolve, reject) {
		var OFF_CANVAS = 'u-hide-off-canvas';
		var OUT_DOWN = 'slide-out-down';
		var IN_UP = 'slide-in-up';
		var TRANSFORM_NONE = 'u-transform-none';

		if (el) {
			el.classList.remove(OUT_DOWN);
			el.classList.remove(OFF_CANVAS);

			el.addEventListener('transitionend', function () {
				resolve(el);
			}, false);

			el.classList.add(IN_UP);
			el.classList.add(TRANSFORM_NONE);
		}
		resolve(undefined);
	});
}
function removeIfExists(element) {
	if (element) {
		return slideOutTransition(element).then(function (elAfterAnimation) {
			var el = elAfterAnimation;
			if (el && el.parentNode && el.parentNode.removeChild) {
				el.parentNode.removeChild(el);
			}
		});
	}
	return Promise.resolve(undefined);
}

function addNewViewAndRemoveOld(contextElement, content) {
	var doc = contextElement.ownerDocument;
	var FLOW_VIEW_CONTENT_ID = 'flow-content-element';

	var oldFlowDiv = doc.getElementById(FLOW_VIEW_CONTENT_ID);
	return removeIfExists(oldFlowDiv).then(function () {
		contextElement.innerHTML = content;
		var newFlowDiv = doc.getElementById(FLOW_VIEW_CONTENT_ID);
		return slideInTransition(newFlowDiv);
	});
}
function display(contextElement, content) {
	contextElement.classList.add('withdrawal--open');
	return addNewViewAndRemoveOld(contextElement, content);
}

var views = {
	getPendingWithdrawFlowView: function getPendingWithdrawFlowView(contextPath, pendingWithdrawContent) {
		var buttons = __WEBPACK_IMPORTED_MODULE_0__flow_flow_view_js__["a" /* setButtonConfig */](['back']);
		var context = {
			path: contextPath,
			content: pendingWithdrawContent.html
		};
		return __WEBPACK_IMPORTED_MODULE_0__flow_flow_view_js__["b" /* flowView */](pendingWithdrawContent.title, buttons, context);
	},
	getWithdrawMethodFlowView: function getWithdrawMethodFlowView(contextPath, methodSelectorContent) {
		var buttons = __WEBPACK_IMPORTED_MODULE_0__flow_flow_view_js__["a" /* setButtonConfig */](['back']);
		var context = {
			path: contextPath,
			content: methodSelectorContent.html
		};
		return __WEBPACK_IMPORTED_MODULE_0__flow_flow_view_js__["b" /* flowView */](methodSelectorContent.title, buttons, context);
	},
	getWithdrawAmountView: function getWithdrawAmountView(contextPath, amountContent) {
		var buttons = __WEBPACK_IMPORTED_MODULE_0__flow_flow_view_js__["a" /* setButtonConfig */](['back']);
		var context = {
			path: contextPath,
			content: amountContent.html
		};

		return __WEBPACK_IMPORTED_MODULE_0__flow_flow_view_js__["b" /* flowView */](amountContent.title, buttons, context);
	}
};

var verification = {
	fetchPlayerInfo: function fetchPlayerInfo() {
		return __WEBPACK_IMPORTED_MODULE_2__account_info_js__["a" /* default */].fetchPlayerInfo().then(function (playerInfoResult) {
			return playerInfoResult.result;
		});
	},
	isMobileVerificationOk: function isMobileVerificationOk() {
		return __WEBPACK_IMPORTED_MODULE_1__withdraw_services_js__["c" /* isMobileVerifyNeeded */]();
	},
	getMobileVerificationView: function getMobileVerificationView(playerInfo) {

		var mockVerify = mockContent.contentContainer('Mobile Verification Needed', 'blue', 'You must first verify mobile number ' + playerInfo.mobileCountryCode + ' ' + playerInfo.mobile);

		var title = 'Mobile Verification Needed';
		var buttons = __WEBPACK_IMPORTED_MODULE_0__flow_flow_view_js__["a" /* setButtonConfig */](['back']);
		var context = {
			path: initData.contextPath,
			content: mockVerify
		};
		return __WEBPACK_IMPORTED_MODULE_0__flow_flow_view_js__["b" /* flowView */](title, buttons, context);
	},
	mobileVerifyHandler: function mobileVerifyHandler(path) {
		return this.fetchPlayerInfo().then(this.getMobileVerificationView);
	}
};

var preConditions = {
	shouldVerifyMobile: function shouldVerifyMobile() {
		return verification.isMobileVerificationOk();
	}
};

var routeHandlers = {
	verifyMobile: function verifyMobile() {
		var pushToMobileVerify = function pushToMobileVerify() {
			__WEBPACK_IMPORTED_MODULE_7__store_history_js__["c" /* push */]('/account/mysettings/verify-mobile/', { referrer: 'withdraw' });
		};
		var pushToAccount = function pushToAccount() {
			__WEBPACK_IMPORTED_MODULE_8__notifications_js__["a" /* default */].hideNotification();
			__WEBPACK_IMPORTED_MODULE_7__store_history_js__["c" /* push */]('/account/');
		};
		__WEBPACK_IMPORTED_MODULE_8__notifications_js__["a" /* default */].showBinaryQuestion(initData.verificationMessages.mobileVerifyError, initData.verificationMessages.mobileVerifyNow, initData.verificationMessages.mobileVerifyNotNow, pushToMobileVerify, pushToAccount);
	},
	cancelPending: function cancelPending(pendingWithdraws) {
		__WEBPACK_IMPORTED_MODULE_3__cancel_pending_withdraw_js__["a" /* getPendingWithdrawContent */](pendingWithdraws).then(function (withdrawContent) {
			return views.getPendingWithdrawFlowView(initData.contextPath, withdrawContent);
		}).then(function (flowContent) {
			display(initData.contextElement, flowContent);
		});
	},
	method: function method() {
		var viewReadyPromiseResolver = void 0;
		var viewReadyPromise = new Promise(function (resolve) {
			viewReadyPromiseResolver = resolve;
		});
		return __WEBPACK_IMPORTED_MODULE_4__withdraw_method_js__["a" /* withdrawMethodView */](initData.contextPath, initData.paymentMethodStore, viewReadyPromise).then(function (withdrawMethodView) {
			views.getWithdrawMethodFlowView(initData.contextPath, withdrawMethodView).then(function (withdrawMethodFlowContent) {
				display(initData.contextElement, withdrawMethodFlowContent).then(function () {
					return viewReadyPromiseResolver(initData.contextElement);
				});
			});
			return withdrawMethodView.viewDonePromise;
		}).then(flowViewDone);
	},
	amount: function amount() {
		var selectedMethod = initData.paymentMethodStore.getMethod();
		if (selectedMethod === undefined) {
			routeHandlers.gotoFlowView('method');
		}
		var viewReadyPromiseResolver = void 0;
		var viewReadyPromise = new Promise(function (resolve) {
			viewReadyPromiseResolver = resolve;
		});

		return __WEBPACK_IMPORTED_MODULE_5__withdraw_amount_js__["a" /* withdrawAmountView */](initData.contextPath, initData.paymentMethodStore, viewReadyPromise).then(function (amountView) {
			views.getWithdrawAmountView(initData.contextPath, amountView).then(function (flowViewHtml) {
				display(initData.contextElement, flowViewHtml).then(function () {
					viewReadyPromiseResolver(initData.contextElement);
				});
			});

			return amountView.viewDonePromise;
		}).then(flowViewDone);
	}
};

function init(contextPath, contextElementId) {
	initData.initialize(contextPath, contextElementId);
}
function cleanup() {
	initData.cleanup();
}

function withdrawFlow() {
	preConditions.shouldVerifyMobile().then(function (response) {
		if (!response.verifyMobile) {
			return navigation.next();
		}
		return routeHandlers.verifyMobile();
	});
}



/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_handlebars__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_handlebars___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_handlebars__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__withdraw_services_js__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__payment_method_data_js__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flow_flow_view_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validators_js__ = __webpack_require__(209);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return withdrawMethodView; });
/* unused harmony export getMethodFormElementId */
/* unused harmony export getMethodSelectorId */
/* unused harmony export getMethodAccountSelectorId */
/* unused harmony export getMethodAccountContextId */
/* unused harmony export fetchCreditCardFormView */










function getContextBasedId(contextPath, id) {
	return contextPath + '-' + id;
}
function getMethodAccountContextId(contextPath) {
	return getContextBasedId(contextPath, 'method-account-context');
}
function getMethodAccountSelectorId(contextPath) {
	return getContextBasedId(contextPath, 'payment-method-account');
}
function getMethodSelectorId(contextPath) {
	return getContextBasedId(contextPath, 'method-selector');
}
function getAccountSelectorId(contextPath) {
	return getContextBasedId(contextPath, 'account-selector');
}

function getMethodFormElementId(contextPath) {
	return contextPath + '-method-form';
}
// Account for Credit Card method
function fetchCreditCardFormView(contextPath, creditCards) {
	var url = '/template/withdraw/methods/credit-card';
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_ajax_json_js__["a" /* fetchJson */])(url).then(function (restResult) {
		var rootContext = {
			cards: creditCards.accounts,
			i18n: restResult.result.rootContext.i18n,
			'account-selector-id': getAccountSelectorId(contextPath)
		};
		var accountTemplate = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.compile(restResult.result.templates['credit-card-selector']);
		return accountTemplate(rootContext);
	});
}
// Account for Bank Wire Withdraw, such as DotPay Payment IQ (DOTPAY_PIQ)
function fetchBankWireWithdrawFormView() {
	var url = '/template/withdraw/methods/bank-wire-withdraw';
	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_ajax_json_js__["a" /* fetchJson */])(url).then(function (restResult) {
		var accountTemplate = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.compile(restResult.result.templates['bank-wire-withdraw']);
		return accountTemplate(restResult.result.rootContext);
	});
}

function mergeMethodWithFormTemplate(methodData) {
	methodData.paymentMethods.map(function (method) {
		var formTemplateType = methodData.formTemplateTypes.find(function (tpl) {
			return tpl.formTemplateCode === method.formTemplateCode;
		});
		method.formTemplateUrl = formTemplateType.formTemplateMobileUrl;
		return method;
	});

	return methodData;
}
function fetchWithdrawMethodFormView(contextPath, methodData, paymentMethodStore) {
	var paymentMethodSelectorId = getMethodSelectorId(contextPath);
	var paymentMethodFormId = getMethodFormElementId(contextPath);

	var lastMethod = paymentMethodStore.getMethod();
	var lastUsedMethodId = lastMethod && lastMethod.methodId;

	return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__core_ajax_json_js__["a" /* fetchJson */])('/template/withdraw/methods').then(function (restResult) {
		var tpls = restResult.result.templates;
		methodData = mergeMethodWithFormTemplate(methodData);
		var rootContext = {
			methods: methodData.paymentMethods,
			playerCurrency: methodData.playerCurrency,
			'payment-method-selector-id': paymentMethodSelectorId,
			'payment-method-form-id': paymentMethodFormId,
			'payment-method-account-context': getMethodAccountContextId(contextPath),
			i18n: restResult.result.rootContext.i18n
		};
		__WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.registerPartial('payment-method-selector', tpls['payment-method-selector']);
		__WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.registerHelper('pre-select-default-method-option', function (contentContext) {
			var methodId = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.escapeExpression(contentContext.methodId);
			var methodText = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.escapeExpression(contentContext.methodText);
			var executeUrl = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.escapeExpression(contentContext.executeUrl);
			var sendHandlerType = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.escapeExpression(contentContext.sendHandlerType);
			var formTemplateCode = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.escapeExpression(contentContext.formTemplateCode);
			var formTemplateUrl = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.escapeExpression(contentContext.formTemplateUrl);
			var formTemplateUrlParams = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.escapeExpression(contentContext.formTemplateUrlParams);
			var logoImageClasses = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.escapeExpression(contentContext.logoImageClasses);
			var extraParameters = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.escapeExpression(contentContext.extraParameters);
			var selected = methodId === lastUsedMethodId ? ' selected' : '';

			return new __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.SafeString('<option value="' + methodId + '"\n\t\t\t\t\tclass="payment__option-method"\n\t\t\t\t\tdata-execute-url="' + executeUrl + '"\n\t\t\t\t\tdata-send-handler-type="' + sendHandlerType + '"\n\t\t\t\t\tdata-form-template-code="' + formTemplateCode + '"\n\t\t\t\t\tdata-form-template-url="' + formTemplateUrl + '"\n\t\t\t\t\tdata-form-template-url-params="' + formTemplateUrlParams + '"\n\t\t\t\t\tdata-logo-image-classes="' + logoImageClasses + '"\n\t\t\t\t\tdata-extra-parameters="' + extraParameters + '" ' + selected + '>' + methodText + '</option>');
		});

		var methodTpl = __WEBPACK_IMPORTED_MODULE_0_handlebars___default.a.compile(tpls['withdraw-methods']);

		var withdrawMethod = {
			html: methodTpl(rootContext),
			title: restResult.result.rootContext.i18n.MOBILE_WITHDRAW_METHOD_PAGE_TITLE
		};
		return withdrawMethod;
	});
}

function noAccountForSelectedMethod(accountContextElement) {
	accountContextElement.innerHTML = '';
}

var formValidation = {
	forms: {
		'CREDIT-CARD': {
			fieldValidators: {
				/* Currently only implemented for Poland
     *		”clearingNumber” field is used, while it will actually contain BIC
     */
				card: function card(cardId) {
					return { inRange: parseInt(cardId, 10) > 0 };
				}
			},
			formHandler: function formHandler(sharedPaymentMethodStore, formElement) {
				var validationResult = __WEBPACK_IMPORTED_MODULE_5__validation_js__["a" /* validateFormElements */](formElement, this.fieldValidators);

				if (validationResult.ok) {
					var cardSelect = validationResult.pass.card;
					var opt = cardSelect.options[cardSelect.selectedIndex];
					sharedPaymentMethodStore.setAccount(opt.dataset);
				} else {
					sharedPaymentMethodStore.setAccount(undefined);
				}
				return validationResult;
			}
		},
		'BANK-WIRE-WITHDRAW': {
			fieldValidators: {
				/* Currently only implemented for Poland
     *		”clearingNumber” field is used, while it will actually contain BIC
     */
				clearingNumber: function clearingNumber(value) {
					var clearingPattern = /^[A-Z0-9]{8,11}$/;
					return clearingPattern.test(value);
				},
				accountNumber: function accountNumber(value) {
					return __WEBPACK_IMPORTED_MODULE_6__validators_js__["c" /* onlyDigits */](value);
				}
			},
			formHandler: function formHandler(sharedPaymentMethodStore, formElement) {
				var validationResult = __WEBPACK_IMPORTED_MODULE_5__validation_js__["a" /* validateFormElements */](formElement, this.fieldValidators);

				if (validationResult.ok) {
					var COUNTRY_PL = '174';
					// country code for PL...
					var accountInfo = {
						country: COUNTRY_PL
					};

					Object.keys(validationResult.pass).forEach(function (elementName) {
						accountInfo[elementName] = validationResult.pass[elementName].value;
					});
					sharedPaymentMethodStore.setAccount(accountInfo);
				} else {
					sharedPaymentMethodStore.setAccount(undefined);
				}
				return validationResult;
			}
		}
	},
	onSubmit: function onSubmit(sharedPaymentMethodStore, formElement, formTemplateType) {
		var formTemplate = this.forms[formTemplateType];
		if (formTemplate && formTemplate.formHandler) {
			return formTemplate.formHandler(sharedPaymentMethodStore, formElement);
		}
		return { ok: true };
	}
};

function accountFormHandler(sharedPaymentMethodStore, methodSelectorId, accountFormElement) {
	var methodSelector = accountFormElement.ownerDocument.getElementById(methodSelectorId);
	var formTemplateCode = undefined;
	if (methodSelector) {
		formTemplateCode = methodSelector.options[methodSelector.selectedIndex].dataset.formTemplateCode;
	}
	if (formValidation.forms[formTemplateCode] && formValidation.forms[formTemplateCode].formHandler) {
		var formTemplate = formValidation.forms[formTemplateCode];
		formTemplate.formHandler(sharedPaymentMethodStore, accountFormElement);
	}
}

function showAccountTemplateForSelectedMethod(methodOption, accountContextElement, sharedPaymentMethodStore, contextPath) {
	return __WEBPACK_IMPORTED_MODULE_1__withdraw_services_js__["g" /* fetchTemplateDataForMethod */](methodOption.dataset.formTemplateUrl, methodOption.dataset.formTemplateUrlParams).then(function (accountData) {
		if (methodOption.dataset.formTemplateCode === 'CREDIT-CARD') {
			return fetchCreditCardFormView(contextPath, accountData).then(function (accountView) {
				accountContextElement.innerHTML = accountView;
				var accountSelector = accountContextElement.ownerDocument.getElementById(getAccountSelectorId(contextPath));
				if (accountSelector) {
					accountSelector.addEventListener('change', function (event) {
						var el = event.target;
						var accountOption = el.options[el.selectedIndex];
						sharedPaymentMethodStore.setAccount(accountOption && accountOption.dataset);
					});
					var evt = new Event('change', { bubbles: false });
					accountSelector.dispatchEvent(evt);
				}
			});
		}
		if (methodOption.dataset.formTemplateCode === 'BANK-WIRE-WITHDRAW') {
			return fetchBankWireWithdrawFormView().then(function (accountView) {
				accountContextElement.innerHTML = accountView;
			});
		}
		return undefined;
	});
}

function addMethodChangeHandler(contextPath, contextElement, sharedPaymentMethodStore) {
	var methodSelector = contextElement.ownerDocument.getElementById(getMethodSelectorId(contextPath));

	if (methodSelector === null) {
		return undefined;
	}
	methodSelector.addEventListener('change', function (event) {
		var actionButton = document.getElementById('flow-click-to-action');
		var spinner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__flow_flow_view_js__["c" /* siblingSpinnerOnAction */])(event.target);

		var accountFormId = getMethodAccountContextId(contextPath);
		var accountForm = contextElement.ownerDocument.getElementById(accountFormId);
		var select = event.target;
		var opt = select.options[select.selectedIndex];

		var paymentMethod = __WEBPACK_IMPORTED_MODULE_2__payment_method_data_js__["b" /* paymentMethodFactory */]({
			methodId: opt.value,
			methodText: opt.text,
			executeUrl: opt.dataset.executeUrl,
			formTemplateCode: opt.dataset.formTemplateCode,
			formTemplateUrl: opt.dataset.formTemplateUrl,
			formTemplateUrlParams: opt.dataset.formTemplateUrlParams,
			logoImageClasses: opt.dataset.logoImageClasses,
			extraParameters: opt.dataset.extraParameters,
			aid: null,
			isMobileDevice: true
		});

		actionButton.setAttribute('disabled', 'disabled');
		sharedPaymentMethodStore.setMethod(paymentMethod);

		if (!opt.dataset.formTemplateUrl) {
			noAccountForSelectedMethod(accountForm);
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__flow_flow_view_js__["d" /* spinnerOff */])(spinner);
			actionButton.removeAttribute('disabled');
		} else {
			showAccountTemplateForSelectedMethod(opt, accountForm, sharedPaymentMethodStore, contextPath).then(function () {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__flow_flow_view_js__["d" /* spinnerOff */])(spinner);
				actionButton.removeAttribute('disabled');
			});
		}
	});
	var evt = new Event('change', { bubbles: true });
	methodSelector.dispatchEvent(evt);
}
function addActionButtonHandler(viewDone, contextElement, sharedPaymentMethodStore) {
	var actionButton = document.getElementById('flow-click-to-action');
	if (actionButton) {
		actionButton.addEventListener('click', function (event) {
			var button = event.target;
			button.classList.add('btn--is-loading');
			var spinner = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__flow_flow_view_js__["c" /* siblingSpinnerOnAction */])(button);

			var methodSelectorId = getMethodSelectorId(contextElement);
			var accountFormId = getMethodAccountContextId(contextElement);
			var methodSelector = button.ownerDocument.getElementById(methodSelectorId);
			var accountForm = button.ownerDocument.getElementById(accountFormId);

			var methodOption = methodSelector.options[methodSelector.selectedIndex];
			var formTemplateType = methodOption.dataset.formTemplateCode;

			var validationResult = formValidation.onSubmit(sharedPaymentMethodStore, accountForm, formTemplateType);
			if (validationResult.ok) {
				viewDone({ status: 'next' });
			} else {
				__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__flow_flow_view_js__["d" /* spinnerOff */])(spinner);
			}
		});
	}
}
function addAccountInputHandler(contextElement, accountFormId, methodSelectorId, sharedPaymentMethodStore) {
	var accountForm = contextElement.ownerDocument.getElementById(accountFormId);
	if (accountForm) {
		var handler = accountFormHandler.bind(null, sharedPaymentMethodStore, methodSelectorId, accountForm);
		var delayHandler = __WEBPACK_IMPORTED_MODULE_5__validation_js__["b" /* getDelayedFormInputHandler */](handler);
		accountForm.addEventListener('input', delayHandler);
	}
}
function viewReady(viewDone, contextElement, contextPath, sharedPaymentMethodStore) {
	addMethodChangeHandler(contextPath, contextElement, sharedPaymentMethodStore);
	addAccountInputHandler(contextElement, getMethodAccountContextId(contextPath), getMethodSelectorId(contextPath), sharedPaymentMethodStore);
	addActionButtonHandler(viewDone, contextPath, sharedPaymentMethodStore);
}

function withdrawMethodView(contextPath, sharedPaymentMethodStore, viewReadyPromise) {
	var addHandlers = void 0;
	var viewDonePromise = new Promise(function (viewDoneResolver) {
		addHandlers = viewReady.bind(null, viewDoneResolver);
	});
	viewReadyPromise.then(function (contextElement) {
		addHandlers(contextElement, contextPath, sharedPaymentMethodStore);
		return viewDonePromise;
	});

	return __WEBPACK_IMPORTED_MODULE_1__withdraw_services_js__["h" /* fetchWithdrawPaymentMethods */]().then(function (methodData) {
		// console.info('withdraw methods', methodData);
		sharedPaymentMethodStore.setCurrency(methodData.lastUsedMethodDetails.lastCurrency);
		return fetchWithdrawMethodFormView(contextPath, methodData, sharedPaymentMethodStore);
	}).then(function (withdrawMethod) {
		withdrawMethod.viewDonePromise = viewDonePromise;
		return withdrawMethod;
	});
}



/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__libs_tomcat_cookies_js__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login_js__ = __webpack_require__(38);
// This file will go obsolete once websockets are implemented





var interval = 300000; // 5 min
var sessionKey = void 0;

function checkStatus() {
	sessionKey = __WEBPACK_IMPORTED_MODULE_1__libs_tomcat_cookies_js__["a" /* default */].get('sessionId');
	if (sessionKey) {
		__WEBPACK_IMPORTED_MODULE_0_jquery___default.a.ajax({
			url: '/player/status',
			type: 'GET',
			contentType: 'application/json; charset=utf-8'
		}).done(function (resultData) {
			if (resultData.status === 'SUCCESS') {
				try {
					sessionKey = resultData.result.map.sessionKey;
					if (sessionKey === undefined || sessionKey === '') {
						logout(resultData.result.map.message);
					}
				} catch (err) {
					console.error('GET PLAYER STATUS FAILED', err);
					logout('Logout');
				}
			}
			if (resultData.status === 'FAILURE') {
				console.error(resultData.errorDescription + '. Code: ' + resultData.errorCode);
				logout('Logout');
			}
		}).fail(function (jqXHR, textStatus, errorThrown) {
			console.error('GET PLAYER STATUS FAILED', errorThrown);
			logout('Logout');
		});
	}
}

function logout(errorMsg) {
	__WEBPACK_IMPORTED_MODULE_3__login_js__["a" /* default */].doLogout();
	__WEBPACK_IMPORTED_MODULE_2__notifications_js__["a" /* default */].showNotification(errorMsg, 'red', true);
}

window.addEventListener('focus', function () {
	checkStatus();
});

function init() {
	setInterval(checkStatus, interval);
}

var playerStatus = {
	checkStatus: checkStatus,
	init: init
};

/* harmony default export */ __webpack_exports__["a"] = playerStatus;

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_history_js__ = __webpack_require__(6);
/**
 * Created by Fatih on 30.06.2016.
 */



var $privacyPolicyPage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.privacy-menu');

function setPrivacyPolicyPageActive(bool) {
	if (bool) {
		$privacyPolicyPage.addClass('menu--is-open');
		setTimeout(function () {
			$privacyPolicyPage.css('transform', 'initial');
			//this part is for smooth scrolling in iOS
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tabs-container').addClass('u-dn');
			if (window.location.href.indexOf('shop') !== -1) {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pusher').children().each(function () {
					__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('u-dn');
				});
			}
		}, 500);
	} else {
		$privacyPolicyPage.removeClass('menu--is-open');
		$privacyPolicyPage.removeAttr('style');
		//this part is for smooth scrolling in iOS
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tabs-container').removeClass('u-dn');
		if (window.location.href.indexOf('shop') !== -1) {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pusher').children().each(function () {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('u-dn');
			});
		}
	}
}

$privacyPolicyPage.find('.icon-close').click(function () {
	//var router = require('./router');
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["f" /* replace */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["d" /* basePathname */])());
});

/* harmony default export */ __webpack_exports__["a"] = {
	setPrivacyPolicyPageActive: setPrivacyPolicyPageActive
};

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reality_check_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__libs_tomcat_cookies_js__ = __webpack_require__(23);







var globalNotificationElem = void 0;
var checkRealityElem = void 0;

function hide() {
	checkRealityElem.classList.remove('notify--is-open');
	globalNotificationElem.classList.remove('global-notification--is-open');
}

function getShowHistoryClickHandler(texts) {
	return function () {
		hide();
		__WEBPACK_IMPORTED_MODULE_3__notifications_js__["a" /* default */].showConfirmationMessage('default-success', texts.historyTitle, texts.historyMessage, texts.historyLinkButton, function () {
			__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["f" /* setDesktopCookies */])();
			__WEBPACK_IMPORTED_MODULE_5__libs_tomcat_cookies_js__["a" /* default */].set('showMobileBanner', true, { domain: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_cookies_js__["e" /* rootDomain */])() });
			window.location.href = texts.historyLink;
		}, texts.historyCloseButton, {
			closeCallback: function closeCallback() {
				__WEBPACK_IMPORTED_MODULE_3__notifications_js__["a" /* default */].hideNotification();
				show();
			}
		});
	};
}

function logout() {
	hide();
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["c" /* push */])('/logout');
}

function show() {
	var globalNotification = document.getElementsByClassName('js-global-notification');
	if (globalNotification && globalNotification.length > 0) {
		globalNotificationElem = globalNotification[0];
	} else {
		return;
	}
	checkRealityElem = globalNotificationElem.getElementsByClassName('js-reality-check')[0];

	globalNotificationElem.classList.add('global-notification--is-open');
	checkRealityElem.classList.add('notify--is-open');

	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_ajax_json_js__["a" /* fetchJson */])('/player/limits/reality-check/popup').then(function (response) {
		var messageUpper = response.result.texts.messageUpper + '. ';
		var playTime = response.result.playTimeHours + ' ' + response.result.texts.hours + ', ' + response.result.playTimeMinutes + ' ' + response.result.texts.minutes + ', ';
		var betSum = '' + response.result.betSum;
		checkRealityElem.getElementsByClassName('js-message-upper')[0].textContent = messageUpper;
		checkRealityElem.getElementsByClassName('js-play-time')[0].textContent = playTime;
		checkRealityElem.getElementsByClassName('js-bet-sum')[0].textContent = betSum;

		checkRealityElem.getElementsByClassName('js-continue-button')[0].textContent = response.result.texts.closeAndReset;
		checkRealityElem.getElementsByClassName('js-disable-button')[0].textContent = response.result.texts.closeAndDisable;
		checkRealityElem.getElementsByClassName('js-history-button')[0].textContent = response.result.texts.historyButton;
		checkRealityElem.getElementsByClassName('js-logout-button')[0].textContent = response.result.texts.logout;
		checkRealityElem.getElementsByClassName('js-history-button')[0].onclick = getShowHistoryClickHandler(response.result.texts);
	});

	checkRealityElem.getElementsByClassName('js-continue-button')[0].onclick = function () {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__reality_check_js__["c" /* resetRealityCheckDuration */])();
		hide();
	};
	checkRealityElem.getElementsByClassName('js-logout-button')[0].onclick = logout;
	checkRealityElem.getElementsByClassName('js-disable-button')[0].onclick = function () {
		__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__reality_check_js__["d" /* disableRealityCheckDuration */])();
		hide();
	};
}

/* harmony default export */ __webpack_exports__["a"] = {
	show: show
};

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by berkin on 24/05/16.
 */
/* harmony default export */ __webpack_exports__["a"] = {
	register: {
		order: 0,
		title: 'Register', // get it from i18n text
		back: null,
		skip: null,
		close: '/',
		nextButtonTitle: '',
		action: null,
		url: '/register',
		closeClass: 'slide-out-down',
		openClass: 'slide-in-up'
	},
	register_details: {
		order: 1,
		title: 'Register Details', // get it from i18n text
		back: '/register',
		skip: null,
		close: null,
		nextButtonTitle: '',
		action: null,
		url: '/register/details',
		closeClass: 'slide-out-down',
		openClass: 'slide-in-up'
	}
};

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_history_js__ = __webpack_require__(6);
/**
 * Created by Fatih on 1.07.2016.
 */



var $responsibleGamingPage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.responsible-menu');

function setResponsibleGamingPageActive(bool) {
	if (bool) {
		$responsibleGamingPage.addClass('menu--is-open');
		setTimeout(function () {
			$responsibleGamingPage.css('transform', 'initial');
			//this part is for smooth scrolling in iOS
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tabs-container').addClass('u-dn');
			if (window.location.href.indexOf('shop') !== -1) {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pusher').children().each(function () {
					__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('u-dn');
				});
			}
		}, 500);
	} else {
		$responsibleGamingPage.removeClass('menu--is-open');
		$responsibleGamingPage.removeAttr('style');
		//this part is for smooth scrolling in iOS
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tabs-container').removeClass('u-dn');
		if (window.location.href.indexOf('shop') !== -1) {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pusher').children().each(function () {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('u-dn');
			});
		}
	}
}

$responsibleGamingPage.find('.icon-close').click(function () {
	//var router = require('./router');
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["f" /* replace */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__store_history_js__["d" /* basePathname */])());
});

/* harmony default export */ __webpack_exports__["a"] = {
	setResponsibleGamingPageActive: setResponsibleGamingPageActive
};

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_history_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes_js__ = __webpack_require__(435);
//import { BrowserRouter as ReactRouter } from 'react-router-dom';





var AppRouter = function AppRouter() {
	return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
		__WEBPACK_IMPORTED_MODULE_0_react_router__["a" /* Router */],
		{ history: __WEBPACK_IMPORTED_MODULE_1__store_history_js__["a" /* history */] },
		__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__routes_js__["a" /* default */], null)
	);
};

/* harmony default export */ __webpack_exports__["a"] = AppRouter;

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_match_hydrate_js__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home_js__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_casino_js__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_shop_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_sportsbook_js__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_login_js__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_register_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_register_details_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_menu_global_js__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_account_account_js__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_payment_result_js__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_withtemp_js__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_about_js__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_logout_js__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_privacy_policy_js__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_terms_conditions_js__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_responsible_gaming_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_email_verify_result_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__player_status_js__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__reality_check_reality_check_js__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__pixel_tracking_pixel_tracking_js__ = __webpack_require__(84);























/**
 *  React Root element. It defines core application routes.
 *  Docs can be found on https://react-router.now.sh/. (it uses react-router v4)
 *  Use <MatchHydrate> if props needs to be passed to hydrate the view.
 *  Use 'authenticate' to enforce login.
 */
__WEBPACK_IMPORTED_MODULE_20__player_status_js__["a" /* default */].init();
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__reality_check_reality_check_js__["a" /* initRealityCheck */])();
__WEBPACK_IMPORTED_MODULE_22__pixel_tracking_pixel_tracking_js__["a" /* default */].push('site');
__WEBPACK_IMPORTED_MODULE_22__pixel_tracking_pixel_tracking_js__["a" /* default */].pushFromCookies();

var Routes = function Routes() {
	return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
		'div',
		null,
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/', component: __WEBPACK_IMPORTED_MODULE_3__components_home_js__["a" /* default */], exact: true }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/casino', component: __WEBPACK_IMPORTED_MODULE_4__components_casino_js__["a" /* default */] }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/shop', component: __WEBPACK_IMPORTED_MODULE_5__components_shop_js__["a" /* default */] }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/sportsbook', component: __WEBPACK_IMPORTED_MODULE_6__components_sportsbook_js__["a" /* default */] }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/sports', component: __WEBPACK_IMPORTED_MODULE_6__components_sportsbook_js__["a" /* default */] }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/login', component: __WEBPACK_IMPORTED_MODULE_7__components_login_js__["a" /* default */] }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/register', component: __WEBPACK_IMPORTED_MODULE_8__components_register_js__["a" /* default */] }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/register/details', component: __WEBPACK_IMPORTED_MODULE_9__components_register_details_js__["a" /* default */] }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/global', component: __WEBPACK_IMPORTED_MODULE_10__components_menu_global_js__["a" /* default */] }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/privacy_policy', component: __WEBPACK_IMPORTED_MODULE_16__components_privacy_policy_js__["a" /* default */] }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/terms_and_conditions', component: __WEBPACK_IMPORTED_MODULE_17__components_terms_conditions_js__["a" /* default */] }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/responsible_gaming', component: __WEBPACK_IMPORTED_MODULE_18__components_responsible_gaming_js__["a" /* default */] }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/about', component: __WEBPACK_IMPORTED_MODULE_14__components_about_js__["a" /* default */] }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/logout', component: __WEBPACK_IMPORTED_MODULE_15__components_logout_js__["a" /* default */] }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* Route */], { path: '/verify-email/*', component: __WEBPACK_IMPORTED_MODULE_19__components_email_verify_result_js__["a" /* default */] }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_match_hydrate_js__["a" /* default */], { path: '/bonus-codes', component: __WEBPACK_IMPORTED_MODULE_5__components_shop_js__["a" /* default */], authenticate: true }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_match_hydrate_js__["a" /* default */], { path: '/account', component: __WEBPACK_IMPORTED_MODULE_11__components_account_account_js__["a" /* default */], authenticate: true }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_match_hydrate_js__["a" /* default */], { path: '/withtemp', component: __WEBPACK_IMPORTED_MODULE_13__components_withtemp_js__["a" /* default */], authenticate: true }),
		__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_match_hydrate_js__["a" /* default */], { path: '/payment/result/:type', component: __WEBPACK_IMPORTED_MODULE_12__components_payment_result_js__["a" /* default */], authenticate: true })
	);
};

/* harmony default export */ __webpack_exports__["a"] = Routes;

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_custom_events_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sbtech_api_client_1_0_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sports_helper_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__login_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_cookies_js__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_settings_js__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__libs_jquery_click_effect_js__ = __webpack_require__(366);









function logout(target) {
	__WEBPACK_IMPORTED_MODULE_4__login_js__["a" /* default */].doLogout(target);
}

function processLogoutSportsBook() {
	var tabBar = document.getElementsByClassName('tabs-bar')[0];
	var betTabs = tabBar.getElementsByClassName('js-my-bets');

	if (betTabs.length > 0) {
		var _arr = [].concat(betTabs);

		for (var _i = 0; _i < _arr.length; _i++) {
			var betTab = _arr[_i];
			betTab.remove();
		}
	}
}

function processAuthSportsBook() {
	if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_cookies_js__["c" /* sessionKey */])()) {
		processLogoutSportsBook();
	}
}

function initEventListener() {
	__WEBPACK_IMPORTED_MODULE_1__utils_custom_events_js__["a" /* emitter */].on('logout', processLogoutSportsBook);
}

function scrollToTop() {
	document.getElementsByClassName('content pusher')[0].scrollTop = 0;
}

function init() {
	console.info('sportsbook init');
	__WEBPACK_IMPORTED_MODULE_2__sbtech_api_client_1_0_js__["a" /* default */].init();
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__store_cookies_js__["b" /* setNavigationCookies */])('sportsbook');

	initEventListener();
	processAuthSportsBook();

	//Click handlers for tabs
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#footerlink_home').on(__WEBPACK_IMPORTED_MODULE_6__config_settings_js__["a" /* eventType */], function () {
		__WEBPACK_IMPORTED_MODULE_2__sbtech_api_client_1_0_js__["a" /* default */].api.client.gotoHome();
		scrollToTop();
	});

	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#footerlink_search').on(__WEBPACK_IMPORTED_MODULE_6__config_settings_js__["a" /* eventType */], function () {
		__WEBPACK_IMPORTED_MODULE_2__sbtech_api_client_1_0_js__["a" /* default */].api.client.gotoSearch();
		scrollToTop();
	});

	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.icon-logout-stroke').off(__WEBPACK_IMPORTED_MODULE_6__config_settings_js__["a" /* eventType */]).on(__WEBPACK_IMPORTED_MODULE_6__config_settings_js__["a" /* eventType */], function () {
		__WEBPACK_IMPORTED_MODULE_2__sbtech_api_client_1_0_js__["a" /* default */].api.client.logout();
		logout(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this));
	});

	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#footerlink_bs').on(__WEBPACK_IMPORTED_MODULE_6__config_settings_js__["a" /* eventType */], function () {
		__WEBPACK_IMPORTED_MODULE_2__sbtech_api_client_1_0_js__["a" /* default */].api.client.gotoBetslip();
		scrollToTop();
	});

	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#footerlink_mybets').on(__WEBPACK_IMPORTED_MODULE_6__config_settings_js__["a" /* eventType */], function () {
		__WEBPACK_IMPORTED_MODULE_2__sbtech_api_client_1_0_js__["a" /* default */].api.client.gotoBettingsHistory();
		scrollToTop();
	});

	__WEBPACK_IMPORTED_MODULE_0_jquery___default()('#footerlink_bs_count').on('betsCounterChange', function () {
		var counter = parseInt(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).text(), 10);

		__WEBPACK_IMPORTED_MODULE_0_jquery___default()().clickEffect(__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this), 'circle');

		if (counter >= 1) {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('u-hide').addClass('u-show');
		} else {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('u-show').addClass('u-hide');
		}
	});

	__WEBPACK_IMPORTED_MODULE_2__sbtech_api_client_1_0_js__["a" /* default */].api.client.registerLogoutCallback(logout);

	__WEBPACK_IMPORTED_MODULE_2__sbtech_api_client_1_0_js__["a" /* default */].api.client.registerStatusCallback(function () {
		__WEBPACK_IMPORTED_MODULE_3__sports_helper_js__["a" /* default */].getStatus();
	});
}

var sportsbook = {
	init: init
};

/* harmony default export */ __webpack_exports__["a"] = sportsbook;

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__login_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications_js__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spinner_js__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store_history_js__ = __webpack_require__(6);
/**
 * Created by Fatih on 23.06.2016.
 */






var $termsAndConditionsPage = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('.terms-menu');

function setTermsAndConditionsPageActive(bool) {
	var logoutUponClose = __WEBPACK_IMPORTED_MODULE_1__login_js__["a" /* default */].checkComplianceFlag();

	if (bool) {
		$termsAndConditionsPage.addClass('menu--is-open');
		setTimeout(function () {
			$termsAndConditionsPage.css('transform', 'initial');

			//this part is for smooth scrolling in iOS
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tabs-container').addClass('u-dn');
			if (window.location.href.indexOf('shop') !== -1) {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pusher').children().each(function () {
					__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('u-dn');
				});
			}
		}, 500);

		if (logoutUponClose) {
			var bottom = $termsAndConditionsPage.find('.u-btn-wrapper');
			var isIphone = /Safari/i.test(navigator.userAgent) && /Mobile/i.test(navigator.userAgent) && /iphone/i.test(navigator.userAgent);
			var isIpad = /Safari/i.test(navigator.userAgent) && /Ipad/i.test(navigator.userAgent);

			//var isSafari = navigator.vendor.indexOf("Apple")==0 && /\sSafari\//.test(navigator.userAgent);

			bottom.show();
			/*
   if (isIpad || isIphone) {
   	const marginPx = (isIpad) ? '50px' : '65px';
   	bottom.css('margin-bottom', marginPx);
   	$(window).on('resize', () => {
   		if (bottom.attr('style').length !== 0) {
   			bottom.removeAttr('style');
   		}
   	});
   }
   */
		} else {
			//if we enter here, it means we dont need to show buttons
			$termsAndConditionsPage.find('.u-btn-wrapper').hide();
		}
	} else {
		$termsAndConditionsPage.removeClass('menu--is-open');
		$termsAndConditionsPage.removeAttr('style');

		//this part is for smooth scrolling in iOS
		__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.tabs-container').removeClass('u-dn');
		if (window.location.href.indexOf('shop') !== -1) {
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.pusher').children().each(function () {
				__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).removeClass('u-dn');
			});
		}

		if (logoutUponClose) {
			__WEBPACK_IMPORTED_MODULE_2__notifications_js__["a" /* default */].hideNotification();
			__WEBPACK_IMPORTED_MODULE_0_jquery___default()('.global-notification').removeClass('is-simple-notification');
			__WEBPACK_IMPORTED_MODULE_1__login_js__["a" /* default */].doLogout();
		}
	}
}

var closeBttn = $termsAndConditionsPage.find('.page-head').find('.icon-close');
closeBttn.click(function (e) {
	e.preventDefault();
	e.stopPropagation();
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_history_js__["e" /* pushBack */])();
});

$termsAndConditionsPage.find('.btn-accept').click(function () {
	__WEBPACK_IMPORTED_MODULE_0_jquery___default()(this).addClass('btn--is-loading');
	__WEBPACK_IMPORTED_MODULE_3__spinner_js__["a" /* default */].show($termsAndConditionsPage.find('.u-btn-wrapper'));
	__WEBPACK_IMPORTED_MODULE_1__login_js__["a" /* default */].doLogin(null, true);
	/*
 	* Example scenario:
 	* 		go to: #/withdraw
 	*		user not logged in so,
 	*			router.js assigns: redirectUrl = #/withdraw
 	*			router.js redirects to: #/login
 	*
 	*		user logs in
 	*		should-show-compliance-form, so
 	*			login.js redirects to: #/terms-and-conditions (in this particular scenario. login.js has multiple execution branches…)
 	*
 	*		user clicks ”agree”
 	*		terms-and-conditions must now tell router to redirect back to the original page (#/withdraw), so
 	*			router.redirect()
 	*
 	*		router redirects to: redirectUrl (hopefully still #/withdraw)
 	*		router assigns: redirectUrl = null;
 	*
 	*
 	*/
	//we dont need a redirect because login function handles redirect
	//router.redirect();
});

$termsAndConditionsPage.find('.btn-logout').click(function () {
	__WEBPACK_IMPORTED_MODULE_1__login_js__["a" /* default */].doLogout();
	__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_history_js__["f" /* replace */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__store_history_js__["d" /* basePathname */])());
});

/* harmony default export */ __webpack_exports__["a"] = {
	setTermsAndConditionsPageActive: setTermsAndConditionsPageActive
};

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__scroll_parent_js__ = __webpack_require__(444);


if (/Android [4-6]/.test(navigator.appVersion)) {
	window.addEventListener('resize', function () {
		if (document.activeElement.tagName === 'INPUT') {
			window.setTimeout(function () {
				var el = document.activeElement;
				var rect = el.getBoundingClientRect();

				var container = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__scroll_parent_js__["a" /* default */])(el);
				var containerHeight = container.clientHeight;

				// scroll to center of visible area
				//console.log(`${rect.top}, ${rect.height}, ${containerHeight}`);
				container.scrollTop = rect.top + container.scrollTop + rect.height / 2 - containerHeight / 2;
			}, 0);
		}
	});
}

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store_index_js__ = __webpack_require__(52);
/*jslint browser: true, devel:true */
/*global define*/



function lodeBetterImage(nodes) {
	if (nodes) {
		var img = new Image();

		img.src = __WEBPACK_IMPORTED_MODULE_0__store_index_js__["a" /* default */].assetPath + '/' + __WEBPACK_IMPORTED_MODULE_0__store_index_js__["a" /* default */].siteCode + '/img/bg-footer.jpg';

		img.addEventListener('load', function () {
			for (var _iterator = nodes, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
				var _ref;

				if (_isArray) {
					if (_i >= _iterator.length) break;
					_ref = _iterator[_i++];
				} else {
					_i = _iterator.next();
					if (_i.done) break;
					_ref = _i.value;
				}

				var node = _ref;

				node.classList.add('blur-bg--no');
			}
		}, {
			once: true,
			passive: true
		});
	}
}
if (parseInt(__WEBPACK_IMPORTED_MODULE_0__store_index_js__["a" /* default */].siteId, 10) === 0) {
	var blurBgNodes = document.querySelectorAll('.blur-bg');
	lodeBetterImage(blurBgNodes);
}

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var events = ['click', 'touchstart', 'touchmove', 'touchend', 'mousedown', 'mousemove', 'mouseup', 'keydown', 'keyup'];

var defaults = {
	timeout: 5000
};

var timer = null;

function BlockUi(context, options) {

	this.options = Object.assign({}, defaults, options || {});

	this.element = context || document.body;
	this.blocker = document.createElement('div');
	this.attachEvents();
	this.setBounds();
}

BlockUi.prototype.attachEvents = function () {
	var self = this;
	events.forEach(function (event) {
		self.blocker.addEventListener(event, function () {
			return false;
		});
	});
};

BlockUi.prototype.setBounds = function () {
	this.element.style.position = 'relative';

	this.blocker.style.position = 'absolute';
	this.blocker.style.top = 0;
	this.blocker.style.left = 0;
	this.blocker.style.right = 0;
	this.blocker.style.bottom = 0;
	this.blocker.style.zIndex = 99999;
};

BlockUi.prototype.show = function () {
	this.element.appendChild(this.blocker);

	timer = setTimeout(this.destroy.bind(this), this.options.timeout);
};

BlockUi.prototype.hide = function () {
	this.element.style.position = '';
	this.element.removeChild(this.blocker);

	timer && clearTimeout(timer);
};

BlockUi.prototype.destroy = function () {
	var self = this;
	events.forEach(function (event) {
		self.blocker.removeEventListener(event, function () {
			return false;
		});
	});

	this.hide();
	this.element = null;
	this.blocker = null;
};

/* harmony default export */ __webpack_exports__["a"] = BlockUi;

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inobounce__ = __webpack_require__(586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_inobounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_inobounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__background_blur_js__ = __webpack_require__(439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pushstate_anchor_history_js__ = __webpack_require__(354);




/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function Intent() {
	var self = this;
	var timer = void 0;

	this.exec = function (callback, duration) {
		self.clear();

		for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
			args[_key - 2] = arguments[_key];
		}

		timer = setTimeout(callback.bind(this, args), duration || 1000);
	};

	this.clear = function () {
		clearTimeout(timer);
	};
}
/* harmony default export */ __webpack_exports__["a"] = Intent;

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_int8_array__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_uint8_array__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_int16_array__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint16_array__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int32_array__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint32_array__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_float32_array__ = __webpack_require__(526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float64_array__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_map__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_set__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_weak_map__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_set__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_reflect_apply__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_construct__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_define_property__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_delete_property__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_get__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__(504);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_has__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_own_keys__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_set__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_promise__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_symbol__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_object_assign__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_is__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_function_name__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_string_raw__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_from_code_point__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_code_point_at__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_repeat__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_starts_with__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_ends_with__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_includes__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_regexp_flags__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_match__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_replace__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_split__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_search__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_array_from__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_of__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_copy_within__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_find__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find_index__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_fill__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_iterator__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_number_is_finite__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_integer__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_nan__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_epsilon__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_math_acosh__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_asinh__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_atanh__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_cbrt__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_clz32__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_cosh__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_expm1__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_fround__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_hypot__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_imul__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_log1p__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log10__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log2__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_sign__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sinh__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_tanh__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_trunc__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es7_array_includes__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_object_values__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_entries__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_string_pad_start__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_end__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_web_timers__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_immediate__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_dom_iterable__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_regenerator_runtime_runtime__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_whatwg_fetch__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_intersection_observer__ = __webpack_require__(587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_intersection_observer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_intersection_observer__);

























































































function loadScript(src) {
	//return new Promise(function(resolve, reject) {
	var script = document.createElement('script');
	script.src = src;
	//script.onload = resolve;
	//script.onerror = reject;
	document.head.appendChild(script);
	//});
}
//loadScript('https://unpkg.com/@webcomponents/custom-elements');
/*
const supportsCustomElementsV1 = 'customElements' in window;
// Lazy load the polyfill if necessary.
if (!supportsCustomElementsV1) {
	// if not extending native element https://unpkg.com/@webcomponents/custom-elements
	loadScript('https://unpkg.com/@webcomponents/custom-elements').then(e => {
	// Polyfill loaded.
	});

	console.log('supportsCustomElementsV1 not supported')
} else {
	// Native support. Good to go.

	console.log('supportsCustomElementsV1 supported')
}
*/

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var regex = /(auto|scroll)/;

var parents = function parents(node, ps) {
	if (node.parentNode === null) {
		return ps;
	}

	return parents(node.parentNode, ps.concat([node]));
};

var style = function style(node, prop) {
	return getComputedStyle(node, null).getPropertyValue(prop);
};

var overflow = function overflow(node) {
	return style(node, "overflow") + style(node, "overflow-y") + style(node, "overflow-x");
};

var scroll = function scroll(node) {
	return regex.test(overflow(node));
};

var scrollParent = function scrollParent(node) {
	if (!(node instanceof HTMLElement || node instanceof SVGElement)) {
		return;
	}

	var ps = parents(node.parentNode, []);

	for (var i = 0; i < ps.length; i += 1) {
		if (scroll(ps[i])) {
			return ps[i];
		}
	}

	return document.body;
};

/* harmony default export */ __webpack_exports__["a"] = scrollParent;

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var transitionEndEvent = void 0;
var defaultDuration = 500;
var el = document.createElement('berkin');
var transitions = {
	transition: 'transitionend',
	OTransition: 'oTransitionEnd otransitionend',
	MozTransition: 'transitionend',
	WebkitTransition: 'webkitTransitionEnd'
};

Object.keys(transitions).forEach(function (name) {
	if (el.style[name] !== undefined) {
		transitionEndEvent = transitions[name];
	}
});

function transitionEndWrapper(element, handler, duration) {
	var called = false;
	function callback() {
		if (!called) {
			handler.call(this, element);
			called = true;
		}

		if (transitionEndEvent) {
			element.removeEventListener(transitionEndEvent, callback);
		}
	}

	if (transitionEndEvent) {
		element.addEventListener(transitionEndEvent, callback);
	}

	setTimeout(callback, duration || defaultDuration);
}

/* harmony default export */ __webpack_exports__["a"] = transitionEndWrapper;

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = {
	get_the_code: {
		order: 0,
		title: 'Mobile Verification',
		back: true,
		skip: null,
		close: null,
		nextButtonTitle: '',
		action: null,
		url: '/verify-mobile',
		closeClass: 'slide-out-right',
		openClass: 'slide-in-left'
	},
	verify_code: {
		order: 1,
		title: 'Enter Code',
		back: true,
		skip: null,
		close: null,
		nextButtonTitle: '',
		action: null,
		url: '/verify-mobile/enter-the-code',
		closeClass: 'slide-out-right',
		openClass: 'slide-in-left'
	},
	success: {
		order: 2,
		title: '',
		back: null,
		skip: null,
		close: true,
		nextButtonTitle: '',
		action: null,
		url: '/verify-mobile/verified',
		closeClass: 'slide-out-right',
		openClass: 'slide-in-left'
	},
	error: {
		order: 3,
		title: '',
		back: true,
		skip: null,
		close: null,
		nextButtonTitle: '',
		action: null,
		url: '/verify-mobile/error',
		closeClass: 'slide-out-right',
		openClass: 'slide-in-left'
	}

};

/***/ }),
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(72);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "u-hide";
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "					<div class=\"game-item__jackpot u-absolute u-pos-b1 u-text-c\">\n						"
    + ((stack1 = container.lambda(depth0, depth0)) != null ? stack1 : "")
    + "\n					</div>\n";
},"5":function(container,depth0,helpers,partials,data) {
    return "game-item__love--selected";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=helpers.blockHelperMissing, alias3=container.escapeExpression;

  return "<figure class=\"game-item u-m0 u-relative u-fl grid-u-sm-1-2 grid-u-md-1-4 "
    + ((stack1 = alias2.call(depth0,alias1((depth0 != null ? depth0.visible : depth0), depth0),{"name":"visible","hash":{},"fn":container.noop,"inverse":container.program(1, data, 0),"data":data})) != null ? stack1 : "")
    + "\" data-gameCode=\""
    + alias3(alias1((depth0 != null ? depth0.code : depth0), depth0))
    + "\" data-dimension=\"small\"\n        data-gameSiteId=\""
    + alias3(alias1((depth0 != null ? depth0.gameSiteId : depth0), depth0))
    + "\"\n        data-gameId=\""
    + alias3(alias1((depth0 != null ? depth0.gameId : depth0), depth0))
    + "\" data-gamePublishCode=\""
    + alias3(alias1((depth0 != null ? depth0.publishCode : depth0), depth0))
    + "\" data-longDescription=\""
    + alias3(alias1((depth0 != null ? depth0.description : depth0), depth0))
    + "\">\n"
    + ((stack1 = container.invokePartial(__webpack_require__(564),depth0,{"name":"game-tags","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "    <div class=\"item-aspect-ratio-small\">\n        <div class=\"aspect-ratio__content\">\n            <a href=\"#\" class=\"game-item__img-wrap u-b-radius-top u-relative\">\n"
    + ((stack1 = alias2.call(depth0,alias1((depth0 != null ? depth0.jackpot : depth0), depth0),{"name":"jackpot","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "				<img\n					data-sizes=\"auto\"\n					data-src=\""
    + alias3(alias1(((stack1 = (depth0 != null ? depth0.imageView : depth0)) != null ? stack1.srcSmall : stack1), depth0))
    + "\"\n					data-srcset=\""
    + alias3(alias1(((stack1 = (depth0 != null ? depth0.imageView : depth0)) != null ? stack1.srcSet : stack1), depth0))
    + "\"\n					alt=\""
    + alias3(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "\"\n					data-game=\""
    + alias3(alias1((depth0 != null ? depth0.code : depth0), depth0))
    + "\"\n					class=\"game-item__img lazyload u-b-radius-top\"/>\n                <div class=\"spinner u-hide\"></div>\n            </a>\n            <figcaption class=\"game-item__caption u-relative u-box-bg\">\n                <div class=\"dots-container u-absolute u-pos-tr0 u-cursor-hand\">\n					<svg viewBox=\"0 0 24 24\">\n						<title>More</title>\n						<path d=\"M4 14C2.9 14 2 13.1 2 12 2 10.9 2.9 10 4 10 5.1 10 6 10.9 6 12 6 13.1 5.1 14 4 14ZM12 14C10.9 14 10 13.1 10 12 10 10.9 10.9 10 12 10 13.1 10 14 10.9 14 12 14 13.1 13.1 14 12 14ZM20 14C18.9 14 18 13.1 18 12 18 10.9 18.9 10 20 10 21.1 10 22 10.9 22 12 22 13.1 21.1 14 20 14Z\"/>\n					</svg>\n                </div>\n				<small class=\"support-title u-truncate\" data-categoryCode=\""
    + alias3(alias1((depth0 != null ? depth0.categoryCode : depth0), depth0))
    + "\">"
    + alias3(alias1((depth0 != null ? depth0.categoryLabel : depth0), depth0))
    + "</small>\n				<h2 class=\"main-title js-game-item-main-title u-truncate\" title=\""
    + alias3(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "\">"
    + alias3(alias1((depth0 != null ? depth0.name : depth0), depth0))
    + "</h2>\n            </figcaption>\n            <div class=\"game-item__footer u-box-bg u-b-radius-bottom\">\n                <a href=\"#\" class=\"game-item__love u-pl1 u-pr1 "
    + ((stack1 = alias2.call(depth0,alias1((depth0 != null ? depth0.loved : depth0), depth0),{"name":"loved","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n                    <svg viewBox=\"0 0 24 24\" class=\"game-item__love-icon\">\n                        <title>Heart Fill</title>\n                        <path d=\"M11.36 20.46C10.68 20.01 9.73 19.31 8.51 18.36 7.24 17.38 6.08 16.26 5.04 15.04 3.97 13.82 3.11 12.44 2.48 10.95 1.87 9.55 1.84 7.97 2.41 6.55 2.77 5.62 3.38 4.81 4.16 4.2 4.94 3.58 5.87 3.18 6.85 3.05 6.97 3.04 7.1 3.03 7.23 3.02L7.6 3.02C9.29 3.01 10.89 3.78 11.93 5.11 12.1 5.32 12.25 5.54 12.37 5.77 12.5 6 12.61 6.24 12.7 6.48 12.76 6.64 12.81 6.8 12.85 6.96 12.88 7.12 12.92 7.28 12.95 7.43 12.94 7.44 12.94 7.46 12.95 7.48 12.96 7.52 12.98 7.56 13 7.61 13.04 7.69 13.11 7.76 13.18 7.81 13.26 7.85 13.34 7.88 13.43 7.88 13.52 7.87 13.61 7.85 13.69 7.81 13.78 7.76 13.85 7.68 13.88 7.58 13.9 7.5 13.9 7.41 13.9 7.32L13.9 7.09C13.87 6.89 13.84 6.7 13.79 6.5 13.75 6.3 13.68 6.11 13.61 5.92L13.48 5.6 13.35 5.27C13.25 5.1 13.21 4.9 13.24 4.71 13.27 4.51 13.37 4.33 13.51 4.19L13.53 4.19C14.01 3.8 14.55 3.5 15.13 3.3 15.71 3.1 16.33 3 16.94 3 17.07 3 17.2 3.01 17.32 3.02L17.69 3.07C18.67 3.19 19.59 3.59 20.35 4.21 21.12 4.83 21.71 5.64 22.05 6.57 22.61 7.99 22.58 9.57 21.98 10.97 21.35 12.46 20.49 13.84 19.42 15.06 18.37 16.27 17.21 17.38 15.95 18.37 14.73 19.32 13.78 20.02 13.11 20.47 12.99 20.56 12.85 20.63 12.7 20.67 12.4 20.76 12.07 20.76 11.76 20.67 11.62 20.63 11.48 20.56 11.36 20.46L11.36 20.46Z\"/>\n                    </svg>\n                    <span class=\"game-item__love-counter\">"
    + alias3(alias1((depth0 != null ? depth0.likes : depth0), depth0))
    + "</span>\n                </a>\n                <a is=\"pushstate-anchor\" href=\"/casino/provider/"
    + alias3(alias1(((stack1 = (depth0 != null ? depth0.provider : depth0)) != null ? stack1.code : stack1), depth0))
    + "\" class=\"game-item__provider u-pl1 u-pr1 u-truncate u-center-vertically\"\n                   data-provider-code=\""
    + alias3(alias1(((stack1 = (depth0 != null ? depth0.provider : depth0)) != null ? stack1.code : stack1), depth0))
    + "\"\n                   data-provider-name=\""
    + alias3(alias1(((stack1 = (depth0 != null ? depth0.provider : depth0)) != null ? stack1.name : stack1), depth0))
    + "\">"
    + alias3(alias1(((stack1 = ((stack1 = (data && data.root)) && stack1.i18n)) && stack1.BY), depth0))
    + " "
    + alias3(alias1(((stack1 = (depth0 != null ? depth0.provider : depth0)) != null ? stack1.name : stack1), depth0))
    + "\n                </a>\n            </div>\n        </div>\n    </div>\n</figure>\n";
},"usePartial":true,"useData":true});

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(72);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, buffer = 
  "    <div class=\"game-tag-new u-absolute\">\n        <svg class=\"game-tag-new__svg\" width=\"64px\" height=\"64px\" viewBox=\"0 0 128 128\">\n            <polygon points=\"0 0, 128 0, 0 128\"/>\n        </svg>\n        <div class=\"game-tag-new__inner\">\n            <span class=\"game-tag-new__text\">";
  stack1 = ((helper = (helper = helpers.i18n || (depth0 != null ? depth0.i18n : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"i18n","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},options) : helper));
  if (!helpers.i18n) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + "</span>\n        </div>\n    </div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return "MOBILE_GAME_TAG_NEW";
},"4":function(container,depth0,helpers,partials,data) {
    return "	<div class=\"game-tag-hot u-absolute\">\n		<div class=\"game-tag-hot__inner u-b-radius-top u-pb1 u-relative\" aria-hidden=\"true\">\n			<svg viewBox=\"0 0 24 24\">\n				<title>Fire Fill</title>\n				<path d=\"M15.37 21.69C15.28 21.6 15.21 21.49 15.17 21.37 15.14 21.25 15.14 21.12 15.17 21 15.24 20.53 15.21 20.06 15.08 19.61 14.97 19.19 14.77 18.8 14.48 18.48 14.18 18.13 13.79 17.86 13.35 17.71 12.87 17.53 12.36 17.44 11.85 17.45 11.27 17.42 10.7 17.55 10.19 17.82 9.83 18.02 9.51 18.28 9.23 18.57 8.94 18.92 8.73 19.32 8.61 19.75 8.49 20.16 8.47 20.59 8.54 21.01 8.56 21.13 8.55 21.26 8.52 21.38 8.49 21.5 8.43 21.62 8.36 21.72 8.28 21.82 8.17 21.9 8.05 21.96 7.93 22.01 7.8 22.04 7.67 22.03 7.6 22.03 7.53 22.03 7.47 22.01 7.41 22 7.35 21.97 7.29 21.94 6.64 21.66 6.04 21.28 5.5 20.82 4.96 20.35 4.49 19.79 4.12 19.17 3.76 18.58 3.49 17.95 3.29 17.29 3.1 16.62 3 15.93 3 15.23 2.98 14.36 3.11 13.5 3.38 12.68 3.61 11.97 3.93 11.3 4.33 10.67 4.68 10.13 5.09 9.63 5.55 9.17 5.99 8.74 6.37 8.38 6.7 8.08 6.78 8.01 6.87 7.94 6.97 7.89 7.07 7.84 7.19 7.81 7.3 7.81 7.42 7.81 7.53 7.83 7.63 7.88 7.73 7.93 7.81 7.99 7.89 8.06 7.95 8.14 8 8.22 8.03 8.31 8.07 8.39 8.09 8.49 8.09 8.58L8.09 8.62C7.96 9.43 7.93 10.25 8 11.07 8.07 11.67 8.36 12.22 8.81 12.62 8.94 12.72 9.1 12.81 9.26 12.88 9.42 12.94 9.6 12.98 9.77 12.98 10 12.98 10.22 12.93 10.42 12.83 10.6 12.75 10.76 12.62 10.88 12.46 11.16 12.01 11.21 11.45 11.03 10.96 10.89 10.38 10.7 9.82 10.47 9.27 10.05 8.31 9.79 7.29 9.7 6.25 9.61 5.42 9.74 4.58 10.07 3.82 10.36 3.15 10.81 2.57 11.38 2.13 12.02 1.63 12.75 1.24 13.52 1L13.66 1 13.77 1C13.92 1 14.07 1.04 14.19 1.12 14.31 1.2 14.41 1.3 14.47 1.43 14.53 1.55 14.56 1.69 14.55 1.83 14.55 1.97 14.5 2.1 14.42 2.21 14.03 2.91 14.05 3.77 14.48 4.46 15.07 5.34 15.74 6.17 16.49 6.93 16.96 7.43 17.43 7.95 17.93 8.51 18.43 9.08 18.89 9.7 19.28 10.36 19.71 11.06 20.05 11.81 20.29 12.58 20.56 13.45 20.68 14.35 20.67 15.25 20.67 15.89 20.57 16.52 20.39 17.13 20.2 17.78 19.93 18.41 19.59 19 19.21 19.64 18.74 20.23 18.2 20.74 17.68 21.23 17.09 21.62 16.45 21.92 16.39 21.95 16.32 21.97 16.25 21.99 16.19 22 16.13 22.01 16.06 22.01 15.93 22.01 15.81 21.98 15.69 21.93 15.56 21.88 15.45 21.79 15.37 21.69L15.37 21.69Z\"/>\n			</svg>\n		</div>\n	</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=helpers.blockHelperMissing, buffer = "";

  stack1 = ((helper = (helper = helpers.isNew || (depth0 != null ? depth0.isNew : depth0)) != null ? helper : alias2),(options={"name":"isNew","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
  if (!helpers.isNew) { stack1 = alias4.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  stack1 = ((helper = (helper = helpers.isHot || (depth0 != null ? depth0.isHot : depth0)) != null ? helper : alias2),(options={"name":"isHot","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
  if (!helpers.isHot) { stack1 = alias4.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer;
},"useData":true});

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(72);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__(563),depth0,{"name":"explore-game-small","data":data,"indent":"    ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.blockHelperMissing.call(depth0,container.lambda(((stack1 = (depth0 != null ? depth0.gameData : depth0)) != null ? stack1.all : stack1), depth0),{"name":"gameData.all","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"usePartial":true,"useData":true});

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(72);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__(567),depth0,{"name":"icon-empty-love","data":data,"indent":"\t\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = container.invokePartial(__webpack_require__(568),depth0,{"name":"icon-empty-recent","data":data,"indent":"\t\t\t","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=helpers.blockHelperMissing, alias3=container.escapeExpression;

  return "<div class=\"notify__head u-pl2 u-pr2 u-text-c\">\n	<div class=\"notify__icon-wrapper u-text-c\">\n"
    + ((stack1 = alias2.call(depth0,alias1((depth0 != null ? depth0.loved : depth0), depth0),{"name":"loved","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = alias2.call(depth0,alias1((depth0 != null ? depth0.playedOrder : depth0), depth0),{"name":"playedOrder","hash":{},"fn":container.program(3, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "	</div>\n	<h2 id=\"empty-grid-title\" class=\"notify__main-title\">\n		"
    + alias3(alias1((depth0 != null ? depth0.title : depth0), depth0))
    + "\n	</h2>\n	<p id=\"empty-grid-support-title\" class=\"notify__p\">\n		"
    + alias3(alias1((depth0 != null ? depth0.message : depth0), depth0))
    + "\n	</p>\n</div>\n";
},"usePartial":true,"useData":true});

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(72);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<svg viewBox=\"0 0 24 24\" class=\"notify__svg-icon u-dib\" aria-hidden=\"true\">\n	<title>Heart Line</title>\n	<path d=\"M11.26 21.16C10.6 20.73 9.66 20.04 8.44 19.08 7.19 18.1 6.04 16.99 5 15.79 3.95 14.59 3.1 13.23 2.47 11.77 1.87 10.4 1.84 8.84 2.4 7.45 2.57 7.01 2.81 6.58 3.09 6.2 3.37 5.81 3.71 5.46 4.08 5.17 4.46 4.87 4.88 4.61 5.32 4.42 5.76 4.22 6.23 4.1 6.7 4.04 7.92 3.89 9.16 4.16 10.21 4.79 10.7 5.09 11.15 5.47 11.52 5.92 11.9 6.36 12.21 6.87 12.43 7.42 12.5 7.62 12.56 7.84 12.61 8.06 12.65 8.27 12.69 8.49 12.72 8.7 12.73 8.8 12.7 8.91 12.63 8.99 12.56 9.08 12.47 9.13 12.36 9.15 12.25 9.15 12.14 9.12 12.06 9.05 11.97 8.98 11.92 8.89 11.91 8.79 11.9 8.59 11.87 8.39 11.82 8.2 11.78 8.03 11.73 7.86 11.67 7.7 11.5 7.23 11.24 6.81 10.92 6.43 10.6 6.05 10.22 5.73 9.8 5.48 9.36 5.21 8.88 5.02 8.37 4.91 7.87 4.81 7.35 4.79 6.84 4.85 6.02 4.95 5.25 5.27 4.61 5.79 3.96 6.29 3.46 6.97 3.16 7.74 2.95 8.29 2.84 8.88 2.85 9.47 2.85 10.11 2.96 10.74 3.17 11.35 3.42 12.04 3.74 12.71 4.15 13.33 4.63 14.08 5.17 14.79 5.76 15.46 6.3 16.05 6.86 16.62 7.45 17.16 8.03 17.7 8.59 18.19 9.13 18.62 9.67 19.06 10.17 19.43 10.63 19.75 11.09 20.06 11.46 20.31 11.72 20.5 11.92 20.65 12.19 20.65 12.39 20.5 12.66 20.32 13.03 20.07 13.48 19.75 13.94 19.43 14.44 19.05 14.98 18.62 15.52 18.19 16.08 17.7 16.66 17.16 17.25 16.62 17.81 16.06 18.35 15.46 18.94 14.8 19.49 14.09 19.96 13.34 20.37 12.72 20.69 12.05 20.94 11.35 21.15 10.74 21.26 10.11 21.27 9.47 21.27 8.88 21.16 8.29 20.95 7.74 20.81 7.37 20.62 7.02 20.38 6.7 20.13 6.38 19.86 6.08 19.55 5.81 19.23 5.56 18.89 5.34 18.52 5.18 18.15 5.02 17.77 4.91 17.37 4.87 16.65 4.74 15.91 4.8 15.22 5.03 14.53 5.27 13.9 5.66 13.4 6.19 13.32 6.26 13.22 6.31 13.12 6.31 13.01 6.32 12.9 6.28 12.84 6.19 12.75 6.12 12.7 6.02 12.7 5.91 12.7 5.8 12.74 5.7 12.81 5.63 13.41 5.01 14.14 4.54 14.96 4.27 15.77 4 16.63 3.94 17.48 4.08 18.42 4.21 19.31 4.6 20.05 5.2 20.79 5.8 21.36 6.6 21.7 7.49 22.25 8.88 22.22 10.44 21.62 11.8 20.99 13.27 20.14 14.63 19.08 15.83 18.04 17.04 16.89 18.14 15.64 19.12 14.42 20.06 13.49 20.75 12.83 21.19 12.71 21.26 12.59 21.32 12.46 21.37 12.2 21.45 11.91 21.45 11.65 21.37 11.51 21.31 11.38 21.25 11.26 21.16L11.26 21.16Z\"/>\n</svg>\n";
},"useData":true});

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var Handlebars = __webpack_require__(72);
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<svg viewBox=\"0 0 24 24\" class=\"notify__svg-icon u-dib\" aria-hidden=\"true\">\n	<title>Clock Line</title>\n	<path d=\"M12.34 21.68C11.09 21.69 9.85 21.45 8.7 20.96 6.45 20.02 4.66 18.23 3.71 15.98 3.23 14.82 2.99 13.59 3 12.34 3 12.23 3.04 12.13 3.11 12.06 3.19 11.97 3.29 11.93 3.41 11.93 3.63 11.94 3.8 12.12 3.81 12.34 3.8 13.48 4.02 14.61 4.46 15.66 5.33 17.71 6.96 19.35 9.02 20.21 10.07 20.65 11.2 20.88 12.34 20.87 13.48 20.88 14.61 20.65 15.66 20.21 17.71 19.35 19.35 17.71 20.21 15.66 20.65 14.61 20.88 13.48 20.87 12.34 20.88 11.2 20.65 10.07 20.21 9.02 19.35 6.96 17.71 5.33 15.66 4.46 13.62 3.61 11.32 3.58 9.25 4.37 8.27 4.75 7.37 5.31 6.59 6.02L11.37 10.79C11.52 10.67 11.7 10.58 11.88 10.52 12.07 10.46 12.27 10.43 12.48 10.43 12.72 10.43 12.96 10.48 13.19 10.58 13.41 10.66 13.62 10.79 13.8 10.95 13.96 11.13 14.09 11.34 14.18 11.57 14.28 11.79 14.32 12.03 14.33 12.28 14.33 12.53 14.28 12.77 14.18 13 14.09 13.22 13.96 13.43 13.8 13.61 13.63 13.78 13.42 13.93 13.19 14.02 12.96 14.12 12.72 14.17 12.48 14.17 12.23 14.17 11.98 14.12 11.76 14.02 11.3 13.82 10.94 13.46 10.74 13 10.64 12.77 10.59 12.53 10.59 12.28 10.59 12.13 10.61 11.97 10.66 11.82 10.7 11.67 10.76 11.53 10.84 11.4L5.74 6.3C5.65 6.23 5.6 6.13 5.6 6.02 5.6 5.91 5.64 5.81 5.72 5.74L5.74 5.74C6.16 5.3 6.64 4.9 7.15 4.56 8.69 3.54 10.49 3 12.34 3 13.59 2.99 14.82 3.23 15.98 3.71 18.23 4.66 20.02 6.45 20.96 8.7 21.94 11.03 21.94 13.65 20.96 15.98 20.02 18.23 18.23 20.02 15.98 20.96 14.82 21.45 13.59 21.69 12.34 21.68L12.34 21.68Z\"/>\n</svg>\n";
},"useData":true});

/***/ }),
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__app_js__ = __webpack_require__(292);


/***/ })
],[772]);
});


// WEBPACK FOOTER //
// js/app.bundle.js